

export const statesData = [
    {
        "Abia": {
            "Aba North": [
                "Ariria",
                "Eziama",
                "Ogbor hill",
                "Osusu",
                "Umuola-Egbelu",
                "Umuola-Okpulor",
                "Uratta"
            ],
            "Aba South": [
                "Aba Ukwu",
                "Abaukwu",
                "Akoli",
                "Amanfuru",
                "Asaeme",
                "Asaokpuaja",
                "Eziukwu",
                "Ihieorji",
                "Ndiegoro",
                "Nnetu",
                "Obuda",
                "Ohabiam",
                "Ohazu",
                "Umuagbai",
                "Umumba",
                "Umunisi",
                "Umuogele",
                "Umuosi"
            ],
            "Arochukwu": [
                "Aba Isu",
                "Aboru",
                "Abuma",
                "Achara",
                "Agbagwu",
                "Agbor",
                "Amaebem",
                "Amaeke",
                "Amaelu",
                "Amafia",
                "Amakpofia",
                "Amakukpo",
                "Amamiri",
                "Amamama",
                "Amankwu",
                "Amangwu",
                "Amuoma",
                "Amukwa",
                "Amukabi",
                "Amukoma",
                "Amaka",
                "Amaoma",
                "Amachi",
                "Amakarama",
                "Amuru",
                "Ameke",
                "Amaogbu",
                "Iheosu",
                "Obieze",
                "Obomime",
                "Ohafor",
                "Ndi Ememe",
                "Ndi Oji Ugwo",
                "Ndi Okereke",
                "Ndi Okorie",
                "Ndi Okwara",
                "Ndiya",
                "Ndiokpo",
                "Oduenyi",
                "Ozu Abam",
                "Ovukwu Abam",
                "Ahuma",
                "Eziafor",
                "Amasa",
                "Amatiti",
                "Amodu",
                "Eziama",
                "Nkpakpi",
                "Obiagwulu",
                "Obiakana",
                "Obiene",
                "Obijoma",
                "Obiluoko",
                "Ohomja",
                "Ubila",
                "Ugwo-Ogo",
                "Ukwuakwu",
                "Ugwuakuma",
                "Ugwu Avor",
                "Ugbo",
                "Isu",
                "Itum",
                "Idima",
                "Oror",
                "Isinkpu",
                "Ujari",
                "Ulughangwu"
            ],
            "Bende": [
                "Achi",
                "Agbamuzu",
                "Agbo",
                "Agboakoli",
                "Agbomiri",
                "Agbozu",
                "Akanu",
                "Akwanu",
                "Alayi",
                "Amaba",
                "Amabo",
                "Amabanta",
                "Amabia",
                "Amadiaba",
                "Amaedukwo",
                "Amaekpu",
                "Amaeke",
                "Amaelu",
                "Amaeze",
                "Amafu",
                "Amaigwu",
                "Amaiyi",
                "Amagbo",
                "Amagu",
                "Amakpo",
                "Amakwu",
                "Amamba",
                "Amangwu",
                "Amaoba",
                "Amaogwu",
                "Amaohoro",
                "Amaokayi",
                "Amaokpu",
                "Amaokwe",
                "Amaokwo",
                "Amaoji",
                "Amaoji Imenyi",
                "Amata",
                "Amauta",
                "Amauta-Item",
                "Amaugwu",
                "Amazu",
                "Amuta",
                "Amamkwo",
                "Amankalu",
                "Amankwo",
                "Amakayi",
                "Amaukwu",
                "Amayanyi",
                "Amuzi-Tem",
                "Amuzukwu",
                "Ebem",
                "Ebguegbubu",
                "Ebem Uzugwueke",
                "Ebom",
                "Egbu",
                "Egbuele",
                "Eluama",
                "Elugwumba",
                "Elu-Lodu",
                "Ezeukwu",
                "Ezenta",
                "Eziama",
                "Eziama-Uzuakoli",
                "Ibinanta",
                "Ibinaukwu",
                "Idiagbo",
                "Ihie Mba",
                "Ikwuegbu",
                "Isiaku",
                "Isiama",
                "Ishimigu",
                "Isiegbu",
                "Item",
                "Itumbauzo",
                "Lohum",
                "Mbgwele",
                "Mbukwa",
                "Muegwu",
                "Ndi-Iwo",
                "Ndi-Torty",
                "Ndielu",
                "Ndiekeugo",
                "Ndiaikpakpim",
                "Ndiobu",
                "Ndiokoroguodu",
                "Ndiokorukwu",
                "Ndiombe",
                "Nditoli",
                "Nkpa",
                "Nkporo",
                "Ngwu",
                "Odua",
                "Ohumola",
                "Okagwe",
                "Okafia",
                "Okayi",
                "Okoko",
                "Okpoedi",
                "Okporoenyi",
                "Okputong",
                "Okpobia",
                "Onuinyana",
                "Obuohia",
                "Obuofia",
                "Ofiavu",
                "Ogboko",
                "Ogo Ubi Bende",
                "Ozui-Tem",
                "Umuakpa",
                "Umuede",
                "Umugwere",
                "Umuhu-Ezechi",
                "Umukpti",
                "Umuisi",
                "Umu-Menyi",
                "Umuokoro",
                "Umuokoroali",
                "Umuokpe",
                "Umuokpo",
                "Umuokwu",
                "Umuolazi",
                "Umunkalu",
                "Umunnato",
                "Umuobia",
                "Ugwueke",
                "Ukpom",
                "Uzuakoli"
            ],
            "Ikwuano": [
                "Ahaba Ukwu",
                "Akanu Nchara",
                "Amaeba-Ikputu",
                "Amaeba-Ime",
                "Amawom",
                "Amizi",
                "Amaru",
                "Aro-Ajatakiri",
                "Aro-Anyama",
                "Azuiyi",
                "Azunchai",
                "Ekebedi",
                "Ekpiri-Alala",
                "Ekpiri-Eludu",
                "Elemaga",
                "Iberenta",
                "Ihim",
                "Inyila",
                "Isiala",
                "Iziugwu-Arizi",
                "Iyalu",
                "Nkalunta",
                "Ndieke",
                "Ndiokoro",
                "Ndiorie",
                "Ndoro",
                "Nnono",
                "Nowugwo",
                "Obuolia",
                "Obuoro",
                "Obunta",
                "Obeagwu",
                "Obeama",
                "Obohia-Okike",
                "Okwe",
                "Oloko",
                "Omuegwu",
                "Orori",
                "Otoro Nchara",
                "Ugbegbule",
                "Umuariaga",
                "Umuemenike",
                "Umuigu",
                "Umuokwe",
                "Umuokwo",
                "Umudike",
                "Umugbalu",
                "Umulemeze",
                "Umuosu",
                "Umugo",
                "Usaka-Eleogu",
                "Usaka Ukwu",
                "Upa"
            ],
            "Isiala Ngwa North": [
                "Abayi",
                "Ahiaba Okpuala",
                "Ahiaba Ubi",
                "Ama-Asa",
                "Amaekpu",
                "Amaogwugwu",
                "Amaorji",
                "Amachi",
                "Amapu",
                "Amapu-Ngwa",
                "Amuzu",
                "Amapu-Ntigha",
                "Amaputa",
                "Aro-Achara",
                "Avoh",
                "Egbelu",
                "Egbelu-Ihie",
                "Eziam",
                "Eziama-Uratta",
                "Ezial - Nsulu",
                "Iheoji",
                "Ihie",
                "Ikputu",
                "Imerem I",
                "Imerem II",
                "Ichi",
                "Mbubo",
                "Nbawsi",
                "Ngwa Ukwu",
                "Nsulu",
                "Obikabia",
                "Okpuala",
                "Okpuala Ngwa",
                "Osusu",
                "Ohuhu",
                "Oriala-Ugaa",
                "Umuchima",
                "Umuapiti",
                "Umuobia",
                "Umuodoala",
                "Umuokatu",
                "Umuokwa",
                "Umuogele Ntigha",
                "Umuakwu",
                "Umubeyi",
                "Umuede",
                "Umunkalu",
                "Umuosonyeike",
                "Umuosu",
                "Umuoha",
                "Umuariaga",
                "Umarandu-Uratta",
                "Usaka-Umuofo"
            ],
            "Isiala Ngwa South": [
                "Aga",
                "Amaiyi",
                "Amaokpu",
                "Amaudara",
                "Amaku",
                "Amauha",
                "Amankwo",
                "Amuze",
                "Ebeyi",
                "Eziama",
                "Ele-na-Ekpu",
                "Iheneriala",
                "Iheoji",
                "Ikem",
                "Imo-Igbo",
                "Isiala Nvosi",
                "Inyila",
                "Mabedeala",
                "Mba",
                "Mbutu",
                "Nkpuka",
                "Ngwa",
                "Ngwama",
                "Nkpuruta",
                "Nnoyi",
                "Okpuhie",
                "Okpuala",
                "Okele",
                "Okungwu",
                "Ovorji",
                "Obekwesu",
                "Obiekwensu",
                "Obuba",
                "Obeagwu",
                "Okporo Ahaba",
                "Ohuhu",
                "Oriala-Ugaa",
                "Owerrinta",
                "Uhum",
                "Umuache",
                "Umuagu",
                "Umuampa",
                "Umuapa",
                "Umuapu",
                "Umuasu",
                "Umuake",
                "Umuapiti",
                "Umubeyi",
                "Umuede",
                "Umuokiri",
                "Umuokpogho",
                "Umuolu",
                "Umuokpo",
                "Umurasi",
                "Umunko",
                "Umunwarida",
                "Umuonka",
                "Umuokwu",
                "Umuchima",
                "Umuelike",
                "Umuokwa",
                "Umuodi",
                "Umuolale",
                "Umuolume",
                "Umuolo",
                "Umuolubi",
                "Umuofe",
                "Umuoha",
                "Umuosu",
                "Umuowa",
                "Umuikea",
                "Umuane",
                "Umuohome",
                "Umukuma",
                "Umusike",
                "Umuejea",
                "Umuezeocha",
                "Umuezeoji",
                "Umuezu",
                "Umuau",
                "Umuapi",
                "Umuomi",
                "Umuorji",
                "Umuakuma",
                "Umuakwa"
            ],
            "Isukwuato": [
                "Achara",
                "Akpukpa",
                "Amaba",
                "Amanyanwu",
                "Amidi",
                "Amokwe",
                "Amuta",
                "Amaebo",
                "Amaeke",
                "Amahia",
                "Amaiyi",
                "Amajo",
                "Amaohuru",
                "Amaogodu",
                "Amawo",
                "Amuyi",
                "Anume",
                "Eluama",
                "Echiele",
                "Eziama",
                "Ezere",
                "Ikpa",
                "Ihenzu",
                "Ihiokwe",
                "Isu",
                "Isunabo",
                "Mbalano",
                "Ndiagidi",
                "Ndiohia",
                "Ngodo",
                "Ndundu",
                "Nunya",
                "Nvururu",
                "Obayi",
                "Obinohia",
                "Obodo",
                "Ohaise",
                "Ohaukali",
                "Ohonja",
                "Ohoroho",
                "Ogudo",
                "Ogwahia",
                "Onuzu",
                "Otampa",
                "Ugwuntu",
                "Umuakwua",
                "Umuama",
                "Umuamara",
                "Umuansuo",
                "Umuohoroko",
                "Umuokogbuo",
                "Umuebere",
                "Umuemoko",
                "Umuieu",
                "Umuokpo",
                "Umurasi",
                "Umuihu"
            ],
            "Obioma Ngwa": [
                "Abala-Ibeme",
                "Abala-Nkomiri",
                "Abala-Nkwonwelechi",
                "Abayi",
                "Ahiaka",
                "Ahiaba",
                "Akuma-Imo",
                "Akpa-Mbator",
                "Akanu-Afagha",
                "Akanu-Okpulo",
                "Akpuga",
                "Amauvuru",
                "Amuzi",
                "Amairingbua",
                "Amapu",
                "Amuzu",
                "Amorji",
                "Aziama",
                "Ehere",
                "Ekwereazu",
                "Eluama",
                "Eziama",
                "Iferefe",
                "Iheorji",
                "Ikala-Umudagwu",
                "Ichi",
                "Imo-Igbo",
                "Itu-Ikila",
                "Itu-Ngwa I",
                "Itu-Ngwa II",
                "Itukpa",
                "Isiahia",
                "Isiko",
                "Mbutu",
                "Mgboko",
                "Mgboko-Amaku",
                "Mgboko-Amiri",
                "Mgboko-Anya",
                "Mgboko-Okpulo",
                "Mgboko-Umu-Ora",
                "Mgboko-Umuoba",
                "Nenu",
                "Ntigha",
                "Ntigha-Umuaro",
                "Ndiaka",
                "Ndiakata",
                "Nnoyi",
                "Obete",
                "Obete-Nchima",
                "Obete-Uku",
                "Obete-Umodu",
                "Obete-Umuoha",
                "Obikabia",
                "Obeala",
                "Ohanze",
                "Ohanze-Agwo",
                "Okpuama-Uku",
                "Okuenyi",
                "Osa I",
                "Osaokea",
                "Osusu",
                "Osusu-Umukpegh",
                "Onicha",
                "Onuzu",
                "Owo-Ahiafor",
                "Owohia",
                "Ukpakiri",
                "Umuafor",
                "Umuaforkwu",
                "Umuagada",
                "Umuaguma",
                "Umuagwa",
                "Umuagwula",
                "Umuake",
                "Umuama",
                "Umuane",
                "Umuapiti",
                "Umuariama",
                "Umuabali",
                "Umubeyi",
                "Umuibe",
                "Umuobasi",
                "Umuobiakwa",
                "Umuocheala",
                "Umuokahia",
                "Umuokatawom",
                "Umuokogbuo",
                "Umuomegbi",
                "Umuomaghi",
                "Umuoniengwa",
                "Umuorukwu",
                "Umuopara-Amuzu",
                "Umuopara-Egbelu",
                "Umuoru",
                "Umuotu",
                "Umuwezi",
                "Umukalika",
                "Umukpi",
                "Umuolo",
                "Umuocha",
                "Umuosu",
                "Umumagberugo",
                "Umuogele",
                "Umuoma",
                "Umuokere Ngwa",
                "Umuokeri",
                "Umuonka",
                "Umusike",
                "Umusu",
                "Umutu",
                "Umuezebele",
                "Umuihu",
                "Umuohoroko",
                "Umurasi",
                "Umura"
            ],
            "Ohafia": [
                "Abia",
                "Abayi-Amaugwu",
                "Abiriba",
                "Akpa 1",
                "Akpa 11",
                "Akpa IV",
                "Akanu",
                "Amake",
                "Amake Abiriba",
                "Amake Echichi",
                "Amanga",
                "Amangwu",
                "Amangwu Ohafia",
                "Amamu",
                "Amane",
                "Ama-Asato",
                "Amaegwuawu",
                "Amapu",
                "Amauzu",
                "Amave",
                "Amavi",
                "Amoge",
                "Amuma",
                "Amuozu",
                "Amuz",
                "Amugawa",
                "Amumera",
                "Amungu",
                "Amuru",
                "Amuroku",
                "Amuzer",
                "Amuse",
                "Anaka",
                "Ankar",
                "Anguwari",
                "Angu",
                "Atama",
                "Aro-Ngwa",
                "Asaga",
                "Ayaba-Umueze",
                "Binyom",
                "Elu",
                "Elughu",
                "Elughu-Nkporo",
                "Emapu",
                "Etemara",
                "Etemaro",
                "Eziafor",
                "Ibeku",
                "Ibi",
                "Ibo",
                "Isiama Ohafia",
                "Isiugwu",
                "Itu-Ngwa I",
                "Itu-Ngwa II",
                "Itukpa",
                "Mbutu",
                "Mgboko",
                "Mgboko-Amaku",
                "Mgboko-Amiri",
                "Mgboko-Anya",
                "Mgboko-Okpulo",
                "Mgboko-Umu-Ora",
                "Mgboko-Umuoba",
                "Ndi-Amogu",
                "Ndi-Anyaori",
                "Ndi-Okala",
                "Ndi-Nko",
                "Ndi-Nko-Nkporo",
                "Ndi-Uduma-Awoke",
                "Ndi-Uduma-Ukwu",
                "Nkwebe",
                "Nkporo",
                "Nkporo-Nkporo",
                "Nso",
                "Numa",
                "Numa-Nkporo",
                "Okagwe",
                "Okpuala",
                "Okpuala-Aro",
                "Okoro",
                "Oko-Aku",
                "Okon-Aku",
                "Ona-Ohafia",
                "Obekpe",
                "Obofia",
                "Obofia-Nkporo",
                "Ohanze",
                "Ohanze-Agwo",
                "Okpuala-Nkporo",
                "Okpuala-Osikaka",
                "Onicha",
                "Osusu",
                "Osusu-Umukpegh",
                "Oso-Akwa",
                "Oukpa",
                "Ona-Okada",
                "Oso-Udoma",
                "Udanta",
                "Umun-Neise",
                "Umunankwoala",
                "Umunoro",
                "Umule",
                "Umuake",
                "Umuama",
                "Umuane",
                "Umuabali",
                "Umuocheala",
                "Umuobasi",
                "Umuobiakwa",
                "Umuohia",
                "Umuokahia",
                "Umuokatawom",
                "Umuokogbuo",
                "Umuomegbi",
                "Umuoniengwa",
                "Umuopara-Amuzu",
                "Umuopara-Egbelu",
                "Umuoruka",
                "Umurasi",
                "Umuukike",
                "Umuukpe",
                "Umuka",
                "Umumba",
                "Umuse",
                "Umuwa",
                "Umuyanga",
                "Umuohoroko",
                "Umuezebele",
                "Umuoni",
                "Umuoji",
                "Umuoyonta",
                "Umuru",
                "Umunnkwoala"
            ],
            "Osisioma": [
                "Amasa",
                "Amapu",
                "Amapu-Igbengwo",
                "Amapu-Ighengwo",
                "Amayi",
                "Amankwu I",
                "Amankwu II",
                "Amaugha",
                "Amauzu",
                "Amaitoli",
                "Amuzu",
                "Ariaria",
                "Akpa I",
                "Akpa II",
                "Akpa III",
                "Akpa IV",
                "Asamoka",
                "Egbede",
                "Egbede-Owo",
                "Egbelu-Owo",
                "Ibibi",
                "Ibeku",
                "Mbutunta",
                "Mbutu-Isiahia",
                "Mbutu-Umuga",
                "Mgboko-Umuete",
                "Okpalukwu",
                "Okpokoroala",
                "Okpokotoala",
                "Obiekwesu",
                "Oberete",
                "Obuzor",
                "Oso-Okwa",
                "Okpuala",
                "Okpuala-Aro",
                "Okpu-Umuobo",
                "Umaba",
                "Umuaga",
                "Umuaduru",
                "Umuobiakwa",
                "Umuobasi",
                "Umuobiloha I",
                "Umuobilaha II",
                "Umuocha",
                "Umuocham",
                "Umuochala",
                "Umuokahia",
                "Umuokoroegbu",
                "Umuoku",
                "Umuoma",
                "Umuoruka",
                "Umuopara-Amuzu",
                "Umuopara-Egbelu",
                "Umuorika",
                "Umuosu",
                "Umuoru",
                "Umuasue",
                "Umuenyikwu",
                "Umuigwe",
                "Umuikea",
                "Umuimo-Amaogwuawu",
                "Umuimo-Egbelu",
                "Umuimo-Osisiasa",
                "Umuone",
                "Umuonu",
                "Umuobia",
                "Umuodigha",
                "Umuomaghi",
                "Umuogele",
                "Umueke",
                "Umuejie",
                "Umueji",
                "Umueze II",
                "Umueze 11",
                "Umuemoko",
                "Umukaa",
                "Umukpi",
                "Umukalika",
                "Umugala",
                "Umugwua",
                "Umuike",
                "Umuncheagu",
                "Umunenikwu",
                "Umunpata",
                "Umunneise",
                "Umunyikwu",
                "Uratta",
                "Uratta/Amaekpu",
                "Umuakoma",
                "Umuoyonta"
            ],
            "Ugwunagbo": [
                "Abayi",
                "Akanu",
                "Alaoji",
                "Amaokpu-Umuitiri",
                "Amaorji",
                "Amapu-Ukebe",
                "Amapu-Umodo",
                "Amavo",
                "Amuzu-Amaikoro",
                "Asa-Amuhi",
                "Asa-Nnentu",
                "Asa-Oberie",
                "Asa-Umunka",
                "Asaomuakwa",
                "Ngwaiyiekwe",
                "Nngwa",
                "Obegu",
                "Obuzor",
                "Osusu-Aku",
                "Ozaa-Umuebukwu",
                "Ukebe",
                "Umuaja",
                "Umuama-Oke",
                "Umuchewu",
                "Umugo",
                "Umule-Osoamadi",
                "Umunkama",
                "Umuodo",
                "Ugwu-Nagbo"
            ],
            "Ukwa East": [
                "Abayi",
                "Akirika-Nta",
                "Akirika-Uku",
                "Ala-Ukwu",
                "Alaoji",
                "Amaobu",
                "Amaoringbua-Ovom",
                "Amasa-Ovom",
                "Agburuke",
                "Amapu",
                "Amakam",
                "Amuzu",
                "Azumini",
                "Asumini-Stranger",
                "Eziama",
                "Eti",
                "Isiahia",
                "Ikiruamike",
                "Ikwueke",
                "Ikwuorie",
                "Obeaku",
                "Obegu",
                "Obija",
                "Oboau",
                "Obosau",
                "Obozu",
                "Obunku",
                "Ohanso",
                "Ohukwu",
                "Ohaogwe",
                "Okoloma Quarters",
                "Okotoko",
                "Osuogwo",
                "Ukebe",
                "Umuaelaki",
                "Umumbukwa",
                "Umuaforkwu",
                "Umuadienweh-Akirika-Obu",
                "Umuagada",
                "Umuagwa",
                "Umuagwula",
                "Umuakoma",
                "Umuobiakwa",
                "Umuobasi",
                "Umuodigha",
                "Umuokafor-Akirika-Obu",
                "Umuokara",
                "Umuopara",
                "Umuomegbi",
                "Umuoru",
                "Umuigbube-Achara",
                "Umuihute-Akirika-Obu",
                "Umunkaru-Akirika-Obu",
                "Umuikea",
                "Umuokatawom",
                "Umueke",
                "Umuechi",
                "Umueijioke",
                "Umuezigbe",
                "Umugwuma",
                "Umujaghari",
                "Umumagberugo",
                "Umuogazi",
                "Umuone",
                "Umukpi",
                "Umume",
                "Umuihu Eze 11",
                "Umuihu Eze 12",
                "Umuihu Eze 13",
                "Umuibe",
                "Umuihueze II",
                "Umuoma"
            ],
            "Ukwa West": [
                "Asa North",
                "Asa South",
                "Amaukwu",
                "Aparazu",
                "Ezebudele",
                "Eze Ugwu Owaza",
                "Etitiuzo Owaza",
                "Imo River",
                "Ipu East",
                "Ipu South",
                "Ipu West",
                "Obiahia",
                "Obiawom",
                "Obiakpu",
                "Obibor",
                "Obuzor",
                "Obehie",
                "Oke Ikpe",
                "Okpokoro Ala",
                "Ogwe",
                "Ogwati",
                "Oguawane",
                "Omuma Uzor",
                "Ozar Ukwu",
                "Ozar West",
                "Owaza",
                "Umunteke",
                "Umuadienwe",
                "Umuakata Owaza",
                "Umuanga",
                "Umuanya",
                "Umuagada",
                "Umuazuta",
                "Umuabali",
                "Umuachakwu",
                "Umuachoke",
                "Umuaebo",
                "Umuahoma",
                "Umuamaka",
                "Umuokwu",
                "Umuaemo",
                "Umuawuchi",
                "Umuema",
                "Umuobasi",
                "Umuokoroegbu",
                "Umuokatawom",
                "Umuoku",
                "Umuopere",
                "Umuopere Kamanu",
                "Umuorika",
                "Umuoruka",
                "Umuoruwu",
                "Umuorku",
                "Umuoriaku",
                "Umuosakara",
                "Umuoji",
                "Umuosu",
                "Umuone",
                "Umuodigha",
                "Umuoka",
                "Umuolu",
                "Umuololo",
                "Umuomegbi",
                "Umuopara",
                "Umuogwu",
                "Umuogazi",
                "Umukalu",
                "Umukpi",
                "Umukwuru",
                "Umule Osoamadi",
                "Umuihu Eze 11",
                "Umuihu Eze 12",
                "Umuihu Eze 13",
                "Umuibe",
                "Umuihueze II"
            ],
            "Umuahia North": [
                "Afugiri",
                "Amafor",
                "Amaforikungwu",
                "Amaogwugwu",
                "Akpahiaobiohuru",
                "Akpahiaokpula",
                "Egwunaeleke",
                "Ihigeude",
                "Isingwu",
                "Isingwuofeme",
                "Mbataofeme",
                "Nkataokpula",
                "Nkatalike",
                "Nkwoachara",
                "Nkwoegwu",
                "Ngboko",
                "Obiohuru",
                "Okaiuga",
                "Okwarakaru",
                "Okwu",
                "Umuabu",
                "Umuagu",
                "Umuada",
                "Umuaganga",
                "Umuagbom",
                "Umuagungoliri",
                "Umuakam",
                "Umuofaka",
                "Umuohuru",
                "Umuokoro",
                "Umuokoroala",
                "Umuokwelenta",
                "Umuokwhiobiohuru",
                "Umuoriehi",
                "Umuosu",
                "Umuawaalaocha",
                "Umuegwuobiohuru",
                "Umuegwuokpuala",
                "Umuekweluii",
                "Umuekwulei",
                "Umueze",
                "Umuezeama",
                "Umuezeaoma",
                "Umuezikwofeme",
                "Umuhu",
                "Umuogba",
                "Umuokara",
                "Umumiri",
                "Umuochu",
                "Umuokwhi",
                "Umule",
                "Umuyota"
            ],
            "Umuahia South": [
                "Abam",
                "Akmibo",
                "Amaudara",
                "Amachara",
                "Amankwo",
                "Amuzu",
                "Amuzuta",
                "Avodim",
                "Ehume",
                "Ekenobizi",
                "Egbeada",
                "Elugwu Umuoram",
                "Eziama",
                "Exeleke",
                "Ipupe",
                "Laguru",
                "Mgbarakuma",
                "Nsirimo",
                "Nsukwe",
                "Ogbodimbe",
                "Ogbodiukwu",
                "Ohiaocha",
                "Omaegwu",
                "Okwu",
                "Old Umuahia",
                "Ohiya",
                "Umuabli",
                "Umuako",
                "Umuimaka",
                "Umuokwom",
                "Umuobutu",
                "Umuogu",
                "Umuopara",
                "Umuove",
                "Umuecheokwu",
                "Umueledi",
                "Umueze",
                "Umuezeala",
                "Umuoyia",
                "Umunwanwa",
                "Umosu",
                "Umuoba"
            ],
            "Umunneochi": [
                "Achra",
                "Akawa",
                "Alokp-Anta",
                "Amaekwuru",
                "Amaelu",
                "Amaogidi",
                "Amaubiri",
                "Amuda",
                "Eziama",
                "Eluama Amairoka",
                "Eluama Orota",
                "Ihie",
                "Ihita",
                "Ihite-Lekuasi",
                "Ihite-Leru",
                "Ikenga-Lekwesi",
                "Ikenga-Leru",
                "Isuochi",
                "Lokpanta",
                "Lomara",
                "Mbala",
                "Ndiawa",
                "Ngodo",
                "Nneato",
                "Obilagu",
                "Ubahu",
                "Umuaku",
                "Umuelem",
                "Umuogele",
                "Umuch-Ileze",
                "Umuodi",
                "Uru"
            ]
        }
    },
    {
        "Adamawa": {
            "Demsa": [
                "Bajan",
                "Bamaro",
                "Bille",
                "Dakusung",
                "Dingle",
                "Ga-Fulani",
                "Gah",
                "Gansari",
                "Gorin",
                "Maizanshe",
                "Mayo",
                "Ntorong",
                "Pishi",
                "Tere",
                "Waka",
                "Mbula",
                "Bajifang",
                "Bangun",
                "Chafan",
                "Garan",
                "Guguri",
                "Kade",
                "Kpakmyagi",
                "Kulangilung",
                "Kulasala",
                "Labakuri",
                "Kuli",
                "Nzungwaling",
                "Shime",
                "Tahau",
                "Tandakai",
                "Tassala",
                "Tsonbwang",
                "Tsware",
                "Uni-Lab",
                "Barinkin",
                "Bomni",
                "Bujin",
                "Dakkli",
                "Dem",
                "Donwa",
                "Guri",
                "Kpankpai",
                "Kpasham",
                "Kwafara",
                "Tamshi",
                "Yagombali",
                "Borrong",
                "Busso",
                "Dili",
                "Loh",
                "Gosho",
                "Kunteri",
                "Lassale",
                "Linga",
                "Mbumaa",
                "Morro",
                "Ngongolang",
                "Salabangha",
                "Takka",
                "Tikka",
                "Uganda",
                "Swangu",
                "Gwamba",
                "Billachi",
                "Bungudo",
                "Byelanga",
                "Famtami",
                "Gamba",
                "Lassala",
                "Mbamburu",
                "Sabewa",
                "Salara",
                "Sondi",
                "Tswaban",
                "Munchi",
                "Bolon",
                "Fara",
                "Gada",
                "Janawuri",
                "Kedemure",
                "Lawaru",
                "Ngbekedewe",
                "Unguwan",
                "Demsa",
                "Bwashi",
                "Dakanta",
                "Dowaya",
                "Dwam",
                "Farai",
                "Gani",
                "Gindin",
                "Gorogbake",
                "Green",
                "Gwassala",
                "Hosere",
                "Kadomum",
                "Kawon",
                "Kindam",
                "Kokumto",
                "Kudiri",
                "Kunliro",
                "Kwale",
                "Kwayine",
                "Lanyaling",
                "Lupanga",
                "Maliki",
                "Mbukanga",
                "Moya",
                "Murgarang",
                "Nzuramta",
                "Pode",
                "Sabon",
                "Wuro",
                "Yero",
                "Zuran"
            ],
            "Fufore": [
                "Bai",
                "Babirwo",
                "Bagale",
                "Balachi",
                "Bappawo",
                "Baraja",
                "Bati",
                "Beti",
                "Beli",
                "Bilachi",
                "Bngo",
                "Boggare",
                "Budiyang",
                "Chafajaule",
                "Chekeuro",
                "Chigari",
                "Chikito",
                "Dasin",
                "Daware",
                "Digino",
                "Dulo",
                "Doaka",
                "Farang",
                "Fema",
                "Filingo",
                "Furo",
                "Fufore",
                "Gagdi",
                "Gawi",
                "Goshidang",
                "Gurin",
                "Guigwa",
                "Gurati",
                "Hamdallah",
                "Holmawo",
                "Kadang",
                "Hegga",
                "Hes-Beti",
                "Hirungo",
                "Jammare",
                "Jili",
                "Karlahi",
                "Kiri",
                "Kofa",
                "Koksupa",
                "Litare",
                "Magdari",
                "Malabu",
                "Mayo",
                "Mayo-Inne",
                "Mbamga",
                "Mbilla",
                "Mboi",
                "Mubako",
                "Muninga",
                "Nassarawo",
                "Nyibango",
                "Nyibire",
                "Pariya",
                "Pateri",
                "Perda",
                "Ribadu",
                "Riba",
                "Sirotore",
                "Slomsi",
                "Tali",
                "Teleuchi",
                "Toza",
                "Vamni",
                "Verre",
                "Watango",
                "Wom-Jangi",
                "Wuro",
                "Wuro-Bokki",
                "Wuro-Jauro",
                "Wuro-Kachalla",
                "Wuro-Mallum",
                "Wuro-Sam",
                "Wuro-Ujiri",
                "Wuro-Yolde",
                "Yaungo",
                "Yadim"
            ],
            "Ganye": [
                "Abuja",
                "Alhamisa",
                "Angawab",
                "Arnadodebbo",
                "Bagana",
                "Balankaren",
                "Banarikiuso",
                "Banshe",
                "Bari",
                "Bappare",
                "Batal",
                "Bawo",
                "Bibadu",
                "Biri",
                "Bowo",
                "Bwole",
                "Burum",
                "Buweti",
                "Da'age",
                "Dabora",
                "Dabadu",
                "Dabaku",
                "Dabgerum",
                "Dabosino",
                "Dabtelum",
                "Dabulla",
                "Daburma",
                "Dadiri",
                "Dadera",
                "Dagumal",
                "Daguma",
                "Daguni",
                "Dajabi",
                "Dajubin",
                "Dakauro",
                "Dakemdu",
                "Daketi",
                "Dakobben",
                "Dakom",
                "Dakpukum",
                "Daku",
                "Dakuna",
                "Dalam",
                "Dalanvau",
                "Dalepkin",
                "Daloo",
                "Daluya",
                "Damema",
                "Damoka",
                "Dampiya",
                "Danjangla",
                "Danubi",
                "Dapellum",
                "Dataraa",
                "Dattam",
                "Dauti",
                "Dayiri",
                "Degorde",
                "Demkun",
                "Desigba'a",
                "Deuti",
                "Dimoso",
                "Dimkurma",
                "Dinkokum",
                "Dinyabbi",
                "Dissol",
                "Dmkusum",
                "Dowaya",
                "Dunggum",
                "Faragba",
                "Fara",
                "Gada",
                "Gamgaraso",
                "Gamgbanen",
                "Gangaila",
                "Gangbuen",
                "Gangbebbi",
                "Gangbiren",
                "Ganglumgorori",
                "Gangminomi",
                "Gangnuyika",
                "Gangsanen",
                "Gangteme",
                "Gangtimeni",
                "Gangtum",
                "Gangtari",
                "Gangvan",
                "Gangwoki",
                "Gangwon",
                "Gansari",
                "Gatanen",
                "Gayemjangba",
                "Garaja",
                "Garamba",
                "Gawakola",
                "Gintagba",
                "Gintigba",
                "Goso",
                "Gosho",
                "Grin",
                "Gudin",
                "Gumbel",
                "Gurum",
                "Hosere",
                "Jaggu",
                "Jalingo",
                "Jamisu",
                "Jangani",
                "Jangpan",
                "Jarandi",
                "Jauro",
                "Jijjiwa",
                "Jukurum",
                "Juduisa",
                "Jusingal",
                "Jutingal",
                "Kanasuwe",
                "Kawon",
                "Kineni",
                "Kindam",
                "Kokiwa",
                "Kong",
                "Kpankpai",
                "Kubaje",
                "Kuli",
                "Kulsala",
                "Kurumji",
                "Kusmji",
                "Lamvan",
                "Lekwoshi",
                "Lingbi",
                "Lisabi",
                "Luggerre",
                "Luko",
                "Mallam",
                "Manti",
                "Masah",
                "Mapiadi",
                "Mayo",
                "Mbula",
                "Mbumaa",
                "Moya",
                "Nabantura",
                "Nabeng",
                "Nabon",
                "Nadeu",
                "Nagana",
                "Nagboko",
                "Nashiri",
                "Nasiti",
                "Nawa",
                "Nayabbi",
                "Naya",
                "Nolomi",
                "Nongvan",
                "Ntorong",
                "Nzugwaling",
                "Nzuramta",
                "Padimso",
                "Peshi",
                "Pishi",
                "Pode",
                "Sabon",
                "Sakule",
                "Sahl",
                "Sakkuwa",
                "Saman",
                "Samarun",
                "Sambari",
                "Sammeti",
                "Sandasini",
                "Sandoka",
                "Sangbang",
                "Sangotim",
                "Sangubi",
                "Sanjetiti",
                "Sankom",
                "Sankuran",
                "Santanen",
                "Sanzuseu",
                "Sausiri",
                "Saukem",
                "Seuchi",
                "Sese",
                "Shiga",
                "Soppken",
                "Tamshi",
                "Tapare",
                "Tasa",
                "Tiduti",
                "Timpukki",
                "Timtubi",
                "Timyemma",
                "Timpoma",
                "Timbeurki",
                "Timpki",
                "Timkusum",
                "Timukum",
                "Timdesi",
                "Timdingga",
                "Timkiti",
                "Timyami",
                "Timyela",
                "Tiri",
                "Tsonbwang",
                "Waja",
                "Wadore",
                "Waka",
                "Wowokki",
                "Wuro",
                "Wuromodibbo",
                "Yalaki",
                "Yamkliro",
                "Yapashi",
                "Yebbi",
                "Yola",
                "Yowokki"
            ],
            "Girei": [
                "Bakari",
                "Bonyo",
                "Damare",
                "Daniyel",
                "Gerei",
                "Gereng",
                "Gerie",
                "Jabbi",
                "Jefan",
                "Labondo",
                "Lainde",
                "Mallam",
                "Modire",
                "Ruwo",
                "Tambo",
                "Wuro"
            ],
            "Gombi": [
                "Alaji",
                "Alanra",
                "Babal",
                "Bada",
                "Bafi",
                "Bala",
                "Balhona",
                "Banga",
                "Barmishu",
                "Barma",
                "Baru",
                "Bawa",
                "Bebe",
                "Bidel",
                "Bidim",
                "Bijibiji",
                "Blwhona",
                "Boga",
                "Bokki",
                "Boma",
                "Dadware",
                "Dahai",
                "Dangula",
                "Dangwara",
                "Daniyel",
                "Demna",
                "Dimaska",
                "Dingai",
                "Dini",
                "Dkungama",
                "Dongo",
                "Dungal",
                "Duwa",
                "Dzangwala",
                "Farma",
                "Farmi",
                "Ferumara",
                "Fotta",
                "Futudan",
                "Gabun",
                "Gada",
                "Gahumba",
                "Galga",
                "Gangrang",
                "Ganjare",
                "Ganjing",
                "Gardama",
                "Garin",
                "Garkida",
                "Garfite",
                "Gegeli",
                "Gir",
                "Girgithang",
                "Gombi",
                "Gural",
                "Guyaku",
                "Hina",
                "Hursada",
                "Hursama",
                "Hursea",
                "Hurunda",
                "Jau",
                "Jebral",
                "Jebre",
                "Joroboi",
                "Jouk",
                "Jula",
                "Kadesum",
                "Kamsu",
                "Kanesu’Kangohobe",
                "Kanjita",
                "Karkwane",
                "Karlahi",
                "Kaudi",
                "Kaula",
                "Kawunda",
                "Kilake",
                "Kilar",
                "Kiro",
                "Kojoli",
                "Koko",
                "Korra",
                "Kwalamba",
                "Kwanan",
                "Kwarwa",
                "Kwari",
                "Kwada",
                "Kwanta",
                "Lala",
                "Labondo",
                "Lainde",
                "Lubu",
                "Maijo",
                "Mallam",
                "Maraba",
                "Marja",
                "Mbewa",
                "Mbilla",
                "Mijiwana",
                "Melbasi",
                "Merja",
                "Modire",
                "Muchalla",
                "Nene",
                "Ngalga",
                "Ngina",
                "Ngurore",
                "Njebjeba",
                "Nyibango",
                "Nyibire",
                "Palara",
                "Pappa",
                "Parijo",
                "Pariya",
                "Pateri",
                "Perda",
                "Pirfa",
                "Pirkasa",
                "Prakwanta",
                "Raba",
                "Riji",
                "Ruwo",
                "Sama",
                "Shigane",
                "Shime",
                "Shanapa",
                "Sokra",
                "Sosai",
                "Talire",
                "Tambo",
                "Tangda",
                "Tashan",
                "Tawasu",
                "Teleuchi",
                "Tofa",
                "Tunu",
                "Tsakesimta",
                "Ulfa",
                "Umdur",
                "Urshelima",
                "Vurgwi",
                "Vurwara",
                "Walaw",
                "Wambai",
                "Wamdituru",
                "Wammirote",
                "Watango",
                "Wojoli",
                "Wmbai",
                "Wugulsa",
                "Wulbara",
                "Wungara",
                "Wuro",
                "Wuyaku",
                "Yamthiar",
                "Yang",
                "Yaungo",
                "Zangara",
                "Zanra",
                "Zugru",
                "Zthzurzu"
            ],
            "Guyuk": [
                "Arah",
                "Banjiram",
                "Bobini",
                "Bodeno",
                "Boshikiri",
                "Burthi",
                "Chikila",
                "Dangir",
                "Doma",
                "Dukul",
                "Dumna",
                "Falu",
                "Gorotoro",
                "Gugu",
                "Gunda",
                "Gundenyi",
                "Gwana",
                "Gwalura",
                "Guyuk",
                "Jagira",
                "Jiu",
                "Kerau",
                "Kola",
                "Kurnyi",
                "Kwadadai",
                "Lakumna",
                "Lamz",
                "Lapandi",
                "Lokoro",
                "Mada",
                "Pondiwe",
                "Purakayo",
                "Salbu",
                "Sili",
                "Sukelye",
                "Theble",
                "Udun",
                "Walu",
                "Wawi",
                "Zakawon"
            ],
            "Hong": [
                "Bangshika",
                "Buzza",
                "Chika",
                "Dabna",
                "Dagza",
                "Daktsi",
                "Daku",
                "Dazal",
                "Dulchidama",
                "Dulmava",
                "Dulwachira",
                "Dugwamba",
                "Dzegayerima",
                "Dzumah",
                "Dzakwa",
                "Fachi",
                "Faah",
                "Fadama",
                "Garaha",
                "Garavi",
                "Gartsanu",
                "Gashaka",
                "Gashala",
                "Gaya",
                "Gudumiya",
                "Gunda",
                "Gundenyi",
                "Gwana",
                "Gwalura",
                "Hildi’Husara",
                "Hong",
                "Jabba",
                "Jalingo",
                "Kala’a",
                "Kinging",
                "Kuddah",
                "Kuliyi",
                "Kubtava",
                "Kura",
                "Kwaprey",
                "Kwakwa’ah",
                "Kwambula",
                "Kwatau",
                "Kwarhi",
                "Lar",
                "Lugga",
                "Maijo",
                "Makera",
                "Maki",
                "Mbalwaha",
                "Mbanga",
                "Mbulagyeng",
                "Mbu",
                "Midillah",
                "Migzil",
                "Mijili",
                "Mombol",
                "Mothol",
                "Mubula",
                "Mugwalar",
                "Mukuving",
                "Mung",
                "Mutuku",
                "Ngalbi",
                "Njerri",
                "Pella",
                "Sikaluri",
                "Shashau",
                "Shiwa",
                "Sukelye",
                "Tasha",
                "Thlang",
                "Uba",
                "Uding",
                "Walu",
                "Washim",
                "Wawi",
                "Wuro",
                "Zah",
                "Zakawon",
                "Zhedinyi",
                "Zugru"
            ],
            "Jada": [
                "Balauru",
                "Banche",
                "Choncha",
                "Dagula",
                "Dalami",
                "Danaba",
                "Dashen",
                "Deggi",
                "Farang",
                "Gaadjo",
                "Gangnai",
                "Gari",
                "Jada",
                "Jalingo",
                "Jamtari",
                "John",
                "Kilbawo",
                "Kojoli",
                "Koma",
                "Konglo",
                "Kubi",
                "Leko",
                "Lengdo",
                "Mangla",
                "Mapeo",
                "Mayo-Hako",
                "Mayo-Ine",
                "Mbngan",
                "Mbulo",
                "Naguma",
                "Namberu",
                "Nassarawo",
                "Nadeu",
                "Ngolomba",
                "Nyibango",
                "Pakorgel",
                "Pola",
                "Samlo",
                "Sapeo",
                "Sarkin",
                "So’o",
                "Tantile",
                "Tuli",
                "Wuro",
                "Yelli"
            ],
            "Lamurde": [
                "Anguwan",
                "Badim",
                "Bajen",
                "Balaifi",
                "Bandawa",
                "Bashaka",
                "Bafio",
                "Bolere",
                "Botoni",
                "Bulkutu",
                "Bunari",
                "Dauto",
                "Dubwagun",
                "Dullum",
                "Dutsen",
                "Gangare",
                "Galu",
                "Gongong",
                "Goh",
                "Gunduli",
                "Gyakan",
                "Gyawana",
                "Hadiyo",
                "Hoki",
                "Kauya",
                "Kizza",
                "Kowei",
                "Kutu",
                "Kwaa",
                "Kwana",
                "Kwah",
                "Labawa",
                "Lafiya",
                "Lamurde",
                "Lassin",
                "Lugere",
                "Luwafute",
                "Mala",
                "Mallah",
                "Mamsirme",
                "Mbemum",
                "Mere",
                "Mwana",
                "Nasarawo",
                "Ngbakowo",
                "Ngbamoto",
                "Ngbebonge",
                "Ngodogoron",
                "Opalo",
                "Overseer",
                "Pude",
                "Rigange",
                "Ruwan",
                "Sabannah",
                "Sabonlayi",
                "Shemun",
                "Song",
                "Suwa",
                "Sulne",
                "Tingno",
                "Tiso",
                "Toto",
                "Tsayawa",
                "Tudun",
                "Turakra",
                "Waduku",
                "Wame",
                "Wankan",
                "Wodipwa",
                "Zekun",
                "Zuggo"
            ],
            "Madagali": [
                "Bakin Dutse",
                "Bebel",
                "Bitiku",
                "Chakawa",
                "Dagali",
                "Damai Kasa",
                "Damai Sama",
                "Dar",
                "Duhu",
                "Dzuel",
                "Gadadamayo",
                "Gadadamayo uda",
                "Gadamayo",
                "Ghantsa",
                "Ghunilse",
                "Gilma",
                "Giwa Bula",
                "Giwa Higgi",
                "Guak",
                "Gulak",
                "Gumbili",
                "Gubla",
                "Gwaram",
                "Hashi",
                "Hyambula I",
                "Hyambula II",
                "Iirsa",
                "Jalingo",
                "Kafin Hausa",
                "Kaya",
                "Kirchinga",
                "Kojiti",
                "Kopa",
                "Kubu",
                "Kuburshuwa",
                "Kuda",
                "Kuda Wazu",
                "Kwakwaghu",
                "Kwalbadi",
                "Kwambula",
                "Kwammnu",
                "Kwamda",
                "Lamore",
                "Lumadu",
                "Mafer",
                "Maigana",
                "Makwan",
                "Maradi",
                "Mayowandu",
                "Mildo Shalmi",
                "Mildo Vapura",
                "Muduvu",
                "Ndalmi",
                "Njahili",
                "Pallam",
                "Pambul",
                "Rugudum",
                "Shuwa",
                "Shuwari",
                "Sukur",
                "Sukur Daurawa",
                "Sukur Settlement",
                "Thalwancina",
                "Tsidla",
                "Tsitil",
                "Turtakiva",
                "Viengo",
                "Visik",
                "Visik Mattakam",
                "Wakara",
                "Wanuki",
                "Wagga",
                "Wula Mango",
                "Wurogas",
                "Wurongayandi",
                "Yebango",
                "Yinagu",
                "Zhau"
            ],
            "Maiha": [
                "Alamisa",
                "Bafere",
                "Baken",
                "Belel",
                "Bodeje",
                "Boloko",
                "Bwade",
                "Bungel",
                "Cede",
                "Dafra",
                "Dagchere",
                "Dude",
                "Ejunturi",
                "Fulberi",
                "Furiemo",
                "Furamane",
                "Gari",
                "Gende",
                "Holma",
                "Hubari",
                "Hudu",
                "Humbutudi",
                "Jababa",
                "Jalingo",
                "Jamtari",
                "Jilang",
                "Kasagila",
                "Kesure",
                "Kilangi",
                "Kilanye",
                "Kirdagirma",
                "Kiringabu",
                "Kolwa",
                "Konkol",
                "Kungoli",
                "Kuna",
                "Kwa’aboon",
                "Kwagol",
                "Laide",
                "Lande",
                "Lefen",
                "Lugdera",
                "Lugga",
                "Lunde",
                "Maiga",
                "Maiha",
                "Majaula",
                "Maner",
                "Manjikir",
                "Massagala",
                "Mbalagi",
                "Mbegechi",
                "Mbila",
                "Mayo",
                "Mayoteyel",
                "Nassarawo",
                "Nguli",
                "Njanyi",
                "Njilang",
                "Pakka",
                "Paraiyel",
                "Pegin",
                "Pete",
                "Salma",
                "Sarau",
                "Sikmavi",
                "Tambajam",
                "Tirsi",
                "Tongo",
                "Vamde",
                "Vokuna",
                "Walewal",
                "Watango",
                "Wuro",
                "Yebango"
            ],
            "Mayo-Belwa": [
                "Alkali Manga",
                "Bajama",
                "Bambe",
                "Binkola",
                "Binyeri",
                "Bum Bum",
                "Bunyayi",
                "Bura Manga",
                "Chukkol",
                "Chukkol Fulani",
                "Dapanti",
                "Gambe",
                "Gang Fada",
                "Ganglamja",
                "Ganglushi Bamfo",
                "Gangsubeni",
                "Gangtagani",
                "Garu",
                "Gengle",
                "Gijaro",
                "Gorobi",
                "Kauram",
                "Labara",
                "Lamja",
                "Liringo",
                "Mbanga",
                "Mbalgara",
                "Mbilla",
                "Mbullo",
                "Mokki",
                "Munchi",
                "Nassarawo Jereng",
                "Ndikong",
                "Ribadu",
                "Sate Jauro Mbilla",
                "Sindigawa",
                "Tola",
                "Tugga",
                "Ubaka",
                "Wakka",
                "Wappa",
                "Wuro Bantare",
                "Yelwa",
                "Yoffo",
                "Yolde Gubdo",
                "Zabi"
            ],
            "Michika": [
                "Anguwan Layi Lassa",
                "Bazza",
                "Bedi",
                "Bokka",
                "Bulabili",
                "Dilichime",
                "Diwa",
                "Dlaka",
                "Dzali",
                "Dzuroke",
                "Futu",
                "Futudu",
                "Futuless",
                "Garta",
                "Garta Kasa",
                "Ghenjawa",
                "Ghevi",
                "Gilhenki",
                "Glumchi",
                "Gra",
                "Himike",
                "Hudzukwi",
                "Hule",
                "Jang",
                "Jigalambu",
                "Kambadea",
                "Kasuwa Naira",
                "Kelen Kela",
                "Kemale",
                "Kubi",
                "Kuda",
                "Kudzum",
                "Kwabapale",
                "Kwalia",
                "Kwatsabe",
                "Layi Lughu",
                "Lidle",
                "Likune",
                "Madzi",
                "Madzi II",
                "Mboruro",
                "Mbradzewi",
                "Michika",
                "Minkisi",
                "Moda",
                "Mukaracitta",
                "Mumi",
                "Murva",
                "Mwagwa",
                "Muzuku",
                "Mutse",
                "Nkafa",
                "Nkafa Mnalamai",
                "Nkala",
                "Pambulo",
                "Patha",
                "Pee",
                "Rafin Samyi",
                "Sangari I",
                "Sima Gali",
                "Sima Mallo",
                "Simakwande",
                "Sufuku",
                "Thukudou",
                "Tilli",
                "Tsukumu",
                "Tuden Wada",
                "VIH",
                "Villegwa",
                "Vu-Kaghe",
                "Vu-Zhehyi",
                "Wambilumi",
                "Warakandza",
                "Watsila",
                "Watu II",
                "Waya Ndawa",
                "Wula",
                "Wurarike",
                "Wuro Gayandi",
                "Wuro Ngiki",
                "Yamue",
                "Zah",
                "Zah Megha"
            ],
            "Mubi North": [
                "Bahuli",
                "Bakaya",
                "Bantahi",
                "Barama",
                "Baagira",
                "Betso",
                "Betso Manga",
                "Chabul",
                "Cha",
                "Dadgala",
                "Dazala",
                "Diagil",
                "Didif",
                "Duga",
                "Duda",
                "Gada Mayo",
                "Ginnziha",
                "Gudumiya",
                "Guri",
                "Gurmanjara",
                "Gurunshida",
                "Gyumbula",
                "Hosere Tumbal",
                "Jerengol",
                "Kamnda",
                "Kapoli",
                "Kelluje",
                "Kiriya",
                "Koma",
                "Kotirde",
                "Kwaba",
                "Kwachifa",
                "Kwaskine",
                "Kwa",
                "Maduguva",
                "Manzil",
                "Maskoka",
                "Mbamba",
                "Mbiduwa",
                "Miza",
                "Mitira",
                "Mobu",
                "Muchalla",
                "Mujilu",
                "Mukta",
                "Muva",
                "Muvudi",
                "Muvur",
                "Nduku",
                "Pawi",
                "Ribawa",
                "Suzuwa",
                "Tapare",
                "Tsamu Tela",
                "Tsemo",
                "Vimtim",
                "Wafango",
                "Wudivi",
                "Wuro Barka",
                "Wuro Gendeji",
                "Wuro Harde",
                "Yaza"
            ],
            "Mubi South": [
                "Chaba",
                "Dirbishi",
                "Duvu",
                "Gandira",
                "Gella",
                "Girburum",
                "Gude",
                "Kwaja",
                "Lamorde",
                "Mugulbu",
                "Mujara",
                "Nassarawo",
                "Nduku",
                "Yadafa"
            ],
            "Numan": [
                "Bandawa",
                "Bang",
                "Bare",
                "Batache",
                "Bolki",
                "Bokotei",
                "Bulkm",
                "Byemti",
                "Bwei",
                "Daso",
                "Dorawa",
                "Fare",
                "Gamadio",
                "Garin Gomro",
                "Gemun",
                "Hayin Gaba",
                "Imburu",
                "Jere",
                "Kanti",
                "Kikan",
                "Kodomti",
                "Koh",
                "Kwapuke",
                "Kwnan Bujem",
                "Lawe Salti",
                "Luram",
                "Monaga",
                "Morro",
                "Nega",
                "Ngawalti",
                "Ngella",
                "Ngendan",
                "Ngbalang",
                "Ngbalapun",
                "Nuguwun",
                "Numan",
                "Nyol",
                "Nzoruwe",
                "Pullum",
                "Sabon",
                "Salti",
                "Shafforon",
                "Tamara",
                "Tamu",
                "Tegbele",
                "Takoh",
                "Tungan",
                "Uban",
                "Vulpi",
                "Wodi",
                "Yanga",
                "Zambun",
                "Zangun"
            ],
            "Shelleng": [
                "Bakta",
                "Bandah",
                "Barata",
                "Bayen",
                "Biki",
                "Birwit",
                "Bira-Bira",
                "Bobere",
                "Boburo",
                "Bokayeki",
                "Bolama",
                "Bodwai",
                "Bubari",
                "Chaba",
                "Dakkiti",
                "Dabewo",
                "Dakiti",
                "Deben",
                "Doge",
                "Dolla",
                "Dunge",
                "Dumburi",
                "Gadajuga",
                "Gandira",
                "Garin",
                "Gargajo",
                "Gargijik",
                "Gella",
                "Gimakurje",
                "Gidan",
                "Girburum",
                "Golla",
                "Gombel",
                "Gondong",
                "Goroshi",
                "Gorum",
                "Gude",
                "Gukuri",
                "Gwadinge",
                "Gwagarap",
                "Gwakta",
                "Gwapopolok",
                "Homra",
                "Iwiriwi",
                "Jabbi",
                "Jabi",
                "Jakinda",
                "Jalingo",
                "Jamali",
                "Jang",
                "Jauro",
                "Jimbo",
                "Jihadi",
                "Jonkolo",
                "Jumbul",
                "Kambila",
                "Karlaje",
                "Katte",
                "Kem",
                "Ketembere",
                "Kikan",
                "Kiri",
                "Kogindole",
                "Koh",
                "Komadi",
                "Kondoronhe",
                "Kongma",
                "Kula",
                "Kukumli",
                "Kurungu",
                "Kwaja",
                "Kwabapale",
                "Kwachifa",
                "Kwapuke",
                "Kwnan",
                "Lababiri",
                "Labaram",
                "Labau",
                "Lagonsho",
                "Laidedama",
                "Lajang",
                "Lama",
                "Lanuwa",
                "Leda",
                "Liringo",
                "Lipiro",
                "Luram",
                "Maduguva",
                "Manzil",
                "Maskoka",
                "Mbamba",
                "Mbiduwa",
                "Mboruro",
                "Mbradzewi",
                "Michika",
                "Mittim",
                "Miza",
                "Monaga",
                "Monpdode",
                "Morro",
                "Mujara",
                "Mujilu",
                "Mukta",
                "Mumi",
                "Murva",
                "Mwagwa",
                "Muzuku",
                "Mutse",
                "Nafada",
                "Nasarawo",
                "Nduku",
                "Nega",
                "Ngawalti",
                "Ngella",
                "Ngendan",
                "Ngbalang",
                "Ngbalapun",
                "Nkafa",
                "Nkala",
                "Nuguwun",
                "Nyol",
                "Nzoruwe",
                "Pawi",
                "Pella",
                "Pullum",
                "Pupa",
                "Rafin",
                "Ribawa",
                "Rimi",
                "Ruhum",
                "Sabon",
                "Salti",
                "Sangari",
                "Sate",
                "Sembuluri",
                "Shafforon",
                "Shebta",
                "Shumshi",
                "Sima",
                "Simakwande",
                "Surara",
                "Suzuwa",
                "Takoh",
                "Talum",
                "Tamara",
                "Tangah",
                "Tegbele",
                "Tetek",
                "Thukudou",
                "Tilli",
                "Timbu",
                "Tola",
                "Tsamu",
                "Tsemo",
                "Tuden",
                "Tungan",
                "Uban",
                "Vanera",
                "Vimtim",
                "Vulpi",
                "Wadafa",
                "Wafango",
                "Waka",
                "Waoje",
                "Warakandza",
                "Watsila",
                "Watu",
                "Welmet",
                "Wodi",
                "Wuro",
                "Yadafa",
                "Yalo",
                "Yanga",
                "Yelwa",
                "Yorong",
                "Zaunan",
                "Zangun",
                "Zhau"
            ],
            "Song": [
                "Boloko",
                "Chukkol",
                "Dirma",
                "Ditera",
                "Dumne",
                "Gben",
                "Gudu",
                "Holma",
                "Karlahi",
                "Kilange",
                "Lappae",
                "Loko",
                "Mbilla",
                "Mboi",
                "Song",
                "Waltadi",
                "Zumo",
                "Zuno"
            ],
            "Toungo": [
                "Adamu",
                "Arne",
                "Baba",
                "Badu",
                "Babre",
                "Bakaya",
                "Bavehi",
                "Biniji",
                "C. Nadu",
                "Dawo",
                "Dananji",
                "Dichire",
                "Galabje",
                "Galabiye",
                "Gamti",
                "Ganti",
                "Gasa-Nappi",
                "Gemda",
                "J. Dewa",
                "Jiman",
                "Jimon",
                "Kagin",
                "Kilta",
                "Kini",
                "Kubali",
                "Kubore",
                "Labore",
                "M. Jaja",
                "M. Kom",
                "Mai",
                "Mao",
                "Mayo",
                "Nappi",
                "Nayini",
                "Nuibago",
                "Okalat",
                "Sabongai",
                "Samkin",
                "Simdagau",
                "Songeli",
                "Sungwara",
                "Tafida",
                "Tapare",
                "Taraba",
                "Tim",
                "Timbangor",
                "Tungo"
            ],
            "Yola North": [
                "Ajiya",
                "Alkalawa",
                "Doubeli",
                "Gwadabawa",
                "Jambutu",
                "Karewa",
                "Limawa",
                "Luggere",
                "Rumde"
            ],
            "Yola South": [
                "Bbamba",
                "Bole",
                "Changala",
                "Goduwu",
                "Gongoshi",
                "Kulangu",
                "Lagire",
                "Maalkobhi",
                "Namtara",
                "Namtari Gurel",
                "Namtari Manga",
                "Ngolamba",
                "Ngorore",
                "Njomboli",
                "Njombvoli",
                "Njoomboliyo",
                "Rugange",
                "Sebore",
                "Wuro Yanka",
                "Yola",
                "Yolde Pate",
                "Zuno"
            ]
        }
    },
    {
        "Abuja": {
            "Abaji": [
                "Adagba",
                "Afo",
                "Agyana",
                "Akori",
                "Alampa",
                "Allu",
                "Ayaba",
                "Bago",
                "Bandagi",
                "Bari-Bezi",
                "Bazi-Bezi",
                "Busga",
                "Chakun",
                "Chundugo",
                "Dabbare",
                "Dara",
                "Dapala",
                "Dewu",
                "Domi",
                "Dum",
                "Ebagi",
                "Ekki",
                "Fakon Tando",
                "Gadabiri",
                "Gari",
                "Gasakba",
                "Gasukpa",
                "Gawu",
                "Gawun",
                "Gbogbogo",
                "Gidan Maisaye",
                "Gurdi",
                "Guruza",
                "Gwanda",
                "Gwona",
                "Jamigbe",
                "Kafako",
                "Kebba",
                "Kpace",
                "Kularida",
                "Kutara",
                "Kwago",
                "Kwakwa",
                "Kyawu",
                "Lafia Yaba",
                "Madechi",
                "Manderegi",
                "Managi",
                "Nadichi",
                "Nagun",
                "Nahalati Sabo",
                "Nah. Tosho",
                "Nassarawa",
                "Nuku",
                "Nowog",
                "Nyembo",
                "Pako Base",
                "Panagana",
                "Panagu",
                "Pandaji",
                "Pankuru",
                "Panpari",
                "Piowe",
                "Rimba",
                "Sabongida",
                "Sarowo-Abdu",
                "Selifulyu",
                "Shadad",
                "Soitan",
                "Takpeshi",
                "Talpa",
                "Tanaga",
                "Uboshenu",
                "Wapa",
                "Yawula",
                "Yelwa",
                "Yelwa Gawu",
                "Zuwa"
            ],
            "AMAC": [
                "Abacha Barracks",
                "Adamu",
                "Airport",
                "Aleku",
                "Aleyita",
                "Angawa",
                "Angwan",
                "Anka",
                "Apo",
                "Arne",
                "Baba",
                "Badu",
                "Babre",
                "Bakaya",
                "Bavehi",
                "Biniji",
                "C. Nadu",
                "Dananji",
                "Damakasa",
                "Damakuba",
                "Damakusa",
                "Damagaza",
                "Dandi",
                "Dayisa",
                "Dei-die",
                "Dichire",
                "Dodo",
                "Dogori",
                "Domi",
                "Dum",
                "Durumi",
                "Dutse",
                "Ebagi",
                "Ekki",
                "Fakon",
                "Filin",
                "Fulani",
                "Gadabiri",
                "Galabje",
                "Galabiye",
                "Gamti",
                "Ganti",
                "Gasa-Nappi",
                "Gemda",
                "Gidan",
                "Gora",
                "Gosa",
                "Gud",
                "Gui",
                "Gwako",
                "Gwagwa",
                "Gwarinpa",
                "Gyeda",
                "Hulumi",
                "Iddo",
                "Idu",
                "Imburu",
                "Jalingo",
                "Jamigbe",
                "Jang",
                "Jauro",
                "Jimbo",
                "Jihadi",
                "Jimon",
                "Kagini",
                "Kagin",
                "Karsana",
                "Katampe",
                "Ketti",
                "Kilta",
                "Kini",
                "Koloke",
                "Koma",
                "Kpace",
                "Kpepegyi",
                "Kubi",
                "Kula",
                "Kularida",
                "Kumo",
                "Kurudu",
                "Kusaki",
                "Kutasa",
                "Kwoi",
                "Kwachifa",
                "Kwakwa",
                "Kwapuke",
                "Kwnan",
                "Lababiri",
                "Labau",
                "Lagonsho",
                "Laidedama",
                "Lajang",
                "Lama",
                "Lanuwa",
                "Leda",
                "Liringo",
                "Lipiro",
                "Luram",
                "Madalla",
                "Maalkobhi",
                "Mai",
                "Makana",
                "Makanima",
                "Managi",
                "Mao",
                "Mayo",
                "Mbilla",
                "Mboi",
                "Mboruro",
                "Mbradzewi",
                "Michika",
                "Mittim",
                "Miza",
                "Monaga",
                "Monpdode",
                "Morro",
                "Mujara",
                "Mujilu",
                "Mukta",
                "Mumi",
                "Munapeyi",
                "Murva",
                "Mwagwa",
                "Muzuku",
                "Mutse",
                "Nassarawo",
                "Nduku",
                "Nega",
                "Ngawalti",
                "Ngella",
                "Ngendan",
                "Ngbalang",
                "Ngbalapun",
                "Nkafa",
                "Nkala",
                "Nuguwun",
                "Nyol",
                "Nzoruwe",
                "Odu",
                "Okalat",
                "Orozo",
                "Pako",
                "Panagana",
                "Panagu",
                "Pandaji",
                "Pankuru",
                "Panpari",
                "Pawi",
                "Pella",
                "Piowe",
                "Pullum",
                "Pupa",
                "Rafin",
                "Ribawa",
                "Rimi",
                "Ruhum",
                "Sabon",
                "Salti",
                "Sangari",
                "Sate",
                "Sauka",
                "Sebore",
                "Shafforon",
                "Shebta",
                "Shelleng",
                "Shumshi",
                "Sima",
                "Simakwande",
                "Songeli",
                "Soitan",
                "Sungwara",
                "Tafida",
                "Takilogo",
                "Takushara",
                "Talpa",
                "Tamara",
                "Tangah",
                "Tapare",
                "Taraba",
                "Tegbele",
                "Thukudou",
                "Tilli",
                "Timbangor",
                "Toge",
                "Tola",
                "Tsamu",
                "Tsemo",
                "Tuden",
                "Tungan",
                "Uban",
                "Utako",
                "Vanera",
                "Vimtim",
                "Vulpi",
                "Wadafa",
                "Wafango",
                "Waka",
                "Waoje",
                "Warakandza",
                "Watsila",
                "Watu",
                "Welmet",
                "Wodi",
                "Wumba",
                "Wuro",
                "Yadafa",
                "Yalwa",
                "Yanga",
                "Yelwa",
                "Yorong",
                "Zaudna",
                "Zhau",
                "Zhidu",
                "Zuno"
            ],
            "Bwari": [
                "Apugye",
                "Barago",
                "Baran Rafi",
                "Barangoni",
                "Barapa",
                "Bazango",
                "Bunko",
                "Byazhi",
                "Chikale",
                "Dankoru",
                "Dauda",
                "Donabayi",
                "Duba",
                "Dutse",
                "Gaba",
                "Galuwyi",
                "Gidan Babachi",
                "Gidan Baushe",
                "Gidan Pawa",
                "Gudupe",
                "Gutpo",
                "Igu",
                "Jigo",
                "Kaima",
                "Karaku",
                "Karawa",
                "Kasaru",
                "Katampe",
                "Kawadashi",
                "Kawu",
                "Kikumi",
                "Kimtaru",
                "Kogo",
                "Kubwa",
                "Kuchibuyi",
                "Kuduru",
                "Kurumin Daudu",
                "Kute",
                "Kwabwure",
                "Panda",
                "Panunuki",
                "Paspa",
                "Payi",
                "Piko",
                "Rugan",
                "Ruriji",
                "Sabon Gari",
                "Sagwari",
                "Shere",
                "Simape",
                "Sumpe",
                "T/Danzaria",
                "T/Manu",
                "Tokulo",
                "Tudun Wada",
                "Tunga Bijimi",
                "Tunga-Adoka",
                "Tungan Sarkin",
                "Ushafa",
                "Yaba",
                "Yajida",
                "Yaupe",
                "Yayidna",
                "Zango",
                "Zuma"
            ],
            "Gwagwalada": [
                "Agota",
                "Akwayi",
                "Akyakyata",
                "Alu",
                "Anguwar Hausawa",
                "Anguwar Sarki",
                "Atopi",
                "Auguwar-Madaki",
                "Bargada",
                "Basan Zuba",
                "Bassa",
                "Biyu",
                "Boka",
                "Chaboda",
                "Chitumu",
                "Chzako",
                "Dabagayi",
                "Dada",
                "Dadabiri",
                "Damin Kara",
                "Dawaki",
                "Didan Tujura",
                "Diko",
                "Dikwa",
                "Dobi",
                "Doni",
                "Doruwa",
                "Eabodo",
                "Garin Godoso",
                "Gbadolo",
                "Gerin Angulu",
                "Gidan Ango",
                "Gidan Bala",
                "Gidan Dandu",
                "Gidan Gade",
                "Gidan Golo",
                "Gidan Yaro",
                "Goi",
                "Gongo",
                "Gulupe",
                "Gurebare",
                "Gurfa",
                "Gwako",
                "Gwale",
                "Gwari",
                "Gwaywalada",
                "Gyabiri",
                "Hanagada",
                "Ibbo",
                "Ibwa",
                "Ikwa",
                "Isom",
                "Jalita",
                "Jigodo",
                "Jiwape",
                "Kaburufi",
                "Kace",
                "Kaida",
                "Kalangu",
                "Kasanki",
                "Kpatawuro",
                "Kutabwche",
                "Kutunku",
                "Kuturpe",
                "Kwalikuzi",
                "Lafiya",
                "Ledi",
                "Madaki",
                "Maikaraya",
                "Maje",
                "Makama",
                "Momo",
                "Pabeyi",
                "Pagada",
                "Pagena",
                "Paiken Korce",
                "Paiko",
                "Pajana",
                "Pako",
                "Paso",
                "Patte",
                "Rafin Zurfi",
                "Sabo",
                "Saboda",
                "Sabon Gari",
                "Shaga",
                "Shajantara",
                "Shanagu",
                "Shara",
                "Shibo",
                "Shida",
                "Shinge",
                "Soko",
                "Tsagban Siji",
                "Tsaunia Kura",
                "Tsudna",
                "Tundun Wada",
                "Tung",
                "Tunga",
                "Tungan",
                "Ung",
                "Wagu",
                "Wuma",
                "Wumi",
                "Wurumbi",
                "Wuye-Wuye",
                "Yaluan",
                "Yemipe",
                "Zuba"
            ],
            "Kuje": [
                "Achmbi",
                "Adegbe",
                "Aduga",
                "Affa",
                "Agwai",
                "Ahinza",
                "Atsauna",
                "Attako",
                "Baban",
                "Bamishi",
                "Banayi",
                "Barayi",
                "Barayi Pada",
                "Bida",
                "Buga",
                "Bugako",
                "Buzunkure",
                "Chegasu",
                "Chibiri",
                "Chida",
                "Chukuku",
                "Dafara",
                "Damakusa",
                "Damangata",
                "Damwa",
                "Darika",
                "Dibe Pada",
                "Dibepe",
                "Dnago",
                "Dubia",
                "Dudagwari",
                "Dude",
                "Duma",
                "Duriya",
                "Fafere",
                "Gabiya",
                "Gadoro",
                "Gafere",
                "Ganagu",
                "Ganaju",
                "Gando",
                "Gashe",
                "Gaube",
                "Gawu",
                "Gbebasa",
                "Genge",
                "Gidan",
                "Gidigwai",
                "Ginagu",
                "Gonge",
                "Gombe",
                "Gova",
                "Gudun",
                "Gumayi",
                "Gunagu",
                "Gunfufu",
                "Gwadaji",
                "Gwape",
                "Gwari",
                "Gwau",
                "Gwagwada",
                "Gyana",
                "Gyawu",
                "Huni",
                "Iye",
                "Jaida",
                "Jeli",
                "Jigwa",
                "Jigwa Isoho",
                "Jigwa Sabo",
                "Kabikasa",
                "Kahodahanmu",
                "Kamo",
                "Kanzo",
                "Kapa",
                "Kasada",
                "Kashemolo",
                "Kiyi",
                "Kiyi Basa",
                "Kiyi Ganara",
                "Kiyizhi",
                "Ksayarda",
                "Kuja",
                "Kujekwa",
                "Kule",
                "Kusaki",
                "Kutada",
                "Kutunibo",
                "Kutunbwa",
                "Kutuop",
                "Kwaku",
                "Lafiya",
                "Lamiga",
                "Lanto",
                "Madatta",
                "Mabamade",
                "Maugi",
                "Mogada",
                "Munu",
                "Nufawa",
                "Odun",
                "Padahi",
                "Paggi",
                "Pami",
                "Pasali",
                "Peki",
                "Perri",
                "Pima",
                "Rubatu",
                "Rubbochi",
                "Rubokya",
                "Rugese",
                "Sabe",
                "Sabon",
                "Sauka",
                "Shaji",
                "Sketuko",
                "Sungba",
                "Takwa",
                "Tuage",
                "Tude",
                "Tukpeki",
                "Tukuba",
                "Tunbwa",
                "Tika",
                "Tuturutu",
                "Ukya",
                "Ungwar",
                "Ure",
                "Wumi",
                "Yaba",
                "Yalwa",
                "Yamma",
                "Yanga",
                "Yewusa",
                "Zagabutu",
                "Zangon",
                "Zilu",
                "Zoge",
                "Zokutu"
            ],
            "Kwali": [
                "Adadu",
                "Ahuwye",
                "Akapo",
                "Angun",
                "Anini",
                "Ashara",
                "Atopi",
                "Auguwar-Madaki",
                "Azarachi",
                "Baban",
                "Bako",
                "Bamishi",
                "Banayi",
                "Barayi",
                "Barayi Pada",
                "Bida",
                "Buga",
                "Bugako",
                "Buzunkure",
                "Chegasu",
                "Chibiri",
                "Chida",
                "Chukuku",
                "Dafara",
                "Damakusa",
                "Damangata",
                "Damwa",
                "Darika",
                "Dibe Pada",
                "Dibepe",
                "Dnago",
                "Dubia",
                "Dudagwari",
                "Dude",
                "Duma",
                "Duriya",
                "Fafere",
                "Gabiya",
                "Gadoro",
                "Gafere",
                "Ganagu",
                "Ganaju",
                "Gando",
                "Gashe",
                "Gaube",
                "Gawu",
                "Gbebasa",
                "Genge",
                "Gidan",
                "Gidigwai",
                "Ginagu",
                "Gonge",
                "Gombe",
                "Gova",
                "Gudun",
                "Gumayi",
                "Gunagu",
                "Gunfufu",
                "Gwadaji",
                "Gwape",
                "Gwari",
                "Gwau",
                "Gwagwada",
                "Gyana",
                "Gyawu",
                "Huni",
                "Iye",
                "Jaida",
                "Jeli",
                "Jigwa",
                "Jigwa Isoho",
                "Jigwa Sabo",
                "Kabikasa",
                "Kahodahanmu",
                "Kamo",
                "Kanzo",
                "Kapa",
                "Kasada",
                "Kashemolo",
                "Kiyi",
                "Kiyi Basa",
                "Kiyi Ganara",
                "Kiyizhi",
                "Ksayarda",
                "Kuja",
                "Kujekwa",
                "Kule",
                "Kusaki",
                "Kutada",
                "Kutunibo",
                "Kutunbwa",
                "Kutuop",
                "Kwaku",
                "Lafiya",
                "Lamiga",
                "Lanto",
                "Madatta",
                "Mabamade",
                "Maugi",
                "Mogada",
                "Munu",
                "Nufawa",
                "Odun",
                "Padahi",
                "Paggi",
                "Pami",
                "Pasali",
                "Peki",
                "Perri",
                "Pima",
                "Rubatu",
                "Rubbochi",
                "Rubokya",
                "Rugese",
                "Sabe",
                "Sabon",
                "Sauka",
                "Shaji",
                "Sketuko",
                "Sungba",
                "Takwa",
                "Tuage",
                "Tude",
                "Tukpeki",
                "Tukuba",
                "Tunbwa",
                "Tika",
                "Tuturutu",
                "Ukya",
                "Ungwar",
                "Ure",
                "Wumi",
                "Yaba",
                "Yalwa",
                "Yamma",
                "Yanga",
                "Yewusa",
                "Zagabutu",
                "Zangon",
                "Zilu",
                "Zoge",
                "Zokutu"
            ]
        }
    },
    {
        "Akwa Ibom": {
            "Abak": [
                "Abak",
                "Abak Ikot",
                "Abak Itenge",
                "Abak Usung Atai",
                "Abak Usung Idim",
                "Abak Village",
                "Abasi",
                "Afaha Esang",
                "Afaha Obong",
                "Ata Ediene",
                "Atai Otoro",
                "Atan Midim",
                "Ebebit",
                "Edem Anwa",
                "Ediene",
                "Ekpat Iduot",
                "Eriam",
                "Ibagwa",
                "Ibanag Ediene",
                "Ibiakpan",
                "Ibong Ikot Abasi",
                "Ibong Otoro",
                "Ikot Akpa Edem",
                "Ikot Akpabio",
                "Ikot Akpan Adia Ukpom",
                "Ikot Akpan Idim",
                "Ikot Akpan Ikpong",
                "Ikot Akwa Ebom",
                "Ikot Anyankana",
                "Ikot Ata Udo",
                "Ikot Ebak",
                "Ikot Ebok",
                "Ikot Edede",
                "Ikot Edong",
                "Ikot Ekang",
                "Ikot Ekiduk",
                "Ikot Ekon",
                "Ikot Eshiet",
                "Ikot Essien Etok",
                "Ikot Etok Udo",
                "Ikot Ibit Ekpe",
                "Ikot Ifang",
                "Ikot Ikpe",
                "Ikot Imo",
                "Ikot Inyang",
                "Ikot Inyang Ediene",
                "Ikot Iyire Ukpom",
                "Ikot Ndue",
                "Ikot Ntuk",
                "Ikot Obio Ikpa",
                "Ikot Obong",
                "Ikot Obong Ediene",
                "Ikot Obong Utu",
                "Ikot Obioko",
                "Ikot Odon",
                "Ikot Osom",
                "Ikot Ubo",
                "Ikot Uden",
                "Ikot Udo Obio Iwok",
                "Ikot Udo Urom",
                "Ikot Udo Usung-Ukpom",
                "Ikot-Akpakpan",
                "Ikwek",
                "Itung",
                "Manta Edem Idim",
                "Manta Village",
                "Mbarakom",
                "Midim Abak",
                "Nkor Otoro",
                "Nna-Enin",
                "Nto Obo",
                "Nto Otong",
                "Nto Utom Ukpom",
                "Obio Obom",
                "Okon Abak",
                "Oku Abak",
                "Onik Obong",
                "Onuk Ukpom",
                "Ukana Mkpa Eyop",
                "Ukukwak",
                "Urnu Obong",
                "Uruk Uso",
                "Utu Edem Akai",
                "Utu Edem Uruam",
                "Utu Midim"
            ],
            "Eastern Obolo": [
                "Akpabom",
                "Ama Ngbauji",
                "Ama Ngulasi",
                "Amadaka",
                "Atabrikang",
                "Ayama",
                "Bethlehem",
                "Elekpon",
                "Elile",
                "Emeremen",
                "Emeroke",
                "Egweenwe",
                "Iko",
                "Ikonta",
                "Iworfe",
                "Kampa",
                "Obianga",
                "Okoro Inyong",
                "Okorobilom",
                "Okoroete",
                "Okoroiti",
                "Okoromboko",
                "Okoromobolo",
                "Okwan Obolo",
                "Otunene",
                "Ozugbo",
                "Umauka"
            ],
            "Eket": [
                "Afaha Atai",
                "Afaha Ukwa",
                "Afia Nsit",
                "Anana",
                "Asang",
                "Ata Idung",
                "Atabong",
                "Atai Ndon",
                "Ebana",
                "Ebebi",
                "Ede Urua",
                "Edebuk",
                "Effoi",
                "Ekepene",
                "Ekong",
                "Ekpene",
                "Esit Urua",
                "Etibe",
                "Etebi",
                "Idim Afia",
                "Idung Enen",
                "Idung Imo",
                "Idung Offiong",
                "Idung Udofa",
                "Ikot Abasi",
                "Ikot Abia",
                "Ikot Afaha",
                "Ikot Akpa",
                "Ikot Akpandem",
                "Ikot Ataku",
                "Ikot Ebiyan",
                "Ikot Eket",
                "Ikot Ibiok",
                "Ikot Ikpa",
                "Ikot Inyang",
                "Ikot Nsidibe",
                "Ikot Obio",
                "Ikot Odiong",
                "Ikot Udoma",
                "Ikot Udota",
                "Ikot Use",
                "Iko Ekwa",
                "Idua",
                "Mkpok",
                "Nditia",
                "Nduo Eduo",
                "Odio",
                "Odoro",
                "Ofriyo",
                "Okopedi",
                "Osiok",
                "Usung Inyang"
            ],
            "Esit Eket": [
                "Aba Ekpe",
                "Afaha Ekpene",
                "Akpa Utong",
                "Edi",
                "Edida Edoir",
                "Edor Atai",
                "Eebi Akwata",
                "Eket Offing Clan",
                "Eke Afaha Clan",
                "Ekpene Obo",
                "Etebi Idung-Asan",
                "Ikpa",
                "Mbak Uyo",
                "Ntak Inyang",
                "Odor Nkit",
                "Oniok Edor",
                "Uquo",
                "Urua Okok",
                "Uwuo Iso Edoho"
            ],
            "Essien Udim": [
                "Adiasim",
                "Adiasim Ambat",
                "Adiasim Ikot Ekon",
                "Adiasim Ikot Essiendot",
                "Adiasim Ikot Udo",
                "Adiosim Atai",
                "Afaha Clan",
                "Akpa Ufong",
                "Atan Ikot-Okoro",
                "Ata Essien-Mkpatak",
                "Ebe Ikpe",
                "Ekoi Ikpe",
                "Ekpen Yongatai Clan",
                "Ekpenyong Atai",
                "Ekpeyong Ufum",
                "Esen Owo",
                "Iboho",
                "Iduog Esimuk",
                "Ikot Abiat",
                "Ikot Afanga",
                "Ikot Akpabio",
                "Ikot Akpan",
                "Ikot Akpan Eka",
                "Ikot Akpan Esang",
                "Ikot Akpan Essien",
                "Ikot Akpan Ifia",
                "Ikot Akpan Inyang",
                "Ikot Akpan Ntiia",
                "Ikot Akpan Essiet",
                "Ikot Ambut",
                "Ikot Ama",
                "Ikot Andem",
                "Ikot Ankan",
                "Ikot Asang",
                "Ikot Ata Enim",
                "Ikot Ayara",
                "Ikot Eda",
                "Ikot Ebak",
                "Ikot Ebiyan",
                "Ikot Ebok",
                "Ikot Ekon",
                "Ikot Ekpe",
                "Ikot Ekpenyong",
                "Ikot Eseh",
                "Ikot Esidomo",
                "Ikot Eso",
                "Ikot Essien",
                "Ikot Eta",
                "Ikot Etok",
                "Ikot Idem",
                "Ikot Idem-Udo",
                "Ikot Igwe",
                "Ikot Ineme",
                "Ikot Inyang",
                "Ikot Inyang Udoh",
                "Ikot Iyire Ukpom",
                "Ikot Ndem",
                "Ikot Nkwa",
                "Ikot Nsidibe",
                "Ikot Obio",
                "Ikot Obio Odok",
                "Ikot Obong",
                "Ikot Obong Edong",
                "Ikot Obiokon",
                "Ikot Ocho",
                "Ikot Oko",
                "Ikot Okuo Onuk",
                "Ikot Osom",
                "Ikot Otu",
                "Ikot Out",
                "Ikot Uba",
                "Ikot Ubo",
                "Ikot Ude-Idim",
                "Ikot Udo",
                "Ikot Udo Ekpat",
                "Ikot Udo Etim",
                "Ikot Udo-Inam",
                "Ikot Udo Okure",
                "Ikot Udom",
                "Ikot Udom Obet",
                "Ikot Ukot Etor",
                "Ikot Ukpong Eto",
                "Ikot Ukpong-Offiong",
                "Ikpe Annang",
                "Ikpe Ekpene Oton",
                "Ikpe Ikot Akpan",
                "Ikpe Ikot Ntuen",
                "Ikpe Nung Inyang",
                "Inyand",
                "Midim Atan",
                "Mbiabet Ikpe",
                "Mbiabong Ikpe",
                "Ntak Ekpenyang",
                "Ntak Ikot Akpan",
                "Nto Akpan Oko",
                "Nto Ikpo",
                "Nto Nsok",
                "Nto Obio Akpan",
                "Nto Osung",
                "Nto Udo",
                "Nyi Okon",
                "Odoro Ikot",
                "Okon Clan",
                "Oniong Ono",
                "Onuk",
                "Onuk Ikot-Abia",
                "Ukana East",
                "Ukana Ikot Ide",
                "Ukana Ikot Ntuen",
                "Ukana Mbak Ukot",
                "Ukana Nsasak",
                "Ukana West Clan",
                "Ufuku Ikot Ama",
                "Umon Okon",
                "Uruk Obong",
                "Utu Ekpenyang",
                "Uwak Eat",
                "Uwa West"
            ],
            "Etim Ekpo": [
                "Abak Obong",
                "Abat Town",
                "Adiasim",
                "Afaha Clan",
                "Atan",
                "Atuai",
                "Ekwet Ikot Ebo",
                "Etek Utu Ikot Eboro",
                "Ete Edet",
                "Esa Obong",
                "Etim Ekpo",
                "Ibio Edem Urua",
                "Ibio Nung Achat",
                "Ibio Nung Iba",
                "Ikono",
                "Ikot Akasor",
                "Ikot Akpa Nsek",
                "Ikot Akpakpan",
                "Ikot Akpan",
                "Ikot Akpan Odomo",
                "Ikot Ama",
                "Ikot Awak",
                "Ikot Edek",
                "Ikot Ikpa",
                "Ikot Inyang",
                "Ikot Inyang Ekpo",
                "Ikot Mboho",
                "Ikot Mkporikpo",
                "Ikot Nkim",
                "Ikot Obio Ama",
                "Ikot Obio Nta",
                "Ikot Odong",
                "Ikot Udo Etor",
                "Ikot Udo Nta",
                "Ikot Udo Obong",
                "Ikot Umo Ebat",
                "Ikpe Atai",
                "Ikpe-Ikot-Akwa",
                "Inen Ikot Okpo",
                "Ndot Obong",
                "Ntak Inyang",
                "Nto Edet",
                "Nto Obo",
                "Nto Unang",
                "Nung Oko Ikot",
                "Nwot Ikono",
                "Obong",
                "Obong Ata Essien",
                "Obong Ikot Akpan",
                "Obong Ntak",
                "Obong Utit Idim",
                "Omum Unyam",
                "Otoro Obong",
                "Uruk",
                "Uruk Ata Ikot",
                "Uruk Ata Ikot Akpan",
                "Uruk Ata Ikot Ebo",
                "Uruk Ata Ikot Ekpor",
                "Uruk Ata Ikot Isemin",
                "Uruk Ata Ikot Otok",
                "Uruk Ata Ikot Udedia",
                "Uruk Ata Ikot-Akpankpan",
                "Uruk Ata Nsidung",
                "Uruk Eshiet",
                "Utu Etim",
                "Utu Etim Ekpo",
                "Utu Idung Akpan Udom",
                "Utu Ikot Ekpo",
                "Utu Ikot Imonte",
                "Utu Ikot Nkor",
                "Utu Nsekhe",
                "Udianga Enem"
            ],
            "Etinan": [
                "Afaha Akpan Ekpo",
                "Afaha Efiat",
                "Afaha Iman",
                "Afaha Urua Essien",
                "Akapasak Efa",
                "Anyam Efa",
                "Ata Efa",
                "Awa Ntong",
                "Efa Mbioto Mbiete",
                "Effiat Mbioto",
                "Ekom",
                "Eso-Efa",
                "Etinan",
                "Iwo Etor",
                "Ikot Abasi",
                "Ikot Akata",
                "Ikot Akpa Esa",
                "Ikot Akpan Ese",
                "Ikot Akpan Ntembom",
                "Ikot Akpan Obio Eket",
                "Ikot Akpabio",
                "Ikot Akpanya",
                "Ikot Ananga",
                "Ikot Eba",
                "Ikot Ebiyak",
                "Ikot Ebo",
                "Ikot Ekang",
                "Ikot Ekot",
                "Ikot Esen Oku",
                "Ikot Esua",
                "Ikot Etakpo",
                "Ikot Etor",
                "Ikot Ibok",
                "Ikot Ikpuho",
                "Ikot Inyang",
                "Ikot Inyang Osom",
                "Ikot Itina",
                "Ikot Mfon",
                "Ikot Nkang",
                "Ikot Nsung",
                "Ikot Nseyen",
                "Ikot Nte",
                "Ikot Obio Eka",
                "Ikot Obio Iko",
                "Ikot Obio Inyang",
                "Ikot Obong Ikot Inyang",
                "Ikot Udo Abia",
                "Ikot Udo Adia",
                "Ikot Udo Oto",
                "Ikot Udo Etor",
                "Ikot Ukpong",
                "Ikot Umiang Ede",
                "Ikot-Akpakpan",
                "Ishiet Erong",
                "Mbiete No.1",
                "Ndon Eyo I",
                "Ndon Eyo II",
                "Ndon Utim",
                "Nkana",
                "Norther Iman",
                "Oniong",
                "Oto Akpan",
                "Southern Iman",
                "Utu Etim"
            ],
            "Ibeno": [
                "Akata",
                "Atabrikang",
                "Atai",
                "Idung Abasi Okure",
                "Ikot Inwang",
                "Inua Eyet Ikot",
                "Itak Abasi",
                "Itak Idim Ekpe",
                "Itak Idim Ukpa",
                "Itak Ifa",
                "Itio Esek",
                "Iwuo Okpom",
                "Iwuo Okpom Opolom",
                "Iwuoachang",
                "Mkpanak",
                "Ndito Eka Iba",
                "Ntafre",
                "Okom Ita",
                "Okoroutip",
                "Okposo I",
                "Okposo II",
                "Opolom",
                "Upenekang",
                "Usuk Ikim Ekene",
                "Usuk Ikim Ukwaha"
            ],
            "Ibesikpo Asutan": [
                "Aba Ukpo",
                "Afaha Atai",
                "Afaha Etok",
                "Afaha Ikot Osom",
                "Afaha Ikot Owop",
                "Afaha Ikot-Obio Nkan",
                "Afaha Udo Eyop",
                "Akpa Utong",
                "Anyam Efa",
                "Ata Efa",
                "Atai",
                "Atabrikang",
                "Awa Ntong",
                "Ebere Out",
                "Edem Ibiok",
                "Ediam",
                "Efa Mbioto Mbiete",
                "Effiat Mbioto",
                "Ekom",
                "Eso-Efa",
                "Etinan",
                "Ibe Sikpo",
                "Idung Abasi Okure",
                "Ikot Abasi",
                "Ikot Abasi Ebin",
                "Ikot Abasi Idem",
                "Ikot Akpa",
                "Ikot Akpa Edu",
                "Ikot Akpa Erong",
                "Ikot Akpa Eyoho",
                "Ikot Akpa-Ndua",
                "Ikot Akpabin",
                "Ikot Akpan Abia",
                "Ikot Akpan Etok",
                "Ikot Akpan Ntembom",
                "Ikot Akpan Obio Eket",
                "Ikot Akpabio",
                "Ikot Akpanya",
                "Ikot Ambon",
                "Ikot Ananga",
                "Ikot Eba",
                "Ikot Ebiyak",
                "Ikot Ebo",
                "Ikot Edaha",
                "Ikot Ediom",
                "Ikot Edung",
                "Ikot Ekang",
                "Ikot Ekot",
                "Ikot Enua",
                "Ikot Esen Oku",
                "Ikot Esua",
                "Ikot Eto",
                "Ikot Etakpo",
                "Ikot Etor",
                "Ikot Iko",
                "Ikot Ikere",
                "Ikot Inwang",
                "Ikot Inyang",
                "Ikot Itina",
                "Ikot Itok",
                "Ikot Mbang",
                "Ikot Mbride",
                "Ikot Mfon",
                "Ikot Nkim",
                "Ikot Nko",
                "Ikot Nkwo",
                "Ikot Nsung",
                "Ikot Nseyen",
                "Ikot Nte",
                "Ikot Obio Edim",
                "Ikot Obio Eka",
                "Ikot Obio Iko",
                "Ikot Obio Inyang",
                "Ikot Obio Nko",
                "Ikot Obio Odongo",
                "Ikot Obio Offong",
                "Ikot Obong Ediene",
                "Ikot Obong Ikot Inyang",
                "Ikot Oduot",
                "Ikot Okubo",
                "Ikot Okure",
                "Ikot Osom",
                "Ikot Udo",
                "Ikot Udo Abia",
                "Ikot Udo Adia",
                "Ikot Udo Ekpo",
                "Ikot Udo Eyoho",
                "Ikot Udo Etor",
                "Ikot Udo-Inam",
                "Ikot Udo-Nkan",
                "Ikot Ukop",
                "Ikot Ukpong",
                "Ikot Umiang Ede",
                "Ikot-Akpakpan",
                "Inua Eyet Ikot",
                "Ishiet Erong",
                "Itak Abasi",
                "Itak Idim Ekpe",
                "Itak Idim Ukpa",
                "Itak Ifa",
                "Itio Esek",
                "Itokko",
                "Iwuo Okpom",
                "Iwuo Okpom Opolom",
                "Iwuoachang",
                "Mbak Ekpe",
                "Mbierebe Akpawat",
                "Mbierebe Obio",
                "Mbikpong Atai",
                "Mbikpong Ikot Edim",
                "Mkpanak",
                "Ndikpo Atang",
                "Ndito Eka Iba",
                "Ndon Eyo I",
                "Ndon Eyo II",
                "Ndon Utim",
                "Nkana",
                "Norther Iman",
                "Ntafre",
                "Ntuk Otong",
                "Ntuk Otong Ibiaku",
                "Nung Ette",
                "Nung Oku",
                "Nung Udoe",
                "Nung Ukana",
                "Nung Ukana Ikot Efre",
                "Obio Aduang",
                "Obio Akpan",
                "Okom Ita",
                "Okoroutip",
                "Okposo I",
                "Okposo II",
                "Oku Ibesikpo",
                "Oniong",
                "Onuk",
                "Opolom",
                "Osiok",
                "Oto Akpan",
                "Southern Iman",
                "Upenekang",
                "Usuk Ikim Ekene",
                "Usuk Ikim Ukwaha",
                "Utu Etim"
            ],
            "Ibiono Ibom": [
                "Abat",
                "AbatUse",
                "Aburu",
                "Aka",
                "AkaIkotAbasi",
                "AkaIkotUdoEno",
                "AkaniObio",
                "Akpa",
                "AkpanIkotUdu",
                "AkpanUsoOno",
                "Akpan-Atai",
                "Akpan-OkponOno",
                "Amba",
                "Ambit",
                "Andem",
                "Andia",
                "AndiaIdidep",
                "Anang",
                "Ankit",
                "Antia",
                "AntiaIdidep",
                "Antia-Idoro",
                "Asating",
                "Atai",
                "Atan",
                "AtanNsai",
                "Aya",
                "AwatNkang",
                "Edem",
                "EdemIdim",
                "EkioIdoro",
                "Ekput",
                "Enyin-Idoro",
                "Essen",
                "EssienIdidep",
                "Essiet",
                "EtoIdoro",
                "Ekwere",
                "Ekwong",
                "Ekpene",
                "Ekpenyong",
                "EkpeneIdidep",
                "Ekpo",
                "Eyo",
                "Ikot",
                "IkotAdaha",
                "IkotAkpa",
                "IkotAkpaIdidep",
                "IkotAkpaNyaI",
                "IkotAkpan",
                "IkotAkpanAbasi",
                "IkotAkpan-Atai",
                "IkotAkpanObong",
                "IkotAkpanUsoOno",
                "IkotAkpan-OkponOno",
                "IkotAmbang",
                "IkotAmba",
                "IkotAndem",
                "IkotAntia",
                "IkotAntiaIdidep",
                "IkotAntia-Idoro",
                "IkotAnkit",
                "IkotAnang",
                "IkotAtim",
                "IkotEdoIdidep",
                "IkotEdok",
                "IkotEkot",
                "IkotEkpot",
                "IkotEkpe",
                "IkotEkwo",
                "IkotEnyin",
                "IkotEto",
                "IkotEtoIdoro",
                "IkotEssiet",
                "IkotEssienIdidep",
                "IkotEfim",
                "IkotEdung",
                "IkotEkwong",
                "IkotEkpenyong",
                "IkotEko",
                "IkotEkpene",
                "IkotEdoro",
                "IkotEkwa",
                "IkotEfio",
                "IkotIdaha",
                "IkotIdoro",
                "IkotIdeOno",
                "IkotInyang",
                "IkotInyangEkpene",
                "IkotInyangIdidep",
                "IkotInyangIdoro",
                "IkotInyangEkwong",
                "IkotMkpebe",
                "IkotNkoIdidep",
                "IkotNyaOno",
                "IkotNyo",
                "IkotNkan",
                "IkotNkpo",
                "IkotObio",
                "IkotObioEyen",
                "IkotObioEdep",
                "IkotObio-Okon",
                "IkotObioAkpan",
                "IkotObioAsa",
                "IkotObo",
                "IkotOboIdoro",
                "IkotObom",
                "IkotObomIdere",
                "IkotOdiong",
                "IkotOdiongUse",
                "IkotOkpoho",
                "IkotOnwen",
                "IkotOnwongIdidep",
                "IkotOpom",
                "IkotOsukpong",
                "IkotObong",
                "IkotOkpot",
                "IkotObio-Idoro",
                "IkotUkana",
                "IkotUkanaNtan",
                "IkotUkpong",
                "IkotUdo",
                "IkotUdoIbiono",
                "IkotUdoEffum",
                "IkotUdoObuk",
                "IkotUdom",
                "IkotUdomIbiono",
                "IkotUkobo",
                "IkotUbo",
                "IkotUboMbiabong",
                "IkotUboOno",
                "IkotUkporo",
                "IkotUwa",
                "IkotUtiatOno",
                "Ikpa",
                "IkpaIkotEnuen",
                "IkpaIkotUbo",
                "Ikpidop",
                "Idere",
                "IdidepUsuk",
                "Idoro",
                "IdoroNtanMbat",
                "Ibiaku",
                "IbiakuIkotUdom",
                "Ibiatuk",
                "Ibiono",
                "IbionoCentral",
                "IbionoI",
                "IbionoII",
                "IbionoIII",
                "IkotAba",
                "IkotEbom",
                "IkotInyangEno",
                "IkotNkp",
                "IkotUsen",
                "Ikot-Idoro",
                "Mbiabam",
                "MbiabamIbiono",
                "Mbiakpan",
                "MbiakpanAtan",
                "MbiakpanIdidep",
                "MbiabongEkoi",
                "Nditung",
                "Nkwa",
                "NkwaIbiono",
                "NdoNdem",
                "NkwaIkotEkwong",
                "NsaiUse",
                "Obot",
                "ObotAfia",
                "ObotAfiaIdoro",
                "ObotOko",
                "ObotUdu",
                "ObotUkana",
                "ObotUkim",
                "ObotUkimNtanMbat",
                "Okobo",
                "OkoboAka",
                "Okpot-Idoro",
                "Okporo-Idoro",
                "Onwong",
                "OnwongIdidep",
                "OsukNtan",
                "OkuObom",
                "Udioho",
                "Udo",
                "Use",
                "UseIkot-Amama",
                "UseIkotEkop",
                "UseIkotOdiong",
                "UseIkot-Udo",
                "UruaAbasiUmoh",
                "Utong-Idoro",
                "Utong",
                "UtongIdoro"
            ],
            "Ika": [
                "Abiakana",
                "Achan",
                "Afen Ibom",
                "Afen Ikot Okoro",
                "Afen Ikot Udonya/Udonja",
                "Edem Akai",
                "Ikot Abai Udo",
                "Ikot Abara",
                "Ikot Akata",
                "Ikot Akpa Idiong",
                "Ikot Akpa-Offiong",
                "Ikot Akpan Anwa",
                "Ikot Akpan Ifang",
                "Ikot Akpan Offiong",
                "Ikot Akpan Okure",
                "Ikot Antia",
                "Ikot Ebenwong",
                "Ikot Ebo",
                "Ikot Edem Inyang",
                "Ikot Edim",
                "Ikot Ekong",
                "Ikot Eseden",
                "Ikot Esien Eshiet",
                "Ikot Esu",
                "Ikot Idiong Etor",
                "Ikot Idomo",
                "Ikot Inwang",
                "Ikot Inyang Ese",
                "Ikot Inyang Odoro",
                "Ikot Inyang Udo",
                "Ikot Inyanga Ika",
                "Ikot Nya",
                "Ikot Okoro-Ata",
                "Ikot Onono",
                "Ikot Osom",
                "Ikot Osukpong",
                "Ikot Otong",
                "Ikot Otuko",
                "Ikot Oyo",
                "Ikot Udo",
                "Ikot Ukang",
                "Ikot Uko",
                "Ikot Urom",
                "Imaman",
                "Ika",
                "Ika Annang",
                "Ikpe Annang",
                "Ito Clan",
                "Ito Ika",
                "Itak Ikot Onono",
                "Itung Achan",
                "Iwukem",
                "Nto Akan",
                "Nto Akpan Etim",
                "Nto Mbadum",
                "Nto Mfang",
                "Nto Ntia",
                "Nto Udo Igwe",
                "Nto Udoete",
                "Nto Udofa 1",
                "Nto Udofa 11",
                "Nto Ukara",
                "Nto Ukong",
                "Nto Urua Itak",
                "Nto Urua Odoro",
                "Nto Usoh",
                "Nto Ukpong-Otong",
                "Odoro Ikot Esedem",
                "Otomo",
                "Uruk Ata II",
                "Urua Inyang-(Nisdung)"
            ],
            "Ikono": [
                "Abak Ikot Akpan-Oduot",
                "Afaha Ediene",
                "Afaha Itak",
                "Afaha Obio-Enwang",
                "Aka Ekpene-Ikot",
                "Ayan",
                "Edem",
                "Edem Edet",
                "Edem Iyere",
                "Ediene",
                "Ediene Atai",
                "Eduo",
                "Ekang",
                "Ekpemiong",
                "Ekpene",
                "Ekpene Ediene",
                "Ekpene Obom",
                "Esien",
                "Esem-Udo",
                "Etip Ediene",
                "Ibakesi Ukpom Unya",
                "Ibakesi-Ikot-Mbiet",
                "Ibiaku Ikot Edet",
                "Ibiannang",
                "Ibok Ndiya",
                "Idem",
                "Idoro Ediene",
                "Ikono",
                "Ikono South",
                "Ikot Abasi Ndiya",
                "Ikot Abia",
                "Ikot Akpa Edet Ndiya",
                "Ikot Akpa Edok",
                "Ikot Akpa Ekpuk",
                "Ikot Akpa Idem Ndiya",
                "Ikot Akpa Isiak",
                "Ikot Akpan",
                "Ikot Akpan Ndiya",
                "Ikot Akpan Odung",
                "Ikot Anyan Ndija",
                "Ikot Antem",
                "Ikot Enie",
                "Ikot Enua",
                "Ikot Etefia-Ndiya",
                "Ikot Ediene",
                "Ikot Eduek Itak",
                "Ikot Efre Itak",
                "Ikot Ekpan Odung",
                "Ikot Idomo",
                "Ikot Idaha",
                "Ikot Inyang-Itak",
                "Ikot Nkwo",
                "Ikot Nseyen",
                "Ikot Nto Ndiya",
                "Ikot Nya",
                "Ikot Obio-Ata",
                "Ikot Obio Edi",
                "Ikot Obok",
                "Ikot Offiong Ndiya",
                "Ikot Okpon",
                "Ikot Oku-Ediene",
                "Ikot Onwon Ediene",
                "Ikot Udo",
                "Ikot Udo Enang",
                "Ikot Udu Ndiya",
                "Ikot Umo",
                "Inyang",
                "Itak",
                "Itak Ikot Onono",
                "Itung Achan",
                "Iwukem",
                "Mbat Aka Ekpene",
                "Mbi akpa Ndiya",
                "Mbiabon Ikot-Ntia",
                "Mbiabong-Ukan",
                "Mfon",
                "Ndiya",
                "Nko",
                "Nkara Obio",
                "Nkwot Ikot Akpan",
                "Nkwot Ikot Apan",
                "Nnung Idio",
                "Nung Eyio",
                "Nung Imo",
                "Nung Inuen",
                "Nung Okoro",
                "Nung Udoe Itak",
                "Okpoto",
                "Osuk Ediene",
                "Otomo",
                "Udek Atai",
                "Ukap Ekpan Itak",
                "Ukpap Ikot Idang",
                "Ukpapa Itak",
                "Ukopon",
                "Ukpim Ikot-Imo",
                "Ukpim Ikot-Inyang",
                "Ukpim Ita",
                "Ukpom Atai Ession",
                "Ukpom Ekpene",
                "Ukpom Ekpene-Inuen",
                "Ukpom Ibakesi-Ikot",
                "Ukpom Ikot Akpakpam",
                "Ukpom Ikot Anwana",
                "Ukpom Ikot Anwana Abasi",
                "Ukpom Ikot Edem Udo",
                "Ukpom Ikot Ekem",
                "Ukpom Ikot Etim",
                "Ukpom Ikot Ntuen",
                "Ukpom Ikot Nya",
                "Ukpom Ikot Nyoho",
                "Ukpom Ikot Odung",
                "Ukpom Ikot Okure",
                "Ukpom Ikot Udo",
                "Ukpom Ikot Udo Nke",
                "Ukpom Nung Eduo",
                "Uruk Ata II",
                "Urua Inyang-(Nisdung)",
                "Usuk Obio Ediene",
                "Uyo Afaha Nkan",
                "Uyo Obio"
            ],
            "Ikot Abasi": [
                "Abasute",
                "Abiran",
                "AtaUdoUsung",
                "AtanEkaIko",
                "AtanIkpe",
                "Ededuo",
                "Edemaya",
                "Essene",
                "EssienEtuk",
                "Ete",
                "Iboro",
                "IkongUkpoInua",
                "Iman",
                "Inang",
                "IkpaIbekwe",
                "IkpaNungAsang",
                "Ikpetim",
                "Ikwa",
                "IkotAba",
                "IkotAbasi",
                "IkotAdaUdo",
                "IkotAkpan",
                "IkotAkpan-Ata",
                "IkotAkpaEnin/IkotEsang",
                "IkotAkpaIdiang",
                "IkotAkpanUdo",
                "IkotAboaNdia",
                "IkotAkpabo",
                "IkotAtaUdo",
                "IkotEduo",
                "IkotEfre",
                "IkotEkpe",
                "IkotEneni",
                "IkotEtefia",
                "IkotEtenge-Ete",
                "IkotEtengeNdom",
                "IkotEssien",
                "IkotEtetuk",
                "IkotEyenImo",
                "IkotIkara",
                "IkotIkwot",
                "IkotImo",
                "IkotIyire",
                "IkotNdien",
                "IkotObiok",
                "IkotObioAkpan",
                "IkotObioEkpe",
                "IkotObong",
                "IkotOboroEnyin",
                "IkotOkpok",
                "IkotOkwo",
                "IkotOsudu",
                "IkotUnya",
                "IkotUboAkama",
                "IkotUfot",
                "IkotUkpongEkere",
                "IkotUmiang-Okon",
                "IkotUsoIde",
                "IkotUsop",
                "ItakAbasi",
                "NdakEkom",
                "NdaUku",
                "Nduk",
                "ObioAkama",
                "OkpotoEte",
                "UkpomOkom",
                "UkpumEte",
                "Ukan",
                "UmenekeI",
                "UmenekeII",
                "UtaEwa",
                "UdoMbon"
            ],
            "Ikot Ekpene": [
                "Abak Ifia",
                "Abak Oko",
                "Abiakpan",
                "Abiakpan Ikot",
                "Abiakpan Ikot Irem",
                "Abiakpan Nto Akan",
                "Abiakpo Edem Idim",
                "Abiakpo Ntak-Inyang",
                "Adaratak",
                "Akanaan",
                "Amanyam",
                "Ata Essien Mbiaso",
                "Ibong Ikot Akan",
                "Ibong Nto Akan",
                "Ifuho",
                "Ikot Abia Idem",
                "Ikot Akpan-Abia",
                "Ikot Ediet",
                "Ikot Enwang",
                "Ikot Idem",
                "Ikot Inyang",
                "Ikot Obong Edong",
                "Ikot Obong Otoro",
                "Ikot Osura",
                "Ikot Out",
                "Ikot Uboh",
                "Ikot Udo Osung",
                "Ikot-Ekpene-Village",
                "Ikot Ekpene Urban",
                "Ikotobio Okpon",
                "Itak Ikot Udo-Okop",
                "Mbiaso Ikot Uso-udo",
                "Mbiaso Nto-Obio Ekong",
                "Nbo Obodom Ibiaso",
                "Ndem Ekpot",
                "Nkap Ikot Obio Ebok",
                "Nsiak",
                "Nyara Enyin-Ntong Uno",
                "Obioekere",
                "Uruk Uso",
                "Utu Edem Usung",
                "Utu Ikot Ekrenyong",
                "Utu Ikot Essien",
                "Utu Ikpe",
                "Uta Ewa"
            ],
            "Ini": [
                "Aba Itiat",
                "Afaha Ikot Akpan-Edu",
                "Akpa-Etok",
                "Akpayak Ikpe",
                "Aka Ekpene",
                "Ananammong",
                "Anwafia",
                "Anwa Urua",
                "Asanting Atan",
                "Asanting Ikot Efredie",
                "Asanting Obot Obom",
                "Asanting Utit Ikpe",
                "Asantin Nquono",
                "Atan",
                "Ebam Edek",
                "Edem Akai",
                "Edem Idim Ibakesi",
                "Edem Urua",
                "Ede Esien",
                "Eminang",
                "Esiyere",
                "Essien",
                "Etefia",
                "Etok",
                "Ibam Edet",
                "Ibam Obot Enen",
                "Ibam Ukwot",
                "Ibiaku Ata",
                "Ibiaku Ikot-Ukana",
                "Ibiaku Okpo",
                "Ibakesi",
                "Ibo",
                "Ibono Okporo",
                "Ibono Usuk",
                "Iboro",
                "Iko Atia",
                "Ikono",
                "Ikong Ukpo Inua",
                "Ikpa Ibekwe",
                "Ikpa Nung Asang",
                "Ikpe",
                "Ikpe Ikot Nkon",
                "Ikporom",
                "Ikpetim",
                "Ikweme",
                "Ikwa",
                "Ikot",
                "Ikot Aba",
                "Ikot Abasi",
                "Ikot Akpan",
                "Ikot Akpan-Ata",
                "Ikot Akpan Ntim",
                "Ikot Akpa Edu",
                "Ikot Akpa Enin/Ikot Esang",
                "Ikot Andem",
                "Ikot Aboa Ndia",
                "Ikot Abasi Inyang",
                "Ikot Awa",
                "Ikot Edem",
                "Ikot Edem Isa",
                "Ikot Ede",
                "Ikot Efre",
                "Ikot Etenge Ndom",
                "Ikot Etenge-Ete",
                "Ikot Emem",
                "Ikot Eneni",
                "Ikot Ese",
                "Ikot Essien",
                "Ikot Etetuk",
                "Ikot Eyene",
                "Ikot Iyire",
                "Ikot Ikara",
                "Ikot Imo",
                "Ikot Inyang",
                "Ikot Nta",
                "Ikot Nko",
                "Ikot Nya",
                "Ikot Ndien",
                "Ikot Obio",
                "Ikot Obio Asang",
                "Ikot Obio Akpan",
                "Ikot Obio Ekpe",
                "Ikot Oboro Enyin",
                "Ikot Obong",
                "Ikot Okpo",
                "Ikot Okpok",
                "Ikot Okwo",
                "Ikot Osom Ikpe",
                "Ikot Ubam",
                "Ikot Ubo Akama",
                "Ikot Ubeng",
                "Ikot Udo",
                "Ikot Udo Asan",
                "Ikot Udo Ata",
                "Ikot Udo Eboho",
                "Ikot Udo Ukana",
                "Ikot Udo Ibakesi",
                "Ikot Udo Uboho",
                "Ikot Udo-Uba",
                "Ikot Ufot",
                "Ikot Ukpong Ekere",
                "Ikot Unya",
                "Ikot Uno",
                "Ikot Umiang-Okon",
                "Iman",
                "Inang",
                "Itak Edem Isa",
                "Itak Ikot",
                "Itak Ikot Akpan Ndem",
                "Itak Ikot Obio",
                "Itak Ikot Udo",
                "Itak Ikot-Udo",
                "Itie Ikpe",
                "Itu Mbonuso",
                "Iton Odoro",
                "Iton Mong",
                "Mbiabon G.I",
                "Mbiabong II",
                "Mbiabong Ikot",
                "Mbiabong Etefia",
                "Mbiabong Mbat",
                "Mbiabong Oku Ikot- Abasi",
                "Mbiabong Ukan Ikot",
                "Mbiabet Ikot",
                "Mbiabet-Eyehedia",
                "Mbaiabet Ikot",
                "Mbiafun",
                "Mbiafun Eyehe Adia",
                "Mbiafun Ikot",
                "Mbiafun Mmananu",
                "Mbiafun Ubot Oko",
                "Mbiakpa Ibakesi",
                "Mbiabon Ekpip",
                "Mbiafun Nkwono",
                "Mbento",
                "Mkpe",
                "Mkpu",
                "Ndiya Mfia",
                "Ndiya Etok",
                "Ndiya Ikot Imo",
                "Ndot Ikpe",
                "Nchana Ebua",
                "Ndinya Ikot Imo",
                "Nkwot Etok",
                "Nkana Ikpe",
                "Nkari",
                "Nung Oku",
                "Nung Ukem Ikot-Udom",
                "Nung Ukem Ikot-Uko",
                "Nung Ukim",
                "Nung Ukim Ikot-Okori",
                "Nung Ukim Ikot-Ukpum",
                "Nturi",
                "Odoro Ikpe",
                "Offufa",
                "Ogu",
                "Oku Ikot Edaha",
                "Okporo",
                "Okpoto",
                "Osuk Ntan",
                "Oniong Ono",
                "Ukwok Ikot Idut",
                "Ukwok Ikot-Udo",
                "Ukpa Okon",
                "Ukpum Ete",
                "Ukan",
                "Umeneke I",
                "Umeneke II",
                "Usuk Idim",
                "Usuk Ibaken",
                "Usung Ita"
            ],
            "Mbo": [
                "AfahaOkpo",
                "AkwaObioEffiat",
                "AsiokObufa",
                "EffiatAkpaNkanua",
                "Ekiebong",
                "EsukAnwang",
                "EyoEfai",
                "EyoUkut",
                "Ibete",
                "IbuetIkot",
                "IbuotUtan",
                "IneInuaAbasi",
                "InuaAbasi",
                "JamesTown",
                "MbeNdoro",
                "ObioIyata",
                "ObongNim",
                "Uba",
                "Ubotuong",
                "Udini",
                "Udombo",
                "UdungEyoAdaeba",
                "UkoAkpan",
                "UsukEffiat",
                "UtanAntai",
                "UtanBrama",
                "UtanUdombo",
                "UtangEfiong"
            ],
            "Nsit Ibom": [
                "Afaha Ikot",
                "Afaha Ikot Ede",
                "Afaha Ikot Etang",
                "Afaha Ntup",
                "Afaha Ofiong",
                "Afia Nsit I",
                "Afia Nsit II",
                "Adia Nsit",
                "Anyam Nsit",
                "Asang",
                "Asang Clan",
                "Eastern Nsit",
                "Edebom",
                "Ekpene Ukpan",
                "Ibakang",
                "Ibedu",
                "Ibiakpan",
                "Idiaba",
                "Idifa",
                "Idikpa",
                "Idikpa Ikot Ntung",
                "Ikat Nsit",
                "Ikot Abasi",
                "Ikot Abiaenyie",
                "Ikot Abiyan",
                "Ikot Akpabio",
                "Ikot Akpan Ike",
                "Ikot Akpan Etang",
                "Ikot Asat",
                "Ikot Asua",
                "Ikot Ebita",
                "Ikot Edebe",
                "Ikot Edong",
                "Ikot Eket",
                "Ikot Ekpot",
                "Ikot Esen",
                "Ikot Esop",
                "Ikot Essien",
                "Ikot Idem",
                "Ikot Inyang",
                "Ikot Itie-Udong",
                "Ikot Mkpo",
                "Ikot Nkpene",
                "Ikot Ntan Nsit",
                "Ikot Ntuen",
                "Ikot Ntuem",
                "Ikot Obio Edim",
                "Ikot Obio Asanga",
                "Ikot Obio Etan",
                "Ikot Obong",
                "Ikot Obok",
                "Ikot Ofiok-Nsit",
                "Ikot Ofiong Nsit",
                "Ikot Oku Nsit",
                "Ikot Ubok Udom",
                "Ikot Udofia",
                "Ikot Ukpong",
                "Ikot Uyo Nsit",
                "Iwok Atai",
                "Iwok Nsit",
                "Iwok Obio Aduang",
                "Mbak Nsit I",
                "Mbiaso",
                "Mbiaso Clan",
                "Mbiakot",
                "Mbikporo II",
                "Miokporo Obio Nsit",
                "Nda Nsit",
                "Nditung Nsit",
                "Ndon Ekpe",
                "Ndon Ikot Itie-Udung",
                "Ndon Omun",
                "Nduo Eduo",
                "Ndisiak",
                "Nkwot",
                "Obiokpok",
                "Obo Atai",
                "Obo Etim",
                "Obo Etok",
                "Obo Ikot Ita",
                "Obo Ntong",
                "Odot No.1",
                "Odot No.2",
                "Odot No.3",
                "Okoro Atai",
                "Okoro Nsit",
                "Okukuk",
                "Okwo Nsit",
                "Ubetim",
                "Udofia",
                "Unyehe Nsit",
                "Ukot Nsit",
                "Ukat Nsit"
            ],
            "Nsit Ubium": [
                "Afia Nsit Atai",
                "Akai",
                "Atiam Kpat",
                "Atan",
                "Edebom",
                "Edem Idim Okpot",
                "Ekpene Ukim",
                "Ibiakpan",
                "Ibiakpan/Obotim Clan",
                "Ibiemin",
                "Ikot Abasi-Ufat",
                "Ikot Ada Okp",
                "Ikot Akan",
                "Ikot Akpa Eno",
                "Ikot Akpa Mba",
                "Ikot Akpaofuk",
                "Ikot Akpabon",
                "Ikot Akpan Ibakpan",
                "Ikot Akpan-Abia",
                "Ikot Ede",
                "Ikot Edibon",
                "Ikot Edikpe",
                "Ikot Edok",
                "Ikot Ekwere",
                "Ikot Enwana",
                "Ikot Esen",
                "Ikot Ete",
                "Ikot Etim",
                "Ikot Etobo",
                "Ikot Ewang",
                "Ikot Eyo",
                "Ikot Imo",
                "Ikot Inyang Eti",
                "Ikot Iyire",
                "Ikot Nkor",
                "Ikot Ntung",
                "Ikot Obio Ndua",
                "Ikot Obong Edong",
                "Ikot Okobo",
                "Ikot Okoro",
                "Ikot Okpodo",
                "Ikot Okpyot",
                "Ikot Osom",
                "Ikot Ubo",
                "Ikot Udo Ide",
                "Ikot Udo Ime",
                "Ikot Udo Iton",
                "Ikot Ukap",
                "Ikot Ukobo",
                "Ikot Uso",
                "Ikpatu",
                "Mbiekene",
                "Mbat Uno",
                "Ndiya Usung Inyang",
                "Ndukpo Ise",
                "Ndem Ekpot",
                "Nkap Ikot Obio Ebok",
                "Nsiak",
                "Nsit Ubium",
                "Nsit Ubium Ndiya",
                "Itreto Clan",
                "Nung Obong",
                "Obio Ekit",
                "Obio Ubium",
                "Odoro Atasung",
                "Ukat",
                "Ukat Atan",
                "Ukpom Okom",
                "Usung Inyand",
                "Ubium North",
                "Ubium South",
                "Utu Edem Usung",
                "Utu Ikot Ekrenyong",
                "Utu Ikot Essien",
                "Utu Ikpe",
                "Uta Ewa"
            ],
            "Obot Akara": [
                "Abak Ukpom",
                "Abiakpo",
                "Abiakpo Idiaha",
                "Abiakpo Ibo",
                "Abiakpo Ikot",
                "Abiakpo Ikot Abasi-Inyang",
                "Abiakpo Ikot-Obio Nting",
                "Abiakpo Ikot-Ukam",
                "Abiakpo Nkap",
                "Abama",
                "Abasi Eduo",
                "Ama Okop",
                "Atai Ikwen",
                "Atan Ibong",
                "Edem Idem Okpo Eto",
                "Esa Iken",
                "Ibong Uruk",
                "Ibongokpo-Eto",
                "Ibiakpan",
                "Ikot Abasi Eyop",
                "Ikot Abia",
                "Ikot Abia Osom",
                "Ikot Akpan-Enuek",
                "Ikot Atasung",
                "Ikot Essien",
                "Ikot Eyem",
                "Ikot Ide",
                "Ikot Idem Udo",
                "Ikot Ikok",
                "Ikot Mba",
                "Ikot Mem",
                "Ikot Moboho",
                "Ikot Ntuen",
                "Ikot Obo Nto",
                "Ikot Obuk",
                "Ikot Oku",
                "Ikot Osom",
                "Ikot Upeng",
                "Ikot Udo Nto-Ide",
                "Ikot Ukana",
                "Ikot Ukpong Ikot Udan",
                "Ikot Utu",
                "Ikot Utu Ikot Akpan",
                "Ikot-Udom Anwa",
                "Imana",
                "Inyang I",
                "Inyang II",
                "Mkpa Uno",
                "Mbat Esifon",
                "Nko Nto Okono",
                "Nkpo Nto Nkoboho",
                "Nsit Ikpe",
                "Nto Asiak",
                "Nto Edino Obot",
                "Nto Ekpe",
                "Nto Esu",
                "Nto Eton",
                "Nto Ide",
                "Nto Ide Anwa-Effiat",
                "Nto Ndung",
                "Nto Obio Ikang",
                "Nto Obio Iwok",
                "Nto Omen",
                "Ntong Uno",
                "Obon Ukwa I",
                "Obon Ukwa II",
                "Obot Akara",
                "Oku Obom",
                "Okop",
                "Okpo Eto Ikot Imo",
                "Unik Osung",
                "Usaka",
                "Uto Ekpu Ikot",
                "Utu Ikot",
                "Utu Ikpe",
                "Ikpe Mbak Eyop",
                "Ikpe Usung-Ita",
                "Ikwen Ikot Udom"
            ],
            "Okobo": [
                "Afaha Akai",
                "Afaha Nsung",
                "Afaha Osu",
                "Akanawana",
                "Akiba Obo",
                "Akai Nyo",
                "Amamong",
                "Anua Ekeya",
                "Anua Okopedi",
                "Ape Amamong",
                "Atai Amamong",
                "Atai Atai Otope",
                "Atipa Odobo",
                "Atipa Okopedi",
                "Atiabang",
                "Ebighi Anwa Ikpi",
                "Ebighi Anwa Oro",
                "Ebighi Edu",
                "Ebighi Eta",
                "Ebighi Okobo",
                "Ekpene Ekim",
                "Ekpene Ekim Eta",
                "Esuk Inwang",
                "Eta",
                "Etieke Udong Eto",
                "Eweme",
                "Eyo Nku",
                "Eyede",
                "Ibawa",
                "Idibi Enin",
                "Ikono",
                "Ikot Abia",
                "Ikot Akpan-Enuek",
                "Ikot Iquo",
                "Ikot Odiong",
                "Ikot Okokon",
                "Ikot Osukpong",
                "Isa Okiuso",
                "Itak Ekim",
                "Itak Okiuso",
                "Itak Uyati",
                "Mbieduo",
                "Mbukpo Oduobo",
                "Nda",
                "Ndoung",
                "Nsating",
                "Nsie",
                "Nung Atai Eta",
                "Nung Udom Odobo",
                "Nung Ukana",
                "Obot Inwang",
                "Obufi",
                "Odu",
                "Okobo",
                "Okiuso",
                "Osu Offi",
                "Otieke",
                "Oti Oron",
                "Oyoku Assang",
                "Ubak",
                "Ube",
                "Ufok Esuk",
                "Ukwong",
                "Uluting",
                "Urue Ita",
                "Uruting",
                "Utine Eyekung",
                "Utine Ndoung",
                "Udung Afiang",
                "Udung Amkpe",
                "Udung Ukpong",
                "Udung Ulo",
                "Udung Umo"
            ],
            "Onna": [
                "Abak Ishiet",
                "Afaha Atai",
                "Afaha Ikot Ankang",
                "Afaha Ikot Idem Udo",
                "Afaha Ubium",
                "Akpan-Nkpe",
                "Akpabom",
                "Atiamkpat Nung",
                "Awa",
                "Awa Nkp",
                "Awandon",
                "Edem Idim",
                "Eyo Essi",
                "Eyo Esu",
                "Eyo Usotai",
                "Eyo Utumong",
                "Iquita",
                "Ikot Abasi",
                "Ikot Akpan",
                "Ikot Akpatek",
                "Ikot Annang",
                "Ikot Ebekpo",
                "Ikot Ebidang",
                "Ikot Ebire",
                "Ikot Edor",
                "Ikot Ese Ishiet",
                "Ikot Ikom Ibom",
                "Ikot Ndua Iman",
                "Ikot Ndudot",
                "Ikot Nkan",
                "Ikot Nuten",
                "Ikot Obio-Eket",
                "Ikot Obong-Ishiet",
                "Ikot Udo",
                "Ikwe",
                "Ishiet",
                "Mkpok",
                "Mkpa Eto",
                "Ndom Eyo",
                "Nko",
                "Ntan Ide",
                "Nung Ndem Clan",
                "Oku Ekanem",
                "Okat",
                "Okom",
                "Oniong Clan",
                "Onna",
                "Udung Ndung",
                "Udung Uso",
                "Ukpan"
            ],
            "Oron": [
                "Akai-Ikon",
                "EsinUfot",
                "EsukOro",
                "Eyo-Abasi",
                "Eyo-Atta",
                "Eyo-EkangInyang",
                "Eyo-Esang-Obisung",
                "Eyo-Esio-Uwak",
                "Eyo-Esu",
                "Eyo-Ifang",
                "Eyo-Obiosio",
                "Eyo-Odiong",
                "Eyo-Okpo",
                "Eyo-Okpo-Oyo",
                "Eyo-Orokra-Usuyak",
                "Eyo-Otong-Uwe",
                "Eyo-Oyete",
                "Eyo-Uya",
                "Uko-Okwong",
                "Uko-Uyokim",
                "Udung-Esien",
                "Udung-Ekung",
                "Udung-EkungII",
                "Udung-Obisung",
                "Udung-Okwong",
                "Udung-Osin",
                "Udung-Uko",
                "Udung-Ulo",
                "Udung-Usotai",
                "Udung-UsotaiudungEkung",
                "Udung-Uwe",
                "Uya Oro"
            ],
            "Oruk Anam": [
                "Afaha Obo-Ikot Ito",
                "Akapa Akpa Ewe",
                "Akpang Offop",
                "Ata Essien Obio",
                "Ata Obio Akpa",
                "Aya Obio Akpa",
                "Edem Idim Ibesit",
                "Ediene Atai",
                "Ediene Ikot-Ebom",
                "Ekefe",
                "Ekparakwa",
                "Ekpene Ukpan",
                "Enuekoro",
                "Eteben",
                "Etok Inen",
                "Etok Nkwo",
                "Etobodom",
                "Ikat Nsit",
                "Ikot Abasi",
                "Ikot Abiaenyie",
                "Ikot Abiyan",
                "Ikot Akan",
                "Ikot Akama",
                "Ikot Akpabio",
                "Ikot Akpa Eda",
                "Ikot Akpa Inyang",
                "Ikot Akpa Osung",
                "Ikot Akpa Ntia",
                "Ikot Akpan",
                "Ikot Akpan Etedue",
                "Ikot Akpan Essien",
                "Ikot Akpan Mbure",
                "Ikot Akpan Ntia",
                "Ikot Akpan Otuk",
                "Ikot Akpan Udo",
                "Ikot Akpam",
                "Ikot Akpaya",
                "Ikot Akpakpan",
                "Ikot Awa",
                "Ikot Ede",
                "Ikot Eda",
                "Ikot Ediene",
                "Ikot Eduep",
                "Ikot Ekpuk",
                "Ikot Ekot",
                "Ikot Ekon",
                "Ikot Eshiet",
                "Ikot Esen",
                "Ikot Esikan",
                "Ikot Ese",
                "Ikot Eteye",
                "Ikot Etim",
                "Ikot Inuen",
                "Ikot Inyang",
                "Ikot Iba",
                "Ikot Idem",
                "Ikot Idem Udo",
                "Ikot Ibram",
                "Ikot Ikpene",
                "Ikot Mbong",
                "Ikot Ndo",
                "Ikot Ntuen",
                "Ikot Obio Asan",
                "Ikot Obio Atara",
                "Ikot Obio-Aduak",
                "Ikot Obio Enin Atai",
                "Ikot Obio Enin-Udobia",
                "Ikot Obio Nkan",
                "Ikot Obio Nsu",
                "Ikot Obio Oruk",
                "Ikot Obok",
                "Ikot Obong-Akan",
                "Ikot Offiong",
                "Ikot Okoro",
                "Ikot Omono",
                "Ikot Oto",
                "Ikot Osukpong",
                "Ikot Otu",
                "Ikot Owuk",
                "Ikot Ubok Udom",
                "Ikot Udoro",
                "Ikot Udo Aduak",
                "Ikot Udo Etok",
                "Ikot Udo Offiong",
                "Ikot Udo Idem",
                "Ikot Ukpong",
                "Ikot Ukpong Eren",
                "Ikot Ukpong Obiokpong",
                "Ikot Ukpong Etor",
                "Ikot Utiat",
                "Inen Abasi Atai",
                "Inen Atan",
                "Inen Ikot Obiom",
                "Inen Ikot-Essien",
                "Inen Nsai",
                "Itung Ekpip",
                "Itung Ikot-Ndem",
                "Kpong",
                "Manta",
                "Mbiakot",
                "Mbiaso",
                "Mbon Ebre",
                "Ndat Ibesit",
                "Nto Adua",
                "Nto Onio-Idang",
                "Nto Udo Akpan",
                "Nung Ikot",
                "Nung Ikot Asanga",
                "Nung Ikot Obiodo",
                "Nung Ikot Urua Ekpo",
                "Nung Oku Ubo I",
                "Nung Oku Ubo II",
                "Okpokoro",
                "Okukuk",
                "Obio Akpa",
                "Obio Ebiet Nkanka",
                "Obio Ibiet Esa",
                "Obio Ndot",
                "Offot",
                "Oruk Anam",
                "Uruk Enung",
                "Uruk Obong",
                "Uruk Otong",
                "Ute Ekuk",
                "Utu Ikot Iwara",
                "Utu Ikot Obio Ekpe",
                "Ukpom",
                "Ukpom Edem Iyang",
                "Usung Atiat Ubo",
                "Warife",
                "Warite"
            ],
            "Udung Uko": [
                "EdikorEyiba",
                "EdikorEyobiosio",
                "EdikorEyokpu",
                "Eniongo",
                "EyoAtai",
                "EyoAtang",
                "EyoAting-Osung",
                "EyoAtingOsung",
                "EyoEbieme",
                "EyoEsin",
                "EyoEsioOsung",
                "EyoEsioUsung",
                "EyoNsek",
                "EyoOkponung",
                "EyoUliong",
                "EyoUlung",
                "EyoUwe",
                "Eyobisung",
                "Eyofin",
                "Eyoko",
                "Eyokponung",
                "Eyokpu",
                "Eyosio-Osung",
                "Eyotai",
                "Ubodung",
                "UboroIsongInyang",
                "UdngOtok",
                "UdungAdatang",
                "UdungEsio",
                "UdungUko",
                "Usung"
            ],
            "Ukanafun": [
                "Abat",
                "AdatIfang",
                "AfahaIkotAkpaIdem",
                "AfahaIkotAkwa",
                "AfahaIkotInyang",
                "AfahaOboAtaEssien",
                "AfahaOboIkotUko",
                "AfahaOdon",
                "Akwa",
                "AtaEssien",
                "AtaEssienAfaha-Ntak",
                "Ekpe",
                "Idem",
                "IdungAkpanUko",
                "IdungEkaUyo",
                "IdungIdemUdo",
                "IdungNneke",
                "IdungUkoUdo",
                "IdungUrumIso",
                "IkotAkai",
                "IkotAkpaIdem",
                "IkotAkpaNkuk",
                "IkotAkpanAfaha",
                "IkotAkpanEbo",
                "IkotAkpanEyo",
                "IkotAkpanEyara",
                "IkotAkpanInyang",
                "IkotAntaEneng-Obum",
                "IkotAntia",
                "IkotAndem",
                "IkotAnuwo",
                "IkotArankere",
                "IkotAwak",
                "IkotDappa",
                "IkotEbok",
                "IkotEdemEwa",
                "IkotEdong",
                "IkotEdung",
                "IkotEffiong",
                "IkotEkpankpe",
                "IkotEnang",
                "IkotEssien",
                "IkotEtim",
                "IkotIbekwe",
                "IkotIkang",
                "IkotIkpe",
                "IkotInyang",
                "IkotInyangAbia",
                "IkotIwara",
                "IkotNdot",
                "IkotObioOkpoho",
                "IkotObio-Owo",
                "IkotObong",
                "IkotOdiong",
                "IkotOkuUsung",
                "IkotOto-Iwuo",
                "IkotOwure",
                "IkotUdo",
                "IkotUdoAbia",
                "IkotUdoIyak",
                "IkotUdoMbang",
                "IkotUdoMbang/AfahaObo",
                "IkotUdo-Ossiom",
                "IkotUkoAnnang",
                "IkotUkoObobo",
                "IkotUkpong",
                "IkotUram",
                "IkotUtiat",
                "IkotWkpankpe",
                "Nkek",
                "NkekAbak",
                "NkekIdim",
                "NdotIkotAkwa",
                "Nsekhe",
                "NtakAfahaIkot",
                "NtoOkonIkotEnyiekop",
                "NtoOkonIkotOkpo",
                "NtoOkonIkot-Obio",
                "NyakZba",
                "ObonOdor",
                "OdoroIkot",
                "Okoyo",
                "UkanafunIkot-Ekpat",
                "Ukanafun-Edem",
                "UsungAtiat",
                "Waterside"
            ],
            "Uruan": [
                "Akpa Utong",
                "Eman Uruan",
                "Ibiaku Uruan",
                "Ibikpe Uruan",
                "Ifiayong Obot",
                "Ikot Oku Uruan",
                "Ikot Udo Uruan",
                "Ikpa Uruan",
                "Ita Uruan",
                "Mbiaya Uruan",
                "Osong Uruan",
                "Utiti Uruan",
                "Uruan",
                "Southern Uruan",
                "Adadi",
                "Afaha Ikot",
                "Akpa Mfriukim",
                "Edik Ikpa",
                "Ekim-Enen",
                "Ekpene Ibio",
                "Ekpene Ukim",
                "Eman Ukpa",
                "Ibeno Isiet",
                "Ibiaku Ikot Ese",
                "Ibiaku Isiet",
                "Ikot Akan",
                "Ikot Akpa Ekang",
                "Isiet Ekim",
                "Isiet Inua Akpa",
                "Ituk Mbang",
                "Ndon Ebom",
                "Ndon Uruan",
                "Nung Ikono Obio",
                "Nung Ikono Ufok",
                "Nung Uruan",
                "Obio Ndobo",
                "Oku Ikot Edung",
                "Ufak Effiong",
                "Use Uruan",
                "Akani Obio Uruan",
                "Anakpa",
                "Eman Ikot-Ebo",
                "Esuk Odu",
                "Idu Uruan",
                "Ifia Yong Esuk",
                "Ifiayong Usuk/Nwaniba",
                "Ikot Inyang Esuk",
                "Ikot Otoingie",
                "Mbiakong",
                "Nna Enin",
                "Nnung Oku Uruan",
                "Nturukpum"
            ],
            "Urue-Offong/Oruko": [
                "Okpo",
                "Uboro Oron",
                "Urue-Offong/Oruko",
                "Egughu",
                "Elei",
                "Ibetong Nsie",
                "Ibighi",
                "Okuko",
                "Oyoku Ibighi",
                "Oyubia",
                "Uya Oron",
                "Okiuso",
                "Atte",
                "Umeme",
                "Ubodong",
                "Abiak Elibi",
                "Anai Okpo",
                "Edok",
                "Eyetong",
                "Eyo Eyekip",
                "Eyo Okwong",
                "Eyo Ufuo",
                "Eyo Uwesong",
                "Eyo Uya",
                "Eyobiasang",
                "Eyokpifie",
                "Eyulor",
                "Oduonim Isong Inyang",
                "Oduonim Oro",
                "Okossi",
                "Ubodung",
                "Udung Eta",
                "Udung Okpor",
                "Udung Uwe",
                "Ukuda",
                "Urue Offong",
                "Ukwong",
                "Ibetong-Eweme",
                "Ikpe",
                "Mbokpu-Eyo-Ima",
                "Mbokpu-Eyokan",
                "Mbukup-Uko-Akai"
            ],
            "Uyo": [
                "AfahaIdoro",
                "AfahaOku",
                "AkaOffot",
                "AnnuaOboo",
                "AnuaObioOffot",
                "AnuaOffot",
                "AtanOffot",
                "EffiatOffot",
                "EkpriNsukara",
                "EniongOffot",
                "EwetOffot",
                "IbaOku",
                "IbiakuOffot",
                "Iboko",
                "IfaAtai",
                "IfaIkot",
                "IfaIkotAbiaNtuen",
                "IfaIkotAkpan",
                "IfaIkotAkpanAbia",
                "IfaIkotIdang",
                "IfaIkotObong",
                "IfaIkotUbo",
                "IfaIkot-Akpabio",
                "IfaIkot-Okpon",
                "IkotAbasiNkpo",
                "IkotAkpanEdiene",
                "IkotAkpanOku",
                "IkotAnyang",
                "IkotEbo",
                "IkotEbido",
                "IkotEboro",
                "IkotEkpeOffot",
                "IkotEkpeyak",
                "IkotEnyienge",
                "IkotInyangIdung",
                "IkotMbon",
                "IkotNtuen-Oku",
                "IkotObioMkpon",
                "IkotOdung",
                "IkotOffiong",
                "IkotOku",
                "IkotOkuIdoOffot",
                "IkotOkuIkono",
                "IkotOkubo",
                "ItiamEtoi",
                "ItianIkotEbia",
                "ItonIkono",
                "MbakAkpanEkpenyong",
                "MbakIkotAbasi",
                "MbakIkotEbo",
                "MbiabongAnyanya",
                "MbiabongIkono",
                "MbiabongIkot",
                "MbiabongIkotAbasi",
                "MbiabongIkot-Antem",
                "MinyaIkono",
                "NsukaraOffot",
                "NduetongOku",
                "NungAsang",
                "NungEdongEdiene",
                "NungObioEnangIdoro",
                "NungUdoeEdiene",
                "NungUkim",
                "NungUyoIdoro",
                "ObioEtoi",
                "ObioOffot",
                "ObotObomEtoi",
                "Offot",
                "UseAtai",
                "UseIkotEbio",
                "UseOffot",
                "Uyo",
                "UyoOffot"
            ]
        }
    },
    {
        "Anambra": {
            "Aguata": [
                "Achara",
                "Achina",
                "Agba",
                "Agbelu",
                "Aguluezechukwu",
                "Akpo",
                "Aku",
                "Akukwa",
                "Amalasi",
                "Amagbo",
                "Amaife",
                "Amaekwulu",
                "Amaowerri",
                "Amesi",
                "Aforehi",
                "Ekwulobia",
                "Ekwulu",
                "Ebene",
                "Ebenato",
                "Enugwu",
                "Ezinifite",
                "Eziagulu",
                "Eziagu",
                "Ezioka",
                "Ifite",
                "Ihite",
                "Ihuokpala",
                "Ikenga",
                "Igbo-Ukwu",
                "Igwugwu",
                "Iruideke",
                "Iruile",
                "Isioji",
                "Isiaku",
                "Isuofia",
                "Ibughuba",
                "Nkono",
                "Nkpologwu",
                "Ndiokoro",
                "Ngo",
                "Obinabo",
                "Obinato",
                "Obunri",
                "Obiuno",
                "Ogbo",
                "Ogugumezi",
                "Ogwugwu",
                "Okpo",
                "Ora-Eri",
                "Osote",
                "Ozala",
                "Ozara",
                "Uhuehi",
                "Uhuala",
                "Udo",
                "Uga",
                "Ujaliwe",
                "Ugwuakwu",
                "Umuezeinyi",
                "Umuchu",
                "Umuchiana",
                "Umuchi",
                "Umueze",
                "Umuazu",
                "Umudike",
                "Umugana",
                "Umuolu",
                "Umuonya",
                "Umunriofia",
                "Umuocha"
            ],
            "Anambra East": [
                "Abalagbo",
                "Agbudu",
                "Agu",
                "Akamanator",
                "Akata",
                "Akpalagbo",
                "Amagu",
                "Amuawor",
                "Amaunu",
                "Amuleri",
                "Aniekwem",
                "Aba",
                "Enugu",
                "Enugu-Otu",
                "Eziagulu",
                "Eziagulu-Otu",
                "Eziama",
                "Eziafor",
                "Ivite",
                "Isiokwe",
                "Igboezunu",
                "Igbariam",
                "Isinyi",
                "Mgbago",
                "Nando",
                "Nneyi",
                "Nnadi",
                "Nisoye",
                "Nkwonando",
                "Ogbu",
                "Ogugu-Etiti",
                "Ogwuari",
                "OkpaAgba",
                "Okpu",
                "Otuocha",
                "Owaloka",
                "Ovu-Oke/Abubeuno",
                "Umuamievili",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umuenini",
                "Umuezeunu",
                "Umueleri",
                "Umuabia",
                "Umuoba",
                "Umu Udenze",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor"
            ],
            "Anambra West": [
                "Aba",
                "Abalagbo",
                "Agbudu",
                "Agu",
                "Akamanator",
                "Akata",
                "Akpalagbo",
                "Amagu",
                "Amuawor",
                "Amaunu",
                "Amuleri",
                "Aniekwem",
                "Enugu",
                "Enugu-Otu",
                "Eziagulu",
                "Eziagulu-Otu",
                "Eziama",
                "Eziafor",
                "Igboezunu",
                "Igbariam",
                "Isiokwe",
                "Ivite",
                "Isinyi",
                "Mgbago",
                "Nando",
                "Nneyi",
                "Nnadi",
                "Nisoye",
                "Nkwonando",
                "Ogbu",
                "Ogugu-Etiti",
                "Ogwuari",
                "OkpaAgba",
                "Okpu",
                "Otuocha",
                "Owaloka",
                "Ovu-Oke",
                "Umuabia",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuoba",
                "Umu Udenze",
                "Umuezeunu",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor"
            ],
            "Anaocha": [
                "Adazi-Ani",
                "Adazi-Enu",
                "Agbadani",
                "Agulu",
                "Agulu-Uzoigbo",
                "Akamkpisi",
                "Akwaeze",
                "Amata",
                "Amatutu",
                "Amolu",
                "Amorji",
                "Amaezike",
                "Asanu",
                "Diodo",
                "Ede",
                "Ezeja",
                "Ezineni",
                "Enugu-Adazi",
                "Enugwu-Iwa",
                "Enuabor",
                "Etitinabor",
                "Etuleze",
                "Ifite",
                "Ifiteani",
                "Ihuhi",
                "Ichida",
                "Iruowelle",
                "Isiamaigbo",
                "Mgbudu",
                "Mgbuwa",
                "Nduani",
                "Nnechia",
                "Nneogidi",
                "Nkifaku",
                "Nwanchi",
                "Nuhukwu",
                "Neni",
                "Nniukwu",
                "Obe",
                "Obeagu",
                "Obeledu",
                "Obeledu-Ani",
                "Ogweni-Oji",
                "Ogwoeni-Ocha",
                "Okofia",
                "Okpu-Agulu",
                "Okpu-Ifite",
                "Ufa",
                "Ugwudunu",
                "Uhueme",
                "Ukunu",
                "Umuabuia",
                "Umudioka",
                "Umueze",
                "Umuezeani",
                "Umuezeosue",
                "Umuifite",
                "Umuideke",
                "Umuonyili",
                "Umuowelle",
                "Umutu",
                "Uruamindo",
                "Uruoji",
                "Uruolu",
                "Unuaneke",
                "Unuown"
            ],
            "Awka North": [
                "Achalla",
                "Achalla Umana",
                "Adama",
                "Akaeze",
                "Akaezi",
                "Akinyi",
                "Akitinyi",
                "Akpana",
                "Akpulu",
                "Amadim",
                "Amameze",
                "Amaeze",
                "Amaezike",
                "Amaokolo",
                "Amanuke",
                "Amansea",
                "Amukabia",
                "Amede",
                "Amuawor",
                "Aniekwem",
                "Enugu",
                "Enugu-Agu",
                "Enugu-Ugbenu",
                "Egbeagu",
                "Ifite-Isu",
                "Ifite-Ora",
                "Isiogugu",
                "Iruchiafo",
                "Mgbakwu",
                "Obubo",
                "Okika",
                "Okpuno",
                "Orebe",
                "Oraofia",
                "Oraukwu",
                "Otoko",
                "Ugbuenu",
                "Ugbene",
                "Ugwuara",
                "Umunagu",
                "Umunono",
                "Umunonyeukwu",
                "Umu-Agunwoke",
                "Umu-Nokwam",
                "Umuchem",
                "Umuogbefi",
                "Umuozide",
                "Umuonye",
                "Umupia",
                "Umuomete",
                "Umu-Ufie",
                "Umuonyeukwu",
                "Umuebie",
                "Umuekpala",
                "Umueze",
                "Umuezeufu",
                "Umuezeunu",
                "Umueleri",
                "Umuelom",
                "Umuosite",
                "Umuyom",
                "Uruayom",
                "Uruonwu",
                "Uruotulu",
                "Uwani"
            ],
            "Awka South": [
                "Adebebe",
                "Agbana",
                "Amawbia",
                "Anumeze",
                "Ebenao",
                "Emuofite",
                "Enugu",
                "Enugwu",
                "Enugwuagu",
                "Enuoji",
                "Ezike",
                "Ezimezi",
                "Ezinato",
                "Ezinwafor",
                "Eziokpo",
                "EkenboAkesi",
                "Gbaragu",
                "Iruoge",
                "Isiagu",
                "Isiakpu",
                "Mbaukwu",
                "Ndikpa",
                "Ndiora",
                "Ngene",
                "Ngodo",
                "Nibo",
                "Nise",
                "Nodu",
                "Obuofia",
                "Obunabo",
                "Okpuno",
                "Okpu",
                "Okochi",
                "Umuawulu",
                "Umuazu",
                "Umuebilo",
                "Umueze",
                "Umuezeafor",
                "Umuezeilo",
                "Umuezeilo Arah",
                "Umuchem",
                "Umuodum",
                "Umuonyia",
                "Umuakunwa",
                "Umuoba",
                "Umuenwuze-Arah",
                "Umuenu",
                "Umuosite",
                "Uru",
                "Uruoge",
                "Umugulu"
            ],
            "Ayamelum": [
                "Amah",
                "Amagu",
                "Amalie",
                "Anaku",
                "Aniocha",
                "Aturia",
                "Eziumubo",
                "Ifitora",
                "Ikenga",
                "Isiachelle",
                "Isiokwe",
                "Isiudala",
                "Irator",
                "Iboji",
                "Omasi",
                "Obiri",
                "Obunze",
                "Obunofia",
                "Umuawa",
                "Umuoke",
                "Umueragu",
                "Umuerike",
                "Umueleri",
                "Umuodu",
                "Umueji",
                "Umuali",
                "Ukpobaka",
                "Ugbuno",
                "Uga"
            ],
            "Dunukofia": [
                "Abidudu",
                "Adagbe",
                "Akamenato",
                "Akpa",
                "Akwueso",
                "Akwa",
                "Akaezi",
                "Eziagu",
                "Ezinezi",
                "Enuaga",
                "Etiti",
                "Idede",
                "Ifite-Ukpo",
                "Ifiteora",
                "Igbuala",
                "Isiekwulu",
                "Iruowelu",
                "Mgbuke",
                "Nagbana",
                "Nkwelle",
                "Obieze",
                "Okpuru",
                "Oranto",
                "Olor",
                "Ozzah",
                "Ukpo-Nmili",
                "Ukwulu",
                "Ugwu",
                "Umuajana",
                "Umuchigbo",
                "Umuezechua",
                "Umuezekwo",
                "Umueze",
                "Umudioka",
                "Umugana",
                "Uruagu",
                "Uruowelle"
            ],
            "Ekwusigo": [
                "Egbema",
                "Enuguaja",
                "Eziora",
                "Ichi",
                "Ifite",
                "Ihembosi",
                "Ireri",
                "Nza",
                "Oka",
                "Onodu",
                "Oraifite",
                "Ubahuihe",
                "Umuabor",
                "Umuezopi",
                "Umunakwu",
                "Umunandu",
                "Ozubulu",
                "Amakwa"
            ],
            "Idemili North": [
                "Abacha",
                "Abatete",
                "Abidi",
                "Abor",
                "Agbaja",
                "Aguma",
                "Akala-Ekiti",
                "Akama",
                "Akuzor",
                "Amogu",
                "Amoji",
                "Anegu",
                "Anike",
                "Ekele",
                "Ekwulu",
                "Etiti",
                "Ifite",
                "Ideani",
                "Ideoma",
                "Ibenabo",
                "Ire",
                "Isungwu",
                "Mgbachu",
                "Nogba",
                "Nkwelle",
                "Nkwelle-Ogidi",
                "Nsukwu",
                "Nzokwe",
                "Ogbu",
                "Oko",
                "Okpuno",
                "Okpaliko",
                "Otta",
                "Ububa",
                "Ubuhu",
                "Ubuluenu",
                "Umabuam",
                "Umuazo",
                "Umuoji",
                "Umuaze",
                "Umuchem",
                "Umuegbe",
                "Umuikpelle",
                "Umuokpeli",
                "Umuokpulo",
                "Umuochi",
                "Umuoma",
                "Umuoli",
                "Umuisiowe",
                "Umuoduba",
                "Umuota",
                "Umuazu",
                "Uruideke",
                "Urunaneke",
                "Urueze",
                "Uruk",
                "Uruowulu",
                "Uruaboh",
                "Uru-Ogidi",
                "Umuezeunu",
                "Umuokpelo",
                "Umurori",
                "Umulisi",
                "Umuakwu",
                "Umuazi",
                "Umuezune",
                "Umuozu"
            ],
            "Idemili South": [
                "Abo",
                "Aboji",
                "Akama",
                "Akwa-Etiti",
                "Alor",
                "Amadumu",
                "Awuda",
                "Ebenesi",
                "Ekele",
                "Etiti",
                "Ezelle",
                "Eziora",
                "Eziama",
                "Ezieke",
                "Ire",
                "Idam",
                "Ifite",
                "Isu",
                "Isuangbede",
                "Iruowelle",
                "Nkpolofia",
                "Nnaba",
                "Nnokwa",
                "Ngo",
                "Ndam",
                "Ogbu",
                "Omoishi",
                "Ogbenwa",
                "Ogonogo",
                "Ogwugwu",
                "Okide",
                "Okuzu",
                "Umagu",
                "Umuafor",
                "Umuide",
                "Umuibua",
                "Umuokwu",
                "Umuegbu",
                "Umuezike",
                "Umuobi",
                "Umudinya",
                "Umudunu",
                "Umuosiukpana",
                "Umuogali",
                "Umururu",
                "Uruezeani"
            ],
            "Ihiala": [
                "Amorka",
                "Aham",
                "Azia",
                "Edeke",
                "Egbuayiga",
                "Ehuejim",
                "Ezieke",
                "Ezikala",
                "Eziala",
                "Etitilukpo",
                "Ihite",
                "Ihite Azia",
                "Ihueke",
                "Ihudim",
                "Ihuoweri",
                "Izu Mbosi",
                "Idinwanedo",
                "Initesha",
                "Isseke",
                "Issiokwe",
                "Isungwu",
                "Mbahunnaka",
                "Mbosi",
                "Mbarakpaka",
                "Ndirokwo",
                "Ndiezike",
                "Ndiumereaka",
                "Nkwonando",
                "Ogbalegbu",
                "Ohukpaia",
                "Okhia",
                "Okpaladike",
                "Odoata",
                "Ogboro",
                "Ogugwuekwe",
                "Ogwuaniocha",
                "Ubahiogu",
                "Ubahu",
                "Ubahu-Mbosi",
                "Ubahuekwem",
                "Ubahuagbugha",
                "Ubahumonum",
                "Ubalwoti",
                "Uhungwu",
                "Uhuobo",
                "Uhuowelie",
                "Umuagu",
                "Umuabike",
                "Umuabuchi",
                "Umuadobaihe",
                "Umuapani",
                "Umuamievili",
                "Umuada",
                "Umuchem",
                "Umudioka",
                "Umudiokpara",
                "Umudala",
                "Umudalaegwu",
                "Umuebugwu",
                "Umueala",
                "Umueze",
                "Umuezeala",
                "Umuezeagwute",
                "Umuezeogu",
                "Umuezeolutu",
                "Umuezedam",
                "Umuezelipi",
                "Umuezeona",
                "Umuezesom",
                "Umuezewuhum",
                "Umuezike",
                "Umufanaka",
                "Umuofor",
                "Umuogu",
                "Umuoma",
                "Umuokpara",
                "Umuokpoto",
                "Umuorilike",
                "Umupani",
                "Umuomuora",
                "Umundumanya",
                "Umuoni",
                "Umunwajiobi",
                "Umuzul",
                "Uzoakwa",
                "Uwawulu",
                "Uzuama",
                "Utaba"
            ],
            "Njikoka": [
                "Abagana",
                "Abba",
                "Achala",
                "Adagbo-Oraofia",
                "Adagbo-Umuduna",
                "Adagbe-Abagana",
                "Akiyi",
                "Amabo",
                "Amafum",
                "Amuenuye",
                "Atukpolom",
                "Awator",
                "Awaobu",
                "Ebonano",
                "Ebonato",
                "Ekpuloji",
                "Egbedeamu",
                "Enora-Oraofia",
                "Enuagu",
                "Enuabomini",
                "Enugwu-Agidi",
                "Enugwu-Ukwu",
                "Ezira",
                "Ifite",
                "Igbolo",
                "Ire",
                "Irunebo",
                "Iruobigeli",
                "Iruoma",
                "Mmini",
                "Nahuru",
                "Nmukwa",
                "Nomu",
                "Ogwugwu",
                "Orji",
                "Orofia",
                "Osili",
                "Umuanu",
                "Umudigba",
                "Umudunu",
                "Umueze",
                "Umuokpoto",
                "Umuakwu",
                "Umuatulu-Awovu",
                "Umuatulu-Ifiteani",
                "Umuoji",
                "Urakwelora",
                "Uranechi",
                "Uruezewebo-Na",
                "Urukpaleke",
                "Urunnebe",
                "Uruabor",
                "Uruani",
                "Uruanyaugani",
                "Uruogbo",
                "Uruoji",
                "Uruokeke",
                "Uruokoke",
                "Uruokpala",
                "Uruonyejem",
                "Uruuze"
            ],
            "Nnewi North": [
                "Nnewi",
                "Nnewi-Ichi",
                "Otolo",
                "Umudim",
                "Uruagu"
            ],
            "Nnewi South": [
                "Amakom",
                "Amichi",
                "Anakom",
                "Akwaihedi",
                "Afoube",
                "Ebenasa",
                "Ebenator",
                "Eziama",
                "Ezinifite",
                "Ekwulu-Mili",
                "Enugwu",
                "Etitinabo",
                "Ifite",
                "Imokpara",
                "Isigwu",
                "Nkwukwo",
                "Obiogu",
                "Ogbodi",
                "Okpala",
                "Okpokoro",
                "Okpuno",
                "Osumenyi",
                "Owelechukwu",
                "Udene",
                "Ubaha",
                "Umunama",
                "Umunnalo",
                "Umunnobe",
                "Umunuko",
                "Umudiama",
                "Umuahama",
                "Umeojilienyi",
                "Umuonyelikpa",
                "Ukpor",
                "Unubi",
                "Urueze",
                "Utuh"
            ],
            "Ogbaru": [
                "AkiliOgidi",
                "Amiyi",
                "Abilibaose",
                "Abilibose",
                "Anibueze",
                "Ezele",
                "Idemili",
                "Ibelenta",
                "Igbuzor",
                "Isioha",
                "Isoru",
                "Iyiowa",
                "Kochio",
                "Nkwekochie",
                "Ndam",
                "Ogba-Kuba",
                "Ogwasiji",
                "Ogbetiti",
                "Okichi",
                "Okpalika",
                "Okoti",
                "Oshita",
                "Osso-Mala",
                "Umu-Emere",
                "Umuadigwe",
                "Umuamu",
                "Umuamiham",
                "Umuamam",
                "Umuoguluji",
                "Umuogwuezi",
                "Umuolokwu",
                "Umuoniha",
                "Umuonyesom",
                "Umuonyogbom",
                "Umupiko",
                "Umuukapa",
                "Umueke",
                "Umuezeoma",
                "Umuezehobi",
                "Umuekeke",
                "Umuekekeobodo",
                "Umuikazu",
                "Umukoligbo",
                "Umumumika",
                "Umuni",
                "Umuosanya",
                "Umuonaechi",
                "Umuyasele",
                "Umunan-Kwo",
                "Umunyasi",
                "Umutaba",
                "Umuobuo",
                "Umugha",
                "Umuoma",
                "Umumumhe"
            ],
            "Onitsha North": [
                "Army Barracks",
                "Awada Layout",
                "Enu Onicha",
                "Gra",
                "Gra Phase I",
                "Gra Phase II",
                "Isiafor Layout",
                "Odoakpu",
                "Omagba Layout Phase",
                "Omagba Phase I",
                "Onitsha",
                "Trans Nkissi Layout",
                "Trans Nkissi Phase I",
                "Woliwo"
            ],
            "Onitsha South": [
                "Niger Bridge Head",
                "State Low Cost Housing",
                "Fegge",
                "City Centre",
                "Onitsha",
                "Main Market"
            ],
            "Orumba North": [
                "Ajango",
                "Akwulofia",
                "Amoji",
                "Amagu",
                "Amako",
                "Anumkpu",
                "Agbanokwe",
                "Agbata",
                "Agbiligba",
                "Ajalli",
                "Abor",
                "Arogwe",
                "Aronato",
                "Enumgbom",
                "Eziobiuno",
                "Eziokbikpa",
                "Eziokwe",
                "Ezibegbe",
                "Ezinkwo",
                "Eziabor",
                "Ezioko",
                "Egbeagu",
                "Enugwu",
                "Enuko",
                "Ifite",
                "Ihengwu",
                "Igweakpu-Ofia Udo",
                "Ikpangene",
                "Kolulu",
                "Mbuluko",
                "Ndiokolo",
                "Ndiokpala",
                "Ndiefele",
                "Ndikpa",
                "Nnadi",
                "Nkwonando",
                "Ngodo Obinikpa",
                "Ndinwedo",
                "Ndiu-Kwuenu",
                "Nkanu",
                "Ogbu",
                "Ojiagbeni",
                "Okpalebuteku",
                "Okeania",
                "Okeofia",
                "Obinagu",
                "Obinikpa",
                "Oboulhuala",
                "Obumetiti",
                "Ozu",
                "Ozu na Amugo",
                "Upata",
                "Amaokpala",
                "Amokwe",
                "Ugwu",
                "Umuabiama",
                "Umudike",
                "Umudala",
                "Umuefu",
                "Umueji",
                "Umuenebu",
                "Umuezeunu",
                "Umuogu",
                "Umuokato",
                "Umuonyinka",
                "Umuonyiba",
                "Umunkwa",
                "Umunkwo",
                "Umuikpa",
                "Umuiguisibe",
                "Umuogem",
                "Uhuama",
                "Uhueze",
                "Umunaba",
                "Ufuma",
                "Umunebonato",
                "Umunu",
                "Umuomewni",
                "Umeuma"
            ],
            "Orumba South": [
                "Abombe",
                "Adani-Ikpa",
                "Adazi",
                "Akata",
                "Akpu",
                "Alaohia",
                "Amaeke",
                "Amangwu",
                "Amopu",
                "Amaoji",
                "Amorie",
                "Amokwe",
                "Aniru",
                "Arekpa",
                "Awuka",
                "Ebiefe",
                "Enekenta",
                "Enugu-Umuonyia",
                "Eziagu",
                "Ezira",
                "Ihebuebu",
                "Imeofia-Okii",
                "Isiama",
                "Isiokpu",
                "Isiafor",
                "Iyiafor",
                "Imedin",
                "Imoia",
                "Mbagbo",
                "Mkputu",
                "Mgboko",
                "Ndiob",
                "Ndiudensi",
                "Ndibeokpalaeze",
                "Nkwonando",
                "Ngodo",
                "Nkereh",
                "Nsogwu",
                "Obeagu",
                "Obioffia",
                "Obinikpa",
                "Obunetiti",
                "Ogbunise",
                "Ogbunka",
                "Ogboji",
                "Ogwuada",
                "OkpaAgba",
                "Okpobe",
                "Okpuno Ifite",
                "Okpu",
                "Omerili",
                "Owerre",
                "Owerre-Ezukala",
                "Owu-Okpo",
                "Uba",
                "Ubaha",
                "Ubaha-Akwosa",
                "Umuabia",
                "Umueze",
                "Umuezeamasi",
                "Umuezeawuru",
                "Umuezeogbu",
                "Umuekwere",
                "Umueonye Kanma",
                "Umuana",
                "Umuamachi",
                "Umuchem",
                "Umuike",
                "Umuokpara",
                "Umuokparaibekwe",
                "Umuokpurukpu",
                "Umuoma",
                "Umuomaku",
                "Umuor",
                "Umuezeregwu",
                "Umuozoro",
                "Umunegbu",
                "Umunewo",
                "Umunwozonde",
                "Umunwozonokebe",
                "Umunz",
                "Urualor",
                "Ururo",
                "Uziza"
            ],
            "Oyi": [
                "Achalla",
                "Agba",
                "Agwa",
                "Akaezi",
                "Amadiaba",
                "Amaezike",
                "Amawa",
                "Amaupa",
                "Amuche",
                "Ajakpani",
                "Azu",
                "Dusogu",
                "Eziane",
                "Ezinkwo",
                "Eziumunya",
                "Ifite",
                "Ikenga",
                "Iru-Anika",
                "Iruoyim",
                "Mmuru",
                "Nteje",
                "Nkwelle",
                "Ojobi",
                "Okpu",
                "Osile",
                "Otoko",
                "Oze",
                "Ukalor",
                "Ukunu",
                "Uruebo",
                "Umuneba",
                "Umunya",
                "Umuanunwa",
                "Umuebo",
                "Umuejebo",
                "Umuevi",
                "Umuaza",
                "Umudioka"
            ]
        }
    },
    {
        "Bayelsa": {
            "Brass": [
                "Abadikiri",
                "Abedigbene",
                "Abolikiri",
                "Abulobiri",
                "Adaakou",
                "Adamkiri",
                "Agbakabiriyai",
                "Agubagaha",
                "Akasa",
                "Akipelai",
                "Amagbefeu",
                "Ampogu",
                "Aparanbio",
                "Arumhikiri",
                "Atubo",
                "Awajeakiri",
                "Awazakiri",
                "Ayagirikiri",
                "Bamankiri",
                "Beletiama",
                "Benkiri",
                "Biantubu",
                "Boama",
                "Bonneykiri",
                "Brass",
                "Buogboko",
                "Burukiri",
                "Cape Formosa",
                "Captninakiri",
                "Clarendon",
                "Curpen",
                "Duokumgbene",
                "Ebelegbene",
                "Ebikiri",
                "Edebarikiri",
                "Egbedekiri",
                "Egbilaba",
                "Egekiri",
                "Egeletia",
                "Egeregere",
                "Egereogo",
                "Egwema",
                "Egwema Pogu",
                "Ekemakiri",
                "Ekesitoko",
                "Elgitekin",
                "Eluenigbene",
                "Enegalogo",
                "Ereweibio",
                "Etabolagone",
                "Ewediri",
                "Eweisuo",
                "Ewoama",
                "Ewokiri",
                "Eyenkiri",
                "Fantuo",
                "Fiwaritimi",
                "Ganigbene",
                "Gbene Ghama",
                "Gold Coast",
                "Golubokiri",
                "Guorogbene",
                "Ibelebiekiri",
                "Ibtufra-Makiri",
                "Idema",
                "Igbabele",
                "Igbabopiri",
                "Ijawki",
                "Imbiri",
                "Iniedoyey-Ekiri",
                "Isikara",
                "Iwoama",
                "Jekegbene",
                "Kabuke",
                "Kalabilema",
                "Kallah Oroba Island",
                "Kamikiri",
                "Kemmers Town",
                "Kinkiamabugo",
                "Kirigupo",
                "Kirikakiri",
                "Kongho",
                "Kpangbokiri",
                "Kurogbaba",
                "Liama",
                "Location",
                "Mabokubu",
                "Mansiorkiri",
                "Mbaskiri",
                "Mileokiri",
                "Minibeleu",
                "Misakiri",
                "Moborokiri",
                "Monikiri",
                "Munighakiri",
                "Namatebe",
                "Nampoju",
                "Oaroweiama",
                "Obama",
                "Obi",
                "Obudogbene",
                "Odioma",
                "Ofo Market",
                "Ogalkiri",
                "Ogbonotroko",
                "Oimiekiri",
                "Okiinibiriba",
                "Okinbiriboteu",
                "Okobotruo",
                "Okoribukio",
                "Okparanaba",
                "Okpoama",
                "Okpokiri",
                "Olugama",
                "Olukama",
                "Olukugbene",
                "Omonikiri",
                "Omugopogu",
                "Onunu",
                "Onunwypele",
                "Opolochi",
                "Oporoma",
                "Opu Akassa",
                "Opuorubo",
                "Orawo",
                "Oro-Foniweitoro",
                "Orukiri",
                "Orukutu",
                "Osugbene",
                "Otatubei",
                "Otolo",
                "Otufor",
                "Peribe",
                "Philippo",
                "Sabatoru",
                "Saikiri",
                "Sanekubo",
                "Sangana",
                "Sasuokiri",
                "Sounkiri",
                "Sowegbene",
                "Spiffis Town",
                "Tana",
                "Tengikiri",
                "Tereke",
                "Ton Kiri",
                "Tuluama",
                "Wabokiri",
                "Wagite",
                "Waribokikiri",
                "Warise Gbene",
                "Warri"
            ],
            "Ekeremor": [
                "Aiegbe",
                "Aleibiri",
                "Amabulour",
                "Ananagbene",
                "Angalawei-gbene",
                "Ayamassa",
                "Azagbene",
                "Bown-Adagbabiri",
                "Eduwini",
                "Ekeremor",
                "Feremoama",
                "Fontoru-Gbene",
                "Isampou",
                "Isreal-O-Zion",
                "Lalagbene",
                "Ndoro",
                "Norhene",
                "Obrigbene",
                "Ogbogbene",
                "Ogbosuwar",
                "Oporoma",
                "Oyiakiri",
                "Peretou-Gbene",
                "Tamogbene",
                "Tamu-Gbene",
                "Tarakiri",
                "Tietiegbene",
                "Toru-Foutorugbene"
            ],
            "Kolokuma/Opokuma": [
                "Akaibiri",
                "Aya-Ama",
                "Ayibabiri",
                "Ayokoroma",
                "Gbarama",
                "Igbanwa",
                "Igbedi",
                "Kalama",
                "Odi",
                "Ofonibiri",
                "Okolobaa",
                "Oloibiri",
                "Oyobu",
                "Sabagreia",
                "Sampou"
            ],
            "Nembe": [
                "Adukiri",
                "Agada",
                "Agrisaba",
                "Akakumana",
                "Allagaokiri",
                "Amasara",
                "Benkiri",
                "Dorgu-Ewoama",
                "Dumobi-Kumakiri",
                "Ekpeikiri",
                "Elemuama",
                "Enyumuana",
                "Etieme",
                "Ewokiri",
                "Fekorukiri",
                "Igbeta-Ewoama",
                "Ikensi",
                "Isaiahkiri",
                "Iseleogona",
                "Iserekiri",
                "Mini",
                "Nembe",
                "Obiama",
                "Obiata",
                "Odekiri",
                "Okokokiri",
                "Okoroba",
                "Ologoma",
                "Olusasiri",
                "Oromabiri",
                "Otumakiri",
                "Sabatoru",
                "Sangakubu",
                "Shellkiri",
                "Tengelkiri",
                "Tengikokiri",
                "Tombi"
            ],
            "Ogbia": [
                "Abobir",
                "Akolomani",
                "Amorokeni",
                "Amuruto",
                "Anyama",
                "Egeleama",
                "Elebele",
                "Emadike",
                "Emago",
                "Emakalakala",
                "Emegai",
                "Epebu",
                "Ewama",
                "Ewoi",
                "Igbo",
                "Imiringi",
                "Iyakiri",
                "Kolo",
                "Obakilolo",
                "Obelebiri",
                "Obuaba",
                "Ogbia",
                "Ogboama",
                "Ogireyankiri",
                "Okiki",
                "Okodi",
                "Olobiri",
                "Ologi",
                "Ologoghe",
                "Oluaganagu",
                "Onuebum",
                "Opume",
                "Oruma",
                "Otegila",
                "Otegwe",
                "Otuabagi",
                "Otuabai",
                "Otuabula",
                "Otuaganagu",
                "Otuakeme",
                "Otuedu",
                "Otuegwe",
                "Otuekpein",
                "Otuogidi",
                "Otuogori",
                "Otuokpoti",
                "Qutar",
                "Sagatama",
                "Sobo Camp",
                "Warbugoama"
            ],
            "Sagbama": [
                "Abuku",
                "Adagbabiri",
                "Agbere",
                "Agoro",
                "Agorogbene",
                "Akeddei",
                "Angalabiri",
                "Anibeze",
                "Asamabiri",
                "Bolou-Orua",
                "Dagnnama",
                "Ebedebiri",
                "Egbepulougbene",
                "Ekperiware",
                "Elemebiri",
                "Igoni",
                "Ikpidiama",
                "Kanan",
                "Odoni",
                "Ofoni",
                "Ogobiri",
                "Ogobokiriama",
                "Ogoni",
                "Okumbiri",
                "Osibiri",
                "Osssiama",
                "Sagbama",
                "Toru-Angiama",
                "Toru-Ebeni",
                "Toru-Orua",
                "Trofani",
                "Tungbabiri",
                "Tungbo"
            ],
            "Southern Ijaw": [
                "Abagbene",
                "Abolgbene",
                "Agidigbere",
                "Aguobiri",
                "Akamanator",
                "Akpobeleiowei",
                "Alagbene",
                "Aleegbene",
                "Alisogbene",
                "Amagu",
                "Amuawor",
                "Amaunu",
                "Amuleri",
                "Amassoma",
                "Apoi",
                "Arikaripo",
                "Atakol",
                "Ayama",
                "Ayougbene",
                "Azuzuama",
                "Babatonogbene",
                "Baberegbene",
                "Bayentorugbene",
                "Betterland",
                "Biabugbene",
                "Biagbogbene",
                "Bikirubogbene",
                "Birieigbene",
                "Birisyegbene",
                "Bitou",
                "Blongbene",
                "Bokomgbene",
                "Bolongbene",
                "Boma",
                "Buragbene",
                "Burukububo",
                "Climonbene",
                "Consingbere",
                "Diebu",
                "Douglasgbene",
                "Dubagbene",
                "Ebatimogbene",
                "Ebidargbene",
                "Eduregbene",
                "Egarebeni",
                "Egberime",
                "Ekowe",
                "Ekeni",
                "Emete",
                "Enugu",
                "Enugu-Otu",
                "Eniwari",
                "Erebugbene",
                "Erefumakomogbene",
                "Eziagulu",
                "Eziagulu-Otu",
                "Eziama",
                "Eziafor",
                "Fiesigbene",
                "Foinbiri",
                "Foniweitoro",
                "Furopa",
                "Fungbene",
                "Gbaran",
                "Glologbene",
                "Guaregbene",
                "Hewigbene",
                "Hittargbene",
                "Hopin Point",
                "Igbomatoru",
                "Igboezunu",
                "Ikebiri",
                "Ikeingbabiri",
                "Ikiambiri",
                "Ikoromogbene",
                "Ikpirigbene",
                "Inoma",
                "Isiokwe",
                "Isinyi",
                "Jermaih-gbene",
                "Kemeligbene",
                "Keregbene",
                "Kalarogbene",
                "Kalawarigbene",
                "Kamboira Boria",
                "Kasoma",
                "Korokorsei",
                "Korumogbene",
                "Kolu-Ama",
                "Koluama",
                "Kokologbene",
                "Komobiama",
                "Komoforagbene",
                "Kugbogbene",
                "Lasofa",
                "Lobia",
                "Lalgbene",
                "Laisukugbene",
                "Livergbene",
                "Luckygbene",
                "Luduon",
                "Mgbago",
                "Miabong Ikot",
                "Nando",
                "Nneyi",
                "Nnadi",
                "Nisoye",
                "Nkek",
                "Nkwonando",
                "North Point",
                "Nyuseyegbene",
                "Obomikorogbene",
                "Odeigbene",
                "Ofmiegbene",
                "Ofogbene",
                "Ogbogbene",
                "Ogbogero",
                "Ogboidigbene",
                "Ogidigbene",
                "Ogoumbiri",
                "Okigbene",
                "OkpaAgba",
                "Okpofuwari",
                "Olobia",
                "Olobobene",
                "Olodi",
                "Olugbogbene",
                "Onugwa",
                "Onyoma",
                "Oporogbene",
                "Oporoma",
                "Opuama",
                "Orikowe",
                "Osugbene",
                "Otuocha",
                "Oweikorogba",
                "Oyeregbene",
                "Ozezebiri",
                "Port-Harcourt-gbene",
                "Pepegbene",
                "Pepelegbene",
                "Peresisofogbene",
                "Petugbene",
                "Piebolegbene",
                "Pisegbene",
                "Polobugo",
                "Rituagbene",
                "Saberugbene",
                "Segpe",
                "Sibiri",
                "Sundaugbene",
                "Sungbene",
                "Tacadosgene",
                "Talegbene",
                "Tangagae",
                "Tebitubufor",
                "Teibidaba",
                "Tipama",
                "Tofiagbene",
                "Tomgbene",
                "Tologbene",
                "Tuimpeigbene",
                "Ukptatube",
                "Ukubie",
                "Umuamievili",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umuenini",
                "Umuezeunu",
                "Umueleri",
                "Umuabia",
                "Umuoba",
                "Umu Udenze",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor",
                "Uyo",
                "Yedogbene"
            ],
            "Yenagoa": [
                "Abasere",
                "Agbia",
                "Agbobiri",
                "Agorogbene",
                "Agudama",
                "Agudama-Epie",
                "Akada",
                "Akpide",
                "Akunomi",
                "Amarata",
                "Amasso",
                "Anyamabele",
                "Atissa",
                "Azikoro",
                "Bebelibiri",
                "Betaland",
                "Biogbolo",
                "Biseni",
                "Bumodi",
                "Ede-Pie",
                "Egbebiri",
                "Ekeki",
                "Ekpetiama",
                "Emblama",
                "Epie",
                "Fangbe",
                "Freetown",
                "Gbarain",
                "Gbaramtoru",
                "Ibia",
                "Igbogene",
                "Ikarama",
                "Ikibiri",
                "Ikolo",
                "Jackbiri",
                "Kaiama",
                "Kalaba",
                "Karama",
                "Korama",
                "Kpansia",
                "Nyanbiri",
                "Obungha",
                "Ogbolomo",
                "Ogoniforu",
                "Ogu",
                "Ojogbolo",
                "Okolobiri",
                "Okorodia",
                "Okotiama",
                "Okutukutu",
                "Omom",
                "Onura",
                "Opolo",
                "Ovelemini",
                "Polaku",
                "Tein",
                "Tombia",
                "Tuburu",
                "Yenegwe",
                "Yeniozue-Epie",
                "Zarama",
                "Zarama Epie"
            ]
        }
    },
    {
        "Bauchi": {
            "Alkaleri": [
                "Alkaleri",
                "Badakoshi",
                "Bakinkogi",
                "Bartak Fali",
                "Bartak Pali",
                "Badaran Daste",
                "Bajama",
                "Bajoga",
                "Begoa",
                "Birim",
                "Bobga",
                "Bura bayi",
                "Dan",
                "Digare",
                "Digi",
                "Dogon Ruwa",
                "Duguri",
                "Duguri (YULI)",
                "Fali",
                "Filu",
                "Futuk",
                "Galanbi Yalwa",
                "Gar",
                "Garin Bahago",
                "Gayar",
                "Gaji Gumu",
                "Gigyara",
                "Gulum",
                "Guma",
                "Gwanan Duste",
                "Gwandun",
                "Gwaram (OLD)",
                "Guruntun",
                "Jada Mansur",
                "Jauro Hamma",
                "Jauro Hanza",
                "Kafi",
                "Kafin Madaki",
                "Kandak",
                "Karenkare",
                "Kashereyel",
                "Klumkar",
                "Kumba",
                "Kumbi",
                "Kunginbar",
                "Kunsakal",
                "Lafiya",
                "Mai`ari",
                "Maimadi",
                "Malla",
                "Makama",
                "Malam Yaya",
                "Manaur",
                "Murtal",
                "Mundaniyo",
                "Mundol",
                "Nastira",
                "Nafuta",
                "Pali",
                "Rafawa",
                "Rimi",
                "Sabon Gari",
                "Sabon jiri",
                "Shafa",
                "Sharam",
                "Tawur",
                "Tarangadi",
                "Tumuru",
                "Tudun Wada",
                "Twara",
                "Unguwan Wako",
                "Wuki",
                "Yalo",
                "Yalon Guruza",
                "Yalwan Dogo",
                "Yalwan Duguri",
                "Yashi",
                "Yuli Camu",
                "Zange"
            ],
            "Bauchi": [
                "Badakoshi",
                "Balanshi",
                "Barumi",
                "Bayara",
                "Bigi",
                "Birshi",
                "Birshi Gandu",
                "Bishi",
                "Burum",
                "Buzaye",
                "Buzoye",
                "Byara",
                "Dandago",
                "Din",
                "Dulbu",
                "Dumi",
                "Dumin Zungur",
                "Durum",
                "Dutse",
                "Galambi",
                "Gakal",
                "Gasgal",
                "Gasgol",
                "Geji",
                "Girshi Fulani",
                "Gokaru",
                "Gubi",
                "Gwaskoram",
                "Inkil",
                "Jamda",
                "Juwara",
                "Kuda",
                "Kuhu",
                "Kundak",
                "Kundum",
                "Kungas",
                "Kuruwala",
                "Kurwala",
                "Kunjinbar",
                "Lafiyari",
                "Liman Katagum",
                "Luda",
                "Lugge",
                "Lushi",
                "Magas",
                "Malmo",
                "Malma",
                "Migyara",
                "Miri",
                "Mun",
                "Munsal",
                "Muwsa",
                "Natsira",
                "Pimi",
                "Rehu",
                "Runde Bin",
                "Shadawanka",
                "Shasawawka",
                "Shinga",
                "Taka Lafia",
                "Tirwun",
                "Tundunwada",
                "Wunti Dada",
                "Wura Wase",
                "Yelwa",
                "Yamrat",
                "Yola Doka",
                "Zungur",
                "Zungur-Dutse",
                "Zungur T-wada"
            ],
            "Bogoro": [
                "Abiya",
                "Badagari",
                "Bala",
                "Ball Lusa",
                "Bar",
                "Baram",
                "Boi",
                "Boloro",
                "Bom",
                "Bonga",
                "Bongo",
                "Bungu",
                "Dashem Bamin Kogi",
                "Dashem Yalwa",
                "Dinki",
                "Dinki Rimi",
                "Dinkin Fate",
                "Dull",
                "Dunga",
                "Dutsen Saki",
                "Fulani",
                "Gambar Lere",
                "Gambar Sabon Layi",
                "Garualan",
                "Gid-Gid Hamman",
                "Gidan Danlaji",
                "Gizaki",
                "Gobbiya",
                "Gwarangah",
                "Gyara",
                "Jalong",
                "Janyar",
                "Kafin-Musa",
                "Kijim",
                "Kori Duwa",
                "Kurum Dodo",
                "Kwara",
                "Lafiyan Sara",
                "Luggere",
                "Lusa",
                "Mallar",
                "Molmol",
                "Naukum",
                "Ndit",
                "Rafin Zurfi",
                "Rafiu",
                "Sourr",
                "Sum",
                "Tadnum",
                "Tapshin",
                "Unglere",
                "Unguwar Gyada",
                "Unguwar Rimi",
                "Vung",
                "Yabra",
                "Zong Dutse",
                "Zurfi"
            ],
            "Dambam": [
                "Arku",
                "Bale",
                "Banjine",
                "Birniwa",
                "Carai",
                "Catahe",
                "Chinade",
                "Dagada",
                "Daguada",
                "Dambam",
                "Damo",
                "Dinchi",
                "Dul",
                "Durwari",
                "Fagam",
                "Gargawa",
                "Garin Chiroma",
                "Garuza",
                "Gurbana",
                "Gwala",
                "Husami",
                "Jalem",
                "Janda",
                "Kaderi",
                "Kaigamari",
                "Lailai",
                "Lelawari",
                "Lumbo",
                "Madawai Garga",
                "Manawachi",
                "Nahuta",
                "Ningo",
                "Shudi",
                "Taiyu",
                "Tingariye",
                "Tudun Wada",
                "Wahu",
                "Wakili",
                "Wuro Bundu",
                "Yanda",
                "Yayari",
                "Yayarin Fulani",
                "Zaure",
                "Zobali",
                "Zaura"
            ],
            "Darazo": [
                "Aliya",
                "Badakoshi",
                "Babaye",
                "Bagaji",
                "Bagurum",
                "Bakoti",
                "Bali",
                "Bam",
                "Bula",
                "Buburi",
                "Bugui",
                "Dambaji",
                "Damata",
                "Darazo",
                "Dafatuwo",
                "Dalagobe",
                "Dayi",
                "Dosho",
                "Dollol",
                "Duwo",
                "Farin Bango",
                "Fate",
                "Gabarin",
                "Gabchiyari",
                "Gadon Jauri",
                "Gandum",
                "Garin Abare",
                "Garin Abba",
                "Garin Lesa",
                "Garin Mailafiya",
                "Garin Mal",
                "Garin Malam Yautare",
                "Garin Seri",
                "Ginaka",
                "Gakkulan Audi",
                "Gakkulan Ganuwa",
                "Gwadal",
                "Gudugul",
                "Jimin'Indabo",
                "Jaberi",
                "Kafiyel",
                "Kamagari",
                "Kamaku",
                "Kanda",
                "Kaigamari",
                "Kanya",
                "Ka`el",
                "Kili",
                "Konkiyel",
                "Korawa",
                "Kwattuje",
                "Lago",
                "Lanzai",
                "Ladi",
                "Lemari",
                "Ligge",
                "Mainari",
                "Mairake",
                "Maluri",
                "Malurin",
                "Mamudu",
                "Magama",
                "Magume",
                "Mgbago",
                "Nahutan",
                "Nahutan Darazo",
                "Nahutan Jiro",
                "Nkwonando",
                "Nneyi",
                "Nisoye",
                "OkpaAgba",
                "Okpu",
                "Otuocha",
                "Owaloka",
                "Ovu-Oke",
                "Pandum",
                "Papa",
                "Ramfa",
                "Ruga Gwano",
                "Sabon Garin Lanzai",
                "Sabon Garin Papa",
                "Sabon Garin Yautare",
                "Sabu",
                "Sade",
                "Sauke",
                "Shadarki",
                "Shuguri",
                "Tagoje",
                "Tauya",
                "Tashar Aduwa",
                "Tashar Kurma",
                "Tsangaya",
                "Tsangayari",
                "Tsamiya",
                "Tudun Wadan Lanzai",
                "Umuabia",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor",
                "Wahu",
                "Wuro Bogga",
                "Wuro Bundu",
                "Wuro-Dole",
                "Wuro Hirna",
                "Wuro Tara",
                "Yalwa",
                "Yalwan Darazo",
                "Yalwan Maluri",
                "Yautare",
                "Zandam",
                "Zira",
                "Zobo"
            ],
            "Dass": [
                "Bagel",
                "Bajar",
                "Bandas",
                "Bangim",
                "Baraza",
                "Bundili",
                "Bundot",
                "Bununu",
                "Dangri",
                "Darrari",
                "Dass Katanga",
                "Donttel",
                "Dott",
                "Dumba",
                "Durr",
                "Gajiwel",
                "Galo",
                "Galtal",
                "Garam",
                "Lusa",
                "Lushi",
                "Pegin Mallam Mato",
                "Polchi",
                "Sabon Garin Burgel",
                "Wandi",
                "Zumbul Dangri"
            ],
            "Gadau": [
                "Abbari",
                "Ashigeri",
                "Atawari",
                "Babu Gudu",
                "Babuwuri",
                "Diga",
                "Dunari",
                "Gadau",
                "Garin Buraji",
                "Garin Malam",
                "Gata Fowa",
                "Kanaderi",
                "Kashuri",
                "Katsinawa",
                "Nomari",
                "Sharifufi",
                "Walai"
            ],
            "Gamawa": [
                "Abusta",
                "Aido",
                "Adabda",
                "Alagarne",
                "Alamaiko",
                "Alasari",
                "Amarchari",
                "Amarchiyari",
                "Ariya",
                "Bagalu",
                "Bagel",
                "Bakata",
                "Bakori",
                "Bambureri",
                "Banamari",
                "Barawatari",
                "Barkewa",
                "Bauchiri",
                "Bauna",
                "Bilabirin",
                "Biriri",
                "Bofel",
                "Boggajiga",
                "Bulaudo",
                "Bukurami",
                "Bumiyami",
                "Bundujaru",
                "Buskuwa",
                "Chaichai",
                "Chunkani",
                "Dagaleri",
                "Dallari",
                "Dallarin Gabas",
                "Dallarin Yamma",
                "Dallol",
                "Dalmari",
                "Damba",
                "Dambayel",
                "Danchuwa",
                "Dankori",
                "Dauduri",
                "Dafsomari",
                "Duwaru",
                "Fewadam",
                "Galjiri",
                "Gamboru",
                "Ganalboji",
                "Gangawa",
                "Gangaw",
                "Ganjiri",
                "Garin Alhaji",
                "Garin Babale",
                "Garin Babuga",
                "Garin Badawai",
                "Garin Bara",
                "Garin Bego",
                "Garin Bikalawa",
                "Garin Buda",
                "Garin Dala",
                "Garin Galadima",
                "Garin Gordi",
                "Garin Ja`oji",
                "Garin Janbiri",
                "Garin Jaure Shehu",
                "Garin Jauro Gashi",
                "Garin Jauro Hamza",
                "Garin Kerma",
                "Garin Kure",
                "Garin Kwano",
                "Garin Kwasam",
                "Garin M. Jumba",
                "Garin Makama",
                "Garin Makau",
                "Garin Malam",
                "Garin Manu Nomari",
                "Garin Umaru Shaiya",
                "Garin Yawaram",
                "Garuwa",
                "Garwa",
                "Gassgaya",
                "Gayau",
                "Gayau Sengo",
                "Gayawa",
                "Geshi",
                "Getattara",
                "Gidameri",
                "Gololo",
                "Gurbana",
                "Gurbana Majam",
                "Guruttu",
                "Gwarbatu",
                "Harderi",
                "Jadokokana",
                "Jadori",
                "Jajiri",
                "Jamari",
                "Jarwa",
                "Jejiri",
                "Jimina",
                "Joyawo",
                "Kachachari",
                "Kachallari",
                "Kafiremi",
                "Kaisawa Dole",
                "Kaisawan Yamma",
                "Kalgiri",
                "Karakafchi",
                "Karshumma",
                "Kasuwa",
                "Katsimawa",
                "Kesa",
                "Kichakki",
                "Kore",
                "Kuda",
                "Kukadi",
                "Kuluwa",
                "Kumbari",
                "Kyaulori",
                "Lafiyari",
                "Lariski",
                "Ladelade",
                "Lariye",
                "Lugagu",
                "Lukkugal",
                "Maiduguri",
                "Mainari",
                "Mainari Karaguwa",
                "Malamfateri",
                "Malumri",
                "Manaba",
                "Manawango",
                "Mabani",
                "Magajeri",
                "Majimba",
                "Majiri",
                "Majumba",
                "Mgbago",
                "Minya",
                "Misoye",
                "Nando",
                "Nneyi",
                "Nnadi",
                "Nisoye",
                "Nkwonando",
                "Nkek Abak",
                "Nkek Idim",
                "Odobo",
                "Ogbu",
                "Ogugu-Etiti",
                "Ogwuari",
                "OkpaAgba",
                "Okpu",
                "Otuocha",
                "Owaloka",
                "Ovu-Oke",
                "Raga",
                "Sabayo",
                "Sabongari",
                "Sagwai",
                "Sansan",
                "Shalum",
                "Shanga",
                "Sharifuri",
                "Shuwari",
                "Suduwari",
                "Supa",
                "Taffi",
                "Taragi",
                "Taranka",
                "Tarmasuwa",
                "Tonde",
                "Tufferi",
                "Turakiri",
                "Udubo",
                "Udube",
                "Umeri",
                "Umuamievili",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umuenini",
                "Umuezeunu",
                "Umueleri",
                "Umuabia",
                "Umuoba",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor",
                "Wabu",
                "Wailawo",
                "Yaba",
                "Yalwa",
                "Yarimari",
                "Yola",
                "Yuri",
                "Zawa",
                "Zindiwa",
                "Zumbuku"
            ],
            "Ganjuwa": [
                "Badaromo",
                "Baben Kasa",
                "Barkaya",
                "Dagale",
                "Deno",
                "Digawa",
                "Dugumi",
                "Durm",
                "Gaboin Danfulani",
                "Gala",
                "Gali",
                "Ganjuwa",
                "Gasina",
                "Gingim",
                "Guadrsa",
                "Gungura",
                "Gurzumo",
                "Janu",
                "Jimbinb",
                "Kafin Luman",
                "Kafin Madaki",
                "Kariya",
                "Kasuwa",
                "Kawu",
                "Kubi",
                "Kumin",
                "Kuna",
                "Lafiya",
                "Lago to Gabas",
                "Lubu",
                "Miya",
                "Nassarawa",
                "Siri",
                "Siri Zuruuhu",
                "Tafawa",
                "Unguwan",
                "Yali"
            ],
            "Giade": [
                "Abdallawa",
                "Ahiyo",
                "Arama",
                "Bambal",
                "Bambiyo",
                "Baushe",
                "Bilkicheri",
                "Buzawa",
                "Dani",
                "Dingeri",
                "Dingashi",
                "Doguwa",
                "Faguji",
                "Galadimawa",
                "Gambara",
                "Gamsha",
                "Gandalima",
                "Ganduha",
                "Ganji",
                "Giade",
                "Gulbun",
                "Isawa",
                "Jarmawo",
                "Jawo",
                "Jugudu",
                "Kafata",
                "Kafin Hardo",
                "Kafin Jaji",
                "Katamba",
                "Kaya",
                "Korawa",
                "Kurba",
                "Lafia",
                "Madilmo",
                "Magarya",
                "Majiya",
                "Marai",
                "Margiri",
                "Mashema",
                "Mainari",
                "Sabon Sara",
                "Tagwaye",
                "Yalwa",
                "Yandure",
                "Zabi",
                "Zindiri",
                "Zirami",
                "Zum"
            ],
            "Jama'are": [
                "Abatalori",
                "Alayyi",
                "Arawa",
                "Baburti",
                "Baki",
                "Bambasa",
                "Boddorgel",
                "Bundiri",
                "Burdugel",
                "Dagahsi",
                "Dagelji",
                "Digiza",
                "Dogonjeji",
                "Dallah",
                "Fetere",
                "G/Babani",
                "Ganuwaji",
                "Garin Babani",
                "Galdimari",
                "Gidan Jauro Sabo",
                "Gongo",
                "Gudo",
                "Gundumi",
                "Hanafari",
                "Jabori",
                "Jafunawa",
                "Jahuno",
                "Jama'are",
                "Janburi",
                "Jogowel",
                "Joroga",
                "Jurara",
                "Kabegel",
                "Kamaku",
                "Kamaku East",
                "Katirje",
                "Kata-Kata",
                "Katsinawa",
                "Kayarda",
                "Kesuwo",
                "Kira",
                "Koyenti",
                "Kuduwo",
                "Kwandawa",
                "Kwankamari",
                "Lariye",
                "Mabai",
                "Mailemo",
                "Maimasheta",
                "Marmanji",
                "Memahefta",
                "Nafarga",
                "Nagelji",
                "N/A",
                "Pango",
                "Rarum",
                "Sabon Gari",
                "Sabon Kaffi",
                "Sabon-Kafi",
                "Sharaba",
                "Tuid",
                "Wamburum",
                "Yakashi",
                "Yangamai",
                "Yarimari",
                "Yola"
            ],
            "Katagum": [
                "Azare",
                "Azare Rural",
                "Barkeji",
                "Bidir",
                "Bulkachuwa",
                "Buskuri",
                "Busuri",
                "Chara-Chara",
                "Chinade",
                "Chinkani",
                "Dagaro",
                "Daramushe",
                "Dawo",
                "Dugunde",
                "Duhuwar",
                "Fatara",
                "Galado",
                "Gambaki",
                "Gangai",
                "Gafada",
                "Goronkawo",
                "Gwasamai",
                "Kachawun",
                "Konkoman",
                "Kujuru",
                "Lafiya",
                "Lariski",
                "Laimari",
                "Lugada",
                "Madachi",
                "Madara",
                "Madiri",
                "Magwamshi",
                "Masaku",
                "Ragwam",
                "Saleri",
                "Wuyum",
                "Yaba",
                "Yayu",
                "Yolawo",
                "Zindi"
            ],
            "Kirfi": [
                "Arawa",
                "Baba",
                "Badara",
                "Bage",
                "Bakginde",
                "Balla",
                "Bara",
                "Beni",
                "Boli",
                "Bure",
                "Cheledi",
                "Danonguza",
                "Dewu",
                "Gaka",
                "Garin Giwa",
                "Harda",
                "Hardo Bawa",
                "Jabba",
                "Jada",
                "Jimbum",
                "Kachiyeli",
                "Kadiya",
                "Kafin Iya",
                "Kafin Maigari",
                "Kalajanga",
                "Kalamboli",
                "Kaloma",
                "Kanawa",
                "Kilari",
                "Kirfi",
                "Kyesu",
                "Lafiya",
                "Shango",
                "Sherifuri",
                "Shongo",
                "Shugu",
                "Sunkani",
                "Taure",
                "Tubule",
                "Wanka",
                "Wuro Chitta",
                "Wuro Laila",
                "Wuro Soyo",
                "Zagaima"
            ],
            "Misau": [
                "Abbayaywo",
                "Aftaka",
                "Ajili",
                "Akuyam",
                "Arobana",
                "BadaKoshi",
                "Barmo",
                "BayaBanza",
                "Bayawo",
                "Beti",
                "Dagolanzai",
                "Dallari",
                "Danfisa",
                "Dolama",
                "DunkuiAmbi",
                "Dunkurmi",
                "DunkwiKasuwa",
                "Eldewo",
                "FarinRuwa",
                "Fulatan",
                "GainanFulani",
                "Galawa",
                "GarinBoyuwa",
                "GarinGaladimanSarma",
                "GarinHausa",
                "GarinMakera",
                "Gaudo",
                "Gwaram",
                "Hardawa",
                "Ishenu",
                "Jabaliya",
                "Jabdo",
                "Jabewo",
                "Jarkasa",
                "Jarmari",
                "Kachawun",
                "KafinSule",
                "KafinZaka",
                "Kalala",
                "Kamfata",
                "Kirindi",
                "Kwadari",
                "Kwaftara",
                "Madakiri",
                "RigarGaladima",
                "Sarma",
                "Tohu",
                "WuroBundu",
                "WuroDangogo",
                "Yelwa",
                "Zadawa",
                "Zindi"
            ],
            "Ningi": [
                "Agotama",
                "Agwarmaji",
                "Andarya",
                "Ari",
                "Bakori",
                "Bakutumbe",
                "Balma",
                "Batu",
                "Baure",
                "Bakin-Dyutse",
                "Barkono",
                "Bashe",
                "Bingin-Buta",
                "Bingi-Labo",
                "Bom",
                "Burra",
                "Buturi",
                "Dabar-Baga",
                "Dafara",
                "Dana",
                "Dangarafa",
                "Dankomi",
                "Deru",
                "Digawa",
                "Dingis",
                "Dogon-Maje",
                "Dogon-Ruwa",
                "Dubure",
                "Duwa",
                "Fatsali",
                "Gamadoro",
                "Ganji",
                "Gando",
                "Gidar-Baki",
                "Gongo",
                "Guda",
                "Gudar-Maiwa",
                "Gwandabi",
                "Gwada",
                "Gwam",
                "Halimbe",
                "Hardo-Bagare",
                "Hardo-Baso",
                "Hardo-Ori",
                "Hardo-Wako",
                "Hayin-Doka",
                "Iyayi",
                "Jar-Gaba",
                "Jata",
                "Jigawa",
                "Jimi",
                "Jirgagu",
                "Kajala",
                "Kafin-Chakuna",
                "Kafin-Lemo",
                "Kafin-Zaki",
                "Katsinawan-Danhayi",
                "Katsinawan-Dingis",
                "Katsinawan-Tabula",
                "Kawari",
                "Kayel",
                "Kongoro",
                "Kujera",
                "Kukuta",
                "Kuluki",
                "Kumba",
                "Kurmi",
                "Kwangi",
                "Kyana",
                "Limi",
                "Lumbu",
                "Luntun-Gabas",
                "Luntun-Yamma",
                "Madafa",
                "Marke",
                "Makanuwa",
                "Makera",
                "Malamawa",
                "Mara",
                "Masussuka",
                "Mazai",
                "Mulka",
                "Nahalo",
                "Nasaru",
                "Ningi",
                "Panna",
                "Parda",
                "Radina",
                "Rafin-Chiyawa",
                "Rafin-Dinya",
                "Rafin-Gora",
                "Rakajuwa",
                "Rakama",
                "Rumbu",
                "Rutai",
                "Ruwan-Dinya",
                "Ruwan-Kanki",
                "Ruwan-Maje",
                "Sabuwar-Kaura",
                "Sama",
                "Sharaf",
                "Shakaleme",
                "Shande",
                "Shuwaki",
                "Sunkuye",
                "Tajiya",
                "Tamba",
                "Takalafiya",
                "Takalafiyan-Balma",
                "Tashar-Maje",
                "Tashar-Mangoro",
                "Tefe-Tshohuwa",
                "Tiffi-Sabuwa",
                "Tilugu",
                "Tipchi",
                "Tsangayar-Madori",
                "Tsangayar-Marke",
                "Tsiro",
                "Tudun-Jarkoya",
                "UNG. Madaki",
                "UNG. Nabarma",
                "Unguwar Dabo",
                "Unguwar-Tudu",
                "Umuamievili",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umuenini",
                "Umuezeunu",
                "Umueleri",
                "Umuabia",
                "Umuoba",
                "Umu Udenze",
                "Umuleri",
                "Urualor",
                "Waya-Kawoka",
                "Yadagungume",
                "Yalwa",
                "Zakara",
                "Zalanga",
                "Zazika",
                "Zidanga",
                "Zuwi"
            ],
            "Shira": [
                "Adamami",
                "Adaha",
                "Alkaleri",
                "Alkasu",
                "Andubun",
                "Auyakari",
                "Bage",
                "Bakul",
                "Balijan",
                "Bangire",
                "Beli",
                "Bidis",
                "Bono",
                "Dalli",
                "Dango",
                "Dangwalu",
                "Darajiya",
                "Daramushe",
                "Disina",
                "Dogo Dutse",
                "Dushi",
                "Eldewo",
                "Faggo",
                "Fandi",
                "Galadimariyel",
                "Gallamari",
                "Gaza",
                "Ganuwa",
                "Goga",
                "Gwanawa",
                "Gurmun",
                "Isore",
                "Jabbari",
                "Jaka",
                "Jalkatari",
                "Kaigama",
                "Kakkaki",
                "Kamaku",
                "Kargo",
                "Kilbori",
                "Koli",
                "Kudawa",
                "Kungo",
                "Lafiya",
                "Lambu",
                "Madabi",
                "Malaji",
                "N/Tsafi",
                "Ribvawo",
                "Rimi",
                "Safuruje",
                "Sambawal",
                "Sambowal",
                "Sawi",
                "Shagogo",
                "Shatari",
                "Shinge",
                "Shira",
                "Suddu",
                "Tsafi",
                "Tumfafi",
                "Yalwa",
                "Yana",
                "Yarka",
                "Yakasai",
                "Zainabari",
                "Zamaga",
                "Zigau",
                "Zubo"
            ],
            "Tafawa Balewa": [
                "Boto",
                "Bununu",
                "Gabgell",
                "Jigi",
                "Kundum",
                "Lere",
                "Sara",
                "Sigidi",
                "Sudaye",
                "Timjim"
            ],
            "Toro": [
                "AnguwanKadiri",
                "AnguwanWaziri",
                "Balarabe",
                "Babajayi",
                "Badiko",
                "BakinKogi",
                "BakinRuwa",
                "BarganKanawa",
                "Baradawa",
                "Banginale",
                "BangonTama",
                "Bujiyel",
                "Bukka",
                "Chediya",
                "ChalinKanawa",
                "Dandore",
                "Dababe",
                "Deho",
                "Didim",
                "Diriko",
                "Dogonjeji",
                "DogonDutseMaje",
                "DurrKatanga",
                "Dawa",
                "Eziama",
                "FilaninKaba",
                "Fingel",
                "Fisha-share",
                "Galda",
                "Gani",
                "Ganda",
                "Garwa",
                "Gweljaule",
                "Gwakka",
                "Gwalfada",
                "Gumau",
                "GumauSanga",
                "Gudun",
                "Gurdum",
                "Gwadi",
                "Jajuwal",
                "Jama'a",
                "JarenBauchi",
                "Jimeri",
                "Jira",
                "Kalgo",
                "Karofi",
                "Kanyawaja",
                "KoginSallah",
                "Koseyal",
                "Kwaciyel",
                "Kwagga",
                "Madda",
                "Magama",
                "MagamaGari",
                "Mette",
                "MiyaBarkatai",
                "Mundu",
                "Muntsira",
                "Nando",
                "Narabi",
                "Nahuta",
                "NahutanTaba",
                "Natsirankawo",
                "Nneyi",
                "Nnadi",
                "Nisoye",
                "NsarawanSamanja",
                "Ogbu",
                "Ogugu-Etiti",
                "Ogwuari",
                "OkpaAgba",
                "Okpu",
                "Omuoch",
                "Ovu-Oke",
                "Palama",
                "Panshanu",
                "PolchinKasuwa",
                "Rauta",
                "Rahama",
                "RiminZayam",
                "Rishi",
                "RiriwanDalma",
                "Runtu",
                "SabonGarinNarabi",
                "SabonGarinTulu",
                "Samanja",
                "Sari",
                "Sauke",
                "Sunkuye",
                "Sutumi",
                "Takabundu",
                "Takandangiwa",
                "TashanMaiAllo",
                "TashanMaiTurare",
                "TashanMalamSale",
                "TasharDurumi",
                "Tilabarga",
                "TildenFulani",
                "Tilde",
                "TingiltinKanawa",
                "Tumu",
                "Tukurkuju",
                "Tulai",
                "Umuabia",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuoba",
                "UmuUdenze",
                "Umuezeunu",
                "Umuleri",
                "Urualor",
                "Wonu",
                "Wom",
                "Wundo",
                "Yakanaji",
                "YalwanBako",
                "YalwanDawani",
                "Yalta",
                "YelwanDallaji",
                "Zaranda",
                "ZariKwaiu",
                "ZariMaku",
                "Zigau",
                "Zull"
            ],
            "Warji": [
                "Aru",
                "Badiyaso",
                "Baima",
                "Dagu",
                "Dansai",
                "Dawatsi",
                "Disa",
                "Gabanga",
                "Ganji",
                "Ingila",
                "Katanga",
                "K/katanga",
                "Lirna'a",
                "Marasuwa",
                "Muda",
                "Rumba",
                "Shitako",
                "Sosaye",
                "Tudun Wada",
                "Tuya",
                "Warji",
                "Yayari",
                "Zurgwai"
            ],
            "Zaki": [
                "Aburbur",
                "Adamante",
                "Adishin",
                "Agoguma",
                "Agon",
                "Agusha",
                "Akeza",
                "Alagarno",
                "Alganari",
                "Alhajeri",
                "Amalewa",
                "Andama",
                "Anamo",
                "Ariri",
                "Asake",
                "Asurbun",
                "Atakuya",
                "Aishi",
                "Alangawari",
                "Alari",
                "Amar",
                "Mari",
                "Aririn",
                "Sakwa",
                "Babbadige",
                "Badagana",
                "Bagalu",
                "Bakari",
                "Bagam",
                "Bakatuma",
                "Balkiri",
                "Barnesu",
                "Barwari",
                "Barwarin",
                "Kudu",
                "Bima",
                "Bindiri",
                "Bulagana",
                "Bulturi",
                "Bursali",
                "Caldimari",
                "Chibiyayi",
                "Chirimari",
                "Cnacharam",
                "Dagumani",
                "Damewa",
                "Damodi",
                "Dasare",
                "Daya",
                "Disini",
                "Dudduru",
                "Dugumani",
                "Dukawa",
                "Dukkuri",
                "Daushe",
                "Daudiri",
                "Fagimari",
                "Fuchukuwa",
                "Fiyo",
                "Futti",
                "Gadai",
                "Gara",
                "Garin Gami",
                "Garin Malam",
                "Gasakakum",
                "Gatuma",
                "Gatashiya",
                "Gauya",
                "Gayambo",
                "Gaguimari",
                "Gujarma",
                "Gurka",
                "Gurara",
                "Gumai",
                "Jalkatari",
                "JamaAren",
                "Katagum",
                "Jujjin",
                "Juliahi",
                "Jumbori",
                "Jundu",
                "Jedde",
                "Jolga",
                "Kadabdu",
                "Kajawai",
                "Kadirawa",
                "Kafin Larabawa",
                "Kagummaje",
                "Kameme",
                "Kankaleri",
                "Kauneri",
                "Kirchubuwa",
                "Kizir",
                "Kore",
                "Mabbi",
                "Kuduban",
                "Kukawa",
                "Kwayamri",
                "Ladari",
                "Lodiyo",
                "Machanguwa",
                "Mai Kore",
                "Mainako",
                "Mainari",
                "Maiwa",
                "Makawa",
                "Makintari",
                "Maluri",
                "Manawaski",
                "Mandamari",
                "Masaje",
                "Migiya",
                "Mur-Mur",
                "Nduya",
                "Nisoye",
                "Nkwonando",
                "Rajuwa",
                "Ragwaram Dau",
                "Ragwaram Tankwali",
                "Sabakuwa",
                "Sabon Gari",
                "Sabon Garin Sakwa",
                "Sade",
                "Sandi Galau",
                "Santalmari",
                "Saradugum",
                "Sutuwa",
                "Talbarin Bare",
                "Talbarin Fulani",
                "Tatije",
                "Tello",
                "Tijjane",
                "Tabbasu",
                "Tadire",
                "Tagoyo",
                "Tashena",
                "Tikirje",
                "Tubsiga",
                "Turari",
                "Wareki",
                "Wasari",
                "Zango",
                "Zaratku",
                "Ziga",
                "Zinah",
                "Zainameri",
                "Zamaramari"
            ]
        }
    },
    {
        "Benue": {
            "Ado": [
                "Abakpa",
                "Abey",
                "Abisunya",
                "Achibila",
                "Adaboa",
                "Adochi",
                "Ai-Adaaka",
                "Ai-Amidu",
                "Ai-Agbo",
                "Ai-Ebiega",
                "Ai-Ogbola",
                "Ai-Onazi",
                "Ai-Oga",
                "Ai-Okpam",
                "Ai-Unazi",
                "Agbekpu",
                "Agila",
                "Agila New",
                "Agom",
                "Agwu",
                "Akpa Centre",
                "Akpoge",
                "Anjotsu",
                "Anmeta",
                "Atuolo",
                "Ayaga",
                "Ebera",
                "Efelo",
                "Efopfu",
                "Efoha",
                "Efofu",
                "Elikizi",
                "Enjoji",
                "Etenyi",
                "Ehaje",
                "Igbizi",
                "Igah",
                "Igedde",
                "Igumale",
                "Ijigbam",
                "Ijigboli",
                "Ijokoro",
                "Ikpeba",
                "Ikpole",
                "Ikpatene",
                "Ikpilogwu",
                "Izetse",
                "Ipole",
                "Izigban",
                "Ivetse",
                "Jalili",
                "Ndekma",
                "Ndogaba",
                "New Agila",
                "Obe",
                "Oda",
                "Ogbegbera",
                "Ogbilolo",
                "Ogbokwu",
                "Ogbee",
                "Ogongo",
                "Ogi",
                "Ogedegi",
                "Oglede",
                "Ojenyo",
                "Ojeba",
                "Ojije",
                "Okari",
                "Okonoji",
                "Okpudu",
                "Okpakor",
                "Okpatobo",
                "Okwo",
                "Olukpo",
                "Osabo",
                "Osiloko",
                "Osipi",
                "Osukpo",
                "Osudu",
                "Oturukpo",
                "Ote-Ogbeche",
                "Otokilo",
                "Opwa",
                "Royongo",
                "Rijo",
                "Udegu",
                "Udegu-Ai-Osa-Kpoma",
                "Udegu-Akpo",
                "Udebo-Ukwonyo",
                "Ukwonyo",
                "Unwege-Igba",
                "Unweje-Rijo",
                "Utonkon",
                "Ugbala",
                "Wunikpo",
                "Wurechi"
            ],
            "Agatu": [
                "Abalichi",
                "Abogbe",
                "Adagbo",
                "Adana",
                "Adum",
                "Agachu",
                "Agbaduma",
                "Aila",
                "Aiyele-Igaisu",
                "Akele",
                "Akolo",
                "Akpeko",
                "Akwu",
                "Ashama",
                "Atakpa",
                "Ayele",
                "Ebete",
                "Edeje",
                "Egba",
                "Egwuma",
                "Ekwo",
                "Elo",
                "Engla",
                "Enjima",
                "Enogaje",
                "Enugba",
                "Ichogolugwu",
                "Idahuna",
                "Igagisu",
                "Ikele-Gochi",
                "Ikpele",
                "Ikpole",
                "Obagaji",
                "Obanowa",
                "Odejo",
                "Ogam",
                "Ogbangede",
                "Ogbaulu",
                "Ogufa",
                "Ogwule-Kaduna",
                "Ogwule-Ugbaulu",
                "Ogwule-Ugbokpo",
                "Ogwumegbo",
                "Ojomachi",
                "Okeji",
                "Okokolo",
                "Okpachenyi",
                "Okpagabi",
                "Okpokoto",
                "Olegoga",
                "Olekochologba",
                "Olobidu",
                "Ologabulu",
                "Ologobenyi",
                "Olomachi",
                "Omokwodi-Edeje",
                "Onitsha",
                "Onugbo",
                "Oweto",
                "Ugba",
                "Ugboju-Ube",
                "Ukadu",
                "Usagbudu",
                "Usha",
                "Utugolugu"
            ],
            "Apa": [
                "Achaba",
                "Adija",
                "Ahija",
                "Ajube-Icho",
                "Ajugbe-Echaje",
                "Akpaniho",
                "Akpanta",
                "Akpete",
                "Akpoloko",
                "Alifeti",
                "Amoke",
                "Angwa",
                "Ankapli",
                "Auke",
                "Auke-Geri",
                "Bapa",
                "Ebukodo",
                "Edikwu-Icho",
                "Ekela",
                "Ibadum",
                "Idada",
                "Iga-Okpaya",
                "Iga-Ologbeche",
                "Igoro",
                "Ijaha",
                "Ijege",
                "Ikampu",
                "Ikobi",
                "Ikor",
                "Imana",
                "Inyapu",
                "Jericho",
                "Jos",
                "Kaduna",
                "Oba",
                "Obinda",
                "Obuleha",
                "Ochenmo",
                "Ochichi-Ologiri",
                "Ochinchi-Olaji",
                "Ochumekwu",
                "Odejo",
                "Ododo-Ajaje",
                "Odugbeho",
                "Odugbo",
                "Ofoko",
                "Ogbenegwu",
                "Ogbonoko",
                "Ogebe",
                "Ogodo",
                "Ogoduma",
                "Ohoke",
                "Oiji",
                "Ojantele",
                "Ojecho",
                "Ojeke",
                "Ojide",
                "Ojuloko",
                "Okpakachi",
                "Okpeme",
                "Okpoda",
                "Okpokwu",
                "Okwoho",
                "Okwuji",
                "Ola Kamonye",
                "Oladu",
                "Oleitodoakpa",
                "Olekele",
                "Olete",
                "Olobaidu",
                "Olodoga",
                "Ologba",
                "Oloja",
                "Olojo-Utukugwu",
                "Oloko-Angbo",
                "Olufene",
                "Omelemu",
                "Omogidi",
                "Opah",
                "Opanda",
                "Otakpa",
                "Oye",
                "Ukpogo",
                "Zauku"
            ],
            "Buruku": [
                "Abakwa",
                "Abor",
                "Abuku",
                "Adyongo",
                "Agbengi",
                "Agine",
                "Agwabi",
                "Agyo-Ugbu",
                "Akamara",
                "Akpara",
                "Akume",
                "Ako",
                "Aminde",
                "Amaa",
                "Anchiha",
                "Anongur",
                "Anshav",
                "Apinega",
                "Ashibi",
                "Ashinya",
                "Awange",
                "Awusa-Pila",
                "Ayunghitse",
                "Biliji",
                "Bako",
                "Bukufu",
                "Buruku",
                "Chijije",
                "Damkor",
                "Dogo",
                "Dzer",
                "Gbaja",
                "Gbanyam",
                "Gbelave",
                "Gbudu",
                "Garagboughul",
                "Garuba",
                "Haanya",
                "Igyu",
                "Ioricye",
                "Ityowanye",
                "Idyua",
                "Kur",
                "Kaimon",
                "Kwaghnihia",
                "Leghem",
                "Mbager",
                "Mbagen",
                "Mbatie",
                "M-Ulav",
                "Nkovul",
                "Nyamatsor",
                "Ortse",
                "Orahii",
                "Sev-Av",
                "Shie",
                "Shorov",
                "Shipine",
                "Sati",
                "Tabe",
                "Tavershima",
                "Tom-Ataan",
                "Tomanyiin",
                "Tomahar",
                "Tse-Abagi",
                "Tse-Adingi",
                "Tse-Akaa",
                "Tse-Gbile",
                "Tseyuna",
                "Tyogbenda",
                "Tyowanye",
                "Ugangese",
                "Upe",
                "Utur",
                "Uter",
                "Usen",
                "Wanvambe",
                "Zua"
            ],
            "Gboko": [
                "Adoom",
                "Akaajime",
                "Akawe",
                "Akpagher",
                "Amaladu",
                "Anema",
                "Anikyov",
                "Anyego",
                "Atonko",
                "Ayom",
                "Aumazwa",
                "Ador",
                "Agam",
                "Agbile",
                "Agom",
                "Akaa",
                "Ande",
                "Andoor",
                "Arua",
                "Atuur",
                "Apine-Mbamter",
                "Apeinumbu",
                "Asokwo",
                "Bunde",
                "Buter",
                "Byer",
                "Bya Bya",
                "Dio",
                "Dur",
                "Eoyum",
                "Ergum",
                "Feda-Atzetan",
                "Foga",
                "Genyi",
                "Gatie",
                "Gboko",
                "Gboko (Rural)",
                "Gwaza",
                "Gyase",
                "Hemen",
                "Ibyabya",
                "Ibyu-Yo",
                "Igbabjor",
                "Igbajor",
                "Igbesue",
                "Ikpa",
                "Ikpenger",
                "Ikumbul",
                "Ilungwa-Not",
                "Ikyuen",
                "Ipav",
                "Itungwa",
                "Jirkyegh",
                "Kankyer",
                "Kumugh",
                "Kukwa (Mba-Adumbe)",
                "Kyado",
                "Kyavel",
                "Lough",
                "Luga",
                "Makanan",
                "Mbaamandev",
                "Mbake",
                "Mbatiav",
                "Mbatierev",
                "Mbaluka",
                "Mbaniongo",
                "Mbatie",
                "Missa",
                "Mkar",
                "Mperigu",
                "Mkilim",
                "Naga",
                "Orpin Village",
                "Pika",
                "Shenge",
                "Songo",
                "Tarbo",
                "Tarkoo",
                "Tarukpe",
                "Tiv",
                "Tyavgar House",
                "Tyekwu",
                "Tyodugh",
                "Tse-Abo",
                "Tse-Ademate",
                "Tse-Akene",
                "Tse-Gatie",
                "Tse-Jor House",
                "Tse-Kagher",
                "Tse-Mkovur",
                "Tse-Orya",
                "Uga",
                "Ujon",
                "Uve",
                "Vamkyongo",
                "Woihyev",
                "Yandev"
            ],
            "Guma": [
                "Achakpa",
                "Anakuma",
                "Angudu",
                "Atawa",
                "Cheakiyne",
                "Daudu",
                "Gogo",
                "Gyushage",
                "Ichergbe",
                "Ijoh",
                "Ikoanenge",
                "Iye",
                "Jugudu",
                "Kaseyo",
                "Madaki",
                "Magum",
                "Mabaai",
                "Mbagwen",
                "Mbasaan",
                "Nyiev",
                "Nalegh",
                "Ortserga",
                "Peregh",
                "Sherev",
                "Talvough",
                "Toura",
                "Tse-Akenyi",
                "Tse-Tule",
                "Ubo",
                "Udei Branch",
                "Uikpam",
                "Umenger",
                "Uyiev",
                "Yelewatta",
                "Yeshewe",
                "Yogbo"
            ],
            "Gwer-East": [
                "Abafakyai",
                "Abiem",
                "Abinsi",
                "Acheche",
                "Achamegh",
                "Achav",
                "Achu",
                "Adetsav",
                "Aduku",
                "Adizenga",
                "Adum",
                "Agbakwa",
                "Agbede",
                "Agboveyav",
                "Agena",
                "Agute",
                "Agono",
                "Akawe",
                "Akume",
                "Ameche",
                "Aondoana",
                "Awasir",
                "Ayar",
                "Ayati",
                "Ayemegh",
                "Ayo Bajimba",
                "Boko",
                "Chia",
                "Dagi",
                "Deda",
                "Dogo",
                "Dura",
                "Eron",
                "Gbajimba",
                "Gbande",
                "Gbuka",
                "Gigi",
                "Howe",
                "Ikygbajir",
                "Ikpayongo",
                "Iyanden",
                "Jimba",
                "Kaahena",
                "Koti Akpoghur",
                "Kudar",
                "Kpam",
                "Kura",
                "Mba",
                "Mbaayande",
                "Mbaiyur",
                "Mbakaha",
                "Mbamev",
                "Mbajeri",
                "Mbasombo",
                "Moi-Igbo",
                "Mbe",
                "Mbaav Oju",
                "Nev",
                "Naka",
                "Ndom",
                "Noal",
                "Nougonoye",
                "Ode",
                "Okukukwu",
                "Orga",
                "Ortserga",
                "Raav",
                "Ringa",
                "Shaga",
                "Shanna",
                "Taraku",
                "Taraku Udugho",
                "Tesewadugh",
                "Tse-Kyula",
                "Tse-Ogbe",
                "Tse-Punusha",
                "Tse-Unzughul",
                "Tse-Ushira",
                "Tse-Vava",
                "Tsean",
                "Tseboaga",
                "Tseiko",
                "Tsejir",
                "Uche",
                "Udam",
                "Ugee",
                "Ugee-Ugee",
                "Ugesa",
                "Uhou",
                "Ukari",
                "Ukpar",
                "Ukpute",
                "Unende",
                "Usa",
                "Yonov",
                "Zauka"
            ],
            "Gwer-West": [
                "Abiah",
                "Adudu",
                "Agagbe",
                "Agasha",
                "Agberagba",
                "Agusu",
                "Anyamile",
                "Api",
                "Audu",
                "Avine",
                "Azon",
                "Borkem",
                "Byer",
                "Chile",
                "Enyer",
                "Ewo",
                "Gbanya",
                "Gebe",
                "Go",
                "Ibor",
                "Ichicadu",
                "Ikyande",
                "Inougu",
                "Mabaiev",
                "Mabchia",
                "Mandaki",
                "Nugi",
                "Senjev",
                "Tongov",
                "Tse-Ogbe",
                "Tse-Tor",
                "Tyoatee",
                "Tyulen",
                "Ududu",
                "Yagba",
                "Yueho",
                "Zekukwu",
                "Ukpute",
                "Ullaim-Ulam"
            ],
            "Katsina-Ala": [
                "Borikyo",
                "Gbise",
                "Katsina Ala",
                "Mbatula/Mberev",
                "Mbayongo",
                "Tse-Bente",
                "Utange",
                "Yooyo"
            ],
            "Konshisha": [
                "Aba",
                "Abagi",
                "Achoho",
                "Aduu",
                "Agen",
                "Agera",
                "Agerega",
                "Agheede",
                "Agidi",
                "Akesa",
                "Akputu",
                "Amule",
                "Ankaaye",
                "Atingel",
                "Atorkaan",
                "Awajir",
                "Awuhe",
                "Ayeer",
                "Azem",
                "Bonta",
                "Chia",
                "Deke",
                "Dio",
                "Gbajema",
                "Gbende",
                "Gboho",
                "IchighkiMbakaha",
                "Igbor",
                "Iger",
                "IjovIkundan",
                "IkuMbur",
                "Ikyon",
                "Ityogbeda",
                "Jov",
                "Kuaa",
                "Ligon",
                "Manta",
                "Mbaakpur",
                "Mbaikyu",
                "Mbeagh",
                "Nalegh",
                "Nenge",
                "Ortungu",
                "Selagi",
                "Shiriki",
                "Shom",
                "Talvough",
                "Tile",
                "TorMkar",
                "TseAgberagba",
                "Tsue",
                "TyoTsar",
                "Tyoate",
                "Tyough",
                "Uavaande",
                "Ugbaikyo",
                "Unow",
                "YaAkur",
                "Yande",
                "Yogbo"
            ],
            "Kwande": [
                "Achia",
                "Adagi",
                "Adikpo",
                "Ahile",
                "Ahundu",
                "Ageraga",
                "Ajio",
                "Akende",
                "Angir",
                "Anatio",
                "Anwase",
                "Atsortjaki",
                "Ayaga",
                "Barakur",
                "Boagundu",
                "Dio",
                "Gbajur",
                "Geso",
                "Gever",
                "Gube",
                "Haanya",
                "Ichor",
                "Igon",
                "Ikume",
                "Ikurav-Ya",
                "Ikyogen",
                "Injiov",
                "Inundur",
                "Iyon",
                "Iyon-Mbahav",
                "Ityough",
                "Jato-Aka",
                "Kanem",
                "Kende",
                "Kookoko",
                "Kuhe",
                "Mbangough",
                "Mbakuran",
                "Mbaga",
                "Nambe",
                "Nanev",
                "Newkkikie",
                "Nyihemba",
                "Shangev-Ya",
                "Susu",
                "Tise-Kwange",
                "Tse-Apera",
                "Tse-Gum-Mbayevikyaior",
                "Tse-Zurgba",
                "Turan",
                "Uno",
                "Upev-Adagi",
                "Uniwach",
                "Waya",
                "Yaji",
                "Yonge",
                "Zel"
            ],
            "Ogbadibo": [
                "Aba",
                "Abache",
                "Adu",
                "Agbafu",
                "Agira",
                "Ago",
                "Aikwu",
                "Akpagidigbo",
                "Alagiranu",
                "Alagarunu",
                "Amejo",
                "Anchimodo",
                "Ankpa",
                "Annachowga",
                "Aoiu",
                "Ati",
                "Atamaka",
                "Court-Otukpa",
                "Ai-Ona",
                "Aifam-Centre",
                "Aije",
                "Ebari",
                "Ebanna",
                "Ebela",
                "Ede",
                "Efeche",
                "Efekwo",
                "Effion",
                "Efocho",
                "Efugo",
                "Eha-Otukpa",
                "Eha-Uleke",
                "Ehicho",
                "Ehuhu",
                "Ejaa",
                "Ejema",
                "Ejule",
                "Eke",
                "Eke-Ai",
                "Eke-Akpa",
                "Eke-Ekwute",
                "Elugu",
                "Epe-Agbo",
                "Epeilo",
                "Epeilo-Ikpoyi",
                "Epige",
                "Eru",
                "Eyere",
                "Eyupi",
                "Ibagba",
                "Ibiladu",
                "Iga-Uroko",
                "Ikemu",
                "Ikregi",
                "Ipichicha",
                "Ipiga",
                "Ipole",
                "Ipole-Adupi",
                "Ipole-Aifam",
                "Ipole-Ako",
                "Ipole-Ekere",
                "Ipole-Iyiru",
                "Ipole-Oko",
                "Ipole-Owukpa",
                "Ipu-Ugbogbo",
                "Ipuchicha",
                "Iwewe",
                "Iwewe-Aiodu",
                "Idede",
                "Idiri",
                "Idodoloko",
                "Ijadoja",
                "Idogobe",
                "Ipari",
                "Imeyi",
                "Inoma",
                "Irubi",
                "Itesi",
                "Iton",
                "Oda",
                "Odoba",
                "Odwebe",
                "Ofejo",
                "Obenda",
                "Obu",
                "Ogbata",
                "Ogaje",
                "Ogbonoko",
                "Ogene",
                "Ogichigodi",
                "Ogonkwu",
                "Ogwurute",
                "Ogwurutee",
                "Okoncheta",
                "Okpoto",
                "Okpudu",
                "Olamago",
                "Olachagbaha",
                "Oladu",
                "Olaigbena",
                "Ole-Igwu",
                "Oleche",
                "Olempe-Ogicho",
                "Onchegbi",
                "Onyirada",
                "Oto",
                "Oture",
                "Otukpa",
                "Owoso",
                "Owukpa",
                "Owuruwuru",
                "Ubafu",
                "Ubenjira",
                "Ubono",
                "Ugbamaka",
                "Ugbogidi",
                "Ugbogwu",
                "Ugbokpo",
                "Ukalegwu",
                "Ukalegu-Igwu",
                "Ukporo",
                "Ukwo",
                "Umafu",
                "Umarichi",
                "Umuamievili",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuabia",
                "Umuoba",
                "Umu Udenze",
                "Umuezeunu",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor",
                "Zaria"
            ],
            "Oju": [
                "Abelega",
                "Abofutu",
                "Adodo",
                "Adum",
                "Adum-East",
                "Adum-West",
                "Ainu-Ette",
                "Akiraba",
                "Akunda",
                "Ameka",
                "Anchim",
                "Andibilla",
                "Anyadegwu",
                "Any-Oko",
                "Anyagwu",
                "Anyichika",
                "Anyuwogbu",
                "Atekpe",
                "Adiko",
                "Adega",
                "Alloma",
                "Anchiomodoma",
                "Anwu",
                "Arigede",
                "Ayoye",
                "Ebenda",
                "Ebong-Itogo",
                "Echoro",
                "Eewu",
                "Ega",
                "Ekpete",
                "Ekoti",
                "Ekpong",
                "Enugu-Oye",
                "Enurn",
                "Esewa",
                "Ekingo",
                "Eziagulu",
                "Eziama",
                "Eziafor",
                "Ibalakum",
                "Ibegi",
                "Igbella",
                "Igbegi",
                "Igbilla",
                "Ichacho",
                "Ichakobe",
                "Idajo",
                "Ihulam",
                "Ikachi",
                "Ikandiye",
                "Ikiriye",
                "Ikonyine",
                "Ikponyine",
                "Inyuma",
                "Ipinu-Adiko",
                "Irachi",
                "Itafor",
                "Itakeni",
                "Itakpa",
                "Ito",
                "Itogo",
                "Iyaho",
                "Iyator",
                "Iyokolo",
                "Oba",
                "Obaogede",
                "Obachita",
                "Obene",
                "Obigago",
                "Obigwe",
                "Obijegwu",
                "Obiladun",
                "Obohu",
                "Obotu",
                "Obubu",
                "Obuza",
                "Ochimode",
                "Ochodu",
                "Odeleko",
                "Odiapa",
                "Ogaka",
                "Ogede",
                "Ogilewu-Itogo",
                "Ogoro",
                "Ogwope",
                "Ogugu-Etiti",
                "Ogbu",
                "Ogwuari",
                "Ohio",
                "Ohirigwe",
                "Ohoho",
                "Ohuma",
                "Ohuye",
                "Okakongo",
                "Okete",
                "Okileme",
                "Okonche",
                "Okpokwu",
                "Okpoma",
                "Okpirikwu",
                "Okpirikwu-Adum",
                "Okukukwu",
                "Okuntegbe",
                "Olumbanasa",
                "Omope",
                "Onyike",
                "Opoan",
                "Orihi",
                "Oshirigwe",
                "Otakini",
                "Otakpi",
                "Otukpo-Oye",
                "Otunche",
                "Owori-Obotu",
                "Owori-Ipinu",
                "Oyiwo",
                "Ubeke",
                "Ubele",
                "Uda",
                "Udebor",
                "Udogwu",
                "Uje",
                "Ugbodom",
                "Ugburu",
                "Ukpa",
                "Ukpileru",
                "Ukpute",
                "Umoda",
                "Utabiji",
                "Utugboji",
                "Yeshewe"
            ],
            "Okpokwu": [
                "A-Adabulu",
                "Adiga",
                "Adiga-Oyira",
                "Agamud",
                "Agbangwe",
                "Agila-Oladikwu",
                "Ai-Anechi",
                "Aiagom",
                "Aiede",
                "Akaga",
                "Akpakpa",
                "Akpitodo-Akpaya",
                "Akpodo",
                "Akpuneje",
                "Alaglanu",
                "Amafu",
                "Amodu",
                "Amuja",
                "Aokete",
                "Aokpaneg",
                "Aokpasu",
                "Aokpe",
                "Atekpo",
                "Ebodahubi",
                "Edkeajio",
                "Efede-Aoi",
                "Efffa",
                "Effion",
                "Efoyo",
                "Ejaa",
                "Edumoga",
                "Ejema",
                "Ekenobi",
                "Engle",
                "Gapo",
                "Ichama",
                "Ichana",
                "Ijele",
                "Ijeha",
                "Ipole-Aiagbo",
                "Ipole-Aiebega",
                "Ipole-Aikpe",
                "Ipole-Aiona",
                "Ipoya",
                "Iwewe",
                "Iwewe-Ichama",
                "Laionyes",
                "Oladegbo",
                "Olago",
                "Olaidu",
                "Olaioleje",
                "Olanyega",
                "Oloayidu",
                "Oma",
                "Agado",
                "Obotu-Ehaje",
                "Obotu-Icho",
                "Obulu",
                "Ode-Sasa",
                "Odaba",
                "Odokpo",
                "Oduda",
                "Ogblega",
                "Ogblo",
                "Ogbodo",
                "Ogbaga",
                "Ogene",
                "Ogodum",
                "Ogomotu",
                "Ogwuche-Akpa",
                "Ojago",
                "Ojapo",
                "Ojocha",
                "Okadoga",
                "Okga-Ogodo",
                "Okpafie",
                "Okpale",
                "Okpale-Ota",
                "Okpilioho",
                "Okpolikpo-Ehaje",
                "Omolokpo",
                "Omusu",
                "Opidlo",
                "Opioli",
                "Otada-Otutu",
                "Otobi",
                "Ugbokolo",
                "Ugbokpo"
            ],
            "Otukpo": [
                "Abach",
                "Adoka",
                "Aibeli",
                "Aichene",
                "Aikolekwu",
                "Aiobiduwa",
                "Ajochoko",
                "Alyeya",
                "Anineju",
                "Aukpa",
                "Aune",
                "Ebologba",
                "Edikwu",
                "Efa",
                "Emichi",
                "Ebolo",
                "Efeyi",
                "Efeyi-Ankpa",
                "Efeyi-Igbanonaje",
                "Efeyi-Ipole",
                "Ekantili",
                "Eko",
                "Ife",
                "Ifete",
                "Ifete-Nkenu",
                "Igbanonaje",
                "Igbelu",
                "Ijigbeli",
                "Ikobi",
                "Inokya",
                "Ipogu",
                "Ipole",
                "Itodo",
                "Izomu",
                "Izowi",
                "Ochia-Ebola",
                "Ochina-Akpa",
                "Ochipu",
                "Oda",
                "Odedi",
                "Ode-Ugbo",
                "Ogodu",
                "Ogosho",
                "Okoliko",
                "Okpu-Echira",
                "Okpu-Enane",
                "Okpu-Enaye",
                "Okpu-Obetu",
                "Okpu-Obi",
                "Okpu-Ogochi",
                "Okpu-Ote",
                "Okpui-Ogbodi",
                "Okpui-Obetu",
                "Okpui-Obi",
                "Okpui-Otuluhio",
                "Omachi",
                "Onda",
                "Onda-Ikpoto",
                "Onogwu",
                "Onyaga",
                "Otoba",
                "Otor",
                "Otu",
                "Otulu",
                "Otume",
                "Ugbilo",
                "Ugbokpo",
                "Ugbokpo-Ankpa",
                "Ugbokpo-Ebola",
                "Ugbokpo-Ikobi",
                "Ugboro",
                "Uga",
                "Ubokpo",
                "Ugbokpoga",
                "Ugbokpo-Odo",
                "Ugbokpo-Ogba",
                "Ugbokpo-Ogbochi",
                "Ugbokpo-Ofobo",
                "Ugbokpo-Onu-Egbe",
                "Ugbokpo-Onu-Ula",
                "Ugbokpo-Orikpo",
                "Ugbokpo-Ota",
                "Ugbokpo-Ula",
                "Ugbokpo-Umu",
                "Ughele",
                "Ula",
                "Umomi"
            ],
            "Logo": [
                "Aba",
                "Abaji",
                "Abako",
                "Abeda",
                "Abeda-Mbadyu",
                "Abega",
                "Adam",
                "Ada",
                "Ada-Ayaijor",
                "Adi Village",
                "Agahyande",
                "Agbaaye",
                "Agber",
                "Aganyi",
                "Agu-Centre",
                "Akai",
                "Akella",
                "Akegi",
                "Akamanator",
                "Akata",
                "Akpalagbo",
                "Amagu",
                "Amuawor",
                "Amaunu",
                "Amatso",
                "Amuleri",
                "Aniekwem",
                "Ankum",
                "Anongo",
                "Anyibe",
                "Anyom",
                "Apeghan",
                "Apir",
                "Atakol",
                "Atumbir",
                "Azege",
                "Ayilamo",
                "Ayua",
                "Ayati",
                "Branch-Adamu",
                "Branch-Kungu",
                "Chenchenji",
                "Dooshima",
                "Dyom",
                "Enugu",
                "Enugu-Otu",
                "Eziagulu",
                "Eziagulu-Otu",
                "Eziama",
                "Eziafor",
                "Gabaaye",
                "Gbagir",
                "Gbena",
                "Gbise",
                "Gbor",
                "Gede",
                "Gonduzua",
                "Goyuse",
                "Gudu",
                "Harga",
                "Hindanigo",
                "Hiitom",
                "Ikpool",
                "Ikyeagba",
                "Imande",
                "Imande-Mbakange",
                "Imande Mbashonov",
                "Imbufu",
                "Inoma",
                "Isiokwe",
                "Ivite",
                "Ityogbenda",
                "Jiji",
                "Jootar",
                "Katsina-Ala",
                "Kera",
                "Kenvanger",
                "Kasar",
                "Kumban",
                "Kyob",
                "Kyuran-Tev",
                "Mbak Akpan Ekpenyong",
                "Mbak Ikot Abasi",
                "Mbak Ikot-Ebo",
                "Mbiabong Ikot-Antem",
                "Mbiabong Ikot",
                "Miabong",
                "Moze",
                "Mough",
                "Mugh",
                "Mbaamamdev",
                "Mboza",
                "Nando",
                "Nneyi",
                "Nnadi",
                "Nisoye",
                "Nkwonando",
                "Nigbo",
                "Ngenev",
                "Ngibo",
                "Ngokem",
                "Nto Okon Ikot-Obio",
                "Nkek",
                "Nkek Abak",
                "Nsekhe",
                "OkpaAgba",
                "Okpu",
                "Omuoma",
                "Omuoma-Ekam",
                "Otuocha",
                "Owaloka",
                "Ovu-Oke",
                "Peva",
                "Pevkyaa",
                "Sai",
                "Sati-Agirigi",
                "Shina",
                "Solozo",
                "Sonko",
                "Tacha",
                "Time-Kyura",
                "Tongov",
                "Tor-Donga",
                "Torov",
                "Tse-Achir",
                "Tse-Adogo",
                "Tse-Amaatimin",
                "Tse-Amachigh",
                "Tse-Ami",
                "Tse-Anam",
                "Tse-Ansambe",
                "Tse-Asongo",
                "Tse-Baim",
                "Tse-Bente",
                "Tse-Bosua",
                "Tse-Bwaja",
                "Tse-Chehia",
                "Tse-Chembe",
                "Tse-De",
                "Tse-Gber",
                "Tse-Hungwa",
                "Tse-Hyambe",
                "Tse-Ibo",
                "Tse-Ighur",
                "Tse-Jime",
                "Tse-Kur",
                "Tse-Kyal",
                "Tse-Mayange",
                "Tse-Makar",
                "Tse-Melapa",
                "Tse-Ngbian",
                "Tse-Nyigh",
                "Tse-Pahal",
                "Tse-Taava",
                "Tse-Tsongo",
                "Tse-Tswar",
                "Tse-Ugbar",
                "Tse-Ukeji",
                "Tse-Usha",
                "Tse-Vav",
                "Tse-Waakaa",
                "Tse-Wande",
                "Tse-Uken",
                "Tse-Avy",
                "Tse-Agakaa",
                "Tse-Agbumgu",
                "Tse-Agkpa",
                "Tse-Alabor",
                "Tse-Aluor",
                "Tse-Alam",
                "Tse-Bavel",
                "Tse-Gyuba",
                "Tse-Kyaya",
                "Tse-Orbunde",
                "Tse-Orkpen",
                "Tse-Tzenger",
                "Ukor",
                "Uke",
                "Umuabia",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuoba",
                "Umu Udenze",
                "Umuezeunu",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor",
                "Uzoa",
                "Uzora",
                "Vingir",
                "Wende",
                "Wendeya Tza",
                "Yomatar",
                "Zaki-Biam",
                "Zanzan"
            ],
            "Makurdi": [
                "Ada",
                "Agan",
                "Ajia",
                "Ajibaji",
                "Ajoraku",
                "Akiki",
                "Akil",
                "Akondonyou",
                "Akume",
                "Alabusa",
                "Anjogh",
                "Antsa",
                "Asamakaha",
                "Asuir",
                "Ataata",
                "Baba",
                "Chavkar",
                "Chia",
                "Fildi",
                "Gaval",
                "Hange",
                "Hembe",
                "High Level",
                "Iganden",
                "Ihyew",
                "Ikpaam",
                "Iyorkyaa",
                "Iyortyer",
                "Jabela",
                "Kanshio",
                "Kaver",
                "Kpughuur",
                "Kubeli",
                "Kurkyor",
                "Kwabo",
                "Kyaan",
                "Kyambe",
                "Makurdi",
                "Makurdi North",
                "Marondu",
                "Mbalagh",
                "Modern Market",
                "North Bank",
                "Nyikua",
                "Nyili",
                "Nyiti",
                "Ogoh",
                "River Ahum",
                "River Ake",
                "River Aso",
                "River Baa",
                "River Fete",
                "River Kbege",
                "River Kereke",
                "Sekonyi",
                "Shawon",
                "Stasungu",
                "Swam",
                "Township",
                "Tse Aba",
                "Tse Poor",
                "Tsechia",
                "Tsegbam",
                "Tsegbayi",
                "Tsekom",
                "Tsuwa",
                "Tyogben",
                "Ude",
                "Uga",
                "Ute",
                "Utenger",
                "Wailomayo",
                "Wurukum",
                "Yaro Caro",
                "Youngu"
            ],
            "Tarka": [
                "Akoodo",
                "Akpa-Agudo",
                "Akpa-Ambajir",
                "Amo",
                "Asukunya",
                "Chia",
                "Iche Amazwa",
                "Jingir",
                "Kamken",
                "Mbakor",
                "Nyambee",
                "Tarhembe",
                "Tasbo",
                "Uchi",
                "Ukyo",
                "Uku",
                "Wannune",
                "Zango-Wannune"
            ],
            "Ukum": [
                "Afia",
                "Amuta",
                "Gbeji",
                "Gyenku",
                "Korwua",
                "Agbatar",
                "Tse-Abenga",
                "Tse-Abuul",
                "Tse-Aliutse",
                "Tse-Anchagbel",
                "Tse-Anonogo",
                "Tse-Atsanga",
                "Tse-Ayali",
                "Tse-Azawe",
                "Tse-Choko",
                "Tse-Goji",
                "Tse-Gube",
                "Tse-Kulevbe",
                "Tse-Kyenge",
                "Tse-Mela",
                "Tse-Oryango",
                "Tse-Truga",
                "Tse-Tyondo",
                "Tse-Ukende",
                "Vaase"
            ],
            "Ushongo": [
                "Akerior",
                "Abayol",
                "Abuul",
                "Achuura",
                "Adeeger",
                "Adiga",
                "Adikipo",
                "Agbuudu",
                "Agoyo",
                "Akile",
                "Akoko",
                "Alu",
                "Ameraga",
                "Antiev",
                "Antyu",
                "Atuuku",
                "Banji",
                "Bage",
                "Ber-Agbum",
                "Boikyaa",
                "Boor",
                "Buter",
                "Chubu",
                "Danji",
                "Dughen",
                "Fiuji",
                "Ge-Mbayem",
                "Gege",
                "Gbatse",
                "Goge",
                "Hiiton",
                "Hegha",
                "Igbee",
                "Igbor",
                "Ikyobo",
                "Ikyô-Azande",
                "Ikov",
                "Ikpakpam",
                "Korinjo",
                "Kwabula",
                "Laadi",
                "Lessel",
                "Madugwu",
                "Manor",
                "Mbagba",
                "Mbaikyaa",
                "Moti",
                "Msa",
                "Mtsenan",
                "Nor",
                "Posu",
                "Sati",
                "Tema",
                "Terna",
                "Tse-Abada",
                "Tse-Gbande",
                "Tse-Gbinde",
                "Tse-Nyagba",
                "Tse-Pan-Anum",
                "Tsedum",
                "Tuamade",
                "Tzongahar",
                "Uazande",
                "Ude",
                "Uga",
                "Ugondo",
                "Uso",
                "Ushongo",
                "Utange",
                "Waapera",
                "Wajir",
                "Wuha",
                "Yaji",
                "Yam",
                "Yese"
            ],
            "Vandeikya": [
                "Abaki",
                "Abwa",
                "Achwa",
                "Adamgbe",
                "Adeiyongo",
                "Agende",
                "Agidi-Mbakena",
                "Agirgba",
                "Agu",
                "AkoAbwa",
                "Akofate",
                "Alagh-Ngulum",
                "Alakali",
                "Ankar",
                "Anongo",
                "AnzaTokuyo",
                "Atayo",
                "Agera",
                "Betse",
                "Bako",
                "BranchAtser",
                "Change",
                "Dagba",
                "Dav",
                "Gbagbongom",
                "Gbe",
                "Gbegba",
                "Gorkem",
                "Gube",
                "Guda",
                "Hembe",
                "Igbee",
                "Ihugh",
                "Ivenge",
                "Kaamem",
                "Kiishi",
                "Korinya",
                "Koti-Yough",
                "Kpamor",
                "Labe",
                "LijamMue",
                "Mandun",
                "Mbaakon",
                "Mbaka-Ange",
                "Mbaduku",
                "Mbagbera",
                "Mbara",
                "Mbayongo",
                "Mede",
                "Mingev",
                "Moji",
                "Naa",
                "Ndete",
                "Nyaro",
                "Nor-Gemaityo",
                "Pev",
                "Sambe",
                "Sati",
                "Shangbum",
                "Shan",
                "Tsambe",
                "Taatihi",
                "Timbir",
                "Tse-Amough",
                "Tse-Anshungu",
                "Tse-Atuul",
                "Tse-Dabo",
                "Tse-Gedege",
                "Tse-Isua",
                "Tse-Ji",
                "Tse-KaseNor",
                "Tse-Kpum",
                "Tse-Mker",
                "Tse-Nduul",
                "Tse-Sho",
                "Tse-Wande",
                "Tyemimongo",
                "Uka",
                "Uganden",
                "Ute",
                "Vandeikya",
                "Yaaya"
            ]
        }
    },
    {
        "Borno": {
            "Abadam": [
                "Abadam",
                "Arege",
                "Banuwa",
                "Bisku",
                "Bisogana",
                "Dareche",
                "Fuguwa",
                "Jabulani",
                "Karinowa",
                "Kudokurgu",
                "Lariski",
                "Mallamfatori",
                "Metele",
                "Yau",
                "Yawa-Kura",
                "Yituwa"
            ],
            "Askira/Uba": [
                "Askira",
                "Bagiau",
                "Chul",
                "Dille",
                "Dum Bam",
                "Gegombi",
                "Giwa Kir Koma",
                "Gwahi",
                "Huyum",
                "Jimbulumu",
                "Kauthlama",
                "Kuhi",
                "Lassa",
                "Malka Dini",
                "Mughal",
                "Njoma",
                "Thulbwa",
                "Uba",
                "Uvu",
                "Uwotaku",
                "Yimirali",
                "Yimurgo"
            ],
            "Bama": [
                "Abbaram",
                "Alhajiri",
                "Amchaka",
                "Bagumari",
                "Bakara",
                "Bama",
                "Banki",
                "Barki",
                "Batra",
                "Borwashe",
                "Buduwa",
                "Bulamanga",
                "Bulongu",
                "Bula Umar",
                "Burguma",
                "Burari",
                "Chachile",
                "Dara",
                "Darai",
                "Dar-el Jamal",
                "Dipchari",
                "Dusuwa",
                "Ghongolo",
                "Goniri",
                "Guluma",
                "Gulumba",
                "Gulumba-Gana",
                "Hausari",
                "Iza",
                "Jaburi",
                "Jakkure",
                "Jandiri",
                "Jeree",
                "Jinner",
                "Jumeili",
                "Kajeri",
                "Kashimiri",
                "Kash-kash",
                "Kasugula",
                "Kote",
                "Kotenbe",
                "Kumshe",
                "Kutila",
                "Mala Ajiri",
                "Malam-Koriri",
                "Malge",
                "Malum Mustari",
                "Marka",
                "Maksomari",
                "Mairi",
                "Mbuliya",
                "Modileyegoru",
                "M. Mastari",
                "Ndire",
                "Ndobe",
                "Ndoria",
                "Ngureri",
                "Ngurosoye",
                "Said",
                "Shehuri",
                "Sir Ajaa",
                "Soye",
                "Tandari",
                "Tarmuwa Kura",
                "Walasa",
                "Wnilibari",
                "Woloji",
                "Yarwa",
                "Yabiri",
                "Yabiri Gana",
                "Yabiri Kura",
                "Yawe",
                "Zangeri"
            ],
            "Bayo": [
                "Balbaya",
                "Bera Fulani",
                "Briyel",
                "Bulama Kabi",
                "Chamgum",
                "Dagon Zaga",
                "Dawal",
                "Fikayah",
                "Gadaba",
                "Gaidam",
                "Gama dadi",
                "Garun Gado",
                "Gedaba",
                "Gubeli",
                "Guburunde",
                "Gumjara",
                "Hara-Guwal",
                "Jara Bah",
                "Jara Guwal",
                "Jauro Garga",
                "Kabara",
                "Kanawa",
                "Karko",
                "Kukal",
                "Laro",
                "Limanti",
                "Maduya",
                "Maina Baba",
                "Nyawi",
                "Sakdiya",
                "Tale",
                "Tashan Itashe",
                "Tashan tsamiya",
                "Tenteni",
                "Tundun Wada",
                "Wuyo",
                "Yababa",
                "Yarda",
                "Zange",
                "Zara"
            ],
            "Biu": [
                "Alagarno",
                "Bam",
                "Berum",
                "Birma Jugwal",
                "Biu",
                "Biu central",
                "Biu east",
                "Bowa",
                "Brikuthi",
                "Burashika",
                "Buratai",
                "Chara",
                "Chukwarzir",
                "Dadinkowa",
                "Dam",
                "Diwar",
                "Dugja",
                "Duzuma",
                "Filin Jirgi",
                "Galabinda",
                "Galdimari",
                "Garu Pirsina",
                "Garubula",
                "Garwashina",
                "Gashua",
                "Ghuma",
                "Guma",
                "Gunda",
                "Gur",
                "Gur Lawan",
                "Gwaram",
                "Helma Jibir",
                "Jalingo",
                "Kabura",
                "Kampala",
                "Kamuya",
                "Kenken",
                "Kimba",
                "Kurnari",
                "Maiduguri",
                "Mainahari",
                "Mandara Abdu I",
                "Mandara Abdu II",
                "Mandaragrau",
                "Manda Fumwa",
                "Mangada",
                "Mbula Kivi",
                "Mbulamel",
                "Miringa",
                "Nassarawa",
                "Njibi",
                "Ngrum",
                "Ntzukuku",
                "Palma",
                "Panana",
                "Piku",
                "Pompamari",
                "Shuwari",
                "Sulumithla",
                "Tabra",
                "Tashan Danfulani",
                "Tum",
                "Vinkuthla",
                "Waka",
                "Warawara",
                "Yamarkumi",
                "Yamir Pilasar",
                "Ya Adam",
                "Yarda",
                "Yawi",
                "Zara Diza",
                "Zara Kwara",
                "Zara Minnga",
                "Zara Wuyaku",
                "Zira"
            ],
            "Chibok": [
                "Bwalagyang",
                "Chibok",
                "Forfor",
                "Garu",
                "Gatamwarwa",
                "Kautikare",
                "Kautikari",
                "Korogillum",
                "Korogillum A",
                "Kuburmbula",
                "Mbalala A",
                "Mbalala B",
                "Mboa-Kura",
                "Piyemi",
                "Shikarikir A",
                "Shikarikir B",
                "Whuntaku"
            ],
            "Damboa": [
                "Abulam",
                "Adika",
                "Ajigin",
                "Ajigi Bulabulin",
                "Ajigin Mairi",
                "Auma",
                "Azur",
                "Ba' ale",
                "Bego",
                "Burum",
                "Burun kauji",
                "Chiralia",
                "Damboa",
                "Dusula",
                "Forfor",
                "Garjang",
                "Gazama Bori",
                "Gazama kura",
                "Golgi",
                "Gorgore",
                "Gorgube",
                "Gumsuri",
                "Gwange",
                "Izzge",
                "Jamyeri",
                "Kachallaburari",
                "Kafa",
                "Kalla",
                "Kauji",
                "Kaushirowa",
                "Kawaram",
                "Kaya",
                "Kinzagiraji",
                "Kobchi",
                "Koljiri",
                "Korede",
                "Kuboa",
                "Kuburivu",
                "Ma tangile",
                "Mafi",
                "Maisaimar",
                "Malaharam",
                "Malemiri",
                "Malumti",
                "Mangubum",
                "Misa-Kurbudu",
                "Molgoi",
                "Mugula",
                "Multe",
                "Ndoksa",
                "Ngirnn",
                "Ngwalimiri",
                "Njaba",
                "Nzuda",
                "Sabon Gari",
                "Shettima - Abogu",
                "Shiwari-Kura",
                "Talala - Buba-Modu",
                "Talala-Buba-Ali",
                "Wajirako",
                "Wawa",
                "Wovi",
                "Wuyaram",
                "Yazza",
                "Yerwa"
            ],
            "Dikwa": [
                "Afuye",
                "Antiau",
                "Aubre",
                "Azgajita",
                "Bajangawa",
                "Boboshe",
                "Dikwa",
                "Dudure",
                "Durba",
                "Durbel",
                "Gajibo",
                "Gumsu",
                "Jemuri",
                "Kaza",
                "Kudeye",
                "Kuduge",
                "Kulehe",
                "Magarta",
                "Mallam Mafa",
                "Malumaja",
                "Maula",
                "Mudu",
                "Mujigete",
                "Mukeye",
                "Muktala",
                "Mulye",
                "Sawa",
                "Sunabaya"
            ],
            "Gubio": [
                "Doili",
                "Fulatami",
                "Gazabure",
                "Gubio",
                "Gubio I",
                "Gubio II",
                "Jilili",
                "Kanguri",
                "Karaguwa",
                "Karauwa",
                "Kareto",
                "Moleram",
                "Musari"
            ],
            "Guzamala": [
                "Doili",
                "Fulatami",
                "Gazabure",
                "Gubio",
                "Gubio I",
                "Gubio II",
                "Jilili",
                "Kanguri",
                "Karaguwa",
                "Karauwa",
                "Kareto",
                "Moleram",
                "Musari"
            ],
            "Gwoza": [
                "Agapa Lama",
                "Alau",
                "Amdaga",
                "Arce",
                "Ashigashia",
                "Balangaje",
                "Balazala",
                "Barawa",
                "Bokko",
                "Bulabulin",
                "Duma",
                "Falagwe",
                "Gadful Bubayawa",
                "Gudul",
                "Gwoza",
                "Gyomuyi",
                "Hambagda",
                "Isge",
                "Jaye",
                "Kina",
                "Kinawa",
                "Kurana Bassa",
                "Kwatara",
                "Limankara",
                "Lokodisa",
                "Luva",
                "Matakum",
                "Ngabura",
                "Rita",
                "Sasawa",
                "Timir",
                "Tokombana",
                "Valangai",
                "Yinagu"
            ],
            "Hawul": [
                "Azare",
                "Azare Piti",
                "Azare Tasha",
                "Bamjikil",
                "Bantali",
                "Barki Sakwa",
                "Batabwa",
                "Bayu",
                "Bilatum",
                "Bokokatau",
                "Bubalkwi",
                "Bukin",
                "Bwala",
                "Bwala Katsina",
                "Buta Kayamda",
                "Chacdamari",
                "Chata",
                "Dagiza",
                "Dagora",
                "Damudanaka",
                "Dangola",
                "Dikira",
                "Dim",
                "Dikir",
                "Diralang",
                "Dira",
                "Dlirim",
                "Dulmi",
                "Duthlalang",
                "Dzaku",
                "Funwa",
                "Galdimare",
                "Gala",
                "Garkwi",
                "Ghung",
                "Ghuma",
                "Giraba",
                "Girassa",
                "Gum",
                "Gumbar",
                "Gumshim",
                "Gwandzang",
                "Gwanga",
                "Gwaski",
                "Gyeraha",
                "Gwadzahar",
                "Gwallam",
                "Gwamagira",
                "Harang",
                "Hema",
                "Hizhi",
                "Huba",
                "Humsu",
                "Hyera Central",
                "Hyeraki",
                "Hyerea South",
                "Hyentira",
                "Hzalama",
                "Jara",
                "Jibhuhuwi",
                "Kidang",
                "Kida",
                "Kingging",
                "Kirkidang",
                "Kuba",
                "Kurkurupu",
                "Kwagu",
                "Kwagu Shar",
                "Kwajjafa",
                "Kwaya Bura",
                "Kwaya bura",
                "Mbalakawa",
                "Mbokva",
                "Mbulatawiwi",
                "Mbuma",
                "Mimithiu",
                "Minda",
                "Minta",
                "Mularam",
                "Ndiragana",
                "Ndirim",
                "Ndirsha",
                "Nduraku",
                "Ngassam",
                "Ngilangshimtu",
                "Ngwa",
                "Pakilama",
                "Pama",
                "Pela Chiroma",
                "Pela Ola",
                "Pelakitsa",
                "Pirtha",
                "Pirkisu",
                "Pirkutum",
                "Pizumbin",
                "Posira",
                "Pusda",
                "Saboda Allah",
                "Sabon Gari",
                "Sakwa",
                "Sakwa-Bura",
                "Samari",
                "Shikthaku",
                "Shiti kam",
                "Shaffa",
                "Shaffa Wuyaku",
                "Shiduffu",
                "Subwang",
                "Sura",
                "Tabomsha",
                "Taga-Ramta",
                "Tarfa",
                "Tashan Alade",
                "Tashan Gauta",
                "Tawasu",
                "Thlakwa",
                "Timpil",
                "Tong",
                "Traku",
                "Turkuta",
                "Uba",
                "Umuamievili",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuoba",
                "Umu Udenze",
                "Umuezeunu",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor",
                "Vina Dam",
                "Wakdang",
                "Walama",
                "Warni",
                "Whitambaya",
                "Wida",
                "Wuyaku",
                "Yalmatata",
                "Yaulan",
                "Yelwa",
                "Yimirshika",
                "Yimana",
                "Zabu",
                "Zali",
                "Zange",
                "Zham"
            ],
            "Jere": [
                "Addamari",
                "Alau",
                "Bale-Galtimari",
                "Dala-Lawanti",
                "Dusuman",
                "Gamboru",
                "Gongulong",
                "Jere",
                "Koshebe",
                "Lawanti",
                "Maimusari",
                "Mashamari",
                "Masu",
                "Ngudda",
                "Tuba"
            ],
            "Kaga": [
                "Afe",
                "Amindole",
                "Barwa",
                "Benisheik",
                "Bokwori",
                "Bulamuri",
                "Buma'a",
                "Bunguji",
                "Burgumma",
                "Dapchi",
                "Didiri",
                "Digimari",
                "Dogoma",
                "Dongo",
                "Dongozo",
                "Gabchani",
                "Galangi",
                "Gangawa",
                "Ganidia",
                "Girgimor",
                "Gubturo",
                "Guno",
                "Jallori",
                "Karagawan",
                "Koyomi",
                "Koyori",
                "Kuruno-Kayar",
                "Lawani",
                "Mainok",
                "Maintagujeri",
                "Maintakurururi",
                "Malam Mustani",
                "Marguba",
                "Mida Koyemi",
                "Modu Koyamri",
                "Mordori",
                "Mulum-Kumuriri",
                "Ngamdu",
                "Tamsu",
                "Tobolo",
                "Umarari",
                "Warsala",
                "Wasaram",
                "Wasaram Lawan",
                "Wugiru",
                "Wujure",
                "Yelemari",
                "Yewal"
            ],
            "Kala/Balge": [
                "Balile",
                "Bombo",
                "Diama",
                "Dogilai",
                "Duguma",
                "Dusum",
                "Gilgil",
                "Gilgo",
                "Gulgum",
                "Jarawa",
                "Kabel",
                "Kala",
                "Kalam",
                "Kulakula",
                "Kulakura",
                "Kulkaraka",
                "Kutilar",
                "Mada",
                "Masana",
                "Meleri",
                "Mokholo",
                "Ran",
                "Rann",
                "Sabba",
                "Sigal",
                "Tilam"
            ],
            "Konduga": [
                "Auno",
                "Ajiri",
                "Bazamri",
                "Bulabulin",
                "Dalori",
                "Dalwa",
                "East",
                "Ghabbol",
                "Jajel",
                "Jakana",
                "Jweu",
                "Kaigamari",
                "Kawuiri",
                "Kellumiri",
                "Kodunga",
                "Konduga",
                "Lambia",
                "Mairamri",
                "Malari",
                "Masba",
                "Nguro",
                "Ngalimari",
                "Njimtilo",
                "Nyaleri",
                "Sandia",
                "Sojbri",
                "Wanori",
                "Yabal",
                "Yale",
                "Garu",
                "Yaleri",
                "Yajiwa"
            ],
            "Kukawa": [
                "Adua",
                "Ajiri",
                "Alagama",
                "Barwati",
                "Bongoa",
                "Borgoa",
                "Bundur",
                "Da'awao",
                "Dabu",
                "Degagu",
                "Dogoshi",
                "Garanda",
                "Gudunbali",
                "Kangarwa",
                "Kauwa",
                "Kekeho",
                "Kukawa",
                "Moduwari",
                "Ngurtuwa",
                "Toyo",
                "Yoyo"
            ],
            "Kwaya Kusar": [
                "Algarno",
                "Balba",
                "Bargu",
                "Bila",
                "Bilazi",
                "Bima",
                "Charangi",
                "Chikwi",
                "Dayar",
                "Dema",
                "Dlashu",
                "Duchi",
                "Dunkur",
                "Durum",
                "Fesingo",
                "Gadam",
                "Gaidam",
                "Gamsama",
                "Gashina",
                "Giba",
                "Guba",
                "Gubai",
                "Guburde",
                "Gudula",
                "Gujba",
                "Gusi",
                "Guwal",
                "Gwandi",
                "Hema",
                "Hutayankwar",
                "Jagali",
                "Jaki",
                "Jalingo",
                "Juga",
                "Jugual",
                "Kenzuwa",
                "Keri",
                "Kopala",
                "Kuamsheng",
                "Kubuku",
                "Kullankasan",
                "Kurba",
                "Kuthi",
                "Kwagu",
                "Kwardun",
                "Kwathaung",
                "Kwaya",
                "Lafiya",
                "Lesga",
                "Magaba",
                "Maiba",
                "Mbula",
                "Midla",
                "Minta",
                "Moku",
                "Paka",
                "Pankilang",
                "Pelatsugi",
                "Peta",
                "Pika",
                "Pukuma",
                "Salahu",
                "Saura",
                "Tawasu",
                "Wada",
                "Wandali",
                "Wara",
                "Wawa",
                "Yangwam",
                "Yimbu",
                "Yimirdlalang",
                "Zobi"
            ],
            "Mafa": [
                "Anadua",
                "Gawa",
                "Kajari",
                "Koshebe",
                "Limanti",
                "Loslari",
                "Ma'afa",
                "Mafa",
                "Mafa-Abbari",
                "Mafa-Nguranna",
                "Masa",
                "Mbuta",
                "Mijigine",
                "Siguabuya",
                "Tamsugu",
                "Umarari",
                "Zannari"
            ],
            "Magumeri": [
                "Abagoderi",
                "Ambolu",
                "Ardoram",
                "BornoYesu",
                "Dandalmai",
                "Dusugua",
                "Furram",
                "Gabchari",
                "Gabtaru",
                "Gajiganna",
                "Ganan",
                "Ganijia",
                "Garmiri",
                "Geske",
                "Gultaru",
                "Jakkana",
                "Ka'ajia",
                "Kalizoram",
                "Kupti",
                "Layratti",
                "Magumeri",
                "MagumeriA",
                "MagumeriB",
                "MallumBusariri",
                "MalumMustari",
                "MonoramGonimiri",
                "Ngamma",
                "Ngubola",
                "Ngura's",
                "Risugua",
                "Yasku",
                "Zumtur"
            ],
            "Marte": [
                "Ala",
                "Ajiri",
                "Alla",
                "Bodairi",
                "Burahutube",
                "Fage",
                "Garadia",
                "Gumma",
                "Kaje",
                "Kajekura",
                "Kabula",
                "Kirenowa",
                "Kulli",
                "Majadukuri",
                "Marte",
                "Masaba",
                "Mawulli",
                "Mugum",
                "Musune",
                "Ngalori",
                "Njine",
                "Saba",
                "Saula",
                "Wubsa",
                "Yedi",
                "Zaga"
            ],
            "Mobbar": [
                "Abadam",
                "Ajiri",
                "Arege",
                "Asagar",
                "Asar",
                "Bamuwa",
                "Barmuwa",
                "Bisigu",
                "Bisku",
                "Bisogana",
                "Bisua",
                "Buram",
                "Camba",
                "Dailo",
                "Damasak",
                "Dankalia",
                "Dansalia",
                "Daregelewa",
                "Dawram",
                "Derechewa",
                "Duji",
                "Duri",
                "Faguwa",
                "Galai",
                "Garege",
                "Garuwa",
                "Gashagor",
                "Gashigar",
                "Gashiwar",
                "Gir",
                "Gonigiro",
                "Goniri",
                "Gugawa",
                "Gumaram",
                "Jabulam",
                "Kabela",
                "Kabewa",
                "Kaleri",
                "Kalinowa",
                "Kareto",
                "Karibia",
                "Karimbori",
                "Karinboa",
                "Kaririwa",
                "Kashiniguri",
                "Kauwa",
                "Korikutila",
                "Kwari-Nonori",
                "Ladari",
                "Lamlam",
                "Lariski",
                "Lavaski",
                "Layi",
                "Limbur",
                "Maiduri",
                "Malam Fatori",
                "Malamsuri",
                "Mallam Kwanori",
                "Mamti",
                "Masakai",
                "Meleri",
                "Metele",
                "Mobbar",
                "Monor",
                "Nagajia",
                "Ngaji",
                "Ngam",
                "Ngamakayale",
                "Nwainowa",
                "Tingiri",
                "Tororam",
                "Uran",
                "Yarumiri",
                "Yau",
                "Yauma Wango",
                "Zari"
            ],
            "Monguno": [
                "Aburaku",
                "Aliyu",
                "Asadu",
                "Bida",
                "Damakuli",
                "Das'a",
                "Dasama",
                "Dedela",
                "Difinowa",
                "Kabal-Balum",
                "Kabulawa",
                "Kaganam",
                "Kalwa",
                "Kaworil",
                "Kumalia",
                "Mandala",
                "Mashilia",
                "Miutar",
                "Mongal",
                "Monguno",
                "Musari",
                "Ngalram",
                "Ngarannam",
                "Ngollam",
                "Wulo",
                "Zulim",
                "Zulum"
            ],
            "Ngala": [
                "Adari",
                "Amsabura",
                "Balammbe",
                "Balila",
                "Bombe",
                "Daima",
                "Dagala",
                "Dogilai",
                "Duguma",
                "Dusum",
                "Fim",
                "Galgum",
                "Gangaya",
                "Gilego",
                "Gilgil",
                "Jakawa",
                "Jarawa",
                "Jarawa-Tatakura",
                "Kabel",
                "Kala",
                "Kalakura",
                "Kalam",
                "Karche",
                "Kulakula",
                "Kulakura",
                "Kulkaraka",
                "Kumega",
                "Kurana",
                "Kutilar",
                "Mada",
                "Masana",
                "Meleri",
                "Mokhelo",
                "Ndusu",
                "Nissini",
                "Ngala",
                "Ran",
                "Sabba",
                "Samboru",
                "Sangaya",
                "Sigal",
                "Tilam",
                "Tumishe",
                "Tunukalia",
                "Wulgo",
                "Wulgo-Nagirari",
                "Wushelia",
                "Wumbe",
                "Wurge"
            ],
            "Nganzai": [
                "Alarge",
                "Badu",
                "Bubabulin",
                "Damakara",
                "Daram",
                "Felo",
                "Gadai",
                "Gadayi",
                "Gajiram",
                "Kingoe",
                "Kuda",
                "Kurnawa",
                "Maiwa",
                "Miye",
                "Sababuwa",
                "Sahsawa",
                "Shattam",
                "Sugundure",
                "Zigalta"
            ],
            "Shani": [
                "Barga",
                "Burgulok",
                "Dalhat",
                "Dumbuku",
                "Gasi",
                "Ghari",
                "Gora",
                "Gwalasho",
                "Gwaskara",
                "Kabara",
                "Kashime",
                "Kimtin",
                "Kombo",
                "Kubo",
                "Kubodemo",
                "Kurje",
                "Kurnglung",
                "Lakundum",
                "Lajada",
                "Pela",
                "Shani",
                "Walama",
                "Yabe"
            ]
        }
    },
    {
        "Cross River": {
            "Abi": [
                "Abanankpai",
                "Abba-Omega",
                "Adadama",
                "Agarabe",
                "Akamanator",
                "Akata",
                "Akpalagbo",
                "Akpoha",
                "Along-Ezeke",
                "Amagu",
                "Amuawor",
                "Amaunu",
                "Amuleri",
                "Aniekwem",
                "Aneja II",
                "Anona",
                "Assiga-Beach",
                "Assiga-New Town",
                "Assiga-Old-Town",
                "Agoi Ekpo",
                "Agoi-Ekpo",
                "Agoi Ibomi",
                "Akanefore",
                "Akeraja",
                "Akugom",
                "Bikobiko",
                "Ebom",
                "Abegor",
                "Ebalabo",
                "Ebekiti",
                "Egberonyi",
                "Egbezum",
                "Ekamasai",
                "Ekori",
                "Ekunkuna",
                "Elige",
                "Eligene",
                "Emina",
                "Eminekpon",
                "Ensuokwe",
                "Enugwema",
                "Epeenti",
                "Epeni-Beach",
                "Epoho",
                "Ezeake-Emege",
                "Eziama",
                "Eziafor",
                "Funaria",
                "Iboiebo",
                "Idomi",
                "Ife Agoi",
                "Imikuo",
                "Imino",
                "Itakono",
                "Itigidi",
                "Kemaniben",
                "Lekpankom",
                "Lebong",
                "Leboikom",
                "Lower Igonigoni",
                "Mbaiebe",
                "Mbaleke",
                "Mkpanghi",
                "Mkpani",
                "Ngaraba",
                "Ajere",
                "Afoafaha",
                "Nko",
                "Nko Rubber Estate",
                "Nfakom",
                "Nsobo",
                "Ntankpo",
                "Okon-Obonogha",
                "Okomasi",
                "Ofrekpe",
                "Otalosi",
                "Uden-Okota",
                "Ugep",
                "Upper Igonigoni",
                "Usumutong",
                "Yeno"
            ],
            "Akamkpa": [
                "Abaribara",
                "Abamba",
                "Abanwam",
                "Abat",
                "Abini",
                "Abini-Ajijia",
                "Afono",
                "Agwaguna",
                "Agwaguna-Egbe",
                "Agwaguna-Emo",
                "Akamanator",
                "Akata",
                "Akofbenyim",
                "Akparavuni",
                "Akpet-Central",
                "Akpet-I",
                "Akugom",
                "Aningeje",
                "Annua-Oboo",
                "Anua-Offot",
                "Anuyem",
                "Atan-Eki",
                "Atan-Idere",
                "Atan-Onoyom",
                "Ayaba-Oji",
                "Ayimo",
                "Edodiesu",
                "Edu",
                "Edodone-Aboni",
                "Egbor",
                "Egip-Urom",
                "Egup-Ipa",
                "Ehom",
                "Ehom-Central",
                "Ekang",
                "Ekpri",
                "Ekpri-Iko",
                "Ekpri-Iwuru",
                "Ekpene-Ibiabong-Eki",
                "Elae-Itokem",
                "Enen-Ito",
                "Enidit",
                "Enodakoton",
                "Enougo",
                "Enougo-Ewuruon",
                "Epefime",
                "Esuikongo",
                "Etono-I",
                "Etono-II",
                "Etabi",
                "Etana",
                "Ewothpo-Ikun",
                "Ewen",
                "Eziagulu",
                "Eziagulu-Otu",
                "Eziafor",
                "Eziama",
                "Ibiakpan",
                "Iboho-Ito",
                "Idima",
                "Idim-Atan",
                "Idim-Nom-Eku",
                "Ifumkpa",
                "Igenigba-Deogbe",
                "Igbariam",
                "Igboria",
                "Igboezunu",
                "Ikami",
                "Ikot-Abasi",
                "Ikot-Ana",
                "Ikot-Akpabio",
                "Ikot-Akpam",
                "Ikot-Anyang",
                "Ikot-Eduong",
                "Ikot-Ekpeyak",
                "Ikot-Etima",
                "Ikot-Esai",
                "Ikot-Ibekwe",
                "Ikot-Iyang-Udo-I",
                "Ikot-Iyang-Udo-II",
                "Ikot-Mbon",
                "Ikot-Ndot",
                "Ikot-Offiong",
                "Ikot-Oko",
                "Ikot-Oto-Iwuo",
                "Ikot-Obong",
                "Ikot-Obio-Mkpon",
                "Ikot-Obio-Okpoho",
                "Ikot-Obio-Owo",
                "Ikot-Okubo",
                "Ikot-Oku",
                "Ikot-Osai",
                "Ikot-Udo",
                "Ikot-Udo-Mbang",
                "Ikot-Udo-Ossiom",
                "Ikot-Uko-Annang",
                "Ikot-Uram",
                "Ikot-Utiat",
                "Ikot-Utum",
                "Ikot-Uyo",
                "Ikot-Wkpankpe",
                "Ikpabio-Ito",
                "Iko",
                "Imasetbi",
                "Ina-Missing",
                "Inu-ranu",
                "Itokem",
                "Itu-Agwagune",
                "Iwuru-Obio",
                "Izan-Egwe",
                "Mbarakpa",
                "Mbarantung",
                "Mbiabong",
                "Mbiabong-Ikot-Abasi",
                "Mbiabong-Ikot-Antem",
                "Mfamosing",
                "Mgbago",
                "Mtabachot",
                "New-Ekuri",
                "New-Ndebeji",
                "Nkame",
                "Nsan",
                "Ntan-Obu-Ukpo-Obio",
                "Nkwonando",
                "Njagachang",
                "Nisoye",
                "Nneyi",
                "Nnadi",
                "Nyaabam",
                "Obani-Erei",
                "Obiot-Esu-Ito",
                "Obiot-Okpo",
                "Obode-Eki",
                "Obodo-Eki",
                "Obot-Akpatio",
                "Obot-Esu-Ito",
                "Obot-Udana",
                "Obukwo-Esa",
                "Obukwomuno",
                "Odioho-Ito",
                "Okarara",
                "Okpefime",
                "Okonta",
                "Okpo",
                "Olumbanasa",
                "Onba-Ikun",
                "Onoronwanza",
                "Orei",
                "Orua",
                "Orua-Umun",
                "Osomba",
                "Owon",
                "Owon-Aradun",
                "Owuai",
                "Ubia-Obio-II",
                "Ubem-Okon-Abia",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Umunzu",
                "Umo Udenze",
                "Umuabia",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuoba",
                "Umuezeunu",
                "Umuleri",
                "Urugban",
                "Urualor",
                "Usiere",
                "Uwet",
                "Uyanga",
                "Uyanga-Abakpa",
                "Uyon-Eyai",
                "Utambara-Ito",
                "Utumua",
                "Uyiere",
                "Uye",
                "Uyo-Offot",
                "Uyo-Okuk"
            ],
            "Akpabuyo": [
                "Anyananse",
                "Atimbo East",
                "Atimbo West",
                "Eneyo",
                "Ikang Central",
                "Ikang North",
                "Ikang South",
                "Ikot Edem Odo",
                "Ikot Eyo",
                "Ikot Nakanda",
                "Idundu"
            ],
            "Bakassi": [
                "Abakpa",
                "Abakpa Efio Ase",
                "Abakpa Etim Ene",
                "Abakpa Ikot-Nkok",
                "Abalagbo",
                "Ada Iba",
                "Adana Mbaibo",
                "Adiabo Akani Obio",
                "Afaha",
                "Akani Obio Ukem",
                "Akapatrefe",
                "Akwa",
                "Akwa Efe",
                "Akwa Ikot",
                "Akwa Iyoke",
                "Akwa Obio Inwang",
                "Akwa Obio-Inwang-Eneyo",
                "Amagu",
                "Amaunu",
                "Amuawor",
                "Amuleri",
                "Anie",
                "Anwa Enang-Edem",
                "Anwa Ibok",
                "Archibong",
                "Atan Odot",
                "Atan Oku",
                "Atimbo",
                "Atimbo (East)",
                "Atimbo (West)",
                "Ede Nsa",
                "Edem",
                "Edem Adua",
                "Edem Esa Abakot",
                "Edik Ekpen Eyo",
                "Edik Iko",
                "Edit Ikpa Eman",
                "Edit Iko Ekpo-",
                "Efe Ene",
                "Efanga",
                "Efiom",
                "Efuk Ifako",
                "Ekakat Iyamba",
                "Ekime Mfuk",
                "Ekong",
                "Ekong Atan Oku",
                "Ekpeme Ikot Ekpse",
                "Ekpeme Ikot Umo",
                "Ekpenyang Eyo",
                "Ekpenyong",
                "Ekpri Ikang",
                "Ekpri Ikot Ene",
                "Ekpri Ikot Eyo-Edem",
                "Ekpri Ikot Umo",
                "Ekpri Nsidung",
                "Ekpene Esuk Esighi",
                "Ekpene Ikot Edet-Nsa",
                "Ekpene Ikot-Okon",
                "Ekwua Iyoke",
                "Esit Ikot",
                "Esit Ikot Ede Nsa",
                "Esit Ikot Nsa Ewa",
                "Esine Ufot",
                "Esine Ufot Ikot-Edet Nsa",
                "Esuk Akwa Obio",
                "Esuk Edem",
                "Esuk Efiom Ikara",
                "Esuk Mba",
                "Esuk Mbat-Efio Urua",
                "Eukene Okon",
                "Etak Okono",
                "Eto Mkpa-Archigong",
                "Eto Mkpe Yellow",
                "Eto Mkpe-Edem",
                "Ewet Offot",
                "Eziagulu",
                "Eziagulu-Otu",
                "Eziafor",
                "Eziama",
                "Ikang Efio Ekpe",
                "Ikang Town",
                "Ikot Abasi Eyo",
                "Ikot Abasi Nkpo",
                "Ikot Abasi Ene-Esighi",
                "Ikot Adiaha Eneyo",
                "Ikot Akpa",
                "Ikot Akpa Idem",
                "Ikot Akpa Nkuk",
                "Ikot Akwa-Umo",
                "Ikot Anta Eneng-Obum",
                "Ikot Antigha Ado",
                "Ikot Antigha Ene",
                "Ikot Antigha Udo",
                "Ikot Asako",
                "Ikot Asido Otu",
                "Ikot Asuquo-Edem",
                "Ikot Asuquo-Ukut",
                "Ikot Aye Eyo",
                "Ikot Efa",
                "Ikot Effiong Otop",
                "Ikot Efefiong",
                "Ikot Efiong",
                "Ikot Efio Enang",
                "Ikot Efio Okon",
                "Ikot Efiok-Ekpenyong",
                "Ikot Ekong",
                "Ikot Ekpe",
                "Ikot Ekpo",
                "Ikot Ekpo Ene",
                "Ikot Enembe",
                "Ikot Ene Edet",
                "Ikot Eneokon",
                "Ikot Enene Esighi",
                "Ikot Eno",
                "Ikot Ewa Effiom",
                "Ikot Ewa Otu",
                "Ikot Eyo",
                "Ikot Eyo Abasi Itam",
                "Ikot Eyo Okon",
                "Ikot Ibok Eyo",
                "Ikot Ikang",
                "Ikot Inyang Nsidung",
                "Ikot Mbang",
                "Ikot Mkpang",
                "Ikot Mkpanam",
                "Ikot Nakan de",
                "Ikot Naya Nya",
                "Ikot Ntung",
                "Ikot Okon Akabom",
                "Ikot Okon Eniang",
                "Ikot Okpo Ene",
                "Ikot Obongeno",
                "Ikot Obo",
                "Ikot Oboko",
                "Ikot Okan Okpo",
                "Ikot Okodiong",
                "Ikot Otu",
                "Ikot Otudor",
                "Ikot Udo",
                "Ikot Udo-Akpan",
                "Ikot Udo Idem",
                "Ikot Udo Iyak",
                "Ikot Udo Mbang",
                "Ikot Udo Mbang/Afaha Obo",
                "Ikot Udo-Ossiom",
                "Ikot Ukpa",
                "Ikot Uko",
                "Ikot Uko Obobo",
                "Ikot Una",
                "Ikot Uram",
                "Ikot Utiat",
                "Ikpet",
                "Inua Akpa",
                "Inwang",
                "Iso Inyang",
                "Isong Inyang",
                "Isong Inyang Ene",
                "Isong Inyang Eyo",
                "Isong Inyang Ufak",
                "Isong Inynag",
                "Mbambori Ikot Ma",
                "Mbarakom",
                "Mbiabo",
                "Mbiabo Ikoneto",
                "Mbiabo Ikot-Antem",
                "Mbombori",
                "Mgbago",
                "Miabong Ikot",
                "Mong",
                "Ndom Itu",
                "Ndom Nyam",
                "Nkitto",
                "Nsa",
                "Nta Ikot Offiong Ede",
                "Nta Obo",
                "Nyom Idibi",
                "Obio Asim",
                "Obot Akpang",
                "Obot Eyo",
                "Obot Idim Nyoyok",
                "Obot Inyang",
                "Obot Inwang",
                "Obot Iyang",
                "Obot Oko",
                "Obot Udo",
                "Obot Urua",
                "Obot Urua Mbiabo",
                "Obufa Obio Ukem",
                "Ofong Okurusa",
                "Okpo Ikpa",
                "Okuruikang",
                "Osak",
                "Ovufa Obio Ukan",
                "Ukem Okoyong-Ekenge",
                "Usang Abani",
                "Usung",
                "Usung Esuk",
                "Usung Idim",
                "Usung Idim Ikot-Antigho",
                "Usung Ikoneto",
                "Usung Odot",
                "Usung Ura",
                "Utan Okpo",
                "Umunzu",
                "Umo Udenze",
                "Umuabia",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuoba",
                "Umuezeunu",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor"
            ],
            "Bekwarra": [
                "Abacho Ogugo",
                "Abanike",
                "Abatchor",
                "Abube Ukpa",
                "Abuekpu",
                "Abi-Irruan",
                "Abiogbole",
                "Abioghole",
                "Abuochiche",
                "Adayom",
                "Adikpe Yole",
                "Adikpe Yohe",
                "Adomogbe",
                "Adop",
                "Adeni",
                "Afrike",
                "Akaraba",
                "Akatem",
                "Akogbe",
                "Akpakpa",
                "Akpahata",
                "Akraha",
                "Akunaye",
                "Akwurinyi",
                "Aladin",
                "Alifokpa",
                "Alonye",
                "Alonge",
                "Anyikang",
                "Anyogbe",
                "Aragbam",
                "Ashuk",
                "Asika",
                "Asaba I",
                "Asaba II",
                "Atambong",
                "Atanghol",
                "Atuana",
                "Atuntak",
                "Awinghi",
                "Ayandie",
                "Ayokpa",
                "Ayuokpa",
                "Ayioba-Wankinde",
                "Bansan-Mapan-Atam",
                "Bansara",
                "Bansara-Abakpo-Ntara",
                "Baraki",
                "Benkaba",
                "Betin",
                "Bewo",
                "Bikele-Obantagama",
                "Binkpe",
                "Bitol",
                "Bitutum",
                "Bituol",
                "Ebaruma",
                "Ebegang-Irihunguchu",
                "Ebo",
                "Ebor",
                "Echimbogu",
                "Echimbong",
                "Echiakpu",
                "Echouge",
                "Echegang",
                "Echumofara",
                "Echumogana-Ofiekpa",
                "Edede",
                "Edemoga",
                "Edimoga",
                "Edogbe",
                "Edogo",
                "Edep",
                "Ediba",
                "Ega",
                "Egbe Mpi-Iman",
                "Egbong",
                "Egung",
                "Eja",
                "Ejebu Oke",
                "Ekagong",
                "Ekajuk",
                "Ekeja",
                "Ekpemongho",
                "Ekpokre",
                "Ekprinyin",
                "Ekrojokown",
                "Ekum Tak",
                "Ekuaro",
                "Ekwokoko",
                "Emandak",
                "Emandok",
                "Emekpo",
                "Enagendak",
                "England",
                "Enyi",
                "Efut Nsei",
                "Eguoh",
                "Eyimi",
                "Eyombon",
                "Ezekwe",
                "Ezike",
                "Ibil",
                "Ibenta",
                "Ibento",
                "Ibiragndi",
                "Igbọlọ",
                "Ichelor Esoka",
                "Ichojil I",
                "Ichojil II",
                "Igbakobu",
                "Igbekuriko",
                "Igede",
                "Igo",
                "Ijegu Ogogo",
                "Ijegu Ore",
                "Ijegu Wobu",
                "Ijibor Agana",
                "Ijibor-Ojiji",
                "Ijibor-Oloko",
                "Ijem",
                "Ijenka",
                "Ijokom",
                "Ikandang",
                "Ikanhuo",
                "Ika Like",
                "Ikparikobo",
                "Ijrurogar II",
                "Ikpongpo",
                "Ikpride",
                "Ikum",
                "Ikojen",
                "Imaje",
                "Imate",
                "Imo",
                "Ina",
                "Imande",
                "Ipollo",
                "Iputu",
                "Inia",
                "Ipekaka",
                "Ipuele",
                "Ipude Okuku",
                "Irribekem-Efintak",
                "Ishindede",
                "Ishony",
                "Itekpa",
                "Itega",
                "Itega Okpodu",
                "Itigidi",
                "Ikirang",
                "Jeriko",
                "Jie",
                "Kaduda",
                "Kadama",
                "Kpambpa",
                "Kpautra",
                "Lagos",
                "Leper",
                "London",
                "Mabuna Fram",
                "Mafung",
                "Mban-Agabo",
                "Mban-Amung",
                "Mban-Bikuel",
                "Mban-Ewenken",
                "Mbora",
                "Mbon",
                "Mbufm",
                "Mbuo",
                "Mbok",
                "Mfom",
                "Mfom II",
                "Mfom Odom",
                "Mfonju",
                "Mkpakua",
                "Mkom",
                "Mpam-Bentam",
                "Mpambeka",
                "Mpangbenyi",
                "Motel",
                "Mtom",
                "Mouye",
                "Ndar",
                "Ndubia",
                "Ndubi",
                "Nfanangbe",
                "Ngidi Adum",
                "Ngiti",
                "Ngomo",
                "Ngon",
                "Ngulia",
                "Njimaya",
                "Njokima",
                "Nkamero",
                "Nkpute Bagidi",
                "Nkpangi",
                "Nnang-Elesi",
                "Nsinjon",
                "Ntara I",
                "Ntara II",
                "Ntara III",
                "Ntara-Ayimaya",
                "Ntingigna",
                "Ntunnop",
                "Nwang",
                "Nyake",
                "Nyanya Ohum",
                "Nyaya Idigwe",
                "Oba Okpoma",
                "Oboso",
                "Oche Okpoma",
                "Ochogbe",
                "Ochocho",
                "Odojie",
                "Odoke",
                "Ogboli",
                "Ogbene-Ijibor",
                "Ogberia-Ochoro",
                "Ogbon",
                "Oganiko",
                "Ogangang",
                "Ogbohi",
                "Ogeria-Ogong",
                "Ogomogoma",
                "Ojerim",
                "Okon Ogbodo",
                "Okpahribo",
                "Okpoma",
                "Okponga",
                "Okpotogom",
                "Okuba I",
                "Okuba II",
                "Okuku",
                "Okukujin",
                "Olatchor",
                "Olemat",
                "Oloko",
                "Olosi",
                "Omoji",
                "Onicha",
                "Opipua",
                "Opriku",
                "Opipu",
                "Orin-Ekpang",
                "Osina",
                "Ospika",
                "Ubeale",
                "Ubeke",
                "Ubekpa",
                "Ububu",
                "Uburogu",
                "Ugaga",
                "Ugboro",
                "Uhakilu",
                "Ujegenyi",
                "Ujemi",
                "Ujissi-Ekagwu",
                "Ujm",
                "Ukinde",
                "Ukolobia",
                "Ukpaka",
                "Ukpagada",
                "Ukpagatale",
                "Ukpa",
                "Ukpada",
                "Ukpat",
                "Ukpahato",
                "Unwagba Ukpa",
                "Unwapu",
                "Utubo Iye",
                "Utugbo",
                "Utukpa",
                "Utukwe",
                "Utukwe-Iye",
                "Wanbiha",
                "Wanjer Elhen",
                "Wamakpe",
                "Wamubu",
                "Wanadon",
                "Wanagina",
                "Wanakandi",
                "Wanakpon",
                "Wanikade",
                "Wanukande",
                "West Nwang",
                "Yahe",
                "Yache",
                "Yaa",
                "Zaria"
            ],
            "Boki": [
                "Aba",
                "Abalagbo",
                "Abankang",
                "Abayongo",
                "Abayongho",
                "Abebene",
                "Abinti",
                "Abonorok",
                "Abat",
                "Adumatam",
                "Alesi",
                "Agba",
                "Agbotai",
                "Agbudu",
                "Agu",
                "Akamanator",
                "Akata",
                "Akpalagbo",
                "Akorahi",
                "Akorofono",
                "Amagu",
                "Amuawor",
                "Amaunu",
                "Amuleri",
                "Anagha",
                "Aniekwem",
                "Amandakureke",
                "Amunga",
                "Ashikpe",
                "Ata Essien",
                "Ata Essien Afaha-Ntak",
                "Enugu",
                "Enugu-Otu",
                "Eziagulu",
                "Eziagulu-Otu",
                "Eziama",
                "Eziafor",
                "Ivite",
                "Isiokwe",
                "Igboezunu",
                "Igbariam",
                "Isinyi",
                "Mgbago",
                "Nando",
                "Nneyi",
                "Nnadi",
                "Nisoye",
                "Nkwonando",
                "Ogbu",
                "Ogugu-Etiti",
                "Ogwuari",
                "OkpaAgba",
                "Okpu",
                "Otuocha",
                "Owaloka",
                "Ovu-Oke",
                "Umuabia",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuoba",
                "Umu Udenze",
                "Umuezeunu",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor"
            ],
            "Calabar Municipal": [
                "Calabar Municipality Eight",
                "Calabar Municipality Five",
                "Calabar Municipality Four",
                "Calabar Municipality Nine",
                "Calabar Municipality One",
                "Calabar Municipality Seven",
                "Calabar Municipality Six",
                "Calabar Municipality Ten",
                "Calabar Municipality Three",
                "Calabar Municipality Two"
            ],
            "Calabar South": [
                "CalabarSouthEight",
                "CalabarSouthEleven",
                "CalabarSouthFive",
                "CalabarSouthFour",
                "CalabarSouthNine",
                "CalabarSouthOne",
                "CalabarSouthSeven",
                "CalabarSouthSix",
                "CalabarSouthTen",
                "CalabarSouthThree",
                "CalabarSouthTwelve",
                "CalabarSouthTwo"
            ],
            "Etung": [
                "Abia",
                "Abijang",
                "Abonita",
                "Agbokim",
                "Agbokimobi",
                "Ajassor",
                "Beabuagbong",
                "Bebuabie",
                "Bebuatauan",
                "Bendeghekiem",
                "Betukwai",
                "Effraya",
                "Ekimaya",
                "Ekuhaiai",
                "Etomi",
                "Ibong",
                "Igwe",
                "Kakum",
                "Kukorshie",
                "Kutiang",
                "Mbume",
                "Mkpot",
                "Nsofang",
                "Ohong",
                "Ubongbetter"
            ],
            "Ikom": [
                "Abanyum",
                "Abonkibi",
                "AdijinkporI",
                "AdijinkporII",
                "Akparabong",
                "Ariekpe",
                "Asenasen",
                "Bebuagam",
                "Bebuyobang",
                "Benwhuan",
                "Bishogbo",
                "Bokomo",
                "Etayip",
                "Isabong",
                "IkomRural",
                "IkomUrbanI",
                "IkomUrbanII",
                "Iwumikwu",
                "LittleAgokum",
                "Mgbagabiti",
                "Nnam",
                "NtaNselle",
                "OfutopI",
                "OfutopII",
                "OkweiObudu",
                "OldIkomTown",
                "Olulumo",
                "Ukambi"
            ],
            "Obanliku": [
                "Basang",
                "Bebi",
                "Becheve",
                "Bendi",
                "Bishiri North",
                "Bishiri South",
                "Bisu",
                "Busi",
                "Utanga"
            ],
            "Obubra": [
                "Ababene",
                "Abiakom",
                "Ahaha",
                "Akim",
                "Alagha",
                "Apiapum",
                "Arama",
                "Arobom",
                "Awongha",
                "Ebiem",
                "Echara",
                "Echingro",
                "Edah",
                "Eja",
                "Enibichiri",
                "Enyadologor",
                "Enyadolozundechi",
                "Ezoama",
                "Ijege",
                "Iko",
                "Ikambak",
                "Ikem",
                "Imabana",
                "Imavana",
                "Imahuna",
                "Ijutum",
                "Isabang",
                "Isobo",
                "Iyalla",
                "Iyamoyona",
                "Iyamitet",
                "Itapibet",
                "Jengro",
                "Idoro",
                "Imebama",
                "Imavena",
                "Ogaga",
                "Ogana",
                "Ogada",
                "Ohama",
                "Okoi",
                "Okokoma",
                "Okokoro",
                "Okpangut",
                "Okpechi",
                "Okpuitumo",
                "Oluriche",
                "Omene",
                "Onyadam",
                "Onyadama",
                "Onyekpenden",
                "Onyen",
                "Osakan",
                "Osini",
                "Osobo",
                "Osopong",
                "Otuocha",
                "Owakande",
                "Ovonom",
                "Ovukwa",
                "Oyina",
                "Oynen",
                "Tet",
                "Ugrupon"
            ],
            "Obudu": [
                "Abonkib",
                "Abuasu",
                "Alege",
                "Akoreshie",
                "Akorahi",
                "Amukwong",
                "Amunga",
                "Amandakureke",
                "Atiekpe",
                "Baggo",
                "Bayabo",
                "Bayalele",
                "Bayama",
                "Bayano",
                "Bayapere",
                "Bayasung",
                "Bayatuga",
                "Bayatugun",
                "Bebushayan",
                "Beabuagbong",
                "Bebuabie",
                "Bebuagam",
                "Bebuatsuan",
                "Beegbong",
                "Begat",
                "Begiaba",
                "Begiatsu",
                "Begiatte",
                "Begere",
                "Behuwhuan",
                "Belegette",
                "Belenge",
                "Bendigie",
                "Bendi",
                "Biwhe-Echua",
                "Blukonu",
                "Buchan-Unya",
                "Bugene",
                "Bukumaya",
                "Busanfung",
                "Buya",
                "Buka",
                "Bute",
                "Benuwhuan",
                "Bayabu",
                "Igel",
                "Ibong",
                "Ijua",
                "Igwo",
                "Ikang",
                "Irie",
                "Irriagu",
                "Iwumikwu",
                "Kakum",
                "Kakwalaike",
                "Kaku",
                "Kalane",
                "Kagbang",
                "Karu",
                "Kigbor",
                "Kitele",
                "Kutiang",
                "Lishiche",
                "Lishikwel",
                "Lundara",
                "Mgbonege",
                "Nkrira",
                "Okpe",
                "Okwei-Obudu",
                "Okorogang",
                "Okorotung",
                "Okiro",
                "Old Ikete Ranch",
                "Omale",
                "Ofambe",
                "Ruberi",
                "Saw Kwala",
                "Shikpeche",
                "Ukambi",
                "Ukpada",
                "Ukpringi",
                "Ukutia",
                "Udeshi",
                "Ugang",
                "Ubong-Better",
                "Utanga",
                "Utugwang",
                "Utuhu",
                "Ugbakoko",
                "Ukordam"
            ],
            "Odukpani": [
                "Adiabo",
                "Akani",
                "Akpong",
                "Anyanghanse",
                "Asabanka",
                "Ediki",
                "Efeta",
                "Esin Ufot I",
                "Esin Ufot II",
                "Esuk Adim",
                "Esuk Itiat",
                "Esuk Mbat",
                "Etaa Kpini",
                "Etantan",
                "Etim Edet",
                "Ibuot",
                "Ikot Agbor",
                "Ikot Ansa Ekpo",
                "Ikot Ayom",
                "Ikot Mesembe",
                "Ikot Offiong",
                "Ikot Okon",
                "Ikot Okon-Archibong",
                "Ikot Okpo-Umoh",
                "Ikot William-George",
                "Mbat Odukpani",
                "Obot Oyoh",
                "Odukpani (East)",
                "Odukpani (West)",
                "Odukpani Dua",
                "Okong Nte-Okong",
                "Usung Ayom"
            ],
            "Ogoja": [
                "Aminica",
                "Igoli",
                "Ishibori",
                "Leper Settlement",
                "Monaya",
                "Ndok",
                "Njaria",
                "Ogboja",
                "Ogoja",
                "Okendi",
                "Okuku"
            ],
            "Yakurr": [
                "Afrekpe",
                "Ajere",
                "Assiga",
                "Biko",
                "Idomi",
                "Ikpakapit",
                "Ijiman",
                "Ijom",
                "Inyima",
                "Mkpani",
                "Nkpolo",
                "Ntan",
                "Ukpawen"
            ],
            "Yala": [
                "Echumofana",
                "Gabu",
                "Ijiraga",
                "Mfuma",
                "Ntrigom",
                "Okpoma",
                "Okuku",
                "Wanihem",
                "Wanikade",
                "Wanakom",
                "Yache",
                "Yahe"
            ]
        }
    },
    {
        "Delta": {
            "Aniocha North": [
                "Abudalo",
                "Anioma",
                "Ezi",
                "Ezechime",
                "Idumuje",
                "Idumuje-Ugboko",
                "Idumuje-Unor",
                "Idumuogo",
                "Ikem",
                "Isa-Ogwashi",
                "Issele-Azagba",
                "Issele-Uku",
                "Obiomkpa",
                "Ogbeanei",
                "Okofia",
                "Onicha-Olona",
                "Onicha-Ugbo",
                "Onicha-Uku",
                "Ugboba",
                "Ugbodu",
                "Ugodor",
                "Ukunzu",
                "Ukwu-Nzu",
                "Ubulubu"
            ],
            "Aniocha South": [
                "Aba Unor",
                "Abugba",
                "Adonta",
                "Ani Usi",
                "Aniefume",
                "Anifekide",
                "Ashama",
                "Azabba-Ogwashi",
                "Azamu",
                "Egbudu",
                "Edo-Ogwashi",
                "Ejeme",
                "Ejeme Aniogo",
                "Ewulu",
                "Isah-Ogwashi",
                "Isheagwu",
                "Nkpulu Camp",
                "Nsukwa",
                "Obi Adigwe",
                "Obi Anigala",
                "Obi Ashimili",
                "Obi Chukuji",
                "Obi Dugbo",
                "Obi Emenen",
                "Obi Nti",
                "Obi Okonkwo",
                "Obi Owodi",
                "Ogidi",
                "Ogwashi-Uku",
                "Olodu-Ogwashi",
                "Otulu-Ogwashi",
                "Ubulu",
                "Ubulu-Okiti",
                "Ubulu-Unor",
                "Ubulu-Uku",
                "Umudike",
                "Umute"
            ],
            "Bomadi": [
                "Adobu",
                "Agoloma",
                "Akugbene",
                "Aven",
                "Bomadi",
                "Bolou-Angiama",
                "Bolou-Apelebiri",
                "Ekametagbene",
                "Esama",
                "Ezebiri",
                "Gbaregolo",
                "Kolafiogbene",
                "Kpakiama",
                "Oboro",
                "Ogbeinyama",
                "Ogriagbene",
                "Ogundobiri",
                "Okoloba",
                "Okpokhunu",
                "Ogo-Eze",
                "Odorubu",
                "Odurubu",
                "Toru-Angiama",
                "Toru-Apelebiri",
                "Uduobori",
                "Uduophori"
            ],
            "Burutu": [
                "Abadiama",
                "Abadima",
                "Agbodobiri",
                "Akparemogbene",
                "Amasuomo",
                "Ayakoromo",
                "Biokorgha",
                "Bolu-Ojobo",
                "Boluo-Tamigbe",
                "Botu-Mangbebe",
                "Bulou-Ndoro",
                "Bulou-Tebegbe",
                "Burutu",
                "Douebido-Zion",
                "Dunu-Ogusu",
                "Egodor",
                "Egolegbene",
                "Edegbene",
                "Ekogbene",
                "Ekumugbene",
                "Ekorogbene",
                "Founkoro-Gbene",
                "Gbekebor",
                "Isreallo-Zion",
                "Iduwuni",
                "Kalafiognene",
                "Kenlogbene",
                "Kiagbo",
                "Kolorugbene",
                "Mien/Ogbulubiri",
                "Ngbilebiri",
                "New Town",
                "Nikorogha",
                "Obatebe",
                "Oboro",
                "Ogbene",
                "Ogbogbabene",
                "Ogbeingbene",
                "Ogbolubiri",
                "Ogulagha",
                "Odimodi",
                "Okuama",
                "Opuapale",
                "Osamayigben",
                "Operemor",
                "Rougbene",
                "Seimibiri",
                "Toubo Town",
                "Toumo",
                "Toru-Temigbe",
                "Torugbene",
                "Yayorogbene",
                "Yobebe",
                "Yokrisobo",
                "Zion-Oyagbene"
            ],
            "Isoko North": [
                "Aja",
                "Akiewe",
                "Anthony",
                "Aradhe",
                "Christopher",
                "Dosiah",
                "Ebregbegbu",
                "Edhemoko",
                "Egbahe",
                "Egubi",
                "Ehor",
                "Ekiugbo",
                "Ellu",
                "Emevor",
                "Eniagbedhi",
                "Enuru",
                "Erioja",
                "Eruwha",
                "Ewhokpokpo",
                "Ewhusigba",
                "Eyaziaru",
                "Ige",
                "Idoni",
                "Ilaya",
                "Iluelogbo",
                "Inime",
                "Itebiege",
                "Ivragbo",
                "Iwride",
                "Iyede",
                "Okpe",
                "Okpaile",
                "Okeleza",
                "Okoro",
                "Okwegbede",
                "Omoka",
                "Omokpara",
                "Omenaka",
                "Oteri",
                "Otor",
                "Ougbe",
                "Ougheghe",
                "Oughwe",
                "Ovwodo",
                "Ozoro",
                "Oyaro",
                "Ozozoro",
                "Ubirioho",
                "Ughusi",
                "Urueme",
                "Urude",
                "Utathe"
            ],
            "Isoko South": [
                "Abale",
                "Aberuo",
                "Awa-Igbide",
                "Akasa",
                "Aladhe",
                "Amiere",
                "Anleze",
                "Araya",
                "Arloya",
                "Asowakpe",
                "Atakene",
                "Aviara",
                "Awara",
                "Bethel",
                "Bly",
                "College",
                "Egbeme",
                "Ekeme",
                "Ekparekpa",
                "Egbo",
                "Egwe",
                "Egwe-Camp-I",
                "Egwe-Camp-2",
                "Enoko",
                "Enuado",
                "Enhwe",
                "Emonina",
                "Emesonye",
                "Enuado-Camp",
                "Erowha",
                "Ewhoke",
                "Ewhoke-Camp",
                "Ewhokpaka",
                "Ewokpaso",
                "Eziama",
                "Eziafor",
                "Ezede",
                "Ibor",
                "Igbide",
                "Igbide-Ivori",
                "Igbariam",
                "Ikpide",
                "Ikiagbodo",
                "Ikiakutu",
                "Idheze",
                "Idike",
                "Ididiri",
                "Idudu",
                "Ighomareno",
                "Ighomerehor",
                "Iwhre-Otoga",
                "Iwhre-Otoga-Camp",
                "Iwhrenuawor",
                "Iwhrewokpe",
                "Iwhre-Kokro",
                "Iwhre-Isha",
                "Iwre",
                "Iwreagba",
                "Iwre-Anibeze",
                "Iwre-Ekpo",
                "Iwre-Mede",
                "Iwre-Okoro",
                "Iwre-Ogilala",
                "Iwre-Oto",
                "Iwre-Otoga",
                "Iwre-Tugh",
                "Iwre-Urhobo",
                "Iwrewekpe",
                "Iwri",
                "Iwri-Ogilala-Camp",
                "Iwritendza",
                "Iwriwokpe",
                "Joseph",
                "Kenan",
                "Lagos",
                "Longhes",
                "Makowere",
                "Mbiabong",
                "Mbak",
                "Nando",
                "Nneyi",
                "Nnadi",
                "Nisoye",
                "Nkwonando",
                "Ogbu",
                "Odoga",
                "Odekpe",
                "Ogbirissa",
                "Oke",
                "Okapao",
                "Okpakefe",
                "Okparude",
                "Olomoro",
                "Onomator",
                "Omoato",
                "Omu",
                "Okpadoghi",
                "Okosun",
                "Ozeriwe",
                "Ozigbo",
                "Ozigbo-Camp",
                "Otoka",
                "Owodokpokpo",
                "Ozariwi",
                "Umuabia",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuoba",
                "Umu Udenze",
                "Umuezeunu",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor",
                "Uroroke",
                "Uruovo"
            ],
            "Ndokwa East": [
                "Abalagada",
                "Abara-Obodo",
                "Abara-Uno",
                "Abare",
                "Abo",
                "Aboh",
                "Abuator",
                "Afiankwo",
                "Akarai",
                "Akarai-Eti",
                "Akarai-Obodo",
                "Ashaka",
                "Ashaka-Okpai",
                "Ashibalam",
                "Asaba-Ase",
                "Asaba-Ashaka",
                "Ase",
                "Azu-Aboh",
                "Ede-Agiliga",
                "Ede-Ugbama",
                "Ekpe",
                "Eke-Okpokri",
                "Ekelegbesi",
                "Egwedhe",
                "Ibedeni",
                "Ibrede",
                "Igbuku",
                "Ise-Ogboko",
                "Ise-Onukpor",
                "Iselegu",
                "Iwene",
                "Iyede-Ame",
                "Iyowu",
                "Kamaro",
                "Lagos-Iyede",
                "Mili-Uku",
                "Nwukpe",
                "Obadoyibo",
                "Obi-Anwu",
                "Obi-Ekuku",
                "Obi-Igbo",
                "Obi-Izeh",
                "Obi-Mgbaragu",
                "Obi-Usuani",
                "Obiaka",
                "Obikwele",
                "Obiofu",
                "Obodobra",
                "Obodo-Ugbome",
                "Obieki",
                "Obo",
                "Ogbeti",
                "Ogbodigbo",
                "Ogboti",
                "Ogborgu",
                "Okoliko",
                "Okpa",
                "Okpai",
                "Okpai-Obeze",
                "Okpai-Oluchi",
                "Okpokri",
                "Olo",
                "Oloe",
                "Oloai",
                "Oloru",
                "Olubor",
                "Omuokpala",
                "Osafu",
                "Osifo",
                "Osumei",
                "Onogbokor",
                "Onuah",
                "Onuaboh",
                "Onya",
                "Osekwenike",
                "Ossissa",
                "Otu",
                "Utchi",
                "Utu",
                "Utu-Okwume",
                "Utuoku",
                "Utuoko",
                "Umuabia",
                "Umu-Inalu",
                "Umu-Ijolo",
                "Umu-Udenze",
                "Umuaghu",
                "Umuagulu",
                "Umuochi",
                "Umuogu",
                "Umuokpala",
                "Umuokpoto",
                "Umu Udenze",
                "Umuechi-Obiofu",
                "Umuechi-Osuani",
                "Umuezeunu",
                "Umueleri",
                "Umugome",
                "Umuihu",
                "Umuleri",
                "Urualor",
                "Ushie",
                "Utuechi",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume"
            ],
            "Ndokwa West": [
                "Abbi",
                "Amorji",
                "Eweshi",
                "Emu",
                "Emu-ebendo",
                "Emu-Iyasele",
                "Emu-Obiogo",
                "Emu-Obodeti",
                "Emu-Uno",
                "Etua-Uno",
                "Ibabu",
                "Ike-Onicha",
                "Ijeze",
                "Imam-Abbi",
                "Igbe",
                "Isumpe",
                "Ndemili",
                "Ogbe-Ogume",
                "Ogbeani",
                "Ogbagu",
                "Ogbole",
                "Ogute",
                "Oliogo",
                "Onicha-Ukwuani",
                "Utagba Ogbe",
                "Utagbe-Uno",
                "Umuchime",
                "Umusadege",
                "Umusam",
                "Umusedeli",
                "Umuseti"
            ],
            "Oshimili North": [
                "Abah-Unor",
                "Abodei",
                "Achaiia",
                "Adonte",
                "Aganike",
                "Akwukwu-Igbo",
                "Ajaji",
                "Ani-Egbune",
                "Ani-Usi",
                "Anifekide",
                "Aniagbala",
                "Anioma",
                "Ashaba-Ubulu",
                "Azamu",
                "Azagba-Ogwashi",
                "Ebu",
                "Edo-Ogwashi",
                "Ekpechor",
                "Egbudu-Akah",
                "Ezukwu",
                "Iyiaga Oshimili",
                "Ibusa",
                "Idumuisagba",
                "Isah-Ogwashi",
                "Machakolo",
                "Mgbago",
                "Nando",
                "Nneyi",
                "Nnadi",
                "Nisoye",
                "Nkwonando",
                "Ngene",
                "Nsuwa",
                "Ogbeani",
                "Ogbe-ani",
                "Ogbe-iase",
                "Ogbeobi",
                "Ogbeolu",
                "Ogbeonaje",
                "Ogbeowe",
                "Ogboli",
                "Ogo",
                "Ogbu",
                "Ogwashi-Uku",
                "Okenta",
                "Okemokrudu",
                "Oko-Anala",
                "Oko-Okwe",
                "Onya",
                "Obi Adigwe",
                "Obi Anigala",
                "Obi Chukwuji",
                "Obi Emenem",
                "Obi Isimili",
                "Obi Nti",
                "Obi Okonkwa",
                "Obi Onwordi",
                "Olodu",
                "Olloh-Ogwashi",
                "Otulu-Ogwashi",
                "Ubulu",
                "Ubulu-Edoe",
                "Ubulu-Okiti",
                "Ubulu-Uku",
                "Ubulu-Unor",
                "Udo",
                "Ugwuaru",
                "Ugwume",
                "Umuagwu",
                "Umuehea",
                "Umuekea",
                "Umueze",
                "Umuezeagwu",
                "Umuodafe",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umuenini",
                "Umueleri",
                "Umuoba",
                "Umu Udenze",
                "Umuleri",
                "Urualor",
                "Usebe",
                "Ukwu-Agbonor",
                "Ukwumage",
                "Ukpologwu",
                "Ubaronisioye",
                "Ubaru"
            ],
            "Oshimili South": [
                "Abala",
                "Anala",
                "Aniocha Camp",
                "Anusai",
                "Anwai",
                "Asaba",
                "Cable Point",
                "Ezenei",
                "Georges",
                "Isieke",
                "Iyiba",
                "Obi Okpu",
                "Obo",
                "Oko",
                "Oko Amakom",
                "Oko Anara",
                "Okogbele",
                "Umuagu",
                "Umuaji",
                "Umueze",
                "Umuezei",
                "Umuonaje",
                "Utuaja"
            ],
            "Patani": [
                "Abari",
                "Aven",
                "Bolou-Angiama",
                "Bolou-Apelebiri",
                "Kabowei",
                "Koloware",
                "Kumboei",
                "Odoruba",
                "Oporoza",
                "Patani",
                "Toru-Angiama",
                "Toru-Apelebiri",
                "Uduophori"
            ],
            "Sapele": [
                "Sapele Town",
                "Amukpe",
                "Oghara",
                "Elume",
                "Ogiedi",
                "Okuovu",
                "Ugborhen",
                "Ugbeyiyi"
            ],
            "Udu": [
                "Aladja",
                "Enerhen",
                "Ekete",
                "Egini",
                "Emadadja",
                "Emogun",
                "Ovwian",
                "Owhrode",
                "Otor-Udu",
                "Oleri",
                "Ovworhokpokpo",
                "Oghior"
            ],
            "Ughelli North": [
                "Afiesere",
                "Agbarha-Otor",
                "Agbarho",
                "Ekiugbo",
                "Ekredjebor",
                "Evwreni",
                "Orogun",
                "Oteri",
                "Otovwodo(Ughelli)",
                "Uwheru"
            ],
            "Ughelli South": [
                "Ekakpamre",
                "Ekete",
                "Ekrejegbe",
                "Ewu",
                "Gbaregolor",
                "Oginibo",
                "Okparabe",
                "Olomu",
                "Otokutu",
                "Ovwor",
                "Owhawha",
                "Owhrode",
                "Ughoton",
                "Ujevwu",
                "Ughievwen",
                "Usiefrun"
            ],
            "Uvwie": [
                "Ekpan",
                "Effurun",
                "Enerhen",
                "Jeddo",
                "Ugbomro",
                "Ugbolokposo",
                "Ugboroke",
                "Ugbuwangue"
            ],
            "Warri Central": [
                "Ajao",
                "Ijala",
                "Jude",
                "Mojere",
                "Ode-Itsekiri",
                "Osubi",
                "Warri"
            ],
            "Warri North": [
                "Ajao",
                "Bateren",
                "Egbokodo",
                "Effurun-Otor",
                "Gbokoda",
                "Koko",
                "Mofor",
                "Okpe",
                "Okwagbe",
                "Otefe"
            ],
            "Warri South": [
                "Ekpan",
                "Jesse",
                "Koko",
                "Oginibo",
                "Udu",
                "Warri"
            ],
            "Warri South West": [
                "Beneath",
                "Effurun-Otor",
                "Forcados",
                "Ogorode",
                "Sapele",
                "Warri"
            ]
        }
    },
    {
        "Ebonyi": {
            "Abakaliki": [
                "Abakpa",
                "Amachi",
                "Amagu",
                "Amagu Unuhu",
                "Azumini",
                "Azuiyi",
                "Edda",
                "Izzi",
                "Ndiagu",
                "Okpoitumo",
                "Timber Shed"
            ],
            "Afikpo North": [
                "Afikpo",
                "Amachara",
                "Amachi",
                "Amaekwu",
                "Amaizu",
                "Amangbala",
                "Amangwu",
                "Amankwo",
                "Amaobolobo",
                "Amauro",
                "Amauzu",
                "Amuku",
                "Egeburu",
                "Enohia-Item",
                "Enohia-Ntalu",
                "Evuma",
                "Itim",
                "Kpogirikpo",
                "Mgbom",
                "Ngodo",
                "Nkpogoro",
                "Ohaisu",
                "Ubam",
                "Ugwu-Egu",
                "Ugwuegu"
            ],
            "Afikpo South": [
                "Amasiri",
                "Agbogo",
                "Agbop",
                "Akanto",
                "Ama-Inyima",
                "Amachara",
                "Amacharaji",
                "Amaegbu-Ezeke",
                "Amakuma-Ezeke",
                "Amaozara",
                "Amaozara-Ndukwe",
                "Amiy-Ndukwe",
                "Ebunwana",
                "Egboha-Amuro",
                "Elugo-Amakpu",
                "Elu-Ogo",
                "Eziama-Ndukwe",
                "Ihie-Agbo",
                "Ihie-Amorie",
                "Ihie-Elu",
                "Imoji",
                "Ndi-Uko-Amuro",
                "Ndiakpu",
                "Nguzu Edda",
                "Orra",
                "Ogbu Edda",
                "Oso Edda",
                "Owutu Edda",
                "Umunna",
                "Amaigbo",
                "Amikpo",
                "Amorie",
                "Amangwu Edda",
                "Etiti Edda",
                "Itim Edda"
            ],
            "Ebonyi": [
                "Abakaliki",
                "Agalegu",
                "Akpanya",
                "Ameta",
                "Amechara",
                "Amagu",
                "Amachi",
                "Amachi-Amagu",
                "Amachi-Onuteta",
                "Amaechara-Nkaleke",
                "Amuawor",
                "Ananchi-Nkaleke",
                "Aniekwem",
                "Alibaruhu",
                "Alike",
                "Amozo",
                "Azama-Agbaja",
                "Azuebirigba-Agbaja",
                "Azugwu-Agbaja",
                "Azuiyokwu-Agbaja",
                "Atakol",
                "Azu-Uda-Echara",
                "Azu-Uda-Eda-Echora",
                "Azuabe",
                "Azuoto",
                "Edoma",
                "Edufu-Akparata",
                "Echegu-Nkaleke",
                "Ede-Echara",
                "Edi-Nkaleke",
                "Eziagulu",
                "Eziama",
                "Eziafor",
                "Eziagulu-Otu",
                "Ekwemo",
                "Ekebe",
                "Enwuagba",
                "Enyibuchiri",
                "Enyiagba",
                "Ezilulo-Eda-Echara",
                "Igbegu-Amagu",
                "Igbariam",
                "Ime-Abali",
                "Isiokwe",
                "Ivite",
                "Ishihumini",
                "Ishile",
                "Izenyi",
                "Ishi-Nwachi-Ntezi",
                "Izzilokwo",
                "Mgbabeluzor",
                "Mgbabo",
                "Mgbalukwu-Amagu",
                "Mbak-Ikot-Abasi",
                "Mbak-Abasi",
                "Mbukobe-Ntezi-Aba",
                "Ndiabo-Ofoke",
                "Ndi-Igboke",
                "Ndioke",
                "Ndiukabi",
                "Ndo-Echara",
                "Ndik-Ofoke",
                "Ndo-Mgbabo-Echara",
                "Ndo-Opfunyionu",
                "Ndokwase-Echara",
                "Ndoketa",
                "Ndieb-Agbaja",
                "Ndieze-Amagu",
                "Ndieze-Nkaleke",
                "Ndugbaleze",
                "Ndu-Ak-Eda-Echara",
                "Ndebo-Aghamohu",
                "Ndebo-Ede-Echara",
                "Ndebo-Mgbabo-Echara",
                "Ndebo-Opfunyionu",
                "Ndeboshi-Oku",
                "Ndingwutu",
                "Ndiofutu",
                "Ndiudara",
                "Nwanwu",
                "Nwogodo-Echara",
                "Obeagu",
                "Obegu",
                "Obegu-Aba-Onu-Oji",
                "Obegu-Aba-Ekpido",
                "Obegu-Abaofra",
                "Obegu-Opfunyionu",
                "Obo-Ofoke",
                "Ochobu-Okum",
                "Odiofia-Echara",
                "Odomoke",
                "Ofe-Iyi-Okwu",
                "Ogbuchia",
                "Ogada",
                "Ogugu-Etiti",
                "Ohatekwe",
                "Okaria",
                "Okaria-Echi",
                "Okpitumo-Amangu",
                "Okpu",
                "Okpanku",
                "Okwefurike",
                "Olua",
                "Omorodu",
                "Onu-Akpara",
                "Onugwa",
                "Onyikwa",
                "Onyirigbo",
                "Oshimaka",
                "Oterufie",
                "Ovuoba",
                "Ubegu-Odeligbo",
                "Ubegu-Omege",
                "Ubaronisioye",
                "Ubaru",
                "Ugbana",
                "Ugwuaru",
                "Ugwume",
                "Umuabia",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuoba",
                "Umu-Udenze",
                "Umuezeunu",
                "Umuleri",
                "Urualor",
                "Uwarem",
                "Uwalakabe"
            ],
            "Ezza North": [
                "Achara-Ezza",
                "Abam",
                "Amebia",
                "Ekerigwe",
                "Ndiagu",
                "Ndioffia",
                "Ndufu Ukwuachi",
                "Ndufu-Amelu",
                "Ndufu-Azuinyirigwu",
                "Ngbogoroafunu",
                "AmaEzekwe",
                "Agbakoro",
                "Eguefium",
                "Iddao",
                "Ndegeazu",
                "Nudufu",
                "Omege",
                "Amagu",
                "Ekwetekwe",
                "Ekwurukwu",
                "Enyim",
                "Igbeagu",
                "Ikwerikwo",
                "Isiofffia",
                "Ndufu Ndeguazu",
                "Odeligbo",
                "Ohaigbo",
                "Ohaoffia",
                "Okeagba",
                "Oshugbo",
                "Ugbodo",
                "Ugbonia",
                "Amana",
                "Agbamegidi",
                "Aghamehu",
                "Amefi",
                "Egogbo",
                "Eguazuwhu I",
                "Ndeguazu",
                "Ndiagu Okaria",
                "Ndufu",
                "Ohaike",
                "Ohuoguazuwhu II",
                "Okaria",
                "Tatakwu",
                "Amawula",
                "Effium",
                "Egwudilegu",
                "Nkporume",
                "Umuefi",
                "Amazu",
                "Amuda",
                "Enyima",
                "Ndiaguazu",
                "Ndufu I",
                "Ndufu II",
                "Ngbo",
                "Ntezi",
                "Onoffia",
                "Onueke",
                "Ameka",
                "Amagim",
                "Amalekwune",
                "Amaogwe",
                "Ihoto",
                "Ndiaguazu-Amajim",
                "Ndiaguazu-Amalekwune",
                "Ndufu-Amalokwune",
                "Ikeregu",
                "Ojorokpo",
                "Agbaja",
                "Akwunagu",
                "Anyadilogu",
                "Equinyima",
                "Ndueguazu",
                "Nduwhu",
                "Odoko",
                "Ohetekwe",
                "Okpagu",
                "Ekka",
                "Azu-Ugwu",
                "Azuakparata",
                "Egu Eke",
                "Ekka Village",
                "Integration",
                "Ugrodo",
                "Ezzama",
                "Ameta",
                "Ekelebi",
                "Ishieke",
                "Ndiagakp",
                "Ohanya",
                "Okaleka-Opazeka",
                "Onicha",
                "Onunwafor",
                "Orokonu",
                "Ikwato Idembia",
                "Amaparata",
                "Azueseikpa",
                "Azuide",
                "Inyimagu",
                "Ndufu-Ide",
                "Ngambo",
                "Ochuhuagba",
                "Odagere",
                "Ohaffia",
                "Ohage",
                "Ohangbe",
                "Onugbo",
                "Onuorieagu",
                "Ugwuogo",
                "Ugwuogo Agu",
                "Inyere",
                "Umuechem",
                "Umuobi",
                "Nkomoro",
                "Azuafor",
                "Igweledoha",
                "Obike",
                "Ohinya",
                "Omegu",
                "Onuafor",
                "Udenyi",
                "Nsokara",
                "Amachi",
                "Amaefi",
                "Egwudinagu",
                "Ekebengwene",
                "Izekwe",
                "Ohankwu",
                "Okffia",
                "Agukwuchie",
                "Ananchi",
                "Azuagu",
                "Enigwe",
                "Evirigu",
                "Ezufu",
                "Igwefere",
                "Nwakparata",
                "Obioma",
                "Ofutu",
                "Ogbenu",
                "Oguzaraonweya",
                "Ojiegbo",
                "Okalieru",
                "Onuagbonyi",
                "Uhuagba",
                "Oriuozor",
                "Umuezeali",
                "Umuezekwe",
                "Umuigboke",
                "Umuome",
                "Umuouru",
                "Ugboji",
                "Achiagu",
                "Akpurata",
                "Azuinyima",
                "Ebushike",
                "Mgbalibe",
                "Ndiegu",
                "Obaju",
                "Ogbojiegu",
                "Ohuola",
                "Onunworie",
                "Umuezeoka",
                "Ndegu",
                "Umuezeokaoha",
                "Anyagharigwe",
                "Ededegu",
                "Ndeagazu",
                "Ohatekwe",
                "Okaleru",
                "Okposi",
                "Oshiegbe",
                "Owunweke",
                "Ugbona",
                "Umunw-Agu",
                "Akpugo",
                "Amagbia",
                "Enurim",
                "Enya-Gharaigwe",
                "Enyadilogu",
                "Eziga",
                "Omaji",
                "Orogbodo",
                "Orokome",
                "Umuoga-Hara",
                "Oghara Ugo"
            ],
            "Ezza South": [
                "Amagu",
                "Amana",
                "Ameka",
                "Amudo",
                "Amuzu",
                "Amaezekwe",
                "Echara",
                "Ezzama",
                "Ikwuator",
                "Idembia",
                "Onueke",
                "Umunwagu"
            ],
            "Ikwo": [
                "Abina",
                "Agalagu",
                "Agubata",
                "Agubata-Ndufu",
                "Aguinyima",
                "Akahaufu",
                "Akahufu",
                "Akataka",
                "Akpan-Wudele",
                "Amain-Yima",
                "Amanguru",
                "Amchara",
                "Amokpo",
                "Amuna",
                "Ebiem",
                "Echare-Ukwu",
                "Eka-Awoke",
                "Elugu",
                "Enyibichiri-Alike",
                "Enyigwuchiri",
                "Enyim",
                "Enukpeofia",
                "Ebusieike",
                "Etim-Ekpuitumo",
                "Ezeke",
                "Igbudu",
                "Igbudun",
                "Igoledoba",
                "Ifelemenu",
                "Imabali",
                "Imenduru",
                "Imogo",
                "Inyimagu",
                "Inyimagu-Amaka",
                "Ishieke",
                "Izo",
                "Ivakpa",
                "Ndiagu",
                "Ndiagu-Achara",
                "Ndiagu-Enyibichiri",
                "Ndiaguazu",
                "Ndiogu",
                "Ndieke",
                "Ndioduma",
                "Ndiona",
                "Ndialegu",
                "Ndifu-Alike",
                "Ndiechi",
                "Ndiechi-Ndiagu",
                "Ndiofia",
                "Ndiofoke",
                "Ndufu-Achara",
                "Ndufu-Amagu",
                "Nduku",
                "Nkwonando",
                "Nsobo-Okwuenyim",
                "Nsuba",
                "Nzashi",
                "Nzeshi",
                "Okpara",
                "Okpotokum",
                "Ochieyin",
                "Ochokwu",
                "Ofenekpa",
                "Oferekpe",
                "Oferekpe Nkalfor",
                "Obegu",
                "Obegu-Ohatekwe",
                "Obeagu-Ndinwese",
                "Obeagu-Ndinwosa",
                "Obuluechi-Ndiechi",
                "Obuluechi-Ndiewese",
                "Obuluechi-Ohatekwe",
                "Ogagbo",
                "Ogidiga",
                "Ogwuari",
                "Omege",
                "Omege-Ameka",
                "Onuofia-Ndiagu",
                "Onyikwa",
                "Orona",
                "Otuocha",
                "Ubaronisioye",
                "Ubaru",
                "Uduku",
                "Umueh",
                "Umuamievili",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umuenini",
                "Umueleri",
                "Umuabia",
                "Umuoba",
                "Umu Udenze",
                "Umuezeunu",
                "Umuleri",
                "Ugwueke",
                "Ugwuefor",
                "Ugwuaru",
                "Ukwenyim",
                "Utaba"
            ],
            "Ishielu": [
                "Aba-Ohofia",
                "Abalagbo",
                "Achara",
                "Agba",
                "Agbaelu",
                "Agbaelu-Aguabonyi",
                "Agu-Ogbugo",
                "Aguachara",
                "Aguedene",
                "Aguefi",
                "Agulime",
                "Agunecheonweya",
                "Aguozu",
                "Akwusakwu",
                "Amachima",
                "Amagu",
                "Amagu-Agba",
                "Amorie",
                "Amuogu",
                "Amukpa",
                "Amaegu",
                "Amaokwe",
                "Amazu",
                "Amanankwa",
                "Amanvu",
                "Amaleze",
                "Amohi",
                "Amuhuba",
                "Amuieka",
                "Anyima",
                "Azuofia",
                "Azuogbagu",
                "Azunyaba",
                "Biledeba",
                "Egbelegu",
                "Ebusieike",
                "Ebusike",
                "Edemngwu",
                "Egwudinagu",
                "Emezu",
                "Ebieji",
                "Ekwetekwe",
                "Enugu",
                "Enugu-Otu",
                "Eziagulu",
                "Eziagulu-Otu",
                "Eziama",
                "Eziafor",
                "Ezillo",
                "Ezzagu",
                "Egedegede",
                "Egge-Egde",
                "Ekpri Nsukara",
                "Eniong Offot",
                "Effiat Offot",
                "Ewet Offot",
                "Ibiaku Offot",
                "Idung Ekpa Uyo",
                "Ikot Akpa Eda",
                "Ikot Akpa Oku",
                "Ikot Ebido",
                "Ikot Ntuen-Oku",
                "Ikot Oku",
                "Ikot Udoro",
                "Idung Eka Uyo",
                "Idung Idem Udo",
                "Idung Uko Udo",
                "Idung Urum Iso",
                "Ikot Akpa Nkuk",
                "Ikot Akpan Eyara",
                "Ikot Enang",
                "Ikot Ibekwe",
                "Ikot Iyang Udo 1",
                "Ikot Iyang Udo 11",
                "Ikot Odiong",
                "Ikot Udo Abia",
                "Ikot Uko Obobo",
                "Ikot Ukpong",
                "Ikot Una",
                "Ikot-Inyang Abia",
                "Ikot Akpa Idem",
                "Ikot Akpan Afaha",
                "Ikot Andem",
                "Ikot Awak",
                "Ikot Dappa",
                "Ikot Edong",
                "Ikot Effiong",
                "Ikot Essien",
                "Ikot Etim",
                "Ikot Ikang",
                "Ikot Ikpe",
                "Ikot Iwara",
                "Ikot Obong",
                "Ikot Oto-Iwuo",
                "Ikot Owure",
                "Ikot Udo-Ossiom",
                "Odoro Ikot",
                "Usung Atiat",
                "Ukanafun",
                "Southern Ukanafun",
                "Edem Idim",
                "Nkek",
                "Nyak Zba",
                "Obon Odor",
                "Okoyo",
                "Okpoto",
                "Omege",
                "Onueke",
                "Onugwa",
                "Oroma Etiti",
                "Onuoji",
                "Onunwafor",
                "Onunwankwo I",
                "Onunwankwo II",
                "Onunweke",
                "Onuebonyi-Onunwankwo",
                "Ugboenyim",
                "Umuamievili",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuoba",
                "Umu Udenze",
                "Umuezeunu",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor"
            ],
            "Ivo": [
                "Akaeze",
                "Akaeze Ukwu",
                "Ihenta",
                "Iyoji",
                "Umuobor"
            ],
            "Izzi": [
                "Agharaoza",
                "Agbaja",
                "Amaleze",
                "Amihu",
                "Amofia",
                "Amorie",
                "Amukpa",
                "Anyima",
                "Azuda",
                "Edukpachi",
                "Ezz-Inyi-Magu",
                "Igbeagu",
                "Igwekaeyim",
                "Igbunu Oiuma",
                "Isohumiri",
                "Isiege",
                "Ndiebe-Ishiagu",
                "Ndieze",
                "Ndiezeoke",
                "Ndiokpoto",
                "Ndiubia",
                "Ndiogwu",
                "Ndigwe",
                "Ndinwakpu",
                "Nwaezariyi",
                "Nwana-Omege",
                "Nuofe",
                "Offia-Okan",
                "Ochebe-Oza",
                "Ogbegum",
                "Okpoduma",
                "Opaetifia",
                "Oseokwuru",
                "Ohuruekpe",
                "Onuoji",
                "Umuakpu",
                "Umuezekoha"
            ],
            "Ohaozara": [
                "Amaeze",
                "Amaezu",
                "Amaeke",
                "Amagu",
                "Amaokwe",
                "Amaonye",
                "Amata",
                "Amegu",
                "Amelu",
                "Amelu-Agu",
                "Amenu",
                "Anaeko",
                "Anata",
                "Eziato",
                "Ihiali",
                "Ihie",
                "Ihietutu",
                "Ihenu",
                "Mebiowa",
                "Mgbom",
                "Mgbom-Achara",
                "Nguogwo",
                "Nzerem",
                "Obinagu",
                "Obiozara",
                "Ogwu",
                "Ogwor",
                "Okoposi",
                "Okposi-Okwu",
                "Ubuaba",
                "Ufuovoke",
                "Ufuezeraku",
                "Umuobuma",
                "Umuchima",
                "Umuodu-Igbo",
                "Umuifere",
                "Umuagwu-Oke",
                "Umuaneketa",
                "Umuanum",
                "Umuka",
                "Umunuka",
                "Uburu",
                "Urobo",
                "Ugwu-Langwu"
            ],
            "Ohaukwu": [
                "Abarigwe",
                "Abogodo",
                "Agu",
                "Aguachi",
                "Aguorie",
                "Agu Ugwu",
                "Akamanator",
                "Akata",
                "Akpalagbo",
                "Amechi",
                "Amike",
                "Amogu",
                "Amuawor",
                "Amaunu",
                "Amuleri",
                "Aniekwem",
                "Andem",
                "Amava",
                "Atakol",
                "Azuedene",
                "Ekendiagu",
                "Ekwelekwe",
                "Ekwashi",
                "Ekwashi Mgbo",
                "Ekuenyi",
                "Enugu",
                "Enugu-Otu",
                "Eziagulu",
                "Eziagulu-Otu",
                "Eziama",
                "Eziafor",
                "Effia Ule Atani",
                "Effia-Ulo",
                "Egu Ojo",
                "Egwegwu",
                "Ekweburu",
                "Eguenyi I",
                "Eguenyi II",
                "Eguojaba",
                "Egwudinagu",
                "Ekpe",
                "Ikot Akpan Eyo",
                "Ikot Akpan Inyang",
                "Ikot Akpan-Ebo",
                "Ikot Antia",
                "Ikot Anuwo",
                "Ikot Arankere",
                "Ikot Ebok",
                "Ikot Edem Ewa",
                "Ikot Edung",
                "Ikot Ekpankpe",
                "Ikot Ndot",
                "Ikot Udo",
                "Ikot Udo Iyak",
                "Ikot Udo Mbang",
                "Ikot Udo Mbang/Afaha Obo",
                "Ikot Uram",
                "Ikot Utiat",
                "Ikot Wkpankpe",
                "Ikot-Ekpat",
                "Ikot-Udoro",
                "Ikot-Obio",
                "Igbodu-Oke",
                "Igbariam",
                "Igboezunu",
                "Imieyom",
                "Inikiri",
                "Inikiri Bernard",
                "Isiokwe",
                "Ivite",
                "Iton Ikono",
                "Igbudu-Oke",
                "Ndiagu Agba",
                "Ndiagu Akpu",
                "Ndiagu Anwu",
                "Ndiagu Eze",
                "Ndiagu Iyiogue",
                "Ndiagu Idaja",
                "Ndiagu Obu",
                "Ndiagu Obu Ameffia",
                "Ndiagu Oshisha",
                "Ndiagu Udu",
                "Ndiagu Ubia",
                "Ndiagu-Ndulo",
                "Ndiagu-Obegu",
                "Ndiulo",
                "Ndiulo Amefia",
                "Ndiulo Ukwagba",
                "Nkek",
                "Nkwolu",
                "Nkwonando",
                "Ndiegu Akparata",
                "Ndiegu Eke-Ochie",
                "Ndiegu-Obuegu",
                "Ndiegu Obashi",
                "Nkwo-Oji",
                "Nwokwo Umueze",
                "Ogbu",
                "Ogbagede",
                "Ogbeda",
                "Ogugu-Etiti",
                "Ogwuari",
                "Okeali",
                "OkpaAgba",
                "Okpo",
                "Okpopri",
                "Okpokoro",
                "Okporo",
                "Okwerike",
                "Ezzamgbo",
                "Obodo",
                "Obodo-Otu",
                "Obomanagu",
                "Ogbodo",
                "Okoroko",
                "Okorogbata",
                "Okpochiri",
                "Onu Inikiri",
                "Onuzuo Igwe",
                "Onu igbe",
                "Onuebetta",
                "Onwe",
                "Onuigwe",
                "Onunwokporo Okpudu",
                "Oroma Etiti",
                "Oshia Ituma",
                "Osha Egu",
                "Otuokpye",
                "Otuokpeye",
                "Umuagara",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuoba",
                "Umu Udenze",
                "Umuezeunu",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor"
            ],
            "Onicha": [
                "Abaomege",
                "Agbabor",
                "Agueke",
                "Amainyima I",
                "Amainyima II",
                "Amakporor",
                "Amangwu",
                "Amajoe",
                "Amaokwe",
                "Amaokpara",
                "Amatu",
                "Amofia",
                "Amuobo I",
                "Anike I",
                "Anike II",
                "Anumocha",
                "Azueonyi-Sub-Village",
                "Ebusirike",
                "Ezekporoke",
                "Eziga",
                "Isiama I",
                "Isiama II",
                "Isieke",
                "Isinkwo",
                "Isu-Achara",
                "Iyiazu",
                "Mboji",
                "Mbala Ukwu",
                "Mgbelaeze",
                "Ntika/Ntiabor",
                "Okaria",
                "Okuzu I",
                "Okuzu II",
                "Okuzu Ngu-Enyi",
                "Okworike",
                "Obeagu",
                "Ojiegbe",
                "Omege",
                "Onicha",
                "Oshiri",
                "Owom",
                "Ufuezokwu",
                "Ugwudiala",
                "Ugwuenu",
                "Umubo II",
                "Umuezikwu",
                "Umuafia",
                "Umuimam",
                "Umumboke",
                "Umuorie",
                "Umuobo I",
                "Umunika",
                "Umumgbala"
            ]
        }
    },
    {
        "Edo": {
            "Akoko-Edo": [
                "Aiyetoro",
                "Akuku",
                "Akuku-Ewan",
                "Anyawozo",
                "Atte",
                "Bekuma",
                "Dangbale",
                "Egbigere",
                "Ekor",
                "Ekpe",
                "Ekpedo",
                "Eshawa",
                "Ibillo",
                "Ikiran-Oke",
                "Ikiren-Ile",
                "Ikpeshi",
                "Ikpeshi-Egbegbere",
                "Imorgn",
                "Lampese",
                "North Akoko",
                "North-East Akoko",
                "Okpe",
                "Okpe-Ijaja",
                "Okukusho",
                "Oloma",
                "Oneme-Nekhua",
                "Onomu",
                "Ososo",
                "Ojirami-Oke",
                "Ojiranu-Petesi",
                "Samorika",
                "Sasaro",
                "Uneme-Osu",
                "Utua-Ufa"
            ],
            "Egor": [
                "Agidigbi's Camp",
                "Egor",
                "Environ Camps",
                "Evbougide",
                "Iguediayi",
                "Iguikpe",
                "Oghedaivbiobaa",
                "Oghokhugbo",
                "Oviasuyi Camp",
                "Ugbighoko",
                "Urunmwon",
                "Uwelu",
                "Uselu"
            ],
            "Esan Central": [
                "Agwa",
                "Akho",
                "Atuagbo",
                "Ebelle",
                "Egbeka",
                "Egbesan",
                "Egbiki",
                "Ekekhen",
                "Eku-Obhiosa",
                "Ekillor",
                "Eko-Akhahuabhalu",
                "Eko-Ariofolo",
                "Eko-Ehonor",
                "Eko-Imolamen",
                "Eko-Iyobhebhe",
                "Eko-Oguanlen",
                "Eko-Uwaya",
                "Eguare",
                "Ekwem",
                "Ewossa",
                "Idomu-Arebun",
                "Idomu-Iyase",
                "Idumu-Ojewa",
                "Idumu-Oweran",
                "Idumuagbodor",
                "Idumebo",
                "Idumegberan",
                "Idumemo",
                "Idumokpa",
                "Idumogbo",
                "Idumoka",
                "Idumomon",
                "Idumudogbor",
                "Idumukebho",
                "Idumuotutu",
                "Idumo Oyomon",
                "Idumoye",
                "Idumoyasele",
                "Idumoyombom",
                "Idumuoma",
                "Idumoza",
                "Iduogbale",
                "Iduwele",
                "Igueben",
                "Iyekogbe",
                "Ikegogbe",
                "Ikekato",
                "Iki",
                "Ikiewanlen",
                "Ikinaogo",
                "Imaruigho",
                "Ididigba",
                "Idigun",
                "Idinegbon",
                "Idinobi",
                "Idipo",
                "Idiyo",
                "Ikio",
                "Okho",
                "Oke",
                "Ohe",
                "Okhoromi",
                "Ologhe",
                "Okpujie",
                "Okuta",
                "Opoji",
                "Otoruwa",
                "Udomi",
                "Udowo",
                "Ugbokhare",
                "Ughalo",
                "Ughenokhua",
                "Uhaekpen",
                "Ujabhole",
                "Uneah",
                "Usenu",
                "Uwessan",
                "Uzebu",
                "Uzegu",
                "Uzoholo",
                "Ukekogbe",
                "Ukpabolele"
            ],
            "Esan North-East": [
                "Amedokhian",
                "Arue",
                "Awo",
                "Ebun",
                "Ebuin",
                "Efandion",
                "Egbele",
                "Eguare-Uromi",
                "Eko-Igene",
                "Eko Ibadin",
                "Eror",
                "Ewoyi",
                "Idinegbon",
                "Idumoza",
                "Ivue",
                "Obedu",
                "Olinlin",
                "Onewa",
                "Ubierumu Oke",
                "Udierumu Uwa",
                "Ukoni",
                "Unuwazi",
                "Utako",
                "Uwalo",
                "Uzea",
                "Ukwaza",
                "Ute",
                "Uroh"
            ],
            "Esan South-East": [
                "Abumere",
                "Abura",
                "Adagwu",
                "Adolor",
                "Akamanator",
                "Akata",
                "Akpalagbo",
                "Alla",
                "Ajakpa",
                "Ajularo",
                "Amagu",
                "Amuawor",
                "Amaunu",
                "Amuleri",
                "Aniekwem",
                "Anoma",
                "Akhiomen",
                "Auma",
                "Eguare-Ewatto",
                "Eguare-Okhuessan",
                "Eguare-Onogholo",
                "Eguare-Ubiaja",
                "Enugu",
                "Eza",
                "Eza-Ekpenyong",
                "Ezianam",
                "Ifeku",
                "Ifade",
                "Ikeken",
                "Ikiala",
                "Ikot",
                "Ikot-Ekpe",
                "Ikot-Ntan",
                "Ikot-Ofiong",
                "Ikot-Ukpong",
                "Ikomu",
                "Isiokwe",
                "Ivite",
                "Isinyi",
                "Isiekubu",
                "Iru",
                "Iyagi",
                "Iyegbe",
                "Ibo Camp",
                "Ide",
                "Ide-Imo",
                "Ide-Eho",
                "Ide-Iyasele",
                "Idumagbo",
                "Idumagbor",
                "Idumije",
                "Idumisaba",
                "Idumobo",
                "Idumowemhen",
                "Idumoshodin",
                "Igbamaka",
                "Igbokwe",
                "Idumoko",
                "Idumoh",
                "Idumoje",
                "Idumuhuan",
                "Ide-Anioma",
                "Idoma",
                "Idoma-Ekpe",
                "Idoma-Udo",
                "Inyenlen",
                "Inyelen",
                "Isoko Camp",
                "Ighara",
                "Igo",
                "OkpaAgba",
                "Okpatawo",
                "Okpokor",
                "Okpokolor",
                "Okoyoyomon Camp",
                "Okudi",
                "Okudu",
                "Olise Camp",
                "Onughwa",
                "Onughwa-Iseme",
                "Onwubuke",
                "Orogwe",
                "Oroma",
                "Orere Camp",
                "Orewuru",
                "Oruhen",
                "Orhun",
                "Osukpong",
                "Uhe",
                "Udo",
                "Udo-Neria",
                "Udo-Aduak",
                "Udo-Ehi",
                "Uduetong",
                "Ukhuanlen",
                "Ukpaja",
                "Ukpodo",
                "Ukpoke",
                "Urok",
                "Umuabia",
                "Umuokpoto",
                "Umuakw",
                "Umuoba",
                "Umu Udenze",
                "Umuezeunu",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor",
                "Ugbenin",
                "Ugbolo",
                "Ugbo",
                "Uwe",
                "Uwakpoku",
                "Uwuoma"
            ],
            "Esan West": [
                "Abia",
                "Akahia",
                "Atologa",
                "Camp",
                "Eghoro",
                "Eghoro-Amede",
                "Eghoro-Naoka",
                "Ebhoakhuala",
                "Ebhoigbon",
                "Ebhokpe",
                "Ebhordiza",
                "Ebhorua",
                "Edueki",
                "Eguare",
                "Eha-Iyekeki",
                "Ekpoma",
                "Eko-Ebutemeta",
                "Eko-Illeh",
                "Eko-Omigie",
                "Ekunalen",
                "Emaudo",
                "Emuhi",
                "Enogban",
                "Idi-Awan",
                "Idi-Esi",
                "Idi-Oboh",
                "Idi-Ogoh",
                "Idihonsi",
                "Idumeakon",
                "Idumebo",
                "Idumegan",
                "Idumemalua",
                "Idumigun",
                "Idumoza",
                "Idumuegbede",
                "Idumunegbon",
                "Igor",
                "Ihiro",
                "Ihomudumu",
                "Ikekogbe",
                "Ikhin",
                "Ileh",
                "Imule",
                "Iruekpen",
                "Iwere",
                "Lower Izogen",
                "Naoka",
                "Oaikhene Camp",
                "Ogbomo",
                "Ogehegho",
                "Oke",
                "Ofie",
                "Otaika",
                "Ogwa",
                "Ubi",
                "Udo",
                "Ueguin",
                "Uen-Ejiekhine",
                "Uen-Ogbeta",
                "Uen-Okola",
                "Uhiele",
                "Ujemen",
                "Ujoelen",
                "Ukhiodo",
                "Ukpata",
                "Ukpenu-Neka",
                "Ukpenu-Odia",
                "Ukpenu-Udia",
                "Ukpoke",
                "Ukhun",
                "Urohinagho",
                "Uvue",
                "Uwenebo",
                "Urhobo-Alamu Camp",
                "Upper Izogen",
                "Urohi",
                "Ujiogba"
            ],
            "Etsako Central": [
                "Abokpha",
                "Ake",
                "Alagbette",
                "Agbazi",
                "Anamu",
                "Ape Ojo",
                "Ape-Eshebo",
                "Apeabebe",
                "Apeagbaza",
                "Apeanethua",
                "Apeaseghiembe",
                "Apeigadumhe",
                "Apeigbiti",
                "Apeikhemhe",
                "Apeitonobi",
                "Apeiyenagbe",
                "Apeobe",
                "Apeoka",
                "Apeokhame",
                "Apeokhumhe",
                "Apeosimetha",
                "Apeowegbu",
                "Atavo",
                "Azukhala",
                "Ebelle",
                "Idegbesue",
                "Igodo",
                "Imiakebu",
                "Imiagbese",
                "Imiamune",
                "Imiegba",
                "Imiegiele",
                "Imiekhuri",
                "Imioko",
                "Imiomoka",
                "Itruogbe",
                "Iraokhor",
                "Iruru",
                "Ivieokpolo",
                "Iviegwela",
                "Iviekhebele",
                "Iviekho",
                "Ivievia",
                "Ivinone",
                "Iviadachi",
                "Iviadoko",
                "Iviagbanaku",
                "Iviagbogbidi",
                "Ivianyoba",
                "Iviapah",
                "Iviarua",
                "Iviavia",
                "Ivido",
                "Iviegwi",
                "Iviochia",
                "Iviodeakhena",
                "Iviokhile",
                "Iviokpo",
                "Iviorehbor",
                "Ivioromia",
                "Iviughelo",
                "Iviukasa",
                "Kalabar",
                "Oketo",
                "Okhu",
                "Okpoha",
                "Odugbe",
                "Ofurkpa",
                "Ogbago",
                "Oghomere",
                "Ogochi",
                "Ogwiji",
                "Ogugu-Etiti",
                "Okpenada",
                "Ophemi",
                "Osomegbe",
                "Udaba",
                "Udaba-Azukhala",
                "Udaba-Ikwidi",
                "Udaba-Omodadi",
                "Udaba-Otoakhi",
                "Udabe-Ogochi",
                "Ughekha",
                "Ughenokwa",
                "Ukhekpe",
                "Ukhomhedokhai",
                "Ukhomoduba",
                "Ukpeko-Orie",
                "Unebode",
                "Uralokhor",
                "Utegie",
                "Ugbato",
                "Ugbereke",
                "Umuamievili",
                "Umuchem",
                "Umuokpoto",
                "Umuakwu",
                "Umueleri",
                "Umuoba",
                "Umu Udenze",
                "Umuezeunu",
                "Umuleri",
                "Ubaronisioye",
                "Ubaru",
                "Ugwuaru",
                "Ugwume",
                "Urualor",
                "Yelwa"
            ],
            "Etsako East": [
                "Agenebode",
                "Agiere",
                "Anumeji",
                "Avhiodor",
                "Bode-Waterside",
                "Dapapa",
                "Edegbe",
                "Egori-Nauge",
                "Egori-Waterside",
                "Ekwotso",
                "Emnokweme",
                "Ighawo",
                "Igienebamhe",
                "Igiode",
                "Ikwakpe",
                "Ilogodo",
                "Itogbo",
                "Itsokwi",
                "Ivbiare",
                "Ivbiebua",
                "Ivhianokpodi",
                "Ivhioghe",
                "Iviakpekha",
                "Iviebua-Naameh",
                "Iviegbepwi",
                "Iviekpe",
                "Iviogheme",
                "Iviokpo",
                "Iviomhe",
                "Iviukhua",
                "Iviukwe",
                "Izotha",
                "Oba Dudu",
                "Obadudu",
                "Ofukpo",
                "Ogwoyo",
                "Ogwozima",
                "Ogwukpakpa",
                "Okanawua",
                "Okieh",
                "Okiolomi",
                "Oshola",
                "Otaukwi",
                "Othame",
                "Ovao",
                "Ugbato",
                "Ughoke",
                "Ukho",
                "Ukpeko",
                "Ukpeko-Agbugwi",
                "Uzanu",
                "Weppa-Wanno"
            ],
            "Etsako West": [
                "Aibotse",
                "Afashio",
                "Afowa",
                "Agbede",
                "Akpana",
                "Akpekpe",
                "Auchi",
                "Aviele",
                "Ayoghena",
                "Ayogwiri",
                "Ayua",
                "Daniel Ajuya Camp",
                "Egeuno",
                "Egbogio",
                "Eware",
                "Ewora",
                "Ibie Nafe",
                "Igbirra Camp",
                "Ihelame",
                "Ikabigbo",
                "Ikhua",
                "Ikholo",
                "Imeke",
                "Imiogia",
                "Imiokono",
                "Irekpai",
                "Iyakpi",
                "Iyamo",
                "Iyerekhu",
                "Iyora",
                "Iyukhu",
                "Jagbe",
                "Jattu",
                "Ogbido",
                "Odigie",
                "Oguolla",
                "Otegie",
                "Rabison Camp",
                "Ukumasi Camp",
                "Ugbenor",
                "Ugieda",
                "Ugiekha",
                "Uzairue-Jattu",
                "Uzoki",
                "Usogun"
            ],
            "Igueben": [
                "Eguare",
                "Ekpon",
                "Idumeko",
                "Idumesan",
                "Idumeshebe",
                "Idumodin",
                "Idumogun",
                "Idumuadocha",
                "Idumu-Ikhialen",
                "Idumu-Ikhinlen",
                "Idumuneduegbe",
                "Idumuoigue",
                "Ijeduma",
                "Ikekogbe",
                "Ikpedu",
                "Isiliakor",
                "Oduwebho",
                "Ogbe",
                "Okaigben",
                "Olenokhua",
                "Ugun"
            ],
            "Ikpoba-Okha": [
                "Aduwawa",
                "Akpe",
                "Ajoki",
                "Avbiama",
                "Egun",
                "Ekae",
                "Ekosa",
                "Egbonodoka",
                "Erimona",
                "Erome",
                "Evbomoma",
                "Evbosa",
                "Evbumufi",
                "Evbuomodu",
                "Idogbo",
                "Igbehimwan",
                "Iguehana",
                "Ilegun",
                "Imasabor",
                "Ivbiugo",
                "Obadolovibiya",
                "Obagie",
                "Nevbosa",
                "Obaretin",
                "Obayantor",
                "Obe",
                "Obenevbugo",
                "Ogbekpen",
                "Ogbeson",
                "Ogheghe",
                "Ohovbe",
                "Okanaruovia",
                "Okabere",
                "Okaniro",
                "Okha",
                "Okha Inland",
                "Ologbo",
                "Orhibanmu",
                "Orogbo",
                "Orogbo Camp",
                "Otene",
                "Uhie I",
                "Ukhirhi",
                "Ukhirhi Nekhere",
                "Umelu",
                "Uroho",
                "Ute",
                "Utezi",
                "Uwusan"
            ],
            "Oredo": [
                "Aakhuakhuari",
                "Amagba",
                "AmagbaCamps",
                "Arogba",
                "Dick'sCamp",
                "EboOgunmwenyin",
                "Egbirhe",
                "Ekae",
                "Emonfonmwan's",
                "Evbuekhae",
                "Evbiyomwanru",
                "Evbokuden",
                "Evborohun",
                "Evbovbioba",
                "Evbukhu",
                "EvbuodiaOlaya",
                "EvbuonusCamp",
                "Iguikpe",
                "ImagbeIzobo",
                "IrhneOwina",
                "Obazagbon",
                "Ogbareki",
                "Ogiza",
                "Okhorhomi",
                "Okpebor",
                "Okua",
                "Osagiede's",
                "ThirdCamp",
                "Ugbor",
                "Uholor",
                "Umegbe",
                "Ureghin",
                "UrhoboCamp",
                "Utagban"
            ]
        }
    },
    {
        "Ekiti": {
            "Ado Ekiti": [
                "Ado Ekiti",
                "Ago Aduloju",
                "Ago Araromi",
                "Ajebamidele",
                "Amirin",
                "Aso Ayegbule",
                "Ategbado",
                "Ernfun",
                "Igim Okogo",
                "Igirigiri",
                "Ika",
                "Ikewo",
                "Ilokun",
                "Iranse",
                "Ireje",
                "Kajola",
                "Oke-Aso",
                "Oke Epa"
            ],
            "Efon": [
                "Abeta",
                "Agboro",
                "Aladura",
                "Alagba Mesan",
                "Alawaye",
                "Araromi",
                "Efon-Alaaye",
                "Etisun",
                "Ido Ajegunle",
                "Igbo Aba",
                "Irunshin",
                "Ita Awure",
                "Ita Ido",
                "Iwaji",
                "Oba Ayetoro",
                "Obake",
                "Oke Agemo",
                "Oko Adagba",
                "Orisunbare",
                "Oro"
            ],
            "Ekiti East": [
                "Emure",
                "Gbonyin"
            ],
            "Ekiti South-West": [
                "Araromi",
                "Eremiji Camp",
                "Igbole",
                "Ilasa",
                "Isinbode-Ekiti",
                "Ikiun",
                "Oda Do",
                "Omuo Ekiti (Rural)",
                "Suru Camp"
            ],
            "Ekiti West": [
                "Aba Egbira",
                "Aba Igbira",
                "Aba Ire Rd",
                "Aba Ita Iroro",
                "Aba Ojumu",
                "Afao Ekti",
                "Ajebamidele",
                "Araromi Obo",
                "Are Ekiti",
                "Ayeye",
                "Esure Ekiti",
                "Igbemo",
                "Igede",
                "Iloba Igedera",
                "Iropora",
                "Iyin",
                "Odo Uro"
            ],
            "Emure": [
                "Aba Adewale",
                "Aba Adeyemo",
                "Aba Ajiboye",
                "Aba Ajireni",
                "Aba Amin",
                "Aba lade",
                "Adeboye",
                "Agbanimu",
                "Ago Sasere",
                "Ajebandele",
                "Akeye",
                "Alabamarum",
                "Alapoto",
                "Amuroko",
                "Anaye",
                "Ayelala",
                "Ba Egin",
                "Ba Ojilo",
                "Emure",
                "Emure Ekiti",
                "Eporo Ekiti",
                "Ibeji Adu (Aro I)",
                "Ibeji Adu (Aro II)",
                "Ibeji Owode Oniyawa",
                "Ibeji Shittu",
                "Ibeji Shittu II",
                "Idi Ope",
                "Igbo Owa (Old Emure Settlement)",
                "Igboso",
                "Ilu Oge",
                "Oke Seri",
                "Oke Sett",
                "Omaje",
                "Opticum",
                "Ose",
                "Owode",
                "Owosi",
                "Owosi Oba",
                "Oyimo Settlement",
                "Sasere",
                "Ugbo Uso"
            ],
            "Gbonyin": [
                "Aba Anifowose",
                "Aba Ikare",
                "Aburumoku Camp",
                "Adadiri/Loye",
                "Adekaye",
                "Agbado-Ekiti",
                "Agbingbin Camp",
                "Agbonkoji",
                "Aguda Camp",
                "Agunbi Aka",
                "Baba Egbe",
                "Bolorunduru",
                "Dan Site Settlement",
                "Edemo Camp",
                "Egbe-Ekiti",
                "Igbegede",
                "Ikare Olorunda",
                "Iluomuba-Ekiti",
                "Ilupeju Ijan",
                "Iro-Ayeteju",
                "Ipole-Agbado",
                "Ijan Ekiti",
                "Oka Camp",
                "Olokemeji Camp",
                "Omuo Camp",
                "Oyan/Ologboo Camp",
                "Sanni 1",
                "Sanni 11"
            ],
            "Ido/Osi": [
                "Aba Araba",
                "Aba Emo",
                "Aba Oke",
                "Abaoko Esu",
                "Abigbinde",
                "Abidogun",
                "Abiona",
                "Adegbite",
                "Adelogun",
                "Adesekun",
                "Agbopo",
                "Agubi",
                "Ajibade",
                "Ajobo",
                "Akankan",
                "Akerele",
                "Akilo",
                "Akindeji",
                "Akindele",
                "Akinware",
                "Akinyanran",
                "Akowooloti",
                "Akufo",
                "Akufo/Idigba/Araromi",
                "Alajata",
                "Alako",
                "Alapata",
                "Alakoso",
                "Alarabo",
                "Aleeyan",
                "Alawusa",
                "Aloko",
                "Aloko/Oloroko",
                "Alowonle",
                "Ami Adio",
                "Anisere",
                "Apata",
                "Apaoyin",
                "Apete",
                "Asoju Sangote",
                "Atare",
                "Atere",
                "Awotan",
                "Ayegun",
                "Ayetoro Ekiti",
                "Baako",
                "Baale",
                "Bakatari",
                "Balogun Alawusa",
                "Batake",
                "Bode-gbo",
                "Dada",
                "Eboade",
                "Egannarin",
                "Elere",
                "Elesinfunfun",
                "Elenusonso",
                "Eleso",
                "Erinwusi",
                "Esu",
                "Faleye",
                "Falogun",
                "Fasan",
                "Fenwa",
                "Fagbogo",
                "Idi Oro",
                "Idi-Amu",
                "Idi-Igbaro",
                "Idi-Oro Elewa",
                "Idiya",
                "Ijaybbawo",
                "Ile Tuntun",
                "Ilaju",
                "Ipole",
                "Igbira Camp",
                "Ifaki",
                "Ifisin-Ekiti",
                "Igbole Ekiti",
                "Iddo",
                "Ido",
                "Ilogbo Ekiti",
                "Ilogun",
                "Ilogun Ekiti",
                "Keeditan",
                "Koguo",
                "Kuye",
                "Ladimeji",
                "Ladunni",
                "Langbin",
                "Latayo",
                "Latunji",
                "Lasokun/Araromi",
                "Morakinyo",
                "Odebode",
                "Oderemi",
                "Odetola",
                "Ogunrinde",
                "Oguo",
                "Ojeniran",
                "Okalawa",
                "Okedina",
                "Okilo",
                "Oke Ese",
                "Oke-Alaro",
                "Oke-Ora",
                "Okeowo",
                "Okunsinde Otun",
                "Olawoyin",
                "Olokogboro",
                "Oloko",
                "Olonwe",
                "Oloro",
                "Olosa",
                "Olowonle",
                "Omojoro",
                "Omowunmi",
                "Onidoko",
                "Onigbagbo",
                "Onigbodogi",
                "Onigbinde",
                "Onikonko",
                "Onikanga",
                "Onikede",
                "Onisago",
                "Oniuu",
                "Onitayo",
                "Onodoko",
                "Opaeye",
                "Opooji",
                "Ora-Ekiti",
                "Orin-Ekiti",
                "Owolabi",
                "Oyawole",
                "Pakuru",
                "Saliu",
                "Sango",
                "Salako",
                "Sinko",
                "Siba",
                "Tade",
                "Temigbola",
                "Tokan",
                "Usi Ekiti",
                "Yidi"
            ],
            "Ijero": [
                "Aba-Owa",
                "Abatuntun",
                "Abedi",
                "Aboro",
                "Afale",
                "Ajana",
                "Ajebandele",
                "Ajeje",
                "Ajioku",
                "Alabari",
                "Alatarite",
                "Amilede",
                "Ara",
                "Arapate",
                "Arun",
                "Ayegunle-Ekiti",
                "Ayegunle",
                "Baba Orioke",
                "Babasale",
                "Balaloro",
                "Boriowo",
                "College",
                "Epe",
                "Eyigbo",
                "Idao",
                "Ijero-Ekiti",
                "Ijero",
                "Iparako",
                "Irapa",
                "Iroko",
                "Ijurin",
                "Ile Olope",
                "Iloro Ekiti",
                "Iloro",
                "Ilukuno",
                "Ipoti-Ekiti",
                "Ipoti",
                "Jubili",
                "Kajola",
                "Kanga",
                "Lare",
                "Odo Ikoro",
                "Odo Owo",
                "Odo Oye",
                "Odo-Ese",
                "Oke Adefila",
                "Oke Asa",
                "Oke Eisinkin",
                "Oke Igi",
                "Oke Ogboni",
                "Oke Oja",
                "Oke Oko",
                "Okelogbo",
                "Okoto",
                "Oluwaseun",
                "Omolewa",
                "Olosun",
                "Osan",
                "Osun",
                "Otun",
                "Oyikaka",
                "Panu",
                "Saloro",
                "Soso",
                "Surulere",
                "Temidire"
            ],
            "Ikere": [
                "Aba Akyejo",
                "Aba Ayede",
                "Aba Ayewa",
                "Aba Igbira",
                "Aba Arokun",
                "Agamo",
                "Agama",
                "Aso-Osolo",
                "Atoka",
                "Oke Aso",
                "Okejegbende",
                "Oniroba",
                "Ugbo-Iyan",
                "Ugbo-Oje",
                "Ugbo-Uro"
            ],
            "Ikole": [
                "Adebayo",
                "Adewumi",
                "Agere",
                "Ajileye",
                "Apadie",
                "Ara",
                "Araromi",
                "Ariyo",
                "Asamo",
                "Asunrin",
                "Awara",
                "Ayebode",
                "Bolorunduro",
                "Ekun",
                "Eleju",
                "Eti",
                "Ijesa-Isu",
                "Igbo-Edun",
                "Igbo Imosun",
                "Igboroko",
                "Ikoyi-Ile",
                "Ikoyin",
                "Ire",
                "Irele",
                "Iwetin",
                "Iya",
                "Odo-Ayedun",
                "Odo-Ugo",
                "Ogbungbun",
                "Oke-Ako",
                "Oke-Ayedun",
                "Oke-Ale",
                "Oke-Orin",
                "Ologbogbo",
                "Ologunro",
                "Omi-Ugba",
                "Omopintan",
                "Osusana",
                "Oyi",
                "Saromi",
                "Saw-Mill",
                "Ugb-Iha",
                "Ugbo-Omo",
                "Utake"
            ],
            "Ilejemeje": [
                "Ayeoja",
                "Eda Oniyo",
                "Erinmope",
                "Ewu",
                "Ijesa Modu",
                "Igogo",
                "Iludun",
                "Ipere",
                "Ikun",
                "Iye",
                "Kosu",
                "Obada"
            ],
            "Irepodun/Ifelodun": [
                "Aba Adedeji",
                "Aba Edunabon",
                "Aba Ibadan",
                "Aba Iragbiji",
                "Aba Oshodi",
                "Aba Osunrin",
                "Aba Petu",
                "Aba Tiamiyu",
                "Abakona",
                "Aiyedade",
                "Ajamuro",
                "Alabameta",
                "Alagbede",
                "Araromi",
                "Ayedarade",
                "Bolorunduro",
                "Edetode",
                "Hamlet",
                "Igbara",
                "Ilawe",
                "Igunurin",
                "Ilupeju",
                "Johnson",
                "Kajola",
                "Lawrence",
                "Oluwabusola",
                "Oke-Ijebu",
                "Ogotun",
                "Omu-aran",
                "Orisunbare",
                "Osogbo",
                "Otapaete",
                "Temidire"
            ],
            "Ise/Orun": [
                "Aba Adeja",
                "Aba Ado",
                "Aba Corner",
                "Aba Ebira",
                "Aba Ede",
                "Aba Eye",
                "Aba Ikare-Idi Osan",
                "Aba Ikire",
                "Aba Ilogbo",
                "Aba Odole",
                "Aba Olisa",
                "Aba Olokemeta",
                "Aba Omoto-Aran",
                "Aba Omuaran",
                "Aba Onisu",
                "Aba Osi",
                "Aba Paanu",
                "Aba Pojo",
                "Aborowa Akande",
                "Ada",
                "Afolu",
                "Agbe",
                "Ajebamidele",
                "Ajebamidele Ilofa",
                "Ajegunle",
                "Alabi",
                "Alagbada",
                "Araromi",
                "Aratu",
                "Aro",
                "Arola",
                "Asalu",
                "Bolorunduro",
                "Borowa",
                "Egin",
                "Egunjobi",
                "Ekan",
                "Eke-mode",
                "Ese",
                "Fatoba",
                "Idi Osan",
                "Igbira Ese",
                "Imope",
                "Ita nla",
                "Kajola",
                "Morupa",
                "Obada",
                "Odofin",
                "Odolo",
                "Ofigba",
                "Ogbese",
                "Oge",
                "Ogunleye",
                "Oguntuase",
                "Ojomu",
                "Okuta Aaragba",
                "Olagunju",
                "Olofe",
                "Olotin",
                "Olu-Oroke",
                "Orisumibare",
                "Oshogbo",
                "Oye Araromi",
                "Oyin",
                "Salaja",
                "Sasere",
                "Temidire"
            ],
            "Moba": [
                "Ajebamidele",
                "Alaye",
                "Aramoko",
                "Aworo",
                "Ayetoro",
                "Elesunsun",
                "Egede",
                "Erinjiyan",
                "Erio",
                "Ido Ajinmare",
                "Ido-Ayefunle",
                "Ikogosi",
                "Ileyigbo",
                "Ipole",
                "Ipole-soke",
                "Ireju",
                "Isokowa",
                "Itape",
                "Kajola",
                "Oko-Owa",
                "Ologunde",
                "Okemesi",
                "Orokuta",
                "Osemo",
                "Osun",
                "Popo-Oba",
                "Willys Camp"
            ],
            "Oye Ekiti": [
                "Ayede",
                "Egbu",
                "Ijelu",
                "Ilafon",
                "Ilemose",
                "Isan",
                "Iyemero",
                "Oloje",
                "Omuo-Odo"
            ],
            "Oye": [
                "Aba Apeye",
                "Aba Apomo",
                "Aba Aseta",
                "Aba Asua",
                "Aba Bolorunduro",
                "Aba Ogbe",
                "Aba Oke",
                "Aba Pabanbari",
                "Aba Sakunmi",
                "Agaba",
                "Ajegunl",
                "Aldejobi",
                "Apata-Ajo",
                "Ayegbaju",
                "Ayelala",
                "Elewuro",
                "Igbara Camp",
                "Igbkorodo",
                "Ilupeju",
                "Imesi Ekiti",
                "Ire",
                "Itaji",
                "Itapa",
                "Kajola",
                "Luke Dada",
                "Modamoro",
                "Odogba",
                "Ojuola",
                "Okeiyin",
                "Olomolowa",
                "Olutumode",
                "Osun",
                "Otaipe",
                "Oye",
                "Ode Ekiti",
                "Villages under Ode",
                "Willys Camp"
            ]
        }
    },
    {
        "Enugu": {
            "Aninri": [
                "Abacheku",
                "Amachara",
                "Amagu",
                "Amankanu",
                "Amanaasato",
                "Amata",
                "Amabor",
                "Amokwe",
                "Amorji",
                "Amurure",
                "Amaeke",
                "Amaeze",
                "Amaogudu",
                "Amuoma",
                "Amuoji",
                "Anamie",
                "Azunkwo",
                "Ezinator",
                "Ezinesi",
                "Eza-Mpu (Obunagu)",
                "Enugunator",
                "Emulemoke",
                "Eziecho",
                "Ihuibe",
                "Ihuezeoke",
                "Isi-Enyi",
                "Iyinu",
                "Mmafu",
                "Nanwu",
                "Ngenanwa",
                "Nochele",
                "Ngeneawanta",
                "Obada",
                "Obeagu",
                "Obiofu",
                "Obulorum",
                "Okpanku",
                "Okpome",
                "Okpulo",
                "Over Rail",
                "Uhucheke",
                "Uhuogiri",
                "Uhungo",
                "Umagari",
                "Umuaga",
                "Umuobele",
                "Umuoma",
                "Umuewo",
                "Umueze",
                "Umuelvo",
                "Umulagu",
                "Umuoji",
                "Umuovute"
            ],
            "Agwu": [
                "Achalla",
                "Adogba",
                "Agbada",
                "Agbogugu",
                "Agbogwu",
                "Agbonator-Ogba",
                "Agboneri",
                "Agwu",
                "Ama",
                "Amaabo",
                "Amaebe",
                "Amagu",
                "Amaka",
                "Amamobaka",
                "Amofiya",
                "Amata",
                "Amavi",
                "Amavoia",
                "Amol",
                "Amomi",
                "Amukpe",
                "Anike",
                "Atta",
                "Awgu",
                "Awgunta",
                "Awkunano",
                "Awono",
                "Awunta",
                "Awa-Layout-Ifite",
                "Azuchi",
                "Azuma",
                "Azunkia",
                "Agualo",
                "Agwuania",
                "Amamalola",
                "Anil",
                "Bawka",
                "Bawmili",
                "Dilu",
                "Donia",
                "Duma",
                "Duzu",
                "Ega",
                "Egbeda",
                "Egbem",
                "Egbua",
                "Ede",
                "Efo",
                "Efuoma",
                "Efue",
                "Eke",
                "Ekore",
                "Ekuka",
                "Emor",
                "Enugu",
                "Enugu-Afam",
                "Enugu-Isu",
                "Enugwu-Agu",
                "Enugwuife",
                "Enugwu-Nkpa",
                "Enugwu-Ugo",
                "Enwea",
                "Ezeokwe",
                "Eziama",
                "Eziola",
                "Ezioha",
                "Ezoka",
                "Ezure",
                "Ezuru",
                "Ife",
                "Ifite",
                "Ifite-Awgu",
                "Ifuteo",
                "Igede",
                "Igogho",
                "Igoye",
                "Ikun",
                "Ime-Ama",
                "Inyi",
                "Isiama",
                "Isu-Uga",
                "Isu-Awa",
                "Isioma",
                "Isiocha",
                "Isuek",
                "Isu-Abam",
                "Iwi",
                "Iwite",
                "Jumu",
                "Jimolo",
                "Koia",
                "Kosu",
                "Kuka",
                "Kule",
                "Kolu",
                "Kulel",
                "Kuo",
                "Kuno",
                "Kunbe",
                "Mamakpo",
                "Mamu",
                "Mgbago",
                "Mgbidi",
                "Mgbodo",
                "Mgbodi",
                "Mgbowa",
                "Mbia",
                "Mbio",
                "Ndeke",
                "Ndahe",
                "Ndenya",
                "Ndohe",
                "Nneka",
                "Nkere",
                "Nkpa",
                "Nkwe",
                "Nwegbu",
                "Nwokocha",
                "Nworu",
                "Nwota",
                "Nyiwa",
                "Obariri",
                "Obineka",
                "Obio",
                "Obio-Akpan",
                "Obio-Anwai",
                "Obio-Idem",
                "Obio-Ngbo",
                "Obuo",
                "Obooma",
                "Obom",
                "Obor",
                "Oburo",
                "Oburu",
                "Oculua",
                "Ododi",
                "Ododo",
                "Odome",
                "Odoma",
                "Odum",
                "Ogba-Ugwunator",
                "Ogba-Ngbo",
                "Ogba-Ogbo",
                "Ogbono",
                "Ogbo",
                "Ogbolo",
                "Ogidi",
                "Ogwugbidi",
                "Ogwumgbidi",
                "Ohaja",
                "Ohumagu",
                "Ohume",
                "Ohu",
                "Ohuama",
                "Ohuagu",
                "Ohuaveta",
                "Okebebe",
                "Okeoga",
                "Okpedi",
                "Okpesi",
                "Okrua",
                "Okuk",
                "Okuna",
                "Okpoma",
                "Olaka",
                "Oluocha",
                "Olukpa",
                "Onoli",
                "Onugwa",
                "Onu",
                "Onu-Obio",
                "Onu-Igwe",
                "Onu-Ni",
                "Ojiaka",
                "Ojiogbu",
                "Oko",
                "Okwenachala",
                "Okwu",
                "Omokwe",
                "Omor",
                "Onutine",
                "Osun",
                "Otibo",
                "Otokwo",
                "Owu",
                "Owuk",
                "Oyibo",
                "Oyibo-Umu-Onaga",
                "Oweli",
                "Owolo",
                "Owo",
                "Uba",
                "Ubaronisioye",
                "Ubazu",
                "Ubu",
                "Ubodu",
                "Ugbado",
                "Ugbau",
                "Ugbongu",
                "Ugbo",
                "Ugboka",
                "Ugbope",
                "Ugom",
                "Ugwu",
                "Ugwu-Eme",
                "Ugwuafor",
                "Ugwuanya",
                "Ugwenesi",
                "Ugwuaru",
                "Ugwume",
                "Uhueze",
                "Uhuagu",
                "Uhuamagu",
                "Uhunukpi",
                "Uhuoma",
                "Umuabuzoukwu",
                "Umu-Amachiala",
                "Umu-Akpu",
                "Umu-Awusi",
                "Umu-Eziri",
                "Umu-Ezugo",
                "Umu-Ijeoma",
                "Umu-Kpebe",
                "Umu-Mmeme",
                "Umuobom",
                "Umuobene",
                "Umuochi",
                "Umuono",
                "Umuonwo",
                "Umuonu",
                "Umuoriji",
                "Umuosidi",
                "Umuozam",
                "Umuokpodo",
                "Umuokpo",
                "Umuomewi",
                "Umupkoro",
                "Umurube",
                "Umurukpu",
                "Umuru",
                "Umunam",
                "Umunozum",
                "Umunwa",
                "Umunzun",
                "Umunzu",
                "Umure",
                "Umure-Udo",
                "Umurue",
                "Umurungun",
                "Umusike",
                "Umuwe",
                "Umunko",
                "Unumagu",
                "Uwupe",
                "Uwuoma",
                "Umuokpe",
                "Uwe",
                "Uwe-Obio",
                "Uwua",
                "Uyak",
                "Uzoro",
                "Uzum",
                "Umumkpa",
                "Ugbuka",
                "Umuahu",
                "Uruah",
                "Uruakpa",
                "Uruato",
                "Uruk",
                "Ururakpo"
            ],
            "Enugu East": [
                "Ako",
                "Akpoga",
                "Alulu",
                "Amoji",
                "Amokpo",
                "Agbogazi",
                "Azama",
                "Edem",
                "Effokwe",
                "Emene",
                "Ibeagwa",
                "Ije-Amaowelle",
                "Nbulunjodo",
                "Nchetanche",
                "Nekeodinigbo",
                "Nekeuno",
                "Ngwuomu",
                "Nkwubo",
                "Nokpa",
                "Obinagu",
                "Ogbodogo",
                "Okpuhu",
                "Onuogba",
                "Onyohu",
                "Ogwogo",
                "Adaeze",
                "Ugwunkwo",
                "Umunagbo",
                "Umunnameze",
                "Umunonu",
                "Utazi"
            ],
            "Enugu North": [
                "Amaigbo",
                "Ihenwuzi",
                "Onueto",
                "Ogui",
                "Umunevo"
            ],
            "Enugu South": [
                "Akuke",
                "Amechi",
                "Amagu",
                "Amauzam",
                "Atagwu",
                "Awkunanaw",
                "Isiagu",
                "Iside",
                "Ngine",
                "Ndiaga",
                "Ndiugbo",
                "Ndiagbana",
                "Nkpofia",
                "Obinagu",
                "Obodou",
                "Obeagu",
                "Ochufu",
                "Onuba",
                "Sata",
                "Ugwuafa",
                "Ugwuagba",
                "Ugwuaji",
                "Uzamdun",
                "Uzamagu",
                "Ugboba-Ani",
                "Umunnaji",
                "Umunnaugwu",
                "Umuedeachi",
                "Umuanigu",
                "Umuogo"
            ],
            "Ezeagu": [
                "Achara-Owa",
                "Agba",
                "Agba-Umana",
                "Aguoba-Obelagu",
                "Amakwo",
                "Amansiodo",
                "Amansiode",
                "Amansi-Odo",
                "Amaetiti",
                "Amandim",
                "Awha",
                "Awha Ndiagu",
                "Ezeonyia",
                "Ezema",
                "Evazu",
                "Imezi",
                "Imama",
                "Isiokwe",
                "Isiugwu",
                "Idume",
                "Ikenga",
                "Ndiabo",
                "Ndiagu",
                "Ndiuno",
                "Ndibinagu",
                "Ndibenifi",
                "Neke",
                "Obelagu-Umana",
                "Obodo Ngbogbo",
                "Obunagu",
                "Obunofia",
                "Okpo-Gho",
                "Okpudo",
                "Okpuata",
                "Omughu",
                "Olo",
                "Ogdo-Ngbogbo",
                "Ogwuofia",
                "Ozono",
                "Ozom",
                "Owa",
                "Oyofo",
                "Owoloti",
                "Unuawo",
                "Umu-Ulatu",
                "Umuanaobu",
                "Umuani",
                "Umuagbo",
                "Umuachen",
                "Umuavaka",
                "Umudim",
                "Umueze",
                "Umuezeagu",
                "Umuodama",
                "Umuonega",
                "Umuonaga",
                "Umuosulu",
                "Umu-Udenze",
                "Umukwabu",
                "Umuhie",
                "Umueze Amaji",
                "Ukwuagba",
                "Volovolo"
            ],
            "Igbo Etiti": [
                "Amandu",
                "Amanefi",
                "Amanonucha",
                "Amagwu",
                "Amaelu",
                "Amaotu",
                "Amabinagu",
                "Amobo",
                "Amoji",
                "Aku",
                "Akutala",
                "Ameti",
                "Akpuato",
                "Amabokwu",
                "Amamkwo",
                "Amobi",
                "Chinwa",
                "Diogbe",
                "Ejuona",
                "Ejuonu",
                "Ezinaibite",
                "Ekwegbe",
                "Idoha",
                "Ikolo",
                "Ikoloani",
                "Isiamelu",
                "Ijo",
                "Nkitiba",
                "Nnaru",
                "Nua",
                "Nkpologwu",
                "Ogbede",
                "Ohodo",
                "Ohumofia",
                "Offienyi",
                "Ochima",
                "Ohebe",
                "Oshigo",
                "Ozeachara",
                "Orda",
                "Ugwuegede",
                "Ugwunani",
                "Ukopi",
                "Uhamurodo",
                "Ujoma",
                "Udueme",
                "Ukehe",
                "Ukwaja",
                "Umudulo",
                "Umufiagu",
                "Umuriko",
                "Umurusi",
                "Umueme",
                "Umuozigbo",
                "Umunashi",
                "Uwani",
                "Uwani Abaka",
                "Use"
            ],
            "Igbo-Eze North": [
                "Aba-Agu",
                "Abaraoji",
                "Aji",
                "Amachall",
                "Amufie",
                "Amebi",
                "Atikor",
                "Echezma",
                "Ekenya",
                "Ero-Aguafor",
                "Ezike",
                "Ezenweze",
                "Ibagwa",
                "Ibagwa-Aka",
                "Idi",
                "Igbelle",
                "Ikpiga",
                "Ikpamodo",
                "Imufu",
                "Olido",
                "Onazi",
                "Onazi-Uno",
                "Onyiro",
                "Oshowu",
                "Owerri",
                "Oyijerewu",
                "Uda",
                "Uda-Enugwu-Ezike",
                "Ugbuagbo-Onyeke",
                "Umuagada",
                "Umuagru",
                "Umuida",
                "Umuogbo-Agu",
                "Umuogbo-Inyi",
                "Umuogbo-Uno",
                "Umuozzi",
                "Umuopu",
                "Uroahi",
                "Uroshi"
            ],
            "Igbo-Eze South": [
                "Achebulo-Iheakpu",
                "Ajuona",
                "Alor-Agu",
                "Ama-Agu-Ovoko",
                "Ama-Ajim-Ovoko",
                "Ama-Agu",
                "Amaenyije-Iheakpu",
                "Amaoboada-Ovoko",
                "Amachalla-Ovoko",
                "Amofia-Ovoko",
                "Amikwo-Ulo",
                "Amobo",
                "Aza-Ali",
                "Edembekwu",
                "Edem-Iheakpu",
                "Emoha",
                "Eke-Utara-Iheaka",
                "Ete",
                "Ete-Nawa",
                "Itchi-Agu",
                "Itchi-Oha",
                "Ibeku-Ovoko",
                "Like-Iheaka",
                "Ngwuola-Iheakpu",
                "Okaja",
                "Okpaligbo",
                "Okolo-Iheakpu",
                "Ororu-Iheakpu",
                "Okan",
                "Ogbodo-Ukwu",
                "Ogbueke",
                "Ogwudo-Ovoko",
                "Ohagu-Ovoko",
                "Ovoko",
                "Ugo-Iheakpu",
                "Umu-Ezeavlu-Ovoko",
                "Umu-Jumuta-Ovoko",
                "Umu-Ogida-Ovoko",
                "Umu-Oroko-Ovoko",
                "Umu-Shire-Ovoko",
                "Umuash-Iheakpu",
                "Umuakpu-Ovoko",
                "Umuagbado",
                "Umuede-Odoga",
                "Umugbado-Odicha",
                "Umuodobo",
                "Umuona",
                "Umuogbu",
                "Umuogbuuru-Ovoko",
                "Umuogene-Ovoko",
                "Umuoshigi-Ovoko",
                "Umuujiogha-Ovoko",
                "Umugbagbo-Ovoko",
                "Umuodi-Ovoko",
                "Umuori-Iheakpu",
                "Umuakaenyi",
                "Umunakata",
                "Umukada-Ovoko",
                "Umunjaba-Iheakpu",
                "Umunkata",
                "Umuezeoka-Ovoko",
                "Umuoki-Iheakpu",
                "Umueko",
                "Umuobom",
                "Umuoroko-Iheakpu"
            ],
            "Isi-Uzo": [
                "Abbia",
                "Abor",
                "Agu-Amede",
                "Amede",
                "Amu-Aram",
                "Amudam",
                "Ape-Mgbuji",
                "Ihanyi",
                "Ikem",
                "Iken-Nkwo",
                "Isienu",
                "Isu",
                "Mbu Amon",
                "Mbu-Agu-Udene",
                "Mbu-Ajona",
                "Mbu-Akpoti",
                "Mbu-Akpuoga",
                "Mgbuji",
                "Neke",
                "Obegu-Aba",
                "Odomogwo",
                "Ogor",
                "Oka-Egbera",
                "Orokoro",
                "Ugwuoke-None",
                "Umu-Aja",
                "Umu-Idiji",
                "Umuegwu",
                "Umueze-Boko",
                "Umueze-Ogbu",
                "Umugwu",
                "Umuhu",
                "Umujoovu",
                "Umuenyi-Ogodo",
                "Umuero"
            ],
            "Nkanu East": [
                "Akanfu",
                "Amaeke",
                "Amafor Ugbawka",
                "Amafu",
                "Amaigbo",
                "Amagu",
                "Amakanu",
                "Amankanu",
                "Amauzam",
                "Amechi Idodo",
                "Amu Okpara",
                "Amukabi",
                "Aniyi",
                "Aniyike",
                "Asisi",
                "Eme",
                "Emene",
                "Emuoku",
                "Enuvu-Egu",
                "Ezi Nkerefi",
                "Ezinachu",
                "Eziama",
                "Eziobodo",
                "Ezza Nkerefi",
                "Ihuagbu",
                "Ihuagu",
                "Ihuawako",
                "Ihuokpara",
                "Imeoha",
                "Imama",
                "Iruka",
                "Isiagu",
                "Isiogbo",
                "Isiewu",
                "Isigwe",
                "Isinga",
                "Mbanaocha",
                "Mburubu",
                "Ndiagu",
                "Ndiaguagu",
                "Ngwubo",
                "Nkerefi",
                "Nomeh",
                "Oganike",
                "Ogala",
                "Ogbahu",
                "Ohuani",
                "Oicha-Agu",
                "Ikeokparogba",
                "Imenike",
                "Isiokpo",
                "Okeani",
                "Omuja",
                "Omuno",
                "Onu Orie",
                "Osu",
                "Owo",
                "Obinagu",
                "Obodo Agbulu",
                "Obodoukwu",
                "Obunagu",
                "Obunu",
                "Obuoffia",
                "Onueke",
                "Oruku",
                "Ugbawka",
                "Uhuafor",
                "Uhuoji",
                "Umu Okpara",
                "Umuaga",
                "Umueze",
                "Umuezeoche",
                "Umuiba",
                "Umukan",
                "Umunevo",
                "Umuo",
                "Umuogbui",
                "Umuogodi",
                "Umuokpalagene",
                "Umuogu",
                "Umuoke",
                "Uzama Nara"
            ],
            "Nkanu West": [
                "Agbaani",
                "Akagbe-Amodu",
                "Akagbe-Ugwu",
                "Ama-Akpu",
                "Amaede",
                "Amafor",
                "Amaigbo",
                "Amaigwe",
                "Amaikwe",
                "Amainyi",
                "Amake",
                "Amankanu",
                "Amankwo",
                "Amaokwe",
                "Amaowre",
                "Amuru",
                "Ani",
                "Aniaku",
                "Atakwu",
                "Echa",
                "Echara",
                "Ekeaku",
                "Enugu",
                "Enugu-Agu",
                "Eziaba",
                "Eziagwu",
                "Eziokwe",
                "Eziobodo",
                "Iga",
                "Ihunekeman",
                "Mbogodo",
                "Ndiagu",
                "Ndiagu-Nnajiori",
                "Njwuaja",
                "Obe",
                "Obeagwu",
                "Obeagu",
                "Obeagini",
                "Obinagu",
                "Obodo Ukpa",
                "Ogirishi",
                "Ogonogeji",
                "Ogonogeji-Ndiagu",
                "Ogonogeji-Ndiuno",
                "Ogbeke",
                "Onuobo",
                "Onuorie",
                "Orji",
                "Ozalla",
                "Umuike Owo",
                "Umuigbo",
                "Umuenenta",
                "Umuorume",
                "Umuokwa",
                "Umuogbu",
                "Umugbe",
                "Umuiibo",
                "Umungutowo",
                "Umunowo",
                "Umuotuo",
                "Umuokwu",
                "Umuubagu",
                "Uwani"
            ],
            "Nsukka": [
                "Acharichankpume",
                "Ajuona",
                "Aka-Utara",
                "Akaibite",
                "Akautara",
                "Akpotoro",
                "Alora",
                "Ama Okpara",
                "Amaechi Elu",
                "Amaogbo",
                "Amikpo",
                "Amundi",
                "Anuka",
                "Azuabor",
                "Breme",
                "Edem",
                "Edem-Ani",
                "Ede-nta",
                "Ede-Ukwu",
                "Eluagu",
                "Ejuona",
                "Eha",
                "Eha-Alu-Mona",
                "Eha-Ndiagu",
                "Etiti-Agu",
                "Ezembunagu",
                "Ibeagwa-Aka",
                "Iheaka",
                "Ihe/Owerre",
                "Ikwoka",
                "Isienu",
                "Nkpunano",
                "Nru",
                "Obige",
                "Obukpa",
                "Odim",
                "Ogbeagu",
                "Ogbozala",
                "Ogwuoroko",
                "Ogbodo Elu",
                "Ogbodu Okanya",
                "Ohuno",
                "Onene",
                "Opi",
                "Opi-Agu",
                "Okpal-Igbo",
                "Okpuje",
                "Okutu",
                "Ovoko",
                "Ugokpe",
                "Ugwu-ohugu",
                "Ukwuaji",
                "Ukwuokpeye",
                "Umabo",
                "Umude",
                "Uwani",
                "Umani",
                "Uzoanyinya"
            ],
            "Oji River": [
                "Achi",
                "Achiagu",
                "Adu",
                "Agbadalna",
                "Agbalenyi",
                "Agbalidi",
                "Agolo",
                "Agungwu",
                "Agunwu-Ogboo",
                "Agu-Ugwu",
                "Aguabosi",
                "Alaocha Nkwerre",
                "Amagu",
                "Amaetit",
                "Amankpunator",
                "Amankwo",
                "Alum",
                "Awlaw",
                "Central",
                "Dodo",
                "Egbe-Agu",
                "Egbeagu",
                "Efulu",
                "Eha",
                "Elhuhe",
                "Enugu Achi",
                "Enugu-Inyi",
                "Ezi-Achi",
                "Ihe",
                "Isikwe",
                "Isiama",
                "Nkpagu",
                "Nkpokoro",
                "Nkwerri-Inyi",
                "Nkwuni",
                "Obune",
                "Obiagu",
                "Ofechem",
                "Ofemili",
                "Ogbudu",
                "Okpudu",
                "Okwe",
                "Ojia-Oyi",
                "Ojinato",
                "Umabu",
                "Umagu",
                "Umuagu",
                "Umualu",
                "Umuome",
                "Umumba",
                "Updata",
                "Ugwunzu",
                "Ugwuoba"
            ],
            "Udenu": [
                "Abada",
                "Adda",
                "Akpoo",
                "Amagu",
                "Amalla",
                "Amalu",
                "Amube",
                "Amu-Egari",
                "Amuopuagu",
                "Ame-Elugwu",
                "Amebi",
                "Amogodo",
                "Ameti",
                "Amezike",
                "Amutenyi",
                "Anuka",
                "Agu Orba",
                "Ibagwa",
                "Idi Ibagwa",
                "Inekpu",
                "Iheakpu",
                "Ifuroka",
                "Inyi",
                "Nkpunato",
                "Nsu Ibagwa",
                "Ndaoma Ngwunyi",
                "Ndioka",
                "Ogbodu Enugu",
                "Ogbufie",
                "Ohule-Etiti",
                "Ohulo",
                "Ohulor",
                "Ohebe-Orba",
                "Oham",
                "Okpaligbo",
                "Okogwuma",
                "Owerri Amagu",
                "Owerri Ezeorba",
                "Owerri Okpu",
                "Owerre Eze",
                "Ozzala",
                "Ugbabe",
                "Ugbabe-Uwani",
                "Ugbaike Enugu",
                "Ukpu-Agba",
                "Unona-Ogbodo",
                "Umuabru",
                "Umuchi",
                "Umueze",
                "Umu-Azojo",
                "Umu-Ndu",
                "Umuopuagu",
                "Umuitedo",
                "Umuesuogwu",
                "Umuloh",
                "Umuonkyeku",
                "Umuo",
                "Umunachi"
            ],
            "Udi": [
                "Abia",
                "Amaeti",
                "Awagu",
                "EnuguAbia",
                "Iseke",
                "Umuma",
                "Abor",
                "Amaezike",
                "Amukwu",
                "Dinigweze",
                "Dinobe",
                "Ozalla",
                "Ubiekpo",
                "Ugwunani",
                "Umuavulu",
                "Affa",
                "Amaozalla",
                "Amofia",
                "Amokwu",
                "Ikono",
                "Inoyi",
                "Obinagu",
                "Afia",
                "Ogor",
                "Umukoloma",
                "Agbudu",
                "Amabo",
                "Amukpa",
                "Ibite",
                "Odume",
                "Uzoagbo",
                "Akpakwume",
                "AmaAve",
                "Amagbo",
                "Amaofue",
                "Amaovellu",
                "Amauzalla",
                "Ogbugo",
                "Umudiekwon",
                "Umuogbo",
                "Umuugwu",
                "Amokwe",
                "EnuguAgu",
                "Ibuzor",
                "Idedu",
                "Obeagu",
                "Orji",
                "Umudim",
                "Umueze",
                "Uwani",
                "Ebe",
                "Adukwu",
                "Amagu",
                "Eziania",
                "Omadi",
                "OmadiUmenu",
                "Umavulu",
                "Umuezike",
                "Egede",
                "Anekeneze",
                "Okwum",
                "Umuanum",
                "Umudi",
                "Umuezenevo",
                "Umuokpalla",
                "Umuovu",
                "Eke",
                "AmankwoEke",
                "EnuguEke",
                "OguiAguEke",
                "OguiEki",
                "OmaEke",
                "Nachi",
                "Ameke",
                "Okpobueze",
                "Umubo",
                "Ngwo",
                "Amachala",
                "Amankwo",
                "Enugu",
                "Etiti",
                "NgwoUno",
                "Okwojo",
                "Uboji",
                "Ukaka",
                "Umuase",
                "Nsude",
                "Agagu",
                "Amenyi",
                "Amosuwo",
                "Diakuma",
                "Okpurio",
                "UgwuUto",
                "Ugwuakulu",
                "Umuaka",
                "Umualor",
                "Umuezeani",
                "Nzue",
                "Agballa",
                "Aguru",
                "Amutu",
                "Ihe",
                "Ihezegwuoke",
                "Ihonze",
                "Ilonze",
                "Isiubo",
                "Ntugevo",
                "Okinigbo",
                "Ujatta",
                "Agbani",
                "Okpunyo",
                "Okunator",
                "Owa",
                "Umuaboshi",
                "UmuanekeAgwo",
                "UmuanekeUgwu",
                "Umudike",
                "Umuota",
                "Obioma",
                "Abba",
                "Amanwugwo",
                "Oluku",
                "Oghu",
                "Ezama",
                "AmaEgbu",
                "AmaAgu",
                "Amachalla",
                "AmaniOkpatu",
                "Amaonugbu",
                "Amoka",
                "Eziama",
                "Obiagu",
                "Umeneme",
                "Umuchime",
                "Umuene",
                "Owhum",
                "AmaAzalla",
                "Amabor",
                "Amani",
                "Isiogwu",
                "Awkunanaw",
                "EkeNaEne",
                "Umuezechime",
                "Umuoka",
                "Ukana",
                "Adani",
                "Amabota",
                "Amaezu",
                "Amakpu",
                "Aseje",
                "EnuguEseachi",
                "Ikenga",
                "Ngodo",
                "Okofia",
                "Umuabi",
                "Amaji",
                "EnuguAmaji",
                "Imama",
                "Inewe",
                "Ogbuabala",
                "Omashi",
                "Ufiala",
                "Umunwe",
                "Umuokefi",
                "Umuifi",
                "Umuaga",
                "Ububa",
                "Imeama",
                "Umuaneke",
                "Umunnacha",
                "Umuokpala",
                "Unuonaga",
                "Umulumgbe",
                "Akpani",
                "Akpato",
                "AmaUwenu",
                "Amachara",
                "Amaowerri",
                "Edem",
                "Lett",
                "Okomaji",
                "Uwenu",
                "Amadia",
                "Amaebu",
                "Amangwu",
                "Ekpe",
                "Umualia",
                "Umuonye"
            ],
            "Uzo-Uwani": [
                "Abbi",
                "Amanyi",
                "Apapam",
                "Enugu",
                "Owereze",
                "Uba",
                "Umuogbogwu",
                "Uruku",
                "Uwenuokpe",
                "Adaba",
                "Ama-Etiti",
                "Amaogbo",
                "Amaokwe",
                "Amoku",
                "Ibagwa",
                "Obunagu",
                "Ozulume",
                "Umedolu",
                "Umueze-Akwu",
                "Umuezeke",
                "Umuotugbo",
                "Ajuona",
                "Akutala",
                "Eziama",
                "Iyiekeniga",
                "Ofesi-Okpu",
                "Onueke",
                "Uwenuakpa",
                "Nkokpe",
                "Ohe",
                "Umugwuyama",
                "Umuinye",
                "Umunjom",
                "Asaba",
                "Amoye",
                "Obianu",
                "Igga",
                "Akwulu",
                "Asado",
                "Ojulo",
                "Nimbo",
                "Akpamaya",
                "Amogbo",
                "Ekwulu",
                "Isiyiareji",
                "Jide Break",
                "Ngwoko",
                "Owerre",
                "Umuoma",
                "Opanda",
                "Ugwuijoro",
                "Ukpabi",
                "Unasi",
                "Nkpologu",
                "Agumu",
                "Ama-ezike",
                "Ama-ikwere",
                "Ama-ngbana",
                "Arakanyi",
                "Awuzi",
                "Nkpunator",
                "Ugwugo",
                "Ugwuonyishi",
                "Umu Enem",
                "Umuobira",
                "Uwani Ogba",
                "Nkume",
                "Amudala",
                "Eji-Nkume",
                "Ujolodu",
                "Umunu",
                "Nrobo",
                "Ajayigbo",
                "Ofumu",
                "Okpara",
                "Umuamuna",
                "Umudesue",
                "Umuoyo",
                "Ogurugu",
                "Atida",
                "Nkanu",
                "Ofuegbe",
                "Okpotopu",
                "Onaja",
                "Ukpele",
                "Ojor",
                "Umu-Ekeyi",
                "Umu-Ogbochi",
                "Umuame",
                "Umuasaba",
                "Umuitodo",
                "Ugbene",
                "Afokuje",
                "Ama-Ikwu",
                "Ama-Ogidi",
                "Amaiseke",
                "Asnienyi",
                "Enugu-Ada",
                "Isi-Uvuru",
                "Isiama",
                "Itakwuna",
                "Ngwokwa",
                "Orba",
                "Owenu-Ori",
                "Ujaju",
                "Umu-Asa",
                "Umuayo",
                "Umueze",
                "Umukpakar",
                "Uwani",
                "Uwani-Eriyi",
                "Uwenu-Onyishi",
                "Ukpata",
                "Achalla Oda",
                "Amufi",
                "Ugwudimu",
                "Umudi-Ugwu",
                "Umudingwuke",
                "Umueze Amunna",
                "Umueze-Amokwulu",
                "Umuezengwu",
                "Umumbosi",
                "Umuogu",
                "Umuonyia",
                "Umulokpa",
                "Akiyi",
                "Akwunitor",
                "Amagu",
                "Amofu",
                "Amulu",
                "Enugu-Uwani",
                "Eziora",
                "Mgbogbo",
                "Nkwelle",
                "Odida",
                "Ukpatu",
                "Umuezeugwu",
                "Umumasi",
                "Umuogene",
                "Uvuru",
                "Amono-Utokpu",
                "Inama",
                "Ogwu-Umudia",
                "Okasibi",
                "Umuntu",
                "Utoamaka",
                "Uvuru-Ani"
            ]
        }
    },
    {
        "Gombe": {
            "Akko": [
                "Bage",
                "Daji",
                "Danjal",
                "Doma",
                "Ganjuwa",
                "Gombe",
                "Jauro Yinu",
                "Kaltungo",
                "Kwami",
                "Pallam",
                "Rama"
            ],
            "Balanga": [
                "Balanga",
                "Billiri",
                "Dukku",
                "Goma",
                "Kaltungo",
                "Kukawa",
                "Shongom"
            ],
            "Billiri": [
                "Biliri",
                "Buri",
                "Daba",
                "Gengle",
                "Kaltungo",
                "Kumo",
                "Piti"
            ],
            "Dukku": [
                "Dukku",
                "Bogo",
                "Biliri",
                "Dagu"
            ],
            "Funakaye": [
                "Dabai",
                "Funakaye",
                "Jekadafari",
                "Kaltungo",
                "Kwami",
                "Luwa",
                "Riyom"
            ],
            "Gombe": [
                "Akko",
                "Balanga",
                "Billiri",
                "Dukku",
                "Funakaye",
                "Gombe",
                "Kaltungo",
                "Kwami",
                "Nafada",
                "Shongom",
                "Yamaltu/Deba"
            ],
            "Kaltungo": [
                "Gona",
                "Kaltungo",
                "Kushaka",
                "Piti",
                "Ruma"
            ],
            "Kwami": [
                "Garga",
                "Gombe",
                "Kwami",
                "Nafada",
                "Rijau"
            ],
            "Nafada": [
                "Dukul",
                "Nafada",
                "Shongo"
            ],
            "Shongom": [
                "Dagauda",
                "Dewin",
                "Gona",
                "Kaltungo area",
                "Nafada",
                "Piti",
                "Shongom"
            ],
            "Yamaltu/Deba": [
                "Deba",
                "Dukul",
                "Gwandum",
                "Kumo",
                "Nasarawo Sakwai"
            ]
        }
    },
    {
        "Imo": {
            "Aboh Mbaise": [
                "Amuzu",
                "Avuru",
                "Enyio-Gugu",
                "Lorji",
                "Mbutu",
                "Nguru Ahiato",
                "Nguru Nwankwo",
                "Nguru-Nweke",
                "Okwuato",
                "Nriukwu",
                "Umuabazu",
                "Umubee",
                "Umuehu",
                "Umueni",
                "Umugberim",
                "Umulolo",
                "Umuodaa",
                "Umuogu",
                "Akputu",
                "Akuwa",
                "Amadim",
                "Amaim",
                "Amaishi",
                "Amano",
                "Egbelu",
                "Egwutu",
                "Eziala",
                "Ndi Orji",
                "Ndigbo",
                "Ndiukwu",
                "Ode-Na-Ocham",
                "Okwuta",
                "Ozuzu",
                "Ugwuala",
                "Umoshi",
                "Umuaghara",
                "Umuananmu",
                "Umuaru",
                "Umudinka",
                "Umudiriha",
                "Umuebii",
                "Umueke Ugo",
                "Umueze",
                "Umuguojii",
                "Umuhtte",
                "Umuime",
                "Umuocham",
                "Umuogakwu",
                "Umuogale",
                "Umuoraobara",
                "Umuorobala",
                "Abiri-na-Owashie",
                "Akwete",
                "Amaetiti",
                "Amangwu",
                "Amoji",
                "Awagu",
                "Ejealolo",
                "Ibeku",
                "Lagwa",
                "Ndokwu",
                "Okwuaku",
                "Osi-Na-Ashia",
                "Osina",
                "Ugwuanya",
                "Uloakwo",
                "Umu Nwefor",
                "Umuchoko",
                "Umuckoko",
                "Umueleme",
                "Umueme",
                "Umuezaku",
                "Umugba",
                "Umulogho",
                "Umuloke",
                "Umumeka",
                "Umunwaozani",
                "Umuokele",
                "Umuokpo",
                "Umuokwe",
                "Umuolu",
                "Umuonu",
                "Umuoshie",
                "Ezi Amata",
                "Umu Gana",
                "Umu Osike",
                "Amaku",
                "Amoda",
                "Amorji",
                "Egbelubi",
                "Ehere Ukwu",
                "Ihitte Ocha",
                "Obo",
                "Obokwu",
                "Onwuka-Na-Ukpabi",
                "Oreetit",
                "Umuagbara",
                "Umuaham",
                "Umuaku",
                "Umualo",
                "Umubadiloke",
                "Umudaogbor",
                "Umudim",
                "Umuekwene",
                "Umuezee",
                "Umuezele",
                "Umuezeorji",
                "Umugbuakpaka",
                "Umunocha",
                "Umunune",
                "Umuobee",
                "Umuochiedu",
                "Umuogwurukwu",
                "Umuoshielo",
                "Umusiehe",
                "Umusuto",
                "Umuzu",
                "Ezialakohu",
                "Ngali",
                "Ofeama",
                "Ogbe",
                "Okori",
                "Uba",
                "Okwu",
                "Umaumadi",
                "Aja-Na-Agwu",
                "Akabor",
                "Duru Ibekuta",
                "Ebee-Umukabi",
                "Egberekatua",
                "Ezido",
                "Ihuala",
                "Ihumadi-Umuagwu",
                "Kwukwa",
                "Ngaragu",
                "Oborji/Obriji Ukwu",
                "Okinkwa",
                "Okwula",
                "Okwuta-Umuabazu",
                "Omuabazu",
                "Umouguge",
                "Umoukere",
                "Umuba",
                "Umubazu-Eziama",
                "Umumechi-Umukabi",
                "Umunaga",
                "Umunoke",
                "Umunokwu-Amato",
                "Umuobazu",
                "Umuofuga",
                "Umuogwugwo",
                "Umojii",
                "Umuokoro",
                "Umuokwu",
                "Umuoshi",
                "Umuosi",
                "Umuaril-Umabazu"
            ],
            "Ahiazu Mbaise": [
                "Akabor",
                "Ekwereazu Town",
                "Ihitte Afor",
                "Lude/Nnara-Mbia",
                "Mkpam",
                "Obodoahiara",
                "Obodo-Ujichi",
                "Obohia",
                "Ogbe",
                "Ogwuama/Amuzi",
                "Opara-Nadim",
                "Oru Ahiara",
                "Otulu/Aguneze",
                "Umuo-Kirika",
                "Akanu",
                "Azuahia",
                "Ehizaobide",
                "Eveulukwu-Obitti",
                "Ibikiri",
                "Ihieama",
                "Lemeadem-Umuapu",
                "Llile-Mgbuisii",
                "Nguma",
                "Nkarahu",
                "Obitto-Rubber-Est",
                "Oburugo",
                "Odiribo",
                "Ogburu",
                "Ozoma-Ukwu-Umuap",
                "Umagbukiga-Etioha",
                "Umuadu",
                "Umuagu",
                "Umuagwo",
                "Umuagwu-Mgbusoii",
                "Umuakamuche",
                "Umuaku-Etiho",
                "Umuayaka",
                "Umuba",
                "Umubowu",
                "Umuchaka-Ndi-Obu",
                "Umuchine",
                "Umuchokonagu",
                "Umudako-Umuagho",
                "Umuduko Umuagwo",
                "Umudum",
                "Umuebizi",
                "Umuekwonye",
                "Umuezenwora",
                "Umuezuta",
                "Umuhaja",
                "Umuheja",
                "Umukene",
                "Umunwauba-Efioha-Efioha",
                "Umuodu-Ono-Umuapu",
                "Umuofo",
                "Umuogbuanua",
                "Umuoji",
                "Umuokochi-Umuapu",
                "Umuonu-Mgbisii",
                "Umuosu-Mgbisii",
                "Waterside-Settlement",
                "Abacheka",
                "Abaezi",
                "Aliocha",
                "Amachi",
                "Ariam",
                "Dimara",
                "Ekpe-Ekugba",
                "Ekpe-Etekwuru",
                "Ekpe-Mbara",
                "Ekpe-Obokofia",
                "Ekpe-Oforole",
                "Ekpe-Umuoji",
                "Ekpe-Umuudike",
                "Ekugha",
                "Elua",
                "Etekwuru",
                "Isiugbo",
                "Iyioka",
                "Lolo",
                "Mgbara",
                "Mmahu",
                "Ndiowerre",
                "Nkpataku",
                "Nwaro",
                "Obiakkpu",
                "Obibi",
                "Obigbo",
                "Obizi",
                "Obokofia",
                "Obom-Ukw",
                "Oborottu",
                "Oforla",
                "Ojiukwu",
                "Opuoma",
                "Ose-Abacheke",
                "Ose-Mmahu",
                "Ose-Orji",
                "Ubaba",
                "Ubomukwu",
                "Ugada",
                "Ukwugbe",
                "Umuodike",
                "Umuowku",
                "Unuojo",
                "Ogbor",
                "Umuchieze",
                "Umueze",
                "Umunumo",
                "Amakofia",
                "Amankpu",
                "Amaobu Settlement",
                "Amaudara",
                "Amekpaka",
                "Ezoama",
                "Lude-Awa",
                "Ndi-Ikwuebe",
                "Ndiako",
                "Ndionwundele",
                "Obeakuma",
                "Obeama",
                "Okwojo",
                "Okwudo",
                "Orsu",
                "Settlement",
                "Ugbele",
                "Umakpuruedere",
                "Umuakpa",
                "Umuezeala",
                "Umuezeneugwu",
                "Umukaghara",
                "Umukpo",
                "Umuloghocha",
                "Umunachi",
                "Umuofeke",
                "Umuofo-Na-Obai",
                "Umuokoro",
                "Umuokwu",
                "Umuole",
                "Umuomi",
                "Umuoriaku",
                "Umuro",
                "Umurutugbu",
                "Umuwaja",
                "Nnemere",
                "Okpankume",
                "Umuaju",
                "Umuegwu",
                "Umuohia",
                "Aro",
                "Mgbala",
                "Obudi",
                "Uba",
                "Umuakwali",
                "Umuobolaugwu",
                "Umuotunwahi",
                "Igburu-Awara",
                "Ikwerrede",
                "Oshia-Awarra",
                "Umuagbalu",
                "Umudimocho",
                "Umudulu",
                "Umugakwu",
                "Umuigwe",
                "Adapalm-Settlement",
                "Afor-Amafor",
                "Alke",
                "Amafor-Obokwu",
                "Amaiyi",
                "Elekenowasi",
                "Eziama",
                "Eziobojwe",
                "Ihumuonuma",
                "Obnogwu",
                "Obokwu-Amafor",
                "Obora",
                "Olhabele-Ohoba",
                "Umuedo",
                "Umuerim",
                "Umugologo",
                "Umuhuocha",
                "Umukpoche",
                "Umuokem",
                "Umuome",
                "Umuoroma-Obosima",
                "Ogbe Nneishii",
                "Okeawa",
                "Abakuru",
                "Amakohia",
                "Amaokwu-Makohia",
                "Izuoha",
                "Ogwuamahati",
                "Oriekpa",
                "Umuage",
                "Umuaku",
                "Umuaro-Mgbirichi",
                "Umunnanwe",
                "Umuochankwo",
                "Umuofor",
                "Umuokazi",
                "Umuokisi",
                "Umuowasi",
                "Uzuuba-Magbirichi",
                "Oparanadim-Nweke",
                "Operanadim-Nweafor",
                "Operandadim-Nwokwo",
                "Abodinoso",
                "Afor-Oru",
                "Ebisike-Igwe",
                "Eket-Idi-Ido",
                "Nnalane-Okorocha",
                "Owainjoko",
                "Umpara",
                "Umuajunwa",
                "Umualaji",
                "Umuber-Leche",
                "Umualaji-Iwe",
                "Umucheikuku",
                "Umuidi",
                "Umudike",
                "Umuele Na-Ezealawa",
                "Umuenuyi-Na-Ehiocha",
                "Umuieoaku",
                "Umukeli",
                "Umulolo-ogbe",
                "Umunrom-Ororocha",
                "Umuokorobo",
                "Umuokwulehe",
                "Umuoparawuadu-Idi",
                "Umuosi",
                "Umurogu",
                "Aguneze",
                "Itu-Aguneze",
                "Orduga",
                "Umuakwake",
                "Umuobogwo",
                "Umuochoke-Aguneze",
                "Umuokpoke",
                "Umuokuzu",
                "Umuoloo",
                "Umuzeri-Aguneze",
                "OTULU-",
                "Ihitte",
                "Umuoke",
                "Umuorise",
                "Umuoyaa",
                "Umuakam",
                "Umugaa",
                "Akpim",
                "Awoma",
                "Idigele",
                "Okirika-Nwankwo",
                "Okirika-Nweke",
                "Okirka-Nwankwo",
                "Okrika-Ama",
                "Umuagbavu",
                "Umuevu",
                "Umuezuo",
                "Umugama",
                "Umugwa",
                "Umuikwo",
                "Umuobodo",
                "Umuosu",
                "Uzoara/Mgbirichi"
            ],
            "Ehime Mbano": [
                "Agbaja",
                "Ehime",
                "Nsu",
                "Nzerem/Ikpem",
                "Umualumaku/Umuihim",
                "Umueze I",
                "Umueze II",
                "Umuezeala",
                "Umukabai",
                "Umunakanu",
                "Umunumo",
                "Abosi",
                "Dinka",
                "Mgbam",
                "Umuchakwe",
                "Umuduruaro",
                "Umuechele",
                "Umueke",
                "Umuemeke",
                "Umuimo",
                "Umuobia",
                "Umuofa",
                "Agbagbara",
                "Ezeoke",
                "Ihitte",
                "Ikpe",
                "Umuakagu",
                "Umuanunu",
                "Umudur",
                "Umuezeala I",
                "Umuezeala II",
                "Umunohu",
                "Umuopale",
                "Ikwe I",
                "Ikwe II",
                "Mpam-Ikpem",
                "Njoke-Nzerem",
                "Nnegbe-Ikpem",
                "Nocha-Nzerem",
                "Umuagum-Nzerem",
                "Umueleala I",
                "Umueleala II",
                "Umueleke-Ikpem",
                "Umuobodo",
                "Umuoha-Nzerem",
                "Umuolimokoro-Nzerem",
                "Umuolo-Ikpem",
                "Umuosu-Nzerem",
                "Umudibia",
                "Umuonyia",
                "Umuoparalum",
                "Umualuwaka",
                "Umuanigo",
                "Umuawuchi",
                "Umunanom",
                "Umuodu",
                "Umuezeala Ama",
                "Umuezeala Ogwara",
                "Ezike/Umunagbala",
                "Ngboroko",
                "Odoli",
                "Umaizi",
                "Umualuwoke",
                "Umuchoko",
                "Umunkwa",
                "Umunwanekwu",
                "Umuowere",
                "Amazi",
                "Ofeokwe",
                "Okpaziza",
                "Umuele",
                "Umueli",
                "Umuerim",
                "Umugolo",
                "Umuja",
                "Umuola",
                "Eze/Obom",
                "Offor-Ama",
                "Ofo-Owerre",
                "Umuamunu",
                "Umuaro",
                "Umuchima",
                "Umuduruokoro",
                "Umuerir",
                "Umunghala",
                "Umuofeke",
                "Umuogwara",
                "Umuwoshe"
            ],
            "Ezinihitte": [
                "Akpodim",
                "Amaumara",
                "Azuzuahia-Eziudo",
                "Ife",
                "Itu",
                "Obizi",
                "Okpofe",
                "Onicha",
                "Owagia Eziudo",
                "Udo",
                "Akpokwu",
                "Amukwu Okoromiri",
                "Amukwu-Okpulor",
                "Abu",
                "Isiama",
                "Ndem",
                "Obibo",
                "Okeohia",
                "Okpanku",
                "Okwuta",
                "Otutu",
                "Amakam",
                "Ezeakam-Umuhunaez",
                "Ezikpi-Egberemiri",
                "Umuakan-Umuagu",
                "Umuekwerede-Ekwenenaelochi",
                "Umuhu-Egberemiri",
                "Umuzu",
                "Nri",
                "Umuoshi",
                "Achi",
                "Afor/Ocham",
                "Akurubi-Akuru",
                "Anaga",
                "Ekwele",
                "Isu",
                "Oria",
                "Umuagu (Agu O)",
                "Umuakuru",
                "Umuezea (Ezea O)",
                "Amaudi",
                "Azuahia",
                "Obokwu",
                "Umuire",
                "Umuosisi",
                "Chukwuoma",
                "Okpula",
                "Okwu",
                "Okwuaba",
                "Umudinta",
                "Umugadi",
                "Umuime",
                "Umuke",
                "Umuocha",
                "Umuoforikpo",
                "Eziama",
                "Omukwu",
                "Ubolukam",
                "Umuagbala",
                "Umuekekwene",
                "Umueleagwua",
                "Umuevu",
                "Umuhu",
                "Umuoma",
                "Ezibu",
                "Ikenga",
                "Umuchekua",
                "Umuegwu",
                "Umuezeaku",
                "Umuhunaezikpo",
                "Umulolo",
                "Umunebia",
                "Uhuala",
                "Umunorde",
                "Umuofo"
            ],
            "Ideato North": [
                "Akokwa",
                "Isiokpo",
                "Akpulu",
                "Obodo-Ukwu",
                "Osina",
                "Umua Laoma",
                "Uralla",
                "Uzil",
                "Akwu",
                "Owerre-Akokwa",
                "Umuazeaga",
                "Umuokegwu",
                "Umuokwara",
                "Umuopia",
                "Isieke",
                "Okpoko",
                "Ubaha",
                "Okwu",
                "Umuishim",
                "Ugbelle",
                "Umuagbo",
                "Umueme",
                "Umunkwukwa",
                "Umunwarahu",
                "Uzubi",
                "Durunogbu",
                "Eluama",
                "Ofe-Eke",
                "Alaike",
                "Obinaohia",
                "Obinuhu",
                "Umuikpa",
                "Amaokwu",
                "Ezemazi",
                "Ozoakoli",
                "Ozu",
                "Umuturu",
                "Abiakanawaegbo",
                "Ezihe",
                "Umudiesie",
                "Umuonuoha"
            ],
            "Ideato South": [
                "Amnator",
                "Awa-Izuogu",
                "Dikenafai",
                "Isiekenesi",
                "Ndiuche Izuogu",
                "Ntueke",
                "Ubiohia",
                "Ugbelle",
                "Umuakam/Umuago",
                "Umuchima",
                "Umueshi",
                "Umunna-Isiaku",
                "Umuobom",
                "Ogboza",
                "Umuelee",
                "Umueze",
                "Umunobo",
                "Ikpeze",
                "Ndiadimoha",
                "Ndiakeme",
                "Ndiakunwanta",
                "Ndiamazu",
                "Ndianichie",
                "Ndianyakie",
                "Ndiawa",
                "Ndiegbuonyeoma",
                "Ndiejezie",
                "Ndimoko",
                "Ndionuoha",
                "Ndiukwu",
                "Ndiabo/Umuabe",
                "Okohia/Ndikpa",
                "Okuahu/Umuabe",
                "Umuchoke",
                "Umudike",
                "Umueju",
                "Umufai",
                "Awalla",
                "Isieke",
                "Okhia",
                "Umuaghobe",
                "Umudim",
                "Umojisi",
                "Agochia",
                "Amakoham",
                "Amorji",
                "Bianko",
                "Irogbelu",
                "Ndiemenike",
                "Ndiume",
                "Obinikpa",
                "Okoro-Abicha",
                "Okoro-Obumukpabia",
                "Okorobi",
                "Durihuaukwa",
                "Onere",
                "Umuakuoma",
                "Umuchinekwe",
                "Umuduruehughara",
                "Umuduruiakam",
                "Umuokwaradim",
                "Agballa",
                "Umudunaku",
                "Umuleke",
                "Umuokwaraodu",
                "Umuonyiri",
                "Umuoriaku",
                "Ndiokwara",
                "Uhuaka-Okorobi",
                "Umuchunioha",
                "Umuohuoba",
                "Umuokwaramire",
                "Umuokwaraozoka",
                "Obinugwu",
                "Okoroduruaku",
                "Uhala",
                "Umudurnwaneri",
                "Umuduruonara",
                "Umuefe",
                "Umuiokwaranke",
                "Umuokwaraku",
                "Umunaga",
                "Umunanwoke",
                "Akeyi Isiaku",
                "Isiogwugwu",
                "Umuebgbu",
                "Umueme",
                "Umuire",
                "Umulebe",
                "Abukwa",
                "Akanu",
                "Amnagwu",
                "Imenweato"
            ],
            "Ihitte-Uboma": [
                "Abuke",
                "Amainyi",
                "Amakoha",
                "Ato-Werem",
                "Awuchi-Numo",
                "Ezimba",
                "Ikper-Ejere",
                "Onicha-Uboma",
                "Umue-Zegwu",
                "Umuihi",
                "Umuoma",
                "Abekenta",
                "Ibe",
                "Ndibinaihu",
                "Umuchie",
                "Umudibia",
                "Umudikengwu",
                "Umudikeorji",
                "Umuegwele",
                "Umuezeala",
                "Umuoparaodu",
                "Amokwe/Amorji",
                "Omulo",
                "Opara Amainyi",
                "Umuebeta",
                "Umunahihie",
                "Umuode",
                "Amuzu",
                "Ipinweke",
                "Nnacheru",
                "Umuahia",
                "Umuokoroezuka",
                "Umuonyeche",
                "Umuoye",
                "Elugwu",
                "Omuchienta",
                "Umuezea",
                "Umuezina",
                "Umulemaku",
                "Umuopi",
                "Amaikpa",
                "Ummudaku",
                "Umuamara",
                "Umuduebo",
                "Umuebonu",
                "Umunumu",
                "Umuokpoko",
                "Umuore I",
                "Umuori II",
                "Umuduroma",
                "Umuduru",
                "Umueze",
                "Umukoku",
                "Umuanyaku",
                "Umudwu",
                "Umuehie",
                "Umuejere",
                "Umuezealaduzu",
                "Umuopara-Owerre",
                "Ehienahi",
                "Umuakpa",
                "Umudiim",
                "Umuezeke",
                "Umuopara",
                "Umuchioma",
                "Umuakpi",
                "Umule/Umuhere",
                "Umuokparaka",
                "Dikenachieze",
                "Emekengwe",
                "Ikenafo",
                "Uhegbu",
                "Uhuanwuse",
                "Umudiaba",
                "Umuezeokwa",
                "Umuikpu",
                "Umunachiala",
                "Umunne",
                "Umuorisa",
                "Umuosocha",
                "Alaocha",
                "Eluama",
                "Ndiehuhu-Alaocha",
                "Ukwuobu",
                "Umuakugba",
                "Umudinagu",
                "Umuijerekwe",
                "Umunwaokafor"
            ],
            "Ikeduru": [
                "Akabo/Amatta",
                "Amaimo",
                "Amakohia",
                "Atta",
                "Avuvu",
                "Eziama-Ikeduru",
                "Ihuo-Dimeze",
                "Inyishi",
                "Ngogu/Ikem Bala",
                "Ugri-Ike/Okwu",
                "Umudim",
                "Uzoagba",
                "Abazu",
                "Obinnekel",
                "Umuezekom",
                "Umuiyi",
                "Umuiyi-Ukwa",
                "Umuohia",
                "Amaohiara",
                "Amuzu",
                "Egbelu",
                "Obodo",
                "Umuofor",
                "Umuri",
                "Amaoba",
                "Amaochari",
                "Ofo-Obodo",
                "Ogwu",
                "Umualumagwa",
                "Umuaririogu",
                "Umuduruoma",
                "Umuechem",
                "Umuelum",
                "Umuezizi",
                "Umugana",
                "Umukebo",
                "Umuobasi",
                "Umuoleru",
                "Umuonunka",
                "Uzoiyi",
                "Agu",
                "Amaano",
                "Amaeke",
                "Amambaa",
                "Amauba",
                "Aro-Atta",
                "Attaukwu",
                "Awo/Ohii",
                "Ntu",
                "Ogada",
                "Okwara-Na-Ezeala",
                "Olulo/Dimagu",
                "Umuafa",
                "Umuchi",
                "Umuh",
                "Umuhu-Ukwu",
                "Umulolo",
                "Umuoku",
                "Umuonuocha",
                "Amachara",
                "Amato",
                "Amaudara",
                "Obama",
                "Owalla",
                "Umushievule",
                "Amachi",
                "Amambara",
                "Owuzo",
                "Umuagwu",
                "Umuchime",
                "Umuigwe",
                "Umuopa",
                "Amanunu",
                "Okpuala",
                "Umuakpim",
                "Umuawom",
                "Umuokoro",
                "Umuori",
                "Umusi",
                "Oziri",
                "Umuuoti",
                "Umuoziri",
                "Amasa",
                "Ekuem",
                "Ndi-Okwu",
                "Ochicha",
                "Oke-Ikpo",
                "Udor/Ochani",
                "Umuabali",
                "Umuahunanya",
                "Umuaruke",
                "Umuzor",
                "Akwuli",
                "Ndioji",
                "Oba",
                "Ofikoche",
                "Umuamadi",
                "Umuduruebo",
                "Umuezem",
                "Umumgeke",
                "Umumkpehi",
                "Umunnohu",
                "Umuochem",
                "Umuodom",
                "Umushihie",
                "Dimodu",
                "Duruagwu",
                "Duruaro",
                "Duruejeme",
                "Durueneriji",
                "Duruyeome",
                "Kwagide/Duruebo",
                "Ndama",
                "Ndiokwu",
                "Oparaire",
                "Oree/Oyime",
                "Uhualaowere",
                "Umuduruonyeoma",
                "Abo",
                "Amambar",
                "Obokwe",
                "Umualumaku",
                "Umuehichie",
                "Umuelumaku",
                "Umueme",
                "Umueze",
                "Umueziogwu",
                "Umunkpeyi",
                "Umuomii"
            ],
            "Isiala Mbano": [
                "Amaraku",
                "Amauzari",
                "Anara",
                "Ibeme",
                "Nneto Nwaefor",
                "Obollo",
                "Ogbor",
                "Oka",
                "Osu-Ama",
                "Osu-Owerre",
                "Uguri",
                "Umuduru",
                "Umunkwo",
                "Umuosu",
                "Orori",
                "Umuelo",
                "Umukaram",
                "Umuobasi",
                "Amanki",
                "Amuzor Owerre",
                "Ekwe",
                "Okwile",
                "Okwosu",
                "Umuagwu",
                "Umuchukwu",
                "Umudim",
                "Umuecheri",
                "Umueze Chokocho",
                "Umuezeduru",
                "Umumpelle",
                "Umunurno",
                "Aguna",
                "Dialum",
                "Durunaezike",
                "Idem",
                "Station",
                "Umudo",
                "Umuehie",
                "Umuneke",
                "Umuoluwa",
                "Agwumaeze",
                "Alaude",
                "Amaoji",
                "Oduagwu Na Ireze",
                "Okoroukwu Nodu",
                "Umuoduma",
                "Umuokii",
                "Umuoko",
                "Umuopurum",
                "Umutu",
                "Ezike Ikpa-Ezike",
                "Obinohuru",
                "Okpeko-Obinohuru",
                "Ugwuala",
                "Ukulu",
                "Umuata",
                "Umuekwara",
                "Umuezeala-Afor-Ezike",
                "Umuikuku-Obinuhuru",
                "Umukala Obinohuru",
                "Umumahia-Obinohuru",
                "Umumkpu",
                "Umunankwo-Ezika",
                "Alaiyi-Owerre",
                "Alaiyiama'Umuanu",
                "Umuche",
                "Umucheze",
                "Umuikiti",
                "Umukam",
                "Umuoroma",
                "Umuozuama",
                "Umuuakobia",
                "Umuduruagwu",
                "Umuebinwele",
                "Umuelem",
                "Umunuaku",
                "Ndiama",
                "Ndibinuhu",
                "Ndikpa",
                "Ndiowerre",
                "Okpala",
                "Umudike",
                "Umuduru-Ire",
                "Umuezeala",
                "Umunoha",
                "Abaeke",
                "Amaise",
                "Ewuru",
                "Ezi-Eze",
                "Okeri",
                "Okpuala-Umunachi",
                "Umuduruimo",
                "Umuezeala-Nyanke",
                "Umulolo",
                "Umunachi-Diewem",
                "Umuoghai",
                "Umuokoro",
                "Umuokpara",
                "Amaolom",
                "Aro-Naeze",
                "Druire",
                "Eziukwu",
                "Mbara",
                "Obinetiti",
                "Obinetiti Okohia",
                "Odiekiti",
                "Ofeiyi",
                "Opara-Na-Duru-Umuafala",
                "Umuafo",
                "Umuagwu-ukwu",
                "Umuahighi II",
                "Umualighi I",
                "Umuama",
                "Umuama-Umunchi",
                "Umuarusi",
                "Umubo",
                "Umudum-Ogwara",
                "Umudurchie",
                "Umuduruele",
                "Umuelemai I",
                "Umueze",
                "Umueze-Abighehie",
                "Umuezeala Okoro",
                "Umuezeala Umunchi",
                "Umuezeala-Oforikpa",
                "Umuezealagwu",
                "Umuezemaire",
                "Umuezike",
                "Umuguma",
                "Umuhim-Okonia-Umulolo",
                "Umukaku Okohia",
                "Umukuju",
                "Umunnum-Okohia",
                "Umunwaoha",
                "Umunwekwe",
                "Umunwiji",
                "Umuogam",
                "Umuogugala",
                "Umuogwaeku",
                "Umuokwaegede",
                "Umuokwaraobi",
                "Umuomagwu",
                "Umuorike",
                "Umuram-Umanchi",
                "Umuzoho",
                "Amemeka-Umuebie",
                "Awam",
                "Obinatiti-Umuneke",
                "Oparadim-Umuobie",
                "Udubu-Umuopala",
                "Umuduru-Aro",
                "Umuele Ujino",
                "Umueneke-Town",
                "Umuezefeke",
                "Umunaku",
                "Umuopara Agwu",
                "Ebeokimma-Dibia",
                "Egbe-Owerre",
                "Isiebu",
                "Ukwuakwu",
                "Umuagwunta",
                "Umuagwuukwu",
                "Umuchioma",
                "Umudur",
                "Umuduru-Orji",
                "Umuduru/Nneji",
                "Umueboise",
                "Umuegbe",
                "Umueke",
                "Umuelema",
                "Umuezeala-Egbema",
                "Umuichie",
                "Umuluwe-Ajirija",
                "Umunwebo",
                "Umuodu",
                "Umuogwuma-Umunwaebo",
                "Ezunenyi",
                "Ndiowere",
                "Nneato",
                "Umuago",
                "Umuduruebika",
                "Umuizi",
                "Umuonyi",
                "Umuozuga",
                "Amagwu",
                "Anuma",
                "Chokendau",
                "Dike-Ntako",
                "Dunmoeji",
                "Duruesiketu-Okorokwu",
                "Duruofor Duruolume",
                "Duruofor-Ntako",
                "Emeramnwume",
                "Ezeale-Okorokwu",
                "Ezedim",
                "Iheoma Okorokwu",
                "Ihimduru",
                "Ihu",
                "Odummchi-Duru-Oluwe",
                "Okorokwu",
                "Okpamnne-Duru-Oluewe",
                "Oluwe",
                "Omuoma-Okorokwu",
                "Oparaichukwu-Duru",
                "Ukwunyi-Duru",
                "Umulolu-Ahia"
            ],
            "Isu": [
                "Aman-Dugba",
                "Amurie-Amanze",
                "EKWE",
                "Isu-Njaba",
                "Umuno-Ugba",
                "Duriobi-Umualoma",
                "Durueghuruo-Umualoma",
                "Ndiaba",
                "Ndiuhu-Umuduru",
                "Umudike-Okporo",
                "Umudishi",
                "Umuduruoho",
                "Umuelem",
                "Umueye",
                "Umuezealachukwu",
                "Umuihoma-Umunama",
                "Umununo",
                "Umunwoke - Umuarisi",
                "Umuogwu",
                "Umuona",
                "Amaeze",
                "Diojiaku",
                "Diokhara",
                "Dioloka",
                "Dioma",
                "Duraji",
                "Durunaoma",
                "Dururaku",
                "Ekilite",
                "Ezisu",
                "Imenyi",
                "Ndiuhu-Uloasa",
                "Nnerim",
                "Obiato",
                "Okporofo",
                "Umuchegba",
                "Umudieke",
                "Umudinre",
                "Umuduruihoma",
                "Umulolo",
                "Umunwankwu",
                "Umunwisi",
                "Umuokwaradum",
                "Amunike",
                "Ebenano",
                "Ebenato",
                "Eluama",
                "Eziekwe",
                "Ibeama",
                "Ibenwa",
                "Nduhu",
                "Obara",
                "Odoicheku",
                "Umudibi",
                "Umudim",
                "Umuduru-Ehie",
                "Umuduru-Ewufu",
                "Umuogra",
                "Umuoko Rokoro",
                "Umuokwara",
                "Amagbara-Ezealaire",
                "Amato",
                "Araku",
                "Dimnwanze",
                "Duruaku",
                "Duruaku-Umukpoko",
                "Duruiheneku",
                "Eluokporo",
                "Ezeduru-Okwara",
                "Ihite",
                "Ihokporo",
                "Mbaraonu-Nkwo",
                "Ndinbara",
                "Nkahu",
                "Nnato",
                "Nzeneri",
                "Okwara-Nam",
                "Uba",
                "Umorji",
                "Umuchima",
                "Umuduru II",
                "Umuezealaibe",
                "Umunwamiri",
                "Umuokwaraku",
                "Duruaro-Okporo",
                "Durunjaba-Okoro",
                "Umuchoko",
                "Umudigo",
                "Umudike",
                "Umudioma-Ezisu",
                "Umuduoma-Nnerim",
                "Umuezeala",
                "Umuezeala-Ezisu",
                "Umuezeala-Nnerim",
                "Umuezealaji-Ororo",
                "Umumkwo",
                "Umunwodo",
                "Umuokebele",
                "Umuokwara-Dim",
                "Umuokwara-Oha"
            ],
            "Mbaitoli": [
                "Afara",
                "Eziama-Obiato",
                "Ifakala",
                "Mbieri",
                "Ogbaku",
                "Ogwa",
                "Orodo",
                "Ubomiri",
                "Umunoha",
                "Akatta",
                "Amakpu",
                "Amaocha",
                "Ihitte",
                "Obibiokwu",
                "Umuahiaami",
                "Umuezike",
                "Umuokwe",
                "Obaba",
                "Obuoka",
                "Otura-Amaigbo",
                "Otura-Ukwu",
                "Umuduruafor",
                "Umuekpu",
                "Umuele",
                "Umufere",
                "Amafor",
                "Nkwesi",
                "Nwaorieubi",
                "Uba/Amazu",
                "Umuagwuoche",
                "Umutaku/Umungwo",
                "Achi",
                "Amaike",
                "Amankuta",
                "Amaulu",
                "Awo",
                "Azioha",
                "Ebon",
                "Obazu",
                "Obilubi",
                "Obokwe",
                "Ohohia",
                "Ubakwu",
                "Ummomumu",
                "Umuagwu",
                "Umuahii",
                "Umuchoke",
                "Umudagu",
                "Umuduru",
                "Umunjam",
                "Umuobom",
                "Umuodu",
                "Umuonyali",
                "Amaegbu",
                "Eziome-Ogbaku",
                "Ishokpa-Obibi",
                "Lawa-Ogbaku",
                "Ohobo",
                "Okpuala",
                "Umuabagwo-Obibi",
                "Umuaku",
                "Umuawaka-Okwu",
                "Umudogu",
                "Umueze",
                "Umugama-Ogbaku",
                "Umuokpu",
                "Umuyazi-Nsokpo",
                "Uzele",
                "Abazu",
                "Amaeke",
                "Amankwo",
                "Ekereazu Ogwa",
                "Idem-Ogwa",
                "Idem-Ukwu I & II",
                "Idune",
                "Igweocha",
                "Ihihe Ogwa",
                "Ndiuhu",
                "Oburo",
                "Ochii",
                "Oluokwu",
                "Umuanu",
                "Umuarisi",
                "Umuaro",
                "Umuarogo",
                "Umueze-Alakpa",
                "Umuezealaeze",
                "Uru",
                "Uymuegbu Ogwu",
                "Ahaba",
                "Amaku",
                "Amaukwu",
                "Eziama",
                "Oduama",
                "Ofekata",
                "Okwu",
                "Ubaha",
                "Umuonyahu",
                "Ahana",
                "Amaubulu",
                "Egbeada",
                "Obokpu",
                "Ohuba",
                "Ohum",
                "Umuabali",
                "Umuocha",
                "Umuojinnka",
                "Emeabiam",
                "Isieke",
                "Umudu",
                "Umudurundom",
                "Umukanama",
                "Umumbala",
                "Umuokparafor",
                "Umuokparaoma"
            ],
            "Ngor Okpala": [
                "Agala",
                "Amala/Alulu/Oburu",
                "Egbelu/Obube",
                "Elelem",
                "Eziama",
                "Ngor/Ihite/Umu",
                "Ntu",
                "Obiangwu/Logara",
                "Obib-Ezena",
                "Obike",
                "Ohekelem/Nnorie",
                "Ozuzu",
                "Egbelu",
                "Emeke",
                "Alatia",
                "Alulu",
                "Elugwu",
                "Ikem",
                "Imekeze",
                "Obokwe",
                "Umuabali",
                "Umuaghara",
                "Umuagwu",
                "Umuaka",
                "Umuakamerim",
                "Umuarii",
                "Umuelemii",
                "Umuemadiukwu",
                "Umuezumezu",
                "Umuims",
                "Umuisu",
                "Umujala",
                "Umuke",
                "Umunebo",
                "Umuokebi",
                "Umuoshi",
                "Umuotu",
                "Umuwadi",
                "Mgwoma",
                "Ugakwoche",
                "Umuchoko",
                "Umugaa",
                "Umuokpaa",
                "Umuagbara",
                "Umuakiri",
                "Umuechem",
                "Umuiche",
                "Umuoka",
                "Egbelubi-Amata",
                "Umualum",
                "Umuchekwu-Amato",
                "Umuchie",
                "Umuebi",
                "Umuegirige",
                "Umulu",
                "Umuogba",
                "Umuopeke",
                "Umuevo",
                "Ameke",
                "Amuke",
                "Obokwu",
                "Ozara Umukabia",
                "Umuafor",
                "Umuagbom",
                "Umuakali",
                "Umuanyika",
                "Umueke",
                "Umuekperechi",
                "Umujioche",
                "Umukabia",
                "Umuochere",
                "Umuodu",
                "Umuogwugwu",
                "Umuohie Ngor",
                "Umuohu",
                "Umuokoche",
                "Uram Nogr",
                "Okpala",
                "Umuaku",
                "Umuhita",
                "Umuocham",
                "Umuogbor",
                "Umuokpor",
                "Umuolokochie",
                "Umuoru",
                "Uvuru",
                "Awogwu",
                "Eziala",
                "Ngali",
                "Obohia",
                "Umuegemolu",
                "Umuekwune",
                "Umuena",
                "Umueze",
                "Umunchi",
                "Umuoghor",
                "Umuokeola",
                "Umuolulu",
                "Umuopara",
                "Umuoronma",
                "Umuwa",
                "Amaeze",
                "Amaorie",
                "Eziobo",
                "Ogbeke",
                "Okolochi",
                "Umuikea",
                "Ugwana",
                "Umuuagwu",
                "Umubachi",
                "Umudu",
                "Umugakwo",
                "Umugo",
                "Umumahi",
                "Umuoda",
                "Umuogbe",
                "Umuohite",
                "Amaedo",
                "Amandara",
                "Amankwu",
                "Mbutu",
                "Mgbuala",
                "Nnabiada",
                "Nnorie",
                "Oda",
                "Ota/Ikaa",
                "Umuahia",
                "Umuakaeshe",
                "Umuarum",
                "Umudim",
                "Umuhu",
                "Umunobo",
                "Umuohii",
                "Umuonyike",
                "Ekwoke",
                "Eti Oha",
                "Obu",
                "Okechibachi",
                "Okeketa",
                "Opehi",
                "Ovakali",
                "Owu",
                "Umu Ekwune",
                "Umuanyim",
                "Umuapu",
                "Umucheze",
                "Umuejechi",
                "Umuejim",
                "Umuezeakali",
                "Umuezom",
                "Umuikoro",
                "Umuimeka",
                "Umunachi",
                "Umunakwo",
                "Umunama",
                "Umuodam",
                "Umuokweke",
                "Uramobo"
            ],
            "Njaba": [
                "Amucha",
                "Atta",
                "Okwudor",
                "Umuaka",
                "Aguwa",
                "Duriaku",
                "Duroboaku",
                "Duruewuru",
                "Duruigwe",
                "Ebeasaa",
                "Ebeise",
                "Eziene",
                "Umuduruoka",
                "Umunudo",
                "Umunzu",
                "Umuokpoko",
                "Umuokwara",
                "Umuoma",
                "Umuorji",
                "Umuzikeabum",
                "Egwedu",
                "Eziuba",
                "Isiekwe",
                "Ohima",
                "Ubokoro",
                "Ubudom",
                "Ugbele",
                "Umuerim",
                "Umumanu",
                "Umunam",
                "Umuoke",
                "Abazu",
                "Umuawi",
                "Umudirogha",
                "Umuelem",
                "Umuneke",
                "Umuofeke",
                "Umuseke",
                "Achara",
                "Amafor",
                "Amainyi",
                "Amakor",
                "Ibele",
                "Isiozi",
                "Obeakpu",
                "Ogbele",
                "Uba",
                "Umuele"
            ],
            "Nkwere": [
                "Amaok-Para",
                "Eziama-Obaire",
                "Nkwerre",
                "Owerre-Nkw-Orji",
                "Umun-Wala",
                "Aboh",
                "Umuagali",
                "Umuegbe",
                "Umujisi",
                "Umulo",
                "Umuokwaranyido",
                "Umuonyenwere",
                "Unudei",
                "Uzii-na Ofeafor",
                "Amano",
                "Amise",
                "Amaigbo",
                "Nnanano",
                "Nnanato",
                "Obinocha",
                "Obinuhu",
                "Onusa",
                "Ugwunagbor",
                "Umugara",
                "Unmuko",
                "Amaegbu",
                "Ezeoha",
                "Ishiowerre",
                "Oforie",
                "Okorokparaocha",
                "Uhusieke",
                "Umuibu",
                "Umuoke",
                "Umuoma",
                "Agboala",
                "Amaorji",
                "Ekiti",
                "Ndimbara-Umuaro",
                "Ofeiye",
                "Ugwaula",
                "Umuchoke",
                "Umudirimo",
                "Umuduru",
                "Umudurunwaner-o",
                "Umueluweren",
                "Umuezeala",
                "Umunnuhu",
                "Umuokwaraurmu",
                "Umuozu-Umuaro"
            ],
            "Nwangele": [
                "Abaja",
                "Abba",
                "Amaigbo",
                "Isu",
                "Umuozu",
                "Aladoro",
                "Amadi",
                "Duruiheeko",
                "Ebikpe",
                "Eziosuala",
                "Nkwonyikwu",
                "Odenaguma",
                "Odu",
                "Okwenafa",
                "Umuarawode",
                "Umubenelu",
                "Umudim",
                "Umuduru",
                "Umuduruafo",
                "Umuduruehe",
                "Umuduruire",
                "Umuduruokoro",
                "Umuezeala",
                "Umuezealaeke",
                "Umuezealaihu",
                "Umuezealaofor",
                "Umugwudu",
                "Umuike",
                "Umunabala",
                "Umuocha",
                "Umuohe",
                "Umuokwara",
                "Umuokwaran-Yanwu",
                "Umuokwem",
                "Umuome",
                "Umuonyimo",
                "Umuozuo",
                "Amukwe",
                "Mbara",
                "Okwaradimnasu",
                "Okwaradum",
                "Okwesi",
                "Orinaosa",
                "Oteke",
                "Umuduruagwu",
                "Umuezealaibe",
                "Umuonuma",
                "Umuotukwu",
                "Umuozuliri",
                "Abali/Anyam",
                "Eluowere",
                "Ezealaopi",
                "Ezeobolo",
                "Nduhu",
                "Obodo",
                "Ofeahia",
                "Otunna",
                "Umuagwoke",
                "Umuakwaraofo",
                "Umuanya",
                "Umuba/Umudurule",
                "Umuda",
                "Umudike",
                "Umudumagu",
                "Umudurji",
                "Umuduru-Oha",
                "Umuduruagrishi",
                "Umudurueze",
                "Umudurugwonu",
                "Umuduruigwe",
                "Umuduruobi",
                "Umuduruobiaku",
                "Umueze",
                "Umuezealanwoke",
                "Umukabia",
                "Umukwaraoha",
                "Umuleke",
                "Umuode-Umuanu",
                "Umuokwaramadu",
                "Umuruofo",
                "Umuwobube",
                "Abbo",
                "Amuziii",
                "Umualaoke",
                "Umurlu",
                "Umudiweugo",
                "Umudurioke-Umueze-Umuorlu",
                "Umuezealarioha-Umugada",
                "Umunnakara",
                "Umuobasi",
                "Umuopara",
                "Umuoparadim",
                "Umuoparaiheoma",
                "Umuora",
                "Umuosbasi",
                "Ekifiafor",
                "Umuchoke",
                "Umudurhie/Dureze",
                "Umuokwuome"
            ],
            "Obowu": [
                "Alike-Obowu",
                "Amuzi-Obowu",
                "Avutu",
                "Ikwuato",
                "Okena-Logha",
                "Umuariam/Achara",
                "Umungwa",
                "Mgboma",
                "Ngali",
                "Owugha-Ohumala",
                "Umuchienwanyi",
                "Umuekwuele",
                "Umukpa-Ohumala",
                "Umukpa-Uhu",
                "Ndiokwu",
                "Ndiuhu",
                "Umuezigwe",
                "Umulowu",
                "Umuosinta",
                "Amaeke",
                "Umuada",
                "Umuagagba",
                "Umueshi",
                "Umuifem",
                "Umuodinma",
                "dikenta",
                "Ndichule",
                "Odenkume",
                "Okwuohia",
                "Umuagwu",
                "Umuezealu",
                "Umukwu",
                "Umuosochie",
                "Ehume",
                "Umunachi",
                "Amagu",
                "Nnachioma",
                "Umuasonye",
                "Umuegele",
                "Umunnebi",
                "Umuokoro",
                "Amanze"
            ],
            "Oguta": [
                "Awa",
                "Egguoma",
                "Egwe",
                "Ezi-Orsu",
                "Izombe",
                "Mgbelle",
                "Nkwesi",
                "Nnebu-Kwu",
                "Orsu-Obodo",
                "Abiaziam",
                "Akabor",
                "Ejemekwuru",
                "Amagu",
                "Aro-Egbu/Ndibwe",
                "Ebenamo",
                "Odode",
                "Okwubarameh",
                "Omadi",
                "Ubahudara",
                "Ugwurugwuala",
                "Umezeala/Umuojinta",
                "Umuadije",
                "Umuamar/Umuereke",
                "Umubwachuwkwu",
                "Umuezeike",
                "Umuezeikegbu",
                "Umuiheala",
                "Umuohuwo",
                "Umuomirima",
                "Amamputu",
                "Eziama",
                "Ihite-Egwu",
                "Imo",
                "Umuchi",
                "Umudarakerekp-u",
                "Umundankike",
                "Amakofia",
                "Ammaudara",
                "Amnkpu",
                "Ezoama",
                "Ndi-Awa",
                "Ndi-Ikwuegbu",
                "Ndiako",
                "Ndionwundele",
                "Okwojo",
                "Okwudo",
                "Orsu",
                "Ugbele",
                "Umakpuruedere",
                "Umuakpa",
                "Umukaghara",
                "Umuoji",
                "Umuokwu",
                "Umuole",
                "Ndeabiara",
                "Uba",
                "Umuobinihu",
                "Umuudiaba",
                "Abodinoso",
                "Umudei",
                "Umudike",
                "Umukeli",
                "Nnebukwu",
                "Igbugankwo",
                "Kalabari-Beach",
                "Mgbabachi",
                "Umu-akpu",
                "Umu-dei",
                "Umu-eze-aja",
                "Umu-Ifumaezeami-Okiri",
                "Umu-Isoma",
                "Umu-Mbeogeri",
                "Umu-Nnama",
                "Umu-Nwokediukor",
                "Umu-Obike",
                "Umu-Ogbugo",
                "Umu-Omeji",
                "Umu-Onwuka",
                "Umu-Opo",
                "Umu-Udara"
            ],
            "Ohaji/Egbema": [
                "Assa/Obile",
                "Awara/Ikweraede",
                "Egbema",
                "Mgbirichi",
                "Nwari-Agwa",
                "Obudi-Agwa",
                "Ohoba",
                "Umuapu",
                "Umuo-Kanne",
                "Awoma",
                "Idigele",
                "Umugama",
                "Umuikwo",
                "Umuobodo",
                "Umuosu",
                "Uzoara/Mgbirichi",
                "Igburu-Awara",
                "Ikwerrede",
                "Oshia-Awarra",
                "Abaccheka",
                "Abaezi",
                "Aliocha",
                "Ekpe-Oforole",
                "Ekpe-Umudike",
                "Ekpe-Umuoji",
                "Ekpe-Ekugba",
                "Ekpe-Etekwuru",
                "Ekpe-Mbara",
                "Ekpe-Obokofia",
                "Ekugba",
                "Elua",
                "Etekwuru",
                "Isiugbo",
                "Iyika",
                "Mgbara",
                "Mmahu",
                "Nkpataku",
                "Nwaro",
                "Obiakpu",
                "Obibi",
                "Obigbo",
                "Obizi",
                "Obokofia",
                "Obom-Uku",
                "Oborottu",
                "Oforola",
                "Ojiukwu",
                "Opuoma",
                "Ose Abacheke",
                "Ose Orji",
                "Ose-Mmahu",
                "Ubaba",
                "Ubomukwu",
                "Ugada",
                "Ukwugbe",
                "Umuodike",
                "Utu",
                "Abakuru",
                "Amakohia",
                "Amaokwu-Makohia",
                "Umuaro-Mgbirichi",
                "Uzuuba-Magbirichi",
                "Obeama",
                "Umuakpu",
                "Umukpo",
                "Umuofeke",
                "Umuomi",
                "Aro",
                "Mgbala",
                "Obudi",
                "Uba",
                "Adapalm-settlement",
                "Afor-Amafor",
                "Alake",
                "Amafor-Obokwu",
                "Eziama",
                "Eziobojwe",
                "Ihumuonuma",
                "Obnogwu",
                "Obobi",
                "Obokwu-Amafor",
                "Obora",
                "Ohabele-Ohoba",
                "Umuagwu",
                "Umuerim",
                "Umugologo",
                "Umukpoche",
                "Umuodu",
                "Umuokem",
                "Umuome",
                "Umuoroma-Obosima",
                "Akanu",
                "Azuahia",
                "Ehizaobide",
                "Eveulukwu-Obitti",
                "Ibikiri",
                "Ihieama",
                "Illile-Mgbuisii",
                "Lemeadem-Umuapu",
                "Nguma",
                "Nkarahu",
                "Obitto-Rubber-Est",
                "Oburugo",
                "Odiribo",
                "Ogburu",
                "Ozoma-Ukwu-Umuap",
                "Umagbukiga-Etioha",
                "Umuadu",
                "Umuagu",
                "Umuagwo",
                "Umuagwu-Megbuosii",
                "Umuaku-Etiho",
                "Umuba",
                "Umubowu",
                "Umuchime",
                "Umudako-Umuagho",
                "Umuduko Umuagwo",
                "Umudum",
                "Umuezenworaa",
                "Umuezuta",
                "Umuhaja",
                "Umuheja",
                "Umukene",
                "Umunwauba-Efioha-Effioha",
                "Umuodu-Ono",
                "Umuokochi-Umuapu",
                "Umuonu-Magbisii",
                "Umuosu-Mgbissi",
                "Waterside-Settlement",
                "Orduga",
                "Umuobogwo",
                "Umuokpoke",
                "Umuokuzu",
                "Umuoloo"
            ],
            "Okigwe": [
                "Amuro",
                "Ihube",
                "Okigwe (Rural)",
                "Otan-Chara",
                "Otanzu",
                "Umulolo",
                "Aro-Amuro",
                "Agbala",
                "Akpugo",
                "Amagu",
                "Amalator",
                "Amano",
                "Ogube",
                "Aro-Okigwe",
                "Aro-Ubaha",
                "Ope",
                "Ubahaa",
                "Umuka",
                "Umuokpara",
                "Alaike-Ogwaku",
                "Alaocha-Igwaku",
                "Ihitte",
                "Ihitte-Isiokwe",
                "Ikenga",
                "Ikenga-Isiokwe",
                "Amaeze-Ogii",
                "Umuawa-Ogee",
                "Unualumoke",
                "Agbobu",
                "Agbuala",
                "Aku (Ihette)",
                "Aku (Ikenga)",
                "Amaosu",
                "Amasator",
                "Aro-Agbobu",
                "Aro-Umulol (West)",
                "Aro-Umulolo (East)",
                "Ibinta",
                "Ndi-Oji",
                "Ndi-Okoroji",
                "Okanachi",
                "Umuawa-Ibu"
            ],
            "Orlu": [
                "Amaifeke",
                "Amaike",
                "Eziachi",
                "Ihioma/Ebenese",
                "Ihitte-Owerre",
                "Mgbee",
                "Obibi-Ochasi",
                "Ogberuru",
                "Okporo",
                "Orlu (Rural)",
                "Owerre-Ebeiri",
                "Umudioka",
                "Umuna",
                "Umuowa",
                "Umutanze",
                "Umuzike",
                "Ajafulem",
                "Amadim",
                "Ihunachi",
                "Okoroemenje",
                "Oleme",
                "Uja",
                "Umucheke",
                "Umudaza",
                "Umuegbe/Umuezihe",
                "Umueze",
                "Umuobom",
                "Umuofeke",
                "Unudu",
                "Unulolo",
                "Unuola",
                "Eshime",
                "Umudimodu",
                "Umudimoha",
                "Umuduruelem",
                "Umuduruewuru",
                "Umuokwaraebike",
                "Umutukutu",
                "Amano",
                "Amato",
                "Umuduruaku",
                "Umuoba",
                "Ebenese",
                "Ikwubali",
                "Umuezenachi",
                "Aboh",
                "Amanator",
                "Obinugwu",
                "Ozara",
                "Umosshie",
                "Umudara",
                "Umuokwara",
                "Amihe",
                "Uhuala",
                "Umudim",
                "Umuede",
                "Umuezike",
                "Umuiheanji",
                "Umuomedi",
                "Eluguwutokpi",
                "Umuadu",
                "Umuawule",
                "Umunume",
                "Ubaha",
                "Abara-Durueze",
                "Akwakuma",
                "Umuechem",
                "Umudaraezike",
                "Umudim-Na-Dara",
                "Umudim-Na-",
                "Umuekee",
                "Umuebele",
                "Umuocham",
                "Aluama",
                "Ndiowerre",
                "Umuafor",
                "Umudiatu",
                "Umudihe",
                "Umuelelke",
                "Umuire",
                "Umundule",
                "E/Uama",
                "Ezeakaeke",
                "Ndimbara",
                "Ndiokwu",
                "Okworji",
                "Onyioha",
                "Umuduru",
                "Umuokwu",
                "Umuorekpu",
                "Owerre",
                "Umudiokaukua",
                "Amoji",
                "Ebenato",
                "Umuokware-ikuku",
                "Umusasa",
                "Ejemewune",
                "Umubu",
                "Odielieku",
                "Ujah",
                "Okwaraebike",
                "Okwu",
                "Okwuekititi-Umubu",
                "Uhu-Umuba",
                "Umudaduru",
                "Umudilee",
                "Umuezikegwu-Ujah",
                "Umuezukwe",
                "Umuogu",
                "Chioke",
                "Obinator-Obor",
                "Okwuafor",
                "Uba-Na-Okpara",
                "Ubaha-Owerri",
                "Umualum",
                "Umunkwu-Umudim",
                "Umuegbe",
                "Umuezeoma",
                "Umuezurike",
                "Umulolo",
                "Umunkwu",
                "Umuogini",
                "Umuokew",
                "Umuokwaraji"
            ],
            "Orsu": [
                "Amaruru/Ebenasaa",
                "Assa Ubirielem",
                "Awo Idemili",
                "Ebenator",
                "Eziawa",
                "Ihitte-Nansa",
                "Orsu Ihite-Ukwu",
                "Umuhu-Okabia",
                "Umuadu",
                "Amaokwe",
                "Elugwutokpi",
                "Elugwu",
                "Umuawula",
                "Umunume",
                "Umungozi",
                "Ihuoma",
                "Umuogueri",
                "Umughadinanwa",
                "Akpiobu",
                "Elugwu-Umuhu",
                "Elugwu-umuoka",
                "Isi-Assah",
                "Okuabasisi",
                "Uhuala-Umuoka",
                "Umucheke",
                "Umuidi",
                "Abahb",
                "Amadim",
                "Amaimo",
                "Amaokew",
                "Edenta",
                "Edeukwu",
                "Ezeogwu",
                "Isieke",
                "Obhukabia",
                "Obibi",
                "Ubahaeze-Awo",
                "Ubahaezeleke",
                "Ubahaezike",
                "Amaebu",
                "Amaebu Nkwo",
                "Amaranetu",
                "Amazu",
                "Akama-Ubaha",
                "Amakpara",
                "Urualla",
                "Akama",
                "Amaokpara",
                "Chekenagu",
                "Nansa",
                "Ogum",
                "Ogwugwu-Eyi",
                "Umudiaba",
                "Umudim",
                "Amihia",
                "Etiti",
                "Iheteukwu",
                "Okwu",
                "Uda",
                "Ofeahia",
                "Ofeke",
                "Umuerem",
                "Umunabochi"
            ],
            "Oru East": [
                "Akatta",
                "Akuma/Amagu",
                "Amiri",
                "Eziawo ll",
                "Eziawo 1",
                "Ofekata ll",
                "Ofekata 1",
                "Omuma",
                "Akwa",
                "Etim",
                "Ibah",
                "Ichina Amaka",
                "Ulahangwu-Nakporo",
                "Ura",
                "Abamba Akuma",
                "Ezi Akuma",
                "Ezioha Amagu",
                "Ihitte-Akum",
                "Ihitte-Amagu",
                "Ulabia-Akuma",
                "Amokpara-Amiri II",
                "Isioorie Amiri-Isu",
                "Nchoko-Amiri I",
                "Nchoko-Amiri-Isu",
                "Ugbeke-Amiri-Oru I",
                "Umbutu-Amiri-Uru II",
                "Umuduni-Amiri III",
                "Umuduni-Amiri-Ise",
                "Isieke",
                "Ubaeze",
                "Umuejike",
                "Umuezukwe",
                "Obibi",
                "Ohuba",
                "Umuokwe",
                "Okwoji",
                "Ubachima",
                "Umubochi",
                "Umueme",
                "Ubogwu",
                "Umuezeala",
                "Abia-Ozuh",
                "Umuhu-Etit"
            ],
            "Oru West": [
                "Aji",
                "Amaofuo",
                "Eleh",
                "Ibi Asoebe",
                "Mgbidi",
                "Nempi",
                "Ohakpu",
                "Otulu",
                "Ozara",
                "Ubulu",
                "Abuga-Ezi",
                "Akwada-Ihitte",
                "Amiriaji-Ihitte",
                "Ihitte",
                "Ubahaze-Ijeja",
                "Amorie",
                "Ebisi",
                "Ubaha",
                "Umuduru",
                "Umuabiahu",
                "Umuezike",
                "Umuoma",
                "Amadaba",
                "Aro-Ibiasoegbe",
                "Exiama",
                "Ubahaibi",
                "Umuonicha",
                "Umuorji",
                "Ezeani",
                "Imeoha",
                "Mgbidi Govt. Station",
                "Ugbele",
                "Umuaboah",
                "Umuehi",
                "Umuekwe/Okwudoe",
                "Umuokpara",
                "Uzinumu",
                "Ezioha",
                "Amafor",
                "Aro",
                "Eziukwu",
                "Ikenga",
                "Ubahudara",
                "Okponsu",
                "Ubahawa",
                "Umueji",
                "Umuezem",
                "Umuhu",
                "Aboh",
                "Etitilabu",
                "Ngbidi",
                "Ubaha-lanuwon",
                "Umuobioma",
                "Umuogu",
                "Umuokoporoma",
                "Amadelu",
                "Amaorie",
                "Ezenamba",
                "Eziama",
                "Umuanyachu",
                "Umuchukwu",
                "Umuihejiofor",
                "Umuoleaku",
                "Umuonyeyile",
                "Umuoru"
            ],
            "Owerri North": [
                "Egbu",
                "Emekuku",
                "Emii",
                "Ihite/Ogada/Oha",
                "Naze",
                "Obibi-Usratta",
                "Orji Aut",
                "Ishiza",
                "Mapna",
                "Ofeuzo",
                "Umuayalu",
                "Umuofor",
                "Akalovo",
                "AWAKA 460110",
                "Azara Owale",
                "Azaraegbelu",
                "Azeogba",
                "Ezedibia",
                "Ndi-Egbelu",
                "Okwu-Emeke",
                "Uboegbulu",
                "Ubowala",
                "Umuadu",
                "Umuakuru",
                "Umuocham",
                "Umuzi",
                "Emeoha",
                "Eziala",
                "Mgbahiri",
                "Nkepho",
                "Ubah",
                "Umuaawuka",
                "Umudulu",
                "Umuebe",
                "Umuolu",
                "Umuorisha",
                "Akwakuma",
                "Amakohia",
                "Ogoloche",
                "Okom",
                "Owaala",
                "Owaelu",
                "Umunahu",
                "Ezeakiri",
                "Okpala",
                "Umuakali",
                "Umuezuo",
                "Umuosu",
                "Umurie",
                "Umualum",
                "Umuobaa",
                "Umuorii",
                "Umegowerem",
                "Umekehi",
                "Umuazuonye",
                "Umuchoke-Umuahuh",
                "Umuegii",
                "Umuimeke",
                "Umundula",
                "Umuodu"
            ],
            "Owerri West": [
                "Avu/Umuguma",
                "Ihiagwa",
                "Nekede",
                "Obinze",
                "Oforola",
                "Okolochi/Eziobodo",
                "Okuku (Obogwu)",
                "Umunwoha",
                "Obokwu",
                "Ogubuosisi",
                "Umuadu",
                "Umuehieta",
                "Umunkwo",
                "Umunwanyi",
                "Umuobia",
                "Umuome",
                "Ibuzor",
                "Iriamugo",
                "Mbokwe",
                "Nkaramuche",
                "Umuchima",
                "Umuehum",
                "Umuezeanula",
                "Umuokwo",
                "Umualum",
                "Umudibia",
                "Umuoma",
                "32 Artillery Bgd",
                "Umuagam",
                "Umuanunu",
                "Umuebo-Obokwu",
                "Umuezereoche",
                "Umunenje",
                "Umuokuru",
                "Amaku",
                "Amaoji",
                "Oboagwu",
                "Umuagubiam",
                "Umueke",
                "Umuezuko",
                "Umuimeka",
                "Umuogide",
                "Emeabiam",
                "Eziobodo",
                "Mgbolo",
                "Obogwu",
                "Uborji",
                "Umuapu",
                "Amakoha-Ubi",
                "Irete",
                "Ndegwu",
                "Ohii",
                "Orogwu"
            ],
            "Unuino": [
                "Okwe",
                "Okwelle",
                "Umuduru",
                "Umuna",
                "Ezelu",
                "Eziama",
                "Ezoama",
                "Owerre",
                "Umucheke",
                "Alaike",
                "Ofeahia",
                "Oji ama",
                "Oji-Owerre",
                "Okoronkwu",
                "Umoma",
                "Umuagwo",
                "Umudufuebo",
                "Umudumoodu",
                "Umuegwala",
                "Umueze-Owerre",
                "Umuoko",
                "Umuokwara",
                "Umuoram",
                "Aboh",
                "Aro-Umuduru",
                "Ofahia",
                "Ofeabia",
                "Okohia",
                "Umuanumeze",
                "Umuokpara-Bobo",
                "Umuokparaiye",
                "Diakuma",
                "Nzifoke",
                "Uhi"
            ]
        }
    },
    {
        "Jigawa": {
            "Auyo": [
                "Auyo",
                "Ayama",
                "Ayan",
                "Gamasarka",
                "Gatafa",
                "Kafur",
                "Tsidir",
                "Auyakayi",
                "Unik",
                "Gamafoi"
            ],
            "Babura": [
                "Babur",
                "Babura",
                "Bai Ali",
                "Batali",
                "Bulo",
                "Burukum",
                "Dorawa",
                "Garu Gudi",
                "Gaskoli",
                "Giginya",
                "Insharuwa",
                "Jigawa",
                "K. Zumi",
                "Kafin Rabo",
                "Kandi",
                "Kanya Babba",
                "Kyanbo",
                "R. Tsamiya",
                "Tasakwasa"
            ],
            "Badawa": [],
            "Birnin Kudu": [
                "Birnin Kudu",
                "Arabode",
                "Badingu",
                "Bakwanga",
                "Bamaina",
                "Birnin",
                "Chiyako",
                "Fada",
                "Gwadayi",
                "Hirin",
                "Iggi",
                "J. Nasara",
                "Jajikoli",
                "Jangargari",
                "Kadangare",
                "Kafin Madaki",
                "Kangire",
                "Kantoga",
                "Kawaya",
                "Kawo",
                "Kwan Gwara",
                "Kwari",
                "Lafiya",
                "Madakanchi",
                "Masaya",
                "Massanawa",
                "Nafara",
                "Samamiya",
                "Shun Gurum",
                "Sundiimina",
                "Surko",
                "Unguwar'ya",
                "Warawade",
                "Wurno Fade",
                "Yalwan Chakauri",
                "Yalwan Damai",
                "Yarma",
                "Zanga",
                "Zarainawa"
            ],
            "Buji": [
                "Buji",
                "Ahoto",
                "Buji-Kudu",
                "Churban",
                "Falgeri",
                "Gantsa",
                "Jukuma",
                "Karanjau",
                "Kawaya",
                "Madabe",
                "Tijio",
                "Y/Tukur"
            ],
            "Dutse": [
                "Dutse (Rural)",
                "Abaya",
                "Baranda",
                "Barandau",
                "Bujim",
                "Burtulan",
                "Chai-Chai",
                "Chamo",
                "Dagwaje",
                "Danmasara",
                "Dantauya",
                "Darau",
                "Dilake",
                "Duku",
                "Dundubus",
                "Duru",
                "Fagoji",
                "Fanisau",
                "Galamawa",
                "Garu",
                "Gidan Dubu",
                "Gofai",
                "Gurungu",
                "Gwari",
                "Hammayayi",
                "Hausawa",
                "Irwa",
                "Jaudi",
                "Jidawa",
                "Jigawar Tsada",
                "Kacha",
                "Kachi",
                "Kargo",
                "Karnaya",
                "Katangar",
                "Katangare",
                "Kawaye",
                "Kazama",
                "Kudai",
                "Kwadiya",
                "Kwaimawa",
                "Kyaran",
                "Lafia",
                "Laraba",
                "Limawa",
                "Madobi",
                "Maranjuwa",
                "Rurun Gwani",
                "Sabalari",
                "Sabon Gari Ruru",
                "Sakwaya",
                "Sharifai",
                "Tabobo",
                "Takur",
                "Tsari",
                "Wangara",
                "Warwade",
                "Wurma",
                "Yadi",
                "Yalwa",
                "Yalwawa",
                "Yargaba",
                "Zobiya"
            ],
            "Gagarawa": [
                "Gagarawa",
                "Garin-Chiroma",
                "Kore Balatu",
                "Madaka",
                "Maiadua",
                "Maikilili",
                "Medu",
                "Sarkin Dare",
                "Yalawa"
            ],
            "Garki": [
                "Garki",
                "Aduwa",
                "Ajun",
                "Babande",
                "Bakar sabara",
                "Baki",
                "Balarabe",
                "Bargoza",
                "Batakashi",
                "Bunji",
                "Chakurawa",
                "Dahuwar",
                "Dakache",
                "Dan Musa",
                "Dan-Dagura",
                "Danikani",
                "Dantsoro",
                "Dinya",
                "Doguwarkula",
                "Doko",
                "Dorai",
                "Dosano",
                "Dukawa",
                "Dundu",
                "Dundube",
                "Dunguzu",
                "Fadikabara",
                "Faggen Gawo",
                "Farakami",
                "Gabari",
                "Gako",
                "Galadima",
                "Garau",
                "Gashi",
                "Gayawa",
                "Gidan Maza",
                "Guddan",
                "Guraji",
                "Gwadiyawa",
                "Gwandai",
                "Gwarzo",
                "Haladadarwa",
                "Jafigari",
                "Jan Gari",
                "Jema",
                "Jirima",
                "Juya",
                "Kanya",
                "Kanyar",
                "Kargo",
                "Katirje",
                "Kattgo",
                "Kiliya",
                "Kita",
                "Koguram",
                "Kore",
                "Koyoma",
                "Kududufawa",
                "Kuguran-Sabuwa",
                "Kukar Kuturu",
                "Kuranbanin",
                "Kurgungun",
                "Kuttu",
                "Kwadage",
                "Kwanarya",
                "Kyasora",
                "Laika",
                "Lautai",
                "Madangala",
                "Mahemi",
                "Mahoni",
                "Mai-Gagaffa",
                "Maiganta",
                "Maigora",
                "Maikaho",
                "Maiwando",
                "Maizaure",
                "Makangawa",
                "Makidaka",
                "Mala",
                "Marke",
                "Muku",
                "Musa Ta Rumawa",
                "Nadanawa",
                "Rafin Marke",
                "Siyori",
                "Sugumgum",
                "Tagawayan Fage",
                "Tagwaye",
                "Tahaiji",
                "Tankari",
                "Tawilawa",
                "Tuya",
                "Unbnono",
                "Unbono/Tsohuwa",
                "Ung. Bako",
                "Ung. Dudi",
                "Ung. Maigari",
                "Ung. Rodo",
                "Walawa",
                "Yan Barage",
                "Yan Wahabi",
                "Yar Kureshe",
                "Zaidawa",
                "Zakoli",
                "Zango"
            ],
            "Gumel": [
                "Danzomo",
                "Albasu",
                "Banaga",
                "Burmanawa",
                "Gangara",
                "Gwadiya",
                "Haammado",
                "Kirgi",
                "Turkushawa",
                "Gumel",
                "Faraina",
                "Gumel Area",
                "Gumel Kudu"
            ],
            "Guri": [
                "Guri",
                "Abunabo Bulama",
                "Adiyani Fulani",
                "Bulama",
                "Dawa Bulama",
                "Gadya Bulama",
                "Gagiya Bulama",
                "Garbagal Bulama",
                "Garin Bulama",
                "Garin Buluma",
                "Garin Mai-Ung.Cadu a m",
                "Garin Mai-Unguwa",
                "Grin Mai -Unguwa",
                "Kadira",
                "Ladiya",
                "Margadu",
                "Musari Dagana"
            ],
            "Gwaram": [
                "Gwaram",
                "Barebari",
                "Basirka",
                "Chediya",
                "Dingaya",
                "F/Dutse",
                "Fagam",
                "Gadama",
                "Gagarayaga",
                "Galambi",
                "Guna'a",
                "Gwaram Sabuwa",
                "Gwaram Tsohuwa",
                "Jikas",
                "Jingino",
                "K/Fulani",
                "Kila",
                "Kwandako",
                "Kwarko",
                "Lafiya",
                "Maruta",
                "N/Nagogo",
                "Nahuche",
                "Nasarawa",
                "Rabadi",
                "Rambazau",
                "Sakuwa",
                "Sara",
                "Tsangarwa",
                "Un Fada",
                "Yadda",
                "Yarfi",
                "Yayari",
                "Z/Tagabas"
            ],
            "Gwiwa": [
                "Gwiwa",
                "Buntusu",
                "Daabi",
                "Darina",
                "Firjin Yamma",
                "Guntai",
                "Korau",
                "Korayel",
                "Saum Sainawa",
                "Shafe",
                "Yola"
            ],
            "Hadejia": [
                "Hadejia (Rural)",
                "Chadi",
                "Dalla",
                "Dubantu",
                "Fantali",
                "G R A",
                "Gagulmari",
                "Gandun Binda",
                "Garko",
                "Goma",
                "Kaffar Yamma",
                "Koffar Fada",
                "Majema",
                "Makwalla",
                "Matsaro",
                "Rumfa",
                "Yankoli",
                "Yelwa"
            ],
            "Jahun": [
                "Aujara",
                "Atawame",
                "Burabiri",
                "C/Dango",
                "C/Gona",
                "Carado",
                "Damutawa",
                "Darai",
                "Dina",
                "Doro",
                "G/Zaki",
                "Gabari",
                "Garan",
                "Gaurai",
                "Gunka",
                "H/Tschuwa",
                "Jabarna",
                "Kale",
                "Kanwa",
                "Kargo",
                "Larabawa",
                "M/Aruman",
                "M/Atuman",
                "Magama",
                "Tukuyama",
                "Achau",
                "Aducuwa",
                "Afunfuna",
                "Agufa",
                "Chambe",
                "Chanbayi",
                "Dogawa",
                "Fngwalayi",
                "Galadima Jibo",
                "Gangawa",
                "Gauza Gwamfai",
                "Gwari",
                "Harbo Sabuwa",
                "Harbo Tsohuwa",
                "Idanduna",
                "Kadawawa",
                "Kadoma",
                "Kafin-Baka",
                "Ki-Bawa",
                "Kwanjamaawa",
                "Maduga",
                "Rinde",
                "Tukunyawa",
                "Yarijigawa"
            ],
            "Kafin Hausa": [
                "Bulangu",
                "G/Dadada",
                "Gamatuwai",
                "Gamayin",
                "Gilador",
                "Hago",
                "Jabo",
                "Kaigamari",
                "Karalbali",
                "Kullimi",
                "Kwatalo",
                "Majawa",
                "Mexam",
                "Safa",
                "Shakato",
                "Shakato Etd",
                "Shamakeri",
                "Yayari",
                "Zango Kura",
                "Abdallawa",
                "Adaraushe",
                "Ashuran",
                "Auno",
                "Baraduwa",
                "Baushe",
                "D/Kyaure",
                "Damadumin toka",
                "Gafasa",
                "Gafaya",
                "Kanzan",
                "Kazalewa",
                "Kore",
                "Kununu",
                "Kutugu",
                "Maruko",
                "Maruwa",
                "Masassadi",
                "Maseri",
                "Ruba",
                "Sarawa",
                "Wuiwui",
                "Zzgo Digaci"
            ],
            "Kaugama": [
                "Kaugama",
                "Dabora",
                "Dakayawa",
                "Garin Gabas",
                "Hadi",
                "Haskandu",
                "Jarkasa",
                "Marki",
                "Ungwar-Jibrin",
                "Yalo"
            ],
            "Kazaure": [
                "Kazaure",
                "Dabaza",
                "Durji",
                "Gada",
                "Guru Karatayi",
                "Kanti",
                "Kazaure Chikingari",
                "Tsohon Kafi",
                "Unguwar Gabas",
                "Unguwar Yamma"
            ],
            "Kiri Kasama": [
                "Kiri-Kasamma",
                "Abunabo",
                "Adiyani",
                "Arin",
                "Baturiya",
                "Buluncai",
                "Dagana Bulama",
                "Dawa",
                "Fandum",
                "Gadua",
                "Gagiya",
                "Garbagal",
                "Garin Babba",
                "Garin Mai-Unguwa",
                "Iyo",
                "Jarmari",
                "K/Kasamma",
                "Kabak",
                "Kadira",
                "Lafiya",
                "Madachi",
                "Mailakaun",
                "Margadu",
                "Marma",
                "Matara Babba",
                "Mattafari",
                "Salwri",
                "Tage Gari",
                "Tasheguwa",
                "Turabu"
            ],
            "Kiyawa": [
                "Kiyawa",
                "Akar",
                "Andaza",
                "Balago",
                "Chiromawa",
                "Duhuwa",
                "Dungu",
                "Fake",
                "Fiya",
                "Garkon Alli",
                "Gurduba",
                "Gurum Bakin Gari",
                "Haddori",
                "Karfawa",
                "Katanga",
                "Katuka",
                "Kumi",
                "Kwanda",
                "Maje",
                "Mazazzaga",
                "Sabon Gari",
                "Shuwarin",
                "Tsurma",
                "Tunanan",
                "Turho"
            ],
            "Maigatari": [
                "Maigatari",
                "Balarabe",
                "Bansuwa",
                "Dankumbo",
                "Fulata",
                "Galadi",
                "Garmka",
                "Jajeri",
                "Katika",
                "Kukayasku",
                "Madana",
                "Matoya",
                "Turbus"
            ],
            "Mallam Madori": [
                "Mallam Madori",
                "Akuriya",
                "Arbus",
                "Arki",
                "Bultuwa",
                "Dakido",
                "Dunari",
                "Fateka",
                "Garin Gabas",
                "Grinwa",
                "Hayya",
                "Jarmeski",
                "Kafinjae",
                "Katomari",
                "Kukakwance",
                "Mairakunmi",
                "Makadari",
                "Masama",
                "Pateka",
                "Sharkawa",
                "Sheya",
                "Tagwaro",
                "Tashena",
                "ToniKotara",
                "Zaburan"
            ],
            "Miga": [
                "Miga",
                "Burji",
                "Dangyatun",
                "Garba",
                "Gululu",
                "Gwari",
                "Hantsu",
                "Sabon Gari",
                "Sansani",
                "Takalafiya",
                "Tsagaiwa",
                "Tsakuwawa",
                "Yanguwa",
                "Zango",
                "Zareku"
            ],
            "Ringim": [
                "Ringim",
                "Amaguwa",
                "Bago-Gwadamo",
                "Chai-Chai",
                "Daabigyel",
                "Dabi",
                "Dan-Makeri",
                "Daurawa",
                "Daushe",
                "Dingare",
                "Gasakole",
                "Kafin Banushe",
                "Karshi",
                "Karwai",
                "Kaura Dabi",
                "Kaya Gazara",
                "Malamawa",
                "Marawa",
                "Sankara",
                "Sintilmawa",
                "Tofa",
                "Yakasawa",
                "Yandutsi",
                "Zangon-Kanya"
            ],
            "Roni": [
                "Amaryawa",
                "A/Fulani",
                "Aborawa",
                "Amaryawa Haba",
                "Baniyaka",
                "Bashe Habe",
                "Billar F",
                "Billas",
                "Bula",
                "Buntusu",
                "Ciki Kaini",
                "Dabawa",
                "Dabi",
                "Dagal",
                "Dage",
                "Dantaimu",
                "Darina",
                "F/Habe",
                "Firjin Yamma",
                "Fulani",
                "Fumuma",
                "Galoru",
                "Gangare",
                "Gidan Dawa",
                "Gora",
                "Guntai",
                "Gwiwa",
                "Jabiyana",
                "Jakanga",
                "Jama a",
                "Jandutse",
                "Jangefe",
                "Jigawa",
                "Kaganto",
                "Kari",
                "Kari Mai Wande",
                "Karofin Tsamiya",
                "Kaya",
                "Kayalwa",
                "Korau",
                "Korayel",
                "Kwadage",
                "Kwaita",
                "Luda",
                "Makadi",
                "Mamudawa",
                "Rumawa",
                "S/Gari",
                "Sauma Sainawa",
                "Shafe",
                "T/Arewa",
                "T/Gabas",
                "Tabanni",
                "Tsakani",
                "Ung. Dashi",
                "Ung. Dunyi",
                "Ung. Fulani",
                "Ung. Rogo",
                "Wailare",
                "Yalde",
                "Yankazi",
                "Yankewa",
                "Yola",
                "Zagabu",
                "Zugai",
                "Zurai",
                "Zuru Makera",
                "Bakin Jangal",
                "Bamau",
                "Baragumi",
                "Basana",
                "Bashe",
                "Bazara",
                "Bugaje",
                "Burna Ruwa",
                "Dadin Sarki",
                "Dagasawa",
                "Daleji",
                "Damalawa",
                "Dan Abzin",
                "Dangadi Maimarina",
                "Dansala",
                "Dansure",
                "Daragi",
                "Datsa",
                "Daurawa",
                "Diddigau",
                "Dinya",
                "Faifeku",
                "Faran Barinje",
                "Furtawa",
                "Gadare",
                "Gallan Kyau",
                "Gasakoli",
                "Gauraye Duwigi",
                "Gerawa",
                "Gezawa",
                "Gimi",
                "Hinningere",
                "Jama sa",
                "Jawo Sanda",
                "Kanawa",
                "Karama",
                "Karo",
                "Karshi",
                "Kuka Tsaye",
                "Kulgure",
                "Kurayai",
                "Kurket",
                "Kurman Runa",
                "Kurneji",
                "Kwanyawa",
                "Kwarare",
                "Kwatsatsa",
                "Lemaru",
                "Ljela",
                "Mahuta",
                "Maje",
                "Makauraci",
                "Makero",
                "Mako",
                "Maraganta",
                "Marke",
                "Mkere",
                "Nanumawa",
                "Pandako",
                "Redi",
                "Sakaina",
                "Sankau",
                "Shaoa",
                "Share Gari",
                "Shatare",
                "Shinfida Fulani",
                "Tabaris",
                "Takwardawa",
                "Tama",
                "Tinmkishi",
                "Tsubut",
                "Tunas",
                "Ung. Ashe",
                "Ung. Bundau",
                "Ung. Gamyi",
                "Ung. Maji",
                "Ung. Malamai",
                "W/Fulani",
                "Wailare Bugaje",
                "Walawa",
                "Warpawa",
                "Wuddi",
                "Yan Kwalli",
                "Yanzaki",
                "Zangana",
                "Zanguna",
                "Zaumar Mahauta",
                "Zazzagawa"
            ],
            "Sule Tankarkar": [
                "Sule Tankarkar",
                "Amanga",
                "Asayaya",
                "Baldi",
                "Dadda",
                "Dangwanki",
                "Danmakama",
                "Danyardi",
                "Galadi",
                "Jeke",
                "Keke",
                "Maizuwo",
                "Matoya",
                "Togai",
                "Tsamiya",
                "Uban Dawaki",
                "Yan Damo"
            ],
            "Taura": [
                "Taura",
                "Ajura",
                "Bardo",
                "Buluranawa",
                "Buturunawa",
                "Chakwai-Kwaiwa",
                "Chukutu",
                "Gilma",
                "Gujungu",
                "Kawllam",
                "Kiri",
                "Kwajali",
                "Maje",
                "Majiya",
                "Sabon Gari",
                "Yangayami",
                "Yanyanga"
            ],
            "Yankwashi": [
                "Yankwashi",
                "Achilafia",
                "Ba Auzini",
                "Badaza",
                "Belas",
                "Daba",
                "Dan Dutse",
                "Dandi",
                "Gezoj",
                "Gwarta",
                "Kafin Chiroma",
                "Karkarna",
                "Kwarin Kalgo",
                "Rauda",
                "Ringim",
                "Tsedau",
                "Zungumba"
            ]
        }
    },
    {
        "Kaduna": {
            "Birnin Gwari": [
                "Birnin Gwari",
                "Dangaladima",
                "Danhadau",
                "Galadima",
                "Shittu",
                "Tudun Jega",
                "Bagom",
                "Goron Dutse",
                "Kagi",
                "Kwaga",
                "Mando",
                "Ung. Katuka",
                "Dogon Dawa",
                "Cikin Garin D/Dawa",
                "Dogo Dawa",
                "Funtuwan Badade",
                "Laca",
                "Ung. Danko",
                "Gayam",
                "Bugai",
                "Dagara",
                "Fari",
                "Kaguru",
                "Kamfanin Doko",
                "Layin Maigwari",
                "Muya",
                "Rumanan Hause",
                "Kakangi",
                "Gauji",
                "Ishiwai",
                "Kanoma",
                "Kisaya",
                "Kubau",
                "Kurgi",
                "Ukinkina",
                "Kazage",
                "Gelobai",
                "Gwanda",
                "Ingade",
                "Takama",
                "Unguwar Dankande",
                "Kungi",
                "Dawakin Bassa",
                "Imagu",
                "Kuki",
                "Loko",
                "Nasarawa",
                "Unguwar Baduku",
                "Unguwar Madaki",
                "Kutemeshi",
                "Kanawa",
                "Kwashi",
                "Raku",
                "Unguwar Chindo",
                "Unguwar Gajere",
                "Kuyello",
                "Dunya",
                "Kwadaga",
                "Kwasa-kwasa",
                "Old Kuyello",
                "Shado",
                "Yankan Dutse",
                "Maganda",
                "Dodo",
                "Old Birnin Gwari",
                "Randagi",
                "Ijinga",
                "Karauchi",
                "Kimbi",
                "Kunun Gayya",
                "Shirya",
                "Ukuga",
                "Saulawa",
                "Jan Birni",
                "Sofa",
                "Unguwar Nacibi",
                "Tabanni",
                "Dokan Ruwa",
                "Kamfanin Mamman",
                "Kwala-kwangi",
                "Layin Lassan",
                "Yarwa"
            ],
            "Chikun": [
                "Chikun",
                "Bagado",
                "Doga-Maijama",
                "Gayan",
                "Kakau",
                "Kashebo",
                "Kotarma",
                "Mafoina",
                "Matari Kujama",
                "Mai Jama'A",
                "Narayi",
                "Rido",
                "Sabon-Tasha",
                "Sabon-Yelwa",
                "Tsaunin Kura",
                "Unguwar Sunday",
                "Gwagwada",
                "Buruku",
                "Gadani",
                "Kasaya",
                "Katarma",
                "Kugo",
                "Kunai",
                "Kuriga",
                "Nassarawa"
            ],
            "Giwa": [
                "Fatika",
                "Danhauya",
                "Gadagau",
                "Galadimawa",
                "Idasu",
                "Iyatawa",
                "Kadage",
                "Karau Karau",
                "Kaya",
                "Kidandan",
                "Kundu",
                "Murai",
                "Rafin Yashi",
                "Ruku",
                "Wazata",
                "Yakawada",
                "Giwa/Shika",
                "Danmahawayi",
                "Diyo",
                "Gangara",
                "Giwa Sabuwa",
                "Guga",
                "Kakangi",
                "Kuringa",
                "Madara",
                "Maje",
                "Makwaye",
                "Mujedawa",
                "Panhauya",
                "Shika",
                "Tsibiri",
                "Yalwa"
            ],
            "Igabi": [
                "Igabi",
                "Amaza",
                "Audi",
                "Bargu",
                "Dunki",
                "Dusten Mai",
                "Eadan Gayon",
                "Faro Kwai",
                "Garda",
                "Gehehu",
                "Kerawa",
                "Mangi",
                "Pumbi Ditse",
                "Turunku",
                "Yalwa",
                "Zangon Aya",
                "Riga-Chikun",
                "Bikaratu",
                "Birnin Yero",
                "Gadan-Gayan",
                "Girku",
                "Gwaraji",
                "Jaji",
                "Kabam",
                "Kabubuwa",
                "Kangimi",
                "Kashirmi",
                "Kurmin Kaduna",
                "Kwarau",
                "Labara",
                "Morarraban Jos",
                "Nagwari",
                "Panshanu",
                "Rigachikun",
                "Rihogi",
                "Rikota",
                "Rubu",
                "Rigasa",
                "Afaka",
                "Birain-Daji",
                "Harawa",
                "Ifire",
                "Kudandan",
                "Kwate",
                "Mashjigwari",
                "Riyawa",
                "Sabon-T Wada",
                "Tami",
                "Wasana"
            ],
            "Ikara": [
                "Auchan",
                "Chara",
                "Dan-Lawal",
                "Furana",
                "Ikara",
                "Janfalan",
                "Jibis",
                "Kankanki",
                "Kurmin Jau",
                "Kurmin Kogi",
                "Kwari",
                "Makurdi",
                "Malilanchi",
                "Pala",
                "Saulawa",
                "Saya-Saya",
                "Paki",
                "Allab-Gaba",
                "Baulawa",
                "Buchan",
                "Bunji",
                "Kakau",
                "Kuya",
                "Rinji",
                "Romi",
                "Vauran",
                "Yalwa Deji",
                "Yauran"
            ],
            "Jaba": [
                "Ankung",
                "Duyyah",
                "Fai",
                "Sambam",
                "Kwoi",
                "Bitaro",
                "Dura",
                "Kyan",
                "Sabchem",
                "Sabzuro",
                "Nok/New Nok",
                "Chori",
                "Daddu",
                "Sabon Gari",
                "U.Galadima"
            ],
            "Jema'a": [
                "Amere",
                "Garti",
                "Garti Station",
                "Ung. Fulani",
                "Ung. Jaba",
                "Anguwar Fari",
                "Alkali",
                "Dakaci",
                "Jeh",
                "Shok I",
                "Small London",
                "Ubandoma",
                "Ungwa Fari",
                "Ungwa Pakachi",
                "Bakin Kogi",
                "Baraki",
                "Doka",
                "Garwa",
                "Gongola",
                "Kyau",
                "Nbiatut",
                "Tasha",
                "Tum",
                "Ungwa Pah",
                "Yanga",
                "Bedde",
                "Azar",
                "Gatai",
                "Hagbon",
                "Injebi",
                "Mabin",
                "Ngaada",
                "Ramindop",
                "Urkura",
                "Dangoma",
                "Bornanken",
                "Fulani",
                "Kafiya",
                "Kaso",
                "Koccel",
                "Nadyry",
                "S.Gari Wunti",
                "Sallabe",
                "Wunti",
                "Gidan Waya",
                "Antang",
                "Baiya",
                "Dogon Filin",
                "Hayi Gada",
                "Kiban",
                "Nisama",
                "Pasa Kwari",
                "Tafan Gidan",
                "Ung. Mada Nisamo",
                "Ung. Nungu",
                "Godogodo",
                "Idu Ungwan Anjo",
                "Akwa",
                "Kibam",
                "Kampa",
                "Gada Biyu",
                "Ninte Madaki",
                "Ninte Sarki",
                "Ninte Andaha",
                "Fari Hawa Sarki",
                "Farin Hawa Somi",
                "Godo-Godo",
                "Golkofa",
                "Manteh",
                "Zankan-Nindem I",
                "Zankan-Nindem II",
                "Nindem kogo",
                "Tudun Wada",
                "Arusuwa",
                "Anguwan Makera",
                "Anguwan Faa",
                "Jagindi",
                "Bakut",
                "Banaje",
                "Dalle",
                "Jagindi Tasha",
                "Lariyo",
                "Marmarare",
                "Marwa",
                "Pah",
                "Ung. Kagoma",
                "Araga",
                "Dangwa",
                "Dogon Awo",
                "Fafinta",
                "Janda",
                "Kogum Dutse",
                "Kogum Gindin Dutse",
                "Kogum Tasha",
                "Koho",
                "Kpgi",
                "Tsakiya",
                "Madaki",
                "Mile one",
                "Pah Kogum",
                "Rafin Dadi",
                "Ug. Patake",
                "Ung. Magaji",
                "Ung. Mangoro",
                "Ung. Ninzam Tasha",
                "Ung. Ninzam Kogum",
                "Jibin",
                "Katak Nien",
                "Katak Nzu'u",
                "Maigida",
                "Nzu'u",
                "Takai",
                "Ungwa Masara (Katak Atyap)",
                "Ungwa Musa Kognet",
                "Kagoma/Asso",
                "Alfana Daji",
                "Alfana Kagoma",
                "Alfana Kaje",
                "Balciyam",
                "Fadan Kagoma 'A'",
                "Fadan Kagoma 'B'",
                "Fadan Kagoma 'C'",
                "Fadan Kagoma 'D'",
                "Gado 'A'",
                "Hausa",
                "Ibo",
                "Iggah",
                "Jibrin 'A' & 'B'",
                "Ngakyozi",
                "Nhesu",
                "Toro",
                "Ung. Kwasau",
                "Kara",
                "Dundu",
                "Faugala",
                "Gombe",
                "Gyosagon",
                "Kpeme",
                "Talani",
                "Kpadam",
                "Fa-nock",
                "Gabi",
                "Ghauta",
                "Gigira",
                "Kanok",
                "Kayaya",
                "Kitti",
                "Kularaba",
                "Manyii",
                "Audi",
                "Aduwan 1-5",
                "Galadima",
                "Katak Mamang",
                "Ma'adam",
                "Musa Aluwong",
                "Quarters",
                "Railway Station &",
                "Tanko",
                "Ungwa Maigizoh",
                "Ungwa Waziri",
                "Sonje",
                "Alkali Goska",
                "Ambam",
                "Ambere North",
                "Farin Dadi",
                "Galadima Goska",
                "Goska",
                "Tudun Wada I",
                "Ung. Motty Amban",
                "Ung. Samuda Ambam",
                "Wada II",
                "Takau",
                "Baita",
                "Kuka",
                "Maji",
                "Takau Bunian",
                "Takau Kali (Takau Gida)",
                "Takau Takai",
                "Ungwa Rago",
                "Ungwa Shemang",
                "Yanshyi",
                "Unguwar Baki",
                "Baduku",
                "Jeh II",
                "Jumrau",
                "Majidadi",
                "Nko",
                "Sabo Gari",
                "Sarki Pada",
                "Station",
                "Station Baki",
                "Ung. Rana",
                "Unguwar Baye",
                "Unguwar G.S.S.",
                "Unguwar Madaki",
                "Zikpak",
                "Bayan Loco",
                "Habu",
                "Markus",
                "Ugwa Awodi",
                "Zahwuo",
                "Zikpak Fada",
                "Atuku",
                "Lassang",
                "Tantsock",
                "Tufin Tsock",
                "Kumpamp",
                "Manyi Kupi",
                "Tuku Gada",
                "Baidi",
                "Sakiyo",
                "Utsak",
                "Tafan Gida",
                "Manyi Gyara"
            ],
            "Kachia": [
                "Ankwa",
                "Ankwa Kudu",
                "Gora",
                "Maid Iddo",
                "Parci",
                "Awon",
                "Akwana",
                "Akwando",
                "Anturu",
                "Bishini A&B",
                "Ariko",
                "Badoko",
                "Daddu",
                "Ingili",
                "K/Iya",
                "Kateri",
                "Kurutu",
                "Doka",
                "Akilibu",
                "Anfu",
                "Rigana",
                "Adage",
                "Jodu",
                "Sakwai",
                "Kurmin Mazuga",
                "Dabarga",
                "Gumel",
                "Kurmin Baba",
                "Mafoa Fadia",
                "Sabon Sarki",
                "Cyani",
                "Gidan Mana",
                "Gidan Tagwai",
                "Jaban Kogo",
                "Kurin Musa",
                "Kwaturu"
            ],
            "Kagarko": [
                "Akote",
                "Kasangwai",
                "Kurmin Kira",
                "Pa Baki",
                "Chakwama",
                "Chama",
                "Kpechi",
                "Tunga",
                "Dogon Kurmin",
                "Kasabere",
                "Kusam",
                "Iddah",
                "Gami",
                "Mape",
                "Tafa Gari",
                "Janjala",
                "Gidan Makeri",
                "Ido",
                "Kohuto",
                "Kuku",
                "Taka Lafiya",
                "Jere",
                "Bakuchi",
                "Chinka",
                "Dlmale",
                "G/Jibo",
                "Gujeni",
                "Kpakulu",
                "Kwasare",
                "Pmana",
                "Dogon Daji",
                "Kadanyu",
                "Kudiri",
                "Kaguni",
                "Kuba",
                "Kuse",
                "Sabon Iche",
                "Katuga",
                "Aribi",
                "Cikin Gari Katugal",
                "Gora 'B'",
                "Kurmin Jibrin",
                "Kushanfa",
                "Sabon Gai Katugal",
                "Kenyi",
                "Kadah",
                "Kahir",
                "Kukyer",
                "Kuratam",
                "Kutaho",
                "Kubacha",
                "Bakin Kasuwa Kubacha",
                "Icce",
                "Kabara",
                "Kuakui",
                "Kurmin Dangana",
                "Dogo Daji",
                "Kasaru",
                "Ruzai",
                "Kushe",
                "Koyi",
                "Kuchi",
                "Kushe Makaranta",
                "Shadalafya",
                "Kampani",
                "Nkojo",
                "Shadalafiya"
            ],
            "Kajuru": [
                "Kajuru",
                "Gefe",
                "Kajuru Town",
                "Kallah",
                "Kasuwan Magani",
                "Kutara",
                "Libere",
                "Rimau",
                "Kufana",
                "Afago",
                "Iburu",
                "Idon",
                "Iri",
                "Makyali",
                "Maro",
                "Rafin-Kunu",
                "Unguwan Gamo"
            ],
            "Kaduna North": [
                "Badarawa",
                "Dadi Riba",
                "Hayin Banki",
                "Kabala",
                "Kawo",
                "Maiburiji",
                "Sardauna",
                "Shaba",
                "Unguwan Dosa",
                "Unguwar Rimi",
                "Unguwar Sarki",
                "Unguwar Shanu",
                "Unguwar Kanawa"
            ],
            "Kaduna South": [
                "Badiko",
                "Barnawa",
                "Kakuri Gwari",
                "Kakuri Hausa",
                "Makera",
                "Sabon Gari North",
                "Sabon Gari South",
                "Television",
                "Tudun Nupawa",
                "Tudun Wada North",
                "Tudun Wada South",
                "Tudun Wada West",
                "Unguwan Sanusi"
            ],
            "Kauru": [
                "Biniki",
                "Apio Kura",
                "Azente",
                "Mayigbunk",
                "Me-Bonet",
                "Tinat Akut",
                "Tsok-Waney",
                "Bondong",
                "Akuku",
                "Chanshia",
                "Chikka",
                "Me-Boye",
                "Me-Bung",
                "Me-Kpakpang",
                "Me-Kura",
                "Me-Sankwai",
                "Tsok Adam",
                "Tsoknbwanu",
                "Tyekum",
                "Fada",
                "Agafuwat",
                "Kadau",
                "Koduak",
                "Oagun Tsuod",
                "Oegbarak",
                "Tuyit",
                "Ung. Rimi",
                "Zankan",
                "Fada Ciki Gari",
                "Fada Dutse",
                "Khikarak",
                "Ung. Katungi",
                "Utak Ua'o",
                "Uz Ua'o",
                "Fadan Attakar",
                "Anturung",
                "Tachira",
                "Fadan Takad",
                "Katsak",
                "Sakinye",
                "Tajak",
                "Garaji",
                "Ung. Ashim",
                "Utak Kamunan",
                "Uza Kajung",
                "Zumuruk",
                "Gizagwai",
                "Aze-Nok",
                "Me-Kukat",
                "Me-Nkah",
                "Tsok-Amin",
                "Kadarko",
                "Agaya",
                "Manyi",
                "Makebum",
                "Kangurung",
                "Makan Uzah",
                "Manyi Dibab",
                "Tukum",
                "Utwan",
                "Uzah Akpi",
                "Zafan",
                "Kajimm",
                "Abuwat",
                "Atuka Randiyam",
                "Aze-Ahui",
                "Bungen",
                "Kajim",
                "Mahuta",
                "Me-Sanet",
                "Rafin Sanyi",
                "Randiyam",
                "Kara",
                "Chan-Tsuwan",
                "Fabuwang",
                "Gasansa",
                "Kaura",
                "Konkwot",
                "Ma-Gattah",
                "Kpak",
                "Anyah",
                "Kpen",
                "Makera",
                "Safiyo",
                "Sakong",
                "Turap",
                "Ung. Hausawa",
                "Kukum Daji",
                "Kafi Tahuwop",
                "Lawkok",
                "Tirim",
                "Tswokwai",
                "Zakwa",
                "Kukum Gida",
                "Aduan",
                "Kankasa",
                "Kpiruk",
                "Kukum Dutse",
                "Manyii Kukum",
                "Malagum (Zali)",
                "Abum",
                "Kasaru",
                "Katanga",
                "Madamai",
                "Manta Takum",
                "Tsayeb",
                "Tswokawai",
                "Tum",
                "Ung. Mission",
                "Uzah Atsuan",
                "Zali",
                "Zangang",
                "Manchok",
                "Akwa-wak",
                "Atak-Tsok",
                "Me-Akut",
                "Me-Ashin",
                "Me-Kajit",
                "Me-Mallam",
                "Me-Nache",
                "Me-yara",
                "Sabon-Gari",
                "Matuak",
                "Chori Marwa",
                "Hayin Gora",
                "Matuak Giwa",
                "Matuk Rimi",
                "Mayi Chanchiyo",
                "Sakan",
                "Mifi",
                "Tafan",
                "Agban Tafan",
                "Kukum Tafan",
                "Ligaba",
                "Manji Kanjung",
                "Mile One",
                "Misisi",
                "Pasakori",
                "Sabon Gari",
                "Tafan Gidan Way",
                "Ung. Ali",
                "Ung. Kaje",
                "Tsonjei",
                "Agban Mararaba",
                "Dan",
                "Gban Gida",
                "Sabon Gari Tsonjei",
                "Kaladi",
                "Kwarga",
                "Ma-gbag",
                "Me-Mang",
                "Tsok-Gurfu",
                "Chawai",
                "Baduran",
                "Daduru",
                "Damakasuwa",
                "Fadan Chawai",
                "Kamuru",
                "Kidundun",
                "Kiffin",
                "Kizakoro",
                "Mai Zanko",
                "Pari",
                "Riban",
                "Zanbina",
                "Geshere",
                "Apapa",
                "Binawa",
                "Bital",
                "Fadan Ilaibi",
                "Fandan Kono",
                "Gasa",
                "Gwandara",
                "Kankawar",
                "Kihogo",
                "Kinono",
                "Kudaru",
                "Kushafa",
                "Kusheka",
                "Kushori",
                "Madauchi",
                "Madauci-Kitimi",
                "Pikal",
                "Rishiwa",
                "Dawaki",
                "Galadimawa",
                "Kauru",
                "Kware",
                "Kwassam",
                "Magajin-Gari",
                "Majidadi",
                "Makami",
                "Wutana"
            ],
            "Kubau": [
                "Anchau",
                "Damau",
                "Dugau",
                "Gadas",
                "Haskiya",
                "Kargi",
                "Kuzuntu",
                "Leren Dutse",
                "Mah",
                "Mkoci",
                "Talata",
                "Dabo",
                "Dalman",
                "Dandande",
                "Danmaliki",
                "Dutse Wai",
                "Galadima",
                "Kera",
                "Kubau",
                "Mutangi",
                "Pambeguwa",
                "Tafiyau",
                "Zuntu"
            ],
            "Kudan": [
                "Doka",
                "Ang. Galadima",
                "Ang. Kanawa",
                "Ang. M. Musa",
                "Bakin Sudu",
                "Barde",
                "Daudu",
                "Guibi",
                "Kyanso",
                "Mahuta",
                "Makoyi",
                "Mazara",
                "Musawa",
                "Tanda",
                "Tashar Dan Kano",
                "Hunkuyi",
                "Ang. Dandubo",
                "Ang. Makada",
                "Ang. Malamai",
                "Ang. Tijjani",
                "Ang. Jarmai",
                "Arewaci",
                "Dafa-Dufa",
                "Dan Tsoho",
                "Danbami",
                "Dumuga",
                "Garu",
                "Jaja Babba",
                "Jaji",
                "Kyadai Ango",
                "Kyaudai",
                "Sabon layi",
                "Sarama",
                "Shekarau",
                "T/ Icce",
                "T/Matasa",
                "Kauran Waki",
                "Ang. Bakoshi",
                "Ang. Garba",
                "Ang. M. Alasan",
                "Ang. Maiyamu",
                "Ang. Makera",
                "Ang. Musa",
                "Ang. Tata",
                "Bankangwa",
                "Baya Fulani",
                "Dan Daso",
                "Dangashi",
                "Dankala",
                "Dantaro",
                "Sabon Gari",
                "Sanda",
                "Tashan Sani",
                "Tauran Wali",
                "Yalwa",
                "Ang Duste",
                "Ang. Labalo",
                "Ang. Ma aji",
                "Damaski",
                "Kadama",
                "Marku",
                "Matarawa",
                "Nasarawan kudan",
                "Randa",
                "Rimin Biso",
                "Sabon Lemu",
                "Tashan Kade",
                "Zabi",
                "L. Ikoro",
                "Bagaddi",
                "Dangayya",
                "Dokah",
                "G/Kudi",
                "G/Mai Gari",
                "Gidan D/Birni",
                "Gwandawa",
                "Hawan Mai Mashi",
                "Kadad Kada",
                "Katsinawa",
                "Kushigi",
                "Lafiyi",
                "Likoro",
                "Rafin Kira",
                "S/gari Likoro",
                "S/Gida",
                "T/Daudu",
                "T/wada",
                "Tashan Jirgi",
                "Tsauni",
                "Tsinka"
            ],
            "Lere": [
                "Garu",
                "Amon Danboyi",
                "Dabban Fadama",
                "Garu Kurama",
                "Gure",
                "Gurza",
                "Jama s Iya",
                "Janji",
                "Kahugu",
                "Karanbana",
                "Kargi",
                "Kurmin Dodo",
                "Lawuna",
                "Mariri",
                "Piti Warsa",
                "Ragwa",
                "Unguwar PA",
                "Kadaru",
                "Bisallah-Hausa",
                "Bita Rana",
                "Disallah",
                "Goron Dutse",
                "Kaku",
                "Kudaru-Kurama",
                "Kudaru-Tasha",
                "Maigamo",
                "Rumaiya",
                "Ukissa",
                "Weire",
                "Wuroko",
                "Yarkasuwa",
                "Abadawa",
                "Dan Alhaji",
                "Dan Alhaji II",
                "Juran Karama",
                "Juran Kari",
                "Kayarda",
                "Kayor",
                "Lazuru",
                "Maresu",
                "Ramin-Kura",
                "Sabon Birni",
                "Saminaka",
                "Sugau",
                "Tuddai",
                "Woba"
            ],
            "Makarfi": [
                "Makarfi",
                "Dan Auamaka",
                "Dandamisa",
                "Danguzuri",
                "Dorayi",
                "Durun",
                "Gangara",
                "Gazara",
                "Gimi",
                "Gubuchi",
                "Gwanki",
                "Kwatakware",
                "Marke",
                "Mayere",
                "Nassarawa",
                "Rahama",
                "Ruma",
                "Sabon Garin Daji"
            ],
            "Sabon Gari": [
                "Basawa",
                "Barashi",
                "Basawa Tsakiya",
                "Bauda",
                "Biso",
                "Dan-Makwarwa",
                "Galadima",
                "Gwanda Tsakiya",
                "Kwari",
                "Layin Zomo Tsakiya",
                "Madaki",
                "Malam Sale",
                "Palladan Tsakiya",
                "Rimin Tsiwa",
                "Sakadadi Tsakiya",
                "Sarkin Fulani",
                "Ung. Amfani",
                "Ung. Barau",
                "Ung. Makera",
                "Ung. Na'inna",
                "Ung. Rimi Village",
                "Ung. Yaro",
                "Ung. Turaki",
                "Ung. Dan-Gaiya",
                "Ung. Fulani",
                "Ung. Hayin-Liman",
                "Ung. Sabon-Layi",
                "Ung. Malam Halilu",
                "Zangon Dan-Baro",
                "Ang-Gabas",
                "Babban Titi",
                "Bassawa",
                "Bomo",
                "Cediyar Bawa",
                "Chikaji",
                "Daurawa Tsakiya",
                "Dogarawa",
                "Dogon Bauchi",
                "Dorawar Malami",
                "Durumin Sabbi",
                "Gwanda",
                "Hanwa",
                "Hayin Ojo",
                "Jama'a",
                "Jushin Waje",
                "Machiya",
                "Mangwarori",
                "Palladan",
                "Sabon Gari",
                "Sakadadi",
                "Shika Dam",
                "Tsugugi",
                "Ung Yamma",
                "Unguwar Kasuwa",
                "Unguwar Tabacco",
                "Yan-Awaki",
                "Zabi",
                "Samaru",
                "Bomo Tsakiya",
                "Bomo Village",
                "Gwada Tsakiya",
                "Jama'a Tsakiya",
                "Kallon-Kura Tsakiya",
                "Mil-goma Tsakiya",
                "Samaru Tsakiya",
                "Samaru Village",
                "Ung. Arewaci",
                "Ung. Bamunna",
                "Ung. Dan-lami",
                "Ung. Dan'ayu",
                "Ung. Dansa'a",
                "Ung. Hayin Danyaro",
                "Ung. Hayin Liman",
                "Ung. Hayin Malam Tsoho",
                "Ung. Hayin Sambo",
                "Ung. Iya",
                "Ung. Kaya",
                "Ung. Koraye",
                "Ung. Kurani",
                "Ung. Kwakwaren Manu",
                "Ung. Kwanin Kubanni",
                "Ung. Kwari",
                "Ung. Liman",
                "Ung. Madaki",
                "Ung. Maiwada",
                "Ung. Makaranta",
                "Ung. Nasarawa",
                "Ung. Rinji",
                "Ung. Samanja",
                "Ung. Sarki",
                "Ung. Sojoji",
                "Ung. Tsauni",
                "Ung. Yalwa Tsakiya",
                "Ung. Yaranda",
                "Ung. Yardorawa Tsakiya",
                "Ung. Zangon Shanu",
                "Ung. Tsamiya"
            ],
            "Sanga": [
                "Aboro",
                "Abu",
                "Ambi Oga",
                "Ayuba",
                "Baka",
                "Dakachi",
                "Dakaci Antor",
                "Dauda",
                "Dauda Kudu",
                "Fasu",
                "Gabas",
                "Halidu",
                "Hausawa",
                "Ibo",
                "Jarawa",
                "Jingina",
                "Joko One",
                "Joko Two",
                "Karfan",
                "Kogun",
                "Kubal",
                "Kulere",
                "Kwanta",
                "Liman",
                "Mada",
                "Mada II",
                "Madaki",
                "Mai Kmbu",
                "Makera",
                "Mallam Musa",
                "Mallam Nuhu",
                "Mangu",
                "Manzi",
                "Maroa",
                "Mato",
                "Ninzo",
                "Ninzo Mada",
                "Nunku",
                "Oara",
                "Rumbu",
                "Sakiya",
                "Sarki",
                "Sarki Aboro",
                "Sarki Cheche",
                "Sarki Gargajiya",
                "Sarki Hausawa",
                "Sarki Kwal",
                "Sarki Mada",
                "Sarki Nami",
                "Sarki Numer 6",
                "Sarki Sabonlayi",
                "Sarki Yamman",
                "Sarki Zangin",
                "Selenan",
                "Tukura",
                "Waziri",
                "Yamma",
                "Zalidu",
                "Aboro Dakaci",
                "Aboro Gida",
                "Ardo Fulani Aboro",
                "Ardo Fulani Ajagwai",
                "D/Kutal",
                "Dakachi Fulani",
                "Dakachi Gongoro",
                "Dakaci Jangwai",
                "Dakaci Kubal",
                "Forom",
                "Gidan Mai",
                "Gidan Mai Arewa",
                "Gidan Mai Kudu",
                "Gyere",
                "Hayen Dem",
                "Kubal Sakiya",
                "Lani Shanu",
                "Marwa",
                "Pole Waya",
                "Sabon Layi",
                "Takar",
                "Tudun Wada",
                "Ung. Dakaci",
                "Ung. Gongoro Gida",
                "Ung. Jarawa",
                "Ung. Kwara",
                "Ung. Kwassu",
                "Ung. Mada",
                "Ung. Saidu",
                "Ung. Sarki Gwasan",
                "Ung. Sarki Jangwai",
                "Ung. Sarki Kudu",
                "Ung. Sarki Kutal",
                "Wakili Fulani Aboro",
                "Wakili Fulani Antor",
                "Amar",
                "Bawa Ambi",
                "Dakaci Akonkrin",
                "Dakaci Amar Tita",
                "Dakaci Bako",
                "Dakaci Landa",
                "Dakaci Makeri Landa",
                "Dakaci Telekpo",
                "Ibrahim",
                "Monday Waziri",
                "Primary Amar",
                "Sarki Landa Gbasar",
                "Sarki Amar Kontogora",
                "Sunday Compani Kontogora",
                "Amar Angwa Ahmadu Ngbo",
                "Amar Jatau",
                "Amar Sarki Musa",
                "Kontogora",
                "Ung. Danladi Tufa",
                "Ungwa Dakaci Amar Ingba",
                "Ungwa Dakaci Ambo Amar Lada",
                "Ungwa Maikwara",
                "Ambel",
                "Boyi",
                "Dakaci Anka",
                "Dakaci Gipa",
                "Madaki Anka",
                "Madaki Ghonbur",
                "Sarki Kadan Ahmadu",
                "Sarki Nigbu",
                "Sarki Yamma",
                "Sule Aboro",
                "Tela Chessu",
                "Timis",
                "Anbel 'A'",
                "Anbel 'B'",
                "Ang. Waziri 'A'",
                "Angwai 'A'",
                "Angwai 'B'",
                "Babur Dakaci",
                "Fatu",
                "Ishen Gba",
                "Sabo Sanglo",
                "Ung. Adamu Makama",
                "Ung. Atili 'B' Sarki Baba Salihu",
                "Ung. Atili Sarki Abbas",
                "Ung. Bako",
                "Ung. Habu Yakubu",
                "Ung. Iliya Dugba",
                "Ung. Markus Injih",
                "Ung. Yakubu Adamu",
                "Ung. Yusuf Anof",
                "Ungw Sarki Bure",
                "Ungwa Bala Mai Lambu",
                "Ungwa Sule Aboro",
                "Ancha",
                "Malla Mamman",
                "Ache Anigbulu",
                "Ajiya",
                "Amwue Idzi",
                "Ayuba Anikyu",
                "Bagaji",
                "Dakachi Dodo",
                "Dakachi Tataura",
                "Fulani Bahago",
                "Fulani Ruwah",
                "Galadima",
                "Godo Tudu",
                "Isah Fulani",
                "Kadarko Fulani",
                "Kogi",
                "Madaki Godo",
                "Madaki Idzi",
                "Mahammadu",
                "Maikudi Bature (Amangbo) 1",
                "Sabo Amueh",
                "Sarki Akawu (Ancha Gida)",
                "Sarki Ambi",
                "Sarki Aninkla",
                "Sarki Noma",
                "Sarkin Fada (Adamu Yabo)",
                "Shamaki",
                "Thoma Amos Tudu Wada",
                "Wakili",
                "Yakubu Anikri",
                "Dakachi Ahmadu",
                "Ung. Akochun",
                "Ung. Gimba",
                "Ung. Makama",
                "Ung. Ogha",
                "Ung. Samuel Ungbo Amunikri",
                "Ung. Sarki Zambur",
                "Ungwa Ayawa Sidi",
                "Ungwa Madaki (Amangbo II)",
                "Ayu",
                "Makaranta",
                "Abu Kampani",
                "Abu Makaranta",
                "Alan",
                "Ayu Gari",
                "Chambwa",
                "Gari",
                "Gbaku",
                "Gbun Tashi",
                "Gbuzhi",
                "Gogo",
                "Jege",
                "Kanjan",
                "Kimba",
                "Koshu",
                "Kpaji",
                "Kpoto",
                "Marinjo",
                "Ninyu",
                "Ragga Ung. Dakachi",
                "Regga Makaranta",
                "SMBE Gari Ung. Dakachi",
                "Takpe",
                "Ung. Abeku",
                "Ung. Gbantar",
                "Ung. Kuza",
                "Ung. Maichibi",
                "Ung. Mangoro",
                "Ung. Sarkin Hausawa",
                "Ung. Yakubu",
                "Unzahu",
                "Unzhakpaji",
                "Bokana",
                "Ado Naira",
                "Amantur",
                "Audu Galadima",
                "Ayaba",
                "Bahago",
                "Bala Sansani",
                "Challa",
                "Dakaci Fadan Ayu",
                "Dakaci Fulani",
                "Dakaci Hausawa",
                "Dakaci Nungu",
                "Dakacin Gashinbaki",
                "Dariya",
                "Haruna Adamu",
                "Idi Lawal",
                "Iliya",
                "Jibirin",
                "Joseph",
                "Mada 'A'",
                "Mada 'B'",
                "Mada Eggon",
                "Mallam Tanimu",
                "Nandu",
                "Nungu Bokana",
                "Salihu",
                "Salihu Kurma",
                "Salihu Musa",
                "Sansani",
                "Sarki Fadan Ayu",
                "Sarki Ibo",
                "Sarki Ibus",
                "Sarki Kwagiri",
                "Sarki Ninzo",
                "Sarki Yoruba",
                "Shehu",
                "Yakubu",
                "Yakubu Habu",
                "Mantur",
                "Pole Waya Boana",
                "Ung. Maisamari",
                "Ungwa Adu Duwaru",
                "Ungwa Dakaci Gwade",
                "Ungwa Sarki Kongo",
                "Ungwa Theological Seminary Ayu",
                "Fadan Karshi",
                "Andakure",
                "Ankirin",
                "Bom B.",
                "C & D",
                "Dogon Daji",
                "Doromiya",
                "Gimi Dogora",
                "Janagwa",
                "Kabau",
                "Kan Kurmi",
                "Karshi",
                "Karshin Daji",
                "Kawo",
                "Kayarda",
                "Kurmi Gero Sarki",
                "Kwagibi",
                "Mahanga",
                "Mile One",
                "Mom C.",
                "Nasarawa",
                "Sabon Gida",
                "Sabon Gida Gabas",
                "Sabon Zawan",
                "Sabongari",
                "Tsoho Gari",
                "Tsohon Gri",
                "Ung. Abamu",
                "Ung. Amutu",
                "Ung. Ardo Fulani",
                "Ung. Ardo Fulani Karshi",
                "Ung. Bauchi",
                "Ung. Bawa",
                "Ung. Bera",
                "Ung. Dakaci F/Karsh",
                "Ung. Dakaci Fulani",
                "Ung. Dakaci Gimi",
                "Ung. Donka",
                "Ung. Fada",
                "Ung. Fulani",
                "Ung. Gambo",
                "Ung. Ganye 'A'",
                "Ung. Gayen 'B'",
                "Ung. Gindiri",
                "Ung. Goma",
                "Ung. Gwandara",
                "Ung. Hausawa",
                "Ung. Hausawa K/Goro",
                "Ung. Ibrahim",
                "Ung. Jere",
                "Ung. Kampani",
                "Ung. Kurmi Goro Titi",
                "Ung. Kyayang",
                "Ung. Maigoro",
                "Ung. Mande",
                "Ung. Nandu",
                "Ung. Numana",
                "Ung. Pah Amale",
                "Ung. Para",
                "Ung. Rindiri",
                "Ung. Sale",
                "Ung. Tanko",
                "Ung. Tella",
                "Vom",
                "Yakwet",
                "Zagzawan",
                "Fadan Ninzo",
                "Galadima Amugbonche",
                "Iya Umugbonche",
                "Makaranta Mission Maitozo",
                "Alhaji Ruwa",
                "Amutongbo",
                "Fulani",
                "Makaho",
                "Makama",
                "Makama Dorawa",
                "Pakachi",
                "Sarki Amugboche",
                "Tukura Pakachi",
                "Ubandoma",
                "Wambai",
                "Waziri Pakachi",
                "Dakachi Sambe",
                "Joga",
                "Madaki Fulani",
                "Sarki Amubi",
                "Sarki Yaki - Maitozo",
                "Iyah Gbara",
                "Musa Anto",
                "Musha Anche",
                "Pakachi Hallo",
                "Sarki Maigoro",
                "Wakili Irimiya Gabata",
                "Atungbe Gya Gbara",
                "Dakachi - Amubimaji",
                "Jarami",
                "Ung. Dagachi",
                "Gunkok",
                "Andun",
                "Angwak",
                "Ankolo",
                "Awali",
                "Forest Arak",
                "Gada Biyu",
                "Gbunkok",
                "Isan",
                "Jenda Sarki",
                "Karkashi",
                "Labari",
                "Langa",
                "Rugan Ardo",
                "Rugan Madaki",
                "Sabon Gari",
                "Tsauni Kulere",
                "Tsauni Majindadi",
                "Tudun Wada Arak",
                "Ung. Saiau",
                "Ung. Adamu",
                "Ung. Duhu",
                "Ung. Durumi",
                "Ung. Ingila",
                "Ung. Magaji",
                "Ung. Maikyau",
                "Ung. Tudu",
                "Ung. Wakili Isan",
                "Ung. Wambai",
                "Ung. Yaro",
                "Ung. Yaute",
                "Ung. Yerima",
                "Gwantu",
                "Aban",
                "Afragbang",
                "Agom",
                "Akongk",
                "Akoshen",
                "Ambe Sarki",
                "Bashayi",
                "Dangam Aneye",
                "Dangam Aniti",
                "Gani Madaki",
                "Gbanzu",
                "Gbongang",
                "Gobir",
                "Guantu",
                "Gwantu Kurmin Dakaci",
                "Kiban",
                "Numbu Dakaci",
                "Nunbu Kono",
                "Sanga Haruna",
                "Ung. Biri",
                "Ung. Ganye",
                "Ung. Giginya",
                "Ung. Goge",
                "Ung. Idzi",
                "Ung. Ningon",
                "Ung. Maikasa",
                "Ung. Mandu",
                "Zang",
                "Hatteh",
                "Atungbo-Gya Gbatar",
                "Dakachi Amubimaji",
                "Dakachi Auganche",
                "Fulani Dorowa",
                "Jerami",
                "Lamido",
                "Madaki Amugbonche",
                "Madaki Sambe",
                "Maikafo",
                "Makaa",
                "Makama Dorowa",
                "Mukama Pakachi",
                "Sarki Amuganche",
                "Sarki Amugbonche",
                "Sarki Amukunche",
                "Sarki Ango Gbatar",
                "Sarki Sambe",
                "Sarkin Yaki Maitozo",
                "Uandoma",
                "Wakili Irimiya Gbatar",
                "Waziri Gbata",
                "Yaki",
                "Yamusa",
                "Ungwa Dakachi",
                "Ungwa Iya Umugbonche",
                "Ungwa Pakachi",
                "Kwassu",
                "Amun Cheyo",
                "Amwe",
                "Dakaci Anzere",
                "Dakaci Chugon",
                "Dakaci Gajere",
                "Dakaci Makeri",
                "Dakaci Rimi",
                "Madaki Awawa (Atu)",
                "Madaki Yakubu",
                "Makeri",
                "Mangoro (Rimi)",
                "Monday Anto",
                "Mu-Konche",
                "Sarki Anzah Agboh",
                "Sarki Anzere Gbuja",
                "Sarki Bala Akonza",
                "Sarki Chiroma",
                "Sarki Langa-Langa",
                "Sarki Ninhan",
                "Sarki Tudun Wada (Rimi)",
                "Sarki Tukura",
                "Vantar Anzere",
                "Sarki Amunikri",
                "Sarki Daniel",
                "Ung. Dangaladima Joseph",
                "Ung. Galadima Chugon",
                "Ung. Madaki Musa",
                "Ung. Sarki Amuku",
                "Ung. Sarki Soja",
                "Ung. Sarki Ichi San",
                "Ungwa Bakasi",
                "Ungwa Dakaci Kwassu",
                "Ungwa Sarki Amuneibam",
                "Mayir",
                "Agas",
                "Akumukun",
                "Alheri",
                "Ankub",
                "Arau",
                "Awgon",
                "Balawes",
                "Digel",
                "Gokwi",
                "Hayen Gada",
                "Ibag",
                "Iden",
                "Kwanan Tigen",
                "Mayir Amanchik",
                "Saken Tigon",
                "Sankwai",
                "Tayu",
                "Tigekn",
                "Ung. Dakaci Hausawa",
                "Ung. Mada Mayir",
                "Ung. Madaki Ali",
                "Ung. Sarki Adamu Yabame",
                "Ung. Sarki Hausawa Nuhyu",
                "Ung. Sarki Mallam Kasimu",
                "Ung. Sarki Ninzo",
                "Ung. Sarki Sale",
                "Ung. Sarki Tari",
                "Yabme",
                "Randa",
                "Dakaci Iron Zikina Richu",
                "Dakaci Tari Ngbo",
                "Dorowa",
                "Gwanda",
                "Sarki Idzi",
                "Sarki Maiakama",
                "Antishi",
                "Burtu",
                "Maitakama",
                "Randa Kasa",
                "Sabon Gari Randa",
                "Ung. Dakaci Ziku",
                "Ung. Mission",
                "Ungwa Hausawa Randa",
                "Ungwa Madaki Randa",
                "Ungwa Makama Karama",
                "Tari",
                "Abandi",
                "Agal",
                "Aku Mallo",
                "Alang",
                "Asibiti",
                "Audu Tari",
                "Awarmashik",
                "Badakoshi",
                "Bola",
                "Fulani Tari",
                "Gaiya",
                "Gbakip",
                "Gimba",
                "Gwamna Tari",
                "Haye Aku",
                "Haye Bala",
                "Haye Knoka",
                "Joshua",
                "Kofai",
                "Rimi",
                "Sarki Makama",
                "Sarki Matasa",
                "Sarki Nome",
                "Sule",
                "Tukurah",
                "Turaki",
                "Ubakmuich",
                "Ubarif",
                "Ubnadoma",
                "Uloh",
                "Yara",
                "Yara Tari",
                "Ung. Sarki Ahmadu Mada",
                "Ungwa Barde",
                "Ungwa Kako",
                "Ungwa Maihibi",
                "Ungwa Makaranta",
                "Ung/Sarki",
                "Madaski Ngbok",
                "Adamu",
                "Ahmadu",
                "Ardo Fulani",
                "Asibiti Ibrahim",
                "Ayuba Bashayi",
                "Bawa Magaji",
                "Danjuma",
                "Gora",
                "Joseph Audu",
                "Lawal Ankpong",
                "Madaki Ankpong",
                "Madaki Kobin",
                "Magaji Ankpong",
                "Magaji Ningeshe Kurmi",
                "Mangu Danladi",
                "Sarkin Yaki Ankara",
                "Tukura Ankara",
                "Akai",
                "Akwakwan",
                "Ankara Dogon Fili",
                "Ankara Makaranta",
                "Ankpong",
                "Dogon Fili",
                "Kaso",
                "Kobin",
                "New Karu",
                "Ngbotiti",
                "Ningeshe Dutse",
                "Ningeshe Kurmi",
                "Ningo Gari",
                "Ningo Kirya",
                "Pogari",
                "Rafin Tagwaye",
                "T/Wada 'A'",
                "T/Wada 'B'",
                "T/Wada 'C'",
                "Ung. Adamu Maikaho",
                "Ung. Manja",
                "Ung. Sarki Numa",
                "Ung. Tari",
                "Ung. Tukura",
                "Ung. Yakubu Bawa",
                "Ungbok",
                "Upo Dirri",
                "Upo Nkiri",
                "Wambe",
                "Wasa",
                "Abuja Mada",
                "Ako",
                "Ani Pantinya",
                "Anji",
                "Atau",
                "Bril Tsada",
                "Daniel",
                "Duhu",
                "Ggon",
                "Gobara",
                "Idah",
                "Ishaya",
                "Jacob",
                "Jirgi",
                "Kwakwasa",
                "Nungu",
                "Sabo",
                "Agbere",
                "Ahar Ko Fai",
                "Anzah",
                "Aworo Sarki",
                "Baki Kogi",
                "Gwaska",
                "Kofe Ahar",
                "Miski",
                "Pantiwa",
                "Rafin Soja",
                "Sarki Yeskwa",
                "Takwa",
                "Tataura Pantiya",
                "Tudu Wada",
                "Ung. Abu",
                "Ung. Akawa",
                "Ung. Amos Yakubu",
                "Ung. Anche",
                "Ung. Goho",
                "Ung. Hosea Pantiyan",
                "Ung. Ishaya Pantiya",
                "Ung. Jibrin",
                "Ung. Lamba",
                "Ung. Mudi",
                "Ung. Pah",
                "Ung. Pah 'A'",
                "Ung. Pah 'B'",
                "Ung. Tasha",
                "Ungwa Jamage",
                "Ungwa Musulmi",
                "Wuro Andaha"
            ],
            "Soba": [
                "Maigana",
                "M. Yahaya",
                "Ang. Galla",
                "Damari",
                "Fagachi",
                "Fari-Kaa",
                "Gimba",
                "Goirawa",
                "Hayin Kinkiba",
                "Kin-kiba",
                "Kuzai",
                "Kwai",
                "Ma-birni",
                "Madaba",
                "Maferawa",
                "Magada",
                "Marwa",
                "Matari",
                "Richifa",
                "Sabon Kudi",
                "Sambvirni",
                "Tamba",
                "Wanka",
                "Yakasai",
                "Yalwa mai akaranta",
                "Yelwa mai Bene",
                "Alhazawa",
                "Ang. Madaki",
                "Ang. Mall dogo",
                "Bakura",
                "Barwa",
                "Dan-Isa",
                "Dan-jaba",
                "Dan-wata",
                "Dinya",
                "Dorayi",
                "Gamagira",
                "Garun-Gwanki",
                "Gurbabiya",
                "Kaware",
                "Kuyamutsa",
                "Kwasallo",
                "Lungu",
                "Mai-0Zare",
                "Makoron-lemo",
                "Marmara",
                "Taba",
                "Taka-Lafiya",
                "Tkurwa",
                "Turawa"
            ],
            "Zangon Kataf": [
                "Abet",
                "Achin",
                "Anguwan Jatau",
                "Kumi",
                "Marabang",
                "Afana",
                "Katsit",
                "Ampaga",
                "Boto",
                "Dinarah",
                "Fadan Ikulu",
                "Lisuri Gida",
                "Lisuru Daji",
                "Sabon Kaura Fadan Ikulu",
                "Ungwan Amawa Lisuru",
                "Ungwan Fulani",
                "Ungwan Goska",
                "Ungwan Rana Lisuru",
                "Unwan Digabi",
                "Anchuna",
                "Akoka",
                "Amawa Lisuru",
                "Burgu",
                "Digabi",
                "Jirayi",
                "Kachia",
                "Makama",
                "Nauta",
                "Sani",
                "Sarki",
                "Toro Ali",
                "Toro Gida",
                "Akurjini",
                "Dankurasa",
                "Dutsen Bako",
                "Gida Ali",
                "Kwarkwano",
                "Sabon Kaura Akupal",
                "Ung. Dodo",
                "Ung. Gauta",
                "Ung. Gimba",
                "Ung. Pate",
                "Ung.Nauta",
                "Ung.Rimi (Gidol)",
                "Ung.Wakili Surubu",
                "Ung.Yawa",
                "Bafoi Gora (Kanai Bafoi)",
                "Bafoi",
                "G/Gimba",
                "G/Kalli",
                "Galadimawa",
                "Kishaura",
                "Mavong",
                "Rafin Saiwa",
                "Fadan Kaje",
                "Kazantsok",
                "Machia",
                "Rumfa",
                "Tabak",
                "Tsohon Gida",
                "Unguwa Bakan",
                "Fadiya",
                "Fadiya Bossan",
                "Fadiya Gugah",
                "Fadiya Mugu Gida",
                "Fadiya Raku Gida",
                "Fadiya Yazonom",
                "Fafom gida",
                "Gida",
                "Jei Agaguk",
                "Jei Aruwan",
                "Jei Atoche",
                "Jei Atom",
                "Jei Baje",
                "Jei Dishia",
                "Jei Gana",
                "Jei Gugah",
                "Jei Kama-Nbrang",
                "Kar (Ungwa) Rankpak",
                "Kar Abuchet",
                "Kar Abukam",
                "Kar aco",
                "Kar Afifak",
                "Kar Akau",
                "Kar Aruwan",
                "Kar Atare",
                "Kar Ayia",
                "Kar Baje",
                "Kar Bui",
                "Kar Cham",
                "Kar Dambvu",
                "Kar Doka",
                "Kar Gagk",
                "Kar Gimba",
                "Kar Gwana",
                "Kar Jatau",
                "Kar Kachat",
                "Kar Kajere",
                "Kar Kamayi-Ntun",
                "Kar Kubin",
                "Kar Kura",
                "Kar Kure",
                "Kar Kwadun",
                "Kar Kwaru",
                "Kar Kyama",
                "Kar Kyang",
                "Kar Kyuka",
                "Kar Lekwot",
                "Kar San",
                "Kar Sule",
                "Kar Suman",
                "Yaribuwan",
                "Zagom Gida",
                "Farman",
                "Gatsa",
                "Kanem",
                "Rikabom",
                "Satwang",
                "Mazaki (Gidan Zaki)",
                "Bakin Kogi (Magwafan)",
                "G/Zaki (Mazaki)",
                "Maige",
                "Saganda",
                "Gora",
                "Atabat Atanyeang",
                "B/Kogi Gora",
                "Gora Gida (Atsung Abyek)",
                "K/Gandu",
                "K/Kwara",
                "Kakwa",
                "Magankon",
                "Magankon K/Kwara",
                "Makutzalen",
                "Sabon Gari",
                "Sabon Gari Gora",
                "Sagwaza",
                "Sakwa'at",
                "T/Wada Gora",
                "Warkan",
                "Jankasa",
                "Apyinzwang",
                "Awak",
                "Jankasa (Ashong Ashyui)",
                "Kacecere",
                "Kacecere Hausawa",
                "Kangwaza",
                "Kurfi",
                "Magadankura",
                "Male",
                "Manta Aswon",
                "Manyii Aminyam",
                "Manyii Ashyui",
                "U/Gawayi",
                "Kabam",
                "Balet",
                "Boro",
                "Gidan Maga",
                "Shankyuak",
                "Tiyat",
                "Ungwn Hausawa",
                "Yal Calihu",
                "Yal Kura",
                "Yal Yaje",
                "Kamuru",
                "Antang Dutse",
                "Antang Gida",
                "Anzah Gida",
                "Anzah Sarki",
                "Bakin Lamba",
                "Fange",
                "Fansil",
                "Gapiyi",
                "Kamuru Dutse",
                "Kamuru Hausa",
                "Kamuru Ikulu",
                "Katul Anzah",
                "Ngwan Wakili Kamuru",
                "Ungwan Nache",
                "Ungwan Basheru",
                "Ungwan Gaiya",
                "Ungwan Giwa",
                "Ungwan Shehu",
                "Ungwan Zomo",
                "Kamurum",
                "Abafot",
                "Fanjim",
                "Kukan",
                "Kurdan",
                "Sakwak",
                "Ung. Ariyahwi",
                "Ung. Magaji",
                "Ung. Rana",
                "Zauru",
                "Kangun",
                "Chigyam",
                "Rinyam",
                "Sabon Kaura",
                "Yaron Fada",
                "Kibori",
                "Atakmawai",
                "Atisa",
                "K/Masara",
                "Kan Kurmi",
                "U/Maichibi",
                "Kurmin Bi",
                "Ahzahwa",
                "Akobe",
                "Akodon",
                "Atagraya",
                "Azakwat",
                "Chanya",
                "Karatuk",
                "Karibwake",
                "Karigwahan",
                "Karikahuat",
                "Karisaka",
                "Kati",
                "Kurmin - Bi",
                "Madauchi",
                "Ung. Ayo",
                "Kwakhwu",
                "Ayagbak",
                "Mamaidawa",
                "Sanzyiam",
                "Shilyam",
                "Takanai",
                "Ladduga",
                "Ungwan Nasarawa",
                "Wuro Borno",
                "Wuro Fulbe Centre",
                "Wuro Mayo",
                "Wuro Nyako",
                "Mabushi",
                "F/ Tsoho",
                "G/ Gimba",
                "G/ Kagrau",
                "K/ Dawaki",
                "Madoo",
                "Manwai",
                "Masukwai",
                "Salau",
                "Madakiya (Batadon)",
                "Atat",
                "Ayagan",
                "Bankwa",
                "Bodari",
                "Bvongkphnang",
                "Dinyiring",
                "Hurgyam",
                "Kpong",
                "Madakiya",
                "Twan",
                "Zitti",
                "Taligan (Magamiya)",
                "G/Wuka",
                "Magamia I",
                "Manyii Aghyui",
                "Chibob",
                "Kigudu",
                "Matyei",
                "Mawa",
                "Runji",
                "Sabanfan",
                "Sako",
                "U/Alagaba",
                "U/Rohogo",
                "Zarkwai",
                "Marsa",
                "Arikawan",
                "Chenchuk",
                "Kphunyai",
                "Tsoriyang",
                "Aduwan",
                "Madobiya",
                "Maniya",
                "Rebok",
                "Wadon",
                "Tudun Wada",
                "Bayan Dutse",
                "Hyurgyam",
                "Kafom Aruwan",
                "Kafom Doka",
                "Unguwan Rimi (Zantarakpat)",
                "Zakwo",
                "Unguwar Gaiya",
                "Jaba",
                "Juju",
                "Atakjei (G/Gata)",
                "Tagama",
                "Unguwar Rohogo",
                "Magwafan",
                "Zagom",
                "Chirani",
                "Fadia Aliu",
                "Rafin Juma",
                "Rumpa",
                "Ungw Jatau",
                "Ungwan Dori",
                "Ungwan Mallam",
                "Zagom Gajere",
                "Zaman Dabo",
                "Atakfang",
                "Chawai Z/Dabo",
                "Doka",
                "Sansak",
                "Z/Awon",
                "Z/Dabo",
                "Zangon Kataf",
                "Gabas",
                "Yamma",
                "Zonkwa",
                "Abaye",
                "Buzu'un",
                "ECWA",
                "Ishaya",
                "Musa",
                "Ruguni",
                "Town Hall",
                "Dauke",
                "Arikuyin",
                "Atakum",
                "Dorow one",
                "Dorowa one",
                "Duchu (Ung. Christopher)",
                "Kariburuk",
                "Kok I",
                "Kok II",
                "Kpan Kok",
                "Layin Shaba",
                "Masat",
                "Ramai",
                "Ung. Baptist",
                "Ung. Danbaki",
                "Ung. Mission",
                "Ung. Narom",
                "Ung. Rama",
                "Ung. Sanke",
                "Ung. Yabanat",
                "Zanzwan",
                "Zonkwa Central",
                "Zonzon",
                "Mabukhwu",
                "Makutsatim",
                "Mashan",
                "Mawukili",
                "Sakum",
                "U/Tabo",
                "Wawa-rafi",
                "Ziturung",
                "Abvabvon",
                "Karachiya",
                "Mago",
                "Nkuwan Yak",
                "Tinta'a",
                "Turan Kariyi",
                "Turan Kayit",
                "Kangurara",
                "Ziturung Pama",
                "Ziturung Akpang",
                "Ziturung Karyi"
            ]
        }
    },
    {
        "Kano": {
            "Ajingi": [
                "Ajingi",
                "Balare",
                "Chula",
                "Dabir-Karawa",
                "Dagaji",
                "Dundun",
                "Fagawa",
                "Fulatan",
                "Gafasa",
                "Gurduba",
                "Jiyaiya",
                "Kara Makama",
                "Kunkurawa",
                "Kwari",
                "Kyaberi",
                "Sakalawa",
                "Toranke",
                "Ungwar Bai",
                "Yanwawa",
                "Zagon Gulya"
            ],
            "Bagwai": [
                "Bagwai",
                "Alajawa",
                "Badodo",
                "Rimin Dako",
                "Daddauda",
                "Dangada",
                "Dungurawa",
                "Gadanya",
                "Gwanki",
                "Galawa",
                "Gogori",
                "Gurdo",
                "Jarimawa",
                "Joben-Yamma",
                "Kiyawa",
                "Kwajali",
                "Majingini",
                "Riminbai",
                "Romo",
                "Santar Lungu",
                "Sare-Sare",
                "Sarkin Iya",
                "Ungwan Waimma",
                "Wuro Bagga",
                "Yar Tofa"
            ],
            "Bebeji": [
                "Bebeji",
                "Anadariya",
                "Baguda",
                "Churta Biki",
                "Damau",
                "Dawakin Dogo",
                "Durumawa",
                "Gargai",
                "Gunki",
                "Gwarmai",
                "Jibga",
                "Kofa",
                "Kuki",
                "Rahama",
                "Ranka",
                "Ranta",
                "Tariwa",
                "Wak",
                "Yak",
                "Yakun",
                "Yanshere"
            ],
            "Bichi": [
                "Bichi",
                "Aawa",
                "Abakur",
                "Badume",
                "Beguwa",
                "Belli",
                "Chiromawa",
                "D/Dorawa",
                "Daddo",
                "Damargu",
                "Daminawa",
                "Danzabuwa",
                "Dokoki",
                "Fagwalo",
                "Garun Bature",
                "Hagawa",
                "Hugulawa",
                "Iyawa",
                "Kakari",
                "Kaukau",
                "Kawaje",
                "Kungu",
                "Kwamarawa",
                "Kyauta",
                "Malikawar Garu",
                "Malikawar Sarari",
                "Marga",
                "Muntsira",
                "Rimaye",
                "Sabo",
                "Sanakur",
                "Saye",
                "Sum Sum",
                "Tinki",
                "Tsaure",
                "Tukubi",
                "Waire",
                "Yan Bundu",
                "Yan Gwarzo",
                "Yan Lami",
                "Yandutse",
                "Zukumi"
            ],
            "Bunkure": [
                "Bunkure",
                "Barkum",
                "Bono",
                "Chirin",
                "D/Dundu",
                "Dundu",
                "Dususu",
                "Falingo",
                "Gabo",
                "Gafan",
                "Garanga",
                "Gora",
                "Gurjiya",
                "Gwamma",
                "Gwaneri",
                "Jalabi",
                "Jallorawa",
                "Jaroji",
                "Karnawa",
                "Kokotawa",
                "Kumurya",
                "Sabon Ruwa",
                "Satigal",
                "Shiye",
                "Tsamabaki",
                "Tudungali",
                "Tugugu",
                "Zanga"
            ],
            "Dala": [
                "Dala (Rural)",
                "Aburawa",
                "Bafin/Ruwa",
                "Gadankaya",
                "Dandunshe",
                "Fuska Arewa",
                "Gandu",
                "K/Lunkwi",
                "K/Waika",
                "Man/Ladan",
                "Tudun Yola",
                "Waika",
                "Yalwa",
                "Yan/Tandu"
            ],
            "Danbatta": [
                "Danbatta",
                "Ajumawa",
                "Barebari",
                "Danratta",
                "Danya",
                "Diggol",
                "Dukewa",
                "Dungurumi",
                "F/Dashi",
                "Fayam-Fayam",
                "Fogolawa",
                "Galoru",
                "Gwalaiba",
                "Gwanda",
                "Gwarabjawa",
                "Gwauran Maje",
                "Hazo",
                "Kadandani",
                "Katsarduwa",
                "Kore",
                "Kwasauri",
                "Mahuta",
                "Nassarawa",
                "Rade",
                "Ruwantsa",
                "Sansan",
                "Satame",
                "Tabo",
                "Takai",
                "Yam Mawa",
                "Yambawa",
                "Yanlada",
                "Zago"
            ],
            "Dawakin Kudu": [
                "Dawaki",
                "Behun",
                "Dabakwari",
                "Danbagina",
                "Dasan Dosan",
                "Dawakin Kudu",
                "Dawakji",
                "Gano Gumaka",
                "Gurjiya",
                "Jido",
                "Kadawa",
                "Kamagata",
                "Kantsi",
                "Kanwa",
                "Kwagwar Kaza",
                "M. Mata",
                "Mabarin Taba",
                "Muras",
                "Runa",
                "Santolo",
                "Sarai",
                "T/Gabas",
                "Takai",
                "Tamburawa",
                "Tanagar",
                "Tar Tofa",
                "Tsakuwa",
                "Ungwar Duniya",
                "Yanbarci",
                "Yanfari",
                "Yankatsare",
                "Yargay",
                "Zogarawa"
            ],
            "Dawakin Tofa": [
                "Dawakin Tofa",
                "Alajawa",
                "B/Tumau",
                "Babban Ruga",
                "Badau",
                "Bagari",
                "Bambarawa Nasara",
                "Bankaura",
                "Chedi",
                "Dandalama",
                "Dawanau",
                "Dnaguguwa",
                "Dungurawa Kwa",
                "F/Kawo",
                "Jalli",
                "Kaleku",
                "Kunnawa",
                "Kwidawa",
                "Marke",
                "Rumi",
                "Sharkakiya",
                "Tattarawa",
                "Tumfefi",
                "Ungwar Jobenkun",
                "Ungwar Rimi",
                "Yanrutu",
                "Yelwa"
            ],
            "Doguwa": [
                "Doguwa",
                "Bakarfa",
                "Bebeji",
                "Dadabo",
                "Dadinkowa",
                "Dandoki",
                "Dariyar Kudu",
                "Falgore",
                "Fanyabo",
                "G/Makera",
                "G/Shere",
                "Jangefe",
                "Katsinawa",
                "Lungu",
                "Mahuta",
                "Maigodo",
                "Maikwadira",
                "Makarfi",
                "Malamawa",
                "Maraku",
                "Muchia",
                "Murai",
                "Pegi",
                "Ragada",
                "Ririwai",
                "Sabon Kwara",
                "Sabuwar",
                "Shiburu",
                "Surutwawa",
                "Tagwaye",
                "Tanalafiya",
                "Tilanbawa",
                "Tsauni",
                "U/Masama",
                "U/Tanko",
                "U/Turai",
                "Ungwar Tsohon-Sarki",
                "Zenabi"
            ],
            "Fagge": [
                "Fagge/Waje",
                "Waje"
            ],
            "Gabasawa": [
                "Gabasawa",
                "Chikawa",
                "Dadin Duniya",
                "Dagar",
                "Darinawa",
                "Doga",
                "Gambawar Kanawa",
                "Garun Danga",
                "Gumawa",
                "Gunduwawa",
                "Guruma",
                "Jigawa",
                "Jigoron Kanawa",
                "Jijitar",
                "Joda",
                "K/Yunbu",
                "Kafamai",
                "Kagadama",
                "Karmami",
                "Kawo",
                "Kiyawa",
                "Kumbo",
                "Kwakwashi",
                "Larabawa",
                "Mazangudu",
                "Mazauta",
                "Mekiya",
                "Saiye",
                "Santsi",
                "Sauna",
                "Shana",
                "Tagwamma",
                "Tankarau",
                "Tofai",
                "Wadugur",
                "Wailare",
                "Wasarde",
                "Yadai",
                "Yautar Arewa",
                "Yautar Kudu",
                "Yamar Fulani",
                "Yandake",
                "Yangwam",
                "Yar Zabaina",
                "Yunbu",
                "Zaidawa",
                "Zakirai",
                "Zango",
                "Zangon Gabasawa",
                "Zugachi"
            ],
            "Garko": [
                "Garko",
                "Buda",
                "Dal",
                "Garinali",
                "Gurjiya",
                "Kafin Malamai",
                "Katimari",
                "Kawo",
                "Kera",
                "Kwas",
                "Lamire",
                "Maida",
                "Makadi",
                "Raba",
                "Sanni",
                "Sarina",
                "Tsakuwardal",
                "Yarka",
                "Zakarawa"
            ],
            "Garun Mallam": [
                "Garun Malam",
                "Agawa",
                "Chiromawa",
                "Dumati",
                "Durawar Sallan",
                "Garun Babba",
                "Jobawa",
                "Kuiwe Dan Maura",
                "Yadakwari",
                "Yanabawa",
                "Zango"
            ],
            "Gaya": [
                "Gaya",
                "Aku",
                "Amarawa",
                "Argida",
                "Balan",
                "Bangashe",
                "Fani Dau",
                "G/Sarki",
                "Gamarya",
                "Gamoji",
                "Gomo",
                "Gul",
                "Hausawa",
                "Jibawa",
                "Jobe",
                "Kademi",
                "Kazurawa",
                "Kera",
                "Larau",
                "Maimakawa",
                "Masabai",
                "Moda",
                "Shagogo",
                "Wudilawa",
                "Y. Audu",
                "Yankau",
                "Zanbur"
            ],
            "Gezawa": [
                "Gezawa",
                "Abasawa",
                "Amarawa",
                "Andawa",
                "Aujarawa",
                "Babawa",
                "Badan",
                "Bangare",
                "Bujawa",
                "Charo",
                "Dagazam",
                "Dan Madanho",
                "Danawa",
                "Danja",
                "Danzaki",
                "Dausayi",
                "Gawo",
                "Gidi",
                "Goforo",
                "Gunduwawa",
                "Indabo",
                "Jogana",
                "Katewa",
                "Kutil",
                "Kwagwar",
                "Kwasan Kwami",
                "L/Kwagwar",
                "Ranawa",
                "Sabo Gezawa",
                "T/Babba",
                "Tofa",
                "Tsalle",
                "Tsamiyar Kara",
                "Tumbau",
                "Uran",
                "Wangari",
                "Wasardi",
                "Yangwan",
                "Yarkogi",
                "Zango"
            ],
            "Gwarzo": [
                "Gwarzo",
                "Badari",
                "Baderi",
                "Dakwara",
                "Dan Kado",
                "Dan Madadi",
                "Dan Nafada",
                "Dandawa",
                "Danja",
                "Dogami",
                "Fada",
                "Fadamar Fulani",
                "Gangare",
                "Garin Sarki Baka",
                "Getso",
                "Unguwar Dorawa",
                "Jaga",
                "Jama Yan Turu",
                "Kagon Kura",
                "Karar Tudu",
                "Karkari",
                "Kazoge",
                "Korkari",
                "Koyar",
                "Kutama",
                "Kwami",
                "Lakwaya",
                "Maimika",
                "Makan Wata",
                "Mariri",
                "Marori",
                "Moda",
                "Naibi",
                "Nassarawa",
                "Ratawa",
                "Rije (Riji)",
                "Sabon Birni",
                "Sabon Gwarzo",
                "Salihawa",
                "Tsauni",
                "Tumfafi",
                "Ungwar Tudu",
                "Wari Kado",
                "Yadau",
                "Yambashi",
                "Yangaruza",
                "Zangarmawa"
            ],
            "Kabo": [
                "Kabo",
                "Balan",
                "Baskore",
                "Binashi",
                "Dan Maliki",
                "Dugabau",
                "Durun",
                "Gabasawa",
                "Godiya",
                "Garo",
                "Gommo",
                "Goza",
                "Gude",
                "Hauwade",
                "Kanwa Zango",
                "Kanya",
                "Karangiyare",
                "Katsinawa",
                "Kazo",
                "Malam Gajere",
                "Massanawa",
                "Nasarawa",
                "Sani",
                "Shabawa",
                "Ungwan Wusama",
                "Walawa",
                "Wari",
                "Yadau"
            ],
            "Kano Municipal": [
                "Gadun",
                "Kano Municipal",
                "Kofar Kudu",
                "Sharada",
                "Tukuntawa"
            ],
            "Karaye": [
                "Karaye",
                "Adama",
                "Barbaji",
                "Bauni",
                "Citama",
                "Dadinkowa",
                "Danzuwa",
                "Daura",
                "Daurawa",
                "Figi",
                "Jajaye",
                "Kalako",
                "Karshi",
                "Kumbu Gawa",
                "Kwanyawa",
                "Kyari",
                "Ma",
                "Nasarawa",
                "Saunagari",
                "Tofa",
                "Turawa",
                "Unguwar Randi",
                "Unguwar Alhazawa",
                "Unguwar Dawa",
                "Yola",
                "Zauna Gari 1",
                "Zauna Gari 2",
                "Yola 1",
                "Yola 2",
                "Yola Adama",
                "Ma 1",
                "Ma 2"
            ],
            "Kibiya": [
                "Kibiya",
                "Agiri",
                "Bacha",
                "Burmuni",
                "Chaibo",
                "Dungu",
                "Durba",
                "Dususu",
                "Falange",
                "Fammar",
                "Fanchi",
                "Gadako",
                "Gari",
                "Gingiya",
                "Gunda",
                "Jabanni",
                "Jar Mawa",
                "Kadigana",
                "Kuluki",
                "Kure",
                "Lausu",
                "Madachi",
                "Nariya",
                "Sanda",
                "Sarari",
                "Shingi",
                "Tarai",
                "U/Liman"
            ],
            "Kiru": [
                "Kiru",
                "Baawa",
                "Bauda",
                "Dangora",
                "Danshoshiya",
                "Dashi",
                "Daurawa",
                "Dum",
                "Jamar Barde",
                "Jibya",
                "Kadangaru",
                "Kankan",
                "Kogo",
                "Lamin Kwoi",
                "Mallam Bature",
                "Maraku",
                "Maska",
                "Rangas",
                "Sagi",
                "Sarkama",
                "Tsaudawa",
                "U/Isakuwa",
                "Ungwar Kaka",
                "Ungwar Kwari",
                "Ungwar Musa",
                "Yako",
                "Yalwa",
                "Yam",
                "Zuwo"
            ],
            "Kumbotso": [
                "Kumbotso",
                "Bechi",
                "Challawa",
                "Damfami",
                "Dan Gwauro Hago",
                "Dan Gwauro Illiyasu",
                "Dan Maliki",
                "Danbare",
                "Dangwauro",
                "Farawa",
                "Gaida",
                "Guringawa",
                "Gwazaya",
                "Hawandawaki",
                "Kayi Panshekara",
                "Krinbo",
                "Kure Ken",
                "Kusaba",
                "Kuyan Ta Inna",
                "Kuyan Tasidi",
                "Limana",
                "Maidinawa",
                "Mariri",
                "Panshekara",
                "Runkusawa",
                "Samegu",
                "Sarkin Shanu",
                "Shekar Barde",
                "Shekar Madaki",
                "Tamburawa",
                "U/Rimi",
                "Umarawa",
                "Unguwar Yamu",
                "Wailari",
                "Yankusa",
                "Yanshana"
            ],
            "Kunchi": [
                "Kunchi",
                "B/Sadawa",
                "Baje",
                "Birkin",
                "Dankwai",
                "Dunbulin",
                "Dunkwai",
                "G/Sheme",
                "Gwadama",
                "Gwarmai",
                "Jodade",
                "Kaya",
                "Kuku",
                "Luka",
                "Magawata",
                "Matan Fada",
                "Pollw",
                "Shamakawa",
                "Shuwaki",
                "Tofawa",
                "Unguwar Gyartai",
                "Yan Kifi",
                "Yandadi"
            ],
            "Kura": [
                "Kura",
                "Danhassan",
                "Dukawa",
                "Gamadam",
                "Gundutse",
                "Imawa",
                "Imawakore",
                "Karfi",
                "Kosawa",
                "Kunshama",
                "Mudawa",
                "Rugar Duka",
                "Sadauki",
                "Sayawa",
                "Shafawa",
                "Tofa",
                "Yakasai",
                "Yalwa"
            ],
            "Madobi": [
                "Madobi",
                "Abarchi",
                "Agalawa",
                "Bakinkogi",
                "Burji",
                "Chiinkoso",
                "Daburau",
                "Dan Maryame",
                "Dan'auta",
                "Danzo Gari",
                "Gazana",
                "Gora",
                "Kafin Agur",
                "Kanwa",
                "Kaura Mata",
                "Kubarachi",
                "Kundurum",
                "Kwankwaso",
                "Jirgwai",
                "Chikawa",
                "Ningawa",
                "Rikadawa",
                "Ruga",
                "Yakun"
            ],
            "Makoda": [
                "Makoda",
                "Bakarari",
                "Chidari",
                "Danya",
                "Dunawa",
                "Ganji",
                "Jibya",
                "Koguna",
                "Mai-Unguwa",
                "Maitse Dau",
                "Nakarari",
                "Sabon Ruwa",
                "Tabo",
                "Tangaji",
                "Yamawa",
                "Zago"
            ],
            "Minjibir": [
                "Abudakawa",
                "Agalawa",
                "Agarandawa",
                "Azore",
                "Bagurawa",
                "Beguwa",
                "Damusawa",
                "Dauni",
                "Daurawa",
                "Dingin",
                "Dukawa",
                "Dukuji",
                "Dumawa",
                "Farawa",
                "Farke",
                "Gandirwawa",
                "Garke",
                "Gasgainu",
                "Gawo",
                "Gezagezawa",
                "Goda",
                "Gurjiya",
                "Gyaranya",
                "Jamaare",
                "Kankarawa",
                "Kantama Baba",
                "Kazawa",
                "Koya",
                "Kuchir Chiwa",
                "Kukana",
                "Kunya",
                "Kurma",
                "Kuro",
                "Kuru",
                "Kwarkiya",
                "Ladan",
                "Madawa",
                "Magarawa",
                "Marke",
                "Runfa",
                "Sanbaluna",
                "Sarbl",
                "Shagen",
                "Tsage",
                "Tsakuwa",
                "Tsankiya",
                "Tunkunawa",
                "Wakamawa",
                "Wasai",
                "Yabawa",
                "Yajin Rana",
                "Yargaya",
                "Yola",
                "Yukana",
                "Z/Dangwali",
                "Zabainawar",
                "Zango",
                "Zura"
            ],
            "Rano": [
                "Barnawa",
                "Burum",
                "Dususu",
                "Faran",
                "Fassi",
                "Fiyaran",
                "Gorabi",
                "Jellorawa",
                "Juma",
                "Kaiwa",
                "Kalambu",
                "Kundun",
                "Kunkura",
                "Lafsu",
                "Madaci",
                "Mashe",
                "Rano",
                "Rurum",
                "Saji",
                "Sanda",
                "Shike",
                "Tofa",
                "Torankawa",
                "Tsaure",
                "Tum",
                "Yado",
                "Yalwa",
                "Yankanchi",
                "Zambur",
                "Zanyau",
                "Zurgu"
            ],
            "Rimin Gado": [
                "Butubutu",
                "D/Gulu",
                "Dan Isa",
                "Gulu",
                "Indabo",
                "Janguza",
                "Jili",
                "Juli",
                "Karofi Yashi",
                "Maigari",
                "Rinji",
                "Sakaratsa",
                "Tamawa",
                "Tuji",
                "Ungwan Rimi",
                "Wangara",
                "Yalwa",
                "Yan Kuni",
                "Yango"
            ],
            "Rogo": [
                "Bari",
                "Beli",
                "Dan Sambo",
                "Dederi",
                "Falgore",
                "Fulatan",
                "Gidanjaro",
                "Gwan Gwan",
                "Kadafa",
                "Kadana",
                "Makwanya",
                "Nasarawa",
                "Ruwanbago",
                "Tsohuwar/Rogo",
                "Uguwar Sundu",
                "Ung. Makera",
                "Yammali",
                "Zamfara",
                "Zarewa"
            ],
            "Shanono": [
                "Alajawa",
                "Bakwami",
                "Bayan Dutse",
                "Danja",
                "Dutsen Danbakoshi",
                "Fagawa",
                "Farin Ruwa",
                "Gangare",
                "Goda",
                "Godawa",
                "Goran Dutse",
                "Gundantuwo",
                "Hauri",
                "Janja",
                "Janmaza",
                "Jigawa",
                "Kadamu",
                "Kakamu",
                "Kandutse",
                "Kazaga",
                "Kofar Kumburi",
                "Kokiya",
                "Koya",
                "Kundila",
                "Laini",
                "Magashin Fulani",
                "Rimantaini",
                "Shakogi",
                "Takama",
                "Taujeri",
                "Tsaure",
                "Unguwar Maladawa",
                "Unguwar Soda",
                "Yan Gobe",
                "Yan Shado"
            ],
            "Sumaila": [
                "Alfindi",
                "Bagagare",
                "Baji",
                "Bango",
                "Beta",
                "Birminawa",
                "Bunturu",
                "Dambazau Yamma",
                "Dando",
                "Dantsawa",
                "Doguwar Dorowa",
                "Doka",
                "Faradachi",
                "Farin Dutse",
                "Gajigi",
                "Gala",
                "Gani",
                "Garfa",
                "Gediya",
                "Giginya Biyar",
                "Gwanda",
                "Jisai",
                "Kanawa",
                "Kawo",
                "Madobi",
                "Magami",
                "Masu",
                "Matugwai",
                "Rimi",
                "Riyi",
                "Rumo",
                "Sabongida",
                "Sitti",
                "Yamma"
            ],
            "Takai": [
                "Abaldu",
                "Bagwaro",
                "Danbazau Gabas",
                "Durbunde",
                "Fajewa",
                "Falali",
                "Gamawa",
                "Hantsai",
                "Huguma",
                "K/Diribo",
                "Kachako",
                "Kafin Farin Ruwa",
                "Karfi",
                "Kayarda",
                "Kogo",
                "Kuka",
                "Kurido",
                "Lafiya",
                "Langwami",
                "Sakwaya",
                "Toto",
                "Tudun Wada",
                "Tumfusha",
                "Zuga"
            ],
            "Tarauni": [
                "Tokarawa"
            ],
            "Tofa": [
                "Dindere",
                "Doka",
                "Dokadawa",
                "Dutwatsu",
                "Fofa",
                "Ginsawa",
                "Kadawa",
                "Kazardawa",
                "Kwami",
                "Lambu",
                "Langel",
                "Rinji",
                "Sabon Gari Katsalle",
                "Yango",
                "Yanoko",
                "Yarimawa"
            ],
            "Tsanyawa": [
                "Baje",
                "Bumai",
                "Daddarawa",
                "Daddarawa Tsohuwa",
                "Dakwai",
                "Dumbulum",
                "Farsa",
                "Gozarki",
                "Gurun",
                "Harbau",
                "Jamar'a",
                "Jigilawa",
                "Kabagiwa",
                "Katsalle",
                "Kokai",
                "Kuka",
                "Kwandawa",
                "Nassarawa",
                "Rafin Tsamiya",
                "Runji",
                "Tatsan",
                "Yakanawa",
                "Yammanman",
                "Yan'awaki",
                "Yancibi",
                "Yanganau",
                "Yankamaye",
                "Zarogi"
            ],
            "Tudun Wada": [
                "Baburi",
                "Bul",
                "Burun Burun",
                "Dalawa",
                "Fala",
                "Faskar Wambai",
                "Gazobi",
                "Hayindenu",
                "Jammaje",
                "Jandutse",
                "Jangefe",
                "Jeli",
                "Jita",
                "Kafin Dalawa",
                "Kankanu",
                "Karefa",
                "Nata Ala",
                "Rugurugu",
                "Ruwan Tabo",
                "Shuwaki",
                "Shuwi",
                "Sumana",
                "Wuna",
                "Yar Fulani",
                "Yar Yasa",
                "Yarmaraya",
                "Yelwa"
            ],
            "Warawa": [
                "A'Giwa",
                "Amarawa",
                "Dan Lasan",
                "Galadima",
                "Ganakako",
                "Garu Dau",
                "Giwarwan",
                "Goget",
                "Gumaka",
                "Jigawa",
                "Kanta",
                "Kanwa",
                "Katarkawa",
                "Kinchau",
                "Ladimakole",
                "Limawa",
                "Madarin",
                "Manyan Mata",
                "Tamburawa Gabas",
                "Token",
                "Wambantu",
                "Warkai",
                "Yan-Dalla",
                "Yan-Tofa",
                "Yangizo"
            ],
            "Wudil": [
                "Achika",
                "Audaga",
                "Bange",
                "Buda",
                "Dagumawa",
                "Dal",
                "Darki",
                "Gariko",
                "Garin Ali",
                "Guna",
                "Gware",
                "Indabo",
                "Juma",
                "Kafin Malami",
                "Kausani",
                "Kawo",
                "Kwas",
                "Lajawa",
                "Maida",
                "Makadi",
                "Makera",
                "Mandawari",
                "Raba",
                "Tsakuwadal",
                "Utai",
                "Yarka"
            ]
        }
    },
    {
        "Kastina": {
            "Bakori": [
                "Kurami",
                "Dutsen Reme",
                "Yankwani",
                "Makera",
                "Kakumi",
                "Guga",
                "Kandarawa",
                "Maiyadiya",
                "Lamido",
                "Tsiga",
                "Jargaba",
                "Kabomo",
                "Barde",
                "Dawan Musa",
                "Kwantakwaran",
                "Amfani",
                "Sandada",
                "Gazara"
            ],
            "Batagarawa": [
                "Ajiwa",
                "Babibayawa",
                "Bakiyawa",
                "Barawa",
                "Dan Iyan",
                "Dandagoro",
                "Danna Baso",
                "Jino",
                "Kaukai",
                "Kayauki",
                "Kayoki",
                "Tsanni",
                "Yan-Rakumma",
                "Yar Gamji"
            ],
            "Batsari": [
                "Abadau",
                "Dan Alhaji",
                "Dan Geza",
                "Darini",
                "Gangarat-Rumah",
                "Garwa",
                "Hauwawa",
                "Hurmiya",
                "Kandawa",
                "Karare",
                "Kurmiyal",
                "Kwari",
                "Madogara",
                "Mai Zurmi",
                "Makada Duma",
                "Mallamawa",
                "Manawa",
                "Margafi Abu",
                "Nahuta",
                "Rumah",
                "Sabon Garin Dunburawa",
                "Shirgi",
                "Wagini",
                "Yan Gayya",
                "Yan-Daka",
                "Yasore",
                "Yau Yau"
            ],
            "Baure": [
                "Babban Mutum",
                "Bare",
                "Faski",
                "Garki",
                "Hui",
                "Kagara",
                "Komo",
                "Kuntaru",
                "Kwasamawa",
                "Maimazari",
                "Rijayan Tsamiya",
                "Taramanawa",
                "Yan Maulu",
                "Yan-Tsai",
                "Yankirya"
            ],
            "Bindawa": [
                "Rinjin-Baushe",
                "Aisawa",
                "Dallaje",
                "Daye Olay",
                "Doro",
                "Faru",
                "Gaiwa",
                "Gire Mawa",
                "Gwanza",
                "Jibawa",
                "Kamri",
                "Kyarmanya",
                "Mazanya",
                "Rugan Barde",
                "Shibdawa",
                "Tama",
                "Tuwaru",
                "Yangora",
                "Tudun Wada",
                "Fura Girke"
            ],
            "Charanchi": [
                "Banye",
                "Dafara",
                "Doka",
                "Ganuwa",
                "Kadanya",
                "Koda",
                "Kumuye",
                "Kuraje",
                "Maje",
                "Radda",
                "Safana",
                "Tsakatsa",
                "Tsaski",
                "Yaruku"
            ],
            "Dan Musa": [
                "Dan Ali",
                "Dandire",
                "Maidabino",
                "Mara",
                "Mara-Zamfarawa",
                "Tsahar Mai-Alewa",
                "Yan-Tumaki-Galadima",
                "Yantunmaki"
            ],
            "Dandume": [
                "Dan Soda",
                "Dantakari",
                "Ilalla",
                "Jiruwa",
                "Magaji-Wando",
                "Mahuta",
                "Mai Kwama",
                "Nasarawa",
                "Tumbarkai",
                "Unguwar Gamba",
                "Unguwar Malamja"
            ],
            "Danja": [
                "Dabai",
                "Tsangamawa",
                "Jiba",
                "Kahutu",
                "Tandama",
                "Yakaji",
                "Majedo",
                "Bazaga",
                "Chediya",
                "Dauraku",
                "Danmaigauta"
            ],
            "Daura": [
                "Bauni",
                "Bojo",
                "Daberam",
                "Don-Nakola Garjiya",
                "Dunu",
                "Ganga",
                "Gurjiya",
                "Iambu-Tudu",
                "Jambu",
                "Kalgo",
                "Kamfawa",
                "Kurneji",
                "Madobi",
                "Maji Yawa",
                "Mazoji",
                "S/Yara",
                "Sabon Gari",
                "Sarkin Yara",
                "Shadambu",
                "Shamarada",
                "Sharawa",
                "Suduji",
                "Sukwanawa",
                "Turimni",
                "Ubandawaki",
                "Unguwa Dawaki",
                "Yamadawa",
                "Yarogel",
                "Zari"
            ],
            "Dutsi": [
                "Baugel",
                "Be'al",
                "Beguwa",
                "Dan Rumai",
                "Dan-Kowa",
                "Danaunai",
                "Dinya Mai",
                "Dinya Mai Randa",
                "Dutsawa",
                "Gazari",
                "Gewayau",
                "Ginginya",
                "Jigawa-Tirke",
                "Kaba",
                "Kafin Labu",
                "Kagon-Burtu",
                "Karawa",
                "Karemi",
                "Kayawa",
                "Kegiya",
                "Macinawa",
                "Madawa",
                "Makan Gara",
                "Makangara",
                "Minawa",
                "R/Kaya",
                "Shargalle",
                "Sirika",
                "Tashar-Wali",
                "Yamel"
            ],
            "Dutsin-Ma": [
                "Bagagadi",
                "Dabawa",
                "Dagelawai",
                "Dan Ali",
                "Dorawa",
                "Dutsi-Ma",
                "Kagara",
                "Karofi",
                "Katanga",
                "Kufan Aggo",
                "Kuki",
                "Kutawa",
                "Kutawa-Badole",
                "Mahuta-Sabon Garin-Safana",
                "Makera",
                "Nasarawa-Gizawa",
                "Rayi-Faguwa",
                "Sabon Garin Turare",
                "Salihawa",
                "Sawawa-Dogon Ruwa",
                "Shema",
                "Shema-Hayin Gada",
                "Tashar Bara'u",
                "Yan Shantuna"
            ],
            "Faskari": [
                "Bagudu",
                "Bakarya",
                "Bele",
                "Bilbis",
                "Birnin Kogo",
                "D/Ba'u",
                "Daudawa",
                "Doma",
                "Fankama",
                "Kadisau",
                "Kanon Haki",
                "Karmanje U/Bikka",
                "Kogo",
                "Kondo",
                "Kwai",
                "Kwakware Sheme",
                "Ladan",
                "Mai Gora",
                "Mairuwa",
                "Maisabo",
                "Monunu",
                "Munhaye",
                "Ruwan Godiya",
                "S/Layin Galadima",
                "Sarkin Fulani",
                "Shawu",
                "Sheme",
                "Tafoki",
                "Tudun Laki",
                "Ung-Bara'u",
                "Ung-Diyam",
                "Ung-Doka",
                "Ung-Ganye",
                "Ung-Gwanki",
                "Ung-Maikanwa",
                "Ung-Maje",
                "Ung-Malam Musa",
                "Ung-Miko",
                "Ung-Namande",
                "Ung-Sakkai",
                "Ung-Wakili",
                "Wakataba",
                "Yan Kara",
                "Yan Turawa",
                "Yankara",
                "Yar Malami",
                "Yar Marafa",
                "Yar Nassarawa"
            ],
            "Funtua": [
                "Dukke",
                "F/Dadutsi",
                "F/Maikatawa",
                "F/Ta Gabas",
                "F/Ta Yamma",
                "F/Tanimu",
                "F/Tudu",
                "F/Wawa",
                "Farin",
                "Goya",
                "Illala",
                "Jabiri",
                "Maigamji",
                "Mairuwa",
                "Makera",
                "Maska",
                "Ruwan Godiya",
                "Tundun Wada",
                "Tundun-iya",
                "Zamfarawa",
                "Funtua (Rural)"
            ],
            "Ingawa": [
                "Agayawa",
                "Bakinkwari",
                "Bareruwa",
                "Bidore",
                "Dan Ashintan",
                "Dara",
                "Daunaka",
                "Dugul",
                "Gamda",
                "Jobe-Kandawa",
                "Kafi",
                "Karkarku",
                "Koda",
                "Kurfeji",
                "Maje",
                "Maramwa",
                "Nasarawa",
                "Rimin Hagau",
                "Ruruma",
                "Tunas",
                "Yalasse",
                "Yallawa",
                "Yan Kaura",
                "Yandoma",
                "Yaya"
            ],
            "Jibiya": [
                "Daddara",
                "Bugaje",
                "Kusa",
                "Zandam",
                "Farfaru",
                "Gangara",
                "Gulbin Baure",
                "Magama",
                "Mallamawa",
                "Mazanya",
                "Riko",
                "Simfida",
                "Tagwaye",
                "Tsanga",
                "Yan Gayya",
                "Yangau"
            ],
            "Kafur": [
                "Barakai",
                "Dakin-Kura",
                "Dan Kanjiba",
                "Dan Kwaro",
                "Dantige",
                "Dantutture",
                "Dayawa",
                "Dutse",
                "Dutsin-Yanke",
                "Gamzako",
                "Gozaki",
                "Huguma",
                "Kagara",
                "Kami",
                "Kanya",
                "Kartakai",
                "Kufan Tambo",
                "Kuraku",
                "Kurin Gafa",
                "Kurmi",
                "Layin-Bagudu",
                "Layin-Makera",
                "Mahuta",
                "Malamawa",
                "Marabar-Kanya",
                "Masari",
                "Masu-Kinari",
                "Rafin-Kada",
                "Rigaji",
                "Sabuwar-Kasa",
                "Santar Arab",
                "Tafkin-Jage",
                "Tudun-Sanusi",
                "Unguwar Waina",
                "Unguwar-Sama'I",
                "Yar-Talata",
                "Yari-Bori",
                "Yarman"
            ],
            "Kaita": [
                "Abdallawa",
                "Allemi",
                "Ba Awa",
                "Bado",
                "Dagon Dawa",
                "Damgamji",
                "Dan Bazau",
                "Dan Kama",
                "Dan Kunama",
                "Dan Tudu",
                "Dankaba",
                "Dankunama",
                "Daurawa",
                "Dumbasa",
                "Dutsin-Safe",
                "Gafiya",
                "Gande",
                "Girka",
                "Gishirawa",
                "Jifatu",
                "Kabobi",
                "Kafin-Mashi",
                "Kagadama",
                "Lafiyaru",
                "Lalaini",
                "Maikasuwa",
                "Makau",
                "Masaki",
                "Matsai",
                "Rogon-Dawa",
                "Sabi",
                "Sabon Birni",
                "Sawarya",
                "Tsamiye",
                "Unguwa Isamiya",
                "Yan Daki",
                "Yan doki",
                "Yan Hoho"
            ],
            "Kankara": [
                "Almajiraiwa",
                "Arewa",
                "Bagoma",
                "Burdugu",
                "Da-Kumeji",
                "Dan Dashire",
                "Dan Maidoki",
                "Dan Marabu",
                "Dan Marke",
                "Dan-Kalgo",
                "Dan-Nakinaba",
                "Dan-Sabau",
                "Dorowar-Natiba",
                "Fawwa",
                "Garaji(A)",
                "Garaji(B)",
                "Gatakawa",
                "Gobi rawa",
                "Goda",
                "Gundawa",
                "Gurbi",
                "Harwaya",
                "Hurya",
                "Jan-Ruwa",
                "Kada-Buki",
                "Kafi",
                "Kanawa",
                "Kankomi",
                "Katoge",
                "Katsalle",
                "Ketare",
                "Kukarsheka",
                "Labi",
                "Madobi",
                "Makera",
                "Malali",
                "Mashigi",
                "Sabon Gari",
                "Sabon Layi",
                "Santar Dangeda",
                "Sherere",
                "Unguwar Alh. Garba",
                "Unguwar-Marke",
                "Wawakaza",
                "Yargoje",
                "Yarwa",
                "Zabaro",
                "Zakaru",
                "Zango"
            ],
            "Kankia": [
                "Dan Doro",
                "Daya",
                "Duku-Duku",
                "Fakuwa",
                "Galadima",
                "Gidan Mutum",
                "Gochi",
                "Gyaza",
                "Jauga",
                "Kafinsoli",
                "Kanyen Maina",
                "Kuduru",
                "Machinjin",
                "Magajin Gari",
                "Magami",
                "Nasarawa",
                "Nasarawa Rimaye",
                "Rimaye",
                "Sagawar Doka",
                "Sukuntuni",
                "Tafajomua",
                "Tafashiya",
                "Tsa",
                "Tudun-Wulli"
            ],
            "Katsina": [
                "Rural",
                "Ajiwa",
                "Baki Yawa",
                "Dndagora",
                "Dustin Safe",
                "Galadiman Arewa",
                "Galadiman Gabasawa",
                "Galadiman Kudu",
                "Gwado",
                "Jino",
                "Kayauki",
                "Madaji Madu",
                "Modoji",
                "Shinkafi",
                "Wakilin Arewa",
                "Wakilin Gabasa",
                "Wakilin Kudu",
                "Wakilin Tamma"
            ],
            "Kurfi": [
                "Barkiya",
                "Birchi",
                "Gwanzo",
                "Kufan Agga",
                "Kware",
                "Nasarrawa",
                "Rawayau",
                "Sabon Gari",
                "Tamawa",
                "Tamu",
                "Tsauri",
                "Wurma"
            ],
            "Kusada": [
                "Aganta",
                "Baurawa",
                "Boko",
                "Dangamau",
                "Dudunni",
                "Kai-Kai",
                "Kofa",
                "Magama-Gidan Mutun Daya",
                "Mairana",
                "Mawashi",
                "Tufani",
                "Yashe"
            ],
            "Mai-Adua": [
                "Baida",
                "Buduma",
                "Bula",
                "Bumbum",
                "Daba",
                "Dadin Sarki",
                "Dagon Hawa",
                "Dagura",
                "Dan Nasara",
                "Dan Yawa",
                "Danmisa",
                "Dansawa",
                "Dunyashe",
                "Galadimawa",
                "Garon Maje",
                "Gojo-Gogo",
                "Guzu",
                "Gwajo-Gwajo",
                "Jassai",
                "Jirdede",
                "Ka Dangwaras",
                "Kahe",
                "Kalansanmi",
                "Katsinawa",
                "Kokutuko",
                "Kongolam",
                "Koza",
                "Kudi Jika",
                "Kurchi",
                "Kwadage",
                "Madaddaga",
                "Mai Daniya",
                "Mai Faru",
                "Mai Gari",
                "Mai Kwamame",
                "Maikoni",
                "Maiturmi",
                "Makerawa",
                "Muludu",
                "Natsalle",
                "Saitawa",
                "Shabewa",
                "Sharta",
                "Shekiya",
                "Shiroka",
                "Tadi",
                "Tafakai",
                "Tilla",
                "Tsabu",
                "Tsauri",
                "Tsiga-Hamisu",
                "Tsohou Birni",
                "Tuga",
                "Unguwar Jimmai",
                "Unguwar Tuka",
                "Wala",
                "Yan Harkum",
                "Yan Kara",
                "Yar Yandi",
                "Yarima Jatau",
                "Yarogel"
            ],
            "Malumfashi": [
                "Agagiwa",
                "Allah Madagara",
                "Almakiyayi",
                "Birin Dawa",
                "Dan-Sarai",
                "Dayi",
                "Dinyar Makeri",
                "Dogon Marke",
                "Fanisau",
                "Gamzaga",
                "Gandum Karfi",
                "Gangara",
                "Gora",
                "Gorar-Dansaka",
                "Gwanamarde",
                "Karfi",
                "Kuringaja",
                "Kurmin Gafa",
                "Kurmin Yan Daddawa",
                "Lamintani",
                "Layin Ministra",
                "M/Kankara",
                "Makaurachi",
                "Malumfashi A",
                "Malumfashi B",
                "Marmara",
                "Na-Alama",
                "Rereji",
                "Ruwan Sanyi",
                "Sabon Gari",
                "Salihawa",
                "Tashar Ali",
                "Tashar Fulani",
                "Wanzamai",
                "Ya-Kwakare",
                "Yaba",
                "Yan Mama",
                "Yan-Janku",
                "Yan-Mama",
                "Yar Tashi",
                "Yaro",
                "Zamzago"
            ],
            "Mani": [
                "Aliyaba",
                "Bagiwa",
                "Bakan Karo",
                "Birjiwa",
                "Bujawa",
                "Dawan-Makawu",
                "Duwan",
                "Gajema",
                "Gewayau",
                "Hancheta",
                "Jachi",
                "Jani",
                "Jirja",
                "kijibta",
                "Kugabo",
                "Kumumuwa",
                "Kwatya",
                "Machika",
                "Magani",
                "Makau",
                "Muduru",
                "Saguwa",
                "Sardago",
                "Shakura",
                "Takusheyi",
                "Tsagen",
                "Tsaurara",
                "Turawa"
            ],
            "Mashi": [
                "Agalla",
                "Badauri",
                "Bamle",
                "Birnin Kuka",
                "Dindiyel",
                "Doguru",
                "Dokawa",
                "Gallu",
                "Jigawa",
                "Karawa",
                "Korau",
                "Majigiri",
                "Morawa",
                "S/Rijiya",
                "Saye",
                "Shargalle",
                "Sonkaya",
                "Tamilo",
                "Tudu",
                "Yamal",
                "Yar Daddo"
            ],
            "Matazu": [
                "Dan-Kwari",
                "Dissi",
                "Gidan-Dangata",
                "Gidan-Karo",
                "Gwarjo",
                "Gyazawa",
                "Jataka",
                "Jumawa",
                "Karaduwa",
                "Karmatako",
                "Kogari",
                "Matazu",
                "Mazoji",
                "Rinjin-Gora",
                "Rinjin-Idi",
                "Sabon Garin Matazu",
                "Sayaya",
                "Tashar Gurgu"
            ],
            "Musawa": [
                "Aljawal",
                "Daminawa",
                "Dan Gani",
                "Dan Janku",
                "Dan Kado",
                "Farin-Dutse",
                "Filalawa",
                "Garu",
                "Gidan-Lumo",
                "Gin-Gin",
                "Jikamshi",
                "Karachi",
                "Katoge",
                "Kauyen-Gide",
                "Kira",
                "Kiryoyi",
                "Kurkjian",
                "Kuru",
                "Marabar-Musawa",
                "Rijar-Kusa",
                "Sako",
                "Sanyinawa",
                "Tabanni",
                "Tuge",
                "Unguwar-Rinji",
                "Yar'adua",
                "Zodwa"
            ],
            "Rimi": [
                "Abukar",
                "Allaraini",
                "Bardayya",
                "Bujawa",
                "Dan Musa",
                "Eka",
                "Fardami",
                "Iyatawa",
                "Iyatawu",
                "Kadandani",
                "Karare",
                "Kurabau",
                "Kuraye",
                "Lambar Rimi",
                "Madunka",
                "Magama",
                "Majen-Gobir",
                "Makurda",
                "Makwalla",
                "Masabo",
                "Remawa",
                "Rimin Guza",
                "Sabob Gari",
                "Siyya",
                "Tzegero"
            ],
            "Sabuwa": [
                "Albasa",
                "Awala",
                "Damari",
                "Doka",
                "Dudun Ma'azu",
                "Gamji",
                "Gazari",
                "Ginanna",
                "Gobirawa",
                "Hayin Issau",
                "Inonon Kabalawa (B)",
                "Inonon Madawaki (A)",
                "Inonon Makera (C)",
                "Inonon Malamai (D)",
                "Kabalawa",
                "Katsalle",
                "Machika",
                "Mai Bakko",
                "Mazare",
                "Nassarawa Daji",
                "Rafin Iwa",
                "Rumada",
                "Sarkin Dawa",
                "Sayau",
                "Un-Habibu",
                "Ung madugu",
                "Ung-Abdu",
                "Ung-Adamu",
                "Ung-Alh Tanimu Gagarkuwa",
                "Ung-Bako Banga",
                "Ung-Dabo",
                "Ung-Donkinari",
                "Ung-Garba",
                "Ung-Halidu",
                "Ung-Hamza",
                "Ung-Iliya",
                "Ung-Kadarko",
                "Ung-Kanawa",
                "Ung-Maigaiya",
                "Ung-Maiwasa",
                "Ung-Sani",
                "Unn-Kanta",
                "Ya Lagwada",
                "Yar Kaka",
                "Zaje-Zaji"
            ],
            "Safana": [
                "B/Dahu",
                "Bare-Bari",
                "Baude",
                "Baure",
                "Dabbana Duhu",
                "Dan-Jukku",
                "Dan-Magaya",
                "Gora",
                "Guzarawa",
                "Illela",
                "Kunamawa",
                "Maikada",
                "Mammadau",
                "Moniya",
                "Runka",
                "Tsakiya",
                "Unadau",
                "Yarlilo",
                "Zakka"
            ],
            "Sandamu": [
                "Dadin-Kowa",
                "Damagi",
                "Danji",
                "Duku-Duku",
                "Fago",
                "Gazori",
                "Ingawa",
                "Jar-Kuka",
                "Jiba",
                "Kaibaki",
                "Karkarku",
                "Katsayal",
                "Kwasarawa",
                "Lemo",
                "Lugga",
                "Markarku",
                "Rade",
                "Rijiyar Tsamiya",
                "Ruma",
                "Ruwau-Dutsi",
                "Yakawada",
                "Yan-Manuwa",
                "Zugai"
            ],
            "Zango": [
                "Agala",
                "Arautake",
                "Badake",
                "Barege",
                "Bidawa",
                "Bulungudu",
                "Dan Ali",
                "Dargage",
                "Dasha",
                "Dawan-Malam",
                "Ditse",
                "Fantaika",
                "Fiwuni",
                "Fiyuni",
                "Garandama",
                "Garni",
                "Gurda",
                "Gwamba",
                "Gwanba",
                "Huli",
                "Ishiyawa",
                "Jiba",
                "Jirdede",
                "Kanda",
                "Katsayai",
                "Kawarin Malamai",
                "Komo",
                "Kututture",
                "Kwarin-Kudi",
                "Kwarin-Malamai",
                "Madaka",
                "Maibara",
                "Makiyawa",
                "Ragogo-Cidari",
                "Rahamawa",
                "Rijiyar Mata",
                "Rogogo",
                "Rogogo Masabka",
                "Rogogo Yan Tuba (Jama'a)",
                "Rogogon Gabsa",
                "Sara",
                "Unguwar Dima",
                "Unguwar Gaje",
                "Unguwar Kanja",
                "Walawa",
                "Yakubawa",
                "Yanduna",
                "Yar Daje",
                "Yardade",
                "Zagon Kofar Gabas",
                "Zangon Customs Barracks",
                "Zangon Kachakurawa",
                "Zangon Kofar Yamma",
                "Zangon Kofar Arewa",
                "Zangon Kofar Kudu",
                "Zangon-Katukulo"
            ]
        }
    },
    {
        "Kebbi": {
            "Aleiro": [
                "Alero",
                "Dangaladima",
                "Jiga Birni",
                "Jiga Makera",
                "Magajin Gari",
                "R/Banwa",
                "S/Fada",
                "Tudun Wada",
                "Sabiyel",
                "D/ Galadima",
                "Dakala",
                "Gumbulu",
                "Kashin Zama Farafa",
                "Kashin Zama-",
                "Nasarawa",
                "R/ Bauna",
                "U/ Galadima"
            ],
            "Arewa Dandi": [
                "Kangiwa",
                "Amagwato",
                "Baraje Buii",
                "Chibike",
                "Falde",
                "Fasko",
                "G/Dikko",
                "Gumundai",
                "Gunki",
                "Muza Jaffeji",
                "Rafin Taska",
                "Yeldu",
                "Bachaka",
                "Danstohuwa",
                "Dantsoho",
                "Daura",
                "Jantullu",
                "Jarkuka",
                "Laima",
                "Sakwaba",
                "Sarka"
            ],
            "Argungu": [
                "Argungu (Rural)",
                "Alwasa",
                "Bachaye",
                "Bela",
                "Dabiri",
                "Filinde",
                "Gottomo",
                "Gulma",
                "Jada",
                "Kadubba",
                "Marafa",
                "T/ Maidawa",
                "T/ Marina",
                "Tasumbulai",
                "Ummara",
                "Unwara",
                "Babgola",
                "Birnin Lafiya",
                "Kaura",
                "Sawwa",
                "T/ Rairai",
                "Lailaba",
                "Baguni",
                "Dagini",
                "Danba",
                "Fakkai",
                "Galbi",
                "Ladafando",
                "Leni",
                "Natsini",
                "Rumbuki",
                "Sakawa",
                "Sarkin Gobir",
                "T/ Zazzagawa",
                "Yamama",
                "Yarkatanga",
                "Zazzagawa"
            ],
            "Augie": [
                "Augie",
                "Bagaye",
                "Dundaye",
                "IIIela Rafi",
                "Kwaido",
                "Mera",
                "Yola",
                "Zagi",
                "Bayawa",
                "Awade",
                "B/Tude",
                "Bubuce",
                "Gudale",
                "Tiggi"
            ],
            "Bagudo": [
                "Bagudo",
                "Bahindi",
                "Bokki(Doma)",
                "Geza",
                "Gumi",
                "Gyalange",
                "Illelar-Awwal",
                "Kaliel",
                "Kudi",
                "Maraka",
                "Marake",
                "Matsinkai",
                "Rafin Gari",
                "Sharabi",
                "Tuga",
                "Ubandawaki-Gummi",
                "Illo",
                "Bani",
                "Gatswani",
                "Gesharo",
                "Giris",
                "Kali",
                "Kasati",
                "Kurkuru",
                "Lolo",
                "Sabon Gari",
                "Tsamiya",
                "Tundi",
                "Yantela",
                "kaoje",
                "Bakin Ruwa",
                "G/Fadama",
                "Gandome",
                "Ganten Tudu",
                "Gwamba",
                "Kaoje",
                "Lafagu Grande",
                "Yemusa",
                "Zagga",
                "Kende",
                "Kumbobo",
                "Kurgu",
                "Kwarguwai",
                "Kwasara",
                "Maidanenni",
                "Maitambari",
                "S/Gari",
                "Zagda Gari"
            ],
            "Birnin Kebbi": [
                "Ambursa",
                "Bago",
                "Busawa",
                "Dagere",
                "Damana",
                "Gandewu",
                "Garu Guri",
                "Gawassu",
                "Gazon fulani",
                "Gazon Zabarmawa",
                "Goru",
                "Gulumbe",
                "Gwadangaji",
                "Hammari",
                "Harasawa",
                "Janzomo",
                "Junju",
                "Kabawa",
                "Kardi Gabas",
                "Kardi Tsakiya",
                "Kardi Yamma",
                "Karyo",
                "Kawara",
                "Lagga",
                "Makera",
                "Nufawa",
                "Randali",
                "Tarasa",
                "U/ Maifada",
                "Ujariyo",
                "Yamma"
            ],
            "Bunza": [
                "Dangaladima",
                "Gwade",
                "Raha",
                "Maidahini",
                "Matseri",
                "Modomawa",
                "Sabon Birni",
                "T/Dannufe",
                "Zogirma",
                "Salawai",
                "Tilli"
            ],
            "Dandi": [
                "Kamba",
                "Bani-zumbu",
                "Buma",
                "Dole Kaina",
                "Fana",
                "Fingilla",
                "Geza",
                "Kwakwaba",
                "Kyengakwai",
                "Maidaji",
                "Maigwaza",
                "Rundu Bussa",
                "Shiko",
                "Tungage",
                "Tungar Rogo"
            ],
            "Danko-Wasagu": [
                "Ayu",
                "Bagida",
                "Bena",
                "D/ Kibiya",
                "D/ Umaru",
                "Dutsen Kwana",
                "Gwazawa",
                "Kango",
                "Kanya",
                "Machika",
                "Morai",
                "Rade",
                "Rambo",
                "Riba Susu",
                "Shengel",
                "Susu",
                "Unashi",
                "Wadako",
                "Waje",
                "Yar Ali",
                "Yarkuka",
                "Zuttu"
            ],
            "Fakai": [
                "B/Tudu",
                "Bajida",
                "Bangu",
                "Bullu",
                "D/Manddanau",
                "Darmi",
                "Garin Awwal",
                "Garin Isa",
                "Gelle",
                "Gulbin Kuka",
                "Inga",
                "Kangi",
                "Kelle",
                "Magaji Fakai",
                "Mahuta",
                "Makera",
                "Marafa",
                "Matseri",
                "Penin Gaba",
                "Rini",
                "S/ Gari/ Yargede",
                "Yarkofoji",
                "Yelwa",
                "Zussun"
            ],
            "Gwandu": [
                "Dalijan",
                "Amore",
                "Bundusule",
                "Danjema",
                "Gwabbare",
                "Gwanyel",
                "Warari",
                "Gwandu",
                "Gora",
                "Gumbai",
                "Gyartau",
                "Jariyaje",
                "Karangiyar Sarki",
                "Kurya",
                "Kwazari",
                "Kwazgara",
                "Magama",
                "Malisa",
                "Marafa",
                "Maruda",
                "Naman Goma",
                "Rimaye",
                "Ruggar Dawa",
                "Rumbuki",
                "S/Fana",
                "Sabon Birni",
                "Sesseda",
                "Tufara",
                "Yalango",
                "Kambaza",
                "Bada",
                "Dodoru Kambaza",
                "Gamdatobe",
                "Gitta",
                "Gulmere",
                "Illelar Madadi",
                "Madadi",
                "Takari",
                "Tari",
                "Yole Magorama",
                "Yolen Birni"
            ],
            "Jega": [
                "Akalawa",
                "Basaura",
                "Dangamaji",
                "Dumbegu",
                "Firchin",
                "Gindi",
                "Jega Magaji",
                "Kokani",
                "Kyarmi",
                "Maza Goma",
                "Nassarawa",
                "S/Yaki (T/Wada)",
                "Sarkin Fada",
                "U/Kuka",
                "Uban Doma",
                "Kimba",
                "Agwada",
                "Alelu",
                "Birnin Mallam",
                "Fagada",
                "Gehuru",
                "Geza",
                "Jadadi",
                "Jan Dutsi",
                "Katanga"
            ],
            "Kalgo": [
                "Badariya",
                "Danaganna",
                "Dangoma",
                "Diggi",
                "Etene",
                "Gangare",
                "Gayi",
                "Hirishi",
                "Keta Fulani",
                "Keta Hausawa",
                "Magarza",
                "Mutubore",
                "T/Wada",
                "Wuro Gauri",
                "Kuka",
                "Danyaku",
                "Galaru",
                "Kokani",
                "Kutu Kullu",
                "Nayalwa",
                "Unguwar Rafi"
            ],
            "Koko/Besse": [
                "Amiru",
                "Bakoshi",
                "Besse",
                "BESSE 871106",
                "Dada",
                "Dulmeru",
                "Dutsin Mari",
                "Hirini",
                "K/Damba",
                "Kalakala",
                "Lani",
                "M/ Marukka",
                "Shebba",
                "Shiyar Magaji",
                "Takware",
                "Zaria"
            ],
            "Maiyama": [
                "Aida",
                "Andarai",
                "Botoro Gadi",
                "Danwa",
                "Dogon Daji",
                "Gamjeji",
                "Gidiga",
                "Giwatazo",
                "Gumbin Kure",
                "Karaye",
                "Kawara",
                "Kuberi",
                "Kuka Kogo",
                "Kurun Kudu",
                "Kyasuwa",
                "Liba",
                "Maiyama",
                "Mayalo",
                "Mungadi Birni",
                "Ruwan Fili",
                "Sabon Sara",
                "Sambawa",
                "Saradosa",
                "T/ Mamman",
                "Unguwar Kurya",
                "Y/ Kamba",
                "Zara Birni",
                "Zugun Liba"
            ],
            "Ngaski": [
                "Birnin Yauri",
                "B/Yauri",
                "G/ Baka",
                "Kambuwa",
                "Kimo",
                "Makirim",
                "Marraban Bin Yauri",
                "Ngaski",
                "Chipanini",
                "G/ Kwano",
                "G/ Tagware",
                "Kwanga",
                "Libata",
                "Macufa",
                "Utono",
                "Wara"
            ],
            "Sakaba": [
                "Adai",
                "Bili",
                "D/ Kolo",
                "Dankan-Kambari",
                "Dirin Daji",
                "Dirin Gari",
                "Dokan Hausawa",
                "Gelwasa",
                "Jan Binni",
                "Jan Dutsi",
                "Jigawa",
                "K/ Hodo",
                "Kaiwar Kasa",
                "Kaiwar Sama",
                "Magami",
                "Mahuta",
                "Makuku",
                "Niger",
                "Tunga Gwamna"
            ],
            "Shanga": [
                "Kwanji",
                "Binuwa",
                "Bukunji",
                "Gebbe",
                "Kawara",
                "Samanaji",
                "Sarge",
                "Turgu",
                "Dugu Tsolo",
                "Golongo",
                "Hundeji",
                "Rafin Kirya",
                "Sakace",
                "Sawashi",
                "Tabki Tara",
                "Takware"
            ],
            "Suru": [
                "Bakuwai",
                "Daniya",
                "Ginga",
                "Gwafadi",
                "Hore",
                "Kainiki",
                "Kaji",
                "Kawara",
                "Kwakware",
                "Maikari",
                "Nagwade",
                "Sangelu",
                "Shema",
                "Takalafiya",
                "Tanikwara",
                "Yarma",
                "Dakin Gari",
                "Aljannare",
                "Bandan",
                "Barbarajo",
                "Bendu",
                "D/Sari",
                "Fanasabo",
                "T/ Alhaji",
                "T/ Mummuni",
                "Tindifai",
                "Zakkuwa",
                "Giro",
                "Dandawa",
                "G/Taure",
                "Kwaifa",
                "Matankari"
            ],
            "Yauri": [
                "Gungun",
                "Baha",
                "Chulu",
                "Jigima",
                "Kyauru",
                "Ruwan Dorowa",
                "Tondi",
                "Yabo",
                "Zamare",
                "R/ Kuka",
                "T/ Maikaho",
                "Tungar Bindiga",
                "Yelwa"
            ],
            "Zuru": [
                "Domo",
                "Dongo",
                "Koga",
                "Maraban Dako",
                "Sanforo (Filin-Jirgi)",
                "Unguwan Gara",
                "Unguwan Joji",
                "Unguwan Kate Ubandawaki",
                "Unguwan Kwanchi Manga",
                "Unguwan Rimi",
                "Unguwan Zuttu",
                "Unguwar Bagna",
                "Unguwar Kobo",
                "Dabai",
                "Banto Wuya",
                "Barshi Gademe",
                "Bijizo",
                "Chiroma",
                "D'Benzo",
                "D'oh",
                "Dabai Same",
                "Dago",
                "Damba",
                "Gamji",
                "Gangara",
                "Garbadu",
                "Gatawa",
                "Gogadi",
                "Gommawa",
                "Gwaram",
                "Isgogo",
                "Jangebe",
                "Kagara",
                "Kahe",
                "Kalgo",
                "Kezge",
                "Klanko",
                "Kseva",
                "Kurawa",
                "Kwendo",
                "Lajinga",
                "Makuwana",
                "Manga",
                "Marai",
                "Matsgi",
                "Msune",
                "Rumu",
                "Ruwan Bore",
                "Ruwan Gizo",
                "Ruwan Gora",
                "Sabon Birni",
                "Sabon Garin Dabai",
                "Seam-Saune",
                "Senchi",
                "Sh/Galadima",
                "Sh/Kayaya",
                "Tara",
                "Ukau",
                "Ung. Lalle",
                "Ushe",
                "Zom-Zomo",
                "Isgogo/Dago",
                "Dago Gari",
                "Dago Karkari",
                "Idgobo",
                "Jambo",
                "Jondo Tuta",
                "Kdumti",
                "Komi Semna",
                "Riatu",
                "Semchlali",
                "Semgongo",
                "Tota",
                "Uhu",
                "Unguwan Galadima",
                "Utmu",
                "Wheleta",
                "Yadi",
                "Zangina",
                "Manga Ushe",
                "Adkwnh",
                "Ahdgoga",
                "Domo Garu",
                "Dongo Manga",
                "Dorowa",
                "Elembelu",
                "Ghazi",
                "Knata",
                "Kogo",
                "Ma-essah",
                "Madugwa",
                "Mogoro",
                "Rio",
                "Sembren Manga",
                "Udun Kudu",
                "Unguwan Raku",
                "Unguwan S/Usara",
                "Unguwan S/Ushe",
                "Usi",
                "WH-Kwebe",
                "Rafin Zuru",
                "Bakin Kasuwa",
                "Denkre",
                "Doga",
                "Hedengen",
                "Jarkasa",
                "K'bancho",
                "Passo",
                "Rimi",
                "Sarku",
                "Semch Loli",
                "Somdoro",
                "Tashar Rimi",
                "Rikoto",
                "Bakin Tsauni",
                "Galadima",
                "Mangori",
                "Rikoto Fada",
                "Sabon Garin Rikoto",
                "Sabon Tasha",
                "Tudun Wada",
                "Unguwan Doro",
                "Unguwan Henso",
                "Unguwan Nagoro",
                "Unguwan Yan Biyu"
            ]
        }
    },
    {
        "Kogi": {
            "Adavi": [
                "Abagiri",
                "Adabi",
                "Adabunoze",
                "Adademe",
                "Adonukoko",
                "Adu",
                "Akobobe",
                "Aku",
                "Anyoke",
                "Anyoke Enyomo",
                "Atami",
                "Ateba",
                "Eba",
                "Ebenitutu",
                "Ebogogo",
                "Edegu",
                "Ege",
                "Elika-Ohuzeyin",
                "Etuta",
                "Idaboniyero",
                "Idakura",
                "Idare Karaworo",
                "Idato",
                "Idatochi",
                "Idkoyivo",
                "Igira",
                "Inagoncho",
                "Inechs",
                "Inumopa",
                "Ipaka Uvete",
                "Irepeni",
                "Iresuhua",
                "Irewagere",
                "Ireyietune",
                "Iriku-Obege",
                "Iriku-Ochakoro",
                "Irikura",
                "Irivoba",
                "Irivuyami",
                "Iruuochionami",
                "Karaworo",
                "Nagazi-Uvere",
                "Ngazi-Eba",
                "Obomobomi",
                "Ogaminama",
                "Ohuaguva",
                "Ojobara",
                "Okua Obanyi",
                "Okunchi",
                "Okuroko",
                "Omu",
                "Oniyeka",
                "Osara",
                "Oshoma",
                "Osisi",
                "Osuoza",
                "Ovakida",
                "Ozikutu",
                "Ozurui",
                "Ubogi",
                "Uboroko",
                "Uhucheba",
                "Uhuodo",
                "Umuakoro",
                "Uro",
                "Utoro",
                "Zariagi",
                "Zongo",
                "Zongodaji"
            ],
            "Ajaokuta": [
                "Ajaokuta",
                "Abedu",
                "Abodudu",
                "Achimopa",
                "Adege",
                "Adegu",
                "Adogu",
                "Anogi",
                "Badoke",
                "Bagana",
                "Bataga",
                "Egede",
                "Gaduma",
                "Ganaja",
                "Garegu",
                "Ichmwa",
                "Idibo",
                "Idire",
                "Inara",
                "Kporoko",
                "Obangede",
                "Ochebanyi",
                "Ochimile",
                "Odenu",
                "Odire",
                "Ogare",
                "Ogirigiri",
                "Ogodo",
                "Ogunmagu",
                "Ohunene",
                "Onado",
                "Onyekumi",
                "Oruge",
                "Owuni",
                "Patesi",
                "Shagana",
                "Ukpaja",
                "Ukpki",
                "Unesi",
                "Ebiya",
                "Ademe",
                "Agarugu",
                "Ajagu",
                "Apanke",
                "Epiri",
                "Iriku Agiga",
                "Iyasa",
                "Ohuns",
                "Okhebanyi",
                "Ubatoto",
                "Ubegiri",
                "Egayin",
                "Achagana",
                "Adogo",
                "Iloshi",
                "Irunisechi"
            ],
            "Ankpa": [
                "Ankpa",
                "Abache",
                "Abo",
                "Acherane",
                "Adde",
                "Aguma",
                "Aka",
                "Akwu",
                "Atuma",
                "Biraidu",
                "Ebakpoti",
                "Ede",
                "Efiwo",
                "Egbeche",
                "Ejegbo",
                "Ejinya-Abakpa",
                "Ejinya-Efoje",
                "Emanyi",
                "Emedo",
                "Emekutu",
                "Emere",
                "Enale",
                "Enekpoli",
                "Igbahala",
                "Igocha",
                "Ikanekpo",
                "Ikebe",
                "Imane",
                "Lagos-Ochi",
                "Ochi-Ofago",
                "Ochinobi",
                "Oda",
                "Ofagele",
                "Ofanwa",
                "Ogaji",
                "Ogbagede",
                "Ogbaloto",
                "Ogbopiala",
                "Ogodo",
                "Ojapata",
                "Ojede",
                "Ojelanyi",
                "Ojogobi",
                "Ojokodo",
                "Ojuwo I",
                "Ojuwo II",
                "Okatikpe",
                "Okeke-Ohia",
                "Okenyi",
                "Okolo",
                "Omogu",
                "Otoaikuru",
                "Ubele",
                "Uboji",
                "Ubokpo",
                "Uferene",
                "Enjema",
                "Acharane",
                "Achele",
                "Afogamgam",
                "Agbeneba",
                "Agwumagwu",
                "Ajiata",
                "Ajitata-Ofobobo",
                "Akpanaji",
                "Alade-Ika-Efofe",
                "Alufele",
                "Alume",
                "Aluro-Ogbowa",
                "Awulu",
                "Efiga-Ofangba",
                "Efu-Ichala",
                "Egboje",
                "Emabu",
                "Enabo",
                "Enegbebe",
                "Eti-Aor",
                "Gota",
                "Gwoche",
                "Ika",
                "Ika-Ajeigbo",
                "Ilori",
                "Imanejo",
                "Inye",
                "Lokoja",
                "Lokoja No 1",
                "Lokoja No 11",
                "Ocha-Agala",
                "Ochekwu-Agojeju",
                "Odagba",
                "Ode-Etor",
                "Odobi",
                "Odokpono",
                "Oforda Okolo",
                "Ofugo",
                "Ogbdobono",
                "Ogboyaga",
                "Ogedeagekpe",
                "Ogo-Ekpo",
                "Ojakpala",
                "Ojate-Ejiga",
                "Ojeke",
                "Ojiuwo",
                "Ojo-Ekpeje",
                "Oju-Odele",
                "Oju-Odeli",
                "Okobo",
                "Okpiko",
                "Olufofo",
                "Ukpolobia",
                "Ojoku",
                "Agbodo",
                "Ajobe",
                "Akatanpia",
                "Akunu",
                "Awo-Agwugwuda",
                "Awo-Akpali",
                "Awo-Anekpa",
                "Awo-Etikwo",
                "Awo-Garage",
                "Awo-Ojuwo",
                "Bagele",
                "Enjem",
                "Eteda-Okaba",
                "Icheke",
                "Iyologu",
                "Obaka",
                "Odogomu",
                "Ofa-Anu",
                "Ofokume",
                "Ogbagbala",
                "Ojeje",
                "Ojuwo",
                "Okwo-Idoko",
                "Utala"
            ],
            "Bassa": [
                "Ahutara",
                "Amara",
                "Antara",
                "Ibiroko",
                "Ibozogi",
                "Kpari",
                "Kpari-Gumi",
                "Kpokpo",
                "Ogbazanyi",
                "Ogbenka",
                "Ogbonka",
                "Okanga",
                "Onyebu",
                "Ozugbo",
                "Zegu",
                "Zube",
                "Akakana",
                "Akishamishi",
                "Akpaku",
                "Ayede",
                "Benebi",
                "Butu",
                "Changudu",
                "Duru",
                "Ebeje",
                "Edigoshi",
                "Gbudugbudu",
                "Gobiji",
                "Idare-Jegwere",
                "Imora",
                "Inigu-Tamarhi",
                "Inigwu-Romo",
                "Irigu-Omono",
                "Iyede",
                "Jegwere-Odule",
                "Kipi",
                "Kpeper-Buba",
                "Kpepere",
                "Maza",
                "Nyimo",
                "Paperi",
                "Rioume",
                "Usaman",
                "Zavkama",
                "Akubasisi",
                "Baki",
                "Dipengewu",
                "Esule",
                "Gbechi",
                "Gbedikere",
                "Gbegbereji",
                "Kwokwoshi",
                "Landu",
                "Oguma",
                "Sheria",
                "Shushare",
                "Suli",
                "Amo",
                "Janji",
                "Kadamo",
                "Kamare",
                "Kasuru",
                "Katako",
                "Kawam",
                "Kihang",
                "Lalang",
                "Lishin",
                "Majaja",
                "Buhit",
                "Assak",
                "Jebbu-Bassa",
                "Kisallol",
                "Kisayip",
                "Unit",
                "Buji",
                "Gurum",
                "Hwol Buji",
                "Jere",
                "Mista-Ali",
                "Runfan Gomna",
                "Sapai",
                "Tariya",
                "Eforo",
                "Agbadakodo",
                "Akotokum",
                "Amewa",
                "Dedebaji",
                "Efere",
                "Egbo",
                "Eroko",
                "Egene",
                "Egeneja",
                "Woje",
                "Emi-Ajoto",
                "Emi-Amdi",
                "Em-Agatu",
                "Emi-Abme",
                "Emi-Awale",
                "Atte",
                "Emi-Bojule",
                "Gbagbalagba",
                "Koji",
                "Kwebi",
                "Tekumene",
                "Togunye",
                "Weobi",
                "Gboloko",
                "Adum-Woiwo",
                "Agaida",
                "Agedegi",
                "Alaem",
                "Amdi",
                "Amonoku",
                "Astagba",
                "Effin",
                "Ekido",
                "Emi-Alemaka",
                "Emi-Andrew",
                "Emi-Dale",
                "Emi-Tsado",
                "Gendi",
                "Nyankpo",
                "Olowa",
                "Tekete",
                "Agabitsu",
                "Emi-guni",
                "Akabe",
                "Emi-Boci",
                "Ikende",
                "Ahalangayi",
                "Akakana-Meru",
                "Akapakude",
                "Akpakudu",
                "Arugbo",
                "Ayebua-Kubiri",
                "Bishu",
                "Chilheteye",
                "Cruori",
                "Elegeji",
                "Gbam",
                "Gbende",
                "Ipegu",
                "Iyade",
                "Jato",
                "Kwalamabana",
                "Moragu",
                "Ngenbu",
                "Nupe",
                "Odogba",
                "Odule",
                "Ohaifo",
                "Ojuwo",
                "Paruwa",
                "Swegene",
                "Ukeje",
                "Wanwa",
                "Zenyi",
                "Bakin Kogi",
                "Fuskan Mata",
                "Jengre",
                "Kaiyaka",
                "Kalambai",
                "Katare",
                "P/Shamu",
                "Rimi",
                "Sarkishau",
                "Zabollo",
                "Zallaki",
                "Kakkek",
                "Igbak",
                "Zagun",
                "Kishika",
                "Binchi",
                "Binibob",
                "Kikala",
                "Kishi(I)",
                "Kpala",
                "Ajigidi",
                "Akobo",
                "Atakpa",
                "Bidaji",
                "Echewu",
                "Eketa",
                "Gande",
                "Gbobe",
                "Kpata",
                "Kpatakpale",
                "Shintaku",
                "Shitte",
                "Kwall",
                "Gabia",
                "Kimakpa",
                "Kpasho",
                "Nunhwie",
                "Zarama",
                "Zodu",
                "Mafara",
                "Bomo",
                "Rumfan",
                "Tige",
                "Miango",
                "Daro",
                "Jebbu Miango",
                "Jebu",
                "Ketago",
                "Ta agba",
                "Tahu",
                "Zobwo",
                "Mozum",
                "Adinbeku",
                "Edikeyi",
                "Ehurama",
                "Kabawa",
                "Lundu",
                "Mozu",
                "Mozum-Waterside",
                "Odogbo",
                "Ogba",
                "Oger",
                "Odeyyi",
                "Agodo",
                "Biyabo",
                "Chipu",
                "Dikwo",
                "Eshikwu",
                "Gbogbolibo",
                "Kara",
                "Kebe",
                "Kerike",
                "Kpekpere",
                "Odenyi",
                "Odugbo",
                "Odulu",
                "Ohete",
                "Okudugu",
                "Onyoji",
                "Orekwe",
                "Shemeje",
                "Ujaw",
                "Uwapa-Wete",
                "Ozonogulo",
                "Awana",
                "Biyitwa",
                "Daji",
                "Gagba",
                "Gbero",
                "Karikwo",
                "Kpanche",
                "Orekwo",
                "Uzhibu-Jimaza"
            ],
            "Dekina": [
                "Birdu",
                "Abocho",
                "Achigili",
                "Adiele",
                "Adoji",
                "Adoma",
                "Adum",
                "Agada",
                "Agbajo",
                "Agidibai",
                "Agojeju",
                "Ahojori",
                "Aje-Kelega",
                "Ajebido",
                "Ajegwuna",
                "Ajieru",
                "Ajijeina",
                "Ajochidi",
                "Ajogwoni",
                "Ajomachi",
                "Ajonu-Ota",
                "Akpameta",
                "Akpobi",
                "Angwa",
                "Araba",
                "Atenokpe",
                "Ayanka",
                "Efikelegwu",
                "Egbile-Ugani",
                "Egomeha",
                "Elika",
                "Emewe",
                "Emewe-Efopa",
                "Gbokoluba",
                "Ibolo",
                "Igbadim",
                "Kefi",
                "Lokp",
                "Ogbogbo",
                "Ojogba",
                "Ojukpo",
                "Okwolo",
                "Opada",
                "Uchaikpele",
                "Dekina",
                "Adoloko",
                "Agbada",
                "Agbeji",
                "Ajada",
                "Ajediomku",
                "Ajiolo",
                "Ajuchaja",
                "Akpelu",
                "Akure",
                "Alioko",
                "Aliolo",
                "Anama",
                "Asbado",
                "Ate-Uge",
                "Ebeje",
                "Egudi",
                "Eturekpe",
                "Ireko",
                "Itaima",
                "Iyale",
                "Jeri",
                "Ochele",
                "Odolu",
                "Odu",
                "Odu Okpakili",
                "Odu-Ofomu",
                "Odu-Ogboyaga",
                "Oduate",
                "Ofomu",
                "Ofugo",
                "Ofujiji",
                "Ogaloto",
                "Ogene-Enigu",
                "Ojiakala",
                "Ojuakala",
                "Ojuapata",
                "Ojuwo",
                "Okete",
                "Okpakili",
                "Okpeyegede",
                "Ologba",
                "Onukpo",
                "Songhai",
                "Tandoma",
                "Ugbabo",
                "Uje",
                "Ulaja",
                "Okura Egume",
                "Abejukolo",
                "Acharu",
                "Adumu",
                "Agala",
                "Ajagum",
                "Ajugwumu",
                "Alade",
                "Aligi-Ado",
                "Ameka",
                "Ayangba",
                "Chikoro",
                "Egbole",
                "Egume",
                "Elubi",
                "Iga",
                "Ijoji",
                "Itama",
                "Lafia",
                "Lakwi",
                "Ochaja",
                "Ochaji",
                "Ofakaga",
                "Ofalikpa",
                "Ofanwa",
                "Ofawuna",
                "Ofejiji",
                "Ofiugo",
                "Ogbogodo",
                "Ojikpadala",
                "Okura-Lafia",
                "Okura-Sawmi II",
                "Okure-Egume",
                "Ola",
                "Olaji",
                "Olowa",
                "Onichaigo",
                "Onugba",
                "Owolowo",
                "Sanioko",
                "Tuani-Oko"
            ],
            "Ibaji": [
                "Onyedge",
                "Adgwu",
                "Ajankoje",
                "Ajitata",
                "Ajmukoje",
                "Akene",
                "Akinia",
                "Akpalobe",
                "Akpanya",
                "Akpiola",
                "Akura",
                "Alakwa",
                "Alogwu",
                "Amabo",
                "Ani-Ocha",
                "Aniocha II",
                "Arrugo",
                "Aya",
                "Echango",
                "Echeno",
                "Efe",
                "Ejule",
                "Ete",
                "Ibaji",
                "Ibaoko",
                "Ika",
                "Ikenye",
                "Ikola",
                "Ikpogwu",
                "Ikpoloko",
                "Inene",
                "Iteti",
                "Iyano",
                "Nokwa",
                "Obale",
                "Obele",
                "Odakupu",
                "Odeke",
                "Odomomo",
                "Ofanwa",
                "Ofronla",
                "Ogbagwu",
                "Ogwu",
                "Ojila",
                "Ojueja",
                "Okapanaji",
                "Okwuonoko",
                "Olla",
                "Oluknodu",
                "Onuabo",
                "Onyedega",
                "Orofuanefe",
                "Ugbugbo",
                "Ugwata",
                "Ujeh",
                "Unale",
                "Odolu",
                "Ayeke",
                "Enweli"
            ],
            "Idah": [
                "Idah",
                "Abujaga",
                "Agalugbaje",
                "Akpo",
                "Akuta",
                "Alade",
                "Aladgbajadu",
                "Alakome",
                "Alimoke",
                "Alla-Okweje",
                "Angwajuma",
                "Chekene",
                "Ede",
                "Ede-Adejoh",
                "Edeke",
                "Efuh",
                "Ejofe",
                "Ekwokata",
                "Etoba",
                "Ichala",
                "Ichijenu",
                "Idoma",
                "Ijobe",
                "Inene",
                "Kaka",
                "Lafi",
                "Nwajala",
                "Obajadaka",
                "Ochijenu",
                "Odobu",
                "Odogu",
                "Offa",
                "Ofugo",
                "Ogaine",
                "Ogba-Dichi",
                "Ogwojibo",
                "Ohiji",
                "Ojebe",
                "Ojibgo",
                "Ojigagala",
                "Ojuba",
                "Okeku",
                "Okele-Agaldoko",
                "Okele-Ocheje",
                "Okele-Ohinem",
                "Olaji",
                "Onah",
                "Onugwa",
                "Onyemu",
                "Ota",
                "Ugwoda",
                "Ukwaga"
            ],
            "Igalamela-Odolu": [
                "Adoru",
                "Aduku",
                "Agbamofa",
                "Agbokete",
                "Agboni",
                "Agejojo",
                "Ajiongu",
                "Ajonuche-Oko",
                "Alaba",
                "Alakwa",
                "Amejekpo",
                "Ameke",
                "Aneke",
                "Apata",
                "Arefe",
                "Ata",
                "Ayi-Kpele",
                "Ekpotoko",
                "Emuchi",
                "Epete",
                "Eti-Akpacha",
                "Ibochi",
                "Igbope Okealuju",
                "Ikare",
                "Ikare-Ojefu",
                "Imere",
                "Obolimi",
                "Ocheja",
                "Ofakpa",
                "Ofe-Anwa",
                "Ofejiji",
                "Off",
                "Oforachi",
                "Ogaji-Gwu",
                "Ogane-offu",
                "Ogbaligbo",
                "Ogbe-Adige",
                "Ogbogbo",
                "Ogbolimi",
                "Ojajuna",
                "Ojete",
                "Ojodoma",
                "Ojokuta",
                "Oko-Oma",
                "Okpabioko",
                "Okpe",
                "Opada",
                "Otobo-Adogulu",
                "Ugbatugba",
                "Abolinyagayaga",
                "Achiokpa",
                "Agamaka",
                "Aguroko",
                "Ajodanwu",
                "Akinie",
                "Akuba",
                "Alade",
                "Anambra",
                "Angba",
                "Atanegume",
                "Buga",
                "Eche-Aba",
                "Eji-Elanyi",
                "Eke-Aminenga",
                "Emachi",
                "Eto Alkura",
                "Ihiame",
                "Ikpokawo",
                "Iyegu",
                "Ofobu",
                "Ofodo",
                "Ofokpiye",
                "Ogbololi",
                "Ogbomucha",
                "Ogbotobo",
                "Ogobogbo",
                "Ogwomichi",
                "Oji Omaji",
                "Ojodu",
                "Ojuwo",
                "Okagbo",
                "Okaimili",
                "Okeku",
                "Oko-Agwu",
                "Oko-Ikere",
                "Okobu",
                "Okoma",
                "Okula-Ameji",
                "Olefu-Oko-Tikpa",
                "Olichekpe",
                "Otochi",
                "Ugbedomagu",
                "Ukpekpele",
                "Uro-Agada",
                "Urodu",
                "Utoro",
                "Uwowo",
                "Ofulko",
                "Ajire",
                "Ala-Akabe",
                "Ala-Ogboyaga",
                "Ala-Okpoga",
                "Egbahieme",
                "Etutu",
                "Ikpudu-Kaji",
                "Iyogbo",
                "Obaloko",
                "Ofuloko",
                "Ogbajele",
                "Ogoji",
                "Ojuro-Afu",
                "Okenya",
                "Okopolo",
                "Okpachala",
                "Okpakpata",
                "Okpo",
                "Okpo-Iyoloko",
                "Okpocti-Aja",
                "Okuta-Eluhe",
                "Orunu",
                "Ujagba",
                "Ukpologu"
            ],
            "Ijumu": [
                "Ijumu",
                "Aduge",
                "Agirigbon-Oke",
                "Aiyegunle-Gbede",
                "Aiyetoro-Gbede",
                "Aiyere Ayere",
                "Araromi-Gbede",
                "Arima",
                "Ayeh-Gbede",
                "Egbeda Egga",
                "Egbedsyere-",
                "Ekinrin Adde",
                "Iffe",
                "Iffe Tedo",
                "Ifihafom",
                "Igbolsyere-",
                "Igbopin-Okeouju",
                "Igo-Igere",
                "Ikoyi",
                "Iluagba",
                "Iyah-Gbede",
                "Iyamoye",
                "Iyara",
                "Kakuma",
                "Odokoro-Gbede",
                "Ogale-Ayede",
                "Ogale-Idi-Oro",
                "Ogidi",
                "Okejumu",
                "Okoro-Gbede",
                "Origa",
                "Oton-Ade",
                "Otungba"
            ],
            "Kaba/Bunu": [
                "Bunu",
                "Aberin",
                "Aduratedo",
                "Afotu",
                "Agbadu",
                "Agbede",
                "Aghara",
                "Aherin",
                "Aiyegunle",
                "Aiyetoro Kiri",
                "Akutupa",
                "Apaa",
                "Are",
                "Asuta",
                "Ayede Apa",
                "Edumo",
                "Eshin",
                "Guguruji",
                "Idoyi",
                "Igbo",
                "Igha",
                "Ighun",
                "Igori",
                "Ike",
                "Ila",
                "Ilogun",
                "Iluke",
                "Jeunro",
                "Lesi",
                "Monodu",
                "Odo-Akete",
                "Odo-Ape",
                "Odogbo",
                "Ofere",
                "Oke",
                "Oke Bukun",
                "Oke-Offin",
                "Oshomu Lekiri",
                "Shado",
                "Suku",
                "Taki",
                "Tata",
                "Kabba",
                "Adesuwa",
                "Aiyede Igunse",
                "Aiyedun",
                "Ayangan",
                "Ebeleko",
                "Egbeda",
                "Egunse",
                "Idde",
                "Iyan",
                "Kakun",
                "Obele",
                "Odo-Bata",
                "Ogbagbe",
                "Ohekiti",
                "Oke-Bata",
                "Okedayo",
                "Otun"
            ],
            "Kogi": [
                "Koton Karifi",
                "Abuse Bassa",
                "Achabo",
                "Acheni",
                "Adaba",
                "Adabode",
                "Adagima",
                "Adama",
                "Adamuro-Bassa",
                "Adanya",
                "Adigi-Gwari",
                "Adiho",
                "Adinjere",
                "Adohu",
                "Adoki",
                "Afanya Bassa",
                "Afoto Giwa",
                "Agaboshi Gwari",
                "Agaga",
                "Agbarionya",
                "Agyara",
                "Ahoko",
                "Aiyara-Gbanagana",
                "Ajanagu",
                "Ajita Bassa",
                "Akabu",
                "Akabu-Anuuya",
                "Akori Bassa",
                "Akpabi",
                "Akpaku",
                "Akpara",
                "Akpasu",
                "Akpo",
                "Akpogu",
                "Akpori Bassa",
                "Akyara Bassa",
                "Alagba",
                "Allah",
                "Amoko",
                "Anegbaki",
                "Aniura",
                "Apashi",
                "Araaba Arakpo",
                "Arawe",
                "Aseni",
                "Ashishi",
                "Ataki",
                "Balu Akure",
                "Bassa",
                "Behu",
                "Bibiroko",
                "Bigitita Bassa",
                "Birigo Bassa",
                "Bishiwo",
                "Bitizuba Bassa",
                "Bori-Bassa",
                "Chakaruku",
                "Chigbeche Bisa",
                "Chikara",
                "Dagbogua",
                "Dangare",
                "Deneku-Bassa",
                "Dillo Ashina",
                "Dillo-Bassa",
                "Dogbo",
                "Duduku-Bassa",
                "Dugbeji",
                "Ebeje",
                "Ebimikpo",
                "Edeha",
                "Ekpegi",
                "Ekpurka",
                "Enyikabu",
                "Ereyi",
                "Eshikabu",
                "Eshikaku",
                "Ete",
                "Fereke",
                "Gabo Nyenyi",
                "Gainabi",
                "Ganagedo",
                "Gbagede",
                "Gbange",
                "Gbarada Bassa",
                "Gbarake Bassa",
                "Gbaramu-Bassa",
                "Gbendu",
                "Gbodege",
                "Gbodogo",
                "Gbogboro",
                "Gbogu-Bassa",
                "Gbugbudu",
                "Geba Bassa",
                "Gegu-Beki",
                "Ginirnya",
                "Gitata",
                "Gozaki",
                "Gujuro-Afuta",
                "Gumbo",
                "Guraro Bukwai",
                "Ibbe Gwari",
                "Idu Igbira",
                "Iganuma",
                "Igbogo Bassa",
                "Igeneku Bassa",
                "Ikumo",
                "Irada",
                "Iraki",
                "Irako",
                "Ironodu",
                "Izene",
                "Kaibe",
                "Kallo",
                "Karagba",
                "Karitata",
                "Kasuwa",
                "Kekere",
                "Kime Bassa",
                "Kitikpomi-Bassa",
                "Kokoshi",
                "Koton-Karfe",
                "Kpabkanki Bassa",
                "Kpakpara Gakiya",
                "Kpakpazi",
                "Kpariku",
                "Kpataku",
                "Kpokpplobi Bassa",
                "Ktakariku-Gwari",
                "Kwakwa Goro",
                "Kwelu",
                "Kworaki",
                "Kyanu Bassa",
                "Lapai Bassa",
                "Lasaniya",
                "Logoji Gogo",
                "Madalla Gwari",
                "Maiwa bassa",
                "Makeru",
                "Makpa",
                "Makpa Aubiriki",
                "Mangoro Bassa",
                "Manko Bassa",
                "Merere Bassa",
                "Mozu-Ete",
                "Napoko",
                "Narawanti",
                "Noge",
                "Nohi Gwari",
                "Numai",
                "Nyaba",
                "Obaye Ubbo",
                "Obobo",
                "Odake",
                "Odama",
                "Odanyi Igbira",
                "Odda",
                "Odugba",
                "Ofoko",
                "Ogase",
                "Ohimigusa",
                "Ohimozi Bassa",
                "Ohokanga",
                "Ohwehuru Bassa",
                "Ohwehuru Nupe",
                "Oji",
                "Okele",
                "Okofi",
                "Okpaka",
                "Okparake",
                "Okporudu Okppzogi",
                "Oleyangana Igbira",
                "Omani",
                "Omoke",
                "Onbu",
                "Onzo",
                "Orehi",
                "Osakpa-Igbira",
                "Osoku-Agbira",
                "Osppridu",
                "Osuku",
                "Ozagi",
                "Ozahi",
                "Ozugbe",
                "Pand Gbara",
                "Poku",
                "Rambo Bassa",
                "Regbeta",
                "Rekabeba Bassa",
                "Riyiya Ganagana",
                "Robomi",
                "Rokpokpo-Gufaci",
                "Sabo-Gwari",
                "Samariga",
                "Sansanyi",
                "Sanunariyaa",
                "Sasiri Bassa",
                "Senseni",
                "Seregyanama Bassa",
                "Shagaya",
                "Shedema",
                "Shiden Bassa",
                "Shikaku",
                "Shimbabeji-Bassa",
                "Sulumanyi Bassa",
                "Taluwa Gwari",
                "Tanabu",
                "Tawari",
                "Tazenyi Igbira",
                "Tege",
                "Tenege",
                "Tototo Bassa",
                "Toyi Gufaci",
                "Tundun Wada",
                "Tungan anamu",
                "Tusa Bassa",
                "Ubbe Bassa",
                "Ugwe",
                "Uhana",
                "Ukwo",
                "Umanyare",
                "Unwari",
                "Usodomi",
                "Uwa",
                "Werewere",
                "Yelwa",
                "Yinakoro Bassa",
                "Zagana",
                "Zarumai"
            ],
            "Lokoja": [
                "Kakanda",
                "Abezumwa",
                "Apata",
                "Arah",
                "Ashe",
                "Budon",
                "Buge",
                "Doji",
                "Eddo",
                "Ere",
                "Kompale",
                "Nambata",
                "Old Budon",
                "Taji Bakin",
                "Taji Chado",
                "Taji Gberuko",
                "Taji Kaji",
                "Taraba",
                "Tungangiwa",
                "Kupa",
                "Abugi",
                "Agini",
                "Angbapu",
                "Arakpo",
                "Awumi",
                "Bagi",
                "Balagun",
                "Batake",
                "Bataku",
                "Bughi",
                "Dekugi",
                "Eban",
                "Eban Kaci",
                "Ebo",
                "Egba",
                "Eggan",
                "Ekan",
                "Elagi",
                "Fikara",
                "Gbaci",
                "Gbebu",
                "Gbedumagi",
                "Giri",
                "Gugurugi",
                "Gunji-Twa-Aki",
                "Gwachi",
                "Igban",
                "Kapu",
                "Kayinlo",
                "Kinami",
                "Koci",
                "Kpaji",
                "Kpapa",
                "Kpoku",
                "Kugbagi",
                "Kumi",
                "Lagan",
                "Lantsara",
                "Lusuta",
                "Majogun",
                "Mami",
                "Migegi",
                "Mikugi",
                "Miza",
                "Mobo",
                "Rambayi",
                "Sampi",
                "Sunawa",
                "Vaji",
                "Yaro",
                "Yekaraji",
                "Yinkara",
                "Lokoja Rural",
                "Adankolo",
                "Ahubana",
                "Lokon-Goma",
                "Meme-Bridge",
                "Sarkin-Noma",
                "Oworo",
                "Adogbe",
                "Agbodo",
                "Agboja",
                "Akorilo",
                "Akpami Oba",
                "Akpangbe",
                "Akpata",
                "Akpayan",
                "Aledu",
                "Ayinoke",
                "Banda",
                "Choko-Choko",
                "Ehinkin",
                "Emda",
                "Emu",
                "Felele",
                "Gbaude",
                "Gbogbaribo",
                "Ibaru",
                "Idoshe",
                "Igbolu",
                "Igbonla Odo",
                "Igiahako",
                "Ihiji",
                "Ihin",
                "Iwa",
                "Jakura",
                "Jamata",
                "Jiffo",
                "Karara",
                "Kugbani",
                "Kuroko",
                "Lolo",
                "Mawo",
                "Obajana",
                "Odogbagba",
                "Odohin",
                "Odonun",
                "Oduka",
                "Ogbagbon",
                "Ogbongboro",
                "Ogoti",
                "Ojoba",
                "Okegba",
                "Okeremi",
                "Oko Tare",
                "Okomba",
                "Okpabu",
                "Okpeko",
                "Oku Ale",
                "Omuwa",
                "Osasara",
                "Osewuru",
                "Osoho",
                "Otada",
                "Otube",
                "Otuga",
                "Oyo",
                "Tajimi",
                "Tunga",
                "Wara",
                "Yashi Keya",
                "Ynaduwa"
            ],
            "Ofu": [
                "Ugwo-Lawo",
                "Adikahane",
                "Ahi",
                "Aja-Kechi",
                "Ajoda",
                "Akpagidigbo",
                "Akpameta",
                "Akpodo",
                "Alijobo",
                "Aloji",
                "Ayeye",
                "Ebuyaji",
                "Idoma",
                "Igaojo",
                "Igebije",
                "Ijogo",
                "Ikagbo",
                "Ikalaba",
                "Ikpalaka",
                "Kukumaji",
                "Memerebo",
                "Obagada",
                "Obagwu",
                "Obubu",
                "Ochadamu",
                "Ofakaga",
                "Ofanwa",
                "Ofejiji",
                "Ofokapi",
                "Ofolijiawa",
                "Ofolikpa",
                "Oforachi",
                "Ogbagba",
                "Ogegume",
                "Ojedegbe",
                "Ojigba",
                "Ojodu",
                "Ojuwo",
                "Ojuwo-Omachi",
                "Ojuwolo",
                "Okabo",
                "Okpa",
                "Okpe",
                "Okpotume",
                "Olichekpe",
                "Olofu",
                "Olukudu",
                "Owalla",
                "Ude",
                "Ugbabo",
                "Ugwolawo",
                "Umoni",
                "Gwalawo",
                "IGALA",
                "Itobe",
                "Adebu",
                "Adumu",
                "Adumuje",
                "Agbenema",
                "Agula",
                "Ajango",
                "Ajegwu",
                "Ajo",
                "Akunuba",
                "Allo",
                "Arokpa",
                "Ataneguma",
                "Egbala",
                "Egonicha",
                "Emicheje",
                "Eyele",
                "Eyele II",
                "Ichapia",
                "Ofegede",
                "Ofoke",
                "Ofoyi",
                "Ogboyaga",
                "Ojimaji",
                "Ojoma",
                "Okogba",
                "Okokenyi",
                "Olokudu",
                "Opitechia",
                "Otebu",
                "Ubewo",
                "Ugbedu",
                "Ukpo",
                "Utagidi",
                "Ogwa",
                "Abejukolo",
                "Agojeju",
                "Agugu",
                "Akopo",
                "Akpopo",
                "Alahha",
                "Alaji",
                "Alla",
                "Alloma",
                "Alobi",
                "Alodo",
                "Alojura",
                "Aloko",
                "Aloma",
                "Amuna",
                "Igwu",
                "Aneke",
                "Boko",
                "Efaku",
                "Egbagbenebe",
                "Egube",
                "Ejukulu",
                "Ejule",
                "Erewa",
                "Iboko",
                "Igalaogwa",
                "Ijabe",
                "Imagba",
                "Inekpe",
                "Laia-Ogugu",
                "Lokoja",
                "Obedomagu",
                "Ochadegbe",
                "Ofante Omojo",
                "Ofanti-Ojone",
                "Offabo",
                "Ofogu",
                "Ogbagebe",
                "Ogbulu",
                "Ogene-Zaria",
                "Ogonicha",
                "Ojo",
                "Okagu",
                "Okele",
                "Okotete",
                "Okpadodo",
                "Okura",
                "Okura-Ogwalala",
                "Omodeda",
                "Onicha-Igo",
                "Ugbamaka",
                "Ugbokonoko",
                "Uleja"
            ],
            "Ogori/Mangongo": [
                "Ogori/Magongo",
                "Afuku",
                "Aiyeromi",
                "Akonoboro",
                "Amuguru",
                "Apata",
                "Arawu",
                "Arere",
                "Ayetoro",
                "Efan",
                "Eke",
                "Eku",
                "Eku Daudu",
                "Eku Oba",
                "Emayin",
                "Eni",
                "Eni-Odan",
                "Ibee",
                "Ichede",
                "Iken",
                "Ileteju",
                "Mangongo",
                "Obatigben",
                "Obinoyin",
                "Ogbekete",
                "Ogburu",
                "Ogori",
                "Ojubedi",
                "Okesi",
                "Oku",
                "Omoda",
                "Onumeba",
                "Opakeru",
                "Oshegbenene",
                "Oshobane",
                "Osobolo",
                "Oturu",
                "Oyinowo",
                "Udadegun",
                "Ude",
                "Ugbundun",
                "Ugudun",
                "Ugugu"
            ],
            "Okehi": [
                "Ihima",
                "Adedoyika",
                "Ahogede",
                "Akene",
                "Apamba",
                "Arawa",
                "Ebako",
                "Ebako Uvete",
                "Ebokechi",
                "Ebozohu",
                "Engwuhehe",
                "Enyahevu",
                "Epaka",
                "Ewuru",
                "Ichameba",
                "Ichamete",
                "Ichenya",
                "Ichoko",
                "Idarere",
                "Ideziadobe",
                "Idieziakuta",
                "Idihiete",
                "Idohazi",
                "Ihuadu",
                "Ijiwu",
                "Ikinato",
                "Ikuehi",
                "Inareba",
                "Inaruvete",
                "Inata",
                "Inuji",
                "Irikuta",
                "Irivo",
                "Irivogo",
                "Irivusechi",
                "Itakata",
                "Itutueba",
                "Obeiba",
                "Oboroke Eba",
                "Oboroke-Uvete",
                "Obuburu",
                "Odaire",
                "Odosi",
                "Ogbeigba",
                "Ogidi New Layout",
                "Ohueta Eba",
                "Ohuete Uvete",
                "Okahachi",
                "Okunya",
                "Onyamina",
                "Opopocho",
                "Oride",
                "Oride Uvete",
                "Oruwhene",
                "Osikoyi",
                "Osikoyi Eba",
                "Otutueba",
                "Ozuvete",
                "Udioyivo",
                "Ugba",
                "Uhwa",
                "Ukako",
                "Ukowa",
                "Umenezi",
                "Uto Ruku",
                "Utobobo"
            ],
            "Okene": [
                "Okene",
                "Acheze",
                "Adegu",
                "Agama",
                "Agasa",
                "Agimi",
                "Bariki",
                "Denku",
                "Emene",
                "Ide",
                "Idoji",
                "Inanup",
                "Inoziomi",
                "Inpyidara",
                "Irewagere",
                "Obassa",
                "Ochebanyi",
                "Ogud",
                "Ohiama",
                "Ohukede",
                "Oka",
                "Okengwen",
                "Okuhepochi",
                "Olu Odumi Otutu",
                "Onyukoko",
                "Orasie chinchi",
                "Orietosu",
                "Orijah",
                "Owere",
                "Udi-Arehu",
                "Udiegba",
                "Upege",
                "Upogoro",
                "Abuga",
                "Agere",
                "Agewa",
                "Ere",
                "Obehira-Egba",
                "Obenira-Bete",
                "Odenku",
                "Ozuja",
                "Ukpororo"
            ],
            "Olamaboro": [
                "Imani",
                "Abo",
                "Achipu",
                "Adamu-Uabo",
                "Afa Owobe",
                "Afenegoma",
                "Agaliga",
                "Agaliga-Efabo",
                "Ajitata",
                "Akpoli",
                "Akpoloko",
                "Alawu",
                "Amobia",
                "Amoke",
                "Barracks",
                "Ebuloko",
                "Ede",
                "Efachipu",
                "Efafo",
                "Efagbo",
                "Efaigele",
                "Efakpa",
                "Efekpe",
                "Efiwo",
                "Efofe",
                "Efoko",
                "Efoko-Igo",
                "Epunobi",
                "Epunoko",
                "Erode II",
                "Eroke I",
                "Etafo",
                "Eteke",
                "Etutekpe",
                "Idekpa",
                "Igabije",
                "Ikankweme",
                "Ikpechi",
                "Inele",
                "Inwa",
                "Iwilli",
                "Iyodo",
                "Mabenyi",
                "Ododa",
                "Oforo",
                "Ofudu",
                "Ogalobe",
                "Ogbodo",
                "Ogili",
                "Ojakpama",
                "Ojamagba Gbuduku",
                "Ojamayigbachu",
                "Ojamidoko-Ele",
                "Ojoche",
                "Ojodochai",
                "Ojoko",
                "Ojuwo",
                "Okolododo",
                "Okunene",
                "Omelewu",
                "Onogbo",
                "Orinago",
                "Ugbonoko",
                "Uloko",
                "Umgwa",
                "Utoje",
                "Ogodu",
                "Achagbe-Adum",
                "Adum-Afo",
                "Adupi-Afo",
                "Alokpo-Ikem",
                "Aludu",
                "Alugu-Emonoja",
                "Amaka",
                "Anyigba-Ogugu",
                "Ega-Orinono",
                "Ejule-Ofante",
                "Ekelekwu",
                "Emagaba No 1",
                "Emagaba No 2",
                "Emaka-Ofante",
                "Emakpe",
                "Emakpe-Uchola",
                "Emenega-Achadu",
                "Emonoji",
                "Emonyokwu",
                "Ikeke/Emagaba",
                "Ikekwu Emanoji",
                "Ikem",
                "Ileke",
                "Ofante",
                "Ofante Adum",
                "Ofante Cetre",
                "Ofode-Adum",
                "Ogbafu-Ileke",
                "Ogbodo-Adum",
                "Ogene",
                "Ogugu",
                "Okegbi",
                "Oko-Edi",
                "Orinono-Ogugu",
                "Unyi",
                "Unyi-Emodu",
                "Unyi-Ogene",
                "Okpo",
                "Abaeche-Iga",
                "Adamaku",
                "Ade",
                "Adumu",
                "Adumu Iga",
                "Agala",
                "Agbaduma",
                "Ago",
                "Agwodaba",
                "Ajikabu",
                "Akpagidigbo",
                "Akpakpa",
                "Alekwo",
                "Alukwo",
                "Amakpa",
                "Atenegoma",
                "Awodo",
                "Eboyi",
                "Efe-Oro",
                "Efekpe Ekpeyeno",
                "Efuofofo",
                "Enabo",
                "Eti-Ede-Ugaru",
                "Etiukwukoh",
                "Ibana",
                "Ibeli Ade",
                "Ichechele",
                "Iga-Eti Ukwo",
                "Iga-Ikeje",
                "Iga-Ocheba",
                "Iga-Ojuwo",
                "Iga-Ugbamaka",
                "Igoti",
                "Inale-Etieke",
                "Inele-Ugo",
                "Ite",
                "Obele",
                "Odeifo",
                "Odobu",
                "Ofenwa",
                "Offa",
                "Ofobobo-Okpo",
                "Ofogo",
                "Ogbagede",
                "Ogbe",
                "Ogboyaga",
                "Ogene-Iga",
                "Ogodo",
                "Ojamakogwu",
                "Ojamapaimn",
                "Ojamonogwu",
                "Ojuwo-Ochekwu",
                "Okpe",
                "Onugba",
                "Opu",
                "Otakpa",
                "Otakwuihi",
                "Otuapa",
                "Owosho",
                "Ubalu",
                "Uefodo",
                "Ugbogbo-Iga",
                "Ugbologidi",
                "Ugojo"
            ],
            "Omala": [
                "Abejukolo",
                "Ado",
                "Adoka",
                "Agbenema-Ife",
                "Agojeju-Odo",
                "Ajaja",
                "Ajibu",
                "Ajiyolo",
                "Akpacha",
                "Bagaji-Odfo",
                "Bagana",
                "Braidu",
                "Bukami",
                "Drisu-Village",
                "Ebiradu",
                "Echa",
                "Efiwo",
                "Ibado",
                "Iga",
                "Igaliwo",
                "Ihiame",
                "Ijali",
                "Ikeffi",
                "Ikpoba",
                "Iyade",
                "Jago",
                "Kaduna Ife",
                "Lato",
                "Majenuwe",
                "Obakume Aloko",
                "Obakume-Ojadebo",
                "Odamagu",
                "Odmukpor",
                "Odogba",
                "Ofejiji",
                "Ogadibo",
                "Ogba",
                "Ojadaga",
                "Ojadama-Ojadoma",
                "Ojaidu",
                "Ojaja",
                "Ojaji",
                "Ojawulu",
                "Ojedibo",
                "Ojejima",
                "Ojema",
                "Ojenebi",
                "Ojichekpa",
                "Ojogori",
                "Ojokpachi",
                "Ojomakoji",
                "Ojuwo",
                "Okpatala",
                "Oliya",
                "Omagede",
                "Opanda",
                "Ife",
                "Agbada",
                "Andemaja",
                "Efe",
                "Icheke-Odili",
                "Icheke-Ojego",
                "Icheke-Ojekewe",
                "Icheke-Ojocholi",
                "Icheke-Ojokpachi",
                "Ichela-Ogeme",
                "Ijoba",
                "Ogbonha",
                "Ogugudu",
                "Ojademi",
                "Ojochema",
                "Ojodoma",
                "Oko-Akwu",
                "Okwiko",
                "Okwugba",
                "Olechu",
                "Olokwu",
                "Oti",
                "Ogodu",
                "Abuja-Igaco",
                "Abuja-Ogodu",
                "Akpaha",
                "Allah",
                "Arku",
                "Atokuja",
                "Efekpe",
                "Igodo",
                "Ojeh",
                "Ojiaji",
                "Okaba",
                "Olla"
            ],
            "Yagba East": [
                "Yagba North-East",
                "Amuro",
                "Iddo",
                "Idofin",
                "Ijowa",
                "Ilafin",
                "Irunda",
                "Isanlu-Itedo",
                "Isanlu-Makutu",
                "Isanlu-Mopa",
                "Iye",
                "Lofin",
                "Odogbe",
                "Yagba South-East",
                "Agi",
                "Aginmi-Isale",
                "Aginmi-Oke",
                "Aiyede",
                "Aiyegunde-Oke",
                "Aiyegunle-Okeagi",
                "Alu",
                "Ejuku",
                "Ife-Olukotun",
                "Igbagun",
                "Igbo-Ero",
                "Ilai",
                "Imela",
                "Isao",
                "Jege",
                "Odo-Amu",
                "Ogbon",
                "Ohun",
                "Okeagi",
                "Oranre",
                "Panyan",
                "Takete-Isao"
            ],
            "Yagba West": [
                "West-Yagba",
                "Akata",
                "Assia",
                "Egbe",
                "Ejiba",
                "Iddo",
                "Igbaruku",
                "Isanlu Esa",
                "Iyamerin",
                "Odo-Ara",
                "Odo-Ere",
                "Odo-Eri",
                "Odosin",
                "Ogbe",
                "Ogga",
                "Oke-Ere",
                "Okoloke",
                "Okoto",
                "Okunran",
                "Omi"
            ]
        }
    },
    {
        "Kwara": {
            "Asa": [
                "Afon",
                "Abayawa",
                "Abeokuta",
                "Abidi Ore",
                "Abio",
                "Abokede",
                "Abote Alfa",
                "Aboto Afon",
                "Aboto Alfa",
                "Aboto-Oja",
                "Aboyi Ode",
                "Aboyi Olokole",
                "Abuyabirin",
                "Abuyanrin Abasi",
                "Abuyanrin Afa",
                "Adabata",
                "Adinimole",
                "Afeyi",
                "Afeyin",
                "Agboyi",
                "Agboyi Alagbade",
                "Agboyi Eleja",
                "Agboyi Idiope",
                "Ago-Oja",
                "Agoro",
                "Aho Alabe",
                "Aiekale (Odo-Ode)",
                "Airport",
                "Aiyede",
                "Aiyekale",
                "Aiyekale Olola",
                "Aiyetoro",
                "Ajagun",
                "Ajagunsi",
                "Ajara",
                "Ajegunle",
                "Ajelanwa",
                "Ajila",
                "Akara Kajola",
                "Akumadu",
                "Akumaju",
                "Alabata",
                "Aladere",
                "Aladere Alayo",
                "Alagbede",
                "Alagbon",
                "Alaja-Adigun",
                "Alaja-Aiyetoro",
                "Alapako Iju",
                "Alata",
                "Alatan",
                "Alawon",
                "Aleniboro",
                "Aleyo",
                "Aloba",
                "Alopako Etile",
                "Apa",
                "Apata",
                "Apata Aje",
                "Arogun",
                "Arowosaiye",
                "Arunde",
                "Asorope",
                "Awimose",
                "Bayi",
                "Bello Irra",
                "Budo Aagun",
                "Budo Abasi",
                "Budo Abogonbo",
                "Budo Abogun",
                "Budo Afa Ajadi",
                "Budo Aiku",
                "Budo Ajibade",
                "Budo Alagbe",
                "Budo Alagi",
                "Budo Alase",
                "Budo Alfa",
                "Budo Alfa Ajadi",
                "Budo Aro",
                "Budo Awero",
                "Budo Egba",
                "Budo Esin",
                "Budo Giwa",
                "Budo Igboto",
                "Budo Ilorin",
                "Budo Kankan",
                "Budo Koko",
                "Budo Lanro",
                "Budo Layemo",
                "Budo Nla",
                "Budo Ogun",
                "Budo Ojoku",
                "Budo Ojuku",
                "Budo Ole",
                "Budo Orogun",
                "Budo Oru",
                "Budo Owode",
                "Budo Sakam",
                "Dadi Gaa",
                "Dadi Ite",
                "Egbejila",
                "Egbon",
                "Egbon Tomori Lasoju",
                "Eiyenkorin",
                "Elega",
                "Eleke",
                "Eleko",
                "Elemula",
                "Elepo",
                "Elewure",
                "Eleyele",
                "Eri-Oke",
                "Eru-Oba",
                "Eruobodo",
                "Faa Afon",
                "Faa Aleyo",
                "Faa Sambe",
                "Falokun",
                "Foke",
                "Foko",
                "Fufu",
                "Gaa Apa",
                "Gaa Badanwaki",
                "Gaa Igboroko",
                "Gaa Imam Isale",
                "Gaa Imam Oke",
                "Gaa Kudu",
                "Gaa Mamudu",
                "Gaa Oba",
                "Gaa Sule",
                "Galadimon",
                "Gambaro",
                "Gbagba",
                "Gbaja",
                "Gbale Asun",
                "Gbego",
                "Gbiyeye",
                "Gbobi Araro",
                "Idi Egun",
                "Idi-Agbon",
                "Idi-Emi",
                "Iganna",
                "Igbaunda",
                "Igberi",
                "Igberi Oko",
                "Igbo Aran",
                "Igbo Ede",
                "Igbo Kurange",
                "Igbo Oja",
                "Igboho",
                "Igbole",
                "Igbon Igbin",
                "Igboro-Oke",
                "Igboroko Beye Aram",
                "Igboroko-Isale",
                "Ikeso",
                "Ila",
                "Ila Ija",
                "Ilaji Garuba",
                "Ipetu",
                "Ipetu Nla",
                "Irede",
                "Ita Alamu",
                "Iwonte",
                "Jaju Gbagede",
                "Joro",
                "Joromo",
                "Kajola",
                "Kanlao",
                "Kawu",
                "Kongu",
                "Koroke",
                "Laduba",
                "Lanle",
                "Lasoju",
                "Majire",
                "Majodi",
                "Mejiro",
                "Mogaji",
                "Mojodi",
                "Momo",
                "Monjaodi",
                "Mosadi Olorun",
                "Obata",
                "Obate",
                "Odo Aho",
                "Odo ta",
                "Odo-Ode",
                "Odo-Omo",
                "Odore",
                "Ofin Anda",
                "Ogare",
                "Ogbiri Gidi",
                "Ogbondoroko",
                "Ogele",
                "Ogodo",
                "Ogunlore",
                "Oguntoyinbo",
                "Oke Afon",
                "Okeso",
                "Okete",
                "Oko Erin",
                "Olofe",
                "Ologbo",
                "Oloka",
                "Olokiti",
                "Oloko Nla",
                "Olokoto",
                "Olokoto Eleye",
                "Olola",
                "Ololore",
                "Olomoda",
                "Oloro",
                "Olorunda",
                "Olowo Abe",
                "Olowo Oko",
                "Olulade",
                "Olupe",
                "Olusi",
                "Omi Doyin",
                "Omole",
                "Oni Fufu",
                "Onibo",
                "Oniboyin",
                "Onigbo",
                "Oniguguru",
                "Onipanpe",
                "Onirin",
                "Oniyere",
                "Onyangi",
                "Ooromo",
                "Opakusa",
                "Opette",
                "Oriho",
                "Osere",
                "Osin",
                "Osin Agaka",
                "Osin Alagbako",
                "Osin Aremu",
                "Osin Atapa",
                "Osin Budo Are",
                "Osin Budo Idi Emi",
                "Osin Budo Kawu",
                "Osin Budo Oba",
                "Osin Olokoto",
                "Otte",
                "Otte Egba",
                "Otte-Oko",
                "Owode",
                "Owode-Pampo",
                "Pampo",
                "Pandoro",
                "Rago",
                "Raufu",
                "Reke",
                "Sama",
                "Samoh",
                "Sap",
                "Sapati Ile",
                "Sapati Oko",
                "Saw Mill Odokun",
                "Senga",
                "Sholu",
                "Sokoto",
                "Sun",
                "Suta",
                "Takoro",
                "Tapo",
                "Temidire",
                "Yakoyo",
                "Yiddo",
                "Onire",
                "Abiowa",
                "Adi Gbongbo",
                "Agbolu-Oke",
                "Agbona",
                "Alapa",
                "Alapa Cetre",
                "Alapata",
                "Aminu",
                "Awe",
                "Ayegunle",
                "Boduwu",
                "Budo Abemiseni",
                "Budo Abanisina",
                "Budo Abuyanrin",
                "Budo Adabata",
                "Budo Adinimole",
                "Budo Agba",
                "Budo Agbege",
                "Budo Age Iju",
                "Budo Agunbelewe",
                "Budo Aiyede",
                "Budo Aiyekale",
                "Budo Aiyekirin",
                "Budo Ajape",
                "Budo Ajegunle Alafe",
                "Budo Ajokode",
                "Budo Ajugba Owu",
                "Budo Ajuwon",
                "Budo Akogbin",
                "Budo Alagbede",
                "Budo Alagogo",
                "Budo Alaka Pupa",
                "Budo Alapa",
                "Budo Alaparo",
                "Budo Alate",
                "Budo Alhaji",
                "Budo Aloba",
                "Budo Alodo",
                "Budo Alogun",
                "Budo Amugba",
                "Budo Apa-Okagi",
                "Budo Aparo",
                "Budo Apere",
                "Budo Araromi",
                "Budo Aribi",
                "Budo Arologun",
                "Budo Aroye",
                "Budo Aroyunjo",
                "Budo Asa Dab",
                "Budo Atere",
                "Budo Atu",
                "Budo Ba-Akefa",
                "Budo Baba Alaso Opo",
                "Budo Baba Ayinde",
                "Budo Baba-Ikudu",
                "Budo Badiko",
                "Budo Bale",
                "Budo Balogun Isale",
                "Budo Berikofo",
                "Budo Daudu",
                "Budo Efue",
                "Budo Efue Isale",
                "Budo Elejenla",
                "Budo Eleran",
                "Budo Elere",
                "Budo Elesin",
                "Budo Elete",
                "Budo Elewure",
                "Budo Fakoyi",
                "Budo Gaa Amadu",
                "Budo Gaa Wara",
                "Budo Gambari",
                "Budo Gbakan",
                "Budo Gbena Akanbi",
                "Budo Gbogun",
                "Budo Gerewu",
                "Budo Idisin",
                "Igbonala",
                "Igbonna Oke",
                "Iho Aminu",
                "Iho Yufus",
                "Ijesha",
                "Imalefe Alafia",
                "Inda",
                "Isale Awe",
                "Iyan",
                "Iyanda Ogbena",
                "Iyanwole",
                "Jagun",
                "Jombo",
                "Kajere",
                "Kanmihun",
                "Keredolu",
                "Konipa",
                "Kuo-Amadu",
                "Laomi",
                "Madi",
                "Makotun",
                "Obafe Rufai",
                "Ogbena Kadiri",
                "Ogbin",
                "Ogidi",
                "Ogundele",
                "Oju Taiye",
                "Oke Aye",
                "Olodo Ogbena",
                "Oloja",
                "Olowo Elekan",
                "Olugbo",
                "Orogbangba",
                "Osekutana",
                "Otte-rere",
                "Oyanlu",
                "Popo",
                "Sara",
                "Tanbo",
                "Tanliko",
                "Tatta",
                "Temidire Uban",
                "Tope",
                "Tuntun",
                "Wara",
                "Wodina",
                "Tafa-Tafa",
                "Yakajo",
                "Yanma",
                "Butubutu",
                "Dongari",
                "Edo Are",
                "Elere",
                "Elo-Ekiwe",
                "Epupu",
                "Etile",
                "Faje",
                "Gaa Aiyede",
                "Gaa Jombo",
                "Gbadu",
                "Gbokedu",
                "Idibo",
                "Igbo-Onlu",
                "Isara",
                "Iyan Wole",
                "Kagode",
                "Mokotun",
                "Ojala",
                "Oluwale",
                "Owude Oja",
                "Saka",
                "Tapa"
            ],
            "Baruten": [
                "Gwanara",
                "Bioweite",
                "Didi Umaru Buran",
                "Gbezei Buran",
                "Gomme Likita",
                "Hannda Woma Buran",
                "Haruna Buran",
                "Hassan Bandawaki",
                "Hassan Buran",
                "Hussaminin Buran",
                "Ibrahim Woma Buran",
                "Ibrahim Wukuji",
                "Ibrahim Zamari",
                "Idiris Bako Buran",
                "Idisin Buran",
                "Idisu Buran",
                "Igbogi",
                "Igbori Buran",
                "Iya Egbe Buran",
                "Kaina",
                "Kemanji",
                "Kuhiaro",
                "Magaji",
                "Mahuta",
                "Maigida",
                "Mohammedu Buran",
                "Monna Buran",
                "Moshe",
                "Moshe Bio Sgebe",
                "Sabi Loru Buran",
                "Sabi Manga Buran",
                "Sabi Suya Buran",
                "Sabi Uwa Be",
                "Sabi Woke Buran",
                "Saidu Buran",
                "Sakin Samar Buran",
                "Sale Buran",
                "Sarilic Be",
                "Sebo",
                "Shirigwaria",
                "Sidi Gaku Buran",
                "Sorere",
                "Sulaima Buran",
                "Sule Buran",
                "Sumaji",
                "Sumazi Gamp",
                "Taimako",
                "Taru Absesare Buran",
                "Tenedy",
                "Tenten",
                "Teri Bura",
                "Teshe",
                "Teshe Nahu",
                "Tori Gandu",
                "Tungan Aboki",
                "Tungan Ademu",
                "Tungan Alh. Baduku",
                "Tungan Alh. Ilorin",
                "Tungan Alh. Wote",
                "Tungan Alh. Yusuf",
                "Tungan Alha",
                "Tungan Ango Bata",
                "Tungan Audu",
                "Tungan Bana-za",
                "Tungan Basadito",
                "Tungan Bature",
                "Tungan Bawa",
                "Tungan Bazaki",
                "Tungan Kendegi",
                "Tungan Kotomotoki",
                "Tungan Mai Dawa",
                "Tungan Maisamari",
                "Tungan Mallam Gado",
                "Tungan Mallam Jiki",
                "Tungan Mallam-Mamudu",
                "Tungan Manga Buran",
                "Tungan Marsamari Yekunu",
                "Tungan Musa Dekara",
                "Tungan Ojo",
                "Tungan Okpe Oli",
                "Tungan Sabi",
                "Tungan Sabi Baba",
                "Tungan Sabi Samaru",
                "Tungan Saidu",
                "Tungan Salihu",
                "Tungan Samari",
                "Tungan Samari Biokana",
                "Tungan Sami",
                "Tungan Sanni Gbensibe",
                "Tungan Saraki Fulani",
                "Tungan Sare",
                "Tungan Sebo",
                "Tungan Swaki",
                "Tungan Tofakisabi",
                "Tungan Umaru",
                "Tungan Usman Babade",
                "Tungan Wakili",
                "Tungan Wanzan",
                "Tungan Ware",
                "Tungan Weru Tori",
                "Tungan Yakubu",
                "Tungan Yaru Maiyaki",
                "Tungan Yusuf Bata",
                "Tungan Zaria",
                "Tungari Alh. Bioweite",
                "Tunwa Buran",
                "Yakpe Buran",
                "Yamitoro",
                "Yara Be",
                "Yaru Tangagedo",
                "Yawoji",
                "Yekena",
                "Yekunu",
                "Yen Wuro",
                "Yimoh Buran",
                "Yusufu Bata",
                "Zakari Buran",
                "Zeber ma Buran",
                "Zekana Buran",
                "Ziaah",
                "Zoo Pasi Buran",
                "Zume Buran",
                "Ilesha",
                "Agbara Guru",
                "Alaya Village",
                "Augeradebu",
                "Bello Fulani",
                "Boro Sonma",
                "Budo Abini",
                "Budo Abiri",
                "Budo Agbede",
                "Budo Bio Majde",
                "Budo Magagi Biode",
                "Budo Otu",
                "Budo Wara",
                "Bukaru",
                "Fulani",
                "Gbedebere",
                "Godeberi",
                "Gukenbu",
                "Kosomomo",
                "Ruga",
                "Shinawu",
                "Shindaruwa",
                "Singu",
                "Subalo",
                "Subayo",
                "Tabetabere",
                "Timgan Ada Bedo",
                "Timgan Alh Abdullahi",
                "Tunbuya",
                "Tung Adam Summonu",
                "Tung Alh Mudi",
                "Tungan Addu",
                "Tungan Al. Alu",
                "Tungan Alh Mudi",
                "Tungan Arijo",
                "Tungan Atiki Jumbo",
                "Tungan Ban Guda",
                "Tungan Banruga",
                "Tungan Barandi",
                "Tungan Bari Guda",
                "Tungan Bari Jimoh",
                "Tungan Da-Bedo",
                "Tungan Damu Tjoko",
                "Tungan Jobi",
                "Tungan Yoma Falani",
                "Okuta",
                "Abata Abu",
                "Abdu Magajibe",
                "Abgake",
                "Aboki-Buran",
                "Abu Buran",
                "Abu Narigbe",
                "Adara",
                "Adehe",
                "Adepe",
                "Adpe",
                "Agberejeh",
                "Ageri",
                "Agwara",
                "Ahamadu-Gene-Buran",
                "Ahe",
                "Ajibe",
                "Ajitunire",
                "Akaha Bayo",
                "Akowa Dogo Buran",
                "Alaba",
                "Alaeta Buran",
                "Alagbede",
                "Alagogo",
                "Alajara",
                "Alakuwa",
                "Alate",
                "Alejata Buran",
                "Alenge",
                "Alerge",
                "Alfa Tarmako",
                "Alh. Amiku",
                "Alh. Ayo",
                "Alh. Gofo-Gbesaji",
                "Alh. Koromotoki",
                "Alh. Ramanu",
                "Alh. Salimonu",
                "Alh. Woru Yamile",
                "Ali",
                "Ali Noma",
                "Aliyu Buran",
                "Amane",
                "Ambali",
                "Anmadu-Gurma-Buran",
                "Anoane",
                "Aremu-Kosigi",
                "Ayegoro",
                "Ba-Gene Buran",
                "Baare Buran",
                "Baba Ibeji",
                "Baba Ilerini",
                "Baba Yowa Buran",
                "Babodonuro",
                "Bah Sabi-Be",
                "Banaguri",
                "Bani",
                "Bani Bani-Gure",
                "Bani Sule",
                "Baniyan-Buran",
                "Banpa",
                "Bashira",
                "Bashurum Buran",
                "Bejira",
                "Beni Kekere Buran",
                "Benu Buran",
                "Bera",
                "Binuwa",
                "Bio Tawo Buran",
                "Bio-Nide-Buran",
                "Biruwolu",
                "Bo",
                "Boko",
                "Boko Nukuyi Buran",
                "Bokonobe",
                "Bonuwolu",
                "Boria",
                "Buba-Buran",
                "Buba-Oloke",
                "Budo Oja",
                "Budo Oki",
                "Budo Ore",
                "Budo Samba",
                "Bunsuru",
                "Bushirikpaara",
                "Chanyo-Buran",
                "Dogo Buran",
                "Egi Oke",
                "Eleku",
                "Elepo",
                "Erinsobare",
                "Essa",
                "Essa-Oke",
                "Gaddamina-Buran",
                "Galo",
                "Galso Buran",
                "Gamdu Buran",
                "Garba-Buran",
                "Gatebe",
                "Gaudamina-Buran",
                "Gbazai Buran",
                "Gbenisi Taku Burab",
                "Ge-Fh-Buran",
                "Ghoro",
                "Gidan Magajia",
                "Gidan-Kanterma",
                "Giwa Buran",
                "Godo-Godo",
                "Gogo",
                "Goma Buran",
                "Gunu Buran",
                "Gunu Sabi-Buran",
                "Gurman Buran",
                "Gwanagiji",
                "Gwaria",
                "Gwaria-Waziri",
                "Hikyan",
                "Jipima",
                "Kafiyan-Buran",
                "Kajin Buran",
                "Kanbi Are",
                "Karagbonkna (2nd)",
                "Karagbonna",
                "Karami Buran",
                "Kasabu",
                "Kasimu Roko Buran",
                "Kausla",
                "Kekena-Buran",
                "Kenu",
                "Kimado Buran",
                "Kipaslu Buran",
                "Kokorogi",
                "Komala",
                "Konto Buran",
                "Koronji Buran",
                "Koto Be",
                "Kpassli-be Buran",
                "Kubinla",
                "Kwaruru",
                "Laki-Buran",
                "Lalare Buran",
                "Lidan Ku Buran",
                "Likita Buran",
                "Lilata Buran",
                "Magbo",
                "Mago",
                "Magwo Daji",
                "Manu",
                "Nikipkeru",
                "Ororo Tudu",
                "Pagirin Gajere",
                "Passetullu",
                "Raguru",
                "Rofia",
                "Rugan Toru-Kparu",
                "Rumu",
                "Shambo",
                "Sheyen",
                "Shiya",
                "Surub",
                "Suteku",
                "Taga",
                "Bako-Dokaku",
                "Tanile",
                "Tenbonu",
                "Teu",
                "Tungan Adda",
                "Tungan Adena",
                "Tungan Ajiya",
                "Tungan Baushe",
                "Tungan Bis Gasu",
                "Tungan Bori",
                "Tungan Dinu",
                "Tungan Kuruma",
                "Tungan Lafina",
                "Tungan Shika",
                "Tungan Sunotaka",
                "Tungan-Kade",
                "Umaru Bawa Buran",
                "Ushatau",
                "Usman Fulani",
                "Usman Jodi",
                "Usman-dada-Buran",
                "Usman-Sanibe",
                "Utula",
                "Venra",
                "Voberah",
                "Wayo",
                "Wobi",
                "Woro",
                "Woromakoto",
                "Woru-Daru",
                "Yamboyan",
                "Zamelo",
                "Yashi Kera",
                "Abegerreru",
                "Abion Kparu",
                "Alafi Yaru-Share",
                "Alafiyaru",
                "Alafujaru",
                "Alh Garba Kparu",
                "Alh. Gene",
                "Alh. Mamman",
                "Alu Kparu",
                "Anasanikiru",
                "Angeraodebu",
                "Barukataran Kparu",
                "Bassa",
                "Benu",
                "Bereguru",
                "Beru",
                "Bisakwera",
                "Bokaguru",
                "Boni Kanank Kparu",
                "Boriya",
                "Boru",
                "Bulakuko",
                "Bushi Kparu",
                "Bushiru Mare S.",
                "Buyen",
                "Cado (Alafiayanu)",
                "Cah-Moro",
                "Chikanda",
                "Chikandu",
                "Cure",
                "Dagoman Karu",
                "Dakasi",
                "Denu Darun Kparu",
                "Diki gamin Kparu",
                "Doganri",
                "Doo Neru",
                "Dunga",
                "Ekenete",
                "Fere Koru",
                "Gah-Awaye",
                "Gando Sund Dede",
                "Gando Sunnon",
                "Ganidu Sumun Kparu",
                "Ganmin Kparu",
                "Garto Kparu",
                "Gbani",
                "Gbe Burabu",
                "Gberabosina",
                "Gendow Senon Kpaku",
                "Geruku Dero Kparu",
                "Gobijowa Kparu",
                "Gobin Kparu",
                "Goruki Garba Kparu",
                "Gudin Kparu",
                "Gure",
                "Guru Kende",
                "Gwane",
                "Gwasoro",
                "Gweewokure",
                "Ibrahim Kparu",
                "Issa Dunbun Kparu",
                "Jenworun Kparu",
                "Jondin Kparu",
                "Kadirin Kparu",
                "Kangbe",
                "Kaoje",
                "Kaounji",
                "Keneugbe",
                "Kenu Booku",
                "Kobi Cure",
                "Kobunifu",
                "Kosubosu",
                "Kpabardike",
                "Kparu",
                "Kparuru Gururu",
                "Kparuru Kparu",
                "Kperu Ganik Adam",
                "Kpeyen Kparu",
                "Kwariya-Daaku",
                "Kwaru",
                "Kwaruru Kworu",
                "Kworu Babanna",
                "Liman Kparu",
                "Makarakpo",
                "Mamman Kparu",
                "Mammandun Kparu",
                "Mara Kparu",
                "Maresumun Kparu",
                "Masun Kparu",
                "Matarun Kparu",
                "Mikikperu",
                "Moral",
                "Mori Guru",
                "Moshi",
                "Moshi Guru",
                "Nasheu Kparu",
                "Nwasero",
                "Oli",
                "Owelle",
                "Pomlo",
                "Sabi Jooden Kparu",
                "Sabi Swaru",
                "Sabo",
                "Saina Toko",
                "Saitun Kparu",
                "Samangen Kparu",
                "Saminin Kparu",
                "San Bion Kparu",
                "Sanisosan Kparu",
                "Sanni Gonadin Kparu",
                "Sekerite",
                "Senugbe",
                "Serkin Fulani Kparu",
                "Shanganun Kparu",
                "Share-Sabo",
                "Shionin-Kparu",
                "Shiya Village",
                "Shru Galasani",
                "Shysinu Kparu",
                "Sinaguru",
                "Sinatokoru",
                "Sinu",
                "Skugbe",
                "Sobutu Gwette",
                "Sonni Aworoi Kparu",
                "Sunsi",
                "Tewure",
                "Tongoru",
                "Tubiriku Guru",
                "Tuka",
                "Tunde",
                "Ugomoe",
                "Umaru Makirin",
                "Washard",
                "Weriguru",
                "Wobero",
                "Woodara",
                "Woru Borun Kparu",
                "Wulran Kparu",
                "Yaaro Guru",
                "Yanri",
                "Yantan Kparu",
                "Yashikira",
                "Yashiru",
                "Yisi Guru",
                "Yobereku",
                "Yonbon Kparu",
                "Yonwonrun Bio",
                "Yonworuni Kparu"
            ],
            "Edu": [
                "Lafiagi",
                "Anfani",
                "Anfanifagi",
                "Babagina",
                "Bacita Swasun",
                "Baganke",
                "Bedekie",
                "Binla",
                "Bishewa",
                "Bokungi",
                "Bommasu Ward",
                "Borogun",
                "Ceke",
                "Cewuru",
                "Chatta",
                "Chekugi",
                "Chikangi",
                "Dawo",
                "Duba",
                "Dubagi",
                "Dzanagan",
                "Dzara I",
                "Dzara II",
                "Dzara III",
                "Ebangi",
                "Edogi",
                "Edogi-Dukun",
                "Efa-Gi",
                "Effan",
                "Effan Shaaba",
                "Eke",
                "Esu",
                "Falada",
                "Funti",
                "Gagara",
                "Gamale",
                "Gamalegi",
                "Ganagagi",
                "Ganagagi Maiyaki",
                "Ganagagi-Kologbo",
                "Gawagagi Ndejin",
                "Gbadi",
                "Gbake",
                "Gbarigi",
                "Gbogbu",
                "Gbondagi",
                "Gbowoagi",
                "Gede I",
                "Gede II",
                "Gudusuru",
                "Guya-Sede",
                "Guye-Dadi",
                "Guye-Deke",
                "Kimpa",
                "Kokodo",
                "Korabo I",
                "Korabo II",
                "Korabo III",
                "Kpangulu",
                "Kpasha Eitsu Yankpa",
                "Kpashaeltsu Yawkpa",
                "Kpoton Ward",
                "Kpotunko",
                "Kpotunworo",
                "Kuke",
                "Ladan",
                "Lagaworo",
                "Lata",
                "Lema Woro",
                "Lemo",
                "Likpata",
                "Lukpete",
                "Macha",
                "Magani",
                "Maganike",
                "Maiyaki",
                "Make-Dawu",
                "Manke",
                "Mijinitagi",
                "Ndakodi",
                "Ndeji",
                "Nnayintu",
                "Obale",
                "Pututa",
                "Sabagiwa",
                "Sabo",
                "Sabo II",
                "Sange",
                "Shekwati",
                "Shesiti Dangawa",
                "Sita Abah",
                "Swasungi",
                "Tandu",
                "Tawake",
                "Toga",
                "Upandawaki Ward",
                "Wariku",
                "Wede",
                "Wodata",
                "Wudzu",
                "Yawu",
                "Yelewa",
                "Yibah",
                "Yikpata",
                "Zambufu",
                "Shonga",
                "Bakpata",
                "Buke",
                "Bussu",
                "Chakyagi",
                "Chetta Bure",
                "Chetta Mayaki",
                "Chiji",
                "Chita",
                "Dmmagi",
                "Dumagi",
                "Dyadya Ningi",
                "Ekikobe",
                "Emi Ndake Finweza",
                "Emiga",
                "Emikpangi",
                "Emiworogi",
                "Etsu Kolle",
                "Faigi",
                "Faigi Banzamin",
                "Faigi Emiman",
                "Gbere",
                "Gbere Edu Issa",
                "Gbere Maafu",
                "Gbere Nabigi",
                "Gbere Sonlawa",
                "Gbore Ndaceko",
                "Gecegugu",
                "Giragi",
                "Gunbaji",
                "Kanke",
                "Kanshi",
                "Kocegi",
                "Kpandaragi Worogi",
                "Kpatake",
                "Kpilegi",
                "Kpotan Ward",
                "Kubeji",
                "Kusogi",
                "Machita",
                "Madkansa Bonkwa",
                "Makwagi",
                "Mamuga",
                "Manadzkwakwa",
                "Manfu",
                "Manuga",
                "Manuga A",
                "Manuga B",
                "Mayaki Ward",
                "Mayakifu",
                "Ndabata Patiji",
                "Ndabata Take",
                "Ndace Baba",
                "Ndakansa Liman",
                "Ndatsadu",
                "Ndeji Ward",
                "Obagbara",
                "Ogudu",
                "Pati Okun",
                "Sanchitagi",
                "Sha /aba Ward",
                "Shigan",
                "Soko Alabe",
                "Suteneti",
                "Tada",
                "Takemwangi",
                "Taruku",
                "Tode Worogi",
                "Tsakpata",
                "Tsunfeneti A",
                "Tsunfeneti B",
                "Tsungenetic C",
                "Yimagi",
                "Tsaragi",
                "Ankoro",
                "Ankoro Hausawa",
                "Baata Village",
                "Badzufu Patike",
                "Belle",
                "Beribe",
                "Bokuwgi 11",
                "Boribe",
                "Dada A",
                "Dada B",
                "Dudugi Late",
                "Dugbangi",
                "Edogi Tswachi",
                "Emidebiwa",
                "Emigbaziti",
                "Emiwaroji",
                "Emoworogi",
                "Erugi",
                "Esanshi",
                "Eyeforogi",
                "Fadundangi",
                "Fawagun",
                "Fawjewa Bokungi",
                "Galofa",
                "Gandaji",
                "Gbabata",
                "Gbadagun",
                "Gbaduna",
                "Gbagunta",
                "Gbodeyeluwa",
                "Gbpde Yaluwa",
                "Gidan Malfan",
                "Ginda",
                "Gondagi",
                "Gulufa Isowa Audu",
                "Gungbawaba",
                "Gunugi",
                "Ielle Bata A",
                "Juma",
                "Kachita",
                "Kandarifu",
                "Kange Elsudangama",
                "Kange Ndadama",
                "Kangelalukpan",
                "Karati Sode",
                "Kochitate",
                "Kosomunu",
                "Kpace Jiya",
                "Kpandaragi",
                "Kuntukpa",
                "Letswa",
                "Maako",
                "Magani Aliya",
                "Magani Gbagunta",
                "Majindu",
                "Mamu",
                "Mandzurugi",
                "Mangohota",
                "Manguru",
                "Marara",
                "Mawegi",
                "Mawfu Chikan",
                "Nati",
                "Nbagada",
                "Ndabigi I",
                "Ndabigi II",
                "Ndaceke",
                "Ndafa Taake",
                "Ndafa Tifin",
                "Ndagba",
                "Ndajola Ward",
                "Ndalati",
                "Ndanini",
                "Ninguba",
                "Nnkpe Nupeko",
                "Obadowa",
                "Obaduwa I",
                "Paliduin",
                "Paracita",
                "Pategi",
                "Patidanu",
                "Patigi Adewe",
                "Patigi Samaru",
                "Patigizuwa",
                "Patike",
                "Patiko",
                "Range Ndakukwa",
                "Range Tsaagba",
                "Sabo Bacita",
                "Sabon Gida",
                "Sedegba",
                "Shagari",
                "Sodegi",
                "Sokun Kpan B",
                "Sokunkpan",
                "Sokunpanc",
                "Tangbere Patike",
                "Tangborogi",
                "Tunku",
                "Ungwa Hausawa",
                "Wote Gwawe",
                "Yabatagi",
                "Yawma Kokonna"
            ],
            "Ekiti": [
                "Obo-Eruku",
                "Ejiju",
                "Eruku",
                "Isapa",
                "Isapa-Titun",
                "Koro",
                "Obbo-Ile",
                "Ora",
                "Ora-Aiyegbaju",
                "Osi",
                "Ajuba",
                "Araromi-Opin",
                "Are-Opin",
                "Ejiku",
                "Epe-Opin",
                "Etan",
                "Ibare",
                "Idera-Opin",
                "Ikerin-Opin",
                "Isale-Opin",
                "Isolo-Opin",
                "Obo-Opin",
                "Oke-Opin",
                "Osi-Opin",
                "Owafun-Opin"
            ],
            "Ifelodun": [
                "Agunjin-Ora",
                "Abayan",
                "Abayawo",
                "Abayowo Yemidire",
                "Adegbite",
                "Adegun",
                "Adigun Alangua",
                "Adigun-Adeleke",
                "Adigun-Bale",
                "Agba Olowo",
                "Agbada Temidire",
                "Agbeku",
                "Agbeyangi",
                "Agunjin",
                "Ailefe",
                "Aireke",
                "Aiyekale",
                "Ajagunle Temidire",
                "Ajegna Temidire",
                "Ajegunle",
                "Ajilete",
                "Ajoko Temidire",
                "Alade",
                "Amori Wande Temidire",
                "Araromi Isele Lapele",
                "Araromi Oja",
                "Araromi Oke",
                "Arifowomo",
                "Arowo",
                "Ayante",
                "Balogun",
                "Bolorunduro",
                "Budo Alli",
                "Deseni",
                "Ekudaji",
                "Ekudaji Oke",
                "Esiuniyi Temidire",
                "Gaa Agbeku Araro",
                "Gaa Opelade",
                "Gaa Wande",
                "Gbotoko",
                "Idi-Igba",
                "Igbafe",
                "Isiaka",
                "Ita Olowo",
                "Itapa-Dowo",
                "Kajola",
                "Lapele",
                "Layemi",
                "Magbon",
                "Monasara",
                "Ode-Ologbo Temidire",
                "Ojutaiye Temidire",
                "Okangi",
                "Oke Odo",
                "Olayinka",
                "Olufayo",
                "Opelade",
                "Ora",
                "Ore",
                "Owode Temidire",
                "Patako",
                "Sanni Koro",
                "Tapa",
                "Temidire",
                "Wande",
                "Ekoende",
                "Abule",
                "Abule Elega",
                "Abule Idi-Irin",
                "Abule Mokoye",
                "Abule Olufi",
                "Eko Ajala",
                "Eko Ende",
                "Olodan",
                "Iba",
                "Alaaro",
                "Aoku",
                "Iga Saliu",
                "Igalambe",
                "Isale Aisin",
                "Ojomu",
                "Okose",
                "Idofin",
                "Abudu",
                "Akata Eleko",
                "Akata Gado",
                "Alakuko",
                "Alamilaya",
                "Amoyo",
                "Elerinjare",
                "Falokun",
                "Gaa Abikoro",
                "Gaa Alakuko",
                "Gaa Butubutu",
                "Gaa Elerinjare",
                "Gaa Ganmo",
                "Gaa Gata",
                "Gaa Kisi",
                "Gamo",
                "Gbagede Isale",
                "Gbagede Oke",
                "Ipo-Eri",
                "Jimba-Oja",
                "Kabba Dogari",
                "Kabba Kajola",
                "Kabba Owode",
                "Kaoju",
                "Oke-Iya",
                "Oke-Ogba",
                "Oko-Okuta",
                "Igbaja",
                "Aaran",
                "Adanla",
                "Afori",
                "Ago",
                "Aguada",
                "Aikere",
                "Aiyekojo",
                "Aiyeretatun",
                "Aji Oja",
                "Ajilowo",
                "Ajoko",
                "Akoba",
                "Aladodo",
                "Alarto Ilupeju",
                "Alasoro Alatan",
                "Alatan",
                "Alo",
                "Aloko",
                "Amule",
                "Apakere",
                "Aperu",
                "Araromi-Ogbe",
                "Atori",
                "Awewe",
                "Ayiga",
                "Balogun Oja",
                "Bayero",
                "Bere",
                "Budo Ada",
                "Budo Ajiba",
                "Budo Ajuba",
                "Budo Akin",
                "Budo Alayo",
                "Budo-Edun",
                "Dala Ilupeju",
                "Duro Seto",
                "Duroseto Rentile",
                "Elejola",
                "Farase",
                "Gaa Adanla",
                "Gaa Agboran",
                "Gaa Alagbede",
                "Gaa Alhaji",
                "Gaa Alo",
                "Gaa Atiran",
                "Gaa Audu",
                "Gaa Balogun",
                "Gaa Bayer",
                "Gaa Giwa Onilu",
                "Gaa Goga",
                "Gaa Ibare",
                "Gaa Idera",
                "Gaa Idiapa",
                "Gaa Kadiri",
                "Gaa Mosudo",
                "Gaa Offarase",
                "Gaa Ogbe",
                "Gaa Ogele",
                "Gaa Ogunbaka",
                "Gaa Onijo",
                "Gaa Oroku",
                "Gbokole",
                "Gwa",
                "Idera",
                "Idiapa",
                "Idiapa Idiya",
                "Ignanu",
                "Ijekele",
                "Ilupeju",
                "Jobi",
                "Kajola II",
                "Kehinde Kajola III",
                "Kunmi",
                "Laokun Araromi",
                "Layioke",
                "Mosunkanne",
                "Obadara",
                "Obate",
                "Obate Modudu",
                "Obin",
                "Odamadi",
                "Odunnada Ilupeju",
                "Offarase",
                "Ogba",
                "Ogbe",
                "Ogele",
                "Ogunniyi",
                "Ojekale",
                "Oke-Ode-Yee",
                "Okegbo",
                "Okenijo",
                "Okotorubo",
                "Oloko",
                "Olorunshogo",
                "Onigbe",
                "Onijo",
                "Opanda",
                "Oroki",
                "Osin",
                "Owobe",
                "Owode",
                "Palade",
                "Saliu Gaa Adamu",
                "Sanda",
                "Sokoto Gbo",
                "Tonyobolo",
                "Yaru",
                "Ikirun",
                "Dagbolu",
                "Jagun",
                "Oluode",
                "Saba",
                "Ile-Ire",
                "Afin",
                "Aga",
                "Aiyereke",
                "Alabe",
                "Amodu Olo",
                "Awere",
                "Aya",
                "Babanla",
                "Baiyero",
                "Budo Are",
                "Budo Idowu",
                "Gaa Alabe",
                "Gaa Ikosin",
                "Gammu",
                "Idiya",
                "Idoba",
                "Ikosin",
                "Obinn Ayetoro",
                "Okeoyan",
                "Okin",
                "Oko",
                "Olorualeke",
                "Oreke",
                "Oreke-Okegbo",
                "Orekeoke",
                "Owa Onire",
                "Owode Offaro",
                "Obagun",
                "Abule Bale",
                "Abule Ologoro",
                "Aogun",
                "Eesa Oke Suru",
                "Igbo Ilamu",
                "Igbo Iroko",
                "Oke Ogun",
                "Olorunsogo",
                "Oke-Ode ilrin south",
                "Adebu",
                "Adetutu",
                "Adetutu Igbo Agbon",
                "Agbee",
                "Agbee Owotoki",
                "Agbelero 11",
                "Agbetero 1",
                "Aiyetoro",
                "Aiyetoro Agegunle",
                "Ajia",
                "Alagbe Oja",
                "Alasodudu",
                "Alawo-Yonba",
                "Aleb Asanlu",
                "Amudun",
                "Arola Idris",
                "Arola Sadiku",
                "Asipa",
                "Asipade",
                "Asungbade",
                "Atipo",
                "Atola",
                "Bada",
                "Bankole",
                "Biji",
                "Bofaje",
                "Buban-Ka",
                "Budo Alagbede",
                "Budu-Efsu",
                "Dabu",
                "Dabu Idris",
                "Dabu Oroki",
                "Dabu-Ojutaiye",
                "Dikko",
                "Ekotuntun",
                "Elesinmeta",
                "Eleyele",
                "Eri-Alhaji",
                "Famole",
                "Gaa - Jihom",
                "Gaa Abudu Asifade",
                "Gaa Jimoh",
                "Gaa Momoda-Elesin Gege",
                "Gaa Musa",
                "Gaa Oke-Ode",
                "Gaa Omu-Are",
                "Gaa Seriki Shagbe",
                "Gaa- Alabe Aiyetoro",
                "Gaa-Alabe",
                "Gaa-Alawo",
                "Gaa-Asungbale",
                "Gaa-Audu",
                "Gaa-Bankole",
                "Gaa-Bello",
                "Gaa-Budo Seu",
                "Gaa-Eleyele 1",
                "Gaa-Eleyele 11",
                "Gaa-Gege",
                "Gaa-Igbo Agbon 1",
                "Gaa-Igbo Agbon 11",
                "Gaa-Judi Adetutu",
                "Gaa-Jumbo-Ologomowode",
                "Giloagi",
                "Igbo Elemi",
                "Keke Aje",
                "Labaka",
                "Labaka-Idera",
                "Labaka-Oju",
                "Obada",
                "Ogboyo",
                "Ogunbayo",
                "Ojukaiye",
                "Okanle",
                "Oke-Ode",
                "Okuta-Oko",
                "Ologoma",
                "Ologorun",
                "Olorunlagba",
                "Oloruntele",
                "Oloruntola",
                "Olowo",
                "Omi Aro",
                "Onigbongbo",
                "Oniminsun",
                "Pidan",
                "Sagbe",
                "Sagbe Ogede",
                "Omupo",
                "Agbo-Koko",
                "Ahoro",
                "Aladia",
                "Alufa",
                "Amberi",
                "Amodu Asungbolu",
                "Apata Kajola",
                "Arugbo",
                "Atanda",
                "Basanyin",
                "Bayagan Ile",
                "Fajeroni",
                "Gaa Oke Omu",
                "Gaa Sulu",
                "Gaa-Okenla",
                "Gaa-Indisa",
                "Gaa-Oja",
                "Igberi",
                "Igbo-Efon",
                "Igbo-Owu",
                "Gudugba",
                "Irapa",
                "Koko",
                "Koloko",
                "Layaju",
                "Nda Aliu",
                "Obaloyan",
                "Olukotun",
                "Oyawajo",
                "Oro-ago",
                "Ahun",
                "Arin Ago",
                "Ayetoro",
                "Irabon",
                "Oganyin",
                "Oke-Ayin",
                "Oke-Daba",
                "Oke-Owa",
                "Omugo",
                "Oro Ago",
                "Oyate",
                "Otan Aiye -Gaaju",
                "Otan Aiyebaju",
                "Township",
                "Share",
                "Aderonme",
                "Adio",
                "Agberiako",
                "Aho",
                "Ajeoripa",
                "Ajibola",
                "Ajikanje-Apata Aje",
                "Alegongo 1",
                "Alegongo-Temidire",
                "Alera",
                "Araromi",
                "Arobye",
                "Arogunyo",
                "Arola",
                "Babanlomo",
                "Bata Kajola",
                "Budo Alufa Oyi",
                "Budo Inalowo",
                "Budo Umoru",
                "Budo-Danyan",
                "Budo-Idishin",
                "Budo-Sabo",
                "Budo-Sosun",
                "Dankoju",
                "Eyeforoji",
                "Faje 1",
                "Faje 11",
                "Gaa Mudi",
                "Gaa Seriki",
                "Gaa-Aiko",
                "Gaa-Alera",
                "Gaa-Elejeri",
                "Gaa-Fulani",
                "Gaa-Idiose",
                "Gaa-Jekeje",
                "Gaa-Mogaji",
                "Gaa-Momo",
                "Gaa-Okelesu",
                "Gaa-Shayo",
                "Igblowowa",
                "Iyana",
                "Managoro",
                "Mosafejo",
                "Pako",
                "Pangbe",
                "Pasinka",
                "Sangotayo",
                "Sekun 1",
                "Sekun 11",
                "Sharagi",
                "Shayo"
            ],
            "Ilorin East": [
                "Iponrin",
                "Abanra",
                "Abonde",
                "Abudu",
                "Ada Nda",
                "Adobasin",
                "Agbeyangi",
                "Ajelende",
                "Ajimasin",
                "Alade",
                "Alalubosa",
                "Apado",
                "Apata Yakubu",
                "Atere",
                "Ayekale",
                "Ayetoro",
                "Badi",
                "Baiyero",
                "Budo Abagbe",
                "Budo Abanra",
                "Budo Abeli",
                "Budo Adanda",
                "Budo Adelu",
                "Budo Afehin Sanbata",
                "Budo Afeyin",
                "Budo Agara",
                "Budo Agbengende",
                "Budo Agboge",
                "Budo Aigoro",
                "Budo Ajaponna",
                "Budo Ajeyin",
                "Budo Ajiponmi",
                "Budo Ajo Ko",
                "Budo Akinde",
                "Budo Akiwo",
                "Budo Akobale",
                "Budo Alagbe",
                "Budo Alakolaro",
                "Budo Alase",
                "Budo Alasebo",
                "Budo Ali",
                "Budo Alokolaro",
                "Budo Apa Ole",
                "Budo Apekun",
                "Budo Aranmonu",
                "Budo Araro",
                "Budo Are",
                "Budo Aregun",
                "Budo Aribi",
                "Budo Asunlope",
                "Budo Atanpa",
                "Budo Atapa",
                "Budo Ateko",
                "Budo Atenge",
                "Budo Atingiri",
                "Budo Atiran",
                "Budo Baba Taiye",
                "Budo Babatunde",
                "Budo Bada",
                "Budo Bada Owe",
                "Budo Bolorunduro",
                "Budo Bolorunshoro",
                "Budo Bubu Kere Aje",
                "Budo Dangiwa",
                "Budo Doguna",
                "Budo Elekan",
                "Budo Elesimete",
                "Budo Eleyode",
                "Budo Eri Oke",
                "Budo Faje",
                "Budo Famole",
                "Budo Fulani",
                "Budo Gaa Gande",
                "Budo Gaa Jowuro",
                "Budo Gaa Suallah",
                "Budo Gangan",
                "Budo Gbadamu",
                "Budo Gori",
                "Budo Idi Ogun",
                "Budo Idi Ose",
                "Budo Idi-Ori",
                "Budo Idigba",
                "Budo Idikanga",
                "Budo Igbo Orun",
                "Budo Ilaga",
                "Budo Ile Tuntun",
                "Budo Isamu",
                "Budo Jagbo",
                "Budo Jolasun",
                "Budo Kawu",
                "Budo Kelebe",
                "Budo Labe",
                "Budo Lossa",
                "Budo Magaji",
                "Budo Maternity",
                "Budo Megun",
                "Budo Oba",
                "Budo Odunbaku",
                "Budo Odunre",
                "Budo Ogunronbi",
                "Budo Oh Ologun",
                "Budo Ojutaye",
                "Budo Okaka",
                "Budo Oke",
                "Budo Oke Imale",
                "Budo Oke Odo",
                "Budo Oke-Ode",
                "Budo Oku",
                "Budo Ologi",
                "Budo Olokuta",
                "Budo Ololekan",
                "Budo Oloro",
                "Budo Olororo",
                "Budo Olukolu",
                "Budo Omo Mere Oja",
                "Budo Omoda",
                "Budo Onidanla",
                "Budo Onigba",
                "Budo Otefan",
                "Budo Oyekan",
                "Budo Oyo",
                "Budo Pakobo",
                "Budo Ruga Omo",
                "Budo Sabo",
                "Budo Sanu",
                "Budo Sentu",
                "Budo Songote",
                "Budo Sunbare",
                "Budo Tapa Odobo",
                "Budo Tapa Onilu",
                "Budo Toto",
                "Budo Woowode",
                "Budo Yanganmu",
                "Dalemo",
                "Idiape",
                "Ile Apa",
                "Ilota",
                "Bada",
                "Isale Osin",
                "Jabi",
                "Kere Aje",
                "Kure",
                "Lajiki",
                "Lajolo",
                "Marafa",
                "Mere",
                "Oke-Ose",
                "Onikoko",
                "Onimomo",
                "Oromi",
                "Oshin",
                "Oyo",
                "Panada",
                "Pepele",
                "Woru"
            ],
            "Ilorin South": [
                "Gaa Akanbi",
                "Oke Ogun",
                "Agbabiaka",
                "Aiyekale",
                "Akanbi",
                "Apa-Ola",
                "Okose",
                "Mogaji-Ajomu",
                "Omomere-Oja",
                "Bada-Ajegunle",
                "Ere-Omo",
                "Fate",
                "Fufu",
                "Igbona",
                "Illota",
                "Joromoh-Osin",
                "Joromo-Oyun",
                "Labala",
                "Mogaji",
                "Nasudo",
                "Omode",
                "Onikanga",
                "Opolo",
                "Tanke",
                "Tongolo"
            ],
            "Ilorin West": [
                "Ilorin (rural)",
                "Adewole",
                "Airport",
                "Are",
                "Baba Isale",
                "Baboko",
                "Badari",
                "Balogun Ajikabi",
                "Balogun Alanamu",
                "Balogun Fulani",
                "Budo Oba",
                "Budo-Ago",
                "Egbejila",
                "Galadima",
                "Ibagun",
                "Idera",
                "Kawu",
                "Magaji Ngari",
                "Obere",
                "Odo-Ota",
                "Odota",
                "Ogidi",
                "Ojuekun",
                "Okaka",
                "Oke Ogun",
                "Oko-Erin",
                "Oloje",
                "Olomoda",
                "Osere",
                "Sobi-Rock",
                "Temidire",
                "Ubadawaki",
                "Wara",
                "Zango",
                "Zarumi"
            ],
            "Irepodun": [
                "Ajase",
                "Aba Ilorin",
                "Aba Rasaki",
                "Adigun",
                "Afelele",
                "Agbamu",
                "Agbonda",
                "Ago",
                "Ago Inisa",
                "Ago Osilo",
                "Ago Panu",
                "Ago-Offa",
                "Ajase-Ipo",
                "Ajegunle",
                "Ajengbe",
                "Ajooko",
                "Amberi",
                "Apata Kajola",
                "Araromi Ajase",
                "Aworo",
                "Ayobiamo",
                "Bayanga",
                "Buari",
                "Dugbe",
                "Egi-Oyopo",
                "Egudu",
                "Elega",
                "Eleyoka",
                "Eyeba",
                "Falukun",
                "Igbonla",
                "Ilala",
                "Mamudu",
                "Okeya",
                "Omido",
                "Onila",
                "Owoyale",
                "Oyanle",
                "Oyate",
                "Sanmora",
                "Erin",
                "Akanbi",
                "Alamo",
                "Anu",
                "Apata Agbore",
                "Elegudu",
                "Iloba",
                "Olorunsogo",
                "Osolo",
                "Esie-Ijan",
                "Agbele",
                "Esie",
                "Ijan",
                "Ilobu",
                "Abepe",
                "Aboduwa",
                "Adeniyi",
                "Aderibigbe",
                "Agborogun",
                "Ajala",
                "Akogun",
                "Alagbaa",
                "Alapata",
                "Anwosi",
                "Aresa",
                "Bara",
                "Eboda",
                "Eji",
                "Fosun",
                "Ilie Twon",
                "Iyaloja",
                "Jagun",
                "Kaura",
                "Mota",
                "Odofin",
                "Odurwale",
                "Ogala",
                "Ogundaro",
                "Ogunlana",
                "Olokwa",
                "Oloriga",
                "Olueti",
                "Olufon",
                "Omilola",
                "Opapa",
                "Orisadare",
                "Oyegple",
                "Oyesiji",
                "Omuaran",
                "Ado-Agbo",
                "Aran-Orin",
                "Arandun",
                "Budo-Aran",
                "Elehin Olodo",
                "Ipetu Igbomina",
                "Oke Igbala",
                "Olomi",
                "Oloruntele",
                "Olowonijere",
                "Omirinrin",
                "Orore",
                "Owode",
                "Oro",
                "Abata",
                "Abode Oro",
                "Afin-Oro",
                "Agbaola Oro",
                "Iddo-Oro",
                "Iludun Oro",
                "Ojomu Oro",
                "Oke-Ola Oro",
                "Okerimi Oro"
            ],
            "Isin": [
                "Isin",
                "Abata Oke",
                "Adigun",
                "Ajegunle",
                "Alla",
                "Budo Manasara",
                "Budo-Igbira",
                "Edidi",
                "Eleyin",
                "Igbesi",
                "Ijara-Isin",
                "Iji",
                "Iklo",
                "Isanlu Isin",
                "Iwo",
                "Kajola",
                "Kudu-Owode",
                "Oba",
                "Odo-Eku",
                "Odo-Ore",
                "Oke-Aba",
                "Oke-Onigibin",
                "Oke-Oyi",
                "Opanda",
                "Opega",
                "Owa Onire",
                "Owu Isin",
                "Pamo",
                "Sabaja",
                "Oko-Ola",
                "Inisan",
                "Oko",
                "Olla"
            ],
            "Kaiama": [
                "Kaiama",
                "Adena",
                "Bamisila",
                "Bani",
                "Batabi",
                "Biovanubo",
                "Bunikani",
                "Frenaba",
                "Garba Ghanga",
                "Gati",
                "Gberia",
                "Gwanabe",
                "Gwareguri",
                "Gwaria",
                "Jekuna",
                "Kageji",
                "Kaiama Unhuibar Saki",
                "Kaima",
                "Kanikoro",
                "Karonji",
                "Kemeji",
                "Kerokun",
                "Kimodo",
                "Kinkini",
                "Kuliji",
                "Madugu Barn",
                "Madugu Boko",
                "Magai",
                "Magaji",
                "Magi Konko",
                "Mai Gemi",
                "Mai Saje",
                "Maidarra Buran",
                "Maidugu Buran",
                "Makeri Buran",
                "Mallam Ango Buran",
                "Mallam Sani Buran",
                "Mamman Buran",
                "Manar Buran",
                "Miji Buran",
                "Mohammed Fari",
                "Moshi",
                "Mukuzi",
                "Musa Baniya",
                "Musa Dabarrai",
                "Ogbagba",
                "Ogbomosho",
                "Ogunniyi",
                "Oko o",
                "Oleri",
                "Oloba",
                "Olokotintin",
                "Olomo Oba",
                "Olowo",
                "Olupo",
                "Olupo Olomopupa",
                "Olupo Yobeyo",
                "Onipako",
                "Onipako Wele Wehe",
                "Onkorolabe Labe",
                "Onpede",
                "Osejene",
                "Ossa",
                "Oyo Buran",
                "Panaje",
                "Patekuku",
                "Patekutu Jejuna",
                "Popo",
                "Tungan Mohammed",
                "Wajiba",
                "Wazibe",
                "Wele Wele",
                "Wenra",
                "Wondo",
                "Woro",
                "Woro Makata",
                "Woro Makoto",
                "Woru Baba be",
                "Woru Oil Buran",
                "Yamani",
                "Yebrea",
                "Yera",
                "Zanje"
            ],
            "Moro": [
                "Ejidon-Gari",
                "Aaro",
                "Abaoki",
                "Abike",
                "Abogunrin",
                "Adebiyi",
                "Afoda",
                "Afunkinkin",
                "Agbaa",
                "Agbakale",
                "Agbaki-Eji",
                "Agbakun",
                "Agbewe",
                "Agogo",
                "Aiyede",
                "Aiyetoro",
                "Ajeteri",
                "Ajuba",
                "Akunu",
                "Akuo",
                "Alaba",
                "Aladie",
                "Alagban",
                "Alagbara",
                "Alagbeja",
                "Alakuko",
                "Alaran",
                "Alasa",
                "Amu",
                "Apata",
                "Ariori",
                "Ariya",
                "Aro/Akuo",
                "Atawin",
                "Ati",
                "Atiku",
                "Ayede",
                "Babadudu",
                "Bale",
                "Bante Owo",
                "Bielesin",
                "Budo",
                "Budo Agbe",
                "Budo Oke",
                "Budo-Abu",
                "Budo-Are",
                "Dada",
                "Daya",
                "Egberioma",
                "Ejidogemi",
                "Ejidongari",
                "Eleja",
                "Elelu",
                "Eleni",
                "Elere",
                "Elesin Nla",
                "Ero",
                "Faje",
                "Fanto",
                "Fayabale",
                "Gaa Aginbso",
                "Gaa Dare",
                "Gaa Jodama",
                "Gado",
                "Gambo",
                "Gbanbalako",
                "Gboro",
                "Idi-Ose",
                "Igbira",
                "Igbo-Emu",
                "Igboemu",
                "Ige",
                "Iju-Owa",
                "Ilu-Fenwa",
                "Ita Giwa",
                "Ita-Alade",
                "Jafe",
                "Jodoma",
                "Jokolu",
                "Koleke",
                "Labaje",
                "Lagbaja",
                "Laigbe",
                "Lamudebo",
                "Matanmi",
                "Odentan",
                "Odentan-Ile",
                "Odentan-Olulu",
                "Odun-Ade",
                "Ogunbo",
                "Ogunbo-Akamu",
                "Oguntulu",
                "Okanla",
                "Okoko",
                "Okuta-Ogun",
                "Okutala",
                "Oladolo",
                "Olaya",
                "Olokiti",
                "Onigbera",
                "Onile-Aro",
                "Owu-Dudu",
                "Rofese",
                "Saja",
                "Sami",
                "Sheji",
                "Sunmela",
                "Lanwa",
                "Adio",
                "Afari-Ogun",
                "Agbeka",
                "Aiyelekan",
                "Alufa-Ojerere",
                "Apata Oko",
                "Arere",
                "Arola",
                "Awesu",
                "Awokunle",
                "Bako",
                "Bi-Elesin",
                "Biala",
                "Biribiri",
                "Bode-Saadu",
                "Budo Gaa",
                "Budo Kawu",
                "Budo Oloye",
                "Budo-Ayan",
                "Budo-Oba",
                "Buka",
                "Dalemo",
                "Daudu",
                "Elemaso",
                "Fala",
                "Fangan",
                "Fulani",
                "Gambe Alagbede",
                "Ganbe",
                "Gata",
                "Gbudugu",
                "Idiapa",
                "Idowu",
                "Irobo",
                "Isakara",
                "Iyare",
                "Jebba",
                "Kabba",
                "Koronwon",
                "Korowa",
                "Ladabu",
                "Lamigan",
                "Lasaki",
                "Maya",
                "Obate",
                "Oke-Aje",
                "Okemi",
                "Ologun",
                "Oloye",
                "Olukowi",
                "Omoda",
                "Oni Pako",
                "Onibembe",
                "Orogun",
                "Pawo",
                "Shaki",
                "Sulu",
                "Were",
                "Yesele",
                "Malete",
                "Abe-Igba",
                "Abe-Ope",
                "Abeelu",
                "Abeokuta",
                "Abo",
                "Abuyanrin",
                "Adanduro",
                "Adejinmi",
                "Adetinmi",
                "Agar",
                "Agbaku",
                "Agga",
                "Ago",
                "Agobarade",
                "Agosoja",
                "Ahere",
                "Ajagbe",
                "Ajagunle",
                "Ajanaku",
                "Ajelanwa",
                "Akata",
                "Alagogo",
                "Alakasu",
                "Alapo",
                "Alaro",
                "Alaya",
                "Alere",
                "Aluga",
                "Amao",
                "Aoodu",
                "Asalapa",
                "Asipa",
                "Baba Tapa",
                "Batamu",
                "Bube",
                "Bulamu",
                "Busamu",
                "Dafari",
                "Elebenla",
                "Eleburu",
                "Elefere",
                "Elepo Agbaku",
                "Epo",
                "Gaa Abiyo",
                "Gaa Adejinmi",
                "Gaa Aiyekale",
                "Gaa Ajagbe",
                "Gaa Alakasa",
                "Gaa Alapo",
                "Gaa Asipa",
                "Gaa Bube",
                "Gaa Bulo Alfa",
                "Gaa Igbo-Onisu",
                "Gaa Jehun Kunnu",
                "Gaa Kekere Ekun",
                "Gaa Larama",
                "Gaa Logun",
                "Gaa Malete",
                "Gaa Oyedele",
                "Gaa Panbo",
                "Gaa Seko",
                "Gbugudu",
                "Ida-Isaa",
                "Idiagano",
                "Idiape",
                "Igbo-Onishin",
                "Igbo-Riku",
                "Ihoo",
                "Jehunkunnu",
                "Jododo",
                "Karibuje",
                "Kawu",
                "Kekere Ekun",
                "Kogbala",
                "Kondondo",
                "Lamula",
                "Logun",
                "Marafa",
                "Obalaja",
                "Obale",
                "Oboku",
                "Ogala",
                "Ogungbe",
                "Ojutaye",
                "Okete",
                "Okoru",
                "Olo Runshola",
                "Olobi",
                "Olodan",
                "Oloko",
                "Oloungbona",
                "Olowo",
                "Olowu-Remi",
                "Omoni Araro",
                "Omoni Etile",
                "Onidoyin",
                "Onigba",
                "Oniko",
                "Onikoko",
                "Onilende",
                "Onilu",
                "Opanda",
                "Owode",
                "Paku",
                "Panbo",
                "Panpo",
                "Poupoju",
                "Shao",
                "Tegbesun",
                "Oloru",
                "Abamba",
                "Abati",
                "Abilude",
                "Abiodun",
                "Aboya",
                "Abuala",
                "Abudala",
                "Adama",
                "Adunmode",
                "Agba",
                "Agbede I",
                "Agbede II",
                "Agbogun",
                "Ago Ontolotolo",
                "Agogoja",
                "Ajegunle",
                "Ajisaye",
                "Akapo",
                "Akata Elelu",
                "Akata Kojere",
                "Akilotan",
                "Akiri Manu",
                "Alagangan",
                "Alagbo",
                "Alagogo-Weru",
                "Alaje Alajo",
                "Alaka",
                "Alakara",
                "Alama",
                "Alapa Sanpa",
                "Alarara Alaje",
                "Alate",
                "Alateko",
                "Alawuyan",
                "Alega",
                "Amma",
                "Anifowose",
                "Aniya",
                "Apo",
                "Aro",
                "Arobadi",
                "Asawure",
                "Asogba",
                "Asunnara",
                "Awuyan",
                "Ayifo",
                "Ayigoro",
                "Babaloke",
                "Bacita Junction",
                "Bagbenu",
                "Baki",
                "Balogun",
                "Barama",
                "Beli",
                "Binukonu",
                "Bosamo Akeremi",
                "Budo Alafa",
                "Budo Ale Banda",
                "Budo Eko",
                "Budo Loke",
                "Budo Ode",
                "Budo Ojo Amari",
                "Budo Ojude",
                "Budo Oki",
                "Budo Ole",
                "Budo-Ode",
                "Dagoji",
                "Daji",
                "Deseni",
                "Egboelemi",
                "Ejin",
                "Elebekan",
                "Elebu",
                "Elega",
                "Elegun",
                "Eleja Raji",
                "Elejola",
                "Elewure",
                "Eniadunma",
                "Ewuji",
                "Gaa Agbaku",
                "Gaa Alhaji Bamo",
                "Gaa Alogbo",
                "Gaa Apo",
                "Gaa Barama",
                "Gaa Eletu",
                "Gaa Gboroko",
                "Gaa Igbo Elemi",
                "Gaa Jouro",
                "Gaa Jowuro",
                "Gaa Kanike",
                "Gaa Lawoyin",
                "Gaa Olopele",
                "Gaa Osinginmi",
                "Gaa Tepadu",
                "Gaa Worunkure",
                "Gareji",
                "Gbada",
                "Giwa Olowo",
                "Gudu",
                "Gunniyan",
                "Ibagun",
                "Idi Apa",
                "Igbo-Elemi",
                "Igboede",
                "Igboroko",
                "Inawole",
                "Isale-Oja",
                "Ita Yanmuyanmu",
                "Iyanakere",
                "Jokoro",
                "Jopoko",
                "Kibo-Alufa",
                "Kulende",
                "Kunmi",
                "Ladoyin",
                "Lahila",
                "Lanle Gidado",
                "Lanwa Ojo",
                "Laonu",
                "Magaji",
                "Manlare",
                "Mari",
                "Megidaju",
                "Meri-Oja",
                "Miraya",
                "Odonigi",
                "Ogan",
                "Oke Awuyan",
                "Oke Dare",
                "Oke Olori",
                "Oke-Bode",
                "Oke-Itta",
                "Okiarenu",
                "Olege",
                "Olododo",
                "Ologbojo",
                "Olokotintin",
                "Olopan",
                "Olopan Olori",
                "Olopanfo",
                "Olori",
                "Olorisogi",
                "Olorogbo",
                "Olorunlana",
                "Olose",
                "Olowo Bale",
                "Olowo Hanman",
                "Olowo Kareem",
                "Olowode",
                "Oloworu",
                "Omidaro",
                "Onigbese",
                "Oniparo",
                "Onipede",
                "Onisun",
                "Onisunju",
                "Oniwa",
                "Ori-Oke Yahaya",
                "Orioke",
                "Orogungan",
                "Osinginmi",
                "Oteleko",
                "Paiye",
                "Popola",
                "Salako",
                "Sangote",
                "Sipata",
                "Somape",
                "Taru",
                "Temidire Olupo"
            ],
            "offa": [
                "Adeleke",
                "Ago Daniel",
                "Ago Gbada",
                "Ago Ilobu",
                "Ago Isola",
                "Ago Maleki",
                "Ago Mogaji",
                "Ago Offa",
                "Ahogbada",
                "Ajegunle",
                "Ajelanwa",
                "Ajoko",
                "Alabanle",
                "Alabere",
                "Alagi",
                "Alao",
                "Alase",
                "Alaya",
                "Alayin",
                "Alayin Aleyin",
                "Alebale",
                "Aleniboro",
                "Apara",
                "Aperin",
                "Asaoye",
                "Asapate",
                "Asipa",
                "Awesu",
                "Awoniyi",
                "Ayekale",
                "Ayeni",
                "Bale Oke Aro",
                "Bolorunduro",
                "Buraimoh",
                "Ekesin Funfun",
                "Eleeku",
                "Erin-Osun",
                "Erinle",
                "Faje",
                "Falokun Jogun",
                "Falokun Owode",
                "Fibike",
                "Gaa Momodu",
                "Galiadi",
                "Ganmo Oko",
                "Gbosura",
                "Gudugba",
                "Igbaweere",
                "Igbo Idun",
                "Igbo Ilofa",
                "Ila Market Station",
                "Ilasa",
                "Ilemona",
                "Inaja Alaro",
                "Inaja Maliki",
                "Ira",
                "Kere Aje",
                "Offa"
            ],
            "oke-ero": [
                "Ekan Meje",
                "Ayedun",
                "Eken",
                "Erinmope",
                "Ilale",
                "Imoji",
                "Idofin",
                "Idofin Odo-Ashe",
                "Idofin-Aiyekale",
                "Idofin-Eyinafo",
                "Idofin-Igbana",
                "Idofin-Odo-Afo",
                "Idofin-Odoaga",
                "Ilofa/Odo-Owa",
                "Ilofa",
                "Odo-Owa"
            ],
            "oyun": [
                "Odo-Ogun",
                "Afijagbade",
                "Agara",
                "Agbamu",
                "Agbo Maja",
                "Ago Balomi",
                "Ago Offa",
                "Ago Olomaba",
                "Aho Igbada",
                "Aje Boki",
                "Ajebandele",
                "Ajekunle",
                "Ajoko",
                "Alaya",
                "Alentbaro",
                "Anaja Moliki",
                "Aponpa",
                "Araromi",
                "Asaoye",
                "Asipa",
                "Asopata",
                "Ayobiamo",
                "Bakini",
                "Belore",
                "Bude Peke",
                "Dake",
                "Dalemo",
                "Ejedilogun",
                "Eleku",
                "Elesin Funfu",
                "Erin-Ile",
                "Fibike",
                "Fufu",
                "Gbolowuduro",
                "Idi Osa",
                "Igberi Ogun",
                "Igberi Osa",
                "Igbo-Alu",
                "Igbona",
                "Igosun",
                "Ile Mogun",
                "Ilemona",
                "Inaja Alaro",
                "Ipe",
                "Ira",
                "Jingini",
                "Kajola",
                "Kamumu",
                "Kolo",
                "Laniyan",
                "Mandol",
                "Odo Ogun",
                "Odowo",
                "Oginte",
                "Ojutaiye",
                "Okelede",
                "Okeogun",
                "Ologuro",
                "Olomi",
                "Olomitaka",
                "Onisapa",
                "Osere",
                "Owode",
                "Parioro",
                "Ramonu",
                "Romode",
                "Sakongba",
                "Somoda",
                "Tabi Olowo",
                "Togun",
                "Oke-Ogun",
                "Adeleke",
                "Ago Aminu",
                "Ago Fulani Jimoh",
                "Apata Aje",
                "Aperun",
                "Awoniyi",
                "Ayeni",
                "Bamo-Oko",
                "Budo",
                "Eleeku",
                "Elemo Ogun",
                "Falokun",
                "Foje",
                "Gamo",
                "Giiji",
                "Goro",
                "Gudugbo",
                "Igagbo",
                "Igbodun",
                "Igbotele",
                "Ijagbo",
                "Ikotun",
                "Ilota",
                "Ipee",
                "Iwoye",
                "Iyeke",
                "Kere Ige",
                "Labisi",
                "Laro",
                "Mosunkare",
                "Ogakunrin",
                "Ogunde",
                "Ojoku",
                "Oke-Ari",
                "Oke-Lala",
                "Oke-Oye"
            ],
            "Pategi": [
                "Kpada",
                "Babogi",
                "Bide",
                "Dagbalode",
                "Dkatsa",
                "Dode",
                "Duro",
                "Ebu",
                "Eka-Cheja",
                "Etchiwada",
                "Etsuvum Emiworogi",
                "Etusuyum",
                "Ezhigike",
                "Fei",
                "Fuma",
                "Gakpan",
                "Gbafa",
                "Gbagufa",
                "Gheti",
                "Gubgi",
                "Guluki",
                "Kajita",
                "Koji",
                "Kokingu",
                "Kokoparagi",
                "Koripkin",
                "Koro",
                "Kpatagba",
                "Kusegi",
                "Kusoti",
                "Latagi",
                "Lubaman",
                "Ma Agi",
                "Maba",
                "Mamba",
                "Mandzigakwa",
                "Mashan",
                "Matotun",
                "Mongi",
                "Mosin",
                "Nimbe",
                "Okusogi",
                "Pati",
                "Reshe",
                "Rokan Kuse",
                "Rokan Tunga",
                "Rokoggi",
                "Sa'Agi",
                "Saiasi",
                "Suku",
                "Szuruta",
                "Tankpatu",
                "Tbadan",
                "Tebe",
                "Tsanba",
                "Tutugi",
                "Vuma",
                "Wadata Duro",
                "Wake",
                "Yagbagi",
                "Yagbagi Roko",
                "Zhiswara",
                "Zunuta",
                "Lade",
                "Bissan",
                "Chenegi",
                "Chitta",
                "Danikun",
                "Dengi",
                "Dina",
                "Dzake",
                "Edegi-Chapa",
                "Ekakpan",
                "Ekati",
                "Esun",
                "Gada-Wdake",
                "Gadavozuwa",
                "Gadaworo",
                "Gbangede",
                "Gbangede Bologi",
                "Gberi",
                "Gbodo",
                "Gbodoniji",
                "Ilua",
                "Kagewegi",
                "Kakafu",
                "Kokodo",
                "Kusokoti",
                "Lalagi",
                "Lata",
                "Lille",
                "Magya",
                "Mawagi",
                "Okpoto",
                "Okuluse",
                "Sagnuwan",
                "Sakpefu",
                "Sansita",
                "Szwajiwo",
                "Yekosa",
                "Charikpan",
                "Dangifu",
                "Edegi Ekpasananke",
                "Edozhigi",
                "Ellah",
                "Emigi",
                "Esungi",
                "Gabi Ward",
                "Gada",
                "Gada-Bazuwa",
                "Gamejefu",
                "Gbade Pati",
                "Gbadekin",
                "Gbaradego",
                "Gbogi",
                "Geduragi",
                "Kolushin-Egboro",
                "Koshiworo",
                "Kparumagi",
                "Kpayi",
                "Kpotun",
                "Kpotwa",
                "Kusogi",
                "Lagada",
                "Lanlegi",
                "Lazgi Yissa",
                "Likefu",
                "Makun Ward",
                "Nawogi",
                "Ndeji Ward",
                "Opta-Wgboro",
                "Ragada",
                "Rifun",
                "Sheshi Sahaaba Ward",
                "Shesihi Tsaha",
                "Taadza Ward",
                "Tsaduke Ward",
                "Tswatagi",
                "Wando",
                "Yabinti"
            ]
        }
    },
    {
        "Lagos": {
            "Agege": [
                "Agbotikuyo",
                "Dopemu",
                "Darocha",
                "Iloro",
                "Onipetesi",
                "Isale Odo",
                "Isale",
                "Idimangoro",
                "Keke",
                "Okekoto",
                "Oniwaya",
                "Papa-uku",
                "Ori",
                "Orile Agege/oko Oba",
                "Oyewole/papa Ashafa",
                "Tabon Tabon/oko Oba",
                "Orile Agege",
                "Ido Aadun",
                "Isale Odan",
                "Ido Gaun",
                "Ipodo",
                "Aaromi (Araromi)",
                "Ido Aagbosu",
                "Magbon",
                "Mulero",
                "Onilekere",
                "Masaku",
                "Ganganja",
                "Ogba",
                "Ashade",
                "Alausa",
                "Agbede",
                "Adekunle",
                "Operekete",
                "Akinode",
                "George"
            ],
            "Ajeromi-Ifelodun": [
                "Ashafa",
                "Awodi",
                "Ajegunle",
                "Aiyetoro Ajeromi",
                "Araromi Ajeromi",
                "Cardoso",
                "Orodu",
                "Temidire",
                "Onibaba",
                "Layeni",
                "Tolu"
            ],
            "Alimosho": [
                "Alimosho",
                "Alakuko",
                "Alagbado",
                "Ayobo",
                "Egbe",
                "Egbeda",
                "Idimu",
                "Ije Ododo",
                "Ijegun",
                "Ikotun",
                "Ipaja",
                "Isheri Olofin",
                "Oke Odo",
                "Shasha"
            ],
            "Amuwo-Odofin": [
                "Amuwo",
                "Amuwo Odofin Estate",
                "Bassa",
                "Beshi",
                "Elachi",
                "Festac Town",
                "Ibasa",
                "Ibese",
                "Igbo Ejoz",
                "Igbolobi",
                "Igbologun",
                "Ikare",
                "Ilasa",
                "Ilashe",
                "Imore",
                "Irede",
                "Isunba",
                "Kirikiri",
                "Lashe",
                "Okun-Ibese",
                "Olute",
                "Porto Novo Creek",
                "Satellite Town",
                "Trade Fair Complex",
                "Volkswagen"
            ],
            "Apapa": [
                "Abule Nla",
                "Ajegunle",
                "Apapa Quays",
                "Badia",
                "Ibafon",
                "Ijora",
                "Ijora Olopa",
                "Tincan Island"
            ],
            "Badagry": [
                "Afowo Doforo",
                "Agaw Awusa",
                "Age Mowo",
                "Ago Hausa",
                "Agonrin",
                "Ahanfe",
                "Ajara",
                "Ajara Agamaden",
                "Ajido",
                "Akarakumo",
                "Akawkaw",
                "Akoko",
                "Ale",
                "Angorin",
                "Apa",
                "Appa",
                "Asepe-Musin",
                "Badagry",
                "Doforo",
                "Epe",
                "Gan'ingbo",
                "Ganme",
                "Gbaji",
                "Gbanko",
                "HenumeIbiku",
                "Igborosun",
                "Ikawga",
                "Ilogbo",
                "Imeke",
                "Iragbo",
                "Iragon",
                "Itawga",
                "Itoga",
                "Iyafin",
                "Kese",
                "Komi",
                "Kveme",
                "Kweme",
                "Magbon",
                "Moba",
                "Morogbo",
                "Mosafejaw",
                "Mosafejo",
                "Mowo",
                "Obele",
                "Ogungbe",
                "Oluge Lagoon",
                "Pasi",
                "Pota",
                "River Imede",
                "Ropoji",
                "Tawpo",
                "Topo",
                "Weshere",
                "Wuru",
                "Yewa",
                "Zinvie"
            ],
            "Epe": [
                "Epe",
                "Ejirin",
                "Imota",
                "Ibeju",
                "Ijebu-Ode (part of it falls within Epe)",
                "Oke-Odo",
                "Oke-Ira",
                "Orimerunmu",
                "Poka",
                "Sabo"
            ],
            "Eti-Osa": [
                "Ajah",
                "Ajao Estate",
                "Lekki",
                "Victoria Island"
            ],
            "Ibeju-Lekki": [
                "Ajah",
                "Badore",
                "Dolphin Estate",
                "Eleko",
                "Ibeju",
                "Ikota",
                "Jakande Estate",
                "Lekki",
                "Magbon Alade",
                "Oko-Ajao",
                "Orimedu",
                "Victoria Island Extension"
            ],
            "Ifako-Ijaye": [
                "Iju",
                "Obawole",
                "Ojokoro",
                "Ifako",
                "Ijaiye",
                "Agege",
                "Ogba",
                "Pen Cinema"
            ],
            "Ikeja": [
                "Agidinbi",
                "Aguda",
                "Alausa",
                "Allen",
                "Erunkan",
                "Idi Mangoro",
                "Ikeja",
                "Ikeja Gra",
                "Ikosi Ketu",
                "Isheri",
                "Ketu",
                "Maryland",
                "Mile 12",
                "Oba Akran",
                "Ogba",
                "OjoduOlowora",
                "Opebi",
                "Oregun"
            ],
            "Ikorodu": [
                "Agbaku",
                "Agbede",
                "Agunfoye",
                "Ajebaw",
                "Ajebo",
                "Baiyeku",
                "Berre",
                "Gberigbe",
                "Gbokuta",
                "Ibere",
                "Ibeshe",
                "Igbopa",
                "Ijede",
                "Ikorodu",
                "Imawte",
                "Imota",
                "Ipanmi",
                "Isawo",
                "Isiu",
                "Isiwu",
                "Ita",
                "Janoke",
                "Maya",
                "Mowo Kekere",
                "Ofin",
                "Oguntoye",
                "Ojagemaw",
                "Ojagemo",
                "Oke-Lisa",
                "Oko Ito",
                "Oko-Itaw",
                "Oyewaw",
                "Salabaw"
            ],
            "Kosofe": [
                "Maryland",
                "Ojota",
                "Alapere",
                "Orisigun",
                "Ajelogo",
                "Akanimodo",
                "Ikosi",
                "Ketu",
                "Oworonshoki",
                "Mende",
                "Ifako",
                "Sholuyi",
                "Anthony village",
                "Ajao Estate",
                "Ogudu",
                "Mile 12",
                "Ayedere",
                "Gbagada",
                "Isheri",
                "Olowora",
                "Shangisha",
                "Magodo phase 1",
                "Magodo Phase 2",
                "Agboyi 1",
                "Agboyi 2",
                "Owode Onirin",
                "Ajegunle",
                "Odo-Ogun"
            ],
            "Lagos Island": [
                "Ajao Estate",
                "Apongbon",
                "Coker",
                "Idumota",
                "Lagos Island",
                "Oke-Popo",
                "Tinubu Square"
            ],
            "Lagos Mainland": [
                "Ebute Metta",
                "Fadeyi",
                "Ikorodu",
                "Iponri",
                "Jibowu",
                "Lafiaji",
                "Maroko",
                "Mende",
                "Mushin",
                "Oyingbo",
                "Shomolu",
                "Surulere",
                "Yaba",
                "Mainland"
            ],
            "Mushin": [
                "Alakara",
                "Babalosa",
                "Babalosa/idi-araba",
                "Idi-araba",
                "Idi-oro/odi-olowu",
                "Ilasamaja",
                "Ilupeju",
                "Ilupeju Industrial Estate",
                "Itire",
                "Kayode/fadeyi",
                "Mushin/atewolara",
                "Ojuwoye",
                "Olateju",
                "Papa-ajao"
            ],
            "Ojo": [
                "Ajangbadi",
                "Ajao Estate",
                "Amuwo Odofin",
                "Badagry Expressway",
                "Iba",
                "Igbede",
                "Ijanikin",
                "Ijegun",
                "Ojo",
                "Ojo Alaba",
                "Ojo Town"
            ],
            "Oshodi/Isolo": [
                "Ajao Estate",
                "Ejigbo",
                "Ilasamaja",
                "Isaga Tedo",
                "Isheri Osun",
                "Isolo",
                "Mafoluku Oshodi",
                "Orile Oshodi",
                "Shogunle"
            ],
            "Shomolu": [
                "Somolu",
                "Bashua",
                "Bariga",
                "some parts of Akoka",
                "Igari",
                "Obanikoro",
                "Pedro village",
                "Abule Okuta",
                "Seriki village",
                "Apelehin",
                "Ilaje"
            ],
            "Surulere": [
                "Ojuelegba",
                "Shitta",
                "Ogunlana",
                "Orile",
                "Ikate",
                "Ibire",
                "Adeniran",
                "Ogunsanya",
                "Gbaja"
            ]
        }
    },
    {
        "Nasarawa": {
            "Akwanga": [
                "Ancio Babba",
                "Ancho Babba",
                "Anjagwa",
                "Andaha",
                "Gugyar",
                "Mochu",
                "Angwan Zaria",
                "Moroa",
                "Anjida",
                "Akwandar",
                "Bakin Kogi",
                "Boher",
                "Nigo",
                "Rija",
                "Gudi",
                "Aricha",
                "Gwadi",
                "Gwanje",
                "Gbuje",
                "Gbunchu",
                "Kambre",
                "Kurmin Tagwaye",
                "Nigha'an",
                "Anji",
                "Arum",
                "Beki-Riga",
                "Katanza",
                "Nidan",
                "Numa",
                "Pam-Pam",
                "Nunku",
                "Gbujah",
                "Goho",
                "Nunku Chun"
            ],
            "Awe": [
                "Abuni",
                "Awe",
                "Gadadima-Awe",
                "Kanje",
                "Kekura",
                "Kofin Moye",
                "Madakin Awe",
                "Magaji M. Awe",
                "Makwangiji Awe",
                "Azaara",
                "Akiri",
                "Arubagu",
                "Azara",
                "Mauakin Azara",
                "Ribi",
                "Wuse",
                "Tunga",
                "Barkano",
                "Baure",
                "Booga",
                "Gidrin Kadai",
                "Hassan Gayam",
                "Jagan Gari",
                "Jangara",
                "Tsohon Tunga"
            ],
            "Doma": [
                "Agwashi",
                "Adadu",
                "Aguma",
                "Akiwata",
                "Akptta",
                "Doma",
                "Alagyy",
                "Alagye",
                "Ana",
                "Arege",
                "Burumburum",
                "Ruru",
                "Doka",
                "Gidan Rai",
                "Yelwa",
                "Awuse",
                "Gwanshigid",
                "Kwarra",
                "Okuba",
                "Osabonya",
                "Osote",
                "Wunge",
                "Agyema",
                "Akpanaja",
                "Ankana",
                "Equd Adori",
                "Rukubi"
            ],
            "Eggon": [
                "Alongani",
                "Agunji",
                "Alogani",
                "Angbaku - Krami",
                "Angbaku Buba",
                "Arikpa",
                "Ezzen",
                "Galle",
                "Gbamze",
                "Ogba",
                "Ogbagi",
                "Wakama",
                "Wogan",
                "Eggon Mada Station",
                "Aboshon",
                "Alushi",
                "Awunza",
                "Burum - Burum",
                "Ekpan",
                "Ekpon",
                "Endehu",
                "Gaji",
                "Ginda",
                "Igeah",
                "Ikka",
                "Kagbu Ero",
                "Kudugba",
                "Lambaga",
                "Landama Onzu",
                "Lizzin Keffi",
                "Ubbe",
                "Wachuku",
                "Wana",
                "Wangibi",
                "Washo",
                "Wata",
                "Whazan",
                "Wolaga",
                "Wollon",
                "Women",
                "Wulko",
                "Umme",
                "Alizaga",
                "Arugbadu",
                "Bakyano",
                "Sako"
            ],
            "Karu": [
                "Gitata",
                "Abam",
                "Abui",
                "Achak",
                "Ago",
                "Agwan Sauyi",
                "Akwaf",
                "Ang. Paparo",
                "Ang. Payasha",
                "Ang. Wayo",
                "Anguwa-Ayaba",
                "Angwa Maje",
                "Angwan Alura",
                "Angwan Gyara",
                "Ankara",
                "Ankoma",
                "Ankomaa",
                "Ankuta",
                "Auta",
                "Bagaji",
                "Bunkusa",
                "Dakuma",
                "Dangwa",
                "Dogon Daji",
                "Duaro",
                "Dutsen Gogo",
                "Gaibo",
                "Garamba",
                "Gardi",
                "Gid Bagobiri",
                "Gidan Alhassan",
                "Gidan Bugobiri",
                "Gidan Dogo",
                "Gidan Kiso",
                "Gidan-Allura",
                "Gunduma",
                "Gwalaji",
                "Iatara",
                "Jaba Panda",
                "Jemage",
                "Jimagen Mada",
                "Kajin",
                "Kare",
                "Kawo",
                "Kogintaro",
                "Kogon Masha",
                "Kondoro",
                "Kondoro-Yeskwa",
                "Kuban",
                "Kube",
                "Kubere",
                "Kuda",
                "Kuda-Yeskwa",
                "Kukan",
                "Kukok-Gardi",
                "Kukuri",
                "Kunan",
                "Kurmin Giwa",
                "Kwagiri",
                "Kwaso",
                "Lengwanpa Koro",
                "Padan Gwari",
                "Panda",
                "Panigbe",
                "Paperi",
                "Rafin Pa'a",
                "Shadami",
                "Shinkafa",
                "Takalafia",
                "Tanga",
                "Tudu Uku",
                "Tudun-wada",
                "Zang Gitata",
                "Zungon Gitata",
                "Karshi",
                "Ang. Maiganga",
                "Bakin Kogi",
                "Dansa",
                "Jijefe",
                "Kabeni",
                "Katal",
                "Kurafe",
                "Kwatarma",
                "Piyanku",
                "Rafin Kwara",
                "Sabon Layi",
                "Ang. Rana",
                "Anta Ba Laifi",
                "Aso Pada",
                "Auta Gurgi",
                "Bakin Ado I",
                "Guata",
                "Gurku",
                "Jan Kanwa",
                "Jikwai",
                "Kabusu",
                "Kalbo Mada",
                "Karu",
                "Katare",
                "Kofa",
                "Kucikau",
                "Kufe",
                "Kugwaru",
                "Kurman Daura",
                "Lakwa",
                "Liguda",
                "Mararaban-Gurku",
                "Masaka",
                "Nassarawa Bada",
                "Pakin Ado II",
                "Timutna",
                "Yayan Gwandara",
                "Yelwan Sobo",
                "Uke",
                "Agada",
                "Ang Bako",
                "Ang. Chediya",
                "Ang. Gwandara",
                "Ang. Jaba",
                "Ang. Kade",
                "Ang. Kura",
                "Ang. Madugu",
                "Ang. Malam",
                "Ang. Saka",
                "Ang. Shaho",
                "Ang. Shamaki",
                "Ang. Soji",
                "Ang. Tandu",
                "Ang. Toni",
                "Ang. Tudu",
                "Ang. Waya",
                "Ang. Zakara",
                "Badiko",
                "Bako",
                "Dauduwa",
                "Dorawa",
                "Dorawan Kunu",
                "Eshi",
                "Gidan Biri",
                "Gidan Kwaro",
                "Gidan Liman",
                "Gidan Rai",
                "Gidan Saka",
                "Gidan Sarki Noma",
                "Gidan Shaho",
                "Gora",
                "Gwagwa",
                "K/Gwandara",
                "Kadaki",
                "Katun Mada",
                "Keffi Shanu",
                "Madubi",
                "Magajin Gari",
                "Murai",
                "Nike",
                "Roguwa",
                "Saka",
                "Shata",
                "Tsakani",
                "Tudun Wada",
                "Tundun Uku",
                "Yelwa"
            ],
            "Keana": [
                "Aloshi",
                "Agaza",
                "Omogade",
                "Giza",
                "Agbari Agbashu",
                "Akuna",
                "Gaskawa",
                "Odapu Ogaji",
                "Keana",
                "Kadarko",
                "Abubakar-Isaleku",
                "Kwara"
            ],
            "Keffi": [
                "Keffi (Rural)",
                "Ang. Salabu",
                "Anguwan Jaba",
                "Anguwan Maiganga",
                "Anguwan-Lambu",
                "Dan Dabi",
                "Fagidi",
                "Ganta",
                "Gidan-Kare",
                "Jigwada",
                "Kaibo Mada",
                "Sabon Gari",
                "Saura",
                "Tila",
                "Tunayi",
                "Yar Kadde"
            ],
            "Kokona": [
                "Kokona",
                "Agwada",
                "Ajuye",
                "Akolo",
                "Akware",
                "Amaha",
                "Amba",
                "Ambase",
                "Ang. Arume",
                "Ang. Doka",
                "Ang. Magaji",
                "Ang. Mai Nasara",
                "Ang. Mai Sauri",
                "Ang. Yaro",
                "Ang. Zabuwa",
                "Apawu",
                "Arusu",
                "Atama",
                "Audun Galadima",
                "Auguwan Kuramai",
                "Bakin Ayeni",
                "Bassan Zarangi",
                "Bazariye",
                "Dari",
                "Doma",
                "Endo",
                "Garaku",
                "Gate",
                "Gidan Sarkin",
                "Gidan-Mal Ugo",
                "Gudindi",
                "Gungu",
                "Gunka",
                "Gurgu",
                "Hadar",
                "Igwo",
                "Jama-Agayan",
                "Jenta",
                "Kabugu",
                "Kafanchan Mada",
                "Kana",
                "Kandare",
                "Karu-Mada",
                "Kodo",
                "Kubero",
                "Kufan Gwari",
                "Kundami",
                "Kurmin Shinkaf",
                "Kuture",
                "Lamingan Janjala",
                "Lokogoma",
                "Mahuta",
                "Marke",
                "Maro",
                "Maute",
                "Ninkoro",
                "Noma",
                "Rafin Gabas",
                "Sabon Gida",
                "Sakwato",
                "Shabu",
                "Tatara Mari",
                "Uken Bassa",
                "Yelwan Bassa",
                "Yelwan Mai-Taba"
            ],
            "Lafia": [
                "Assakio",
                "Abu",
                "Achigogo",
                "Adogi",
                "Agbulagu",
                "Akura",
                "Akuya",
                "Alawa-Gana",
                "Ambana",
                "Andasin",
                "Aridi",
                "Arikya",
                "Arugbadu",
                "Ashangwa",
                "Ashige",
                "Awuwa",
                "Azuba",
                "Barikin Abdullahi",
                "Barkin Kogi",
                "Danka",
                "Fefe Ruwa",
                "Gidan-Aiki Ajiga",
                "Giddan Akeffi",
                "Gilan Buka",
                "Godam Mai",
                "Gwayaka",
                "Jibel",
                "Keffi Wambai",
                "Kiguna",
                "Kireyi",
                "Koro Kuje",
                "Kwandere",
                "Mankwar",
                "Padaman-Bauna",
                "Padan Bauwa-Alh Audu",
                "Rafin Ganye",
                "Randa",
                "Sabon Gida",
                "Shabu",
                "Shimar",
                "Tunga Nupawa",
                "Ugah",
                "Wanza",
                "Wata",
                "Wuyi",
                "Zagyo",
                "Zambal",
                "Angbako",
                "Ashapa",
                "Awuma",
                "Awuye",
                "Bakin-Gudi",
                "Ruwaya",
                "Takpa-Ozzi",
                "Lafia (Rural)",
                "Agabija",
                "Agudu",
                "Agyarag Yakubu",
                "Agyaragu To",
                "Akunza",
                "Akurba",
                "Akurba Asanya",
                "Alakyo",
                "Angwa Ayaba",
                "Bassa",
                "Bukan Allu",
                "Bukan Buzu",
                "Bukan Kwato",
                "Bukan Sidi",
                "Bukan Tambo",
                "Chiroma",
                "Gandu Sarki",
                "Gayam",
                "Gimare",
                "Gudu Sarki",
                "Kan Ashara",
                "Kayarda",
                "Kurikyo",
                "Lachuce",
                "Lahuce",
                "Madagwa",
                "Mararaba",
                "Sabo Dale",
                "Wakwa",
                "Zanwa"
            ],
            "Nasarawa": [
                "Loko",
                "Aguba",
                "Aissa",
                "Angewa",
                "Ataga",
                "Ayele",
                "Aza",
                "Bakono",
                "Dora",
                "Guto",
                "Gwafa",
                "Hamsin-Hamsin",
                "Illa",
                "Illshan-Kasa",
                "Mai Yawa",
                "Oshugun",
                "Rafin Sita",
                "Tunga",
                "Uke",
                "Zangon-Daji",
                "Agoi",
                "Ara",
                "Araba",
                "Dansa",
                "Gida Biri",
                "Gidan S/Wari",
                "Gogon Dutse",
                "Gudigi",
                "Gunki",
                "Kampanu",
                "Kurudu",
                "Laminga",
                "Marmara",
                "Marrarabar Ara",
                "Nahuche",
                "S/Garin",
                "Saukan-Ara",
                "Shamage",
                "Tammah",
                "Tulluwa",
                "Zabutu",
                "Zaku Bello",
                "Zaku Sarki",
                "Udege",
                "Afura",
                "Agam",
                "Akum",
                "Amaku",
                "Andewayo",
                "Apawu",
                "Endo",
                "Gidan Zabutu",
                "Itta",
                "Kama Otto",
                "Kana",
                "Marraraban",
                "Odu",
                "Ombi",
                "Ube",
                "Udege Kasa",
                "Udegi",
                "Udenin Gida",
                "Udenin Magaji",
                "Useni",
                "Yelwa"
            ],
            "Obi": [
                "Adudu",
                "Agwatashi",
                "Akanga",
                "Atabara",
                "Daddere",
                "Dedere",
                "Obi",
                "Zhemegli",
                "Abiuga",
                "Agrugwa",
                "Agwade",
                "Agyaragu",
                "Ajeregwa",
                "Akaba",
                "Akaleku",
                "Akunza Migula",
                "Akwanka",
                "Angantiv",
                "Angwan-Madaki",
                "Ashiga",
                "Ashipe",
                "Atu Kwasa",
                "Baba",
                "Dazillah",
                "Duduguro",
                "Echiechene",
                "Eregwa",
                "Eshugu",
                "Gidan Ausa",
                "Gwadanya",
                "Idevi",
                "Kwashiri",
                "Kyakale",
                "Mutum Daya",
                "Sabo",
                "Tabula",
                "Umah"
            ],
            "Toto": [
                "Gada",
                "Abebasen",
                "Akureba",
                "Akwashi",
                "Araba",
                "Buga",
                "Buke",
                "Daji",
                "Dajio",
                "Dikko",
                "Gada bake",
                "Garagwa",
                "Gombe",
                "Gudun Karya",
                "Gwargwada",
                "Jaun",
                "Karmo",
                "Karmo Ganji",
                "Kpembo",
                "Kulo Sabo",
                "Kunke",
                "Loko-Goma",
                "Madeki",
                "Majaga",
                "Muro",
                "Nakuse",
                "Offu",
                "Pesun",
                "Saukan Buga",
                "Saukan-Kure",
                "Segiya",
                "Tudu-Uku",
                "Warrakata",
                "Zochi",
                "Adadu",
                "Ajurawa",
                "Akutu",
                "Bakate",
                "Biye",
                "Chiji",
                "Dare",
                "Dumbeku-Toto",
                "Gate",
                "Gbwachi",
                "Inyeji",
                "Karbana",
                "Kolo",
                "Kuru",
                "Ladaya",
                "Rakpami",
                "Rudu",
                "Sadauna",
                "Shaffa Abakwa",
                "Shaffan Kwato",
                "Shekara-Uku",
                "Shinshinga-Nashi",
                "Toto",
                "Ugya",
                "Ukya-Sabo",
                "Zono",
                "Umaisha",
                "Anda",
                "Dausu",
                "Egwa Pati",
                "Fofuru",
                "Iggi",
                "Kaita",
                "Katakwa",
                "Kein Yahu",
                "Kokoto",
                "Kpadebu",
                "Kuwa",
                "Ogbere",
                "Shege",
                "Sogane",
                "Uffu"
            ],
            "Wamba": [
                "Ambaka",
                "Amboga",
                "Arum",
                "Arum Sarki",
                "Binna",
                "Chini",
                "Chugbu",
                "Jimiboli",
                "Jimiya",
                "Jini Duffat",
                "Jini Mut",
                "Kado",
                "Kam Lamo",
                "Kanje",
                "Kumurum",
                "Kwarra",
                "Lam Kire",
                "Machai",
                "Mama",
                "Mangar",
                "Mansseuge",
                "Marhai",
                "Muggu",
                "Muttu",
                "Shawai",
                "Shua",
                "Toff",
                "Tsaro",
                "Tumara",
                "Turkwai",
                "Ukambu",
                "Ukanju",
                "Ukolo",
                "Yashi",
                "Wamba",
                "Angba",
                "Angbo",
                "Dechu",
                "Gbagi",
                "Gbata",
                "Gbogi Ugu",
                "Gbombu",
                "Gbriji",
                "Gbude",
                "Gitta Barmo",
                "Gitta Kasa",
                "Gitta Klogba",
                "Sisinbaki",
                "Gitta Maisaje",
                "Gitta Mbasha",
                "Jidda",
                "Klama",
                "Konvah",
                "Kose",
                "Kurize",
                "Kwanza",
                "Lago",
                "Langi",
                "Maigauga",
                "Nakere",
                "Ninkada",
                "Ogye",
                "Ragga",
                "Riuza",
                "Ugure",
                "Ungo",
                "Utugu",
                "Wado",
                "Waja",
                "Waji",
                "Wamba Kurmi",
                "Wayo Arewa",
                "Wayo Kudu",
                "Wude Kurmi",
                "Wude Kwano",
                "Wuji"
            ]
        }
    },
    {
        "Niger": {
            "Agaie": [
                "Kintifi",
                "Afuwagi",
                "Agaie",
                "Ahashe",
                "Alikenci",
                "Angunu",
                "Ashinu",
                "Assayin",
                "Baba-Kasuwa",
                "Bantigi",
                "Batako II",
                "Batako III",
                "Boku",
                "Bororo",
                "Bororoko",
                "Bototi",
                "Bugana",
                "Chata",
                "Chekp-Kinpa",
                "Chekpadan",
                "Chemiyan",
                "Chirik-Olo",
                "Danbole",
                "Daniya",
                "Daracita",
                "Dawaworo",
                "Dekodza",
                "Doko-Baba",
                "Dokoci",
                "Duguyi-Woro",
                "Dzukodan",
                "Dzungi-Kudiri",
                "Ebami",
                "Ebugi",
                "Edo-Kenchi",
                "Edoko",
                "Efi-Gana",
                "Efu-Ladan",
                "Efu-Naskuta",
                "Efu-Ndagi",
                "Efu-Yagi",
                "Efu-Yalwa",
                "Egbangi",
                "Eginna",
                "Ejiko",
                "Ejin",
                "Ejingi",
                "Ekagi",
                "Eko Liman",
                "Eko-Egiganyan",
                "Ekogo",
                "Ekohadegi",
                "Ekosa Nakorji",
                "Ekossa",
                "Ekowugi",
                "Ekowugi-Taci",
                "Ekowugi-Tako",
                "Ekowuha",
                "Ekowuna Nufu",
                "Ekpangi",
                "Emi-Jipoci",
                "Emi-Linan",
                "Emi-Sheshi",
                "Emi-Yanni",
                "Emidigi",
                "Emijiko",
                "Emitacigi",
                "Emiworogi",
                "Esafarigi",
                "Esanka",
                "Esozhi",
                "Estako I",
                "Etsu-Audu",
                "Etsu-Nugba",
                "Etsugale",
                "Etsun-Ndako",
                "Evuntagi",
                "Evutagi",
                "Evutagi-Cikan",
                "Ewangi-Sheshi",
                "Ewugi Dagaci",
                "Ewugi-Gabi",
                "Ewugi-Kofa",
                "Eyangi-Sale",
                "Eye",
                "Ezhi-Woro",
                "Fullako",
                "Fuyaka",
                "Gambo",
                "Gba Cita-Ganyi",
                "Gbadaroko",
                "Gbaji",
                "Gbanatako",
                "Gbogun",
                "Goba",
                "Goyi-Gonta",
                "Goyiko",
                "Gudungu",
                "Guluci",
                "Itsaduko",
                "Jikpangi",
                "Jipo I",
                "Jipo II",
                "Jitu-Magaji",
                "Kakati",
                "Kalema",
                "Kandigi",
                "Kanpi",
                "Kansnagi",
                "Katchafu",
                "Kenci-Keza",
                "Kodogi",
                "Kolo Tidun",
                "Koloshemi",
                "Koriyagi",
                "Kpatafi",
                "Kpatsunlo",
                "Kpotun",
                "Kucitagi",
                "Kungaru",
                "Kunguru",
                "Kutiriko",
                "Lafiyagi",
                "Lafiyagi-Wace",
                "Lakan",
                "Lamduworo",
                "Liman",
                "Lociko",
                "Loguma",
                "Maba",
                "Magaji-Woro",
                "Magajiko",
                "Magba",
                "Maikudi",
                "Maikudi-Nupe",
                "Maikurdi",
                "Majaki",
                "Makagi I",
                "Makagi II",
                "Malowo",
                "Mamman-Kobo",
                "Mamman-Zagi",
                "Mammantsu",
                "Manfara",
                "Marnati",
                "Masaka",
                "Masakawagi",
                "Mashina",
                "Mawogi",
                "Mawogi-Tswayan",
                "Mayaki",
                "Maza",
                "Mdugu",
                "Naawoyegi",
                "Nami",
                "Nanfara",
                "Nankokan",
                "Ndabade",
                "Ndagoshi-Woro",
                "Ndaiji",
                "Ndaiji-Ndasure",
                "Ndaiji-Tswayan",
                "Ndalelu",
                "Ndamaza",
                "Ndannade",
                "Nnafene",
                "Nugban",
                "Rani",
                "S/Gari-Hausawa",
                "Sakiwa",
                "Sall-Gbakoroko",
                "Sallaaaru-Tako",
                "Sallawu",
                "Santali",
                "Sarkin-Samari",
                "Shabawoshi",
                "Shabayisa",
                "Shaisa",
                "Sheshi",
                "Sonfara-Abu",
                "Sowanke",
                "Taragi",
                "Tawagayeci",
                "Timigi",
                "Tsa Bororo",
                "Tsadu",
                "Tsadza-Ewen",
                "Tsadza-Nupe",
                "Tsaka",
                "Tsakpati",
                "Tswaciko",
                "Tswasha",
                "Tsweci",
                "Turkur",
                "Umaru",
                "Wadata",
                "Wawegi",
                "Wubago",
                "Wugbe",
                "Wuna",
                "Wuna-Dagaci",
                "Wuna-Kan",
                "Wuna-Lafiagi",
                "Wuna-Woro",
                "Wuna-Zhinde",
                "Yagbaci I",
                "Yellwa",
                "Yelwa-Woro",
                "Zayiko",
                "Zhima",
                "Kintako",
                "Abunndace",
                "Akwanu",
                "Aliko",
                "Baro",
                "Bawalagi",
                "Bini-Edrira",
                "Ebangi",
                "Edoman-Woro",
                "Edomem Gbako",
                "Egunkpa",
                "Essui Mutum",
                "Eyatsu",
                "Fogbe",
                "Gari-Nwake",
                "Gbani",
                "Gbawugi",
                "Gbimigi",
                "Gunge",
                "Guregi",
                "Gushe",
                "Gutsungi",
                "Illubo",
                "Jiya Dzama",
                "Kapagi",
                "Kibban",
                "Koroba",
                "Kpasa",
                "Kujikp",
                "Kusogba",
                "Kusoti",
                "Kusoyaba",
                "Laban",
                "Lado",
                "Lakan I",
                "Lakan II",
                "Magaji",
                "Makum-Babba",
                "Mamman-Dogo",
                "Mamman-Ndale",
                "Mashine-Cikan",
                "Maurogi Getsa",
                "Mayaki-Yisa",
                "Munigo",
                "Ndace Kolo",
                "Ndako",
                "Nnegenu",
                "Saganuwa",
                "Sankangi I",
                "Sankungi II",
                "Shehshi",
                "Shipogi",
                "Sonjami",
                "T/Gwari",
                "Tagagi",
                "Tsaduko",
                "Tsagbenku",
                "Tsnaye",
                "Tswayan Doka",
                "Tudunwada",
                "Wace Gbenku",
                "Wanigi",
                "Zago",
                "Zeko"
            ],
            "Agwara": [
                "Shagunu",
                "Abebugur",
                "Agwara",
                "Akisanri",
                "Alhaji-Da Are",
                "Berkete",
                "Boro Gandugi",
                "Budo",
                "Budo Kadinta",
                "Budo Saidu",
                "Budo Sule",
                "Bukari",
                "Dabon Sansani",
                "Dada Bio",
                "Dauda Bagidi",
                "Debuguru",
                "Den-Kwaita",
                "Dodo",
                "Duga",
                "Fulani",
                "Gabi-Bi",
                "Gada-Gobe",
                "Gade-Aguda",
                "Ganda Bedo",
                "Gandugi",
                "Gani Sani",
                "Garu-Anara",
                "Gera Abubakar",
                "Guffanti",
                "Gungawa",
                "Kando",
                "Kanigungawa",
                "Kuri Bio",
                "Luma",
                "Luma Sanke",
                "Magajin Teku",
                "Mail Wiridi",
                "Mego",
                "Musa Fulani",
                "Naroru",
                "New Sansani",
                "Ofiki",
                "Olan",
                "Old Sansani",
                "Pasatulu",
                "Road",
                "Ruga Boroko",
                "Rugan Nari",
                "Rugan oga",
                "Rugan Raina",
                "Rugan-Munkpa",
                "Sabi",
                "Sahgna",
                "Shinanade",
                "Shubayo",
                "Silinaru",
                "Swashi Madiga",
                "Swashi Mair",
                "Tebetebere",
                "Toafon Sansani",
                "Tumbuya",
                "Tunga Ajia",
                "Tungan Mamba",
                "Tungan-Kara",
                "Tungar Noma",
                "Ujiju",
                "Ulakanini",
                "Unguar Samai",
                "Unguwar",
                "Ungwar",
                "Wakamini",
                "Wausawa",
                "Wee",
                "Wora",
                "Yumu"
            ],
            "Bida": [
                "Bida",
                "Wanigi",
                "A/Adisa",
                "Agibogga",
                "Aketanbako",
                "Baba Ko",
                "Babeko",
                "Bakin-Zenebide",
                "Bamisu-Wuya",
                "Bangie",
                "Banniu Gbogi",
                "Bantuwa Area",
                "Bazumagi",
                "Bello",
                "Bida-Fawa",
                "Bidafwa",
                "Bwana",
                "Dangana",
                "Daruda",
                "Dauda",
                "Dzukogi",
                "Dzwayagi",
                "E/A/ Tswanku",
                "E/Abeshin",
                "E/Abonichi",
                "E/Abubakar",
                "E/Afa-Sarkin-Daji",
                "E/Al. J. Wandoi",
                "E/Alh -Tanko",
                "E/Alh-Allah-Yakiyaya",
                "E/Alh-Banmisu",
                "E/Alh-Tahiru",
                "E/Alh. Banmibu",
                "E/Alh. Cijici",
                "E/Alh. Ndagiferuk",
                "E/Alkali-Bwafe",
                "E/Baba-Banga",
                "E/Baba-Jeba",
                "E/Babakor-Dzung",
                "E/Badawu",
                "E/Bafugi",
                "E/Bamisu-Nma",
                "E/Bangaye",
                "E/Banin Bida",
                "E/Banwunangi",
                "E/Banyagi",
                "E/Basheru",
                "E/Bayage",
                "E/Bazumagi",
                "E/BCCC",
                "E/Bentigi",
                "E/Benue Tank-Loncita",
                "E/Benue-Jukegi",
                "E/Besakun",
                "E/Bonwuya",
                "E/Bube",
                "E/Chekpa",
                "E/Coce",
                "E/Dadaima-Mgni",
                "E/Danbugi",
                "E/Dandanma",
                "E/Danyiya",
                "E/Daracita",
                "E/Dokodza",
                "E/Dukya Annebi",
                "E/Duma",
                "E/Dzwale",
                "E/Easghara",
                "E/Edita",
                "E/Edogifu",
                "E/Eengbara",
                "E/Efogi Munzhi",
                "E/Efogi-Leman",
                "E/Efogimenshi",
                "E/Ejiko",
                "E/Ejiko II",
                "E/Ejiko-Rijiya",
                "E/Emiworo",
                "E/Esheta",
                "E/Essozhi",
                "E/Etsu Gbeni",
                "E/Etsu Umaru",
                "E/Etsu-yiza",
                "E/Fengcci",
                "E/Fogun",
                "E/Gabi",
                "E/Galadima",
                "E/Galaima",
                "E/Galedime-Gari",
                "E/Gara",
                "E/Gazacizhi",
                "E/Gbaboruwate",
                "E/Gbafe Bida",
                "E/Gbagbaruku",
                "E/Gbazhi",
                "E/Gbezhi",
                "E/Geniya",
                "E/Ginya",
                "E/Gozanzhi",
                "E/Guduko",
                "E/Gudun",
                "E/Gyaye",
                "E/Hassen Taga",
                "E/Kabeligulu",
                "E/Kania",
                "E/Kanuwan",
                "E/Karako",
                "E/Kari",
                "E/Katanbeko",
                "E/Kibokun",
                "E/Kobonki",
                "E/Kodondo",
                "E/Kolo-Taki",
                "E/Koroko",
                "E/Kotan Komu",
                "E/Kotonkoman",
                "E/Kotonkonem",
                "E/Kpokpo Tswazhi",
                "E/Kuccfagi",
                "E/Kutufani",
                "E/Kyari",
                "E/Labezhici",
                "E/Lakpene",
                "E/Lalenu",
                "E/Lcman",
                "E/Ledan",
                "E/Liman Shafii",
                "E/Liman-Jipan",
                "E/Limen -Gogun",
                "E/Lukepan",
                "E/Lukpan",
                "E/Lumgoyi",
                "E/Madajin-Yagi",
                "E/Madaki",
                "E/Madami",
                "E/Madodo",
                "E/Mai Truku",
                "E/Majin-Kenp",
                "E/Makans",
                "E/Makanta",
                "E/Makuda",
                "E/Mallam-Abba",
                "E/Mambelo Dzugu",
                "E/Man Danganedi",
                "E/Man Makuwa",
                "E/Man Nakisu",
                "E/Man-Jiya",
                "E/Man-Santali",
                "E/Manfafa",
                "E/Manjiya Area",
                "E/Manmosu",
                "E/Manmusa Kidogi",
                "E/Manndaguniji",
                "E/Manzuruku",
                "E/Marinatu",
                "E/Marnati",
                "E/Mashera",
                "E/Mataki",
                "E/Mayak ndejiya",
                "E/Mayaki",
                "E/Mdace Wleya",
                "E/Megayaki",
                "E/Mekame",
                "E/Modki-Bale",
                "E/Mukedami",
                "E/Nagu",
                "E/Naibi",
                "E/Naibi Area",
                "E/Naiji",
                "E/Nakode",
                "E/Nasarafu",
                "E/Natsu",
                "E/Nda Kpaye",
                "E/Nda Tsade",
                "E/Nda-Gimba",
                "E/Ndaji",
                "E/Ndakobokolo",
                "E/Ndaleti",
                "E/Ndamaimi",
                "E/Ndameraki",
                "E/Ndaminaain",
                "E/Ndatafya",
                "E/Ndazwafu",
                "E/Ndeburu",
                "E/Ndeji Kafabi",
                "E/Ndigi",
                "E/Ndoguye",
                "E/Nducekpa",
                "E/Nnedyakpe",
                "E/Nudandyepe",
                "E/Ogi Limen-Shaba",
                "E/Rafi",
                "E/Rani Bida",
                "E/Rofya",
                "E/S/Gone",
                "E/S/Kudu",
                "E/Sagi",
                "E/sakiwa",
                "E/San Sani",
                "E/Sani-Lamu",
                "E/Sanjiya",
                "E/Sanjon",
                "E/Sanluec",
                "E/Santali Benwuya",
                "E/Sapanuwa Kuts",
                "E/Sarken-Kyauro",
                "E/Shamako",
                "E/Sheba",
                "E/Shehu",
                "E/Shengbo",
                "E/Shesa Nupe",
                "E/Sheshi-penti",
                "E/Sheshi-Shaba",
                "E/Shimini",
                "E/Sonfadako",
                "E/Sonfawa",
                "E/Sonfede",
                "E/Sunatsuzhi",
                "E/Tafaski",
                "E/Taka",
                "E/Tako",
                "E/Tako Alh.",
                "E/Tako-Jwabishi",
                "E/Tangbo",
                "E/Tifi-Nnasanci",
                "E/Tsaduya",
                "E/Tsu Kenehi",
                "E/Tsu Musa",
                "E/Tsu Usnen",
                "E/Tsu-Abenchi",
                "E/Tsu-Kenchi",
                "E/Tsuratemukun",
                "E/Tswajiyatsu",
                "E/Tswanku",
                "E/Tswashko",
                "E/Tswatako",
                "E/Tswato",
                "E/Tswato Area",
                "E/Tswatswana",
                "E/Tswaya - shaba",
                "E/Twia",
                "E/Ubandawaki",
                "E/Ubandone",
                "E/Usmantsozhi",
                "E/Wacai Tswa",
                "E/Wacai-Iswa II",
                "E/Wachin-Tafa",
                "E/Wacin Lapa",
                "E/Wambai",
                "E/Wazhiri",
                "E/Ya Ekumisu",
                "E/Yekoko",
                "E/Yekunisu",
                "E/Yikunu",
                "E/Yisanaku",
                "Efu Laruta",
                "Efu Alkeli Musa",
                "Efu Mdatureki",
                "Efu Tsu Nitsa",
                "Efu Tsu-Dazen",
                "Egbeshi",
                "Ekusodu Area",
                "Elsarin Daji",
                "Emi Kuta-Kin",
                "Esso Area",
                "Fogun Area",
                "Gbagbifu Area",
                "Gbagi Ladan",
                "Gbajigi",
                "Gbongbon Tigi",
                "Gundum-Ndasa",
                "Ibrahim",
                "Iswazhi",
                "Iyararuwa-Area",
                "Karan Kuba",
                "Kasuwa-Danuda",
                "Kasuzhi",
                "Kerau Kuba",
                "Kereu Keba",
                "Kereu Kuba",
                "Kpanta",
                "Kpotu",
                "Kucitafi Area",
                "Lomcita",
                "Lomcita Area",
                "Lomen Shabe II",
                "Lubasafugi",
                "Mali",
                "Masaga",
                "Masaruli",
                "Nasalach Bologi",
                "Nayazu",
                "R/Aaba Kpekoo",
                "S/Gida",
                "Serki",
                "Shaba",
                "Shabe",
                "Tadafu",
                "Tafa",
                "Tako Wasa",
                "Tswatagi Area",
                "W/Wacaintswa",
                "Yadafu",
                "Yakiyaya",
                "Zdazaba"
            ],
            "Borgu": [
                "Babana",
                "Abdullahi Kparu",
                "Abdullahi Woru",
                "Abu Kparu",
                "Agbeloban",
                "Agbelobu Kparu",
                "Agen Budo",
                "Akwaru Saka",
                "Alfa Bani Bodo",
                "Alh. Hussaini",
                "Alh. Ibrahim",
                "Alh. Msciden",
                "Aliri Kparu",
                "Aliyu-Budeboin",
                "Arikpru",
                "Ayooru",
                "Baba Karin",
                "Bani Awayer",
                "Bano budo",
                "Bariya Woru",
                "Beni Ture",
                "Bio Ago Orokin",
                "Bio Gbern",
                "Bip Gizah",
                "Biyan",
                "Bobioro",
                "Bodo",
                "Bodu",
                "Boni Yori Bodu",
                "Brobuye",
                "Budo Saidu Sabi",
                "Budo Wara",
                "Budu Aiki",
                "Bukarnikparu",
                "Buogan Kparu",
                "Dabon Kparu",
                "Dawiru",
                "Dekale",
                "Dekale Gbeji",
                "Digoro-Kparu",
                "Fidena Kparu",
                "Galadimaru",
                "Gamoru",
                "Gauji",
                "Gauyi",
                "Gawkosu Budo",
                "Gbabanbudo",
                "Gbade",
                "Gbeteru",
                "Gbo",
                "Gbogbonu",
                "Geri Wari",
                "Gigoro Kparu",
                "Gogen Kparu",
                "Goro Bani",
                "Goromgun",
                "Gudmi Kparu",
                "Gukenbi",
                "Gumbadoro",
                "Guruko Baku",
                "Gururu",
                "Gusakp Aru",
                "Ibrahim Kparu",
                "Ibrahim Woru",
                "Ilorin",
                "Jurgunwan",
                "Kabe",
                "Kabotu-Budo",
                "Kabun Bude",
                "Kai",
                "Kanu",
                "Kapubara",
                "Kara",
                "Karenzi",
                "Karinu",
                "Katafo",
                "Kenerun Kparu",
                "Kigbe",
                "Kiyoru",
                "Koburen Kparu",
                "Kokani",
                "Komoduren",
                "Konkwesso",
                "Koro Achin",
                "Kpakotoru",
                "Kparu",
                "Kpenwonki",
                "Kpura",
                "Kpura Mondoro",
                "Kpyen Kpatu",
                "Ksokonbara",
                "Kubil",
                "Kuri",
                "Kwaya",
                "Kyeru",
                "Lumoto",
                "Machu",
                "Mai-Areoan",
                "Mammen Kparu",
                "Mancido Kparu",
                "Manden Budo",
                "Marani",
                "Mare",
                "Maroji",
                "Memko",
                "Monkon",
                "Mubure",
                "Mure Budo",
                "Nameru",
                "Ochan Kparu",
                "Ogun Budo",
                "Ogun Madugun",
                "Oluji",
                "Pa",
                "Pege",
                "Puissa Bani",
                "Saba yunusa",
                "Sabi Sidin Budo",
                "Safelumo",
                "Sakan Lajia",
                "Sanboora Kparu",
                "Sani Kparu",
                "Sani Yeron",
                "Sann Bani Ayooru",
                "Sarkini Fulani",
                "Sekini Budo",
                "Seoya Shafasiri",
                "Sheron Bune",
                "Shinken",
                "Ssanomoru",
                "Subi-Sike",
                "Suno Sabi",
                "Sure",
                "Swapa",
                "Swate",
                "T. Bube",
                "Taben Budo",
                "Takun Budo",
                "Tu Ganvuda",
                "Tunger-Jaraa",
                "Tungun",
                "Tutu Sumonu",
                "Uma Ru Sudu",
                "Woru Gobin",
                "Wa-Kekubu",
                "Waba",
                "Woru",
                "Woru Doro",
                "Woru Gura",
                "Woru Yeriman",
                "Woru Yoyo",
                "Wuri Woru",
                "Wuro",
                "Wuru",
                "Yahayan Budo",
                "Yaken Budo",
                "Yakinbun",
                "Yanban Kparu",
                "Yangbasum",
                "Yangbasun",
                "Yanpokorun",
                "Yaro",
                "Yendana sabi",
                "Yere",
                "Zugariji",
                "Wawa",
                "Abdullahi",
                "Abun Kparu",
                "Ada Shakarun",
                "Adamu",
                "Agbeshidi",
                "Agumu",
                "Aheandum",
                "Alafiyaro",
                "Alen Kuyeba",
                "Alhaji Kparu",
                "Alufeturen",
                "Alun Kparu",
                "Andemi Kparu",
                "Anita Boyuja",
                "Ankomu Kparu",
                "Aranguru",
                "Argungu New Settlement",
                "Aso Inan Kparu",
                "Ason Kparu",
                "Asuman Kparu",
                "Awaye",
                "Ayiatila",
                "Ba Ah",
                "Baba",
                "Babasola",
                "Babsumkparu",
                "Bakuta",
                "Bamkubu",
                "Basten Kparu",
                "Beben Baru",
                "Benorabu",
                "Bero Keru Kpani",
                "Beruko Kparu",
                "Biborun",
                "Biokpor Kparu",
                "Bioponto Weran",
                "Boni Zunbu",
                "Bonni Iben",
                "Bonni Sikan",
                "Bugan Kparu",
                "Bussa",
                "Dahseki",
                "Danbokparu",
                "Dekera",
                "Dogen Kpanu",
                "Dogon Gari",
                "Dore",
                "Dorian",
                "Forfon",
                "Fulani",
                "Ga A Yakparu",
                "Gaa Gasows",
                "Gaa Mango",
                "Gaa Tawun",
                "Gada Oli",
                "Gado Yakparu",
                "Gadun Sarkin",
                "Gandege Kparu",
                "Gandu",
                "Gandu Gbere",
                "Gandu Take",
                "Gangalesaho",
                "Gangle",
                "Garafin",
                "Gari",
                "Gbebara",
                "Gbehjin",
                "Gen Din Kparu",
                "Gengadu",
                "Genikasayi",
                "Getidon Kparu",
                "Getula Safadi",
                "Gidagbanso",
                "Gidan Bamekidi",
                "Gidan Goshijiza Gidan Marafa",
                "Gidan Nabuku",
                "Giddan Doma",
                "Godebe",
                "Gogan Samun",
                "Goide",
                "Gonagbaso",
                "Gonwa",
                "Goyan Kparu",
                "Gunanguru",
                "Gunji",
                "Imile",
                "Indun Bube",
                "Isa",
                "Issa B. Ason",
                "Jabekwari",
                "Jantawun Kparu",
                "Jobbon Kparu",
                "Kaba",
                "Kabu Keya",
                "Kagbenja",
                "Kakuria",
                "Kali",
                "Kandami",
                "Kanji Dan",
                "Kankuria",
                "Kaojera Fulani",
                "Kapubare",
                "Karabombe",
                "Kaunkpe",
                "Kekepe",
                "Kemi",
                "Kemken Kparu",
                "Kere",
                "Kerenji",
                "Keronji",
                "Ketiden Kparu",
                "Kigbera",
                "Kobo",
                "Kodabo",
                "Kogogi",
                "Konkoso",
                "Kori",
                "Koro",
                "Kpame",
                "Kpanu",
                "Kpara",
                "Kpasan-Ralee",
                "Kpenya",
                "Kpepiya",
                "Kporu",
                "Kuble",
                "Kwa Sare",
                "Kwakhuna",
                "Kwaran kparu",
                "Kwatan Wara",
                "Leshigbe",
                "Lesu",
                "Libraray",
                "Litensure",
                "Maduns-Menga",
                "Mahuta",
                "Malale",
                "Mamengte",
                "Mandasuki",
                "Maresumun",
                "Masana",
                "Mibbe",
                "Mohammed",
                "Mongola Fulani",
                "Mongoro",
                "N/Settlement",
                "New Bussa",
                "New Kuruwasa",
                "Nunworugu",
                "Old Rurwara",
                "Oskete",
                "Patai",
                "Qua",
                "Rakuni",
                "Rebagore",
                "Rugan S. Fulani",
                "Saboh Gari",
                "Sabon",
                "Sabon Pogi",
                "Sadoro",
                "Safeluna",
                "Sakon Bara",
                "Sanni Kparu",
                "Saon Gari",
                "Sarabe",
                "Sarkwama",
                "Sat Gayi-new B",
                "Segun",
                "Sesura",
                "Shafari",
                "Shakaru Kparu",
                "Shamage",
                "Shani",
                "Shiyaman Kparu",
                "Shiyen",
                "Sobi yarun",
                "Sofon Degan",
                "Sukenkaru",
                "Sutaran Kparu",
                "T. Alh. Dan",
                "T. Angulu",
                "T/Abashi",
                "T/Adanu",
                "T/Ajikomi",
                "T/Ali",
                "T/Ankiki",
                "T/Auta",
                "T/Awaru",
                "T/Awato",
                "T/Azangonno",
                "T/Azunfa",
                "T/Baare",
                "T/Babun",
                "T/Babushi",
                "T/Bagudu",
                "T/Bako",
                "T/Bana",
                "T/Bani",
                "T/Bani Mari",
                "T/Barimini",
                "T/Basuna",
                "T/Bawa",
                "T/Bela",
                "T/Bezuna",
                "T/Bobadomu",
                "T/Bogo",
                "T/Bogonnkure",
                "T/Bube",
                "T/Buhago",
                "T/Buje",
                "T/Chinlamai",
                "T/Chuguru",
                "T/Damana",
                "T/Damisa",
                "T/Daw",
                "T/Dogari",
                "T/Dokule",
                "T/Doran Roma",
                "T/Dore",
                "T/Ecko",
                "T/Eoka",
                "T/Gada",
                "T/Galadima",
                "T/Garba Adda",
                "T/Garbasashi",
                "T/Goro Kunbo",
                "T/Gwani",
                "T/Hassan",
                "T/Ibrahim",
                "T/Jaddikaka",
                "T/Jaru",
                "T/Jatau",
                "T/Jatua",
                "T/Jetaru",
                "T/Kanta",
                "T/Kikwashi",
                "T/Kogbale",
                "T/Konde",
                "T/Kudu",
                "T/Kuginya",
                "T/Kulikuli",
                "T/Kyanre",
                "T/Lafuja",
                "T/Lakalle",
                "T/Lakunle",
                "T/Lofiye",
                "T/Magaji",
                "T/Magaji-Generu",
                "T/Magala",
                "T/Magiro",
                "T/Makili",
                "T/Makunderi",
                "T/Makunle",
                "T/Mamata",
                "T/Mamman",
                "T/Masara",
                "T/Moma",
                "T/Monohi",
                "T/Musami",
                "T/Mzigibi",
                "T/Nayasha",
                "T/Noma-Majego",
                "T/Odegu",
                "T/Okofun",
                "T/Omeru",
                "T/Pakie",
                "T/Sabi Dogo",
                "T/Sadakaya",
                "T/Sadangi",
                "T/Sagaru",
                "T/Saji",
                "T/Sallai",
                "T/Sami",
                "T/Samu",
                "T/Sembe",
                "T/Semmo",
                "T/Shaba-Umaru",
                "T/Shagamu",
                "T/Tudu",
                "T/Tuma Jidda",
                "T/Umaru",
                "T/Woru Issu",
                "T/Yaru Kuma",
                "T/Zakawu",
                "Taada",
                "Tagan Sarkawa",
                "Tamanai",
                "Tasare",
                "Temidire",
                "Ten",
                "Ten-Bonu",
                "Tengan",
                "Tikendu",
                "Tonguwen",
                "Tudan Sani",
                "Tukanzoro",
                "Tungan",
                "Tungan Gado",
                "Tungan Gungun",
                "Tungan Kjwani",
                "Tungan Kuka",
                "Tungan Kure",
                "Tungan Lami",
                "Tungan Mai",
                "Tungan Maile",
                "Tungan Nagoda",
                "Tungan Sani",
                "Tungan Sule",
                "Tungan Tasmiya",
                "Tungan Usaman",
                "Tungan Yahaya",
                "Tungan Yahjuza",
                "Tungan Yakubu",
                "Tungan Zabairu",
                "UmaruMauberun",
                "Unguwan Fulani",
                "Ungwan Waje",
                "Usman Bi Sani",
                "Usman Kparu",
                "Wanhin-Kparu",
                "Woriya Woru",
                "Woru Yen",
                "Yagwso",
                "Yakparu",
                "Yakubur Kparu",
                "Yalle Menosi",
                "Yami",
                "Yanbon",
                "Yanjowu Kparu",
                "Yarun Beru",
                "Yawagin Kparu",
                "Yeshikiri",
                "Yowdomun",
                "Zattena",
                "Zu Gunji",
                "Zugunji"
            ],
            "Bosso": [
                "Bejo",
                "Bosso",
                "Chanchaga",
                "Garatu",
                "Kampala",
                "Kodo",
                "Maikunkele",
                "Maitumbi",
                "Shata"
            ],
            "Chanchaga": [
                "Minna",
                "Babeji",
                "Bako",
                "Bako Pampe",
                "Debbi",
                "Ekpigi",
                "Etsu Musa",
                "G. Dutse",
                "Gwodworo",
                "Jamgaru",
                "Jigbeji",
                "K. Dajuwa",
                "Kampani",
                "Kangwa",
                "Kuka",
                "Kurumi",
                "Lapai",
                "Lashami",
                "Nagun",
                "Nkankutu",
                "Pette",
                "Popoi",
                "Shana",
                "Zakwogi"
            ],
            "Edati": [
                "Jima/Doko",
                "Adoga",
                "Anbgbaba",
                "Anfani",
                "B/Ndagbaji",
                "B/Tako",
                "B/Tifin",
                "Baba",
                "Baba Isa",
                "Baja",
                "Barwa",
                "Bokangi",
                "Boki/Yekotacin",
                "Ceko",
                "Cetufu",
                "D/K/Guragi",
                "Dadofu Idoko",
                "Dakani",
                "Dakuntigi",
                "Dangi",
                "Dantigi",
                "Dato",
                "Dazhi/Doko",
                "Dicitagi",
                "Dingi",
                "Doko",
                "Dokofogi",
                "Dokogi",
                "Dokokpan",
                "Dokomba",
                "Dokotigi",
                "Dzwowu/ Kpocita",
                "E/Solawo",
                "Edoci",
                "Egubagi",
                "Ekpagi",
                "Elomi",
                "Emigba",
                "Emijiko",
                "Emikuta",
                "Enitsu Mangun",
                "Eoki/Yabaja",
                "Epsu Zagi",
                "Esumti",
                "Ewako",
                "G/Yekogi",
                "Gaba",
                "Gbaci",
                "Gbara",
                "Gbodoti",
                "Giragi",
                "Gudukoshaba",
                "Guga",
                "Guzzan",
                "Jikanagi",
                "Jima",
                "K/Dakpan",
                "K/K/Giraki Kpacinifu",
                "Kupafu",
                "L/Danyagba",
                "Lacin",
                "Lagun",
                "Loncitagi",
                "Lugwa",
                "Ma Ag' Bukun",
                "Ma Agi Kenchi",
                "Mambwari",
                "Mustafa",
                "Nantu",
                "Nginda",
                "Nuwandurgi A",
                "Nuwandzungi",
                "Nuwandzurgi B",
                "Patigi",
                "Sanchiya",
                "Santali",
                "Seesshishaba",
                "Sunlati",
                "Swansun 2",
                "Swansun I",
                "T/K Bako",
                "T/Salkawa I",
                "T/Salkawa II",
                "Takpa",
                "Tokogi D",
                "Tokunzhi",
                "Tswasha",
                "Vunchi",
                "Wodata",
                "Wusanti",
                "Y/Doko",
                "Yagbagi",
                "Kutigi/Edati",
                "Enagi"
            ],
            "Gbako": [
                "Lemu",
                "Abaguta",
                "Abuchado",
                "Ajake a",
                "Ala-Tswaci",
                "Algeta-Bubakon",
                "Aloyu yagi",
                "Anfaur",
                "Ayiso",
                "Babban-Zaure",
                "Bafaworo",
                "Baki ja abo",
                "Bata",
                "Batagi",
                "Batako",
                "Bicafu",
                "Bine",
                "Bisauti",
                "Buki Manu",
                "Buku Kota",
                "Cemiyan I",
                "Cemyan Tako",
                "Cen/Tifin",
                "Chogo",
                "Cijimisu",
                "Dacaita",
                "Dacaita Sabo",
                "Dacitako",
                "Dakore",
                "Dancita Kolo",
                "Dangi",
                "Dasa ma Salali",
                "Dasa Turia",
                "Dautigi-Borogun",
                "Dikko",
                "Edokota",
                "Edotsu",
                "Egbatisan",
                "Ejiko",
                "Emi Dewo",
                "Emi Iyeti",
                "Emi Ndaji",
                "Emi Ndako",
                "Emi Rowa",
                "Emi Sanmasu",
                "Emi Takogi",
                "Emi Tswaci",
                "Emi Tswanyan",
                "Emi Worong",
                "Emi Yagi",
                "Emi-Daci",
                "Emiaru Sabo",
                "Emibezhi",
                "Emigiyatsu",
                "Emigozan",
                "Emikupa",
                "Emitsu Bubakan",
                "Emitsu Isado",
                "Emitsu Yagi",
                "Emiyezhi",
                "Emo Sagi",
                "Eni Maru",
                "Enogogi",
                "Enu Gaka",
                "Essa",
                "Etsu Abu",
                "Etsu Alashe",
                "Etsu Audu",
                "Etsu Yisa",
                "Evatagi",
                "Ewanko",
                "Fujeregi",
                "Gabanginigi-",
                "Gagato",
                "Ganabigi",
                "Gari",
                "Gatagi",
                "Gbagba Tsofo",
                "Gbaginigotako",
                "Gbandun",
                "Gbangba",
                "Gbanguita",
                "Gbegbaruku",
                "Gidanko",
                "Giwa Yagi",
                "Godogo",
                "Gududzuru",
                "Guye",
                "Ja Jadu",
                "Jaba",
                "Jangana",
                "Jatau",
                "Jeban Ciko",
                "Jiyako",
                "Kagowogi",
                "Kalace",
                "Kalobu",
                "Kantogi",
                "Kpapeci",
                "Kpauta Nakoji",
                "Kucitagi",
                "Kudugi Nakorji",
                "Kukakugi",
                "Kukece",
                "Kusogi",
                "Kuyi Babba",
                "Kuyi Karami",
                "Lada",
                "Lagbo Zukum",
                "Lago",
                "Lakin",
                "Laukorogi",
                "Lemi",
                "Lori",
                "Magi",
                "Magujin Geri",
                "Mamagi",
                "Mamasala",
                "Mandzukwa",
                "Mangevala",
                "Manmuna",
                "Mantafen",
                "Manzainu",
                "Masaasa",
                "Masani",
                "Mawoge",
                "Mucita",
                "Mundisabo",
                "Munditsofo",
                "Ndace Yeko",
                "Ndadce Babbo",
                "Ndagbaci",
                "Ndaiji",
                "Ndakogana",
                "Ndakotsu-Gbagba",
                "Ndakotsu-Shuru",
                "Ndalado",
                "Ndamake",
                "Ndamanman",
                "Ndarubu",
                "Ndasheuko",
                "Ndatuki",
                "Ndaturaki",
                "Nmagunu",
                "Nngwogegi",
                "Nuwako-Souman",
                "Nuwakota",
                "Patigi Tabo",
                "Patishun",
                "Patoshin",
                "Picitu",
                "Pundzuru",
                "S/Gari",
                "Sabon Gida",
                "Sagunwo",
                "Sakiwo",
                "Sautigi",
                "Shaba Legbo",
                "Shabafu",
                "Sheeshi Gona",
                "Sheshi Ya Benu",
                "Sheshiko",
                "Somajiko",
                "Sonfacako",
                "Sonmajigi",
                "Sunsun Ndadan",
                "Swagungi-Sebon",
                "Tangwagi-Woro",
                "Titin",
                "Totoko",
                "Tsadko",
                "Tsadu",
                "Tsadu Kafa",
                "Tsadu Kashi",
                "Tsadu-Baraja",
                "Tsadza",
                "Tsadze",
                "Tsakpazhi",
                "Tswako yagi",
                "Tswako-Makun",
                "Tswako-Yabi",
                "Tswanyan",
                "Tswasho",
                "Tswatagi",
                "Wacin Saba",
                "Walin Gana",
                "Wasagi",
                "Washigi",
                "Wodata",
                "Yabatagi",
                "Yazhingi-Tswala",
                "Yikangi",
                "Yizhigi",
                "Yizhigi Tsadu",
                "Ysia Dzuru",
                "Zanagi",
                "Zanfita Daku"
            ],
            "Gurara": [
                "Gawu",
                "Abuchi",
                "Baji",
                "Boku",
                "Boku-Nubuta",
                "Bonu",
                "Daku",
                "Dikko",
                "Ebba",
                "Dagbami",
                "Tudun-Wada",
                "Gawu-Gasakpa",
                "Gawu-Kopati",
                "Gawu-Dawaki",
                "Kaura-Gawu",
                "Gawu-Babangida",
                "Guna",
                "Gurara",
                "Gwachife",
                "Gwari",
                "Izom",
                "Kabo",
                "Kadna",
                "Kaka",
                "Kungo",
                "Kungoshi",
                "Ladan",
                "Lambata",
                "Lefu",
                "Buzhi",
                "Mararaba",
                "Nasami",
                "Saku",
                "Shanu",
                "Shegi",
                "Tuchi",
                "Tufa",
                "Tuna"
            ],
            "Katcha": [
                "Badeggi",
                "Amina Woue",
                "Amma",
                "Angulu Gitsu",
                "Arewa",
                "Bakin Chachaga",
                "Bakin Chacheja",
                "Bakohdare",
                "Bishetiawoji",
                "Bissati",
                "Bororo",
                "Bossati",
                "Captigi",
                "Cheche",
                "Cikagasa",
                "Cikatigi",
                "Copa",
                "Dadi",
                "Daniya",
                "Dankorogi",
                "Danuya",
                "Daracita",
                "Dari",
                "Dodi",
                "Dokogodu",
                "Edigi",
                "Edikusa",
                "Edotsu",
                "Ekapagi",
                "Ele",
                "Elegi-Zuzungi",
                "Emi Klofogi",
                "Emi Ndaci",
                "Emi Sheshi",
                "Emi Tsowa",
                "Emi-Liman",
                "Emi-Natsu",
                "Emigba",
                "Emigbari",
                "Emijiko",
                "Emirafi",
                "Emitacigi",
                "Eshasti",
                "Eshsti",
                "Essa",
                "Etsu Bako",
                "Etsu Mamma",
                "Etsu Sidi",
                "Evaa Agada",
                "Evatagi",
                "Evutagi",
                "Ezhigi",
                "G/Danladi",
                "G/Saidu",
                "Gade",
                "Gadza",
                "Gana",
                "Gbado",
                "Gbagbnaruku",
                "Gbakogi",
                "Gbakpan",
                "Gidan Dogo",
                "Gidan Mai",
                "Goshigi Babba",
                "Goyi Dzuwa",
                "Goyikenu",
                "Gudan Dogo",
                "Gusadi",
                "Guye",
                "Halilu",
                "Isa Kpant",
                "Jimade",
                "Ka agi",
                "Ka agi Maba",
                "Ka agi Toga",
                "Kafa",
                "Kagowogi",
                "Kakapkagi",
                "Kakun",
                "Kanbari",
                "Kanma",
                "Kataeregi",
                "Kataeregi-Rapakpa",
                "Katako",
                "Kataregi",
                "Kausangi",
                "Kladi Pangu",
                "Kloerogi",
                "Kodoko",
                "Kotugi",
                "Kpanti",
                "Kparaka",
                "Kpata Savi",
                "Kpotu",
                "Kpotuko",
                "Kpotuku",
                "Kuncita",
                "Kusogi",
                "Kutakpa",
                "Kutukpa",
                "Ladan",
                "Lade",
                "Lafiyagi Lafe",
                "Lafiyagi-Zadi",
                "Lafoyagi-Zadi",
                "Langga",
                "Lanko",
                "Lankokpagi",
                "Legbodzan",
                "Lenfa Bororo",
                "Mageda",
                "Magenu",
                "Majidadi",
                "Mamafu",
                "Mamma isa",
                "Mantuntu",
                "Maraya",
                "Masantali",
                "Matulu",
                "May Aki-Kolo",
                "Mayaki",
                "Menefu",
                "Mukagi",
                "Nagya Amadu",
                "Natsu",
                "Nda Gowogi",
                "Ndabarshi",
                "Ndadoko",
                "Ninwoye",
                "Olusegi",
                "Pato Ndaloke",
                "Rabakpa",
                "Rafin Bauna",
                "Rapin",
                "Sabongida",
                "Sagikoro",
                "Sakciwa Natsu",
                "Sakowa",
                "Samasi",
                "Sawaidi",
                "Shidi Agga",
                "Shiri",
                "Sonbagi",
                "Taka",
                "Takutu",
                "Tiawogi",
                "Tsadogonns",
                "Tsadu Gakpa",
                "Tsaduko",
                "Tsdogonna",
                "Tsdudwale",
                "Tsowa-Maka",
                "Tuturugi",
                "Wadata",
                "Wadata Pangu",
                "Wadata Tasha",
                "Wasagi",
                "Zadi",
                "Zancita",
                "Zhumanle"
            ],
            "Kontagora": [
                "Kontagora (rural)",
                "Abubakar",
                "Alala",
                "Am. Benyo",
                "An. Auta",
                "An. Dan Jibo",
                "An. Maidandum",
                "An. Mamman Gwdan",
                "An. Man",
                "G/Abara",
                "An. Muham.",
                "An. Nagani",
                "An. Saidu",
                "Badakkar",
                "Badukke",
                "Bakin Gulbi",
                "Basullube",
                "Bawa Ragura",
                "Buda",
                "D/Dawan Tum",
                "D/Fadama",
                "Daji Kamuku",
                "Dappa",
                "F/Usalle",
                "Fangu Us",
                "Fun Abdu",
                "Ganawa",
                "Ibini",
                "Ibolid/Fadama",
                "Kafin Maikomo",
                "Kag. Gabirawa",
                "Kagara Tsahuwa",
                "Kam Bain",
                "Kamuka",
                "Kamutu",
                "M. Bnuda Sadau",
                "M/Adamu",
                "M/Bisallah",
                "Maaji Mashingin",
                "Magaida",
                "Magaji",
                "Magandu",
                "Maje",
                "Makeri Boka",
                "Malehe Gari",
                "Malo",
                "Maraba Lamba",
                "Masaha",
                "Masama",
                "Mashigin Maje",
                "Masuga Gari",
                "Matacibu",
                "Mint. Masakara",
                "Monde",
                "Munt. M.",
                "Nama",
                "Noma",
                "Rafin Gora Gari",
                "Rafin/Wa-Gona",
                "Ragadawa",
                "S/G Managu",
                "S/Garin",
                "Sar/Sudan",
                "T/Amadu Kama",
                "T/Gamu-Gaku",
                "T/Jaye",
                "T/Kawata",
                "T/Kawo",
                "T/Mande",
                "T/Na Ukku",
                "T/Sakko",
                "T/Siri",
                "T/Usubu",
                "T/Wada",
                "T/Wawa",
                "Tun Akwati",
                "Tun Babandogo",
                "Tun Bagudu",
                "Tun Habu",
                "Tun. Gelawa",
                "Tun. Habu",
                "Tun. Maikame",
                "Tun. Makeri",
                "Tun. Sullubawa",
                "Tun/Ga-Allah",
                "Tund Ado",
                "Udara",
                "Ung. Amaduri-Zargina",
                "Ung. Balassar/",
                "Ung. Dukkawa",
                "Ung. Galadiman",
                "Ung. Jan. Buda",
                "Ung. Janwuru",
                "Ung. Mamman",
                "Ung. Ranga",
                "Ung. Saturan Noma",
                "Ung. Zuru Gadan",
                "Urungwa Gari",
                "Usale",
                "Usalle",
                "Ushinda",
                "Birnin Maza",
                "Acitukpa",
                "Adagba",
                "Ajiji",
                "Anmadu",
                "Baban Gwari",
                "Badegi-Lapai",
                "Bargo",
                "Basa Sabo",
                "Batatu",
                "Binin-Maza",
                "Bwacha Basa",
                "Bwache",
                "Bwaji",
                "Cecetudun-Lalada",
                "Cheche",
                "Dado Dangana",
                "Dara",
                "Dwafu",
                "Efubankogi",
                "Efujwaja",
                "Efushaba II",
                "Efutsawa",
                "Eminuku",
                "Etsugi",
                "G. Un-Gabas",
                "Gabi",
                "Gananadi",
                "Garawa",
                "Gatako",
                "Gbacidan",
                "Gbanwa",
                "Girkuma",
                "Gudani",
                "Gurdi-Basa",
                "Gwauna",
                "Isadza",
                "Jaligah",
                "Jimada",
                "Juguda-Fulani",
                "Kache",
                "Kapako",
                "Katakiti",
                "Kawu",
                "Kotara",
                "Kpabisan",
                "Kpagu",
                "Kudugu",
                "Kungoshin",
                "Kunguni",
                "Lapai",
                "Lenfa",
                "Magbashin",
                "Magudan",
                "Mai Jaki",
                "Mawogi",
                "Mayali",
                "Mdamurugi",
                "Mukugi",
                "Muwanbubu",
                "Ndawashi",
                "Ndeji",
                "Pangu",
                "Ruga",
                "Ruga (II)",
                "Rugan-Mugu",
                "Rulani",
                "Sami Naka-Gwari",
                "Saminaka",
                "Saminaka Hausa",
                "Shaku",
                "Sonfada",
                "Sundugi",
                "T/Alallam",
                "T/baushe",
                "T/Jaiye",
                "T/Makafo",
                "T/Sarkin Fulani",
                "T/Tukura",
                "Takalafiya",
                "Tako Achau",
                "Takuti-Ruga",
                "Tashibo",
                "Titundo",
                "Un Yuguda",
                "Un-Arewa",
                "Un-Jamma",
                "Un-Natena",
                "Un.Limen-Ashin",
                "Zagom-Basa",
                "Znimadegi",
                "Zologi",
                "Zugi-Mazabo",
                "Ebbo",
                "Akoyi",
                "Akwanvu-Oaji",
                "Anguwan-Havshwa",
                "Apataku",
                "Baka Tako",
                "Baka-Fifin",
                "Bashi",
                "Bashi-Gwuari",
                "Beba",
                "Cibeyaga",
                "Daku Bwaje",
                "Dakunmi-Gati",
                "Dere",
                "Dwale",
                "Ebwa-Kikoshinna",
                "Ebwadakiri",
                "Ebwekoba Madi",
                "Ebwoa",
                "Eda",
                "Elegi Mumbu",
                "Eshi",
                "Euchi-Yababia",
                "Ezhin Sabo",
                "Gbami",
                "Gbedu-Sabo",
                "Gbege",
                "Geku",
                "Katakpa-Scho",
                "Koki",
                "Kpange",
                "Kuchi-Eye",
                "Kuchi-gbago",
                "Kuchi-Kebba",
                "Kuci",
                "Nyanbabo",
                "Paisa",
                "Puzhi",
                "Rakapa",
                "Rarabuku",
                "Rigivo",
                "Tana",
                "Yawa-Kanaworo",
                "Yawa-Wadata",
                "Gulu",
                "Abeta",
                "Abugi-Jankana",
                "Abugi-Kenigi",
                "Abugi-Kenigo",
                "Aciba",
                "Aciba Woro",
                "Aciba-Gudo",
                "Adun-Beku",
                "Adwakia",
                "Agb Beku",
                "Akiba",
                "Akwanu",
                "Amina",
                "Arah",
                "Atsu",
                "Atsu-Amiko",
                "Atsu-Re Kpan",
                "Avukucita",
                "Ayuya",
                "Azopati",
                "Bgeye",
                "Bina",
                "Bina Yaba",
                "Biwa Gbedu",
                "Bokyo",
                "Borokpan",
                "Bwasoje",
                "Ceku",
                "Dabagaje-Woka",
                "Dabogi",
                "Dagbaje",
                "Daji",
                "Dalami",
                "Danbe",
                "Doba",
                "Duma",
                "Duman-Bassa",
                "Eba Emitachi",
                "Ebaloti",
                "Edo",
                "Edo-Etsubagi",
                "Efan",
                "Efutsu-Abu",
                "Egba",
                "Egba-Tuko",
                "Egbagomacibe",
                "Egbati",
                "Egun",
                "Egya",
                "Ekkan",
                "Ekku",
                "Ekun",
                "Emiko-Tako",
                "Emileban",
                "Emiworogi",
                "Emu",
                "Epe",
                "Eshinshinbu",
                "Etsu-Makka",
                "Etsu-Ndakoji",
                "Evti",
                "Ewabademi",
                "Ewan-",
                "Ewtc-Emiko",
                "Ewugi",
                "Ewukponu",
                "Fapo",
                "Faru",
                "Gada-kpan",
                "Galle",
                "Galu",
                "Ganyakpa",
                "Garabda",
                "Gati",
                "Gbaguje",
                "Gbakinku",
                "Gbandara",
                "Gbedako",
                "Gbedu",
                "Gbodumega",
                "Gbolu",
                "Gupa",
                "Gupa-Atsu",
                "Gupa-Mifin",
                "Guragi",
                "Gurdi",
                "Gurgudu",
                "Gwa",
                "Hasheyimi",
                "Jakapami",
                "Jakucita",
                "Jihu",
                "Kagbodoi",
                "Kalaba",
                "Kandi-Emiko",
                "Kandi-Gbimi",
                "Katakpan",
                "Kiripo",
                "Kpada",
                "Kpasama",
                "Kpotegi",
                "Kuba",
                "Kukwo",
                "Kuti",
                "Lafuya-Kpada",
                "Lapaigi",
                "Malaba",
                "Mararbba",
                "Muti",
                "Muye-Gbako",
                "Naibi",
                "Nakwabi",
                "Nasarawa",
                "Nasarwa-Bassa",
                "Nikpe",
                "Nnakpan",
                "Nuugbangi",
                "Nyanda",
                "Nyimi",
                "Pele",
                "Pelemi-Kunkond",
                "Poko",
                "Revu",
                "Rifi",
                "Sabo Muye",
                "Samle",
                "Sanumwagi",
                "Shevu-Sabo",
                "Sokun-Fvba",
                "Sokunsheba",
                "Sokvn-Pege",
                "Sokvntaki",
                "Sulu-Lukati",
                "Tanaye",
                "Vatsa-Adeyan",
                "Vatsa-Agbana",
                "Vatsa-Eminworogu",
                "Vuiegbo",
                "Wue-Wuna",
                "Yabata",
                "Yelwa",
                "Yelwa-Pacha",
                "Yung-Guji",
                "Ywlwa-ana",
                "Zabba",
                "Zaikpe",
                "Zango",
                "Zhitmigi"
            ],
            "Lavun": [
                "Kutigi/Edati",
                "Ajanabu",
                "Ajanatu",
                "Alakusu-Tsah",
                "Aljusu Ndabu",
                "Aragieta",
                "Audu Kenco",
                "Bade",
                "Bafo",
                "Bakombgagi",
                "Baminda",
                "Bana",
                "Bankawu",
                "Bantogi",
                "Baratsu",
                "Barzzhe",
                "Batagi",
                "Batagi Ndace",
                "Batagi-Dzwabu",
                "Batati",
                "Batavovogi",
                "Batzhitsu",
                "Bawu",
                "Benuko",
                "Bokungi",
                "Bongi",
                "Boromo",
                "Bukkasa",
                "Bwada",
                "Cegiama",
                "Changudugi",
                "Charati",
                "Charati (To)",
                "Chatafu",
                "Chegungi",
                "Ckkagi",
                "D/Masalaci",
                "D/Ndatuna",
                "Dabangi",
                "Dabban",
                "Dadi",
                "Dafi Buku",
                "Dagbegi",
                "Dagida",
                "Dakpanci",
                "Danara",
                "Dancitagi",
                "Dancitako",
                "Dangifu",
                "Danko Emi",
                "Danti",
                "Darafa",
                "Dari",
                "Dassun",
                "Datako",
                "Dati-Mapa",
                "Datso",
                "Dayifu",
                "Dikko",
                "Dikko Tako",
                "Dikko-Tikin",
                "Diko Koro",
                "Dodondawa",
                "Dofu Bake",
                "Dogbe",
                "Dokke",
                "Donko",
                "Dooci",
                "Dowogi",
                "Duma",
                "Dumagi",
                "Dzagwun",
                "Dzunmbe",
                "E/Bafu",
                "E/Dawle",
                "E/Gana",
                "E/Karami",
                "E/Ndyelu",
                "Ebangi",
                "Ebanti",
                "Ebbo",
                "Ebegi",
                "Edo Baba",
                "Edogi",
                "Edotsu",
                "Edugui Bawu",
                "Egagi",
                "Egbako",
                "Egbanti",
                "Ekota",
                "Emi - Emidakosule",
                "Emi Daga",
                "Emi Datishi",
                "Emi Emiworogi",
                "Emi Gazhelati",
                "Emi Gbodzu",
                "Emi Gbogbonti",
                "Emi Gorgo-Tifin",
                "Emi Jike",
                "Emi Kagba",
                "Emi Kanda",
                "Emi Kosunti",
                "Emi Lukpa",
                "Emi Manbaru",
                "Emi Mangujaza",
                "Emi Nadeji",
                "Emi Nda Kotsu",
                "Emi Ndafa",
                "Emi Ndaleko",
                "Emi Ndanuwan",
                "Emi Ndashaba",
                "Emi Nkonin",
                "Emi Nkpayiko",
                "Emi Poto",
                "Emi Shaba",
                "Emi Tete",
                "Emi Tsadu",
                "Emi Tsuyisa",
                "Emi Tswayan",
                "Emi Worokuso",
                "Emi Zhutsu",
                "Emi- Evungi",
                "Emi-?Worongi",
                "Emi-Akpaki",
                "Emi-Batagi",
                "Emi-Bongi",
                "Emi-Botan",
                "Emi-Dawu",
                "Emi-Dokociz",
                "Emi-Dokocizhi",
                "Emi-Dznazhi",
                "Emi-Edosuerwayi",
                "Emi-Ekpagi",
                "Emi-Ewognsu",
                "Emi-Gamu",
                "Emi-Garako",
                "Emi-Gawo",
                "Emi-Gawo Iswari",
                "Emi-Gawo Tswa",
                "Emi-Gawo Tsysankpa",
                "Emi-Gazhe",
                "Emi-Gazhevata",
                "Emi-Gbanditati",
                "Emi-Gbogingi",
                "Emi-Gbokota",
                "Emi-Ghazhe Mu",
                "Emi-Kokonkara",
                "Emi-Kpansa-Nagi",
                "Emi-Kpareji",
                "Emi-Kpatadzupu",
                "Emi-Kpatanti",
                "Emi-Kpayi",
                "Emi-Kucitagi",
                "Emi-Kugi",
                "Emi-Lagada",
                "Emi-Lanfa",
                "Emi-Likede",
                "Emi-Luci",
                "Emi-Majin",
                "Emi-Makama",
                "Emi-Makun",
                "Emi-Mantawaki",
                "Emi-Mantuaki",
                "Emi-Manyisa",
                "Emi-Masaki",
                "Emi-Matswagi",
                "Emi-Mayaki",
                "Emi-Ndadzan",
                "Emi-Ndagi Isa",
                "Emi-Ndalikali",
                "Emi-Ndanida",
                "Emi-Ndarani",
                "Emi-Ndasheshi",
                "Emi-Ndashun",
                "Emi-Ndaswanyan",
                "Emi-Ndatsyiya",
                "Emi-Ndayamma",
                "Emi-Ndayiko",
                "Emi-Sakpefu",
                "Emi-Shaba Keji",
                "Emi-Shabako",
                "Emi-Tswaako",
                "Emi-Tswanyan",
                "Emi-Twaci",
                "Emi-Uluko",
                "Emi-Waki",
                "Emi-Wodata",
                "Emi-Wokali",
                "Emi-Woro",
                "Emi-Woro-Shaba",
                "Emi-Worong (1)",
                "Emi-Worong (II)",
                "Emi-Worongi",
                "Emi-Worongo",
                "Emi-Yabindin",
                "Emi-Yebosoko",
                "Emi-Yekoko",
                "Emidadocin",
                "Emigi",
                "Emikako",
                "Emikarmu",
                "Emiladan",
                "EmiNdaceko",
                "Emindaniya",
                "Emitsu",
                "Emitsuzuru",
                "Emizhigici",
                "Emu Mapa",
                "Endekotsu",
                "Enuta",
                "Esungi",
                "Etnudogo",
                "Etsan",
                "Etsu Woro",
                "Etsu-Tasha",
                "Evungi",
                "Evuntagi",
                "Eyagi",
                "Ezhigi",
                "Fada",
                "Fadshi",
                "Fanga",
                "Fikun",
                "Fitigi",
                "G/Dancitagi",
                "G/Kata",
                "G/Tagi",
                "Gaba",
                "Gana mar",
                "Gara",
                "Gatagi",
                "Gazhe",
                "Gazhitu",
                "Gbaci",
                "Gbada-Gbadzu",
                "Gbade",
                "Gbaguda",
                "Gbanagi",
                "Gbancitagi",
                "Gbangba",
                "Gbanpin",
                "Gbarigi",
                "Gbencitgi",
                "Gbenko",
                "Gbeteru Tarwo",
                "Gbodoti",
                "Gbongonati",
                "Gekpa",
                "Giwa",
                "Goga",
                "Gogata",
                "Gogata-Majin",
                "Gogata-Tsadu",
                "Goggata",
                "Gogoti",
                "Gonagi",
                "Gudu Tako",
                "Guduko",
                "Gukuko",
                "Guzan",
                "Jangi",
                "Jiga",
                "Jina",
                "Jipan",
                "K/Kanzhi",
                "K/Sokyara",
                "K/Tagi II",
                "Kabici",
                "Kafetun",
                "Kagowogi",
                "Kakuti",
                "Kangi",
                "Kangi-Makun",
                "Kanko",
                "Kansanagi",
                "Kapami",
                "Katamba-Bologi",
                "Keogi Sabo",
                "Ketsa",
                "Kinbokun",
                "Kitsa Tifun",
                "Kkpatagi I",
                "Koccla",
                "Kocitako",
                "Koegi Tsofo",
                "Kokogi",
                "Kolowasa",
                "Kolowoni",
                "Kolozuru",
                "Kotugi Dada",
                "Kpambo",
                "Kpankuruzhi B",
                "Kpanzhi",
                "Kpautasaci",
                "Kpekpo",
                "Kpenyeto",
                "Kpizhi I",
                "Kplitagi",
                "Kpunkuruzhi",
                "Kuci Yabata",
                "Kuci-Woro",
                "Kucitagi",
                "Kudogi",
                "Kukpagi",
                "Kuna",
                "Kuni-Awo",
                "Kupafu",
                "Kupe",
                "Kuragba",
                "Kuso Tachin",
                "Kusodu",
                "Kusogi",
                "Kusotaci",
                "Kutigi",
                "Kutiwongi C",
                "L/Fazhi",
                "Labozhi",
                "Lade Makun",
                "Lafarma",
                "Lafigagi",
                "Lafiyagi",
                "Lagun",
                "Lagun Malogi",
                "Lagun-Efuko",
                "Lalo",
                "Lamboeh",
                "Lancikagi",
                "Lanfagi",
                "Langbata",
                "Lanle",
                "Lasagi",
                "Latiko",
                "Lazhi-Kolo",
                "Legbo",
                "Lelefu",
                "Lukaro",
                "Madi",
                "Madodo",
                "Mafoko",
                "Maintwaki",
                "Majidai",
                "Majimkaji",
                "Majin Gari",
                "Majin-Kusoagi",
                "Makufu",
                "Makwafu",
                "Makwagi",
                "Makwako",
                "Malungi",
                "Mamagi",
                "Mambe",
                "Mamina",
                "Mamuzhi",
                "Mana",
                "Manamama",
                "Manyisa",
                "Manzwakwa",
                "Masaleci",
                "Masha I",
                "Masingo",
                "Mawogi",
                "Mazari",
                "Miniko",
                "Mucita",
                "Mumuni",
                "Nacita",
                "Nadmanki",
                "Nafogi",
                "Nagyafu",
                "Naike",
                "Nambe-Jako",
                "Nasaratu",
                "Ndabo",
                "Ndafuraki",
                "Ndaijiko",
                "Ndakehei",
                "Ndaketsa",
                "Ndako A",
                "Ndakogitsu",
                "Ndakogitsu A",
                "Ndakolo",
                "Ndalaba",
                "Ndale",
                "Ndaleutswa",
                "Ndaloke",
                "Ndarubu",
                "Ndashaba",
                "Ndawangwa",
                "Ndayama",
                "Nku",
                "Nmamayi",
                "Nnadindi",
                "Nnadukun",
                "Nnafeane",
                "Nwakanuna",
                "Pako Panti",
                "Pantiwodata",
                "Pat-Kasangi",
                "Patigi-Shaba",
                "Patigi-Waziri",
                "Patignin",
                "Pokpo",
                "Potox",
                "Rama",
                "Ribiku",
                "Rokota",
                "Rugagi",
                "Rugga",
                "Rwakwa-Nda",
                "Rwankwa",
                "S/Ewowara",
                "Sabo",
                "Saci",
                "Sacifu",
                "Sakpe",
                "Sakwa",
                "Salwu",
                "Sanmaji",
                "Sansanu balo",
                "Santali",
                "Shaba Kaiji",
                "Shaba Legbo",
                "Shaba Maliki",
                "Shaba Manma",
                "Shabatu",
                "Shakpetu",
                "Shaku B",
                "She Matsu",
                "She-Katsa",
                "She-Tsa",
                "Shebe",
                "Shebe Woro",
                "Shegba",
                "Sheshi",
                "Sheshi Agba",
                "Sheshi Madaki",
                "Sheshi-Bikun",
                "Shet",
                "Sodangi",
                "Sokomba",
                "Sokyara Gabi",
                "Sonfada",
                "Sonmazair",
                "Sopa",
                "Swajiya",
                "Swalagi",
                "T/Baban",
                "T/Kabagi",
                "T/Karami",
                "T/Mamudu",
                "T/Tswada",
                "Tabo I",
                "Tabu Gari",
                "Taci",
                "Tada-Miliki",
                "Tafian",
                "Tafien",
                "Tama",
                "Tanaworo",
                "Tate",
                "Tatun",
                "Tayuma",
                "Teregi",
                "Totomi",
                "Tsadu",
                "Tsadu Alokochi",
                "Tsampa",
                "Tsavni",
                "Tsoegi",
                "Tsun",
                "Tswadzuru",
                "Tswagba",
                "Tswagi",
                "Tswako",
                "Tswance",
                "Tswankiwagi",
                "Tswashaworo (T.I)",
                "Tswatagi",
                "Tswowo-Dzama",
                "Tugi",
                "Tumaka",
                "Tunga D. Masha",
                "Tunga Zavarna",
                "Tutuntiko",
                "Twaki 2",
                "Twaki I",
                "U/Sheti II",
                "U/Sheti III",
                "Ubaandoma",
                "Uluko",
                "Vuntako",
                "Vunun",
                "Wangwa",
                "Washigi",
                "Wochiko",
                "Wodata",
                "Wodiko",
                "Woliko",
                "Wuchi",
                "Wulifa",
                "Wunigi",
                "Wunta",
                "Wuya",
                "Yakowodu",
                "Yakudi-Kpangi",
                "Yakudi-Tanko",
                "Yalwa",
                "Yebosoko",
                "Yekoko",
                "Yekosa",
                "Yekotacingi",
                "Yelwa",
                "Yeti",
                "Yezegha",
                "Yidzuwugi",
                "Yifengi",
                "Z/Kencifu",
                "Z/Majin",
                "Zakari",
                "Zhigati",
                "Zhigun",
                "Zhiluko",
                "Zhiwu"
            ],
            "Magama": [
                "Auna",
                "Agido",
                "Aiki",
                "Akutu",
                "Akwan Manke",
                "Akwaru",
                "Alunguci",
                "Alura",
                "Amale",
                "Amali",
                "Anaba",
                "Andarai",
                "Ang/Dawa",
                "Ang/Dakuza",
                "Ang/Dan Auta",
                "Ang/Dandariya",
                "Ang/M. Bako",
                "Ang/Nadawaju",
                "Ang/Nasamu",
                "Ang/Sansana",
                "Anifani",
                "Arhu",
                "Asala-Karama",
                "Asaya",
                "Awanjabi",
                "B.Zabgi",
                "Balugu",
                "D. Hili",
                "Damale",
                "Danladibiri",
                "Finga",
                "G. Fulani",
                "G. Gona",
                "G.Y. Alaucho",
                "Galanzare",
                "Gallehe",
                "Gatagi",
                "Gele",
                "Gengi",
                "Gilo",
                "Gode",
                "Gumbi",
                "Gungawa",
                "Hiriya",
                "Inkwai",
                "Ipama Bima",
                "Iraba",
                "Irama",
                "Iriyan",
                "Isama",
                "Issale",
                "Iteri",
                "Jagura",
                "Janyau",
                "Kabara",
                "Kada",
                "Kafigo",
                "Kaida",
                "Kajabu",
                "Kanfani",
                "Karandadi",
                "Kasuwan Ndaji",
                "Kawo",
                "Keriko",
                "Kindawa",
                "Kinkiya",
                "Koso",
                "Ksoshi",
                "Kumbi Sani",
                "Kwakolo",
                "Kyau",
                "Lade",
                "Ladibin",
                "Libale",
                "Lofawa",
                "Luhu",
                "Luwo",
                "M. Kawa",
                "Mabunguri",
                "Madaki",
                "Madakin Koma",
                "Madalo",
                "Madalu",
                "Madugu",
                "Magana",
                "Magashi",
                "Magilk",
                "Magumo",
                "Mahara",
                "Mahuta",
                "Mahute",
                "Maigoge",
                "Majabu",
                "Maje-Mabin",
                "Majeme",
                "Maketi",
                "Makici",
                "Makogi",
                "Makuki",
                "Makyalo",
                "Malaga",
                "Malela",
                "Managara",
                "Mangwaro",
                "Mapapo",
                "Maragwasa",
                "Maranya",
                "Matadangwani",
                "Maundu",
                "Mazakari",
                "Momagi",
                "Nnali",
                "Old Izalo",
                "Old Kaiabu",
                "Old Magala",
                "R. Akwai",
                "R. kaba",
                "R.Gora",
                "Rafinahankachi",
                "Raha",
                "Rataya",
                "Rikwanjen",
                "Runtuwa Fulani",
                "S. G. Gwagwade",
                "S. Garafuni",
                "S. Gare",
                "S. Gumbi",
                "S. Majinga",
                "S. Manuta",
                "S/Garin Bobi",
                "Sarkwe",
                "Shuwale",
                "Suibonu",
                "Sukuntuntunun",
                "T. Ajiya",
                "T. Angulu",
                "T. Asala",
                "T. Assisa",
                "T. Audu",
                "T. bala",
                "T. bature",
                "T. Bawa",
                "T. Dandare",
                "T. Danjuma",
                "T. Gandi",
                "T. Gano",
                "T. Gere",
                "T. Giwa",
                "T. Gunzu",
                "T. Gwonda",
                "T. Hakeri",
                "T. Ibrahim",
                "T. isa",
                "T. isale",
                "T. Jibo",
                "T. Jika",
                "T. Joji",
                "T. Kade",
                "T. Kowa",
                "T. M",
                "T. M. Alu",
                "T. M. Gengi",
                "Ibelu",
                "Abaka",
                "Agille",
                "Agumo",
                "Akwau",
                "Atabo",
                "Azozo",
                "Bado",
                "Billi",
                "Bukkawa",
                "Buta",
                "D.Dandare",
                "D.Hill",
                "D.Kidi",
                "D.Saura",
                "Dakkolo",
                "Dankiyabu",
                "Dautai",
                "Doka",
                "F.Hill",
                "Farar Doka",
                "G. Baluwa",
                "G. Danboka",
                "G. Gamo",
                "G. Gamu",
                "G. Kwanu",
                "G. Magala",
                "G. Magashi",
                "G. Maigoge",
                "G. Mutun Daya",
                "G. Ubandakwaki",
                "Gaji Barabade",
                "Gari",
                "Gwari",
                "Hayi",
                "Hinsawan-Kume",
                "Ibeto",
                "Ibili",
                "Illela",
                "Ipana",
                "Itali",
                "Jange",
                "Jangu",
                "Kadarko",
                "Kura Gari",
                "Kwanzokwanzo",
                "Lagam",
                "Lagunmo",
                "Lujuru",
                "Mabunya",
                "Machinfa",
                "Magaman Baji",
                "Mahorondawa",
                "Maigaraja",
                "Mailanbu",
                "Mara a",
                "Masabu",
                "Masamagu",
                "Masanji",
                "Matalengo",
                "Nasko",
                "Old Madusa",
                "R. Daji",
                "Rafin Fada",
                "Shadadi",
                "Shashunwa",
                "T. Auta",
                "T. Bagudu",
                "T. Baha",
                "T. Basu",
                "T. Bukawa",
                "T. Dogari",
                "T. Galadima",
                "T. Kambari",
                "T. Kure",
                "T. Magaji",
                "T. Makeri",
                "T. Mangworo",
                "T. S. Fambo",
                "T. W. Mahilo",
                "T. Wakili",
                "Takalafiay",
                "U. S. Fulani",
                "U. B. Mai",
                "U. Baguda",
                "U. Bagudu",
                "U. Bamago",
                "U. Bande",
                "U. Bauna",
                "U. Bisalla",
                "U. Burgu",
                "U. Dambawa",
                "U. Danjule",
                "U. Dogo",
                "U. Gado",
                "U. Gishiri",
                "U. Hussani",
                "U. Kaddayui",
                "U. Kambari",
                "U. Kanda",
                "U. kettu",
                "U. Kibiya",
                "U. Langi",
                "U. Madalla",
                "U. Maje",
                "U. Maliki",
                "U. Mallam",
                "U. Mande",
                "U. Noma",
                "U. S. hardo",
                "U. S. Noma",
                "U. Shanu",
                "U. W. Ladan",
                "Wakili Gata",
                "War",
                "Yazariya",
                "Ygwama"
            ],
            "Mariga": [
                "Koton Kobo",
                "Ang S/Fillani",
                "Ang. Bangawa",
                "Ang. Bingara",
                "Ang. Citama",
                "Ang. Damagata",
                "Ang. Danbakwai",
                "Ang. Dangami",
                "Ang. Duda",
                "Ang. Maisigari",
                "Ang. Majiro",
                "Ang. Mitauni",
                "Ang. Nadaki",
                "Ang. Rugu",
                "Ang. Shekarau",
                "Ang/Wakili",
                "Asaya",
                "Basaya",
                "Bawa",
                "Beri Gari",
                "Bijagira",
                "Bobi Gari",
                "Danko",
                "Dogon Dawa",
                "Dorawai",
                "Durugu",
                "Dutsin Magaji",
                "Dutsindosa",
                "Fagai Sabuwa",
                "Galma Sama",
                "Ganda",
                "Garin Mamba",
                "Gauji",
                "Geshe",
                "Gudashi",
                "Ibaru",
                "Ifari Sabuwa",
                "Igwama Gari",
                "Indago",
                "Inkwai",
                "Iraba",
                "Jarenbana",
                "Kafigo",
                "Kanfani",
                "Kasuwan Ango",
                "Kasuwan Dogo",
                "Kasuwan Garba",
                "Kawawu Gari",
                "Kisisu",
                "Kotonkoro",
                "Kubaba",
                "Kudungunai",
                "Kukunga",
                "Kunai",
                "Kunugo",
                "Kurigi",
                "Kwanye",
                "Magumo",
                "Mahuta",
                "Maigoge",
                "Maketi",
                "Makici",
                "Mangwaro",
                "Mariga Gari",
                "Matari",
                "Matseri",
                "Maundu",
                "Mkaura",
                "Mudi",
                "Murai",
                "Rikwanjen",
                "S/Garin",
                "S/Garin Bobi",
                "Saban Gurugu",
                "Sabuwan",
                "Tsohon Gari",
                "Tumgan Maje",
                "Tun. Mailaka",
                "Tunku",
                "Uanbaru",
                "Uukuru",
                "Ung/Makama",
                "Unguwan Koto",
                "Urama",
                "Ushaman",
                "Wamba",
                "Yadi",
                "Zabiya",
                "Kumbashi",
                "Afaga",
                "Bangi",
                "Chuchu",
                "Daguzu",
                "G/Boka",
                "Gabbas",
                "Ibde",
                "Isanga",
                "Kakuza",
                "Kasankici",
                "Kazau",
                "Kuinme Gari",
                "Liwji",
                "Mabinni",
                "Mabirni",
                "Maburya Fada",
                "Mahoro Gari",
                "Makyankyane",
                "Mazame",
                "Ragada",
                "Runtuwa",
                "T/Dutsi",
                "U. Magaji",
                "Ukata Banji",
                "Ung. Dada",
                "Ung. Dutsi",
                "Ung. Fada",
                "Ung. Galadima",
                "Ung. Madawaki",
                "Ung. S. Fulani",
                "Ung. Ubandawaki",
                "Ung. Wan ya",
                "Ung. Waziri"
            ],
            "Mashegu": [
                "Mashegu",
                "Adabo",
                "Adogo",
                "Adogo Abase",
                "Agiya Dadin",
                "Akumu",
                "Amungi",
                "Ashiwa",
                "Assan",
                "Babagi",
                "Babban Aso",
                "Babban Rami",
                "Bagada",
                "Bakwai Bakwai",
                "Bangi",
                "Buzana",
                "Cagwa",
                "Dadin Kowa",
                "Dokoki",
                "Duba",
                "Dutsimangaji",
                "Gamu Gaku",
                "Gwata Muma",
                "Ibeton Kara",
                "Jagira",
                "Jaraku",
                "Jemaku",
                "Jigawa",
                "Kaboji",
                "Kalanto",
                "Karkaka",
                "Katati",
                "Kawo",
                "Konwan",
                "Labije",
                "Likyaule",
                "Magma",
                "Mahuta",
                "Maibabban Doki",
                "Makeri",
                "Masudi",
                "Masughi",
                "Matande",
                "Matane",
                "Nagogo",
                "Nasarawan",
                "Nsarawa Lugge",
                "S/Rijaya",
                "Sassa",
                "Soba",
                "Tibamu",
                "Tung Gusso",
                "Tung Madabiya",
                "Tung Maidoji",
                "Tung Nabobi",
                "Tung. Abba",
                "Tung. Afaf-Saiwa",
                "Tung. Ango",
                "Tung. Baare",
                "Tung. Barwa",
                "Tung. Dakarkar",
                "Tung. Damiwira",
                "Tung. Dan",
                "Tung. Dogo",
                "Tung. Edima",
                "Tung. Hussami",
                "Tung. Inda",
                "Tung. Ingilishi",
                "Tung. Kanahu",
                "Tung. Kassinawa",
                "Tung. M. Haussinmi",
                "Tung. Masara",
                "Tung. Namadala",
                "Tung. S/Noma-Masari",
                "Tung. Sa are",
                "Tung. Sabarma",
                "Tung. Sami Naka",
                "Tung. Tanangi",
                "Tung. Usaman Kano",
                "Tung. Wanzan",
                "Tung. Zarunmi",
                "Tung.Inwala",
                "Tung.Jagaba",
                "Tung.jiyya",
                "Tung.Kura",
                "Tung.Lelle",
                "Tung.Madagu",
                "Tung.Madawaki",
                "Tung.Magaji",
                "Tung.Maibanga",
                "Tung.Mairakumi",
                "Tung.Maisamari",
                "Tung.Mudi",
                "Tung.Namata",
                "Tung.Rafingora",
                "Tung.Tanko",
                "Tung.Ubandasaki",
                "Ugimu",
                "Ukaghu",
                "Zanfara",
                "Zugurma",
                "/M/Tanto",
                "Arewa",
                "Awuru",
                "Awuru Salkawa",
                "Baffan",
                "Bakochi",
                "Bakoshi",
                "Bakwai",
                "Bambafu",
                "Bani Zumbu",
                "Bawugi",
                "Bazabalmo",
                "Beji",
                "Bishe Kashi",
                "Bitagi",
                "Bodinga",
                "Bokota",
                "Bonko Salwaka",
                "Chafu",
                "Chega",
                "Cikogi",
                "Cuwankumin",
                "Daja",
                "Danpangi",
                "Danshe",
                "Dapangi",
                "Doka",
                "Donko",
                "Edam",
                "Edan Mallam",
                "Edogi",
                "Ekwagi",
                "Estagi",
                "Faje",
                "Fala Tako",
                "Fala Tifi",
                "Fanga",
                "Fellagi",
                "Gatakum",
                "Gbogan",
                "Gungawa",
                "Gwaji",
                "Hayin Buhari",
                "Ibbi",
                "Indamushi",
                "Jibwangi",
                "Jikimba",
                "Jiya",
                "Kachi",
                "Kangon Mulo",
                "Kanti",
                "Kawatachi",
                "Kawo Faje",
                "Kawo mulo",
                "Kiji",
                "Kuda",
                "Kulho",
                "Kupa",
                "Kuso",
                "Kusoko",
                "Kwabu",
                "Kwaifawa",
                "Kwantu",
                "Kwatachi",
                "Kwati",
                "Kyangawa",
                "Labin Shamu",
                "Lafu",
                "Leaba Salkowa",
                "Lebba",
                "Likoro",
                "Mabima",
                "Madubandaji",
                "Magama Mulo",
                "Mai Azara",
                "Mai Azara Faje",
                "Maikade",
                "Majeme",
                "Makuleshi",
                "Manigi Kotare",
                "Mapayi Mulo",
                "Mararaban",
                "Mash",
                "Mazakuka",
                "Mule",
                "Mulo Faje",
                "Nasarawa",
                "Nasarrawa Faje",
                "Nbokugi",
                "Pate",
                "Patiko",
                "Patiko Baki-Rafi",
                "Patiko U/Makera",
                "Pyi",
                "Rijoyogi",
                "Robu",
                "Ruga",
                "S/Garin Bisha",
                "S/Garin Bokosta",
                "S/Garin Yemi",
                "S/Maigodiya",
                "S/Mangara",
                "S/Mashigi I",
                "S/Mashigi II",
                "S/pegi",
                "S/Rijiya",
                "S/Sari Ubegi",
                "Sadugi",
                "Saho Rami",
                "Saikawa",
                "Salkawa",
                "Shafini",
                "Shakade",
                "T/Abu",
                "T/Abudu",
                "T/Ajiya",
                "T/Alh. Banjima",
                "T/Alhaji",
                "T/Aliyu",
                "T/Bakwai",
                "T/Dan Iya",
                "T/Danlando",
                "T/Dashi",
                "T/Dawa",
                "T/Gara",
                "T/Gero",
                "T/Gobirawa",
                "T/Gungawa",
                "T/Gyara",
                "T/Hassan",
                "T/Ibrahim",
                "T/Idirisu",
                "T/Jagbba",
                "T/Karo",
                "T/Lamba Biyu",
                "T/Liman",
                "T/Mabdu Jiya",
                "T/Magaji",
                "T/Magamata",
                "T/Mairiga",
                "T/Maisamale",
                "T/Miri",
                "T/Musa",
                "T/Raba Gardama",
                "T/Sabon Leaba",
                "T/Saidu Dule",
                "T/Sami",
                "T/Sammi",
                "T/Wansan",
                "T/Zabarma",
                "Talle",
                "U/Dukkawa",
                "Ubegi",
                "Uddu",
                "Ung. Kodage",
                "Ung. Maidawa",
                "Ung. Sarki",
                "Wadata",
                "Yemi",
                "Zuguma Yari"
            ],
            "Mokwa": [
                "Kede",
                "A. Aliyi",
                "A. Aliyu",
                "A. Ibrahim",
                "A. Moh. Haya",
                "Afugi",
                "Agatu",
                "Alh. Saidu",
                "Bade",
                "Banda",
                "Batagi",
                "Batangi",
                "Camp",
                "Cida Adua",
                "Cikangi",
                "Dakogi",
                "Dakungi",
                "Dalachi",
                "Denfa Kuso",
                "Dikko",
                "Edan",
                "Edolusa",
                "Edugi",
                "Egbagi",
                "Ekpagi",
                "Epa",
                "Esunginda",
                "Foti",
                "Fulani",
                "Ganamaru",
                "Gbatagi",
                "Gbogifu",
                "Gboto Alfarma",
                "Gudugi",
                "Gunduko",
                "Haruna Honad",
                "Ibba",
                "Irrigation",
                "Jangi",
                "Jebba",
                "Jedan Life",
                "Jiffu",
                "Kagowogi",
                "Kapataki",
                "Karogi",
                "Kodan",
                "Koshaba",
                "Koso Tsun",
                "Kpacita",
                "Kpaki",
                "Kpata Nku",
                "Kpetagi",
                "Kukpanti",
                "Kusoko Kota",
                "Labozhi",
                "Ladefu",
                "Lafiyagi",
                "Lafiyagi Ebigi",
                "Lafu",
                "Mahhanci",
                "Mai Saje",
                "Makatar S.",
                "Mamma Yagba",
                "Mamman Loko",
                "Mawogi",
                "Mureji",
                "Musa Giwa",
                "Mutari",
                "Muwo",
                "Ndafu",
                "Ndafu Hausawa",
                "Ndamaga",
                "Ndanawu",
                "Neieupa",
                "Nwogi",
                "Nyafu Olu",
                "P/Shaba Kolo",
                "Pati Zhiko",
                "Rabba Mokwa",
                "Rakun",
                "Sheshi Shaba 1",
                "Sheshi Shaba 2",
                "Takuma",
                "Tama Ai",
                "Tanapa",
                "Tatabu",
                "TEKpagi",
                "Tsafa",
                "Tswanle",
                "Tuna Hausawa",
                "Tunga",
                "Tyabo",
                "U/Hakimi",
                "Umaru",
                "Umaru M.",
                "Ungwar Dakari",
                "Usman Bukka Tusman Hakimin",
                "Wadat Uman",
                "Yahwa",
                "Mokwa",
                "Alj. Maikumbo",
                "Arma",
                "Bado",
                "Bali",
                "Bia Agi Eyi",
                "Bijagi",
                "Bokani",
                "Bukka",
                "Cattle Ranch",
                "Dakpan",
                "Egangi",
                "Ekwa",
                "Ezhi",
                "Fadegi",
                "G/Mai Bitagi",
                "Gbajibo",
                "Gunjigi",
                "K/Bokun",
                "Kagogi",
                "Kalema",
                "Kaniyan",
                "Kpakiko",
                "Kudu",
                "Kumigi",
                "Magun",
                "Maraba II",
                "Marraba",
                "Mile-One",
                "Ndayako",
                "Ngpe Camp",
                "Saw Mill",
                "Shika",
                "T/Alh. Musa",
                "T/Jirgi Gari",
                "Tab Gidan I",
                "Tika",
                "Tswakwagi",
                "Tung Dukawa",
                "Tuntuntiko",
                "Wa Abim Azhi",
                "Yakede Fimaye",
                "Yalwa Zab"
            ],
            "Munya": [
                "Muyi",
                "Angunu",
                "Beni",
                "Chibani",
                "Dandaudu",
                "Dangunu",
                "Daza",
                "Fuka",
                "G. Auta",
                "Gini",
                "Gwaderi",
                "Kabula",
                "Kazai",
                "Sarkin-Pawa",
                "Zaggaga"
            ],
            "Paikoro": [
                "Kafin Koro",
                "Abolo",
                "Adunu",
                "Agwa",
                "Baani",
                "Beji",
                "Beni",
                "Bukpasi",
                "Chimbi",
                "Danda",
                "Egwa",
                "Feri",
                "Fiene",
                "G. Bahago",
                "G. Garuba",
                "G. Gejere",
                "G. Gwari",
                "Gakoro",
                "Gbajawi",
                "Gwato",
                "Ishau",
                "Jibi Gida",
                "Jpamako",
                "Kafinkoro",
                "Kakuri",
                "Kamarini",
                "Kapadna",
                "Kuchiribi",
                "Kuchis",
                "Kudere",
                "Kuka",
                "Kumin Gwa",
                "Kunukunu",
                "Kurshi",
                "Kutikwa",
                "Kwagana",
                "Kwakuau",
                "Kwatuti",
                "Miye",
                "Nabw",
                "Nanati",
                "New Angnanpa",
                "New Dakolo",
                "Pinai",
                "S. Gbusami",
                "Shapkere",
                "Shaudna",
                "T. Amale",
                "T. Dndu",
                "T. Samari",
                "paiko",
                "Amini",
                "Baidna",
                "Bakajiba",
                "Bambe",
                "Buti",
                "Chapa",
                "Chawagi",
                "Chawnara",
                "Chefe",
                "Damago",
                "Damawopon",
                "Dankele",
                "Danu",
                "Dogon Ruma",
                "Dugba",
                "Eloigi",
                "Essan",
                "Farindoki",
                "Fenaleta",
                "Fide",
                "For a",
                "Gangare",
                "Gbam",
                "Gbansegodan",
                "Gbeite",
                "Gbodna",
                "Gemi",
                "Guada",
                "Gugo",
                "Guto",
                "Gwali",
                "Gwam",
                "Gwara",
                "Gwari",
                "I. Komo",
                "Isan",
                "Isari",
                "Jatau",
                "Jatayi",
                "Jedna",
                "Jere",
                "Jinboi",
                "Kaikuta",
                "Knatu",
                "Kuchisara",
                "Kwachi",
                "Kwakuti",
                "Kwanpi",
                "Laitapi",
                "Latuto",
                "Lukochi",
                "Lukopi",
                "M. Yaro",
                "Mikweji",
                "Mkuchi",
                "Mugi",
                "Mukapa",
                "Muye",
                "Nago",
                "Nagopita",
                "Ndayma",
                "Nubipe",
                "Nusupi",
                "Paiko",
                "Panshe",
                "Peta",
                "Pisiyingbo",
                "Raboji",
                "Ratati",
                "S. Gwari",
                "Sabo Gida",
                "Sala",
                "Sapai",
                "Seita",
                "Sesita",
                "Shai",
                "T/Mago",
                "T/mallam",
                "Takumpara",
                "Tanu",
                "Tau",
                "Tutungo",
                "Wabe",
                "Yida",
                "Zaje",
                "Zuru"
            ],
            "Rafi": [
                "Guna",
                "Abidi",
                "Ajimi",
                "Akusu",
                "G. Majaman",
                "Garungabas",
                "Gunugu",
                "Guria",
                "Gushi",
                "Jangaru",
                "Jimawa",
                "Kato",
                "Kundu",
                "Kwange",
                "Lelemu",
                "Pangu",
                "Sheta",
                "T. Maijaki",
                "T. Mauzu",
                "Ushama",
                "Yakila",
                "Kusheri",
                "G.Abaki",
                "Afilamaza",
                "Bakura",
                "Barkin Koci",
                "Bisama",
                "Bisura",
                "Canye",
                "D. Mainono",
                "Dasa",
                "G. B. Wakili",
                "G. Bagugu",
                "G. Baji",
                "G. Bidawa",
                "G. Bwabiyu",
                "G. Dangana",
                "G. Dankanu",
                "G. Gajere",
                "G. Haruna",
                "G. Kadaku",
                "G. Koko",
                "G. Maidoka",
                "G. Maidugu",
                "G. Maima",
                "T/Aliyu",
                "T/Bakwai",
                "T/Dan Iya",
                "T/Danlando",
                "T/Dashi",
                "T/Dawa",
                "T/Gara",
                "T/Gero",
                "T/Gobirawa",
                "T/Gungawa",
                "T/Gyara",
                "T/Hassan",
                "T/Ibrahim",
                "T/Idirisu",
                "T/Jagbba",
                "T/Karo",
                "T/Lamba Biyu",
                "T/Liman",
                "T/Mabdu Jiya",
                "T/Magaji",
                "T/Magamata",
                "T/Mairiga",
                "T/Maisamale",
                "T/Miri",
                "T/Musa",
                "T/Raba Gardama",
                "T/Sabon Leaba",
                "T/Saidu Dule",
                "T/Sami",
                "T/Sammi",
                "T/Wansan",
                "T/Zabarma",
                "Talle",
                "Tung. Abba",
                "U/Dukkawa",
                "Ubegi",
                "Uddu",
                "Ung. Kodage",
                "Ung. Maidawa",
                "Ung. Sarki",
                "Wadata",
                "Yemi",
                "Zuguma Yari"
            ],
            "Rijau": [
                "Rijau",
                "Korem",
                "Ulo",
                "Abaka",
                "Abara Mallam",
                "Abba Ushe",
                "Abonu",
                "Adamu",
                "Adande",
                "Adara",
                "Addaro",
                "Aduwa",
                "Afka",
                "Agwale",
                "Alamga",
                "Alanga Kure",
                "Anaina",
                "Angu",
                "Anna",
                "Anyau",
                "Anyo",
                "Arida Gare",
                "Arigida",
                "Ashama",
                "Ashingi",
                "Ayawu",
                "Ayituwo",
                "Anma",
                "Babba Zaure",
                "Badukike",
                "Bagasa",
                "Bakin Dutsi",
                "Bambadawa",
                "Baro",
                "Bashuwa",
                "Berje",
                "Buni",
                "Chinama",
                "Chitunu",
                "Bukkdcio",
                "Taru",
                "Daguni",
                "Dakibiyu",
                "Damana",
                "Dandagi",
                "Dandawa",
                "Dangi",
                "Danrangi",
                "Danrimi",
                "Darga",
                "Dima",
                "Diriya",
                "Diyanfura",
                "Dlanko",
                "Dofawa",
                "Doka",
                "Dugge",
                "Duku",
                "Etku",
                "Farin Dutse",
                "Farin Rawu",
                "Faskaregiwa",
                "Bature",
                "Bawa",
                "Boka",
                "Gatama",
                "Jambior",
                "Kambari",
                "Kanubari",
                "Kura",
                "Maiyaki",
                "Mallam",
                "Maima",
                "Myau",
                "Sualia",
                "Tawai",
                "Telu",
                "Uukuru",
                "W. Mmaturu",
                "Wagari",
                "S. Usama",
                "Danjuma",
                "Dogonkagari",
                "Gamahemari",
                "Jibomakeri",
                "Gidigori",
                "Godere",
                "Jakiri",
                "Kano",
                "Karaku",
                "Kashuwa",
                "Keke",
                "Kofanpawa",
                "Kugu",
                "Kukoki",
                "Kusheriki",
                "Masuku",
                "Moogo",
                "Gida",
                "Ukusu",
                "Sambuga",
                "Shamuyambu",
                "Bako",
                "Tukunguna",
                "Hamza",
                "Sani",
                "Toro",
                "Ufwaka",
                "Ukushe",
                "Uregi",
                "Ushama",
                "Zari",
                "Kwon Goma",
                "Dan-Gwasa",
                "Dogonfili",
                "Auta",
                "Biyuboki",
                "Dangaladima",
                "Dassa",
                "Galadima",
                "Jatau",
                "Kalia",
                "Kuyambana",
                "Maiduku",
                "Nakada",
                "Sarkinoma",
                "Masira",
                "Wusheynu",
                "Gabi",
                "Ganye",
                "Kwongoma",
                "Maikujeri",
                "Mangoro",
                "Pandogori",
                "Ringa",
                "Makeri",
                "Uranciki",
                "Ussiba",
                "Tegina",
                "Agwai",
                "Ankawa",
                "Gona",
                "Bangu",
                "Biito",
                "Padama",
                "Dada",
                "Abashi",
                "Barau",
                "Danbiki",
                "Dangama",
                "Dangoru",
                "Dijimakert",
                "Jada",
                "Katina",
                "Kushama",
                "Maiganga",
                "Maikangara",
                "Manzo",
                "Tanko",
                "Wakayi",
                "Wani",
                "Zubdomgi",
                "Gende",
                "Gini",
                "Gisisi",
                "Godora",
                "Gulangi",
                "Gunugu",
                "Halatayi",
                "Indaki",
                "Inga",
                "Inga Gari",
                "Jambaka",
                "Jiro",
                "Madaka",
                "Kagara",
                "Kakuri",
                "Katako",
                "Kuru",
                "Kwana",
                "Luaga",
                "Machinanugu",
                "Madagwa",
                "Mahanga",
                "Natsina",
                "Rubo",
                "Rubu",
                "Sabon Gari",
                "Samboro",
                "Sufawa",
                "Ceshi",
                "Duste",
                "Tunma",
                "Alhaji",
                "Uban-Dawaki",
                "Butsi",
                "Ugu",
                "Ussa",
                "Wayan",
                "Yalwa"
            ],
            "Shiroro": [
                "Galkogo",
                "Abaku",
                "Agumi",
                "Agwanggi",
                "Aiwa",
                "Akwaki",
                "Aleji",
                "Allawa",
                "Ayaba",
                "Bassa",
                "Batako",
                "Berago",
                "Bikwo",
                "Burwayi",
                "Chinwanya",
                "Chiwayu",
                "Chukuba",
                "Daggan",
                "Dami Dami",
                "Danumi",
                "Dogwashi",
                "Durni",
                "Ealali",
                "Erena",
                "Falele",
                "G. Sarkin",
                "G. Baguda",
                "G. Bako",
                "G. Galadima",
                "G. Idi",
                "G. Kama",
                "G. Kogo",
                "G. Maaji",
                "G. Maikomo",
                "G. Maimo",
                "G. Sarki",
                "G. Umaru",
                "G. Usisi",
                "G. Zamfara",
                "Godogodo",
                "Guadguri",
                "Gudo",
                "Gurmana",
                "Gwagwaulu",
                "Gwama",
                "Gwassa",
                "Ibunu",
                "Jabki",
                "Jangara",
                "K. Doma",
                "K. pada",
                "K/ Gurumai",
                "Kabagu",
                "Kalagai",
                "Kalia",
                "Kambari",
                "Karki",
                "Kasuman Kwaki",
                "Kawo",
                "Kazuma",
                "Kpakari",
                "Kuchid",
                "Kudodo",
                "Kukoki",
                "Kundimdna",
                "Kurebe",
                "Kurebi",
                "Kurusu",
                "Kushaka",
                "Kwaiki",
                "Kwaiko",
                "Laban",
                "Ladmana",
                "Lugga",
                "Lukupe",
                "Maganda",
                "Makera",
                "Mangwai",
                "Manta",
                "Mokuri",
                "Musuku",
                "Nakinde",
                "Numa",
                "Roro",
                "S. Gari",
                "Safari",
                "Shafi",
                "Sunnayu",
                "T. Garba",
                "T. Gora",
                "Tambaji",
                "Tatu",
                "U. Chirau",
                "Zangono",
                "Kuta",
                "Daboye",
                "A. Kolo",
                "Abera",
                "Adnami",
                "Agwagwa",
                "Aje",
                "Amuku",
                "Apomi",
                "Asha",
                "Awolo",
                "Badampa",
                "Bagnape",
                "Baguna",
                "Baku",
                "Bakuchi",
                "Bangajiya",
                "Bawa",
                "Bawaki",
                "Bayko",
                "Bushimi",
                "Cachala",
                "Chapai",
                "Chik Wale",
                "Chimbi",
                "D. Kofa",
                "Demi",
                "Dnalepe",
                "Dnawi",
                "Dugo",
                "Dumi",
                "Ebba",
                "Egba",
                "G. Gonday",
                "G. Akawu",
                "G. Alugoy",
                "G. Baroe",
                "G. Basakuri",
                "G. Dalawi",
                "G. Dibata",
                "G. Gazoma",
                "G. Guwa",
                "G. Jiko",
                "G. Kabori",
                "G. Kurumbe",
                "G. Kwabaita",
                "G. Kwato",
                "G. Laydna",
                "G. Madaki",
                "G. Mayo",
                "G. Musa",
                "G. Mutundaya",
                "G. Pinayi",
                "G. Sama",
                "G. Sugbi",
                "G. Sule",
                "G. Tapi",
                "G. Tuguru",
                "G. Tukwo",
                "G. Wakili",
                "G. Wambai",
                "G. Yarmasama",
                "G. Zar",
                "G. Zarumai",
                "G. Zarumaji",
                "G.Bakai",
                "G.Barga",
                "G.Karba",
                "Gbakopoi",
                "Gijiwa",
                "Gilwa",
                "Gunu",
                "Gurusu",
                "Gusoro",
                "Gwada",
                "Gwadna",
                "Gwarame",
                "Igu",
                "Ikanpini",
                "Ikwa",
                "Jataye",
                "Kafa",
                "Kakuru",
                "Kamache",
                "Kamari",
                "Kami",
                "Kapana",
                "Katipe",
                "Kato",
                "Kongo",
                "Kperi",
                "Kubi",
                "Kuchehuru",
                "Kuchi",
                "Kudami",
                "Kudodna",
                "Kufe",
                "Kukuwari",
                "Kulumi",
                "Kuna",
                "Kuno",
                "Kurmi",
                "Kushayi",
                "Kushi",
                "Kutitibi",
                "Kwamie",
                "Kwochi",
                "Lappa",
                "Lowa",
                "Lukuma",
                "Lukumbasa",
                "Luma",
                "Magayeba",
                "Maiganga",
                "Maikakaki",
                "Makama",
                "N. Gurusupe",
                "Nabi",
                "Nako",
                "Naza",
                "Nungbai",
                "Obaba",
                "Piwa",
                "Rafin Kuta",
                "Rowo",
                "Sabongida",
                "Sakwata",
                "Shaga",
                "Shakada",
                "Shakwati",
                "She",
                "Shinoro",
                "Shiri",
                "Sumaila",
                "T-Dama",
                "T. Sawadna",
                "T. Wakili",
                "Tagnari",
                "Tankita",
                "Taya",
                "Tepai",
                "Twalayi",
                "U. Agmay",
                "U. Kwaipe",
                "U. Kwase",
                "Ubandoma",
                "Ugba",
                "Yadna",
                "Yanuako",
                "Zuba"
            ],
            "Suleja": [
                "Apia",
                "Buru",
                "Burum",
                "Bwoi",
                "Chimbi",
                "Chizako",
                "Dachine",
                "Dwakoro",
                "Gauraka",
                "Gupena",
                "Gusun",
                "Ibo",
                "Ikume",
                "Jigbodo",
                "Kopu",
                "Kuchin Pwele",
                "Kutudibi",
                "Kwalada",
                "Kwamba",
                "Kwankashe",
                "Lafu",
                "Madalla",
                "Madugu",
                "Maje",
                "Muran",
                "Nabulic",
                "Numewa",
                "Padawa",
                "Rafin Kaffi",
                "Shingere",
                "Tunga Gwuntu",
                "Yagun",
                "Yaldna",
                "Zahehna"
            ],
            "Tafa": [
                "Tapa",
                "Dogon-Kurmi",
                "Garam",
                "Ija",
                "Iku",
                "Jakoro",
                "New Bwari",
                "Wuse",
                "Zuma"
            ],
            "Wushishi": [
                "Dagbaiko",
                "Akare",
                "Alkollko",
                "Ashishi",
                "Bada Mai Tulu",
                "Bankwagi",
                "Barwa",
                "Batan-Ndaba",
                "Bayan_Gayi",
                "Begi",
                "Bumigi",
                "Butuyi",
                "Buzu",
                "Cheji",
                "Dabbo",
                "Dabiti Woro",
                "Dankumagi",
                "Dogan Ruwa",
                "Dukusakun",
                "Dunyutugi",
                "Emi-Shiru",
                "Emiworo",
                "Enagi",
                "Erina",
                "Fugagi",
                "Gadan Merke",
                "Gboyagi",
                "Gekun",
                "Gidan Pangu Ndac",
                "Gidan Pangu Toko",
                "Gidan-Pangu",
                "Girin",
                "Gudi",
                "Gwasakun",
                "Indiga",
                "Jankwata",
                "Kacha",
                "Kado",
                "Kalakala",
                "Kaliko",
                "Kanankogi",
                "Kanfanin Kirya",
                "Kankara",
                "Kanko",
                "Kantin Kwari Hausawa",
                "Kanwa",
                "Katuna",
                "Kutai",
                "Kutunku",
                "Kutunkwaci",
                "Kwankwagi",
                "Kwaragi",
                "Kwata Chedu",
                "Liala Hausawa",
                "Lokjogoma",
                "Madegi",
                "Makera",
                "Makusudi",
                "Matajiya",
                "Mato",
                "Nadasako",
                "Naganu",
                "Nda-Ganshi",
                "Nda-Sara",
                "Nda-Shanko",
                "Ndace-Mamman",
                "Ndace-Shanko",
                "Ndaka-Gisau",
                "Pakara Gari",
                "Pakara Tasha",
                "Pasa",
                "Sabongari",
                "Saidan",
                "Saminaku",
                "Sancigi",
                "Shaku",
                "Tashan Dirigi Agwa",
                "Tsogi",
                "Tundun Alumu",
                "Tung. Kano",
                "Tunga",
                "Tunkunji",
                "Un. Sarkin Baka",
                "Ung. Madaki B",
                "Ung. Alkali",
                "Ung. Anarwa",
                "Ung. Barawa A",
                "Ung. Barawa B",
                "Ung. Madaki A",
                "Ung. Maje",
                "Ung. Makeri",
                "Ung. Mallam Lawal",
                "Ung. Pangu",
                "Ung. Rimi",
                "Ung. Tukura",
                "Ung. Tura",
                "Ung. Undako",
                "Ushiba",
                "Utare",
                "Wodata Hausawa",
                "Yakaji",
                "Yalwa",
                "Yamigi",
                "Zargin Hausawa"
            ]
        }
    },
    {
        "Ogun": {
            "Abeokuta North": [
                "Abeokuta (Rural)",
                "Imala",
                "2nd Ogun River Bridge",
                "Abese",
                "Abesin Isale",
                "Abesin Oke",
                "Abomolaso",
                "Abule - Aje",
                "Abule -Oke Sabo Area",
                "Abule Adelanwa",
                "Abule Nla",
                "Abule odunjo",
                "Abule Ohori",
                "Abule Oko",
                "Abule Olowojo",
                "Abule Olowun",
                "Abule Owe",
                "Abule Titun Village",
                "Adeku",
                "Adeleye",
                "Adeotan",
                "Adeyori",
                "Afagba",
                "Afonja",
                "Agarawu",
                "Agbanla",
                "Agbawo",
                "Ago - Odo",
                "Ago - Owu",
                "Ago-Ika",
                "oja Agbo",
                "Agunmona",
                "Ajana",
                "Ajegunle",
                "Akala",
                "Akere",
                "Akin olugbade",
                "Akinmade Oloro",
                "Akinwunmi",
                "Akiode",
                "Akomoje",
                "Alamaa",
                "Alamala Barrack",
                "Alapako Idi-Emi",
                "Alapo",
                "Alaru",
                "Amoror N.T.A",
                "Amukankan",
                "Anifa",
                "Anigbagbo",
                "Anima-Saun",
                "Animale",
                "Apana",
                "Apapa oluwa",
                "Apo-Owu",
                "Araromi - Aiyetoro",
                "Aro Hospital",
                "Aro village",
                "Asani",
                "Aseeso",
                "Asipa Ijeja",
                "Ata",
                "Atapa Ikoyi",
                "Atapa Ishaga",
                "Ate",
                "Babalogun",
                "Banjoko",
                "Base",
                "Base Olodi",
                "Bembe",
                "Bosero",
                "Church",
                "Daga",
                "Dasogunjo",
                "Dega",
                "Denro",
                "Ekefun",
                "Ekerin",
                "Eko",
                "Elega",
                "Elepo",
                "Elewuro",
                "Eruku",
                "Erunbe",
                "Fafunke",
                "Fagbenro",
                "Falano",
                "GAA",
                "Garage Area",
                "Gbengeri",
                "Gbolaku",
                "Gbomolese",
                "Gbopa",
                "Housing Elega",
                "Ibara Orile",
                "Ibaro",
                "Iberekodo",
                "Idan",
                "Iwo",
                "ijaye",
                "Idere",
                "Idi emi",
                "Idi Emo",
                "Idi Igba",
                "Idi Ori",
                "Idi-Iya/Onisasa",
                "Idiro Lanlowo",
                "Idiroko",
                "Idofin",
                "Idomapa",
                "Igbeyin",
                "Igbo - Aje",
                "Igbo Egun",
                "Igbogbede",
                "Igosun",
                "Ija Ofa",
                "Ikeye",
                "Ijaaye Onipepeye",
                "Ijaiye Deyorin",
                "Ijaje Road",
                "Ijako",
                "Ijemo",
                "Ijesha",
                "Ijeun",
                "Ika Ajibefun",
                "Ika Oloba",
                "Ikerek",
                "Ikereku",
                "Ikereku Idan",
                "Ikija",
                "Ila -Olona",
                "Ilakan",
                "Ilawo",
                "Ilewo",
                "Ilewo Township",
                "Ilugun",
                "Ilugun Agunrin (Mokola)",
                "Ilugun Isale",
                "Ilugun Itun Oluwo",
                "Ind. Est. (Idi-Ori)",
                "Ipaya Akintunde",
                "Isaga Orile",
                "Isaga Township",
                "Isagbesan",
                "Ita - Kinoshi",
                "Ita Balogun",
                "Ita Iyalode",
                "Ita Morin",
                "Ita Oje",
                "Oke Iddo",
                "Ita Oshin",
                "Itaka",
                "Ajitadun",
                "Iyalo Iliewo Oke",
                "Iyaye Obirintin",
                "Jagbadarigi",
                "Jebode",
                "Kanuko",
                "Keere",
                "Kipe",
                "Km 3 (mile 2 -a Stream)",
                "Kobiti",
                "Kogo",
                "Kojola",
                "Koosa Kerere",
                "Koosa Nla",
                "Kukudi",
                "Kumapayi",
                "Kurere",
                "Lafenwa",
                "Layeni",
                "Leper colony",
                "Loki",
                "Luhami",
                "Lukosi",
                "Lupona",
                "Madi",
                "Makinde",
                "Malomo",
                "Mulero",
                "Nageke",
                "Obada",
                "Obada Market",
                "Obalakun",
                "Obangeri",
                "Odi Ori",
                "Ogbe",
                "Ogbodo",
                "Ogboye",
                "Ogongo",
                "Ogun (Adedotun)",
                "Ogungbade",
                "Ojangangagan",
                "Ojibo-Alade",
                "Ojokodo/Ijaye",
                "Oke",
                "Oke Ata Housing Est.",
                "Oke Oko",
                "Oke Pape",
                "Oke Sokori",
                "Olomore Housing Estate",
                "Olomore Village",
                "Olorogun",
                "Olorogun Village",
                "Olose",
                "Olowo",
                "Olowo Odunjo",
                "Olowo Papa",
                "Olubo",
                "Oluwanfere",
                "Oluwo Ikije",
                "Onipako",
                "Oniyanrin village",
                "Onju",
                "Ontoye",
                "Oogidan",
                "Ope Oluwa Village",
                "Ori Okuta",
                "Orun",
                "Osho",
                "Osieke",
                "Osun Lafunke",
                "Owode",
                "Owu Olubode",
                "Owu Tuntun",
                "Padiku",
                "Ponkuku",
                "Sala Ayiinla",
                "Salu",
                "Sangote",
                "Sapon",
                "Sariki",
                "Siga Mayero",
                "Sodeke/Oko",
                "Sodipe",
                "Solosun",
                "Surulere Area Ita",
                "Taiwo",
                "Telefun",
                "Temidire off Sabo/Abule",
                "Tolato",
                "Totoro",
                "Township",
                "Yagi",
                "Yagofijo",
                "Yogun",
                "Abayawo",
                "Abule Egba",
                "Abule Oba",
                "Abule Ojo",
                "Abule Seriki",
                "Adelabu",
                "Adimo",
                "Agba",
                "Akiegun",
                "Akinniyi",
                "Alagbagba",
                "Alagbede",
                "Alagogo",
                "Alamola",
                "Aleelo",
                "Alowo Esin",
                "Anigbado",
                "Apasi",
                "Apata",
                "Apata-Oke odo",
                "Aragba",
                "Aragudu",
                "Are Elebute",
                "Arobajo",
                "Asanusi",
                "Aseso",
                "Asipa",
                "Ategbe",
                "Atoku",
                "Ayo",
                "Baala",
                "Baale",
                "Baba Ellegun",
                "Bamajo",
                "Begbinlawo",
                "Dasofunjo",
                "Elemugbarade",
                "Eleyoiju",
                "Falekan",
                "Fapota",
                "Fookusewa",
                "Iajiye",
                "Idera",
                "Idiata",
                "Idiemi",
                "Idiya",
                "Ijaiye Orike",
                "Ijala Orile",
                "Ijala Papa",
                "Ijaye Oke Odo",
                "Ilala",
                "Ileniku",
                "Ilugun Orile",
                "Imala Town",
                "Inawole",
                "Ipaya",
                "Isaka",
                "Iwelode",
                "Iwofin",
                "Iyalode",
                "Iyalode Tibo",
                "Jaarija",
                "Kesan",
                "Kesan Orile",
                "Ketu",
                "Kojala",
                "Laluwe",
                "Moloso",
                "Odango",
                "Ogbaagba",
                "Ogbon Elegba",
                "Ogenne",
                "Ogunola",
                "Ogunte",
                "Oje",
                "Ojo",
                "Ojokodo",
                "Ojubo Lade",
                "Ojubu Akinwande",
                "Ojubu Latilewa",
                "Ojugbele",
                "Ojumo",
                "Okooko",
                "Oloko",
                "Olorunda Market",
                "Olowu",
                "Olukosi",
                "Omilende",
                "Onlado",
                "Orunto",
                "Oyan Lawn",
                "Remilekun",
                "Sangowole",
                "Tibo",
                "Tim",
                "Tofi",
                "Yawo"
            ],
            "Abeokuta South": [
                "Ake",
                "Keesi/Emere",
                "Ijemo",
                "Itoko",
                "Ijaye/Idi-Aba",
                "Erunbe/Oke Ijeun",
                "Ago-Egun/Ijesa",
                "Sodeke/Sale-Ijeun I",
                "Imo/Isabo",
                "Igbore/Ago Oba",
                "Ibara"
            ],
            "Ado-Odo/Ota": [
                "Ado-Odo",
                "Igbesa",
                "Otta Rural",
                "Abule Kukoyi",
                "Adegbite",
                "Adigbon",
                "Agbojedo",
                "Agboku",
                "Agosu",
                "Ago potefa",
                "Aisunle",
                "Aisunle Alaagba",
                "Ajogbo Akia",
                "Ajogbo Aladura",
                "Ajogbo Ayeteju",
                "Ajogbo Asokere",
                "Ajogbo Bamgbose",
                "Ajogbo Dansin",
                "Ajogbo Jisu",
                "Ajogbo Idi Epa",
                "Ajogbo Seje",
                "Ajogbo Zebbe",
                "Akasun",
                "Aksun",
                "Araromi",
                "Alapoti",
                "Aragba",
                "Arubielu",
                "Aromokala",
                "Asipa",
                "Asokere",
                "Dodo",
                "Edu Sangoyomi",
                "Ejigbo",
                "Ere Oke",
                "Eruku",
                "Gbago",
                "Gbekan",
                "Gboje",
                "Gunuko",
                "Ibeku Papasa",
                "Iberese",
                "Idi Ope",
                "Idi Orogbo",
                "Idi ota",
                "Idiafa",
                "Idijigan",
                "Idofe",
                "Idolehin",
                "Idopbaarun",
                "Idosaba",
                "Ifako Ajogbedo",
                "Ifako igbegu",
                "Ifako Imasgai",
                "Igbeji",
                "Igbekan",
                "Igbogbo",
                "Igbojo",
                "Igborisa",
                "Igesu",
                "Igounu",
                "Ihundo",
                "Ijako",
                "Ijana",
                "Ijegbe Inawole",
                "Ijegemo",
                "Ijomu",
                "Ikoga bamalu",
                "Ikogale",
                "Ileji",
                "Iloro",
                "Imeiade onilogbo",
                "Inisa",
                "Isalu",
                "Ishapa",
                "Isogo",
                "Itiri",
                "Jagbaru",
                "Kento",
                "Kofelerin",
                "Kosomi",
                "Morekete",
                "Oba",
                "Obekobe",
                "Odan ijako",
                "Oju Iroko",
                "Ojuroko",
                "Olorunsogo",
                "Okanran Centre",
                "Okanran Ifelodun",
                "Oke Okuta",
                "Oko",
                "Okkusu",
                "Olokuta",
                "Oloparun",
                "Olorunleke",
                "Onantan Tafin",
                "Onilogbo",
                "Oniniosalasi",
                "Onlogbo",
                "Sagbamu",
                "Soki Ere",
                "Tepo",
                "Tokemi",
                "Aaaago",
                "Abatabutu",
                "Abisoye",
                "Abule Akapo",
                "Abule tisa",
                "Adekoyemi",
                "Aduloju",
                "Agana Idi Agbon",
                "Agana Olorunda",
                "Agbajowo Agoro",
                "Agbara",
                "Agboloye",
                "Ago Attan",
                "Ago Egan",
                "Ago Iboro",
                "Ago Imuse",
                "Ago Iso",
                "Ago Joyi",
                "Ago Titun",
                "Aiku",
                "Ajerogun",
                "Ajibode",
                "Agelete",
                "Akinleye",
                "Akinwunmi",
                "Akoore",
                "Aladie",
                "Aladura",
                "Alagbado",
                "Alasia",
                "Alogi",
                "Anuoluwapo Ijolo",
                "Araro",
                "Arigba",
                "Arigbawonwo",
                "Arikewuyo",
                "Arobi Eye",
                "Attan",
                "Atuko",
                "Ayigboyi",
                "Edu Baale",
                "Egando Ailigun",
                "Egando Akinbo",
                "Egando Alagba",
                "Egudu Baale",
                "Egudu Adesi",
                "Egudu Agbogun",
                "Egudu Lele",
                "Eguntedo",
                "Eleru",
                "Erinlr",
                "Ewuoe Ajasa",
                "Ewutagbe",
                "Fagbohun",
                "Faluyu",
                "Gboko Lusada",
                "Gbongbona",
                "Hunsa",
                "Iboro",
                "Idanyin Isaga",
                "Idanyin Mosafeso",
                "Idanyin Okepen",
                "Idanyin Orokogodo",
                "Idayin Petu",
                "Idi Araba",
                "Idologbo",
                "Idoye",
                "Idoye Aladura",
                "Ifelagba - Ijoko",
                "Igabehinadun",
                "Igbala Sango",
                "Igbekotin",
                "Igbele Fagbir",
                "Igbele Tella",
                "Igbo Odo",
                "Igbo Ota",
                "Igere",
                "Ijako Petedo",
                "Ijaliye Akosile",
                "Iju",
                "Ikogbo",
                "Ikumapayi",
                "Ilamiro",
                "Ilemijan",
                "Ilewo Alaga",
                "Iludun Attanimose",
                "Imuta",
                "Imutum",
                "Ipatira",
                "Iperun Odubule",
                "Irebale",
                "Isaga",
                "Isaga Onlado",
                "Isaka Sango",
                "Isanyin Baale",
                "Isorosi Abeokuta Road",
                "Itekun",
                "Iyana Ilogbo",
                "Joga Owode",
                "Jogbo",
                "Kajola Abanise",
                "Ketu Adie Owe",
                "Koko",
                "Konifewo",
                "Korogboji",
                "Kuku Oluyomi",
                "Kuoye",
                "Liasun Baligun",
                "Maku",
                "Messau",
                "Mew",
                "Mosufejo",
                "Obaraja",
                "Odan Abuja",
                "Odan Abuja Sule",
                "Odan Agbara",
                "Odan Odunsi",
                "Odugie Adie Ome",
                "Oke - Osa",
                "Oke Ilewo",
                "Oke Oki",
                "Oke ore",
                "Olanisa",
                "Ologir",
                "Olokopupo",
                "Olorunda Oke Ore",
                "Olorunlekan",
                "Omiata",
                "Onibisere",
                "Onigbogbo",
                "Onse Agbedi",
                "Onse Olose",
                "Onse Orita",
                "Opaaga",
                "Ore-Akinde",
                "Orente Abeokuta",
                "Oresa",
                "Owode Centre",
                "Owode Titun",
                "Paramoele",
                "Petedo",
                "Raod Ilogbo",
                "Sari",
                "Temidire",
                "Tigbolu",
                "Titilayo",
                "Totowu",
                "Wasimi Ajibawo",
                "Whedaum",
                "Wonwo",
                "Abgoju",
                "Abiola",
                "Aboyade",
                "Abule Abudu",
                "Abule Alimi",
                "Abule Egun",
                "Abule Fatorisa",
                "Abule Ijana",
                "Abule Iroko",
                "Abule Ologege",
                "Adalemo",
                "Ado _odo",
                "Afobaje",
                "Agbajowo",
                "Aiflodun Area",
                "Ajambata",
                "Ajegunle",
                "Ajuwose",
                "Akintole",
                "Akosile",
                "Alagba",
                "Araromi I",
                "Araromi Ifelodun",
                "Araromi II",
                "Araromi Orita",
                "Arijelowo",
                "Arinko",
                "Asore",
                "Atan Otta",
                "Ayetoro",
                "Balogun",
                "Egbatedo",
                "Ejigbo Baale",
                "Ekoledo",
                "Elemoki",
                "Erin",
                "Eriwo _Ejigbo Titun",
                "Ewupe",
                "Fabgayi",
                "Faluyi",
                "Farm Settlement",
                "Feru",
                "G.R.A",
                "G.R.A Extension",
                "Gateway",
                "Gbodojego",
                "Idesemo",
                "Idiagbon Agonna",
                "Idimu",
                "Idoleyin",
                "Ifedagba Surulere",
                "Ifedara",
                "Ifesowapo",
                "Igbawo",
                "Igbele Tela",
                "Igi Agbode",
                "Ignele Ajana",
                "Iho Ifako",
                "Ijaba",
                "Ijamido",
                "Ijegemo Seto",
                "Ijofin",
                "Ijoko",
                "Ijoko Titun",
                "Iju Otta",
                "Ilasa",
                "Ilogbo",
                "Iloye I",
                "Ilugbemi",
                "Ilupeju",
                "Ilupeju Estate",
                "Ilupeju iloye",
                "Ilupeju Owoye",
                "Ilupeju Temidire",
                "Imupi",
                "Ipamesan/Lereulist",
                "Ire Akari",
                "Irewolede",
                "Irofoko Aparadija",
                "Iropodun Morcas",
                "Isie",
                "Isimu",
                "Isokun",
                "Ita Mosa",
                "Itele",
                "Itori",
                "Iwaya",
                "Iwaye",
                "Iyana Arobieye",
                "Iyauru Titun",
                "Iyedi Titun",
                "Jibowi Isokan",
                "Joju Area Sango",
                "Kajola",
                "Ketere",
                "Keti Ohuyomi",
                "Kogi",
                "Lafenwa",
                "Lemomu",
                "Lesi",
                "Liberty Estate",
                "Mabaodu",
                "Madojutimi",
                "Mopin",
                "Ntabo",
                "Obere",
                "Odewale",
                "Odun-otun",
                "Ogo Oluwa",
                "Ogun Gbade",
                "Oguntedo",
                "Oke Ola",
                "Oke Ola Otun",
                "Oke Suna",
                "Olainukan",
                "Olokunla",
                "Olorunda",
                "Olorunde Aguna",
                "Olorunkemi",
                "Olugbode",
                "Olukoko Pupo",
                "Olunloye Ilufun",
                "Onifade",
                "Onipanu",
                "Onitoki",
                "Ore - Ajubde",
                "Orente",
                "Orile Iloye",
                "Oruba",
                "Ose Agbedi",
                "Osimeta",
                "Osuya",
                "Otun",
                "Otunlagba",
                "Oyede",
                "Oyero",
                "Oyewole",
                "Saka",
                "Sekoji",
                "Sokenu",
                "Surulere",
                "Unity Estate"
            ],
            "Ewekoro": [
                "Itori",
                "Abalabi",
                "Abese",
                "Abule Ado",
                "Ade aga",
                "Adopele",
                "Adunbu Bose",
                "Afewowa",
                "Aga olowo",
                "Pakudi village",
                "Agbamaya Isale",
                "Agbamaya Oke",
                "Agbesi",
                "Agbon",
                "Agodo",
                "Aiyepe",
                "Ajanbata",
                "Ajegunle",
                "Ajipatutu",
                "Akakun",
                "Ake",
                "Akimbo",
                "Akinale",
                "Akinbiye",
                "Akinjolo",
                "Akinyele",
                "Akirikan",
                "Alawusa",
                "Algbon",
                "Apode Sapode",
                "Aposu",
                "Araromi",
                "Arigbajo",
                "Arogo",
                "Asa",
                "Asa Abule Egba",
                "Asa obintin",
                "Asa oke oke",
                "Asa Olowo",
                "Asipa",
                "Ass Palolo",
                "Atola",
                "Atototan",
                "Awade",
                "Awu",
                "Ayinla",
                "Ayodere",
                "Babalawo",
                "Balagbe",
                "Balogun isaga",
                "Bayee",
                "Egbado Ajegunle",
                "Ejio",
                "Elegbata",
                "Elere Adubi",
                "Elobuto",
                "Eloyele",
                "Eruka",
                "Ewekoro",
                "Fasola",
                "Gudugba",
                "Idi aga",
                "Idiroka",
                "Idole",
                "Igbani awosegbe",
                "Igbani ojo",
                "Igbin Oloya",
                "Ijuma Ologboni",
                "Ika",
                "Ikeja",
                "Ikereku",
                "Ikija",
                "Ilawo",
                "Irenpa",
                "Isaye",
                "Iseku",
                "Ishopin",
                "Isofin orile",
                "Isola",
                "Itori Alase",
                "Iwokun Nia",
                "Iyede Balogun",
                "Jagua",
                "Jaguna",
                "Jaguna village",
                "Kajola",
                "Karieran",
                "Kenta",
                "Kewu",
                "Koboro",
                "Lafunke",
                "Lala",
                "Lambo",
                "Loti",
                "Lufedo",
                "Mataka",
                "Mokelu",
                "Mosan",
                "Mose",
                "Mose Balogun",
                "Obada",
                "Ogbaga",
                "Ogbere obanlade",
                "Ogunsola",
                "Ogunsola Oke",
                "Ogunsolu",
                "Ojo",
                "Oke",
                "Oke Lemo",
                "Oke Nia",
                "Oke Oke Egbado",
                "Oko oko sokoni",
                "Okun",
                "Olapeleke",
                "Olowo Papa",
                "Olowo Railway station",
                "Olu Agun",
                "Olugbesan",
                "Olujebi",
                "Oluko",
                "Olukobi",
                "Olupe Gbelu",
                "Oluwaji",
                "Ona Ara",
                "Onibotujo",
                "Onigbedu",
                "Onigbodu",
                "Onikooko",
                "Ontoye",
                "Opeyeke",
                "Orimoleye",
                "Oteyi Alagbede",
                "Oteyi Olokuta",
                "Otunaa",
                "Owo Railway station",
                "Owowo village",
                "Pade",
                "Papa ifo",
                "Papalanto",
                "Pata Abiodun",
                "Pataleri",
                "Sango Jinmi",
                "Sangojimi",
                "Sapeti",
                "Sepeti",
                "Sideji",
                "Siga Bayede",
                "Siga opalola",
                "Siwunmi",
                "Soderu",
                "Sojuolu",
                "Sokan",
                "Sologun",
                "Sopade",
                "Sule",
                "Temu",
                "Tobo",
                "Wasimi",
                "Wasimi Alaafia",
                "Wasimi Elefon",
                "Wsimi",
                "Yobe"
            ],
            "Ifo": [
                "Agbado",
                "Ifo",
                "Ojodu",
                "Aboro",
                "Aboro Town",
                "Adalemo Ope-Ilu",
                "Adiyan",
                "Adubaleja Ojuelegba",
                "Agbado Railway Station",
                "Ago Alagbede",
                "Enilolobo",
                "Folarin Olaore",
                "Ibaragun",
                "Ikuponiyi Afonta",
                "Isaga Town",
                "Isale",
                "Itoki",
                "Kongo",
                "Obafewmi",
                "Oke-Aro",
                "Ope-Ilu",
                "Oredegbe",
                "Ota",
                "Owonikoko",
                "Powerline",
                "Robiyan",
                "Sango",
                "Abekoko - Ifo Town",
                "Abeloju",
                "Abepaki",
                "Abudu",
                "Abule Ogun",
                "Adegbite",
                "Aderenle Town",
                "Agbegise",
                "Agosi Estate",
                "Akinhami",
                "Akinside",
                "Alapako Oke",
                "Alapako Sogunje",
                "Alapoti",
                "Araromi Quarters",
                "Asagun",
                "Asani",
                "Awe Akinde",
                "Awe Alapapo",
                "Awe-nla",
                "Ayede",
                "Baamu",
                "Balogun",
                "Bungalo - Ifo",
                "Coker Town",
                "Ebiti",
                "Ekundayo",
                "Epoto",
                "Ibgun Oderinlo",
                "Ibogun Akinode",
                "Ibogun Adina",
                "Ibogun Balogun",
                "Ibogun Egbeda",
                "Ibogun Fasina",
                "Ibogun Fayolu",
                "Ibogun Giwa",
                "Ibogun Ilugboro",
                "Ibogun Odejimi",
                "Ibogun Odeyemi",
                "Ibogun Olaogun",
                "Ibogun Sowunmi",
                "Ibogun Sunlola",
                "Idiaga",
                "Ifote",
                "Igbogun",
                "Iiepa",
                "Inogun Olaoparun",
                "Inogun Osugboye",
                "Jagunna",
                "Janbu",
                "Kajola",
                "Kajola Railway Station",
                "Lerin",
                "Oba Oseni",
                "Obasa",
                "Ojusango Town",
                "Okenla",
                "Olomu",
                "Oloparun",
                "Olorunsogo",
                "Olose",
                "Olowo",
                "Oluomo",
                "Omitoro Onifade",
                "Omitoro Balogun",
                "Onihale",
                "Oniyamo",
                "Opo",
                "Orile Ifo Town",
                "Osoba",
                "Ososun",
                "Pakoto",
                "Power line",
                "Saw-Mill",
                "Senokan",
                "Seriki",
                "Sogunle",
                "Solu",
                "Sonde",
                "Soyinka Alaga",
                "Tigbo-Ogun Town",
                "Ade Oni Estate",
                "Adigboloya",
                "Ishan-Olofin",
                "Mowere Town",
                "Ojodu Abiodun Town",
                "Wanwa",
                "Yakoyo"
            ],
            "Ijebu East": [
                "Fetedo",
                "Ogbere",
                "Ojowo",
                "Denuren",
                "Ebuite Imobi",
                "Fowoseje",
                "Iba",
                "Ija Gba",
                "Ijebu Ife",
                "Imodi",
                "Itapampa",
                "Itasin",
                "Luwako",
                "Malara",
                "Mofowoku",
                "Oke Mayar",
                "Oke Tonigbo",
                "Oki Aroromi",
                "Oki Ggbode",
                "Okomokun",
                "Taliwo",
                "Tekule",
                "Terelu",
                "Togunsilu",
                "Totoruubesan",
                "Tozsiwotoga",
                "Tutunba",
                "Abapawa",
                "Ago Ajebe",
                "Ago Alafia",
                "Ago Ikale",
                "Ago Isoko",
                "Ago Oloja",
                "Ajage",
                "Aje Bandele",
                "Ajepodo",
                "Araromi Balogun",
                "Atayo",
                "Bolorunduro",
                "Dopamu",
                "Esure",
                "Ewuren",
                "Idono",
                "Ifodo",
                "Igan Arin",
                "Igan Nla",
                "Ilodo",
                "Ijebu-Imushin",
                "Ikala",
                "Imarere",
                "Imogun",
                "Imuwen",
                "Isire",
                "Itamarun",
                "Itamogiri",
                "Itele",
                "Iwaya",
                "Kojola",
                "Lagun",
                "Lagunjo",
                "Lawiwi",
                "Lumafon",
                "Lumugo Akande",
                "Mafowokun",
                "Odo Aseri",
                "Odolameso",
                "Odomagbo",
                "Odometi",
                "Oke Ogbe",
                "Okenla",
                "Okeyinbo",
                "Onipetesi",
                "Orisombare",
                "Orita Imobi",
                "Temidire",
                "Ala Camp",
                "Ebidagba",
                "Erigun",
                "Idofe",
                "Igbo Mokun",
                "Igode",
                "Ijebu -Ife",
                "Odoladalepo",
                "Okeliwo",
                "Tajala",
                "Tedesia",
                "Timorowo",
                "Tirosogun"
            ],
            "Ijebu North": [
                "Ago Iwoye",
                "Ijebu - Igbo",
                "Oru / Awaa / Ilapoaru",
                "Aajugunle",
                "Aba Abekok",
                "Aba Atala",
                "Aba kaka",
                "Aba Mosemi",
                "Aba Nene",
                "Aba Oke",
                "Aba Panu",
                "Aba Tedu",
                "Aba Togungbe",
                "Abekoko",
                "Agbanje",
                "Aityetutu",
                "Aiyere",
                "Ajalorun",
                "Aje-Bandele",
                "Ako Alasala",
                "Ako Gelete",
                "Ako Oladere",
                "Ako Olojimbo",
                "Ako Onigbagbo",
                "Aladie",
                "Alebiosu",
                "Aledis",
                "Alesinloye",
                "Animasaun",
                "Araromi",
                "Aredi",
                "Badaru",
                "Dako",
                "Dehinsilu",
                "Ebidagba",
                "Ehin Etiri",
                "Elega",
                "Elegun Mesan",
                "Erapo",
                "Eri Oke",
                "Erilobi",
                "Erin Somibare",
                "Erubudo",
                "Esenale",
                "Fifipon",
                "Idarika",
                "Idesan",
                "Idi Ewere",
                "Idi Orombo",
                "Idiomo",
                "Igbodu Oloja",
                "Ilemo",
                "Imobido",
                "Imosu -Nla",
                "Ipakodo",
                "Isanmuro Alelo",
                "Isiye",
                "Itamo",
                "Labagidi",
                "Laboye",
                "Laguntan",
                "Lasan",
                "Latutbu",
                "Legan Onigbagbo",
                "Lokota Orile",
                "Lukoti",
                "Lumasa",
                "Mamu",
                "Masawun",
                "Mobido",
                "Mosimi",
                "Ogunsanya",
                "Oke Eri",
                "Ologundudu",
                "Olojowo",
                "Omi Gbogbongbo",
                "Osuu Budepo",
                "Tako",
                "Talagbe",
                "Tomoloju",
                "Aba Afon",
                "Aba Alaga",
                "Aba Makoli",
                "Aba Titun",
                "Abaliwo",
                "Abidepe",
                "Abude",
                "Afolabi",
                "Agbowa",
                "Agunboye",
                "Aiyesan Agoke",
                "Aiyesan Gboko",
                "Aiyesna Soyemi",
                "Ajebandele",
                "Ajebo",
                "Ajede Koleti",
                "Ajegunle",
                "Alabameta",
                "Alakiya",
                "Alakosu",
                "Alasodudu",
                "Aparaki Isale",
                "Araromi (R.H. S.)",
                "Araromi Balogun",
                "Araromi Liji",
                "Arowontaba Alimi",
                "Balore",
                "Balufon",
                "Basele",
                "Bojowa",
                "Dagbolu",
                "Danloro",
                "Egan Elagbawa",
                "Egbe",
                "Eleiyele",
                "Elewudu",
                "Enigbowa",
                "Eresun",
                "Erilope",
                "Erineke",
                "Eringbala",
                "Erinla",
                "Erinlogun",
                "Erinwodo",
                "Etiale",
                "Etikiji",
                "Falafumu",
                "Feoseje",
                "Feyifitan",
                "Fowosere",
                "Gbedesre",
                "Idi Oparun",
                "Idi-Orogbo",
                "Idofe",
                "Igaran isale",
                "Igaran Oke",
                "Ijbu igbo",
                "Iloren",
                "Imaagbon",
                "Imope",
                "Iyaniwura",
                "Jibowu",
                "Kajola",
                "Kujera",
                "Laosi",
                "Lapekun",
                "Lojota",
                "Lumogede",
                "Moborade",
                "Mosimi Awa",
                "Motokan",
                "Munira",
                "Obisesan",
                "Odeko",
                "Odiolowo",
                "Odo Alamo",
                "Odo Osun",
                "Ogbeluja",
                "Ogunbela",
                "Ogundugbo",
                "Ogunligba",
                "Oke Oliwo",
                "Oke Orowa",
                "Oke-Owa",
                "Oligbo",
                "Olkuwa Oke",
                "Oloba Loke",
                "Olokuta",
                "Olriwo Olotun",
                "Oni Digbolu",
                "Onigbo- Tunije",
                "Orimogunye",
                "Orisunbare",
                "Owode Awa",
                "Pamipola",
                "Patugi",
                "Sebiotimo",
                "Tagbejade",
                "Tagidi",
                "Takemo",
                "Telu Bomi",
                "Timogun",
                "Togunberu",
                "Tokinowo",
                "Towotunsen",
                "Yesufu",
                "Aba Iiepe",
                "Aba Laiwo",
                "Aba Merin",
                "Abata",
                "Abeku",
                "Abobi",
                "Adaran",
                "Adegba",
                "Adegorusen",
                "Ademowo",
                "Aiyesan",
                "Ajebandele Nugba",
                "Ajere",
                "Ajeregun",
                "Akinlade",
                "Alagunatan",
                "Alakija",
                "Alaporu",
                "Alesin Loye",
                "Amula",
                "Apoje",
                "Ariye",
                "Arowa",
                "Arowasun",
                "Asigidi",
                "Awe",
                "Awori",
                "Baba Egbe",
                "Bale",
                "Balogun",
                "Bobale",
                "Dinagbodo",
                "Egan Moro",
                "Egan Saba",
                "Egan-Giwa",
                "Egudugba",
                "Egunango",
                "Eredo",
                "Eredo Siwonku",
                "Eresu",
                "Erigboro",
                "Erikurudu",
                "Eril Somibare",
                "Erilamo",
                "Eriloke",
                "Erubodo",
                "Etikiriji",
                "Etitiale",
                "Eyin-Erejun",
                "Eyinobo",
                "Eyioke",
                "Gbogiri",
                "Gbokutaru",
                "Gboro",
                "Ibakan Isale",
                "Ibakan Oke",
                "Idagbolu",
                "Idi-Egun",
                "Ikan-Ide",
                "Imosu Daniel",
                "Ipakado",
                "Ipeja",
                "Ita Erikekere",
                "Ita-Arapa",
                "Ita-Egba",
                "Italiwo",
                "Iworo",
                "Lagan",
                "Lajao",
                "Lijota",
                "Lokoti",
                "Lugbangidi",
                "Lugbowo",
                "Moborode Sanni",
                "Mope",
                "Muren",
                "Odo-Ekerin",
                "Odosenbora",
                "Odosubugbawa",
                "Odooye",
                "Ogun Sanya",
                "Ogundugba",
                "Ohun",
                "Ojobaloke",
                "Oke- Eraye",
                "Oke- Eri",
                "Oke- Odo",
                "Oke- Ogbe",
                "Oke- Oliwo",
                "Oke- Owa",
                "Oke-Efon",
                "Ologunduu",
                "Oloje",
                "Olowa",
                "Olugba",
                "Oluwo Olotun",
                "Omo Ogunarun",
                "Omu Gbawojo",
                "Oni Dagbolu",
                "Osun Budepo",
                "Owode Agbatioro",
                "Papa Bale",
                "Reseyin",
                "Samore",
                "Sigunsin",
                "Ago Oloja",
                "Ajage",
                "Aje Bandele",
                "Ajepodo",
                "Atayo",
                "Bolorunduro",
                "Dopamu",
                "Esure",
                "Ewuren",
                "Idono",
                "Ifodo",
                "Igan Arin",
                "Igan Nla",
                "Ilodo",
                "Ijebu-Imushin",
                "Ikala",
                "Imarere",
                "Imogun",
                "Imuwen",
                "Isire",
                "Itamarun",
                "Itamogiri",
                "Itele",
                "Iwaya",
                "Kojola",
                "Lagun",
                "Lagunjo",
                "Lawiwi",
                "Lumafon",
                "Lumugo Akande",
                "Mafowokun",
                "Odo Aseri",
                "Odolameso",
                "Odomagbo",
                "Odometi",
                "Oke Ogbe",
                "Okenla",
                "Okeyinbo",
                "Onipetesi",
                "Orisombare",
                "Orita Imobi",
                "Temidire",
                "Ala Camp",
                "Erigun",
                "Igbo Mokun",
                "Igode",
                "Ijebu -Ife",
                "Odoladalepo",
                "Okeliwo",
                "Tajala",
                "Tedesia",
                "Timorowo",
                "Tirosogun"
            ],
            "Ijebu Ode": [
                "Ijebu Ode",
                "Abapawa",
                "Agbowa",
                "Agoro",
                "Akata",
                "Asenba",
                "Atakobo",
                "Atiba",
                "Egba",
                "Ereji",
                "Erigo",
                "Erinlu",
                "Esuru",
                "Gbawojo",
                "Idi Mmango",
                "Idona",
                "Ifido",
                "Iganke",
                "Igara",
                "Igasa Odo",
                "Igbeba",
                "Igbogun",
                "Igbokutu",
                "Iillses",
                "Ikangba",
                "Ikoto",
                "Ilone",
                "Iloti",
                "Imagbonlmegun",
                "Imodi",
                "Imosan",
                "Imowe",
                "Imowo",
                "Iperin",
                "Irawon",
                "Isade",
                "Isiwo",
                "Itabu",
                "Itamarun",
                "Iwesi",
                "Lapara",
                "Latugun",
                "Maraika",
                "Mobalufon",
                "Odo - Ajatun",
                "Odo - Ladenusi",
                "Odo -Deyo Isiwo",
                "Odo Epo",
                "Odo Lataye",
                "Odo- Akata",
                "Odoaiye",
                "Odokobiara",
                "Odolayanra",
                "Odolewu",
                "Odomolasa",
                "Odonoko",
                "Odosengbu Ajano",
                "Odosenlu",
                "Oke - Owe",
                "Oke -Oke",
                "Oke Eri",
                "Oke Lifete",
                "Okemoyin",
                "Omidudu",
                "Omodo",
                "Onala -Odoasonyin",
                "Ososa"
            ],
            "Imeko-Afon": [
                "Ilegbe",
                "Ilubo",
                "Imule",
                "Iropo",
                "Ita Egbe",
                "Ita ige",
                "Kajola",
                "Koko",
                "Lukosi",
                "Mede",
                "Modoga",
                "Mogbara",
                "Ogosa",
                "Oju-Igo",
                "Oke Eye",
                "Oke Iwo",
                "Oke Ojomo",
                "Okere",
                "Onibgedu"
            ],
            "Ikenne": [
                "Irepodun",
                "Dumez Staff",
                "Idarika",
                "Idenna",
                "Iditun",
                "Ikenne",
                "Ilishan",
                "Iperu",
                "Irolu",
                "Ogere"
            ],
            "Ipokia": [
                "Ifeyintedo",
                "Aferiku",
                "Afuye",
                "Ajegunle-Town",
                "Ajelande",
                "Akojapa",
                "Akopin",
                "Alari",
                "Araromi",
                "Asipa",
                "Atan-Otta",
                "Ayetoro",
                "Bantepa",
                "Idiroko",
                "Idoforo",
                "Idologun -Araromi",
                "Idomogun",
                "Iganmi",
                "Igbo Egun",
                "Igbo-Atan",
                "Igbodo",
                "Igborddo",
                "Igboso",
                "Ihunbo",
                "Iledu",
                "Ilegbe",
                "Ilese",
                "Ilubo",
                "Imule",
                "Iropo",
                "Ita Egbe",
                "Ita ige",
                "Kajola",
                "Koko",
                "Lukosi",
                "Mede",
                "Modoga",
                "Mogbara",
                "Ogosa",
                "Oju-Igo",
                "Oke Eye",
                "Oke Iwo",
                "Oke Ojomo",
                "Okere",
                "Onibgedu",
                "Orisada-Eyo",
                "Osooro",
                "Osoro",
                "Owotedo",
                "Saaraa",
                "Wasimi-Korodu",
                "Abojupa",
                "Abule Baba-Kerere",
                "Abule Iboro",
                "Abule Idogun",
                "Abule Olupe",
                "Adanmaye",
                "Adegolu",
                "Adimarum",
                "Afame",
                "Afannji -Oke",
                "Afon",
                "Agada",
                "Aganmathen",
                "Agbenodo",
                "Agbogbe",
                "Agbojedo",
                "Agoegun",
                "Agosasa",
                "Aholome",
                "Ahovo",
                "Ajana",
                "Ajekora",
                "Akere",
                "Alagangan",
                "Alagba Gba",
                "Alagban",
                "Alagbomejo",
                "Anagunji",
                "Apata",
                "Araromi Onfo",
                "Arogo",
                "Aruwa Aboloko",
                "Aseko",
                "Asere",
                "Atapele",
                "Atupa",
                "Aworo",
                "Ayedire",
                "Bejeri",
                "Bilafon",
                "Bode -Ashe",
                "Daramola",
                "Elemo jogga",
                "Falegbe",
                "Fanji Whegbe",
                "Gbadata",
                "Gbegodo",
                "Gbodojego",
                "Gbonje",
                "Ibadan",
                "Ibetefui",
                "Idabata",
                "Idaoka",
                "Idaoku",
                "Idaro",
                "Idetefin",
                "Idijoriidiku",
                "Idimarun",
                "Idofa",
                "Idolirosa",
                "Idomafe",
                "Idopetu",
                "Idosa",
                "Idosemo Village",
                "Igada",
                "Iganun",
                "Igate",
                "Igbao",
                "Igbeko-Akapo",
                "Igbekon",
                "Igbo-Irin",
                "Igesu",
                "Ighodoroju",
                "Igu",
                "Igudafin",
                "Igude",
                "Igun",
                "Igunnu",
                "Igunu",
                "Ijofin Town",
                "Ilara",
                "Ilero",
                "Ileshi- Isale",
                "Ileshi-Oke",
                "Ilewe",
                "Ilotin",
                "Ilufe",
                "Ilusi",
                "Imeko",
                "Imeri",
                "Inuka",
                "Inuya",
                "Ipinle-Aga",
                "Ipinle-Otho",
                "Ipokia",
                "Ishaka",
                "Isii",
                "Isuku",
                "Ita Agboyinu",
                "Iwoye",
                "Iwuka",
                "Iweka",
                "Iweka Gbodo",
                "Iyesi",
                "Izigi",
                "Jihome",
                "Kate Seje",
                "Keguta",
                "Kobejo",
                "Kogo",
                "Koriwi",
                "Kosomi",
                "Mafor",
                "Magunta",
                "Matale",
                "Maun Isale",
                "Maun Oke",
                "Maunseje",
                "Modo",
                "Moriwo",
                "Mosifa",
                "Obada",
                "Obalaja-Isale",
                "Obaningbe Oke",
                "Obolo",
                "Odan Ijaye",
                "Odan Ipopo",
                "Odofin Folashade",
                "Ojubu-Alade",
                "Okuta",
                "Ologede",
                "Oloruntedo",
                "Onimowo",
                "Oniro",
                "Orisade",
                "Osibadan-Isale",
                "Osibadan-Oke",
                "Owode-Idi-Ayin",
                "Pao",
                "Sakome",
                "Seje",
                "Soka",
                "Soke Topota",
                "Tapa",
                "Tobolo",
                "Togbowa",
                "Tongeji",
                "Tube Poye",
                "Tube-Town",
                "Vahe-Ajanukome",
                "Vahwe Tafa",
                "Vawhe -Pevi",
                "Vawhe-Hundo",
                "Vawhe-Tukuru",
                "Vitapa",
                "Whekan",
                "Wheke",
                "Zekanme"
            ],
            "Obafemi-Owode": [
                "Ajebo",
                "Ajura",
                "Alapako oni",
                "Kajola",
                "Mokoloki",
                "Mokoloki Asipa",
                "OBA",
                "Obafemi",
                "Ofada",
                "Ogunmakin",
                "Onidundu",
                "Owode",
                "Aderupatan",
                "Ajebo Iga Diyaolu",
                "Ajebo Iga Durojaiye",
                "Ajebo Iga Osaye",
                "Ajebo Iga Sanyaolu",
                "Ajongolo",
                "Apena Ifote",
                "Aragba",
                "Asore",
                "Ayidina",
                "Bala Ifote",
                "Bamigbaye",
                "Eleruja",
                "Fidiwo",
                "Moshan",
                "Nig. Youth Camp.",
                "Obe",
                "Odekunle Abatan",
                "Odeyemi Olugbo",
                "Odi",
                "Oduroye",
                "Oluwo Ifote",
                "Oniworo",
                "Oseni Kehinde",
                "Osiele",
                "Sanya Akiloju",
                "Soyinka Ifote",
                "Abata Ladile",
                "Abiodun",
                "Afuyeke",
                "Agbada",
                "Agbadu",
                "Agbedi",
                "Agbojulogun",
                "Agura",
                "Ajayi Are",
                "Ajetutu",
                "Alfa Jinadu",
                "Alfa Lemomu",
                "Ariye",
                "Asero",
                "Awo Lufoko",
                "Bara",
                "Eredo Balogun",
                "Fere-bi Ekun",
                "Idin ni",
                "Igbore",
                "Igun Elegande",
                "Iiegbo",
                "Iiepe",
                "Ijaiye",
                "Ijemo Aretu",
                "Ijemo Kokoyi",
                "Ijemo Oguntayo",
                "Ikanna Balogun",
                "Ikanna Paraga",
                "Ikanna Seriki",
                "Isoba",
                "Itoku Ande",
                "Jokuto",
                "Kumolu",
                "Lapoyo",
                "Liyoku",
                "Logbara",
                "Oba Akinsola",
                "Odofin Odo",
                "Odofin Oko",
                "Odowore",
                "Oganla",
                "Ogbanja Liyebi",
                "Ogun Oridota",
                "Oke Age",
                "Olojo",
                "Oluodo",
                "Oluwo Ikanna",
                "Orile Imo",
                "Otunba",
                "Ponlade",
                "Potoki",
                "Seriki Imo",
                "Sinun",
                "Siun Market",
                "Sofolu",
                "Sogbake",
                "Sogbiyanju",
                "Solo",
                "Somore Olowotedo",
                "Soyinka",
                "Tiku",
                "Wasimi Sogaolu",
                "(Kolade)",
                "Aba Ibadan",
                "Abujana",
                "Adeliyi",
                "Akidele",
                "Akinbile",
                "Aladura Araromi",
                "Aladura Seriki",
                "Alapako - Oni Iga Asipa",
                "Alapako - Oni iga Balise",
                "Alapako - Oni Ita Itoko",
                "Alapaku - Oni II",
                "Aluoge",
                "Asaolu",
                "Ayegunle",
                "Balagada",
                "Bankole Ifote",
                "Bere Lemomu",
                "Bereola",
                "Bodo",
                "Debonre",
                "Ekendetu",
                "Erunwon Lagba",
                "Fadipe",
                "Ijana Alapako",
                "Ijeun Obadina",
                "Imo Lisa",
                "Iporo Akigbogun",
                "Iporo Akonsanya",
                "Iporo Bankole",
                "Iporo Sopin",
                "Itori Fasola",
                "Jagunna Erunwon",
                "Ladijo",
                "Lawani Degbe",
                "Oba Funmilayo",
                "Oba Ogundimu",
                "Odo Ibadan",
                "Ogundimu",
                "Ogunmakin Hausa Coom.",
                "Ogunmakin Market",
                "Oliyide",
                "Olorunda Market",
                "Olowo Oyerinde",
                "Omi Ayo Itoku",
                "Onigbodogi",
                "Sanya Iporo",
                "Sanya Itoku",
                "Seriki Sotayo",
                "Sonde Elesin",
                "Soobu",
                "Sora Bale",
                "Sotayo",
                "Sotiyo",
                "Sowunmi",
                "Yakoyo",
                "Abayomi",
                "Aberuagba",
                "Abiona",
                "Abore Ikagbo",
                "Adebayo",
                "Adegbesan",
                "Adekunjo",
                "Adelokun",
                "Adesuyi",
                "Agbedimu",
                "Agosu Sekeseke",
                "Ajibayo",
                "Ake Amode",
                "Akiegun",
                "Akinsola",
                "Akinwale",
                "Akiode",
                "Apena Erunwon",
                "Apena Ishan",
                "Araba",
                "Aro Erunwon",
                "Aro Ituko",
                "Baki Ake",
                "Baleye",
                "Baloye",
                "Baluorogun",
                "Base Itoku",
                "Basina",
                "Bayan Kemta",
                "Dada Odamo",
                "Foke",
                "Gbagura Akinyemi",
                "Gbebikan",
                "Gbonaja",
                "Ibunlare",
                "Idi-Osun",
                "Ikereku",
                "Ikereku Ewemoja",
                "Ikereku Sipe",
                "Ilogbo Abore",
                "Iraye",
                "Isolefon",
                "Itori Loka",
                "Jagunna",
                "Jibowo",
                "Kajola Market",
                "Kannike",
                "Kemta Lakusodo",
                "Kuti Ikagbo",
                "Lemo Okunsiji",
                "Lesin",
                "Losi",
                "Lufijabi",
                "Luodo",
                "Mayan",
                "Momo",
                "Mosafejo",
                "Oba",
                "Oba Imale",
                "Oba Okukenu",
                "Obayomi",
                "Ogbe Erunwon",
                "Ojoke",
                "Oko Atoyinbobo",
                "Oko Iyeru",
                "Oko Nlado",
                "Olibori",
                "Olojede Asipa",
                "Oluwo Iporo",
                "Oojoru",
                "Oojunibojuleru",
                "Opeifa",
                "Oropa Akinde",
                "Orunmolu",
                "Osaye",
                "Oso Layanran",
                "Otunbade",
                "Oyebola",
                "Saibu",
                "Sakotun",
                "Sapana",
                "Sodunke",
                "Solanke",
                "Sowemimo",
                "Tolu",
                "Wasimi Oloruntedo",
                "Woro Elepo",
                "Woro Meroyi",
                "Aba Oke",
                "Agbawin Obi",
                "Agbawon Etido",
                "Age Bankole",
                "Aghbanowo Etitdo",
                "Ajambata",
                "Ajelanwa",
                "Ajerogun",
                "Akomologbon",
                "Amu",
                "Apena Ojodu",
                "Aralu",
                "Asasa",
                "Asasa Olofin",
                "Aworan Lesi",
                "Bala Onigbongbo",
                "Balogun Bobe",
                "Bisodun",
                "Ebute Ore",
                "Eleworo",
                "Erunla",
                "Ewepeju",
                "Gidimo",
                "Ibafo",
                "Idiroko",
                "Igangan kilaso",
                "Ijemo eroke",
                "Ijere Onigbedu",
                "Ijewo Oluwo",
                "Ijiwo Ologboni",
                "Ijoko Nla",
                "Ikereku Aworan",
                "Ikereku Onikoko",
                "Ikija",
                "Ikubeku",
                "Ilate",
                "Imedu Obadeye",
                "Imi Lamosun",
                "Iporo Elepo",
                "Iro Town",
                "Isoko",
                "Iyedi Balogun",
                "Jagunna Lasoju",
                "Jagunna Sorunke",
                "Jibode",
                "Jiboso",
                "Kenta Olojo",
                "Kulu",
                "Lajila",
                "Lapado",
                "Lapeji",
                "Lukosi",
                "Luponna",
                "Magada Onigbagbo",
                "Magada Onimale",
                "Magbon Bankole",
                "Mope Olorunsogo",
                "Mowe",
                "Obada",
                "Obanlado",
                "Odofin Bankole",
                "Odofin Oyegunle",
                "Ojo kerere",
                "Ojusango",
                "Oke Oluwo",
                "Olosan",
                "Oluwo Soge",
                "Osoba",
                "Pakuro",
                "Seriki",
                "Soremi",
                "Tudu",
                "Yawota Bankole",
                "Abata",
                "Adunbu",
                "Afo Jagunna",
                "Agba",
                "Agbaege",
                "Agbede",
                "Aiyetoro",
                "Ajegunle",
                "Akaso",
                "Akija",
                "Akinbo",
                "Akogun",
                "Akoja",
                "Apesin Magbafofo",
                "Apidan",
                "Aro Ere",
                "Aro Oba",
                "Arowoje Iede",
                "Asu",
                "Bala Ereginrin",
                "Binu",
                "Biun",
                "Ebiran Lube",
                "Ebiran Sofusi",
                "Edun Ogedegede",
                "Ege",
                "Erukute",
                "Ewedina",
                "Ibare",
                "Idaganna",
                "Idi Orogbo",
                "Idowu Ofonren",
                "Igbein",
                "Ijemo Wasimi",
                "Itan Memta",
                "Iyanbu Rere",
                "Kemta Sonuti",
                "Kemta Wasimi",
                "Kobape",
                "Lemode",
                "Libegun",
                "Lisogbe",
                "Lugbesun",
                "Lumoko",
                "Maga Akilapa",
                "Magbagbodun",
                "Obadeyi",
                "Obaluwaji",
                "Obateye",
                "Ode",
                "Odemo",
                "Odofin",
                "Ogidan Lufusi",
                "Oke Nla",
                "Oko",
                "Oko Sorunke",
                "Olowowagba",
                "Oluwo Akibola",
                "Oluwo Lisemo",
                "Ososu",
                "Ososupayi",
                "Osu Abawongbe",
                "Own Adelanwa",
                "Rere Lijigun",
                "Sobande",
                "Soke",
                "Woru",
                "A bule Panu",
                "A dekanmbi",
                "Abore Ijeja",
                "Adebiopon",
                "Adigbe",
                "Afara",
                "Aganyan",
                "Agbadi",
                "Agbagba",
                "Agbamoya",
                "Agbamoya Oja",
                "Agbana",
                "Agbese",
                "Agbon",
                "Agboru",
                "Agejo",
                "Aina Afidiate",
                "Ajaku Akogu Imo",
                "Aje Kekere",
                "Ajegunle Idowu",
                "Ajegunle Oluwo",
                "Ajiwon",
                "Ake Konigbabe",
                "Akete",
                "Akinsawmki",
                "Akolu",
                "Akolun Akolu Nlado",
                "Alagada",
                "Alakoka",
                "Apagun",
                "Apena Igbein",
                "Apena Ijemo",
                "Apena Obea",
                "Apode",
                "Apola",
                "Aprin",
                "Aro",
                "Aro Ijera",
                "Arosun akibo",
                "Arowa Oke",
                "Arowa Salami",
                "Asa",
                "Asa-Mologede",
                "Ashipa",
                "Asipa Bode",
                "Asipa Ijemo",
                "Asoda",
                "Awaro Olokemeji",
                "Balogu Stoteye",
                "Balogun",
                "Basa Akibule",
                "Base Akibule",
                "Base Ijeja",
                "Bilesami",
                "Bowoje",
                "Dada Lawaye",
                "Daddy Lawani",
                "Debari Ikoja",
                "Deliyi",
                "Demola",
                "Efun Oyeodu",
                "Egbe",
                "Egirugi Oba",
                "Egunda",
                "Ekiti",
                "Erin",
                "Eroke",
                "Erunb Ejilafin",
                "Erunbe Lwani",
                "Esimi",
                "Ewusin Ladewusi",
                "Faleye",
                "Fasola",
                "Gbaguru",
                "Gbega",
                "Gbeyanmi",
                "Gbogbo",
                "Gbongan",
                "Ibon",
                "Idiorogbo",
                "Ifbein",
                "Igbakunle",
                "Igbein II",
                "Igbein Odetunde",
                "Igbein Soyombo",
                "Igbo Lobo",
                "Igbomeku",
                "Igbore Jagunnlawo",
                "Igbore Somlu",
                "Ige Idowu",
                "Ija Nla",
                "Ijemo Akinbola",
                "Ijeun Dipeolu",
                "Ijeun Eya",
                "Ijeun Odofin",
                "Ijeun Solalu Aro",
                "IjeunLirogbo",
                "Ikija Obasa",
                "Ikkana Ajade",
                "Ikkana Bayen",
                "Ikkana oso",
                "Imo Adagun",
                "Imo Emulu",
                "Imo Madekun",
                "Imo Senifiran",
                "Imo Yan",
                "Inadan",
                "Iporo Asalu",
                "Iporo Odunlami",
                "Iposo Bangudu",
                "Iposo fasina",
                "Irenpa Awopeju",
                "Ita Oku Ayanjobi",
                "Itoku Abore",
                "Itoku Jiboso",
                "Itoku Sukunbi",
                "Itori Ariyibiyi",
                "Itori Base",
                "Itori Jejere",
                "Itori Oke",
                "Itori Oke Abore",
                "Jagunna Apaki",
                "Jagunna Dada",
                "Jaki",
                "Jamo",
                "Kemo Olododo",
                "Kerebe",
                "Konko",
                "Koto Akogun",
                "Koto Bisodun",
                "Kulewunlo",
                "Kuluku",
                "Kumapayi",
                "Kusimodi",
                "Ladoke",
                "Lagbaja",
                "Lajulo",
                "Lanki",
                "Lemo Basala",
                "Lemo Ogundairo",
                "Likere",
                "Lipakala",
                "Lisa Kemta",
                "Lisokun",
                "Lukanri",
                "Lukosi Oderinde",
                "Luponna Idrao",
                "Lusokun",
                "Maba",
                "Magbara",
                "Magbon",
                "Makale",
                "Malaka",
                "Malaka Kujore",
                "Malaolu",
                "Marako",
                "Megi",
                "Melekuro",
                "Molegede Odefin",
                "Mope",
                "Mosan",
                "Mosunmore",
                "Nlado Agboke",
                "Oba Ikio",
                "Oba Isoko",
                "Oba Kuwoji",
                "Oba Ladeinde",
                "Oba Luwaji",
                "Oba Musa",
                "Oba Oluwa",
                "Oba Sagobi",
                "Oba-Kumolu",
                "Obadeye",
                "Odaina",
                "Odo Igbein",
                "Odofin Garuba",
                "Odofin Ijemo",
                "Ogboloko Asode",
                "Ogunmokaolu",
                "Oja Oba",
                "Ojere",
                "Oka Odofulu",
                "Oke egan",
                "Oke Nlado",
                "Oke-egan",
                "Okiri",
                "Oko Omilado",
                "Olobe",
                "Oloke",
                "Olorunsogo",
                "Olowolagba",
                "Oluwo",
                "Oluwo Iboko",
                "Oluwo Ije",
                "Oluwo Ijeja",
                "Oluwo Ijemo",
                "Oluwo Iraye",
                "Oluwo Sodeke",
                "Onidundun",
                "Onikoko",
                "Onipepeye",
                "Opalo",
                "Oregbe",
                "Orokuta",
                "Oruntu Dalemo",
                "Osiki",
                "Oso akore",
                "Osu",
                "Ototo Lukoye",
                "Otun Kemta",
                "Otunbadu",
                "Oyemeji Ogbe",
                "Oyero",
                "Pasi",
                "Rogowu Itoku",
                "Safu",
                "Saki",
                "Sidipon oru",
                "Sobo",
                "Sobomde",
                "Sodeke",
                "Sodemi",
                "Soderu",
                "Sodubi",
                "Sofuyi",
                "Sogbanmu",
                "Solake",
                "Somolu Ijeun",
                "Somolu Isoko",
                "Sorungbe",
                "Sosanya",
                "Sotade",
                "Soto",
                "Sotoyi",
                "Toloko",
                "Tonawo",
                "Obafemi Market",
                "Odedina",
                "Odedola",
                "Odo Dipeolu",
                "odo Ijesha",
                "Odo Nla",
                "Odo Sonde",
                "Ogungbade",
                "Ogunkanbi",
                "Ogunkandi Saguntan",
                "Ogunkayode",
                "Ogunmakin Orile",
                "Ogunsan Fadiro",
                "Ogunseye",
                "Ogunwolu",
                "Ojebiyi",
                "Ojoki Sobowale",
                "Oka",
                "Oke",
                "Oke Iporo",
                "Okolomo",
                "Okukenu",
                "Olobi",
                "Olofin",
                "Oloparun",
                "Olorunde",
                "Oloye",
                "Olude",
                "Oluwo Erunbe",
                "Oluwo Esanowo",
                "Onigbori",
                "Onle -oke",
                "Ori",
                "Orisaye",
                "Osin Toko",
                "Osiun",
                "Oso Ogunloko",
                "Osu Liyele",
                "Ota",
                "Owojo",
                "Owolabi",
                "Pagura-gbagura",
                "Pempe",
                "Sagalu",
                "Sango Tolu",
                "Sanmi Sobo",
                "Sapala",
                "Sapala Makinde",
                "Sarumi Diro",
                "Seriki Okusanjo",
                "Sewunju",
                "Shodunke",
                "Siluade",
                "Sobiye",
                "Sodaolu",
                "Sodolu",
                "Sogbake II",
                "Sokanlu",
                "Sorin",
                "Sotan ijemo",
                "Sotomi",
                "Tejuoso",
                "Took Ogunboyejo",
                "Yesolu Gbasemo",
                "Yinagi",
                "Zion Okegbala",
                "Abaren",
                "Abata sobulo",
                "Abatan",
                "Abore",
                "Abule Oba",
                "Abule Oko",
                "Abule Ori",
                "Adaje Larinlo",
                "Adebesin",
                "Adebopon",
                "Adegbokan",
                "Aderugboko",
                "Adesan",
                "Adigboluja",
                "Agbo",
                "Agbogunlere",
                "Agboro",
                "Agewe",
                "Agodo",
                "Agunje",
                "Aiyedi",
                "Ajala",
                "Ajala Sokunbi",
                "Ajana",
                "Ajana Ikereku",
                "Akibo Agbin",
                "Akingbade",
                "Akoko Knoshi",
                "Akoyogun",
                "Akun",
                "Alaba",
                "Alagbade",
                "Alayin",
                "Alayin II",
                "Alebiosu",
                "Aleku",
                "Alli Seriki",
                "Alufa",
                "Amida",
                "Amusan Osogberin",
                "Amusan Soremekun",
                "Apaipai",
                "Apena Ake",
                "Apena Erunbe",
                "Apena Ijeun",
                "Apena Oderinde",
                "Araromi",
                "Are Ago",
                "Arigbowonwo",
                "Asalu Efujo",
                "Asaya agewe",
                "Asaya bala",
                "Asaya Elegada",
                "Asaya Elegun",
                "Asaya Lokoji",
                "Asaya Sodeke",
                "Asegunle",
                "Asese",
                "Asimoloowo",
                "Asore Soyoye",
                "Atapepe",
                "Ategun",
                "Awakana",
                "Awodun Ekun",
                "Awowo",
                "Awowo Bakare",
                "Awowo Depoda",
                "Baala",
                "Bakere",
                "Baki Alamo",
                "Bale Maanolu",
                "Balogun Erunbe",
                "Balole",
                "Bamagbade",
                "Bamgbade",
                "Bamukola",
                "Bamukole",
                "Baromu",
                "Base Iporo",
                "Basuru",
                "Bisodum",
                "Bodo Lisemi",
                "Boodo",
                "Dagunja",
                "Daluwon",
                "Degbaolu",
                "Degesin",
                "Ebinpejo",
                "Ebut Osese",
                "Egun",
                "Erinle",
                "Eruku",
                "Erunbe Asogboni",
                "Erunwon",
                "Erunwon Oridota",
                "Ewetedo",
                "Fadipe Aragbagba",
                "Fadipe Soyoye",
                "Fati",
                "Fatoyinbo",
                "Fidiwo Market",
                "Fodoko",
                "Fowowawo",
                "Gbagura",
                "Gbenle Odu",
                "Gboro",
                "Gbure",
                "Ibasa",
                "Idaba",
                "Igbedu",
                "Igbin",
                "Ige",
                "Igu Landu",
                "Ijemo Aiyejoun",
                "Ijemo Ajagbe",
                "Ijemo Shotan",
                "Ijemo Sobujo",
                "Ijemosotan",
                "Ijere Aglete",
                "Ijere Akiyegun",
                "Ijere worukudu",
                "Ijoko",
                "Ikeredo Oluwo Ijoko",
                "Imedu Bage",
                "Imedu Oke Ipa",
                "Imedu Olori",
                "Ipare Akinsanya",
                "Iriro",
                "Isoleku",
                "Itoko",
                "Itoko Solabomi",
                "Itori Esuruoso",
                "Iyanbu",
                "Jagona",
                "Jaow",
                "Jawun",
                "Jibesin",
                "Jiboku Molere",
                "Jinadu Saguwa",
                "Kannakanna",
                "Kara Aragbada",
                "Kara Ewumi",
                "Kemta Luponna",
                "Kori Eluku",
                "Kori Isa",
                "Kufile",
                "Kurogbe",
                "Kuti",
                "Kuti Iloda",
                "Lagidi Ojo",
                "Lakehinde",
                "Landu",
                "Latunde",
                "Lisa Erunbe",
                "Liso/Alapandi",
                "Loburo",
                "Lojede",
                "Lowa Oke",
                "Mabon",
                "Magada Amusan",
                "Magada Ototi",
                "Magboro",
                "Magboro Akeran",
                "Makogi",
                "Manworo",
                "Mosadomi",
                "Mosafejo Oni",
                "Oba Okio",
                "Ogunrombi",
                "Ogunrore",
                "Ogunrun Eletu",
                "Oju Ora",
                "Okepa",
                "Omu Sorin",
                "Omu folakan",
                "Omu Aleku",
                "Omu Arogun",
                "Omu Jibode",
                "Omu Osoko",
                "Omu Pampe",
                "Ori Soyede",
                "Orimerunmu",
                "Salemo",
                "Sefu elelede",
                "Sefu Ota",
                "Sefusote",
                "Totoro",
                "Ago Ilorin",
                "Agoro",
                "Aiyegunle",
                "Ajanbata",
                "Akeju",
                "Alapako Oni",
                "Alufogejo",
                "Asedo",
                "Atoku",
                "Demolapa",
                "Erin Nla",
                "Ijoko - Ijalemo",
                "Imo Apena",
                "Imolisa",
                "Jaguna",
                "Labosi Otun",
                "Lagngan",
                "Mobolawole",
                "Oba Ajana",
                "Ogunbora",
                "Oluwosoye",
                "Afojupa Igbore",
                "Afojupa Kekere",
                "Afojupa Nla",
                "Ajade Oluye",
                "Ajana Liyebi",
                "Ajana Oke",
                "Akankan",
                "Akisan",
                "Akiyegun",
                "Asagbe",
                "Ate Lempe",
                "Ate Libere",
                "Balogun Sote",
                "Boto",
                "Daddy",
                "Eguru",
                "Eleiyile Adebiyi",
                "Elepo",
                "Eriki Awoke",
                "ErikiOdofin",
                "Igbo Oya",
                "Ijemo Aganna",
                "Ijemo Olusi",
                "Ijemo Soetan",
                "Ijemo Yaro",
                "Ijemota Gogoro",
                "Ijoko Kekere",
                "Isa Itori",
                "Iyanu Itori",
                "Jiboku",
                "Kemta Kilaso",
                "Laloko",
                "Ogun",
                "Ogunbebe",
                "Ogunbona",
                "Oko Oko",
                "Olugbo",
                "Oniwawa",
                "Orogbo",
                "Oruntu",
                "Ososapon",
                "Otanki",
                "Ropo",
                "Soji",
                "Soseri",
                "Tapala",
                "Abata Ogunla",
                "Abule Ijade",
                "Adegunle",
                "Adeiga",
                "Agbaakin",
                "Aiyetoro Oyetola",
                "Ajasu",
                "Akinlegun",
                "Apera Isan",
                "Are Village",
                "Asalu",
                "Asanwole",
                "Asubojo",
                "Balufe",
                "Bara bagbimo",
                "Doga",
                "Edun Onlogbo",
                "Elere",
                "Erifu",
                "Erofo",
                "Erukulesi",
                "Erunbe",
                "Gbarawe",
                "Gbodo",
                "Geledun",
                "Geleodun",
                "Ibokun Olege",
                "Ibokun Oro",
                "Igbore Araferin",
                "Araferin",
                "Ijemo Kukoyi",
                "Ikanna",
                "Ikoyi Ijemo",
                "Imo Isasa",
                "Itori Jekayinfa",
                "Jibowu",
                "Kaloko",
                "Kangibe",
                "Keke",
                "Kenke",
                "Kori Gbarago",
                "Koselu",
                "Lanlemo",
                "Lapala",
                "Lasogba",
                "Leke",
                "Lugboko",
                "Lukosi Igbein",
                "Maja Afolu",
                "Melegun",
                "Mosarejo",
                "Oba Oluwo",
                "Odedeyi",
                "Ofesepe",
                "Ogbe Odujoko",
                "Oguseye",
                "Ogutayo",
                "Olajo Oke",
                "Olojaoke",
                "Olori",
                "Olorombo",
                "Olowotedo",
                "Omu Atere",
                "Omu Ayoyinde",
                "Omu Base",
                "Omu Onikoko",
                "Ori-Igbein",
                "Orisuvmibare",
                "Otere Oba",
                "Otere Apena",
                "Otere Luwoye",
                "Otere Peki",
                "Otete",
                "Sogoye",
                "Someke",
                "Shinwuun",
                "Sode",
                "Wajawaja",
                "Wasimi"
            ],
            "Odeda": [
                "Aigbagba",
                "Alabata",
                "Ilugun",
                "Itesi",
                "Obantoko",
                "Obete",
                "Odeda",
                "Olodo",
                "Opeji",
                "Osiele",
                "Abakuyamo",
                "Akia",
                "Alagbagba",
                "Amini Awo",
                "Araromi",
                "Baba-Pupa",
                "Balogun-Ilawo",
                "Elegunmefa",
                "Ijemo-Fadipe",
                "Ikija",
                "Itesi Lijigun",
                "Itoku",
                "Lersin-Olorode",
                "Ntoji",
                "Odebo",
                "Ogundipe",
                "Ojebiyi",
                "Ola",
                "Owu",
                "Abidogun",
                "Adao",
                "Agurodo",
                "Ajilete",
                "Baka",
                "Balekan",
                "Court",
                "Egbeda",
                "Erinle",
                "Fagbohun",
                "Famii",
                "Imala",
                "Oba",
                "Odunbaku",
                "Omitogun",
                "Oota",
                "Seriki",
                "Tejoun",
                "Adedapo",
                "Adewusi",
                "Ajagbe",
                "Ajobo",
                "Akonko",
                "Alaghaa",
                "Daodu",
                "Efon",
                "Fadipe",
                "Kila",
                "Kugba",
                "Ladipo",
                "Oguntolu",
                "Okiriojule",
                "Olofin",
                "Olokemeji",
                "Olokun",
                "Olowo",
                "Onireke",
                "Oniyanrin",
                "Yisa",
                "Aderupoko",
                "Aganrere",
                "Anifamu",
                "Apena Kemta",
                "Araomi",
                "Awowo",
                "Balogun",
                "Bantun",
                "Edila",
                "Emulu",
                "Ese Oke",
                "Iyanbu",
                "Kebo",
                "Keere",
                "Lalemi",
                "Odelaitan",
                "Ogunda",
                "Olori",
                "Papa-Oja",
                "Segile",
                "Yakoyo",
                "Aaya",
                "Akingbade",
                "Anigilaje",
                "Apena",
                "Aregbesola",
                "Eleweran",
                "Ijebu",
                "Iligun",
                "Ilupapu-Alagbede",
                "Kangudu",
                "Lakiri",
                "Legua",
                "Leso",
                "Morekete",
                "Obaasa",
                "Olubo",
                "Sobeyi",
                "Tirinmi",
                "Adebori",
                "Ajuba",
                "Apojola",
                "Arikola",
                "Ariwo",
                "Asipa",
                "Ayoyo",
                "Bonuola",
                "Idi Emi",
                "Ihokoko",
                "Ijape",
                "Luhani",
                "Odo-Erin",
                "Ogunmola",
                "Okedi",
                "Orile Abaaka",
                "Oyan Dam",
                "Sikiru",
                "Agboke",
                "Akogun",
                "Alayin",
                "Anipupo",
                "Arege",
                "Eweje",
                "Idi-Obi",
                "Ilagbe",
                "Ile-Olu",
                "Itoko Elemide",
                "Lugbose",
                "Makuleri",
                "Oboskoto",
                "Ogboye",
                "Ogeleje",
                "Ogunbayo",
                "Oluga",
                "Olugbo",
                "Rogun Rogun",
                "Sokan",
                "Agbe",
                "Baagbon",
                "Bangboye",
                "Ego",
                "Fagbemi",
                "Ipora Oga",
                "Kereku",
                "Kesinro",
                "Ladojo",
                "Loosi",
                "Obo-ogunsola",
                "Oju-Ogun",
                "Oluwa Kessi",
                "Otere Ogunkola",
                "Adako",
                "Ajaro",
                "Amoje",
                "Fadage",
                "Gbotikale",
                "Ijo Agbe",
                "Ilawo",
                "Isope",
                "Kajola",
                "Lemo",
                "Mawuko",
                "Obe",
                "Olajogun",
                "Onigbogbo",
                "Arimi-Esin Ajayi",
                "Iyalode Tinubu",
                "Ojokodo",
                "Ajan",
                "Alabata Solotan",
                "Apakila",
                "Are",
                "Atepa",
                "Camp",
                "Egunre",
                "Idera",
                "Idi Aka",
                "Iporo Pooopla",
                "Isolu",
                "Itoko Ajegunle",
                "Iwo Ali",
                "Jagun Akinfenwa",
                "Odogba",
                "Ogboja",
                "Owe",
                "Tesi Ajegunle"
            ],
            "Odogbolu": [
                "Alekunifesowapo",
                "Leguru",
                "Adofe",
                "Aiyepe",
                "Araromi",
                "Eyinwa",
                "Ijesa Ijebu",
                "Isaye",
                "Itamerin",
                "Moloko",
                "Odogbolu",
                "Ogoji",
                "Ogudu",
                "Okunowa",
                "Omju Warun",
                "Owoyade",
                "Ababa",
                "Abapawa",
                "Abatiwa",
                "Agoro",
                "Akio",
                "Ala",
                "Ebute Odo",
                "Egb-Imosu",
                "Egbe",
                "Emuren",
                "Erinlu",
                "Eriwe",
                "Ibefun",
                "Ibido",
                "Ibido Omu",
                "Idido Ogbo",
                "Idiru",
                "Idotun",
                "Idowa",
                "Iganke",
                "Igbile",
                "Igbomowo",
                "Ijagun",
                "Ijele",
                "Ijesa-Ijebu",
                "Ikangba",
                "Ikise",
                "Ikoto",
                "Ikoto-Ogbo",
                "Ilado",
                "Ilado Ogbo",
                "Ilawe Ogbo",
                "Imagbon",
                "Imaka",
                "Imaweje",
                "Imodi Ijasi",
                "Imodi Ijebu",
                "Imoro",
                "Imoru",
                "Imosan",
                "Iperin",
                "Irete",
                "Isanyin Ogbo",
                "Ita-Epo",
                "Itanrin",
                "Ite Merin",
                "Jobore",
                "Larowo Ogbo",
                "Latotun",
                "Maraika",
                "Odo Agameji",
                "Odo Alumapebi",
                "Odo Epo",
                "Odo Oba",
                "Odo Sikanwa",
                "Odoja",
                "Odoragba",
                "Odosenlu",
                "Ogbo",
                "Oke Lamuren",
                "Oke Orundun",
                "Omu",
                "Ososa",
                "Shibadewa"
            ],
            "Ogun Waterside": [
                "Abigi",
                "Ijebu Manuwa",
                "Iwopin",
                "Ode Omi",
                "Agbede",
                "Agbure",
                "Agerige",
                "Agilla",
                "Agodo",
                "Aiyede",
                "Aiyesan",
                "Ajegunle",
                "Apata",
                "Araromi Odo",
                "Araromi Oke",
                "Arokola",
                "Ayetunmara",
                "Bolorun Duro",
                "Efire",
                "Gbagi Market",
                "Ibide",
                "Ibu",
                "Igbafo",
                "Ijebu",
                "Ilusin",
                "Isekun",
                "Ita Ogun",
                "Ita Out",
                "Itabaiye Itatufolu",
                "Italugade",
                "Itebu",
                "Kesumeta",
                "Leren",
                "Logbosere",
                "Logede",
                "Lokula",
                "Lomiro",
                "Lukugbe",
                "Makun",
                "Moba",
                "Oka",
                "Okakota",
                "Ologbu",
                "Oruiye",
                "Ranger",
                "Sunbare",
                "Tagbu Nrin",
                "Tayoku",
                "Tibada",
                "Tigara",
                "Tilagbe",
                "Toga",
                "Togunren",
                "Toso",
                "Urhobo",
                "Yemoje",
                "Zion",
                "Araromi Obu",
                "Arijan",
                "Ayede",
                "Ayila",
                "Batedo",
                "Edunola Igodankuda",
                "Gbaragada Ibu",
                "Idobilayo",
                "Igbo Ala",
                "Ijako",
                "Ipakemore",
                "Iteju Elero",
                "Lofoluwa",
                "Momiro",
                "More",
                "Okebi",
                "Ajelanwa",
                "Alo",
                "Demolu",
                "Ebute Oni",
                "Idata Akila",
                "Igele",
                "Imeki",
                "Itomosafeso",
                "Lumuganran",
                "Molofe",
                "Molopope",
                "Ologbun Orita Omo",
                "Olojumeta",
                "Oni Shalu",
                "Oribu",
                "Oriegbe",
                "Oriyanrin",
                "Sumoge",
                "Aba J.K",
                "Aba Olori",
                "Abusoro",
                "Agbala Irokun",
                "Ago Ariye",
                "Ajimo",
                "Akede II",
                "Awodikora Iganla",
                "Awodikora Osa",
                "Awodikora Seafu",
                "Eba Igboedu",
                "Ebute Okun",
                "Ibodu",
                "Igbo Edun",
                "Irokun",
                "Ito Aro",
                "Itomowa-I Tolabase",
                "Liyewu",
                "Makun Omi",
                "Mofere",
                "Moha",
                "Mosefejo",
                "Obimilehin",
                "Okun Akede",
                "Okun Awodikora",
                "Okun Elufon",
                "Okun Igbosere",
                "Okun Ilete",
                "Olokun Olosumeta"
            ],
            "Remo North": [
                "Isala",
                "Aba James",
                "Adegbolu",
                "Adeyoruna",
                "Afofu",
                "Agbala",
                "Aja Gba",
                "Ajade",
                "Ajana",
                "Ajanaku",
                "Ajayi",
                "Ajayi Egba",
                "Ajegunle",
                "Akabiti",
                "Akaka",
                "Akofa",
                "Alafoh",
                "Alamure",
                "Alara",
                "Alebiosu",
                "Alegbo",
                "Aro",
                "Arukuyan",
                "Asanre",
                "Asiru",
                "Asonre",
                "Atoba",
                "Bada",
                "Baiyede",
                "Balogun",
                "Bamigbopa",
                "Banmu",
                "Bata",
                "Dawara",
                "Eboda",
                "Ebugan",
                "Egua",
                "Egundebi",
                "Egunfoye",
                "Ekuku",
                "Eleruja",
                "Eluju",
                "Ewo",
                "Fayemi",
                "Gbasemo",
                "Gbolujo",
                "Gboyegsa",
                "Giwa",
                "Gomina",
                "Idi Osan",
                "Igbore Ajanaku",
                "Ige",
                "Ilara",
                "Imagbo",
                "Imo",
                "Ipara",
                "Iraye",
                "Iresi",
                "Isan _Araromi",
                "Isara",
                "Itakete",
                "Itoku Oloruntedo",
                "Iya Orisa",
                "Jagun",
                "John-Egbedele",
                "Jowoje",
                "Jowoje -Nla",
                "Kajola",
                "Kayero",
                "Koko",
                "Kokoro",
                "Kura",
                "Ladunke",
                "Lagbana",
                "Lapeni",
                "Layungbo",
                "Lere",
                "Lokuta",
                "Lokuta Nla",
                "Loluta",
                "Mope",
                "Oba",
                "Ode Remo",
                "Odo Nla",
                "Odofin",
                "Ogedengbe",
                "Ogunbi",
                "Ogunbodo",
                "Ogunleye",
                "Ogunmuyiwa",
                "Ogunsina",
                "Ogunti",
                "Ojikoredun",
                "Oke - Delokun",
                "Oke Eri",
                "Ologuro",
                "Oloro",
                "Oluwo",
                "Ori Egaun",
                "Ori Eta",
                "Orile Oke",
                "Ososile",
                "Otete",
                "Oyedele",
                "Peteku - Awowo",
                "Peteku Sokabi",
                "Petekun Darawa",
                "Piti",
                "Sapade",
                "Sasawo",
                "Shofidipe",
                "Silalu",
                "Singuru",
                "Sisalu",
                "Sisawo",
                "Sobowale -Oba",
                "Sodipe",
                "Sodipe II",
                "Sofidipe",
                "Sofolabo",
                "Soka",
                "Sokabi",
                "Sokita",
                "Sontere",
                "Sore",
                "Sotayo",
                "Sotobi",
                "Sotunbe",
                "Tesi"
            ],
            "Sagamu": [
                "Ode Lemo",
                "Sagamu (Rural)",
                "Ajeregn",
                "Ewo Oliwo",
                "Ewu -Lemo",
                "Ewu Dihomey",
                "Gbaga",
                "Gunsemade",
                "Lemo",
                "Aberebi",
                "Agabala",
                "Agbagbonyin",
                "Agbere Sowo",
                "Agbonmagbe",
                "Agbowo",
                "Agbowu",
                "Aguntoye",
                "Aiyetoro",
                "Ajebandele",
                "Ajebo",
                "Ajegunle",
                "Ajeregun",
                "Ajiyan",
                "Akarigbo",
                "Alagbe",
                "Alase Araromi",
                "Alupape",
                "Amiteku",
                "Apara",
                "Apele Suberu",
                "Araromi",
                "Arigbabu",
                "Arobo",
                "Aroyi Ajegunle",
                "Asipa",
                "Balugun",
                "Dakole",
                "Dodfin",
                "Ebinpejo",
                "Edina",
                "Elepetu",
                "Emure",
                "Ereku",
                "Erin Igbo",
                "Erinle",
                "Eriyo Ga",
                "Ewa Oluwa",
                "Ewa Solaja",
                "Ewu Ajeinfunja",
                "Ewu Ena",
                "Ewu Ode",
                "Ewu Ogun",
                "Ewu Oloja",
                "Ewu Olopo",
                "Eyin Odan",
                "Eyita",
                "Fajege",
                "Fakale",
                "Gbadamo",
                "Gbara",
                "Gbasepo",
                "Gbomo",
                "Ibelefun",
                "Iboriade",
                "Igbafa",
                "Igbogbo",
                "Igboke",
                "Igbololo",
                "Igbosoro",
                "Igode",
                "Ijagun",
                "Ijemo",
                "Ijoko",
                "Ijokun",
                "Ilara",
                "Ilesun",
                "Imagbon",
                "Imogun",
                "Imoro",
                "Imusin",
                "Imute",
                "Ipa",
                "Iraye",
                "Isaga",
                "Ita Arogun",
                "Ita Sanni",
                "Itailein",
                "Itamerin",
                "Iwelepe",
                "Jabulu",
                "Kanuyi",
                "Kayoju",
                "Kereru",
                "Koe-imaso",
                "Kojola",
                "Kujore",
                "Ladegbuwa",
                "Ladesura",
                "Ladi",
                "Latoro",
                "Lenuwa",
                "Likosi",
                "Lisa",
                "Losi",
                "Loyo",
                "Makun",
                "Mayungbo",
                "Mede",
                "Memigba",
                "Molakori",
                "Molatu",
                "Moro",
                "Mosimi",
                "Negbuwa",
                "Ode Kesiro",
                "Odogboro",
                "Odojobe",
                "Odu Gboro",
                "Oduyamo",
                "Ogijo",
                "Ogundipe",
                "Ogunlogun",
                "Ogunmogbo",
                "Ok Esalu",
                "Oke Agbala",
                "Oke Ariko",
                "Oke Ate Fumuyiwa",
                "Oke-Odo",
                "Okelupa",
                "Okerala Apena"
            ],
            "Okerala Apena": [
                "Okerere Itamerin",
                "Oko Oba",
                "Oko Ojugbo",
                "Okoe Imaso",
                "Okoto Ajegunle",
                "Ologbun",
                "Olojaolokiti",
                "Olowojobi",
                "Onimale",
                "Onisope",
                "Ori Okuta",
                "Orile Ado",
                "Orita Atoyo",
                "Orita odo",
                "Osile",
                "Oso",
                "Osopo",
                "Ososo",
                "Ota",
                "Otuyelu",
                "Out - Bakoga",
                "Oyegbami",
                "Oyeleke",
                "Pofuwa",
                "Radelu",
                "Ranadu",
                "Rasupi",
                "Ritamerin",
                "Rofo Agbele",
                "Simawa",
                "Sogbadun",
                "Somisire",
                "Soso",
                "Sotubo",
                "Sowo"
            ],
            "Yewa/Egbado North": [
                "Ayetoro",
                "Igbogila",
                "Oja - Odan",
                "Tata",
                "Ajo",
                "Abukle Agberiode",
                "Abule Alaga",
                "Abule Adeyemi",
                "Abule Agbede",
                "Abule Agbowogbo",
                "Abule Bolarinwa",
                "Abule Iko",
                "Abule Obe",
                "Abule Oga",
                "Abule Oke odo",
                "Abule olude",
                "Abulke Alagba",
                "Adedira",
                "Adegba",
                "Adekajyb Church",
                "Agboro Isanah",
                "Agboro Saagi",
                "Agbowo",
                "Ahan Village",
                "Ajayi",
                "Ajegunle",
                "Ajibola Idigba",
                "Akimale",
                "Akinfenwa",
                "Akintayo Iliemo",
                "Aladin",
                "Alaga",
                "Allagbaa",
                "Apata Atemola",
                "Ape Sin _Aibo",
                "Asate",
                "Asipa",
                "Atan - Ajanaku",
                "Atan - Atemole",
                "Atokun",
                "Babafa",
                "Babalasa",
                "Bamajo Arewu",
                "Disu",
                "Edun Ejire",
                "Elebutu",
                "Elega",
                "Elemo",
                "Elewuran",
                "Erinpa Apensa",
                "Idi Aparan",
                "Idi Ata",
                "Idi Odan",
                "Idigba Faremi",
                "Idiigba",
                "Igbori",
                "Ijan Okoto",
                "Ijaye",
                "Ikoo Village",
                "Isa Ope",
                "Isa-Ogun Apapa",
                "Isanta",
                "Jagbadarigi",
                "Jagode",
                "Ketu",
                "Kobejo",
                "Kudaju Alagberekan",
                "Obiri",
                "Odanle",
                "Odunfa",
                "Ogunseye",
                "Ojo",
                "Oke Akanni",
                "Oke Akanno",
                "Okundun",
                "Olobi",
                "Ologbogbo",
                "Oloke - Ile",
                "Olowonyo",
                "Omiragoro",
                "Onibeji",
                "Opete",
                "Owuwu",
                "Popoola",
                "Saaka Orile",
                "Sakere",
                "Soleye",
                "Sunwa",
                "Tunnda",
                "Yewa",
                "Yewa Drisu",
                "Abule Ajama",
                "Abule Balogun",
                "Abule Egba",
                "Abule Ijesha",
                "Abule Imasai",
                "Abule Oke",
                "Aga Odofin",
                "Aje Rogun",
                "Ajibawo",
                "Alaganju",
                "Aramrori",
                "Araromi Abiodun",
                "Araromi Ilewo",
                "Bad Elefu",
                "Balogun",
                "Egba Ilewo",
                "Egba Isaga Orita",
                "Eleeyo",
                "Farm Settlement",
                "Ibese",
                "Iboro",
                "Igbgila farm",
                "Igboeleke",
                "Iiewe",
                "Ijake Orile",
                "Ijako Awaye",
                "Ijiko",
                "Isaga Abiodun",
                "Isaga Oke",
                "Isaga Orita",
                "Jogga Orile",
                "Komi Oba",
                "Kudifi",
                "Oke Odo",
                "Omilende",
                "Orente",
                "Orita",
                "Owode",
                "Owoyele",
                "Sawonjo",
                "Settlement Wasimi",
                "Swonjo",
                "Wasinmi Imasayi",
                "Abe Isin",
                "Abon Orile",
                "Abuke Idi",
                "Abule Aga",
                "Abule Isu",
                "Abule Lesse",
                "Abule Mulere",
                "Abule Okele",
                "Abule Zachraus",
                "Adeisin",
                "Afo - Nkaa",
                "Agbele",
                "Agbo Ogede",
                "Agbon Ojodu",
                "Agbontedo",
                "Ageru",
                "Ajelende",
                "Ajengula ibayin",
                "Akeru Abeobi",
                "Aleru Ajiboye",
                "Apate",
                "Asa",
                "Awe",
                "Baba Kekere",
                "Bambola",
                "Ebute -Igboro",
                "Egbeda",
                "Gbogoru",
                "Gbokoto",
                "Gotoko Isale",
                "Hauga",
                "Ibayin",
                "Ibeku",
                "Igbeme Alabe",
                "Igbeme olude",
                "Igbo Ogebe",
                "Igbo Orile",
                "Igbon",
                "Igbooro Oke",
                "Igho Timber Camp",
                "Ihumbe",
                "Ijege",
                "Ijoko Ase",
                "Ijoko Isale",
                "Ijoko Oke",
                "Ijoko Orile",
                "Ile Alabe",
                "Ile Igboro",
                "Ileme",
                "Ilepa",
                "Iselu Orile",
                "Isuku",
                "Isun",
                "Ita Kasia",
                "Iyalode",
                "Iyana Meta",
                "Kobejo Abikanlu",
                "Kobejo Aladura",
                "Kodere",
                "Korole",
                "Kusade",
                "Lanloku",
                "Mere",
                "Moro",
                "Mosan",
                "Obele",
                "Ogbe",
                "Ojugbele",
                "Ojumo",
                "Oke-Odo",
                "Okoso",
                "Ologiri",
                "Oloparun",
                "Olosun",
                "Opata",
                "Orebiyi",
                "Owode Balogun",
                "Papa Olosun",
                "Pedepo",
                "Refurefu",
                "Seke",
                "Yewa Mota",
                "Abule ketu",
                "Adekan",
                "Agbogbo",
                "Akapo",
                "Aruku",
                "Asaga",
                "Atan Efon",
                "Aworo Pedepo",
                "Ayerinde",
                "Dangi-dangi",
                "Eeja Orile",
                "Egba",
                "Eggua",
                "Falade",
                "Ibisi Idigbo",
                "Ibiyan",
                "Ibore Oke Ode",
                "Idan Iga",
                "Idi-Ori",
                "Idigbo",
                "Igan-Alade",
                "Igbimu",
                "Igbo-Aje",
                "Igbo-Iju",
                "Igbo-Nla",
                "Igbokofi",
                "Igboofa",
                "Ijaka Isale",
                "Ijaka Oke",
                "Ijale-Ketu",
                "Ijeun",
                "Ika Orile",
                "Imaa",
                "Imoto Orile",
                "Imoto Yewa",
                "Isa Ogun",
                "Iseiyoun",
                "Iwale",
                "Iyana-Agbere",
                "Lasilo",
                "Llodo",
                "Modeyo",
                "Mokoya",
                "Ogunba Aiyetoro",
                "Oke",
                "Oke-Eyo",
                "Okeola",
                "Onilogbo",
                "Orile Ijonu",
                "Orisade",
                "Owode-Ketu",
                "Sagbon",
                "Sagisa",
                "Sowere",
                "Tobolo"
            ],
            "Yewa/Egbado South": [
                "Ifeko Wajo",
                "Ilaro (Rural)",
                "Abu",
                "Abule Abu",
                "Abule Ademola",
                "Abule Ajayi Odi",
                "Abule Akegbo",
                "Abule Debo",
                "Abule Fadayiro",
                "Abule Kesehin",
                "Abule Monija",
                "Abule Oke",
                "Abule Oladele",
                "Abule Paki",
                "Abule Teacher",
                "Ago Iilobi",
                "Agosu",
                "Agude",
                "Ajayi Oti",
                "Ajegunle",
                "Ajilete",
                "Ajimagbodo",
                "Ajise",
                "Ajolojo",
                "Alabba",
                "Alagbade",
                "Alagbede Eredo",
                "Alaparun",
                "Alaparun Oke Odo",
                "Alaraba",
                "Apala",
                "Apara",
                "Araromi",
                "Asipa",
                "Awukoketu",
                "Ayomaya",
                "Cement",
                "Egunjobi",
                "Elegbede",
                "Eredo",
                "Erimi",
                "Erinja",
                "Eykarise",
                "Fadairo",
                "Farawole",
                "Fatedo",
                "Gereta",
                "Ibio",
                "Ibure Ogun",
                "Idiku",
                "Idohude",
                "Idologun",
                "Igboho - Tedo",
                "Igborodo",
                "Ihunbo",
                "Iilesha",
                "Ijako",
                "Ikorodu Wasimi",
                "Isagbo - oke",
                "Isagbo ere",
                "Ita igbe",
                "Jobi",
                "Kajola",
                "Kampu",
                "Makusota",
                "Odan ijoko",
                "Odunewu",
                "Offa",
                "Oja erin",
                "Oja-ota",
                "Oju epo",
                "Ojumo adodo",
                "Oke erinja",
                "Oke Odan",
                "Okerinja",
                "Oko Baba",
                "Oko-Eiye",
                "Okobaba",
                "Olowologba",
                "Onigbedu",
                "Onijam",
                "Onirike",
                "Orisada",
                "Owede",
                "Owo",
                "Owode-Egbado",
                "Petedo",
                "Saabe",
                "Sabo",
                "Yakata",
                "Abule Iyalode",
                "Abule Sondiro I",
                "Abule Olopa",
                "Abule Olope",
                "Abule Olusoji",
                "Abule Sondiro II",
                "Adewale",
                "Agbada",
                "Agbomola",
                "Ajibabi",
                "Akamu",
                "Akinde",
                "Akinlade",
                "Akiti",
                "Aladie",
                "Alagbado",
                "Alagbe",
                "Alarabe",
                "Alugangan",
                "Apakoso",
                "Araromi Ifelodun",
                "Araromi Yesufu",
                "Arogun Ategbe",
                "Asafo village",
                "Atoyo",
                "Atoyo I",
                "Atoyo II",
                "Booda",
                "Damolapa",
                "Egbo Oloparun",
                "Elemere",
                "Eleyale Dada",
                "Eleyele",
                "Erinmi",
                "Erinmi Oguntade",
                "Etute Adewale",
                "Fagbohun",
                "Feyisitan",
                "Gbogo",
                "Gbokoto",
                "Gbokoto ijanna",
                "Idi Isin",
                "Idi Mangoro",
                "Idi Obi",
                "Idi Osan",
                "Idi Osun",
                "Idogo",
                "Idola",
                "Idolude",
                "Ieoye",
                "Iganmu Isale",
                "Iganmu Olosa",
                "Igbeji",
                "Igbeme",
                "Igbintedo",
                "Ijado",
                "Ijanna",
                "Ijegun",
                "Ijoke",
                "Ilobi Onuwa",
                "Imeke",
                "Imoro",
                "Ipaja Town",
                "Ipake",
                "Irogun Olatunji",
                "Irogun Adebo",
                "Irogun Akere",
                "Irogun Olurunde",
                "Isaga - Olutunji",
                "Ita Baba Monday",
                "Itolu",
                "Itoro Town",
                "Iweke",
                "Iwogia",
                "Jaja",
                "Jeburu",
                "Kajola Palaki",
                "Kakanfo",
                "Koto - Obo",
                "Kudoro",
                "Kudu",
                "Odan Apadi",
                "Oguntedo",
                "Ojete",
                "Ojetedo",
                "Oke Iganmu",
                "Oke-Ayo",
                "Ologorin",
                "Olokuta",
                "Oloparun Fadare",
                "Olorunlekan",
                "Olorunsogo",
                "Olose",
                "Oluiye",
                "Oluta",
                "Olute",
                "Omilende",
                "Omolere",
                "Onitubu",
                "Oniyaha",
                "Orile Itoro",
                "Sarunmi",
                "Sobola",
                "Yewe matta"
            ]
        }
    },
    {
        "Ondo": {
            "Akoko North-East": [
                "Akunnu/Isowopo",
                "Akunnu",
                "Auga",
                "Iboropa",
                "Ikakumo",
                "Ise",
                "Ikare (Rural)",
                "Ikare",
                "Ugbe"
            ],
            "Akoko North-West": [
                "Ajowa",
                "Eriti",
                "Gedegede",
                "Igasi",
                "Oge",
                "Oyin",
                "Arigidi (Rural)",
                "Arigidi",
                "Iye",
                "Irun/Surulere",
                "Ese",
                "Igbooji",
                "Irun",
                "Italeto",
                "Kajola Camp",
                "Ogbagi",
                "Ojeka",
                "Surulere",
                "Oke Agbe",
                "Afa",
                "Afin",
                "Aje",
                "Ase",
                "Erusu",
                "Ibaram",
                "Ido",
                "Ikaram",
                "Iyani",
                "Oke-Agbe",
                "Oye"
            ],
            "Akoko South-East": [
                "Epinmi-Akoko",
                "Ifira-Akoko",
                "Ayegunle",
                "Ikun-Akoko",
                "Ipe Akoko",
                "Ipe-Akoko",
                "Isua-Akoko",
                "Sosan-Akoko"
            ],
            "Akoko South-West": [
                "Akungba-Akoko",
                "Akunagba-Akoko",
                "Etioro",
                "Oba-Akoko",
                "Ago Ajayi",
                "Ago Ojo",
                "Ago Oka",
                "Ose-Oba",
                "Oka-Akoko",
                "Alegunle",
                "Iwaro",
                "Supare-Akoko",
                "Abulenla",
                "Ago Flower",
                "Ago-Orikuta",
                "Igboegun",
                "Igbonla"
            ],
            "Akure North": [
                "Aiyede-Ogbese",
                "Ago Oyinbo",
                "Alayere",
                "Ayunla",
                "Ilu Abo",
                "Kajola",
                "Iju/Ita Ogbolu (Rural)",
                "Abusoro",
                "Agamo",
                "Ago Egbira",
                "Amosi",
                "Aresun",
                "Igbogede",
                "Iju",
                "Ilado",
                "Ipole Irado",
                "Odudu",
                "Oba-Ile",
                "Araromi",
                "Bolorunduro",
                "Eleyewo",
                "Owode"
            ],
            "Akure South": [
                "Igba-Toro",
                "Alasoadura",
                "Aponmu",
                "Awule",
                "Eleyowo",
                "Igbatoro Femilugba",
                "Igoba",
                "Isinigbo",
                "Ita-Oniyan",
                "Iwoye",
                "Osi",
                "Oda",
                "Adejubu",
                "Ajagbusi",
                "Emilolo",
                "Ilekun",
                "Isagba",
                "Olokuta",
                "Onipanu"
            ],
            "Ese-Odo": [
                "Arogbo II",
                "Abedingo",
                "Abere",
                "Adanu-Gbini",
                "Adoloseimo I",
                "Adoloseimo II",
                "Adoloseimo III",
                "Adoloseimo IV",
                "Adoloseimo V",
                "Agadagba Obon",
                "Agbedigbalan",
                "Ainromozion",
                "Ajapa Community",
                "Akonkotughu",
                "Akpata",
                "Amalaita Zion",
                "Amatibo Zion",
                "Asenebuboghoana Zion",
                "Ashingbene",
                "Asigborodo",
                "Bobougbini Okegbini",
                "Bolowoghu Community",
                "Dababulebu",
                "Dababulebu Zion",
                "Damugbene",
                "Dedobogha-Zion",
                "Dibigbini",
                "Ebibotei Zion",
                "Ebiwegboni",
                "Egbeghebini",
                "Fiyebrasinitei",
                "Gbarangbini",
                "Gbiniweigbin",
                "Igaligangbo",
                "Iganbo",
                "Ijoujou Kubu",
                "Ipiteikiri",
                "Itaita Igbin",
                "Itebuagbini",
                "Itekungbin",
                "Jabegbini",
                "Janegbini",
                "Jeribeni",
                "Karagbini",
                "Karigbin",
                "Keribeni",
                "Kokotoru",
                "Latalie",
                "Lupougbo",
                "Mobiremigbini",
                "New Ajapa",
                "Oboroghini Amelica",
                "Ogbnogologbini",
                "Ogidigba I",
                "Ogidigba II",
                "Ogokiri Zion",
                "Okaminiwei",
                "Okegbini",
                "Okorobobigbini",
                "Opuba Community",
                "Opugbini",
                "Osaki",
                "Otuwokubu",
                "Pankuno",
                "Pelebosou",
                "Pinaama Zion",
                "Pubalebu",
                "Pububogho Zion",
                "Pubulebu",
                "S.K. Zionimi",
                "Tamalaubotei Zion",
                "Temesokogbini",
                "Tolu-Kiribo",
                "Tuwegbini",
                "Ugbobeimo",
                "Upe Community",
                "Urousoama",
                "Uyakumogbini",
                "Wotimigbinin",
                "Zion",
                "Amapere",
                "Arogbo IV",
                "Adumu-Uba",
                "Agbedigbaran",
                "Aserejugbini",
                "Biagbini",
                "Gboinbo",
                "Itaita",
                "Kurukurugbini",
                "Lalatie",
                "Ogidigba",
                "Okorobobi",
                "Pankumo",
                "Babomi",
                "Ajagba Village",
                "Ajalere",
                "Akpoweri",
                "Anthony",
                "Araromi",
                "Augustine Camp",
                "Benjamin",
                "Calabar Camp",
                "Christopher",
                "David's Camp",
                "Ehin Ofe",
                "Emomo",
                "Eyo",
                "Ezekiel Camp",
                "French Village",
                "Friday Camp",
                "Giwa",
                "Hitler Camp",
                "House of God's Camp",
                "Idiatala",
                "Idogho",
                "Igberaja Camp",
                "Igirikile",
                "Igwe Camp",
                "Johnson",
                "Joseph Camp",
                "Karimu Camp",
                "Katangar camp",
                "Korefe",
                "Matulu",
                "Memigbere",
                "Memorigha",
                "Mukoro Osanyin",
                "Obadiah Camp",
                "Obakaako",
                "Obasemo (Oberemo)",
                "Ofineme",
                "Oginiji",
                "Okorogbhene",
                "Omi Pupuru",
                "Omisesi",
                "Pateko",
                "Rujere",
                "Sabomi",
                "Yerighebe",
                "Igbekebo",
                "Abadi Pekagha",
                "Abariko",
                "Aghaje (Aghejo/Akaba)",
                "Aghansue",
                "Ago Eyin",
                "Ago Lagos",
                "Ago Moses Isiaka",
                "Ago Oghebor",
                "Ago Thompson",
                "Akorin",
                "Aluju Ibila Camp",
                "Arulewo",
                "Bannard Umokoro Camp",
                "Butoru",
                "Dele Richard Camp",
                "Emewu Camp",
                "Falomo/Labour Camp/Bejowa",
                "Gbafenfen",
                "Igangbo",
                "James Umiaghe Camp",
                "James Umokoro Camp",
                "Kateri (Katuru)",
                "Kelekele",
                "Kosoko",
                "Lupogbo",
                "Mete Joseph Camp",
                "Metiala",
                "Micheal Edo Camp",
                "Mogboju",
                "Mrs Iji Camp",
                "Niwari",
                "Noble Camp",
                "Oba Egbukuyomi Camp",
                "Obateru Camp",
                "Ojarigho Camp",
                "Okoloko",
                "Okoto Lekki",
                "Olisa (Oliseh)",
                "Olorugun",
                "Orita Joseph",
                "Oruda",
                "Osari",
                "Pa Emi's Camp",
                "Tamuke",
                "Teji Sheile Camp",
                "Uba",
                "Ugbo Yagha",
                "Ugbonla Zion Igbekebo",
                "White Sand Zion Igbekebo",
                "Inikorogha",
                "Dina Camp",
                "Dododo",
                "Doro",
                "Ebiniza",
                "Epin Camp",
                "Fia",
                "Gbenebo",
                "Igbekeji",
                "Igbini Omi (Igbene Omi) Camp",
                "Kurughene",
                "Maseye",
                "Okoro Camp",
                "Okuleluju",
                "Olorunleke",
                "Omiyetuse",
                "Orita Thompson",
                "Osobu",
                "Suopopagha",
                "Thompson Camp",
                "Torukoba Camp",
                "Yanyanghan",
                "Kiribo",
                "Ago Alaguntan",
                "Ago Gee",
                "Ago Gee Akubo",
                "Ago Ogunmahin",
                "Ago Rowolo",
                "Ago Williams",
                "Akaraba",
                "Akporido",
                "Aphiande",
                "Apogidi",
                "Aye Abasa",
                "Bintolu",
                "Ekpu Camp",
                "Ekundayo I",
                "Ekundayo II",
                "Gbeleju Ode",
                "Gbeleju Oke",
                "Gege",
                "George",
                "Gurame",
                "Ibugbe Alafian",
                "Ikusedun",
                "Ishiekuene",
                "Ita Ibale",
                "Iwanefun",
                "Jegun Camp",
                "John Jele",
                "Kalariju",
                "Kasipere",
                "Kemere",
                "Leven",
                "Lupogbo Kiribo",
                "Mabene",
                "Maclean",
                "Mawanami",
                "Mene Bambe",
                "Moju",
                "Monebi",
                "Oburuku",
                "Ogundowo",
                "Ogunye I",
                "Ogunyo II",
                "Oharisi",
                "Ojigbegbini",
                "Okerojaye",
                "Okoko",
                "Olaposi",
                "Oluku",
                "Omefon",
                "Omenigho II",
                "Omonigho II",
                "Omonira",
                "Opotuo",
                "Oronla",
                "Orunde",
                "Polugbene Ogun",
                "Sea Camp",
                "Senghemi",
                "Tebuju",
                "Yasere",
                "Ojuala",
                "Adebayo Camp",
                "Ago Kusedun",
                "Ago Weghan",
                "Anifowose",
                "Calabar Camp I-V",
                "Igo Ilaje",
                "Ita Oluwa Camp",
                "Ita Opoto",
                "Jinrongho",
                "Lapomu Camp",
                "Nanahan (Nanaghan)",
                "Ojuala Mill",
                "Okitigerege I & II",
                "Olomitutu I & II",
                "Omiorisa",
                "Ugbogi Camp",
                "Ukparama Ward II /Arogbo III",
                "Agalabotiye",
                "Agalakiri Community",
                "Ajapa-Bilebu",
                "Alagba",
                "Amadumo-Opuba",
                "Arukarabou",
                "Beleu-Amah",
                "Bojito Zion",
                "Dabiyotuboghu",
                "Diadara",
                "Difidinogho",
                "Ebibotei Zion-Opuba",
                "Eere Community",
                "Ekpetonron",
                "Ibakelele Zion",
                "Ishmeal Zion",
                "Majebi Camp",
                "Ojudou-Ama Zion",
                "Oke Oba-Igbo",
                "Okosi-Igbo",
                "Opu-Akpatakubu",
                "Opu-Olubo",
                "Opuba-Igbobemo",
                "Opuba-Kalatubu",
                "Opuba-Ofoghuba",
                "Ori-Oke Zion",
                "Otumara",
                "Sea-water",
                "Songhoron Community",
                "Tabamotimi Camp",
                "Tububiri",
                "Ugobubogho Zion",
                "Ukparama I I/ Arogbo I",
                "Ajakirigbene",
                "Akina Zion",
                "Asere",
                "Baikiri",
                "Bibokepiri",
                "Demiyen-Gbene",
                "Dinokumo",
                "Epemubou",
                "Gbagi-Gbini",
                "Iyorubugbini",
                "Jongha-Gbini",
                "Katewei-Gbini",
                "Kurukuru-Gbini",
                "Morogbini",
                "Odugba-Gbini",
                "Ogono-Ama Zion",
                "Okirigbo",
                "Opubobuibogho",
                "Opukutugbune",
                "Seisuwogha",
                "Seitipa-Gbini",
                "Sisegbin",
                "Torugbini",
                "Ukpetubu",
                "Yala-Bou"
            ],
            "Idanre": [
                "Alade",
                "Aboekan",
                "Akindana",
                "Aponmu-Lona",
                "Aseigbo",
                "Geberiwojo",
                "Ikako",
                "Imolumo/Iloro",
                "Ipinlerere",
                "Ipoba 1 & II",
                "Ipoba-Jomu",
                "Itaidorun",
                "Lafere",
                "Lokuta",
                "Meromi",
                "Oike-Anifor",
                "Owena-Ayetoro",
                "Sama",
                "Tejugbola",
                "Odoe Idanre",
                "Abababubu",
                "Abalaka",
                "Ago-Joshua",
                "Ajagbusi",
                "Ajebamidele",
                "Ajegunle-Orunbato",
                "Ajipowo Cims &",
                "Akinmoji",
                "Ala-Elefosan",
                "Ala-Goke",
                "Ala-Omiliyan",
                "Aladura",
                "Anukansugba",
                "Apefon",
                "Arapa",
                "Aribigbola",
                "Arisin I & II",
                "Arun",
                "Atosin",
                "Ayede",
                "Ayefemi",
                "Baale Ojumu",
                "Bajare",
                "Daralode",
                "Eripose",
                "Fayomi",
                "Gbalegi",
                "Ido Oshinle",
                "Igbolowowa",
                "Ijama",
                "Iramuji/Agbaje",
                "Ironwon Igbatayo",
                "Irowo-Sasere",
                "Isan Jigbokin",
                "Isurin",
                "Itanarowa/Asoko",
                "Itogun-Adaja",
                "Iwonja",
                "Jingbe",
                "Labuwa",
                "Lisagba",
                "Loagbo",
                "Malan",
                "Meth. High School",
                "Obatedo/Bamotula",
                "Odeja",
                "Odeja Orts II",
                "Odele",
                "Odo-Ewu",
                "Odo-Orisa",
                "Ojadale",
                "Oke-Ala",
                "Okedo -Manare",
                "Omilade-Januyi",
                "Omilifon 1 & 2",
                "Opa/Omiolosun",
                "Owo",
                "Owomofewa",
                "Teniola",
                "Ubi 1 & II",
                "Ugbepo",
                "Owena",
                "Apomu",
                "Elebiseghe",
                "Erijo",
                "Esale",
                "Farm Settlement Poun",
                "Jonibola",
                "Ofosu",
                "Oke-Idanre",
                "Omifunfun",
                "Onisere"
            ],
            "Ifedore": [
                "Igbara-oke",
                "Amaye",
                "Asae",
                "Ilero",
                "Imokuti",
                "Odo-Oja",
                "Ijare",
                "Ayetoro",
                "Odo-Esi",
                "Ogbontitun",
                "Otalo-Gboido",
                "Post Office Are",
                "Ugoba",
                "Uye",
                "Ilara",
                "Igbehin",
                "Iro",
                "Lare",
                "Odofin",
                "Ipogun",
                "Aaye",
                "Eti Oreseun",
                "Ibule",
                "Ikota",
                "Ipon",
                "Irese",
                "Obo",
                "Ologorere"
            ],
            "Ilaje": [
                "Aheri Kingdom",
                "Agbala Obi",
                "Agbala Olope Meji",
                "Agerige Zion",
                "Aheri Camp",
                "Ajebamidele",
                "Akata",
                "Ako Ira-Oba",
                "Alape Junction",
                "Araromi Sea-side",
                "Enu-Ama",
                "Idegbele",
                "Idigbengbin",
                "Igogun",
                "Ihapen",
                "Ilefunfun",
                "Ipare",
                "Ipepe",
                "Mofehintokun",
                "Okesiri",
                "Olopo",
                "Temidire",
                "Ubalogun",
                "Zion pepe",
                "Etikan King-dom",
                "Agba Gana",
                "Ago Apeja",
                "Ago Buli",
                "Ago Egun",
                "Ago Festus",
                "Ago Gbobaniyi",
                "Ago Ijebu",
                "Ago Ikumapayi",
                "Ago Iwabi",
                "Ago Lubi",
                "Ago Oluji",
                "Aiyetitun",
                "Araromi Etikan",
                "Igbobi",
                "Ikaji Etikan",
                "Moborode",
                "Obalende Etikan",
                "Ode Etikan",
                "Oja Igo Etikan",
                "Oja oje",
                "Oja Osho",
                "Oja Temidire",
                "Oke Harama",
                "Okonla",
                "Okun Eikan",
                "Ramasilo Etikan",
                "Uba Agba",
                "Uba Akobi",
                "Uba Domi",
                "Uba Etikan",
                "Uba Kalebari",
                "Uba Oke Kelian",
                "Uba Ropeda",
                "Uba Yellow",
                "Igbotu",
                "Aboromeji",
                "Aboto Camp",
                "Ago",
                "Ago-Ogele",
                "Ago-Yellow",
                "Amayetigba",
                "Araromi",
                "Arigbe Camp",
                "Baale Camp",
                "Bisewe Golote",
                "Ebidlo",
                "Ekohebo Camp",
                "Enikorogha",
                "Epewe",
                "Eredase Camp",
                "Esenoko Camp",
                "Gbabijo",
                "Gunmagun Camp",
                "Hamidifa",
                "Idigba Camp",
                "Igbebomi Iyara",
                "Igbobini",
                "Igbolani-Arubenghan",
                "Igbotu-Atijo",
                "Igbotu-Gbaluwe",
                "Igbotu-Zion",
                "Igirikile",
                "Imobi",
                "Itebetabe Camp",
                "Iyara",
                "Kafawe",
                "Kitikoro",
                "Kolodi Camp",
                "Kurugbene",
                "Lagereke",
                "Laporen Camp",
                "Lobele Camp",
                "Logede",
                "Lumoko Camp",
                "Moboro Village",
                "Odibo",
                "Ogbeni Camp",
                "Ogunmade",
                "Okoro",
                "Okorogbene",
                "Okuru Camp",
                "Olorunsola Camp",
                "Olowo Camp",
                "Oluagbo",
                "Omukoro Camp",
                "Onipanu Ago Bagi",
                "Onisosi",
                "Otarogbene Camp",
                "Pee Camp",
                "Pghono Camp",
                "Piria",
                "Sabomi Babomi",
                "Sogbo Camp",
                "Surulere",
                "Yogha",
                "Zion",
                "Mahin Kingdom",
                "Abealala",
                "Abereke",
                "Aboto",
                "Ago Doroh",
                "Ago Ikuebolati",
                "Ago Lulu",
                "Ago Olomidegun",
                "Alagbede",
                "Aruwayo",
                "Asisa",
                "Atijere",
                "Betiegbofo",
                "Broke Camp",
                "Ebute Ipare",
                "Ehin - Osa",
                "Elegboro",
                "Ereke",
                "Ereke Majofodun",
                "Ereke Makuleyi",
                "Etigho",
                "Ibila",
                "Idigho",
                "Igbegunrin",
                "Igbo - Okuta",
                "Igbokoda",
                "Igbolomi",
                "Ikale Camp",
                "Iloro",
                "Ilu Sosi",
                "Imoluwa",
                "Ita - Age",
                "Italita Camp",
                "Itebukunmi",
                "Job Camp",
                "Korolo",
                "Kugbonre",
                "Legha",
                "Lerenren",
                "Logede Camp",
                "Madagbayi",
                "Magbehinwa",
                "Mogbojuri",
                "Mahin",
                "Mahintedo",
                "Maran",
                "Moferere",
                "Mogunyanje",
                "Motiala",
                "Motoro",
                "Odun Oloja",
                "Odun Oluma",
                "Odun Oroyo",
                "Odunmogun",
                "Ogorogo",
                "Ohaketa Camp",
                "Ojan",
                "Oke Etigho",
                "Okishilo",
                "Okoga",
                "Okunniyi",
                "Olosunmeta",
                "Opolo",
                "Orere - Ara",
                "Oribero",
                "Orimoloye",
                "Orioke Iwamimo",
                "Oriranyin",
                "Orofin Camp",
                "Oropo Zion",
                "Oroyomi",
                "Pete-Inu",
                "Piawo",
                "Ramasilo",
                "Seja Odo",
                "Seja Oke",
                "Seluwa",
                "Tedo Camp",
                "Tomoloju",
                "Tomoloju Camp",
                "Ugbaha",
                "Zion Gbabijo",
                "Zion Igbokoda",
                "Zion Mahintedo",
                "Zion Ogogoro",
                "Ugbo Kingdom",
                "Abetobo zion",
                "Abokiti",
                "Ago Alufa",
                "Ago nati",
                "Ajegunle",
                "Alagbom zion",
                "Alagbon",
                "Amehin",
                "Apata ilaje",
                "Asumaga",
                "Awoye",
                "Ayetoro",
                "Bijimi",
                "Bowoto",
                "Eke atiye",
                "Eke baale",
                "Eke didi",
                "Eke ilutitun",
                "Eke itiola",
                "Eke moki",
                "Eke nla",
                "Eke ofolajetan",
                "Eke yonren",
                "Ernna ogbeni",
                "Erunna",
                "Erunna lagbe",
                "Gbagara",
                "Idogun",
                "Idogun ayadi",
                "Idogun ehinmore",
                "Ikorigho",
                "Ilepete",
                "Ilowo",
                "Ilowo ayetoro",
                "Ilowo Nla",
                "Ilowo ogunsemore",
                "Iluabo",
                "Jirinwo",
                "Lepe",
                "Molutehin",
                "Obe Adun",
                "Obe akingboye",
                "Obe apata",
                "Obe Arenewo",
                "Obe Dapo",
                "Obe Enikanselu",
                "Obe ifenla",
                "Obe Iji",
                "Obe Jedo",
                "Obe Magbe",
                "Obe Nla",
                "Obe Ogbaro",
                "Obe Olomore",
                "Obe Orisabinone",
                "Obe Rebimino",
                "Obe Rewoye",
                "Obe Sedara",
                "Odofado",
                "Odonla",
                "Odonla meduoye",
                "Odun Ogungbeje",
                "Odun ojabireni",
                "Odun oriretan",
                "Odun Oyinbo",
                "Odun Yonren",
                "Ogbongboro",
                "Ogboti",
                "Oghoye",
                "Ojumole",
                "Okun ipin",
                "Olotu",
                "Olotu kuwo",
                "Olotu wiye",
                "Olotu yara",
                "Orioke Harama",
                "Oroto",
                "Otumara",
                "Otumare se- side",
                "Owoleba",
                "Saheyi",
                "Uba Korigho",
                "Ubale",
                "Ubale kekere",
                "Ubale nla",
                "Ugbage",
                "Ugbo",
                "Ugbonla",
                "Womi Tearen",
                "Yaye",
                "Zion Ikerigho",
                "Zion Iluabo"
            ],
            "Ile-Oluji/Okeigbo": [
                "Adebaso",
                "Adekunle",
                "Adeoba",
                "Agunla",
                "Aiyegun",
                "Akinbobola",
                "Akingbami I & II",
                "Akingbe",
                "Akinmadewa",
                "Akinmisiola",
                "Akinsulure",
                "Akinye-Oja",
                "Akinyemiju",
                "Asokin",
                "Ayetoro",
                "Ayo",
                "Bakare",
                "Ipoti",
                "Itamesi",
                "Lasobewu",
                "Lebiba",
                "Lipepeye",
                "Odo",
                "Ogunja",
                "Ojowo",
                "Okobolunsen",
                "Oladapo",
                "Oloronbo",
                "Omigbede",
                "Owodezama",
                "Bamkemo",
                "Aba-Gureje",
                "Aba-John",
                "Awo",
                "Ayadade",
                "Badeji",
                "Bafon",
                "Bajewolu",
                "Bamikemo",
                "Bamikemo-Oja",
                "Dagbaja",
                "Gate",
                "Iyire",
                "Iyire Adeboyeku",
                "Iyire-Akinmatimi",
                "Jegun",
                "Labowi I & II",
                "Lipanu",
                "Lisamikan",
                "Ologundudu",
                "Ulosen",
                "Ileoluji",
                "Adenipekun",
                "Adenyan",
                "Agbabakawodi Club 71",
                "Ajifarere",
                "Akintimehin",
                "Akinyosotu",
                "Alhaji Odo",
                "Asio",
                "Atanyele",
                "Awokiyesi",
                "Ayeyemi",
                "Barracks Road",
                "Bolawa",
                "Caeco",
                "College Road",
                "Ehinogbe",
                "Hofere",
                "Iparuku",
                "Irewumi",
                "Lawe",
                "Lodasa",
                "Lodun Lanre",
                "Logo-Lane",
                "Lokun",
                "Odoaisom",
                "Odololo",
                "Odosikan",
                "Odotu",
                "Odoyegbe",
                "Ogbodu",
                "Ogbotitun",
                "Ogunsusi Lane",
                "Oja-Idioma",
                "Oke-Atiba",
                "Oke-Otunba",
                "Oke-Pole",
                "Oke-Alafia",
                "Okerisa",
                "Okerowo",
                "Oketoko",
                "Okunmuyiwe",
                "Olorunkole",
                "Omoko",
                "Omokole",
                "Otasan",
                "Parde",
                "Samalogbe",
                "Skyway",
                "Surulere",
                "Temi-tope",
                "Temidire",
                "Temiwohunwa",
                "Wasimi",
                "Okeigbo",
                "Aba Kolajo",
                "Aba Ojoja",
                "Aba Panu",
                "Ajegunle",
                "Ajejigi",
                "Ajeloro",
                "Akinola",
                "Akitikoro",
                "Alabata",
                "Alarere",
                "Awo Odunkunle",
                "Awopeju",
                "Bolorunduro",
                "Ehin Oke",
                "Erin Titun",
                "Gbinrindin",
                "Idi Asan",
                "Idi-Iroko",
                "Igbo Oiodumare 11",
                "Igbo Olodumare 1",
                "Kajola Arepa",
                "Ode Okuta",
                "Oke Alafia I",
                "Oke Alafia II",
                "Ologiri",
                "Oloruntele",
                "Omilaje",
                "Orinsumibare",
                "Ramonu",
                "Tenidire",
                "Aba Michael",
                "Adefulire",
                "Ajana",
                "Asatan",
                "Awo-Usman",
                "Ayesan",
                "Dosi Lomafe",
                "Eloyeko",
                "Eyingun",
                "Eyingun Akimoledun",
                "Farm Settlement",
                "Kajola",
                "Kolo",
                "Leugun",
                "Limitutu",
                "Losunla",
                "Luwasola",
                "Moferere",
                "Oke-Agbara",
                "Oke-Awo",
                "Onimole",
                "Orisunmibale",
                "Sade I & II",
                "Sadiku",
                "Sipo"
            ],
            "Irele": [
                "Ajagba",
                "Ayadi",
                "Logbosere",
                "Onitorotoro",
                "Akotogbo",
                "Abusoro",
                "Ajijoh",
                "Barogbo",
                "Iju-Osun",
                "Kenumu",
                "Naino",
                "Reuben",
                "Yopiara",
                "Igbinsin Oloto",
                "Abraham Camp",
                "Ago Taiye",
                "Ago Unolo",
                "Apene/Bopbotu",
                "Dugbolu",
                "Ebute Oko",
                "Gbejoko Camo",
                "Igbinsin Oke",
                "Ikale Camp",
                "Kanne",
                "Odo Igbisin",
                "Ojo Camp",
                "Osopan",
                "Odeirele",
                "Aduga",
                "Akingboye",
                "Gbeleju Lodan",
                "Gbogi",
                "Igboke",
                "Irelejare",
                "Iyara I",
                "Kidimu",
                "Labale",
                "Legbongbon",
                "Leunrun Luhoho Oke",
                "Likaran",
                "Lipano",
                "Lokaka",
                "Lomeye",
                "Lutako",
                "Omififun",
                "Ori-Ale Oyo",
                "Otuloya",
                "Ruwahe",
                "Omi",
                "Abiola Camp",
                "Agoraya",
                "Akinboyewa Camp",
                "Akinmoye Camp",
                "Apozere Camp",
                "Chief Luperik",
                "Chief Memogho",
                "Chief Oredo",
                "Chief Wogbo",
                "Igo-Ome",
                "Iyana",
                "Iyasan",
                "James Upogo",
                "Lisha Camp",
                "Lot Camp",
                "Obaterun",
                "Obireri",
                "Obondogo",
                "Odogbo",
                "Ogunkalu Camp",
                "Ojomo Camp",
                "Seja"
            ],
            "Odigbo": [
                "Abojupa",
                "Abojupa I",
                "Abojupa II",
                "Adeogun",
                "Adigbolu",
                "Agbirigidi",
                "Agunla",
                "Ajebamidele",
                "Ajebamidele Daodu",
                "Ajegunle Elepa",
                "Alagbo",
                "Alayumire",
                "Araromi",
                "Arato Ologo",
                "Arowole",
                "Asana akinyemi",
                "Asana Famule",
                "Asana Fatanmi",
                "Asana Kode",
                "Asana Pakoyi",
                "Atari-Oke I&II",
                "Atototan",
                "Ayedarade",
                "Ayede Adeboyeku",
                "Ayue",
                "Balagbe",
                "Balewa",
                "Bolorunduro Idi Osan",
                "Bolorunduro Sanni",
                "Fasawe",
                "Gbamrinlegi",
                "Ibasayin",
                "Irowa",
                "Ita Efun",
                "Joseye",
                "Karimu",
                "Kokumo",
                "Kolawole",
                "Laleipa",
                "Ologunba",
                "Olojo Faguwa",
                "Olorunkemi",
                "Oloyede",
                "Omoboyewa",
                "Omogunsoye",
                "Omoyoge",
                "Orisa Egbe",
                "Rubber Para",
                "Seriki",
                "Sokoto",
                "Sopotosepete",
                "Wasini-Odunwo",
                "Alawaye",
                "Adejayan",
                "Adewakun",
                "Agba",
                "Ajebamibo",
                "Akinkuhinmi",
                "Akinladenu",
                "Akinpeloye",
                "Awawye",
                "Edinmolota",
                "Fawehinmi",
                "Kajola",
                "Lipepeye",
                "Lota Adegasoye",
                "Lota-Akinseye",
                "Lota-Gbaje",
                "oloronbo",
                "Olorunsogo",
                "Olowosunmoye",
                "ShendurowoAraromi-Obu",
                "Aba-Panu",
                "Ago Alane",
                "Ago-Alaye",
                "Ago-Baale",
                "Ago-Ibadan",
                "Ago-Jeremiah",
                "Ago-Paul",
                "Agrifon Village",
                "Ajebanbo",
                "Ajebandele",
                "Araromi-obu",
                "Aujeseun",
                "Ayesan",
                "Ayetimbo",
                "Bakuo",
                "Basola",
                "Bolorunduro",
                "Erinjomo",
                "Gbegude",
                "Gbogi",
                "Good Luck",
                "Ifara",
                "Igo Village",
                "Imorun",
                "Kangidi Camp",
                "Leege",
                "Lisagbede",
                "Nursery",
                "Ogunlepa",
                "Oil Palm Camp",
                "Okefare",
                "Olaibon",
                "Olomiro",
                "Oloruntedo",
                "Oloruntedo I",
                "Oluwa Forest Reserve",
                "Ondo state",
                "Onipaanu",
                "Oniparaga",
                "Orisunbare",
                "Paranta",
                "Raphael",
                "Rubber Estate",
                "Saba",
                "Aba Alafia",
                "Aba Ilaje",
                "Aba Jimoh",
                "Aba Raphael",
                "Aba Roder",
                "Aba Wole",
                "Abapanu",
                "Aforestation Project",
                "Badee",
                "Bolomudureo II",
                "Bolorunduro I",
                "Jagiodo",
                "Komowa Camp",
                "Kosem",
                "Labon Camp",
                "Lalepa",
                "Lisa - Agbede",
                "Makinde",
                "Obadore",
                "Olokuta I",
                "Olotua II",
                "Onipetes",
                "Onitea",
                "Orita Ajebanbo",
                "Sakoto I",
                "Sakoto II",
                "Temidire",
                "Ore (Rural)",
                "Aba Eire Lucas",
                "Aba Fasu",
                "Aba James",
                "Aba-Ojoja",
                "Abagun",
                "Aiyede",
                "Ajegunle",
                "Ajeloro",
                "Alarere",
                "Awo-Odekunle",
                "Awopeju",
                "Ayede Adeboyegun",
                "Azan Fatanmi",
                "Erin Titun",
                "Idi-Asan",
                "Igbo Olodumare I",
                "Igbo-Olodumare II",
                "Ode-Okuta",
                "Ode-Alafia I",
                "Ode-Alafia II",
                "Omilaje",
                "Omoyogba",
                "Orisumbare"
            ],
            "Okitipupa": [
                "Araromi",
                "Ayeka",
                "Ugbe-Ayeka",
                "Ugboran Camp",
                "Igbodigo",
                "Afo Balumen",
                "Ago Tejere",
                "Igbodigo 1",
                "Igbodigo 2",
                "Odole Camp",
                "Igbotako",
                "Abegunde Village",
                "Abusoro Camp 1",
                "Abusoro Camp 2",
                "Adegolu Village",
                "Ademujimi Village",
                "Akinfosile Village",
                "Bilado Market",
                "Estate Camp 1",
                "Estate Camp 2",
                "Ewi camp",
                "Idi Opopo Village",
                "Idungun Village",
                "Ilado Ibini",
                "Ilebe Village",
                "Labatiyan Village",
                "Laguntan Camp",
                "Laiol Village",
                "Lawereere Village",
                "Lobuko Camp 1",
                "Lobuko Camp 2",
                "Lokuka (Better Life)",
                "Lokuka Village",
                "Loyinmi Village",
                "Mile 4 village",
                "Mile 6 Village",
                "Mobolorunduro Mile 49",
                "Moriwo Village",
                "Ogunlowo Village",
                "Oke-Ola Village",
                "Okedebi Camp 1",
                "Okedebi Camp 2",
                "Omowole Village",
                "Shogbon Village",
                "Taiwo Village",
                "Ikoya",
                "Ikulala Camp",
                "Ilado Camp",
                "Ipeta"
            ],
            "Ipeta": [
                "Lijoyi Camp",
                "Liyete",
                "Loni Camp",
                "Lowolowo Camp",
                "Majeja",
                "Obajere Camp",
                "Obolo Camp",
                "Odolawo",
                "Ohonpan",
                "Ojokodo Camp",
                "Okeraye Camp",
                "Okitipupa Oko",
                "Omoyinbo Camp",
                "Onagunte",
                "Oniseregun Camp",
                "Orunkanyerin Camp",
                "Pepere",
                "Peregun Camp",
                "Sapele",
                "Urele",
                "Uwalere Camp",
                "Yasere Camp",
                "Ilutitun",
                "Adekanle",
                "Adewinle",
                "Agirinfon I",
                "Ago Alafia",
                "Ago Edema",
                "Ago Ogunji",
                "Ago Oyinbo",
                "Ago-Agbedun",
                "Akperen Camp",
                "Aoro Camp",
                "Ayetoro 1",
                "Ayetoro 2",
                "Daweren",
                "Iditala",
                "Idogun",
                "Igbaroko",
                "Igbasan",
                "Igbile",
                "Iju-Odo Ilutitun",
                "Iju-Oke Market",
                "Ilado",
                "Ilado Ojapinwa",
                "Ilado Olatenuju",
                "Ilado Olowosusi",
                "Ilebe",
                "Ilutituu Estate",
                "Ira Odole",
                "Ira Petu",
                "Iwade",
                "Kisoso I",
                "Kisoso II",
                "Korode II",
                "Lerinrin",
                "Lerun",
                "Mobolorunduro",
                "Obonde",
                "Ogunteko",
                "Okegbe",
                "Okerisa Camp",
                "Okerisa Jimba",
                "Okerisa Lulawo",
                "Oko Lisa",
                "Oloruntedo",
                "Omonigbo",
                "Omonigbo Camp",
                "Sogbon",
                "Yasere",
                "Abusoro Camp",
                "Abusoro Village",
                "Adegboraye Camp",
                "Aduwo Camp",
                "Agbabu Camp",
                "Agbabu Village",
                "Agbaje Village",
                "Ago Oloja",
                "Ajegunle",
                "Akeun Camp",
                "Akinrinleye Camp",
                "Batedo Camp",
                "Ekelen Camp",
                "Epowe",
                "Gbude Camp",
                "Idebi Village",
                "Idogun Village",
                "Igbo Olofin",
                "Igboluwaye",
                "Igoloye",
                "Igorisa Village",
                "Ikoloma Village",
                "Ilutitun Camp",
                "Irokin Village",
                "Isowa Village",
                "Ladan Village",
                "Ladawo Village",
                "Lafe Village",
                "Lagbigidi Camp",
                "Lagboja Village",
                "Lapeti",
                "Likaje Camp",
                "Likare Village",
                "Loda Camp",
                "Lumeko Village",
                "Luwoye Camp",
                "Mile 1 Camp",
                "Modebiayo Camp",
                "Mulekagbo",
                "Odofin Village",
                "Ogunmade Village",
                "Oha Camp",
                "Ojabale Village",
                "Ojokodo Village",
                "Ojomo Village",
                "Okamisa",
                "Oke-Oluwa Camp",
                "Okerisa Village",
                "Olibo Camp",
                "Oloijau Village",
                "Oluwa Village",
                "Omidu",
                "Ominla Village",
                "Orokan",
                "Owe Camp",
                "Rain-Head Junction",
                "Uboke Camp",
                "Umobi Village",
                "Umoboro Village",
                "Yasere Village",
                "Yeabata Camp",
                "Zeba Camp",
                "Okitipupa",
                "Abisoro Camp",
                "Abogedegbe",
                "Adegoju Camp",
                "Agbere",
                "Ago Akerun Camp",
                "Ago Gbagudu",
                "Ago Taiwo",
                "Ajana Camp",
                "Akinbulure Camp",
                "Awolowo Camp",
                "Calabar Camp Idepe",
                "Dugbolu",
                "Egure Jomo",
                "Farm-Settlement",
                "Herbert Camp",
                "Igborogbo"
            ],
            "Ondo East": [
                "Oboto",
                "Aleru",
                "Araromi",
                "Baikin",
                "Bolorunduro",
                "Igba",
                "Igbo-Oja",
                "Ireje",
                "Kayola",
                "Laworo",
                "Lodasa",
                "Logara",
                "Lomoso",
                "Mobire",
                "Obun-Ewi",
                "Obun-Ondo",
                "Omiluri",
                "Ulasimi",
                "Owena Obadore",
                "Aba-Ikirun",
                "Adaja",
                "Adeyanju",
                "Aiyetoro",
                "Akintewe",
                "Anigbogi",
                "Aponla",
                "Apurere",
                "Augusts",
                "Bagbe",
                "Doherty",
                "Epe",
                "Erinla",
                "Gbandan",
                "Igbindo",
                "Iguusin",
                "Ilunla",
                "Jegunle",
                "Kolawole",
                "Komowa",
                "Labosipo",
                "Lafiaji",
                "Lamu",
                "Leepo",
                "Leku",
                "Lemoso",
                "Leyowo",
                "Lipepeye",
                "Litetu",
                "Lobi",
                "Logaara",
                "Lomututu",
                "Lotgbo",
                "Mobolade",
                "Modebiayo",
                "Number",
                "Obada",
                "Obadere",
                "Obuakekere",
                "Odowo",
                "Ogho",
                "Ogundele",
                "Oju-Oluwa",
                "Oke-Alafia",
                "Okekun",
                "Okeruku",
                "Oladapo",
                "Olorun Sogo",
                "Olorun-Gbadurami",
                "Olorunsefunmi",
                "Oloruntedo",
                "Orisunmibare",
                "Orunbato",
                "Osun",
                "Otokola",
                "Owoele",
                "Sade",
                "Sasere",
                "Sokoto",
                "Solo",
                "Sopotospete",
                "Temidire",
                "Tokunbo",
                "Tolagbola",
                "Urore",
                "Yeu",
                "Tekunle",
                "Ajabamboorin",
                "Asantan-Fbe",
                "Asantan-Oja",
                "Awaye I & II",
                "Awoduyi",
                "Ayadi",
                "Ayetoro",
                "Baipie",
                "Ebunla",
                "Elikenah",
                "Fagbo",
                "Fagbo-Centre",
                "Gbolagun",
                "Ighori",
                "Jeun",
                "Kooni",
                "Loka",
                "Losare",
                "Moraje",
                "Oke-Opa",
                "Oke-Oya",
                "Okegegere",
                "Omifunfun",
                "Omunutun",
                "Otalupe",
                "Owena-Tepo",
                "Owomamowo",
                "Soko",
                "Tepo"
            ],
            "Ondo West": [
                "Ajegunle",
                "Aboba",
                "Adeoye",
                "Ajaba-Alafia",
                "Akinyosoye",
                "Aratu-Olojo",
                "Aratundin",
                "Ayetimbo",
                "Ayetoro",
                "Fadani",
                "Gbaghengha",
                "Gbagia-Ile",
                "Gbagia-Oja",
                "Gbengbo",
                "Gbokuta",
                "Ilutitun",
                "Irowa",
                "Laje",
                "Lijoka",
                "Losan I",
                "Losan II",
                "Losare",
                "Obado",
                "Oigbe",
                "Oluwabasiri",
                "Onisoosi",
                "Orisunmi",
                "Ounkeko",
                "Temidire",
                "Bomodeloku",
                "Ajebamo",
                "Ayikun",
                "Dudu",
                "Ita Oba",
                "Laagba",
                "Leruku",
                "Leutu",
                "Lolorunranmilowo",
                "Olorunsefunmi",
                "Ugbo",
                "Abusoro",
                "Ajebambo",
                "Ajebamidele",
                "Apaja",
                "Araromi-Oke",
                "Ayesanmi",
                "Basola",
                "Gbokufa",
                "Igbo-Ake",
                "Ikunja",
                "Ironsi",
                "Itagbogi",
                "Lapawe",
                "Lasoro",
                "Lugbogi",
                "Masole",
                "Mobayode",
                "Modeboayo",
                "Moferere",
                "Mojolu",
                "Motadale",
                "Orisunmibare",
                "Sasere"
            ],
            "Ose": [
                "Afo",
                "Anade",
                "Araromi",
                "Atiba",
                "Igbodu",
                "Iwoye",
                "Jaipe",
                "Ohin",
                "Ugbetere",
                "Ugboka",
                "Arimogija",
                "Ugboke Ikare",
                "Idoani",
                "Ago Alamasi",
                "Baale Village",
                "Igbo Otagbe",
                "Igbogburu",
                "Kajola",
                "Kekeri",
                "Odoro",
                "Ofunrun",
                "Ogege Camp",
                "Okikanmi",
                "Olagbe",
                "Omi Adun",
                "Omireke",
                "Osan Daji Camp",
                "Otagboosa",
                "Otalere",
                "Otaloro",
                "Sekere",
                "Soleh Boneh",
                "Ifon",
                "Abusoro",
                "Ago A1sabare",
                "Agric Settlement",
                "Arepa",
                "Elegbeka",
                "Iju Agborin",
                "Okitiofa",
                "Omi Alafia",
                "Ori-Ohin",
                "Oruju",
                "Ugbo Oke",
                "Ugbonia",
                "Ijagba",
                "Akori",
                "Amian",
                "Apokorobi",
                "Eze",
                "Ezeje II",
                "Itutuwa",
                "Odibiade I& II",
                "Odikahor",
                "Tode Camp",
                "Tutu Kuru",
                "Ugbogoro",
                "Ikaro",
                "Odotori",
                "Uguru",
                "Ulema",
                "Imeri",
                "Okeloro",
                "Imoru",
                "Ago Aruwajoye",
                "Ago Ikare",
                "Ago Oyinbo",
                "Ago-Owadana",
                "Akemiri Camps",
                "Eleninla",
                "Omiobi",
                "Tebe",
                "Ugbooke Ikare",
                "Okeluse",
                "Abuja Mile-2 Camp",
                "Abuja Mile-4 Camp",
                "Ago Omoba",
                "Aminu Camp",
                "Apololo",
                "Ariyan Mile",
                "Mokoko",
                "Ogbese Falodun",
                "Oluse Camp",
                "Omolege",
                "Omonuogbe Camp",
                "Omosule",
                "Ute",
                "Arijonpeye",
                "Aso-Finch",
                "Ero",
                "Owajalaye",
                "Sanusi"
            ],
            "Owo": [
                "Emure-Ile",
                "Eporo",
                "Gbadegun",
                "Oke-Camp",
                "Ulura",
                "Idasen",
                "Amirin",
                "Ijegunmon",
                "Ilale",
                "Ilema",
                "Isijogun",
                "Keji",
                "Ogain",
                "Ipele",
                "Ago Oloko",
                "Aladie Ofi",
                "Alo",
                "Molege",
                "Okiti Ota",
                "Pole",
                "Uwese Omosule",
                "Isuada",
                "Igbo-Oke",
                "Obaso Oto",
                "Odo",
                "Riya",
                "Sasore",
                "Iyere",
                "Igbe",
                "Ijelu",
                "Oyoyo",
                "Umoje",
                "Upo",
                "Owo (rural)",
                "Amehinti",
                "Ijebu Owo",
                "Obaseto",
                "Ojana",
                "Ugbeta",
                "Ugbo-Agbo",
                "Upenmen",
                "Ago",
                "Ago-Paanu",
                "Ose Ohere",
                "Yeye",
                "Uso",
                "Aruwajoye",
                "Asolo",
                "Kajola-Ode",
                "Odofin",
                "Oke Odo"
            ]
        }
    },
    {
        "Osun": {
            "Aiyedade": [
                "Gbongan",
                "Ode-Omu",
                "Orile Owu",
                "Ogbagba",
                "Wakajaiye",
                "Abinu Alakinde",
                "Adam",
                "Afonle",
                "Alagbede",
                "Alakan",
                "Anjorin",
                "Gbaja",
                "Idi-Iroko",
                "Moso Alagba",
                "Oloba",
                "Oniwe Aporo",
                "Oogi",
                "Oosa Aro",
                "Aba Dorcas",
                "Aba Ibadan",
                "Aba Oba",
                "Abewela",
                "Abimbola",
                "Ademuyiwa",
                "Adetunji",
                "Afeleke-Dabongbo",
                "Agbeja",
                "Ajegunle",
                "Ajule",
                "Akinjobi",
                "Alaguntan Village",
                "Anlugbua",
                "Araromi Owu",
                "Atoba Village",
                "Awaye",
                "Baba Jakan",
                "Bolarinwa-ladinni",
                "Ejemu",
                "Elegbeje",
                "Fetubori",
                "Fowosere Village",
                "Gbeke",
                "Gbonna",
                "Idi Roke",
                "Kegunnode",
                "More Owode",
                "Motakola",
                "Obalufon",
                "Ojetunde Village",
                "Olosi Village",
                "Opakunle",
                "Osunwale",
                "Sangodiran",
                "Sesa Alila",
                "Supori-Village",
                "Timi Village",
                "Toka"
            ],
            "Aiyedire": [
                "Ile Ogbo",
                "Kuta",
                "Oke Osun (Alabata)",
                "Olupona",
                "Aderibigbe",
                "Balogun",
                "Lemomu",
                "Olukohun",
                "Aba Akan",
                "Aba Olodo",
                "Agbanda",
                "Arugbede",
                "Edoro",
                "Eleja",
                "Gboyi",
                "Igboawu",
                "Konko",
                "Odoogun",
                "Ojegeba",
                "Oke Osun",
                "Otaawodi",
                "Seke",
                "Songba",
                "Aba Alaya",
                "Aba Baale",
                "Aba Igbira",
                "Abani Kanda",
                "Abi-Ilu",
                "Abimbola",
                "Adogba",
                "Agba",
                "Agbodowu",
                "Ajadi",
                "Ajegbendele",
                "Ajigbagun",
                "Akiru",
                "Alabata",
                "Alagbade",
                "Alakeji",
                "Alalubosa",
                "Alamo",
                "Alatise",
                "Alawo",
                "Aragba",
                "Arindu",
                "Aro Tarapin",
                "Asipa Elefon",
                "Baase",
                "Babalawo",
                "Bole",
                "Dalemo",
                "Ekerin",
                "Eleegun",
                "Eleji Oweeru",
                "Elesin",
                "Fagbolu",
                "Gbojona",
                "Igberinwo",
                "Ile Eran",
                "Jagun labu Akinbami",
                "Molamoyin",
                "Okeelu",
                "Olodo",
                "Olota",
                "Olowu",
                "Olubooku",
                "Onigangan",
                "Onilete",
                "Oosa Awoyale",
                "Osolo",
                "Osunwoyin",
                "Owotoroka",
                "Segbodile",
                "Telemu",
                "Aba Jagun",
                "Ajagbangba",
                "Akuru",
                "Alagbaa",
                "Alawusa",
                "Alaya",
                "Idi Ogun",
                "Lagesin",
                "Lanye",
                "Molosu",
                "Monfu",
                "Moye",
                "Odunfa",
                "Ologiri",
                "Olokun",
                "Oloosa",
                "Oloro",
                "Olosokun",
                "Olota Baale",
                "Olubu",
                "Olukotun",
                "Onigbongbo"
            ],
            "Atakunmosa East": [
                "Ajebamidele",
                "Eti-Oni",
                "Ipole",
                "Iwara",
                "Igangan",
                "Iwikun",
                "Iyinta",
                "Oko Aogo",
                "Bolorunduro",
                "Iperindo",
                "Ise",
                "Odo",
                "Aiyetoro",
                "Ajido",
                "Alarere",
                "Faro",
                "Itaapa",
                "Odogbo",
                "Olowu",
                "Araromi",
                "Arewa",
                "Atorin",
                "Ayinrin",
                "Bello Alaka",
                "Fadahunsi-Ogundele",
                "Faforiji",
                "Lapaede",
                "Number",
                "Onigbogi",
                "Otokobo",
                "Sokoto"
            ],
            "Atakunmosa West": [
                "Epe/Ifelodun",
                "Ibodi",
                "Ifewara",
                "Isaobi",
                "Itagunmodi",
                "Muroko",
                "Okebode",
                "Osu",
                "Akola",
                "Alakowe",
                "Alusekere",
                "Aro-Aji",
                "Ayorunbo",
                "Balogun",
                "Bara",
                "Iloba",
                "Itamerin",
                "Iwaro",
                "Odesomi",
                "Orogo",
                "Abebeyun",
                "Kajola",
                "Lala",
                "Oke-Osin",
                "Aladura",
                "Ilaa",
                "Isireyun",
                "Isolo",
                "Isotun",
                "Itaosin",
                "Salau",
                "Bowale",
                "Ifeware",
                "Imelu",
                "Ogogo Akaro",
                "Owena",
                "Aba Anu",
                "Igila",
                "Olorombo",
                "Epe",
                "Igbadae",
                "Igun",
                "Ijana",
                "Iyenmogun"
            ],
            "Boluwaduro": [
                "Eripa",
                "Igbajo",
                "Iresi",
                "Alafara",
                "Igbodu",
                "Oke Oba",
                "Gbeleru",
                "Iloro",
                "Obaala",
                "Obanla",
                "Okerun",
                "Agofulani",
                "Gbonko",
                "Morakinyo",
                "Obuke",
                "Oke Opa",
                "Osolo"
            ],
            "Boripe": [
                "Aagba/ Ororuwo",
                "Ada",
                "Iragbiji",
                "Iree",
                "Amola",
                "Aru",
                "Aweda",
                "Elere",
                "Fadele",
                "Obada",
                "Ororuwa",
                "Otake",
                "Alomi",
                "Erinwo",
                "Loba",
                "Okeigbo",
                "Aromadu",
                "Banji Elegun",
                "Egbeda",
                "Elemo",
                "Esa",
                "Goregun",
                "Idi Osan",
                "Inurin",
                "Morifin",
                "Odebudo",
                "Olukosin",
                "Oyo",
                "Egbejoda",
                "Iloko",
                "Imuleke"
            ],
            "Ede North": [
                "Ede",
                "Abogunde",
                "Adejuwon",
                "Araromi",
                "Atapara",
                "Atoyebi",
                "Bara",
                "Doba",
                "Ede Township",
                "Egbejoda",
                "Elero",
                "Faosun",
                "Kajola",
                "Lasiyi",
                "Oloba",
                "Tomoni"
            ],
            "Ede South": [
                "Alajue",
                "Sekona",
                "Agbeinpa",
                "Aminiwon",
                "Arola",
                "Ededimeji",
                "Idi-Oro",
                "Idiagbon",
                "Obanase",
                "Ogbaagbaa",
                "Olodan",
                "Owode-Ede",
                "Owojun",
                "Popoola",
                "Adekolu",
                "Agboopa",
                "Akoda",
                "Awoo",
                "Dauda",
                "Denu",
                "Elewure",
                "Isale-Ofa",
                "Kusi",
                "Laogun Araromi",
                "Laogun Isemi",
                "Oloki"
            ],
            "Egbedore": [
                "Ara",
                "Awo",
                "Ido Osun",
                "Ikotun",
                "Iragberi",
                "Iwoye / Origo",
                "Ojo/Aro",
                "Okinni",
                "Aigbagbon",
                "Aigbe",
                "Alaadota",
                "Alapupu",
                "Ateri",
                "Idi-Mangoro",
                "Igbokiti (I & II)",
                "Oke-Agunbelewo",
                "Aba Agberi",
                "Abere",
                "Akogun",
                "Alaro Elemo",
                "Areago",
                "Aro",
                "Asalu",
                "Asipa",
                "Bara",
                "Ekerin",
                "Ijagemo",
                "Ilora",
                "Imofo",
                "Iseki",
                "Iya Agba",
                "Iyalode",
                "Jagun",
                "Lado",
                "Oloode",
                "Oloso",
                "Onipara",
                "Oose",
                "Otun",
                "Seriki",
                "Alasan",
                "Ekuro",
                "Ekusa",
                "Iddo",
                "Origo",
                "Aba Ajao",
                "Abudo",
                "Adeyeyi",
                "Aronwa",
                "Ebunlaope",
                "Eleran",
                "Aba Aliyu",
                "Aba D.F. Kolajo",
                "Aba Dada",
                "Aba Faro",
                "Aba Golu",
                "Aba Ife",
                "Aba Raji",
                "Adesigbin",
                "Ago Oluwu",
                "Ajegbinrin",
                "Aleahanran",
                "Asawure",
                "Baba Ibadan",
                "Bolorunduro",
                "Ebgejoda",
                "Ere",
                "Erinoke",
                "Fabamira",
                "Fadeyi",
                "Idi-Obi",
                "Ifetedo Township",
                "Imolengbalafia",
                "Jagilegbo",
                "Kole Akinjola",
                "Kongo",
                "Lusoye",
                "Odebunmi",
                "Ogbon Ayesan",
                "Ogedengbe",
                "Okesoda",
                "Ologiri",
                "Oloparun",
                "Olorombo",
                "Omosebi",
                "Onikanga",
                "Orafidiya",
                "Oragbade",
                "Oriola",
                "Owusunmomi",
                "Surulere",
                "Taroko",
                "Kere",
                "Aba Aafa",
                "Abewale",
                "Adereti",
                "Amu Fagbewesa",
                "Amu-Igbo",
                "Apata Oloko",
                "Apoje",
                "Araromi",
                "Atoba",
                "Awurele",
                "Esena",
                "Iponrin",
                "Oke-Odo",
                "Ologede",
                "Olomuoba",
                "Olomuoja",
                "Olorunda",
                "Oshogbo",
                "Osogun",
                "Poso Obutu",
                "Posu Adedire",
                "Mefoworade",
                "Omifunfun",
                "Aba Mama",
                "Aba Mathew",
                "Aba Pastor",
                "Afolabi",
                "Agbaje",
                "Agbele",
                "Aiyetorojera",
                "Ajebandele-Dadehan",
                "Atetedaye",
                "Awosiyan",
                "Elegberun",
                "Fasure",
                "Idi Ogun Sanni",
                "Idi Ogun-Adedire",
                "Ita Agba",
                "Kaledun",
                "Obajida",
                "Ologbenla",
                "Olomidudu",
                "Onigbodogi",
                "Orisunbare",
                "Poyika Adewumi",
                "Poyika Ogunleye",
                "Poyika Onikoko",
                "Sekunde",
                "Sukulubi",
                "Oke-Owena",
                "Gbengbeleku",
                "Aba Oba",
                "Ajabandele",
                "Akinyele",
                "Alabameta",
                "Amula odunlade",
                "Amula Saliu",
                "Amusan",
                "Baba Eko",
                "Camp-Obele",
                "Fadaka",
                "Falola",
                "Idi Ogun",
                "Ikeketu",
                "Natha",
                "Odesan",
                "Ogunsakin",
                "Okoro Elusoji",
                "Okoro-Isaiah",
                "Oru-Alayinde",
                "Sunbere",
                "Yinmi",
                "Yinmi Oja",
                "Olode",
                "Aba Ijesha",
                "Aba Natha",
                "Aba Oyinbo",
                "Aba Stephen",
                "Aba Titun-Balogun",
                "Agbombiti",
                "Agbon Paul",
                "Alatere",
                "Arode",
                "Eleweran",
                "Elewure Oke",
                "Elewure-Isale",
                "Garage Olode",
                "Idi Ako",
                "Labata",
                "Odemuyiwa",
                "Omidi Onipetesi",
                "Omidire",
                "Sekunde Isanlu",
                "Sekunde-Ibadan",
                "Osi / Ara / Joshua",
                "Aba Andrew",
                "Aba Edunabon",
                "Aba Kajola",
                "Aba Ode",
                "Aba Ojo",
                "Aba Oni",
                "Agbiri",
                "Agbonkuta",
                "Ajagbegun",
                "Ajegunle",
                "Albert",
                "Alutierin",
                "Apata",
                "Ara Akinloye",
                "Ara Joshua",
                "Ara Oosa",
                "Arugbosegbe",
                "Eeelu",
                "Idi Ogun-Wogun",
                "Isoyo",
                "Ita Orunto",
                "Jagun Osin",
                "Obere",
                "Onikoto Esera",
                "Osi Luobe",
                "Osi Sooko",
                "Osiokero",
                "Walode"
            ],
            "Ifedayo": [
                "Oke Ila",
                "Aworo Ayedaade",
                "Balogun",
                "Ejemu",
                "Idi Awere",
                "Ilupeju",
                "Obaale",
                "Obaloja",
                "Obanla",
                "Ora",
                "Abanju Akesin",
                "Aganju Asaoni",
                "Oyi Adumi",
                "Oyi Araromi",
                "Temidire"
            ],
            "Ifelodun": [
                "Ekoende",
                "Iba",
                "Obagun",
                "Otan Aiye -Gaaju",
                "Eko Ajala",
                "Olodan",
                "Alaaro",
                "Aoku",
                "Iga Saliu",
                "Igalambe",
                "Isale Aisin",
                "Ojomu",
                "Okose",
                "Dagbolu",
                "Jagun",
                "Oluode",
                "Saba",
                "Olorunsogo"
            ],
            "Ila": [
                "Ila",
                "Aba Ododo",
                "Abalagemo",
                "Ajaba",
                "Alagbede",
                "Ayetoro Obaaro",
                "Edemosi",
                "Ejigbo-Orangun",
                "Gaa Fulani",
                "Idi Odan",
                "Idi Ogbagbara",
                "Isinmi Olootu",
                "Oore",
                "Oyi Adunni",
                "Oyi Araromi",
                "Oyi Ayegunle"
            ],
            "Ilesa East": [
                "Okesa",
                "Imo",
                "Ifosan/Oke-Eso",
                "Itisin/Ogudu",
                "Ijamo",
                "Upper & Lower Ijoka",
                "Iloro/Roye",
                "Isare",
                "Ilerin",
                "Biladu"
            ],
            "Ilesa West": [
                "Itakogun/Upper Egbe-Idi",
                "Lower Egbe-Idi",
                "Upper/Lower Igbogi",
                "Omofe/Idasa",
                "Isokun",
                "Ikoyi",
                "Ilaje",
                "Isida/Adeti",
                "Ereja",
                "Ayeso"
            ],
            "Irewole": [
                "Ikire",
                "Arinkin",
                "Ayetoro",
                "Balogun",
                "Bamgbola",
                "Bamidele",
                "Fidiwo",
                "Ikire Township",
                "Majeroku",
                "Molarere",
                "Odeyinka",
                "Oloowa",
                "Wasinmi"
            ],
            "Isokan": [
                "Apomu",
                "Ikoyi",
                "Afijogba",
                "Afolu",
                "Alabamejo",
                "Alagbede",
                "Alahun",
                "Alara",
                "Aro Kekere",
                "Aronla",
                "Awala",
                "Awala Japo",
                "Baare",
                "Bodunde",
                "Bodundekoro",
                "Elebanla",
                "Idi Eeegu",
                "Kagbadanla",
                "Kajola",
                "Katesan",
                "Kekere",
                "Labu",
                "Ladaru",
                "Mogun",
                "Mowo Ejemu",
                "Odofin",
                "Ogundiran",
                "Oju-Ona",
                "Olaleye",
                "Olokuta",
                "Omolowo",
                "Opelade",
                "Oran Eemu",
                "Otun Ojeyemi",
                "Pannu",
                "Riti Egbeda",
                "Sunbare",
                "Abelebiyi",
                "Abidemi",
                "Afoluoba",
                "Ajebamidele",
                "Ajolode",
                "Akoogun",
                "Alakeji",
                "Alamo",
                "Olonjo",
                "Oloya",
                "Onilewo",
                "Sakotun"
            ],
            "Iwo": [
                "Agberire",
                "Iwo",
                "Adana",
                "Afiku",
                "Afingba",
                "Agbede",
                "Agbodan",
                "Agbona",
                "Akinde",
                "Alapo",
                "Alebiosu",
                "Ameree",
                "Anaru",
                "Ape",
                "Arusa",
                "Awuje",
                "Elemi",
                "Elemo",
                "Fagbayibi",
                "Idi-Iroko",
                "Ikire Ile",
                "Ikolaba",
                "Iwara",
                "Iyangan",
                "Jagun",
                "Kanna",
                "Kekere",
                "Lemomu",
                "Molare",
                "Motunase",
                "Obajoko",
                "Obutu",
                "Ofisan",
                "Ogburo",
                "Ogede",
                "Ogundangogo",
                "Ogunju",
                "Ologun Ogunjana",
                "Olokodudu",
                "Olubusan",
                "Olupo Jolu",
                "Omoba",
                "Omosan-Igbo",
                "Osa Ogunala",
                "Osunjobi",
                "Papa",
                "Sade",
                "Tantan",
                "Yakoyo",
                "Iwo Township"
            ],
            "Obokun": [
                "Eesun/Ido-Oko",
                "Atanra",
                "Ere",
                "Igogo",
                "Ibala",
                "Idi-Oko",
                "Ijana",
                "Ijaregbe",
                "Oke-Opa",
                "Esa Odo",
                "Esa-Oke",
                "Farm-Settlement",
                "Ido Ayegunle",
                "Ibokun",
                "Ada Owode",
                "Amele",
                "Apalara",
                "Ipetu Ile",
                "Itiya",
                "Matawin",
                "Okegun",
                "Olobe",
                "Saloro",
                "Sawe",
                "Ase-Ijesa",
                "Ilahun/Ikinyinwa",
                "Gbogidigbo",
                "Ilahun",
                "Odo-Opa",
                "Ilare",
                "Afolabi",
                "Ajioku",
                "Egigun",
                "Eriro",
                "Ilase/Idominas",
                "Ajegunle",
                "Alafon",
                "Coker",
                "Idoka",
                "Idominasi",
                "Ilase",
                "Ilowa",
                "Iponda",
                "Iregun",
                "Oke Osun",
                "Oke-Oro",
                "Olorunda",
                "Oniyere",
                "Oota",
                "Owasanmi",
                "Imesi-ile",
                "Otan-Ile"
            ],
            "Odo Otin": [
                "Asi/Asaba/Oyan",
                "Asaba",
                "Asi",
                "Oyan",
                "Ekosin/Iyeku",
                "Elesin-Funfun",
                "Kosemani",
                "Oiakunmodu",
                "Olokumodo",
                "Faji/Opete/Igbaye",
                "Ago Ayo",
                "Faji",
                "Idiroko",
                "Igbaye",
                "Imuleke",
                "Opete",
                "Ijabe/Ila/Odo",
                "Alapata",
                "Igbotele",
                "Ijabe",
                "Ila-Odo",
                "Opanda",
                "Inisa/Obe/Agbeye",
                "Agbeye",
                "Inisa",
                "Ore",
                "Okua/Ekusa",
                "Ekusa",
                "Okuku",
                "Adegbite"
            ],
            "Ola Oluwa": [
                "Ajagba/Iwo Oke",
                "Elewedu",
                "Elewure",
                "Jagunode Ofa",
                "Kekere",
                "Mogbelerin",
                "Molaye",
                "Olota",
                "Olupe",
                "Oluponia",
                "Tankoda",
                "Asa/Ajagun-lase",
                "Aba Ajuba",
                "Adebiopon",
                "Afingba",
                "Agogo Ogun",
                "Aigbede",
                "Ajagunlase",
                "Aladorun",
                "Asa",
                "Balogun Oja",
                "Dagbelu",
                "Dagbolu",
                "Elere",
                "Idiya",
                "Nka",
                "Ododo",
                "Ogunoja",
                "Okoro",
                "Tarapin",
                "Yamganmu",
                "Asamu",
                "Aba Junadu",
                "Aba Lemomu",
                "Alawoloko",
                "Aromole",
                "Ilamodu",
                "Ile Ajo",
                "Ile Kuta",
                "Kinko",
                "Laafe",
                "Oke Igan",
                "Oke Ogun",
                "Olukotun",
                "Olusenwo",
                "Oniyangi",
                "Orilowo",
                "Orisasa",
                "Parakoyi",
                "Bode Osi",
                "Alagbon",
                "Aloro",
                "Elepo",
                "Elesu",
                "Idi Oro",
                "Molosayowo",
                "Olowo",
                "Paku Odan",
                "Ikire Ile/Iwara",
                "Afiku",
                "Agbede",
                "Agbodan",
                "Akinde",
                "Alapo",
                "Alebiosu",
                "Ameree",
                "Ape",
                "Arusa",
                "Elemi",
                "Fagbayibi",
                "Ikalaba",
                "Ile Ogo",
                "Imoru",
                "Obamore",
                "Obamoro",
                "Orilende",
                "Otunjagun",
                "Ogbaagba",
                "Aba Odan",
                "Asati",
                "Igege",
                "Mogaji",
                "Toto",
                "Telemu",
                "Agbowu",
                "Akoti",
                "Eeleke",
                "Mogbidun",
                "Olopalamba"
            ],
            "Olorunda": [
                "Oba-Ife/Oba-Oke",
                "Abegunde",
                "Ajala",
                "Ajegunle",
                "Aliyu",
                "Aminu",
                "Amusun",
                "Aro Elemo",
                "Awokunle",
                "Awoniyi",
                "Awoyale",
                "Elemo",
                "Esa",
                "Folarin",
                "Idi Ape",
                "Idi Osan",
                "Idiape",
                "Jagun",
                "Odesola",
                "Odofin",
                "Ogundele",
                "Ojomu",
                "Oke",
                "Okemole",
                "Oloba Oke",
                "Olobaile",
                "Olorunda",
                "Olukotun",
                "Oluode",
                "Onigiloro",
                "Osolo",
                "Saba"
            ],
            "Oriade": [
                "Erinmo/Iwaraja",
                "Erin-Oke/Erin-Ijesa",
                "Ijebu-Jesa Rarul",
                "Ijeda/Iloko",
                "Ipo Arakeji",
                "Ikeji Arakeji",
                "Ikeji-Ile",
                "Ipetu-Ijesa",
                "Iwoye",
                "Ijimo",
                "Omo-Ijesha",
                "Oke-Ana Ijesa",
                "Igbelajewa",
                "Aba Lawani",
                "Ijaregbe",
                "Itegun",
                "Ijeda",
                "Iloko",
                "Alajale",
                "Alagbe",
                "Akunrin",
                "Christ Apostolic Church",
                "Igbo Reserve",
                "Ita Ata",
                "Joseph Ayo Babalola University",
                "Odo Ipo",
                "Oiyo",
                "Oju Oja",
                "Ogbon Oyo",
                "Omo Afa",
                "Akeji",
                "Olori-Oko",
                "Owena Ijesa",
                "Oko Orisakeji",
                "Olobe-Ide",
                "Adedeji",
                "Afinbiokin",
                "Alabameta",
                "Apoti",
                "Asalu",
                "Bolorunduro",
                "Dagbaja",
                "Ipetu Jesa",
                "Lawaye",
                "Oko",
                "Oloruntedo",
                "Onikoko",
                "Orisunbare",
                "Sawe",
                "Eti Oni",
                "Ilo Ayegunle"
            ],
            "Orolu": [
                "Ifon",
                "Abegunde",
                "Ajala",
                "Ajegunle",
                "Aliyu",
                "Aminu",
                "Amusun",
                "Aro Elemo",
                "Asalu",
                "Awokunle",
                "Awoniyi",
                "Awoyale",
                "Bara",
                "Barohun",
                "Basorun",
                "Bolorunduro",
                "Egan Aje",
                "Elemo",
                "Esa",
                "Folarin",
                "Idi Ape",
                "Idi Iroko",
                "Idi Osan",
                "Idiape",
                "Idiya",
                "Ikimo",
                "Jagun",
                "Kajola",
                "Laarope",
                "Molufon",
                "Odesola",
                "Odofin",
                "Ofe Bolo",
                "Ogundele",
                "Ogunkeye",
                "Ojomu",
                "Oke",
                "Okemole",
                "Oloba Oke",
                "Olobaile",
                "Ologede",
                "Olorunda",
                "Olukutun",
                "Oluode",
                "Onigari",
                "Onigiloro",
                "Onsokun",
                "Osolo",
                "Osun Esa",
                "Owode",
                "Saba"
            ],
            "Osogbo": [
                "Ataoja",
                "Otun Jagun",
                "Alagba",
                "Are-Ago",
                "Jagun",
                "Baba Kekere",
                "Eketa",
                "Otun Balogun",
                "Ekerin"
            ]
        }
    },
    {
        "Oyo": {
            "Afijio": [
                "Akinmorin / Jobele",
                "Awe",
                "Fiditi",
                "Ilora/Oluwa-Tedo",
                "Imini",
                "Iware",
                "Aba Ibadan",
                "Aba Kasia",
                "Akinmorin",
                "Alapadi",
                "Anfelerin",
                "Bali",
                "Basi",
                "Ekewa",
                "Eleko",
                "Elepe",
                "Elesu",
                "Elewebe",
                "Fadare",
                "Idiito",
                "Ijefon",
                "Ile Olufi",
                "Imeleke",
                "Iseke",
                "Jagun",
                "Jobele",
                "Jokan",
                "Kolobo",
                "Lanipekun",
                "Lapiti",
                "Oke",
                "Olokiti",
                "Oniyanrin",
                "Sulu",
                "Aba Bara",
                "Aba Ogunremi",
                "Aba Olori",
                "Aiyekale",
                "Ajegunle",
                "Apaara",
                "Asipa",
                "Emiabata",
                "Idi Agbon",
                "Idi Orpa",
                "Idimangoro",
                "Ijado",
                "Isale Apata",
                "Jabata",
                "Kiyesemi",
                "Kosobo",
                "Laraniyi",
                "Moromipin",
                "Olukolu",
                "Oluode",
                "Onfunfun",
                "Adekunfe",
                "Agbaakin",
                "Bello",
                "Dakeja",
                "Egbejoda",
                "Idowu Oko",
                "Ijaiye Ojutaye",
                "Irepodun Village",
                "Modeni",
                "Abeodo",
                "Aburumaku",
                "Agbonrin",
                "Ago Fulani",
                "Agunbiade",
                "Ajuwon",
                "Akee",
                "Akesapon",
                "Akinpelu",
                "Akodudu",
                "Akuo",
                "Alapinni",
                "Alawusa",
                "Anti",
                "Aribambo",
                "Aridiogo",
                "Arin",
                "Eleekara",
                "Eleyele",
                "Fadari",
                "Obananko",
                "Obanlete",
                "Ogunwemimo",
                "Ojutaye",
                "Olorieru",
                "Olukosolu",
                "Olukotun",
                "Oluwatedo",
                "Onikoko",
                "Oniluru",
                "Sakutu",
                "Temidire Farm Sett.",
                "Agoyo",
                "Ajana",
                "Ajobo",
                "Arulogun",
                "Atan",
                "Atente",
                "Hosi",
                "Ilu Aje",
                "Isioye",
                "Japeta",
                "Lakanpa",
                "Ojerinde",
                "Okelagun",
                "Olounde",
                "Olowa",
                "Waya",
                "Aba Jagun",
                "Ajayi",
                "Akinola",
                "Labe",
                "Molade",
                "Ogunkanmi",
                "Sekeseke"
            ],
            "Akinyele": [
                "Ajibade / Alabata",
                "Akinyele",
                "Arulogun / Igbo OLoyin",
                "Ijaye",
                "Ikereku",
                "Iroko",
                "Moniya",
                "Olode / Onidundu",
                "Olorisakoko/Mele",
                "Agbedo",
                "Akingbala",
                "Alagbaa",
                "Balogun",
                "Dabadango",
                "Elekuru",
                "Lakeye",
                "Olorisa",
                "Onibon-Nla",
                "Agbirigidi",
                "Ajobo",
                "Akinjero 1 & II",
                "Babalawo",
                "Iba",
                "Irepodun",
                "Isabiyi",
                "Solalu",
                "Adebayo",
                "Agbongun",
                "Akinaje",
                "Akinode",
                "Aroro",
                "Atere",
                "Eniosa",
                "Igboloyin",
                "Ogunranti",
                "Olanla",
                "Oluwo",
                "Salako",
                "Agbonrin",
                "Ajibode",
                "Atan Ojedele",
                "Atan-Nla",
                "Bamidele",
                "Fagbenro",
                "Fagunwa",
                "Idi-Aayan",
                "Ijaye Ajeja",
                "Iware",
                "Lalare",
                "Odunewu",
                "Ojedeji",
                "Olonitutu",
                "Saanu",
                "Sangobon",
                "Tola larumo",
                "Agbagi",
                "Alade",
                "Alasoosun",
                "Atapa",
                "Ayepola",
                "Ekefa",
                "Eleepo",
                "Ogbogbologun",
                "Folarin",
                "Oloya",
                "Agoro-Ibadan",
                "Faleye",
                "Idiapa",
                "Ileyioku",
                "Labode",
                "Morowonaa",
                "Obada",
                "Ogbongan",
                "Ogunjinmi",
                "Ogunjinmi Egan",
                "Olunlosin",
                "Onikarahun",
                "Osayindeyi",
                "Oyada",
                "Akinwumi",
                "Arikanki",
                "Fakore",
                "Igbagbo",
                "Motunde",
                "Olowogbo",
                "Onisigun",
                "Oretu",
                "Taiwo",
                "Adeosun",
                "Akobo",
                "Apapa",
                "Ògo",
                "Dabiri",
                "Idi Ose",
                "Idi-Iroko",
                "Kajorepo",
                "Kakun",
                "Lanibe",
                "Mokankan",
                "Olade",
                "Odogbo",
                "Ojoo",
                "Okeona",
                "Olomo",
                "Olugbode",
                "Onilabu",
                "Orogun",
                "Oyatola",
                "Sada",
                "Sasa",
                "Abatan",
                "Adifa",
                "Amosun",
                "Asania",
                "Idi Ori",
                "Ileba",
                "Ojerinde",
                "Olode",
                "Onidundu",
                "Onigbongbo",
                "Togiri",
                "Aba Osa",
                "Talotan",
                "Ayun",
                "Sokinloju",
                "Ojotegiri",
                "Ayunhun",
                "Apapa Odan",
                "Iya Ofa",
                "Baba Mogba",
                "Akande",
                "Idi Oro",
                "Ogungbe",
                "Eke Ola",
                "Onikange",
                "Bantuu",
                "Paade",
                "Obodaa",
                "Asipa",
                "Anisere",
                "Asani",
                "Ejitolu",
                "Elewintan",
                "Idi-Odan",
                "Mele",
                "Molarere",
                "Okegbemi",
                "Olorisaoko",
                "Oyodo"
            ],
            "Atiba": [
                "Atiba",
                "Aaatan",
                "Abolupe",
                "Afonja",
                "Agbaa",
                "Agbaakin",
                "Agbaka",
                "Agbalowo-Asa",
                "Agberinde",
                "Agunpopo",
                "Ajalaruru",
                "Ajegunle",
                "Ajikobi",
                "Akaparo",
                "Akinu",
                "Alaafin Palace",
                "Alubata",
                "Alusekere",
                "Are-Eromasanyin",
                "Aremo Area",
                "Asanminu",
                "Ashamu",
                "Ashipa",
                "Ayetoro",
                "Baago",
                "Balogun Maje",
                "Bangudu",
                "Basorun",
                "Ekesan",
                "Eleke",
                "Elerinle",
                "Elewi",
                "Gaa Bale Fulani",
                "Gbangba Taylor",
                "Gbanta",
                "Ijawaya",
                "Ikolaba",
                "Ile-Ewe",
                "Ilowagbade",
                "Ilusinmi",
                "Iyalamu",
                "Jowo Ese",
                "Keeto",
                "Koloko",
                "Koso",
                "Lagbondoko Area",
                "Latula",
                "Obagbori",
                "Ode Moje",
                "Ofa-Meta",
                "Ogbegbe",
                "Oke Oloola Area",
                "Oke-Afin Area",
                "Olokun Esin",
                "Olugbile",
                "Ona-Aka",
                "Onireko",
                "Onre Bare",
                "Oota",
                "Oridota",
                "Origbemidele",
                "Orokoroko",
                "Otefon",
                "Saakin",
                "Saamu",
                "Sabo",
                "Sangolokeke",
                "Sarumi",
                "St. Andrews Area",
                "Tak"
            ],
            "Atisbo": [
                "Ago-Are / Owo",
                "Aha / Tede",
                "Irawo / Ofiki",
                "Ago Are",
                "Agunrege",
                "Alaga",
                "Bashi Owo",
                "Corner Owo",
                "Ito",
                "Sabe",
                "Aha",
                "Tede",
                "Irawo",
                "Irawo Ile",
                "Irawotedo",
                "Kajewole",
                "Ofiki",
                "Owode"
            ],
            "Egbeda": [
                "Ayede / Alugbo",
                "Egbeda",
                "Erunmu",
                "Olodo / Kumapayi",
                "Osegere",
                "Owobaale / Kasumu",
                "Adeyadi",
                "Alagbo",
                "Buramo",
                "Fatade",
                "Fayo",
                "Koloko",
                "Abepe",
                "Adegbayi",
                "Adekola",
                "Adelabu",
                "Adogba",
                "Agbowo Village",
                "Agoro",
                "Ajia",
                "Ajule-Alagbaa",
                "Alakia",
                "Alarere",
                "Alarobo",
                "Apete",
                "Apoku",
                "Arolu",
                "Asaju",
                "Ayepe",
                "Bole Village",
                "Egbalekan",
                "Idi-Mango",
                "Jagun",
                "Koroboto",
                "Lamuregun",
                "Mapo-Egbeda",
                "Molade Ayedaade",
                "Mosafejo",
                "New Gbagi",
                "Nigeria Breweries",
                "Olo",
                "Olodi",
                "Olopo Metta",
                "Olorisaoko",
                "Olowo",
                "Oloya",
                "Olubadan Estate",
                "Olugbojo",
                "Onipepeye",
                "Onisade",
                "Oremeji",
                "Reji Sekere",
                "Sawmill",
                "Tanmo",
                "Adeleye",
                "Arije",
                "Afinti",
                "Ajiwogbo",
                "Akinlomo",
                "Aloba",
                "Ataari",
                "Gberinmi",
                "Jooda",
                "Kolayan",
                "Moje",
                "Olodan",
                "Olokeke",
                "Oloro",
                "Olosun",
                "Onibata",
                "Pagun",
                "Solowojaiye",
                "Aba Igbo",
                "Ajo",
                "Akinluwo",
                "Akorede",
                "Aloko",
                "Egbe",
                "Elesan",
                "Gbenku",
                "Idi Osan",
                "Jeriyin",
                "Kumapayi",
                "Maje",
                "Odan",
                "Ogaala",
                "Ogan-Ango",
                "Ojujinle",
                "Ojuolape",
                "Oki",
                "Oko",
                "Oko-Omi",
                "Olodo",
                "Olukunle",
                "Wakajaiye",
                "Wofun",
                "Awaye",
                "Awowo",
                "Erinmi",
                "Idogo",
                "Ilaro I & II",
                "Olumakun",
                "Alagbede",
                "Alaikola",
                "Apaso",
                "Efunwole",
                "Gidigidi",
                "Ibiti",
                "Kasumu",
                "Odode",
                "Ore I",
                "Ore II",
                "Owebaale",
                "Yati"
            ],
            "Ibadan North": [
                "Agodi",
                "Ibadan",
                "Mokola Hill",
                "Ward V N5b",
                "Ward VI N6a Part I",
                "Ward VII N6a Part Ii",
                "Ward VIII N6a Part Iii",
                "Ward X N6b Part Ii",
                "Agbowo",
                "Ajibode",
                "Bodija",
                "Eleyele",
                "Gate",
                "Ojoo",
                "Samonda",
                "Sango",
                "UI (University of Ibadan)"
            ],
            "Ibadan North-East": [
                "Ibadan",
                "Iwo Road",
                "Ward Xi E9 I",
                "Agodi",
                "Agugu",
                "Bashorun",
                "Idi-Ape",
                "Monatan",
                "Oje",
                "Oluwo",
                "Orita-Aperin",
                "Sawmill",
                "Total Garden"
            ],
            "Ibadan North-West": [
                "Dugbe",
                "Onireke",
                "Ayeye",
                "Inalnde",
                "Agbeni",
                "Eleyele",
                "Jericho",
                "Mokola",
                "Oke Ado",
                "Oke Bola",
                "Oritamerin",
                "Queen Cinema"
            ],
            "Ibadan South-East": [
                "Mapo Hall",
                "Aremo",
                "Beere",
                "Felele",
                "Ibuko",
                "Idi-Arere",
                "Oke-Ado",
                "Oke-Bola",
                "Oke-Odo",
                "Oke-Oluokun",
                "Oranyan",
                "Orita Aperin",
                "Orita-Merin",
                "Owode"
            ],
            "Ibadan South-West": [
                "Ring-Road",
                "Oke-Ado",
                "Oke-Bola Gege",
                "Born-Photo",
                "Agbeni",
                "Agodi",
                "Aleshinloye",
                "Aremo",
                "Bodija",
                "Iwo Road",
                "Jericho",
                "Oniyide",
                "Orita Challenge"
            ],
            "Ibarapa Central": [
                "Idere",
                "Igboora",
                "Abolanle",
                "Adeagbo",
                "Ajumobi",
                "Akeroro",
                "Alabi",
                "Alagba",
                "Araromi",
                "Arigbeyo",
                "Asipa",
                "Fidegbo",
                "Geke",
                "Igboleke",
                "Jato",
                "Sekere",
                "Eruwa",
                "Ido",
                "Iseyin",
                "Lanlate",
                "Okeho"
            ],
            "Ibarapa East": [
                "Eruwa",
                "Lanlate",
                "Abule Oba",
                "Abule Okie",
                "Abule-Osun",
                "Aderohunmui",
                "Afuye",
                "Agboti",
                "Ago-Ajaala",
                "Aiyegbede",
                "Alagbena",
                "Ameke",
                "Atanke",
                "Ayeno",
                "Baba Oke",
                "Baba-Elenutipala",
                "Bamigbose",
                "Dagilegbo",
                "Dagiloro",
                "Dawodu",
                "Dudoyemi",
                "Elepo",
                "Elukotun",
                "Gboru",
                "Ilo Ogundele",
                "Isaba Temidire",
                "Iseyin Villages",
                "Jagala",
                "Jankata",
                "Language",
                "Lawore",
                "Obadelu Hill",
                "Ogundele",
                "Okolo",
                "Olokenoji",
                "Olori",
                "Olorunda",
                "Oluwo",
                "Panu",
                "Sango",
                "Sango Odo",
                "Sangote",
                "Sobaloju",
                "Sunmirire",
                "Temidire-Idiope",
                "Alapa",
                "Igbodudu",
                "Itabo",
                "Ilado",
                "Elegun",
                "Are-Ago",
                "Owode",
                "Eran",
                "Aborisade",
                "Sikiti",
                "Panlati",
                "Opoogede",
                "Asako",
                "Maya",
                "Osoogun",
                "Egboolasa",
                "Gaadi",
                "Salako",
                "Aboya",
                "Akeete",
                "Lagaye",
                "Adegbola",
                "Ojonamo",
                "Atunwa",
                "Owaka",
                "Aga",
                "Oba",
                "Alaye",
                "Abule One",
                "Baba Magbe",
                "Age",
                "Majengbasan",
                "Lala",
                "Idowu Abidiosa",
                "Abule Ige",
                "Abidiosa",
                "Jagun",
                "Onibenbe",
                "Adeyemi",
                "Temidire",
                "Janata",
                "Jaleagbon",
                "Akinwunmi",
                "Abaapa",
                "Araromi",
                "Goke Saangi",
                "Danenu",
                "Ebinpejo",
                "Filakaka",
                "Igbolaja",
                "Aiyegunle",
                "Igboora",
                "Iroko",
                "Mekun",
                "Oke-Ode",
                "Olorunsogo",
                "Oni",
                "Ona Ara",
                "Orin"
            ],
            "Ibarapa North": [
                "Ayete",
                "Igangan",
                "Tapa",
                "AgunOjekunle",
                "Aiyete",
                "Ajelanwa",
                "Akowe",
                "Alagbaa",
                "Alapala",
                "Apagbo",
                "Elewure",
                "Gbodiko",
                "Gboko",
                "Iki",
                "Kajola",
                "Kajola Shipa",
                "Oba",
                "Ojekinde",
                "Okugba",
                "Onipede",
                "Opomu",
                "Tobalogun",
                "Ture Origi",
                "Ajegunle",
                "Akoya",
                "Asunnara",
                "Egbe Omo",
                "Elegbeda",
                "Idiope",
                "Olokete",
                "Owode",
                "Adeagbo",
                "Ahoro",
                "Alaparun",
                "Gbelckale",
                "Itumeta",
                "Kongo",
                "Oyee"
            ],
            "Ido": [
                "Aba Emo/Ilaju/Alako",
                "Akufo/Idigba/Araromi",
                "Akinware/Akindele",
                "Apete/Ayegun/Awotan",
                "Batake/Idi-Iya",
                "Erinwusi/Koguo/Odetola",
                "Fenwa/Oganla/Elenusonso",
                "Ido/Onikede/Okuna Awo",
                "Omi Adio/Omi Onigbagbo Bakatari",
                "Ogundele/Alaho/Siba/Idi-Ahun"
            ],
            "Irepo": [
                "Kishi",
                "Aawe",
                "Abanla Agunla",
                "Adagbangba",
                "Agunbebe",
                "Aiyekale",
                "Ajanaa",
                "Ajetowa",
                "Alagbon",
                "Alegongo",
                "Amuda Aro",
                "Apata",
                "Arogbe",
                "Atipa",
                "Ayifo",
                "Ayola",
                "Baale Ajila",
                "Baba Ilorin",
                "Barunganma",
                "Budo Ibadan",
                "Budo Abu",
                "Budo Ago",
                "Budo Aifo",
                "Budo Diedie",
                "Budo Fatowa",
                "Budo Gesi",
                "Budo Ibariba",
                "Budo Ido Akun",
                "Budo Igboho",
                "Budo Iseyi",
                "Budo Jagun",
                "Budo Kilani",
                "Budo Moradesa",
                "Budo Mujemi",
                "Budo Mushi",
                "Budo Nla",
                "Budo Sabi",
                "Budo Sule",
                "Budo Suru",
                "Budo Woru",
                "Elerin",
                "Gaa Adu",
                "Gaa Apata",
                "Gaa Asapa",
                "Gaa Baale",
                "Gaa Gudu",
                "Gaa Idi",
                "Gaa Kumosa",
                "Gaa Momodu",
                "Gaa Sanni",
                "Gaa Tunku",
                "Gaa Umoru",
                "Iba",
                "Ibudo Adeigba",
                "Ibudo Ado",
                "Igbo Elemi",
                "Igboroko",
                "Iyayoyin",
                "Joore",
                "Kishi Township",
                "Kumbi",
                "Laha",
                "Odo Igbo",
                "Ojetete",
                "Ojo Aro",
                "Oko Oba",
                "Olokoto",
                "Onipako",
                "Oniyo",
                "Osalakin",
                "Sangoleye",
                "Seibu",
                "Sise Olowo",
                "Tesi",
                "Tesi-Idi Ero",
                "Wole Wole",
                "Yakubu",
                "Yerepe"
            ],
            "Iseyin": [
                "Ado Awaye",
                "Iseyin",
                "Osogun",
                "Aagba",
                "Aba Nla",
                "Aba Tapa",
                "Abapan",
                "Abidioki",
                "Aboriso",
                "Abule Nla",
                "Abule Oloola",
                "Adeagbo",
                "Adegbola",
                "Adekola",
                "Adeniji",
                "Ado",
                "Ajagbeegun",
                "Akoda",
                "Aladere",
                "Aladura",
                "Alagbede",
                "Amolegbe",
                "Anko",
                "Atapa",
                "Atunwa",
                "Aweye",
                "Awolese",
                "Ayanbule",
                "Baba Sango",
                "Balogun",
                "Egbebi",
                "Elekule",
                "Elewele",
                "Elewuro",
                "Eleyele",
                "Esinjowo",
                "Ewetunde",
                "Ireso",
                "Iserin",
                "Joloko",
                "Maya Oke",
                "Oba",
                "Obanase",
                "Odo Ogun",
                "Ogbigbi",
                "Olose Onike",
                "Olukela",
                "Onire",
                "Samson",
                "Tabiti",
                "Wasinmi",
                "Aaba Titun",
                "Aba Ibadan",
                "Aba Sule",
                "Abugaga",
                "Abule Odo",
                "Adewuyi",
                "Adodo",
                "Afonja",
                "Ajagbadi",
                "Ajofin",
                "Ajokete",
                "Akan",
                "Alayan",
                "Alayin",
                "Aleshinloye",
                "Apata",
                "Apata Olodo",
                "Apenpe",
                "Asba Titun",
                "Asesu",
                "Asheru",
                "Baba Isale",
                "Balelayo",
                "Dokun",
                "Gboro",
                "Idi Emi",
                "Idi Igba",
                "Igbo Oloro",
                "Igbokandi",
                "Igbomara",
                "Igboro",
                "Igunrin",
                "Ikere",
                "Iseyin Township",
                "Itagbe",
                "Kajola",
                "Lokodu",
                "Odoomu",
                "Odooto",
                "Ogungbe",
                "Oke Edu",
                "Okese",
                "Olode",
                "Olode Olokosuru",
                "Olofin",
                "Olokolo",
                "Olokosun",
                "Olugbade",
                "Orita Merin",
                "Osantu",
                "Otiri Alagbado",
                "Pago",
                "Aba Agba",
                "Aba Paanu",
                "Adebisi",
                "Afoyasoro",
                "Agelu",
                "Ago Olosun",
                "Ahiyangan",
                "Ajiyo",
                "Akinlabi",
                "Akinwumi",
                "Akiti Ponpo",
                "Alapako",
                "Alaro",
                "Alawure",
                "Apapasana",
                "Araromi",
                "Ayantade",
                "Budo Agba",
                "Dananu",
                "Daripapa",
                "Epipi",
                "Fidayi Papa",
                "Goke Sago",
                "Igbodudu",
                "Jagun Sagbo",
                "Maya",
                "Odo Ogba",
                "Ogbo Ilasa",
                "Ogboolasa",
                "Ogodu I",
                "Ogodu II",
                "Ogundipe",
                "Oguntunji",
                "Olohunde",
                "Oloje",
                "Olose",
                "Onikaninkanin",
                "Owonitola",
                "Sagbo Ile",
                "Salami",
                "Sekelade",
                "Temidire"
            ],
            "Itesiwaju": [
                "Ipapo/Oke Amu",
                "Komu/Igbojaye",
                "Temidire Layout",
                "Abugaga",
                "Alagbede",
                "Amuda Egunsola",
                "Ariyo",
                "Aroje",
                "Ayodele",
                "Baba Sango",
                "Balelayo",
                "Elekuku",
                "Hagbe",
                "Igboro",
                "Ipapo",
                "Isemi",
                "Kasia",
                "Oke Amu",
                "Okebi",
                "Okose",
                "Onisau",
                "Owode",
                "Panla",
                "Aba Ogbomoso",
                "Adenle",
                "Adeta",
                "Agba",
                "Agbaruru",
                "Ago Fulani",
                "Ajibija",
                "Akinsapon",
                "Amaja",
                "Amosun",
                "Apo Wuku",
                "Arigidana Isale",
                "Arigidana Oke",
                "Arikuyeri",
                "Asaja",
                "Baba Ode",
                "Bale Agbe",
                "Ehito",
                "Gelede",
                "Igbojaye",
                "Ijasan",
                "Ilaji",
                "Kajola",
                "Komu",
                "Kujifi",
                "Monmon",
                "Ogodu",
                "Ojurepepe",
                "Olekete",
                "Olukotun",
                "Olunlade",
                "Omopupa",
                "Orisunbare",
                "Oroki",
                "Aba Paha",
                "Abidogun",
                "Ahere",
                "Alaga",
                "Apa Funwonleta",
                "Arogede",
                "Asaju Onileku",
                "Egbedoyin",
                "Okaka",
                "Onijokun",
                "Suberu"
            ],
            "Iwajowa": [
                "Aiyegun",
                "Idiko Ago",
                "Itasa",
                "Ayetoroile",
                "Idiko-Ile",
                "Iganna",
                "Ijio",
                "Ilaji Ile",
                "Iwere Ile",
                "Border Area",
                "Oha Village",
                "Wasinmi",
                "Aba Akinsapon",
                "Aba Ayetoro-Ile",
                "Aba Ifo Ere",
                "Aba Obelu",
                "Aba Oko Aje",
                "Aba Oloje",
                "Agbeji Village",
                "Alapa Village",
                "Asefisun Village I",
                "Asefisun village II",
                "Ayetoro Ile",
                "Dauda Village",
                "Ehinke",
                "Gaa Arole",
                "Gaa Arubiewe",
                "Gaa Atiku",
                "Gaa Saliu",
                "Gbedu Village",
                "Idiko-Ago",
                "Idogun Oko Oloti",
                "Igbole",
                "Iseni",
                "Keun II",
                "Madi Village",
                "Okan Village",
                "Oke Aba Village",
                "Ologbo",
                "Olopele",
                "Onipako Village",
                "Oyan",
                "Sabeleke",
                "Aba Jagba",
                "Aba Lamidi",
                "Alaidan",
                "Forekemi I",
                "Forekemi II",
                "Forekemi III",
                "Gaa Irete",
                "Igbo Ikun",
                "Igbo Olesin",
                "Igbo Olubi",
                "Igbodo",
                "Konkonbido",
                "LFI Farm Area",
                "Okola",
                "Omo Odo Oyinbo Village",
                "Igbo Eleeru",
                "Aba Aladura I",
                "Aba Alapinni",
                "Aba Arugbo Oto",
                "Aba Dabaru",
                "Aba Gbelekale",
                "Aba Makurdi",
                "Aba Okeho",
                "Aba Olokunola",
                "Aba Omodudu",
                "Aba Ontanyin",
                "Aba Soonsi",
                "Aba Tapa",
                "Abowoyagba",
                "Abule baba Isale",
                "Abule Lemomu",
                "Agba",
                "Agbaakin",
                "Agbegilori",
                "Ago",
                "Ajase",
                "Ajimati Village",
                "Akaparo Village",
                "Akinlabi",
                "Alokolodo Village",
                "Apaobe",
                "Apata Ibadan",
                "Arigbejo",
                "Arole Ikoko",
                "Ayede",
                "Baba Igbagbo Village",
                "Baba Mogba",
                "Balogun Ofeefun",
                "Basipa",
                "Budo Iseyin",
                "Dango",
                "Eeri",
                "Eesunla",
                "Efunwumi",
                "Eleeru",
                "Elekokan",
                "Fedegbo",
                "Idi Ose",
                "Idi Kasia",
                "Idi Oro",
                "Igbanna",
                "Igbo Ako",
                "Igbo Odan",
                "Igbo Odun",
                "Ikia",
                "Imode",
                "Inamere",
                "Isagbon",
                "Jagun Leeri",
                "Joloko",
                "Karimu",
                "Lapaho",
                "Mogoji",
                "Odedudu",
                "Ofeegun",
                "Ofiki",
                "Ogbu I",
                "Ogbu II",
                "Ogbua",
                "Ojapa",
                "Oke Ago",
                "Okesu",
                "Olomopupo",
                "Olorunda",
                "Olosan",
                "Olowokese",
                "Olukoti",
                "Onikoro",
                "Oobo",
                "Otubu",
                "Saaki",
                "Sonson",
                "Temidire",
                "Tudi",
                "Abafon",
                "Alajuba",
                "Alapa",
                "Baba Jugu",
                "Laafin",
                "Ohori",
                "Okooko",
                "Oloro",
                "Pele",
                "Samo",
                "Yellow",
                "Aaapa",
                "Aba Aladura II",
                "Aba Fulani",
                "Aba Iteku",
                "Aba Josiah",
                "Aba Ogunlade",
                "Alaje",
                "Apara",
                "Apinni",
                "Ede",
                "Eyinke",
                "Igbogaa",
                "Ilaji-Ile",
                "Itee I",
                "Itee II",
                "Ogbere I",
                "Ogbere II",
                "Ogbere III",
                "Oke-Oyan",
                "Oke-Itunu",
                "Osofa",
                "Osuuru",
                "Tubu",
                "Aba Baba Sango",
                "Aba Adeniran",
                "Aba Alado",
                "Aba Alaye",
                "Aba Ayoola",
                "Aba Baba",
                "Aba Bamikarere",
                "Aba Egbeda",
                "Aba Ele",
                "Aba Esudele",
                "Aba Ibadan I",
                "Aba Ibasun",
                "Aba Idi Igba",
                "Aba Igbo-Elewuro",
                "Aba Ilaji",
                "Aba Iseyin",
                "Aba Kobinu",
                "Aba Kokumo",
                "Aba Odo Dudu",
                "Aba Okoro",
                "Aba Onigilori/Adesina",
                "Aba Osi",
                "Aba Saminu Ladele",
                "Adesina",
                "Agbaruru",
                "Agbonla/Tafa Village",
                "Aiyetoro Ile",
                "Ajekigbe Village",
                "Akoda",
                "Alahji Aibina Vill.",
                "Alaraba Village",
                "Alugben",
                "Apakolo",
                "Apata",
                "Asipa",
                "Balu Village",
                "Eeye Village",
                "Egbedeyi",
                "Egideeye Village",
                "Elewuro",
                "Epo Village",
                "Falana",
                "Gaa Alhaji Dankaso",
                "Gaa Alhaji Diko",
                "Gaa Alhaji Gwani",
                "Gaa Gooro-Belu Village",
                "Gaa Idi-Igba",
                "Gaa Momodu",
                "Gaa Sanbo",
                "Gaa Sunmonu",
                "Galajimo",
                "Gbendeke",
                "Ibudo Oko Agbede",
                "Idi-Iroko",
                "Idi Ero Village",
                "Idogun",
                "Iwa",
                "Jalepi",
                "Kete",
                "Keun I Village",
                "Ogundeji",
                "Ogungbenle",
                "Ohori I Village",
                "Ohori II Village",
                "Oje Village",
                "Olomu",
                "Olurepepe",
                "Onigbongbo Village",
                "Owode",
                "Owure",
                "Sonyin",
                "Sooso I Village",
                "Sooso II Village",
                "Tafa Village",
                "Wayin"
            ],
            "Kajola": [
                "Ilero",
                "Isemi-Ile/Ilua",
                "Okeho",
                "Aaalago",
                "Aba Oloyinka",
                "Agbamo",
                "Agbede",
                "Agbeleje",
                "Ago Ipapo",
                "Ajala",
                "Akintegbe",
                "Alaje",
                "Alapola",
                "Alatori",
                "Alatori Ojo",
                "Alokoloja",
                "Amudago",
                "Arioje",
                "Atupo",
                "Ayetorokowosi",
                "Bale Ayito",
                "Egbeda",
                "Gbodogbodo",
                "Gbokoyi",
                "Gboro",
                "Idi Ayin",
                "Idi Isin",
                "Igbooopa",
                "Igborokodowo",
                "Igho Alubo",
                "Ighoopa",
                "Ilero Ago",
                "Isale Iwere",
                "Jagun Abese",
                "Labulo",
                "Molete",
                "Oguntaye",
                "Oko oba",
                "Olokobo",
                "Olope",
                "Olorunsogo",
                "Olowa",
                "Olukosi",
                "Olukotun",
                "Opopo Mawo",
                "Osin Ago",
                "Sangodokun",
                "Sobaloju",
                "Tofio",
                "Aaatan",
                "Aba Saria",
                "Abataibo",
                "Abisapa",
                "Agbamabiwon",
                "Agunfon",
                "Ajaji",
                "Ajipopo",
                "Akinlawon",
                "Alafefe",
                "Alusekere I and II",
                "Apaja",
                "Araromi",
                "Asinmolowo",
                "Asoore",
                "Ayomaya",
                "Babamogba",
                "Bale Oke Ogun",
                "Budo Alaga",
                "Egbeleka",
                "Ekuku",
                "Eletu",
                "Esinmu",
                "Gbelekale",
                "Gele Gele",
                "Gelede",
                "Idi Esu",
                "Idi Igba",
                "Idi Odan",
                "Idi Ooro",
                "Ifadamiduro Abiowo",
                "Igbo Alayin",
                "Igbo Asalu",
                "Igbo Baale",
                "Igbo bale",
                "Igbo Iroko",
                "Igbogaa",
                "Ile Ago",
                "Ilua",
                "Imia",
                "Imoba Ile",
                "Isanrin",
                "Isemi-Ile",
                "Jofoba",
                "Kangunmalo",
                "Kogoru",
                "Langbin",
                "Lanlosi",
                "Mamu Alamala",
                "Mogaji",
                "Motaku",
                "Ogbugudu",
                "Ogunlokeodo",
                "Ojete",
                "Oke Eru",
                "Oke Oge",
                "Okesado",
                "Okuta Epa",
                "Okuta Keyinkeyin",
                "Olaitan Adimu",
                "Ologbin",
                "Ologoji",
                "Olokoyo",
                "Olole Ile",
                "Onirokomeji",
                "Onitiri",
                "Oore",
                "Opoopo",
                "Sangolase",
                "Sannagi",
                "Sekere",
                "Yakoyo",
                "Okeho and Village"
            ],
            "Lagelu": [
                "Ejioku/Ile Igbon/Ariku",
                "Lagun/Aromona",
                "Lalupon/Iyana Offa",
                "Offa-Igbo",
                "Ogunremi/Ogunsina",
                "Olorunda/Monatan",
                "Oyedeji/Olode/Kutayi",
                "Sagbe/Pabiekun",
                "Aba Edun",
                "Aboke",
                "Ariku",
                "Ejioku",
                "Elegbada",
                "Elekuru",
                "Eleyan Igbo",
                "Fagbemi",
                "Idi Akitiko",
                "Idi Igba",
                "Idi Ogun",
                "Idi Ogun Omowale",
                "Ile Igbon",
                "Olodogboro",
                "Oloja Oke",
                "Onigbede",
                "Onigbodo",
                "Oyagaga",
                "Oyediran",
                "Aba Bale Olobo",
                "Aba Egan",
                "Akankan",
                "Aromona",
                "Bale-Oya",
                "Bolorunduro",
                "Lagun",
                "Laketu",
                "Lamuyan",
                "Ogburo",
                "Ogunjana",
                "Onilu",
                "Owode",
                "Aba lgbira",
                "Akinsawe",
                "Gidi Gidi",
                "Idi Osan",
                "Iyana Offa",
                "Jagun Egan",
                "Lalupon",
                "Molepin",
                "Odo Oba",
                "Papa Gegede",
                "Sukuru",
                "Aba Ogundipe",
                "Aba Oje",
                "Adedokun",
                "Ajimagbo",
                "Alawusa",
                "Balogun",
                "Dagi",
                "Elemu",
                "Ode Ote",
                "Offa Igbo",
                "Olokuta",
                "Wasimi",
                "Alatare",
                "Eleruko",
                "Ogunremi",
                "Ogunsina",
                "Ogunsowo",
                "Aba Alaropo",
                "Agoro",
                "Ajangboju",
                "Akobo",
                "Alapata",
                "Alegongo",
                "Arulogun",
                "Arun",
                "Asi",
                "Dosumu",
                "Elewuro",
                "Farinto",
                "Idi Araba",
                "Ijara",
                "Iyana Church",
                "Kasela",
                "Kelebe",
                "Leyland Area",
                "Monatan",
                "New Gbagi Market Area",
                "Olode",
                "Olodo",
                "Olorunda",
                "Olua",
                "Onikokoro",
                "Opeodu",
                "Aaje",
                "Aba",
                "Apatere",
                "Kufli",
                "Kutayi-Alapa",
                "Ogo",
                "Ogunbode",
                "Oyedeji",
                "Anifa",
                "Atiba",
                "Bangbola",
                "Farukan",
                "Isagede",
                "Kiremi",
                "Oteda",
                "Pabiekun",
                "Sagbe"
            ],
            "Ogbomosho North": [
                "Ahere Offa",
                "Imoji",
                "Ogbomosho",
                "Kinnira"
            ],
            "Ogbomosho South": [
                "Aarada Market Road",
                "Adeleke Sawmill",
                "Alapa",
                "Idiaraba-Abata",
                "Ogbomoso-Osogbo",
                "Oke Alapata",
                "Olope Marun",
                "Oyo - Ogbomoso"
            ],
            "Ogo Oluwa": [
                "Ogo Oluwa",
                "Ajaawa",
                "Ayede",
                "Ayetoro",
                "Idewure",
                "Iwo-Ate",
                "Lagbedu",
                "Odo-Oba",
                "Opete",
                "Otamokun"
            ],
            "Olorunsogo": [
                "Igbeti",
                "Abenu",
                "Abere-ijo",
                "Agbogangan",
                "Agbona",
                "Ageri",
                "Ago Fulani",
                "Alakuko",
                "Alapete",
                "Alawa",
                "Aloba-bi-oke",
                "Aloba-Ile",
                "Alusekere",
                "Apa-Odo Opa",
                "Asure-Ola",
                "Ayekale",
                "Binukonu",
                "Bosaro",
                "Bosere",
                "Budo-Igbo",
                "Edunjo",
                "Eleke-Elere",
                "Elekoto",
                "Elemere",
                "Elesin",
                "Ewuji-Asa",
                "Gaa Aliyu",
                "Gaa Dende",
                "Gaa Sangojinmi",
                "Gaa sidi",
                "Gaa Suberu",
                "Gasali",
                "Gboko",
                "Gida Lalere",
                "Godo-godo",
                "Idi Ogede",
                "Igbo Elemi",
                "Jabiolowu",
                "Jenkoro",
                "Jeunkunu",
                "Jokoro",
                "Karamo",
                "Kendoro",
                "Kosigi",
                "Lawoyin",
                "Ogbagba",
                "Okebode",
                "Olododo",
                "Olokoto-Iju",
                "Olorubaba",
                "Olowe",
                "Olupo",
                "Onigidudu",
                "Onipede",
                "Oniyeye",
                "Oro-Ola",
                "Osowuelegan",
                "Pankoko",
                "Tantomo",
                "Tesi baba pupa"
            ],
            "Oluyole": [
                "Orisunbare/Ojo-Ekun",
                "Onipe",
                "Olonde/Aba-Nla",
                "Olomi/Olurinde",
                "Okanhinde/Latunde",
                "Odo-Ona Nla",
                "Muslim/Ogbere",
                "Idi-Osan/Egbeda-Atuba",
                "Idi-Iroko/Ikereku",
                "Ayegun",
                "Aba-Ibeji",
                "Abanla",
                "Adebayo (CRIN)",
                "Alaho",
                "Alata",
                "Alomaja",
                "Argungu",
                "Busogbooro"
            ],
            "Ona Ara": [
                "Aba-Kuye",
                "Akanran",
                "Araromi",
                "Arinokuta",
                "Foworogun",
                "Idi–Ogun",
                "Elese–Erin",
                "Olosunde",
                "Ojebode",
                "Gbada–Efon"
            ],
            "Orelope": [
                "Igboho Township",
                "Igboho Villages",
                "Bonni",
                "Igbope",
                "Jakuta",
                "Modeke",
                "Obaago",
                "Oke Afin",
                "Oke Igboho",
                "Aba Woru",
                "Aba Yekini",
                "Abo Mango",
                "Aboni Ayo",
                "Abule Soro",
                "Adefi",
                "Adenko",
                "Adeta",
                "Afun",
                "Agunla",
                "Ahoro Adan",
                "Ajagba",
                "Akingbasa",
                "Alaba",
                "Alagbon",
                "Alaguntan",
                "Alahji Beliki",
                "Alarode",
                "Amoke",
                "Apata Alaje",
                "Asode",
                "Ate",
                "Baaru",
                "Baba Aladura",
                "Baba Ogudu",
                "Baba Pupa Yaaye",
                "Baba Sango",
                "Budo Idoro",
                "Budo Igbetti",
                "Budo Ilorin",
                "Budo Iya Wule",
                "Budo Nla",
                "Budo Olowo",
                "Budo Otun",
                "Budo Oyo",
                "Budo Sika",
                "Budo Sule",
                "Dede",
                "Dogo",
                "Dongari",
                "Eesomi",
                "Eleja",
                "Faruku",
                "Fomu",
                "Gaa Baba Pupa",
                "Gaa Lagbanda",
                "Gaa Lambuo",
                "Gaa Musa Fulani",
                "Gaa Peepee",
                "Gaa Yellow",
                "Gaa Yisa Fulani",
                "Gbadegun",
                "Gungumi",
                "Igbonla",
                "Jagun",
                "Jegede",
                "Kaabi",
                "Kajola",
                "Kansa",
                "Kujifi",
                "Kunbi",
                "Lasebu",
                "Loko",
                "Lube",
                "Odo Ogun",
                "Odo Oloko",
                "Odo Owo",
                "Odujin",
                "Ogbora",
                "Ogun Agbede",
                "Ogunniyi",
                "Oke Aran",
                "Oke Bukun",
                "Ologede",
                "Olomoba",
                "Olose",
                "Oluwoko",
                "Onigbaa",
                "Onile-Aro",
                "Onipako",
                "Onsile Oyo",
                "Opoo",
                "Ori Oke",
                "Salu I",
                "Salu II",
                "Sooro",
                "Yaaye Bunmi",
                "Yewere"
            ],
            "Ori Ire": [
                "Ikoyi-Ile",
                "Oolo",
                "Aba-Oba",
                "Aba-Oyo",
                "Abikehin",
                "Adesehin",
                "Agbalesun",
                "Agbelepo",
                "Ahere-Abata",
                "Ahoro Esinele Ogbomoso",
                "Ahoro Oko",
                "Ajombadi-Idiayin",
                "Alabidun",
                "Alagbayun",
                "Alagbede-Faji",
                "Alahusa",
                "Alakasu",
                "Alamola",
                "Alaropo Kekere",
                "Alokomanro",
                "Arohunpe",
                "Awaye",
                "Aweran Kale",
                "Baba Sale",
                "Balosa",
                "Bosa",
                "Bosunla",
                "Dananu",
                "Elegungun",
                "Elesu Adeosun",
                "Emi Abata",
                "Gbemiro",
                "Idi Emi",
                "Idiamu",
                "Igbo Alaye",
                "Ikolaba",
                "Ilekunkun",
                "Ipeba",
                "Isale-Oba",
                "Itamaya",
                "Koro",
                "Lapalapa",
                "Moleyo",
                "Mosunmade",
                "Moyin Moyin",
                "Odogbo",
                "Ogunniran",
                "Ojelabi",
                "Oke-Are",
                "Oke-Awoni",
                "Oke-Oba",
                "Okedoyin",
                "Okesubu",
                "Olojiji",
                "Olokemeji",
                "Olokiti",
                "Olomoleyin",
                "Olugbile",
                "Onalemole",
                "Onisakada",
                "Oolo and Villages",
                "Opeola",
                "Samo",
                "Sorotan",
                "Tapa",
                "Yawuyi",
                "Abaja",
                "Abeabaja",
                "Acute",
                "Afekulu",
                "Afun",
                "Afun Ile",
                "Afun-Iju",
                "Agbeni",
                "Agidi",
                "Ago Fulani",
                "Aiyetoro",
                "Ajegunle",
                "Ajegunle Gbola",
                "Ajibowu",
                "Ajinopa",
                "Akute",
                "Aladie-Ile",
                "Alagogo",
                "Alapamowo",
                "Alapere",
                "Alatori",
                "Alawodi",
                "Alayan",
                "Alfa Iwo",
                "Alugbede",
                "Aribaba",
                "Arigidana",
                "Arijo",
                "Arungboogbin",
                "Aselebe",
                "Atunkumi",
                "Baba Eko",
                "Berekodo Dongari",
                "Bootin",
                "Budo Adu",
                "Budo Akin",
                "Budo Alade Atu",
                "Budo Biyayin",
                "Budo Igbo",
                "Budo Musa",
                "Budo Ode",
                "Budo Ode Ajado",
                "Dogo Oke",
                "Egbejoda",
                "Elebe",
                "Elebenla",
                "Elega",
                "Elekulu",
                "Elelu",
                "Elemibo",
                "Elerufila Ile",
                "Elewure",
                "Fowomole",
                "Gaa Ahingba",
                "Gani Iju",
                "Gani Oja",
                "Gote",
                "Ibadi Ori",
                "Idi Apa",
                "Idi Eji",
                "Igbo Elemi",
                "Igbo Kekere",
                "Igbo Onito",
                "Igbo-Eleru",
                "Igboayin",
                "Igbona",
                "Igbori Ile",
                "Igboroko",
                "Ijana Yeye",
                "Ilutitun",
                "Ipata Oguri",
                "Jegede",
                "Keredolu",
                "Ketere",
                "Ketu",
                "Kojete",
                "Lahese",
                "Mesunmoje",
                "Mosadi Olorun",
                "Mosumoje",
                "Odesanwo",
                "Ojatitun",
                "Oke Bola",
                "Okodudu",
                "Olodan",
                "Oloje",
                "Olokoto-Iju",
                "Olomopupo",
                "Olopoto",
                "Olorulekan",
                "Olowo Iju",
                "Olowo Oko Boro",
                "Olugbejo",
                "Omidoyin",
                "Omo Erin",
                "Onigarawa",
                "Onigba",
                "Onigbin",
                "Oniguguru",
                "Onikaraun",
                "Onikolobo",
                "Onilali",
                "Onimangoro",
                "Ori Okuta",
                "Osarokun",
                "Osowuelegan",
                "Saako",
                "Sarayi",
                "Somodero",
                "Tewure Iju",
                "Tewure Ile",
                "Wusa",
                "Yakoyo"
            ],
            "Oyo East": [
                "Agboye/Molete",
                "Ajagba",
                "Alaodi/Modeke",
                "Apaara",
                "Apinni",
                "Jabata",
                "Oke Apo",
                "Oluajo",
                "Owode/Araromi"
            ],
            "Oyo West": [
                "Oyo Rural",
                "Oyo Villages",
                "Akeetan",
                "Ajokidero/Akewugberu",
                "Fasola/Soku",
                "Iseke",
                "Isokun I",
                "Isokun II",
                "Iyaji",
                "Opapa",
                "Pakoyi/Idode"
            ],
            "Saki East": [
                "Agbonle",
                "Ago Amodu",
                "Ogoro",
                "Oje-Owode",
                "Sepeteri",
                "Aba Alade",
                "Aba Daniel",
                "Aba Dika",
                "Aba Ilero",
                "Aba Kutuwenji",
                "Aba Laisi",
                "Aba Panu",
                "Aba Sango",
                "Aba Sidi",
                "Abakoko",
                "Adekoroku",
                "Adeseun",
                "Agbokeke",
                "Agbokele",
                "Agunla",
                "Alajuba",
                "Alasan",
                "Amukooko",
                "Apata",
                "Arikewuyo",
                "Aromole",
                "Babadele",
                "Bole",
                "Budo Apata",
                "Budo Ayedun",
                "Budo Lorin",
                "Dogo",
                "Egede",
                "Egunla",
                "Elepo",
                "Igbo Eleni",
                "Ijana",
                "Ikoko",
                "Ilado",
                "Kajola",
                "Kebiewu",
                "Laimo",
                "Laniyan",
                "Musa",
                "Odo Oba",
                "Oja Iya",
                "Okutalogun",
                "Olojola",
                "Olomometa",
                "Olugbemi",
                "Onikanga",
                "Onikosa",
                "Onise Oyo",
                "Osoko",
                "Saafu",
                "Saaka",
                "Yie",
                "Aba Obi",
                "Abuja",
                "Adaku",
                "Adeaga",
                "Adeduntan",
                "Agbagba",
                "Ajaku",
                "Alade",
                "Aladura",
                "Alakuko",
                "Alesinloye",
                "Apo",
                "Arogede",
                "Bada",
                "Balelayo",
                "Balogun",
                "Erin",
                "Ga Akani",
                "Ga Amuda",
                "Ikeeja",
                "Ipade",
                "Joseph",
                "Jowuro",
                "Koko",
                "Lukutu",
                "Makudi",
                "Mangoro",
                "Mayegun",
                "Ogunlere",
                "Old Oyo National Park",
                "Ololu",
                "Paanu",
                "Pele",
                "Sando",
                "Sango",
                "Tupuru",
                "Afa",
                "Ago",
                "Ajandoku",
                "Aketepe",
                "Alakia",
                "Alapo",
                "Alfa",
                "Amutiti",
                "Baba Abudu",
                "Basiru",
                "Budo Gomina",
                "Budo Kudoro",
                "Budo Nla",
                "Budo-Dele",
                "Elera",
                "Ikolaba",
                "Komi",
                "Kota I",
                "Kota II",
                "Lati",
                "Layipapa",
                "Mofowure",
                "Mogaji",
                "Mojidi",
                "Ogboro",
                "Oge",
                "Ojumokan",
                "Olosekan",
                "Paul",
                "Pius Simoni",
                "Sabata",
                "Sala",
                "Samari",
                "Yawale",
                "Yikiyiki",
                "Zakare",
                "Abu",
                "Alapata",
                "Budo Bank",
                "Budo musa",
                "Erinoti",
                "Ga",
                "Ga Adamu",
                "Ga Ake",
                "Ga Oke-Owu",
                "Ibilekan",
                "Maye",
                "Oje owode",
                "Tiv",
                "Yakuata",
                "Aba Dodo",
                "Aba Nla",
                "Adamu",
                "Agbago",
                "Agbedegun",
                "Aho",
                "Ajiromi",
                "Ajirowo",
                "Aloba",
                "Alota",
                "Amolese",
                "Awolere",
                "Baba Ajoke",
                "Baba Ijesa",
                "Baba Ilorin",
                "Bada Beji Makudi",
                "Bado Monmo",
                "Budo Akeem",
                "Budo Akewe",
                "Budo Karimu",
                "Budo Monday",
                "Dansafi",
                "Disu",
                "Eleja",
                "Godi",
                "Ikupola",
                "Imodi",
                "Iworu",
                "Iyake",
                "James",
                "Kanga",
                "Kewu-lere",
                "Kosobo",
                "Kujifi",
                "Mathew",
                "Ode Ajayi",
                "Odo-Owo",
                "Odogodo",
                "Ogunsipe",
                "Oke Odo",
                "Onisile",
                "Peter",
                "Soho",
                "Sule",
                "Tankari",
                "Temidire",
                "Welewele",
                "Yakubu",
                "Yellow Egede"
            ],
            "Saki West": [
                "Saki/Ekokan",
                "Aba Ilero",
                "Aba Iseyin",
                "Aba Ogbomosho",
                "Aba Seele",
                "Abatade",
                "Abawaye",
                "Agbele",
                "Ago Oluwabi",
                "Agunloye",
                "Aroje",
                "Asabari",
                "Ataye",
                "Barrack",
                "Bodilu",
                "Budo Eniola",
                "Budo Ige",
                "Ekokan",
                "Gaa Dogo",
                "Gbeponkan Oja",
                "Idera",
                "Idi Apa",
                "Idi Ayin",
                "Igaa Iyere",
                "Igbo Irawo",
                "Igbo Ologun",
                "Igbo Olosan",
                "Ilabo",
                "Ilua",
                "Kaje",
                "Kogijo",
                "Koomi",
                "Mojo",
                "Mua",
                "Oge",
                "Olomitutu",
                "Onigbongbo",
                "Orita Ogunmola",
                "Owode",
                "Saki Township",
                "Sanmisala",
                "Sekona",
                "Tagiri",
                "Tenleke",
                "Wasangere"
            ],
            "Surulere": [
                "Gambari/Baya",
                "Iresadu / Arolu",
                "Iwofin",
                "Oko",
                "Aba Kae",
                "Abewo",
                "Abogunde",
                "Abuduka",
                "Ajase",
                "Alate",
                "Aresejowi",
                "Asileke",
                "Baya Oje",
                "Biro",
                "Egbeda",
                "Gambari",
                "Gbede",
                "Igbon",
                "Iyelu",
                "Jabata",
                "Kangi",
                "Mumuni",
                "Olooye",
                "Oloya",
                "Paasi",
                "Patiko Oloya",
                "Adudu",
                "Aganyan",
                "Alagbede",
                "Alayin-Elebekebe",
                "Arolu",
                "Ayetoro",
                "Baasa",
                "Baba Egbe",
                "Elesinmeta",
                "Fasina",
                "Gbena",
                "Idi Opele",
                "Idi oro",
                "Idi-ori",
                "Igboile",
                "Ikle Odu",
                "Ikunsin",
                "Ilosin",
                "Iranyin",
                "Iregba",
                "Iregba Bankole",
                "Iresaapa",
                "Iresadu",
                "Kulodi",
                "Labanju",
                "Labode",
                "Lekewogbe",
                "Maya",
                "Ogala",
                "Ojo",
                "Okiti",
                "Olowosoke",
                "Olukosi",
                "Omonijuku",
                "Pooro",
                "Sadiwin",
                "Sapati",
                "Yakoyo",
                "Aba Araoye",
                "Ajegunle",
                "Alayin",
                "Bagbaji",
                "Budo Oni Eran",
                "Igbo-Ile",
                "Oke-Asaa",
                "Olorombo",
                "Onisa",
                "Oniyeya",
                "Opatoyin",
                "Owode",
                "Temidire",
                "Aagba Ijado",
                "Ajagunsi",
                "Aserawo",
                "Bale Oba",
                "Ebila-Temidire",
                "Ikolo",
                "Ilajue",
                "Ilogbo",
                "Ipasa",
                "Iware",
                "Laege",
                "Mayin",
                "Mumi",
                "Odanbon-Adare",
                "Ogede",
                "Okolo",
                "Onikeke",
                "Oosu",
                "Origi",
                "Owoaso",
                "Panda"
            ]
        }
    },
    {
        "Plateau": {
            "Barkin Ladi": [
                "Fan",
                "Foron",
                "Gashish",
                "Heipang",
                "Dafiyona",
                "Ndina Gura",
                "Ndina Rankassa",
                "Nding",
                "Nwok",
                "Rafan",
                "Rite",
                "Tafan",
                "Fo",
                "Kamang",
                "Kapwen",
                "Kapwis",
                "Ket",
                "Newo",
                "Nofok",
                "Rarung",
                "Rung",
                "Sho",
                "Zabot",
                "Exland",
                "Gindan-Akwati",
                "Kakuruk",
                "Kurra-Falls",
                "Kuzen",
                "Ruku",
                "Tenti Baba",
                "Zakerek",
                "Ban",
                "Chit",
                "Kpang",
                "Pomol",
                "Tagbam",
                "Tapo",
                "Tatu"
            ],
            "Bokkos": [
                "Bokkos",
                "Daffo",
                "Kamwai",
                "Manguna",
                "Mushere",
                "Richa",
                "Sha",
                "Toff",
                "Batun",
                "Bot",
                "Butura",
                "Forof",
                "Kop Mandarken",
                "Kuba/Maiyanga",
                "Mangar",
                "Mangor",
                "Mbar",
                "Tangur",
                "Tanti",
                "Tarongol",
                "Gada-Biyu",
                "Hottom",
                "Amban",
                "Kangil",
                "Tukyeh",
                "Chakfem",
                "Gwashesh",
                "Horop",
                "Kaban",
                "Kawel",
                "Manger",
                "Barkul",
                "Maboh",
                "Mista-Kuku",
                "Mundat",
                "Ambul"
            ],
            "Bassa": [
                "Bassa",
                "Daffo",
                "Dangi",
                "Gindiri",
                "Jebu",
                "Kwan",
                "Piti",
                "Piti Dogo",
                "Tajo",
                "Wom",
                "Zawan"
            ],
            "Jos East": [
                "Federe",
                "Fobur",
                "Fursum",
                "Maigemu",
                "Shere",
                "Damsun",
                "Dorong Babba",
                "Fardo",
                "Febas",
                "Fekolibing",
                "Fredk",
                "Gandi Bappa",
                "Gandi Shom",
                "Jarawa",
                "Keben",
                "Kogi",
                "Lamingel Tsafi",
                "Nabas",
                "Nakwang",
                "Risen/Geri",
                "S. Layi",
                "Yelwa Dorong",
                "Zandi",
                "Zazzi",
                "Zigam",
                "Adabok",
                "Awari",
                "Faraka",
                "Farin Yashi",
                "Foda Fobur",
                "Fogom",
                "Fulani",
                "Kerker",
                "Kwang 'A",
                "Laminga",
                "Nabatong",
                "Rizak",
                "Sabon Gari",
                "Woda",
                "Zarrazong",
                "Doss",
                "Fadan Fursum",
                "Foro Jarawa",
                "Fulanin Kabba",
                "Fusan Jarawa",
                "Gingin Karra",
                "Hardo Bello",
                "Hardp Rusa",
                "Hausawan Fusaa",
                "Hausawan Gora",
                "Kwanga",
                "Mai Ido Taro",
                "Maijuju",
                "Nakwon foron",
                "Naton Doss",
                "Niji",
                "Nitseng",
                "Tere",
                "Ungwan Awang",
                "Angwara",
                "Ardo Adamu",
                "Ardo Halilu",
                "Danehe",
                "Dankurma",
                "Duze",
                "Fadamdabo",
                "Federe Tudu",
                "Fefur",
                "Feram",
                "Fries",
                "Gurgu",
                "Gwadong",
                "Gwaji",
                "Jail",
                "Kasuwan Dada",
                "Lamingle",
                "Layarda",
                "Mu,un",
                "Nashanana",
                "Nuku",
                "Pa",
                "Rando",
                "Seradang Isafi",
                "Sjibiri",
                "Tudun Baro",
                "Zangam",
                "Chele",
                "Dabo",
                "Dayong",
                "Fesumuijng",
                "Fesumuing",
                "Gwashe",
                "Lurbi",
                "Sako",
                "Yelwa",
                "Zakin"
            ],
            "Jos North": [
                "Gwong",
                "Babale",
                "Dong",
                "Fudawa",
                "Furaka",
                "Gwafan",
                "Gwash",
                "Jos Jarawa",
                "Kabong",
                "Larantos",
                "Nabgar",
                "Nabor",
                "Nagohom",
                "Naraguta",
                "Nassarawa A",
                "Nupkis",
                "Rigiza",
                "Rusau",
                "T/Wada",
                "Targwong",
                "Zakaliyo",
                "Zangam",
                "Zangan"
            ],
            "Jos South": [
                "Du",
                "Gyel",
                "Kuru",
                "Vwang",
                "Anguldi",
                "Bek",
                "Challang",
                "Cham",
                "Chuel",
                "Dadop",
                "Dadura",
                "Dahwol",
                "Dahwol N'tong",
                "Dahwol Vvorok",
                "Dahwol-Dangwong",
                "Dati",
                "Dayah",
                "Diye-Du",
                "Dogo Na-Hauwa",
                "Dorowa Gindin Dutse",
                "Fwapwa",
                "Giring",
                "Got",
                "Hwolshe",
                "Kabong",
                "Kazong",
                "Kufang",
                "Kugiya",
                "Kwang",
                "Kwata",
                "Madu",
                "Mazaram",
                "Rabin Rahol",
                "Rahwol Kanag",
                "Rashonong",
                "Rawarak",
                "Rogatak",
                "Sabwak",
                "Shen",
                "T/Wada",
                "Timtim",
                "Viafyang",
                "Vyara",
                "Wawan",
                "Zawan",
                "Zek",
                "Zok",
                "Cafeng",
                "Gero",
                "Gura-Lando",
                "Gura-Riyom",
                "Kaxong",
                "Nyango",
                "Rafin Bauna",
                "Ran Gyel",
                "Rankyeng",
                "Ranta",
                "Rasot",
                "S/Gidan Ramar",
                "Tahel",
                "Takum",
                "Tanchol",
                "Yelwa",
                "Bakuanvwei",
                "Conservation",
                "Dahwul-Wat",
                "Daken",
                "Dancho-Kosho",
                "Danchol",
                "Dankarang",
                "Dawol",
                "Dazek",
                "Gakok (H. Jenta)",
                "Gatsen",
                "Hwak",
                "Kanadap",
                "Kumbuna",
                "Kuntei",
                "Kushe",
                "Ohol",
                "Police Staff College",
                "Sabon Pegi",
                "School",
                "Shwan",
                "Vwei",
                "Wat",
                "Zankong Soil",
                "Barikin Turu",
                "Changwi Tawo",
                "Chugwi",
                "Dagai",
                "Daggoshet",
                "Danchugwi",
                "Dandyes",
                "Fwil Vwang Kogot",
                "Gott",
                "Hwen",
                "Kaduna Vom",
                "Kogom",
                "Lo Ngeng",
                "Lo-Kun",
                "Rawuk",
                "Tunu Gozok",
                "Tura Chwe",
                "Turu Gweh",
                "Turu Lah"
            ],
            "Kanam": [
                "Dengi",
                "Garga",
                "Kanam",
                "Kantana",
                "Bagyar",
                "Bandiri",
                "Bankilong",
                "Basson",
                "Bwalangyip",
                "Dangi Town",
                "Gar-Duam",
                "Gumshir",
                "Guzuk",
                "Gwomgwom",
                "Jahun",
                "Kagyyal",
                "Kass",
                "Kunkyam",
                "Kwalkai",
                "Kyankurum",
                "Mabr",
                "Namaran",
                "Nan-Gar",
                "Yipmong",
                "Yugur",
                "Bayar",
                "Dadda",
                "Garga Mban",
                "Garga-Kufai",
                "Gyangyang-Garga",
                "Kukawa",
                "Kyansar",
                "Kyaram",
                "Munbutbo",
                "Yalwa",
                "Dal",
                "Dugub",
                "Gagdi",
                "Gidgid",
                "Gilong",
                "Gwarong",
                "Gyangyang",
                "Kam",
                "Mbat",
                "Mun-Galamkya",
                "Sallaman Kanam",
                "Zakkam",
                "Bawas",
                "Bribyang",
                "Ganjuwa",
                "Jarmai",
                "Jarmai Hausawa",
                "Jom",
                "Takwar",
                "Takzul",
                "Tukur",
                "Tunga",
                "Wakkat-Mulas",
                "Yanla (Wan)"
            ],
            "Kanke": [
                "Ampang-East",
                "Amper Chika 'A'",
                "Amper Chika 'B'",
                "Amper Seri",
                "Garram",
                "Kabwir Pada",
                "Kabwir/Gyangyang",
                "Langshi",
                "Nemel",
                "Dungung I",
                "Kagar",
                "Kuwang",
                "Kopging",
                "Kagu",
                "Wuye",
                "Sharam",
                "Mwel I",
                "Mwel II",
                "Dungung II",
                "Luwarang I",
                "Luwarang II",
                "Lampwai",
                "Kalashi",
                "Chika I",
                "Lerpye/Dibir",
                "Amnet",
                "Chika Ll",
                "Gugur",
                "Dangkang",
                "Mimyak",
                "Belbu",
                "Nyinnang",
                "Mban",
                "Jangjwat",
                "Lamba",
                "Ngolong Seri",
                "Golbong",
                "Gunji",
                "Kurrum",
                "Zong Shiwer",
                "Kalin",
                "Golkung",
                "Leptar",
                "Kaler",
                "Tollong",
                "Nyayit",
                "Leplek",
                "Dung",
                "Dung Popit",
                "Dangkem",
                "Piri-Tiplik",
                "Kabwir R. C. M",
                "Myelche",
                "Tuwan I",
                "Tuwan II",
                "Chikan",
                "Lur I",
                "Rong",
                "Lur II",
                "Gyangyang I",
                "Somji I",
                "Garyang",
                "Gomadaji",
                "Bolkon",
                "Longa",
                "Gyangyang II",
                "Somji II",
                "Bolkon II",
                "Langshi I",
                "Langshi II",
                "Munok",
                "Goktok",
                "Nekong"
            ],
            "Langtang North": [
                "Bwarat",
                "Gazum",
                "Langtang (Rural)",
                "Pil",
                "Angwan - gani",
                "Angwan Marafa",
                "Angwan Yari",
                "Binding",
                "Dangyil",
                "Ganjglang",
                "Gindim",
                "Gunnunu",
                "Kaplak",
                "Kurgwan",
                "Kynjit",
                "Laka",
                "Lawur",
                "Mai Bangyel",
                "Pishe",
                "Yakot",
                "Zamadede",
                "Zamgwar",
                "Ang. Pada",
                "Bali",
                "Bankun",
                "Bapkwai",
                "Batkilang",
                "Danga",
                "Danglong",
                "Dingjor",
                "Durgu",
                "Gazaam",
                "Gian - Gazadima",
                "Gwandamung",
                "Ibim",
                "Jidadi",
                "Kalapi",
                "Kandim",
                "Kangtang",
                "Kongnkog",
                "Kuffen",
                "Kukwar",
                "Kuyim",
                "Lazhan",
                "Lifir",
                "Lipchok",
                "Lop",
                "Mabe",
                "Mankot",
                "Mantamtam",
                "Mban",
                "Mindim",
                "Nassarawa",
                "Ndinzhan",
                "Ngura",
                "Ngwak",
                "Nowar",
                "Nwur",
                "Ntorok",
                "Nyattang",
                "Nyer",
                "Nyer - Jarak",
                "Nyer - Ponzhi",
                "Padur",
                "Pajat",
                "Pangna",
                "Pock",
                "Pyar",
                "Pyache",
                "Pyayil",
                "Rimi",
                "Sabon - Layi",
                "Shiber",
                "Shifor",
                "Shikal",
                "Shishiri",
                "Tabat",
                "Tahfa",
                "Talbul",
                "Tarok",
                "Tongtong",
                "Wallang",
                "Yal",
                "Zambur",
                "Zamchan",
                "Zamko",
                "Zamkumkum",
                "Zanzat",
                "Zhantani",
                "Ang. Chiroma",
                "Ang. Galadima",
                "Dabgyil",
                "Danbur",
                "Dibbar",
                "Fujul",
                "Funyallany",
                "Gabong",
                "Gantang",
                "Igbar",
                "Jwakber",
                "Kumkaka",
                "Kumkwar",
                "Kwallak",
                "Langan",
                "Langbap",
                "Pang",
                "Panmyam",
                "Wallyat",
                "Waroh",
                "Warrang",
                "Zambaraki",
                "Bangkur",
                "Biller",
                "Chikwak",
                "Dabur",
                "Dangre",
                "Fillap",
                "Kankur",
                "Kensong",
                "Kpadiar",
                "Kumkwam",
                "Kwampe",
                "Limum",
                "Lohmak",
                "Luwki",
                "Miyam-Shiko",
                "Myam",
                "Nachang",
                "Nyapkai",
                "Pagwam",
                "Pakuk",
                "Pang-myer",
                "Reak",
                "Shiyik",
                "Tippang",
                "Tiuam",
                "Tunkun",
                "Wacha",
                "Zambau-Bwarat",
                "Zambau-Diyan"
            ],
            "Langtang South": [
                "Dadin Kowa",
                "Fajul",
                "Gamakai",
                "Lashel",
                "Resettlement Area",
                "Sabon Gida",
                "Timbol",
                "Turaki",
                "Daruwa",
                "Kanana",
                "Mahanga",
                "Barracks",
                "Bolya",
                "Karkashi",
                "Long-Goemai",
                "Magama",
                "Nassawa",
                "Timshat",
                "Gamin",
                "Koko",
                "Kwaikon",
                "Mailfour",
                "Dandinkowa",
                "Faya",
                "Gbaldung",
                "Gida Bua",
                "Kamkun",
                "Mabudi",
                "Magama Mangwam",
                "Maiyanga",
                "Milfoar",
                "Ndushim",
                "Soban Gida nagani",
                "Takalafiya",
                "Taldun",
                "Talgwang",
                "Zamya",
                "Kamkum",
                "Taigwang",
                "Timfam",
                "Dinshan",
                "Takakafia",
                "Timman",
                "Nakiwasw",
                "Lamdwal",
                "Walnim",
                "Wubang",
                "Zambang"
            ],
            "Mangu": [
                "Gindiri",
                "Jipal",
                "Kerang",
                "Kumbul",
                "Langai",
                "Mangu",
                "Panyam",
                "Vodni",
                "Bwonpe",
                "Garkun",
                "Kambring",
                "Kopshir",
                "Puka",
                "Pushit",
                "Telengpat",
                "Daika",
                "Kombili",
                "Kopal",
                "Nyes",
                "Bunga",
                "Chakfem",
                "Kantoma",
                "Mairana",
                "Mangu Halle",
                "Sabon Gari",
                "Babban Rinji",
                "Kadunun",
                "Bwai",
                "Dari",
                "Ampang",
                "Sabon Kerang",
                "Kaper",
                "Katual",
                "Kundun",
                "Zuwahai",
                "Chanso",
                "Cinbun",
                "Janaret",
                "Kasuwan Ali"
            ],
            "Mikang": [
                "Garkawa",
                "Koeneom",
                "Montol",
                "Paipung",
                "Gingim",
                "Jimakwi",
                "Killa",
                "Kongnati",
                "Lahil",
                "Longgkrom",
                "Poensong",
                "Rotha",
                "Swoshal",
                "Tundun Wada",
                "Yakoep",
                "Lifidi",
                "Lun-Niyu (Lifin)",
                "Nwoop",
                "Pangshot",
                "Pangsot",
                "Zomo",
                "Baltep",
                "Betkang",
                "Dinmuanpus",
                "Laham",
                "Lalin",
                "Pockot",
                "Pocyuum",
                "Swakan",
                "Talme",
                "Tunkus",
                "Gotlong",
                "Koetes",
                "Longbis",
                "Pangjiem",
                "Piaber",
                "Piapung",
                "Poekot",
                "Tangguk",
                "Zamkoekop"
            ],
            "Pankshin": [
                "Chip",
                "Fier",
                "Kadung",
                "Lankan",
                "Pankshin (Rural)",
                "Wokkos",
                "Buttal",
                "Dakup",
                "Dang",
                "Dikkal",
                "Fwenzuk",
                "Gille",
                "Iskep",
                "Jimat",
                "Kwalla",
                "Lepbwai",
                "Mantom",
                "Tazuk",
                "Ballang Lep",
                "Ballang-Shippang",
                "Barche",
                "Beinin",
                "Berek",
                "Bumning",
                "Bwarak",
                "Chigwong",
                "Chikan",
                "Ciroma-Shippang",
                "Dene",
                "Dereng",
                "Duk",
                "Dungyle",
                "Galadima Lep",
                "Gromamep",
                "Gun",
                "Hikumuran",
                "Jang",
                "Kanyi",
                "Kapang",
                "Katke (Tanglat)",
                "Kazuk",
                "Kobi",
                "Kop",
                "Koploki",
                "Kor",
                "Kudol",
                "Kulukning",
                "Kuwang-Fung",
                "Labwor",
                "Lagor",
                "Landan",
                "Lishan",
                "Ma Aji Vel",
                "Magyil",
                "Manget",
                "Miller",
                "Ngolong",
                "Pangpel",
                "Pankshin",
                "Pankshin (Ner)",
                "Shippang",
                "Sum",
                "Tambes",
                "Taying",
                "Tubong",
                "Tukung",
                "Tulwar",
                "Wulmi",
                "Wuseli",
                "Akong",
                "Amnat",
                "Adeng",
                "Asa",
                "Chinkat",
                "Changgash",
                "Dyis/Abwor",
                "Genye",
                "Ghibang",
                "Gutong",
                "Ghuza Jiblik",
                "Jak",
                "Jing",
                "Kagu",
                "Kap",
                "Labyom",
                "Lander",
                "Lungchan",
                "Mosan",
                "Ninkut",
                "Nungwus",
                "Parkat",
                "Permangous",
                "Sihin",
                "Tangfom",
                "Tinkum",
                "Zundun",
                "Chiroma",
                "Chrus",
                "Jivir",
                "Pada",
                "Panzam",
                "Saikn-Gurrup",
                "Sarkin Burum",
                "Gwabi Nyelleng",
                "Kadyis",
                "Mier",
                "Mile",
                "Mudel",
                "Nyelleng",
                "Takkas",
                "Angwan-Hausawa",
                "Bakwar",
                "Bongmut",
                "Daboshu",
                "Dimwai",
                "Dungwu",
                "Jepmidiyel",
                "Jepmijit",
                "Jikon",
                "Kangmum",
                "Karam",
                "Khipil",
                "Kwalah",
                "Longkamt",
                "Mingkohot",
                "Minting",
                "Mudung",
                "Pabower",
                "Pikongship",
                "Tanglant"
            ],
            "Qua'an Pan": [
                "Bwall",
                "Doemak",
                "Dokan Kasuwa",
                "Kwal (Koffar)",
                "Kwalla",
                "Kwande",
                "Kwang",
                "Namu",
                "Janta",
                "Kayarda",
                "Kwari",
                "Lankaku",
                "Njak",
                "Pandam",
                "Shindai",
                "Fujing",
                "Kwang Dala",
                "La'ar",
                "Ampap",
                "Bakin Ciyawa",
                "Giddan Dabat",
                "Kurgwi",
                "Turniang",
                "Chim",
                "Goeba'an",
                "Goepin",
                "Kofogom",
                "Kopboetpang",
                "Kopwarmak",
                "Kwaggar",
                "Muda",
                "Shangful'up",
                "Yadin",
                "Yitlas'ar",
                "Boglong",
                "Koffiar",
                "Kongde",
                "Lardang",
                "Lumuat",
                "Miket",
                "Dungnocgoch",
                "Komkwas",
                "Kopgoewam",
                "Kwanoeng",
                "Lagurut",
                "Yilpia",
                "Bong",
                "Dang toe geom.",
                "Dimmuk",
                "Geobout",
                "Geochim",
                "Kangwe",
                "Kangyl",
                "Katoon",
                "Latok",
                "Bwal Goechim",
                "Bwal Goepil",
                "Bwal Nakum"
            ],
            "Riyom": [
                "Jal",
                "Riyom",
                "Bum",
                "Danto",
                "Dantse",
                "Danwal",
                "Fangroi",
                "Gura",
                "Koroda",
                "Kwakhwi",
                "Gol",
                "Jol",
                "Kwi",
                "Ra-Hoss",
                "Rim",
                "Ta-Hoss"
            ],
            "Shendam": [
                "Dakan Tofa",
                "Derpeng",
                "Dorok",
                "Shendam",
                "Ajikamai",
                "Bakin Kogi",
                "Derlit",
                "Dungba",
                "Garas",
                "Gidan-Adamu",
                "Ilalong",
                "Kato",
                "Kuru wat",
                "Kuruh Lagai",
                "Kwaphur",
                "Kwapkuwa",
                "Lakushi",
                "Lavaba",
                "Lon goebou",
                "Longvel",
                "Naburuk",
                "Nball",
                "Nbet",
                "Nder",
                "Nshar",
                "Ntuer",
                "Pangshom",
                "Peoshie",
                "Poediel",
                "Rajiyam Giwa",
                "Shanlang",
                "Shepwan",
                "Shunkwan",
                "Sohlut",
                "Soklut",
                "Tangzeb",
                "Tinhan",
                "Tsovo",
                "Tukum",
                "Tumbi",
                "Turdung Doruwa",
                "Yamini",
                "Yelwa",
                "Biembiem",
                "Demshim",
                "Goesm",
                "Gonvel",
                "Haambangkalong",
                "Kuka",
                "Makera",
                "Moekat",
                "Namass",
                "Nda-yak",
                "Ngwazam",
                "Pape",
                "Shimankar",
                "Ungwan Dadi",
                "Ungwan Rina",
                "Bunoegwang",
                "Dualak",
                "Duankwan",
                "Dung-Goeshing",
                "Gaklang",
                "Hambiaka",
                "Jayu",
                "Kendeng",
                "Lurka",
                "Nyak",
                "Tsa kani",
                "Tunwanghem",
                "Katai",
                "Kirgagan",
                "Met",
                "Nanes",
                "Ngaj",
                "Tak Doka",
                "Tengnadung"
            ],
            "Wase": [
                "Bashar",
                "Kadarko",
                "Lamba",
                "Wase Town",
                "Gaji Bashar",
                "Gingir",
                "Gudu",
                "Kanpani",
                "Madaci",
                "Nyalun",
                "Sabon-Layi",
                "Safiyo",
                "Yuli",
                "Zurak",
                "Bakin-Rijiya",
                "Danshanya",
                "Dogon-Ruwa",
                "Garga",
                "Gimbi",
                "Glakwai",
                "Gwuman-Kogi",
                "Jauri",
                "Jigawan-Audu",
                "Kumboug",
                "Mavo",
                "Pinou",
                "Ruwan Goggo",
                "Team",
                "Tsamiya",
                "Anguwan-Clar",
                "Damau",
                "Gumshar",
                "Nakibulala",
                "Nassarawa",
                "Pako",
                "Salawai",
                "Talafiya",
                "Wase Tofa",
                "Ang. Garkuwa",
                "Ang. Kuyambana",
                "Ang. Makaki",
                "Ang. Sayawa",
                "Angwan",
                "Rugan Jodi",
                "Zamburun"
            ]
        }
    },
    {
        "Rivers": {
            "Abua–Odual": [
                "Abua/Odual",
                "Abada",
                "Abual",
                "Agada",
                "Akani",
                "Amalem",
                "Amaraka",
                "Amorota",
                "Aniningboko",
                "Anyu",
                "Arukwo",
                "Dibiriga",
                "Efebiri",
                "Egboama",
                "Egbolom",
                "Egbom",
                "Egunughan",
                "Ekunuga",
                "Elok",
                "Emago",
                "Emeh",
                "Emekesue",
                "Emelego",
                "Emesu",
                "Emilaghan",
                "Emirikpoko",
                "Emon-Ema Emabu",
                "Engeni",
                "Esala",
                "Esidia-Ogbema",
                "Forest-Reserve",
                "Iyak",
                "Kola-Ogbogbo",
                "Lower Orashi River",
                "Obaranyi",
                "Odaga",
                "Odedum",
                "Ogbema",
                "Ogbema Koku",
                "Ogbokuma",
                "Ogbologbo Plantain",
                "Ogboloma",
                "Oghora",
                "Okana",
                "Okoboh",
                "Okomade",
                "Okpedem",
                "Omokwa",
                "Opikiri",
                "Opu-Ogbogbo",
                "Oruama",
                "Otabha",
                "Otari",
                "Owerewere",
                "Plantains",
                "Serebia"
            ],
            "Ahoada East": [
                "Ahoada",
                "Abarikpo",
                "Akoh",
                "Ala-Ahoada",
                "Anakpa",
                "Ebiriba/Ikodi",
                "Ebiro",
                "Edeeha",
                "Edeoha",
                "Ekpene",
                "Idoki",
                "Idu-Obosiuku",
                "Idu-Osobile",
                "Igbuduya",
                "Ihuaba",
                "Ihugboko",
                "Ihuowo",
                "Ijuaje",
                "Ikata",
                "Joinkprama",
                "Kunusha",
                "Membe",
                "Oboh",
                "Obolobolo",
                "Obumeze",
                "Ochigba",
                "Odawu",
                "Odereke",
                "Odiabidi",
                "Odido",
                "Odiemudie",
                "Odiemusana",
                "Odierenguroji",
                "Odiokwu",
                "Ododi",
                "Ogbede",
                "Ogbelle",
                "Ogbo",
                "Ogoda",
                "Ogua-Akmima",
                "Ohigbo",
                "Okarki",
                "Okebe",
                "Okpoga-Ulo-Udo",
                "Okponmini",
                "Oluokobo",
                "Oporowo",
                "Orija",
                "Orupata",
                "Oshi",
                "Oshiebele",
                "Oshugboko",
                "Oyiba I & II",
                "Ozachi",
                "Ubarama",
                "Ubio",
                "Ukerede",
                "Upata"
            ],
            "Ahoada West": [
                "Agbo/Akogbologba",
                "Akaramirin",
                "Akinima",
                "Anwurugbokor",
                "Better Land",
                "Edugberi",
                "Emezi",
                "Ibrass",
                "Igoria",
                "Ihuechi",
                "Isua",
                "Isusa",
                "Mbiama",
                "Odiapiti",
                "Odieke",
                "Okolobiama",
                "Okparaki",
                "Oruama",
                "Oshika",
                "Ubeta",
                "Ubie",
                "Upatabo",
                "Uyalama"
            ],
            "Akuku Toru": [
                "Akuru Toru",
                "Abissa",
                "Abonnema",
                "Elem Sangama",
                "Idama",
                "Kula",
                "Obonoma",
                "Oru-Sangama",
                "Soku"
            ],
            "Andoni": [
                "Andoni",
                "Aam-Ekut",
                "Aama-Runner",
                "Afradiki",
                "Aganna",
                "Aganofor",
                "Agbachichama",
                "Agbadama",
                "Agbadem",
                "Agbakoroma",
                "Agwut Obolo",
                "Ama Sunday",
                "Amanku",
                "Amansa",
                "Amaoke",
                "Amatamuno",
                "Anyama",
                "Anyama-Aganna",
                "Anyamaboko",
                "Asakokola",
                "Asakokolo",
                "Asarama",
                "Asuk-Ama",
                "Asuk-Oyet",
                "Asurubaa",
                "Ataba",
                "Aturube",
                "Ayama",
                "Darile",
                "Dema",
                "Dimama",
                "Ebon-Okolo",
                "Ebuguma",
                "Echitcham",
                "Egbomu",
                "Egbormu",
                "Egwede",
                "Ekede",
                "Friday",
                "Glilea",
                "Ilotombi",
                "Ibotobom",
                "Ibotokpon",
                "Ichama",
                "Igbanga",
                "Ikuru",
                "Inyoukpo",
                "Isidum",
                "Isioke",
                "Isiokwan",
                "Iwo",
                "Iwoogone",
                "Kapamant",
                "Kwake",
                "Mertege",
                "Muma",
                "Nchiama",
                "Ngo",
                "Obiama",
                "Obot-Usut",
                "Obukolum",
                "Ogbidim",
                "Okokiri",
                "Okoro Iro",
                "Okoroboile",
                "Okorolo",
                "Okukpoi",
                "Okwaniok",
                "Oloma",
                "Otak",
                "Otiga",
                "Otuafik",
                "Otudon",
                "Otugan",
                "Oyorokoto",
                "Samanga",
                "Uyeada",
                "Uyengala",
                "Weret"
            ],
            "Asari-Toru": [
                "Buguma",
                "Abalama",
                "Aluka",
                "Angulama",
                "Apama",
                "Bekinkiri",
                "Dagogakiri",
                "Ebuye-Dokubekiri",
                "Gogokiti",
                "Ido",
                "Ifoko",
                "Isia",
                "Kalama",
                "Krakrama",
                "Minama",
                "Pakama",
                "Munguma-ama",
                "Iyala-ama",
                "Ojiama",
                "Ojima",
                "Okpo /Idema",
                "Omekwe",
                "Operoma",
                "Omekwe-Tariama",
                "Owoko",
                "Sama",
                "Sama-Naguakiri",
                "Sangama",
                "Tema"
            ],
            "Bonny": [
                "Adamakiri",
                "Agbala",
                "Akpakpasu",
                "Alaasiakiri",
                "Amanadama",
                "Angalabie",
                "Asaramatoru",
                "Atabakiri",
                "Bartholomy",
                "Beregade",
                "Biemekiri",
                "Bilemekiri",
                "Binye",
                "Birayekiri",
                "Boloba",
                "Bony-Onwon",
                "Charuama",
                "Crutoru",
                "Dokubotorughia",
                "Eferewari",
                "Fakpa",
                "Febiri",
                "Gbolokiri",
                "Georgekiri",
                "Green",
                "Greenkiri",
                "Ibiribiri",
                "Ijanikwe",
                "Inawanacha",
                "Iwoama",
                "Iwoama-Kuruama",
                "Jackmay",
                "Kalabiama",
                "Kuruama",
                "Kuruma",
                "Ligakiri",
                "Magbegbekiri",
                "Mbikiri",
                "Mbisu",
                "Namabie",
                "Nenekin",
                "Nwachu",
                "Obetene",
                "Ogbomumo",
                "Ogbuluama",
                "Ogidigba",
                "Ogumabie",
                "Okolobie",
                "Okoloma-Iwoma",
                "Okolomable",
                "Okpomadapa",
                "Oloma",
                "Olomabia",
                "Omubiokolo",
                "Onwonwokiri",
                "Opiriafan",
                "Opo",
                "Oporbakiri",
                "Opukiri",
                "Orutoru",
                "Otokolomabie",
                "Otukpo",
                "Otutunbi",
                "Owaopiri",
                "Owuopili",
                "Perside",
                "Pondomakiri",
                "Samai",
                "Samgama",
                "Sampite",
                "Sombiekiri",
                "Tumbikulu",
                "Wasakiri",
                "Wastom"
            ],
            "Degema": [
                "Bille",
                "Bakana",
                "Bukuma",
                "Consulale",
                "Elem Ama",
                "Ke",
                "Obuama",
                "Old Bakana",
                "Tombia",
                "Usokun"
            ],
            "Eleme": [
                "Acharama",
                "Adama",
                "Agbonchia",
                "Agbeta",
                "Agbi",
                "Akara",
                "Akaraolu",
                "Akpajo",
                "Akpakpan",
                "Alejor",
                "Alesa",
                "Aleto",
                "Alode",
                "Aluakpajo",
                "Alualesa",
                "Alubeokpa",
                "Aluebo",
                "Aluejor",
                "Alueken",
                "Aluoken",
                "Alungwa",
                "Awalama",
                "Chumu",
                "Chittey",
                "Ebubu",
                "Echaapere",
                "Efere",
                "Egbalor",
                "Egbara",
                "Ejamah",
                "Ejialejor",
                "Ejii",
                "Ekara",
                "Ekenkua",
                "Eken-ogban",
                "Ekongor",
                "Ekorokoro",
                "Ekornwi",
                "Ekpangbala",
                "Ekporo",
                "Eta-bai",
                "Eteo",
                "Ewika",
                "Ewuu",
                "Eyaa",
                "Makani",
                "Mao",
                "Mbuma-eta",
                "Nchia-Eleme",
                "Nda",
                "Ngejalawa",
                "Ngala",
                "Ngelale",
                "Ngesia",
                "Ngofa",
                "Ngololo",
                "Njuru",
                "Nkpaala",
                "Nkpornwi",
                "Nkeleoken",
                "Nnonoa-eta",
                "Nsin-akukuri",
                "Nsisioken",
                "Nwaja",
                "Nwaji",
                "Nyime-eta",
                "Obiban",
                "Obini-eta",
                "Obini-ngwa",
                "Obini-nkikee",
                "Obolo",
                "Ochani",
                "Odaranmu",
                "Odido-Eleme",
                "Ogale",
                "Ogoloma",
                "Ogologbaa",
                "Oka-ebem",
                "Oken-eta",
                "Okerewa",
                "Okole",
                "Okori",
                "Okpa",
                "Okpako",
                "Oku",
                "Ollorte",
                "Onne",
                "Onimbie",
                "Onura",
                "Oya",
                "Panya",
                "Tekara"
            ],
            "Emohua": [
                "Emohua",
                "Agbandele",
                "Ahi Ogbakiri",
                "Ahia Wokoma",
                "Akpabu",
                "Amapa",
                "Bundele",
                "Chio",
                "Chiwokanwere",
                "Egamini",
                "Egbeda",
                "Egbelu",
                "Ehio",
                "Ehioprada",
                "Ekunchara",
                "Elele Alimni",
                "Ereku",
                "Eza-Nkpokwu",
                "Hiamali",
                "Ibaa",
                "Ibomimere",
                "Ikungachinwo",
                "Imere",
                "Isiodu",
                "Itu",
                "Izuoya",
                "Mbuama",
                "Mbuegizi",
                "Mechiemechi",
                "Mgbu Ehinmi",
                "Mgbu Igobo",
                "Mgbu Ika",
                "Mgbu Ogbakiri",
                "Mgbuajah",
                "Mgbuakni",
                "Mgbuateta",
                "Mgbuayim",
                "Mgbuealalu",
                "Mgbuedah",
                "Mgbuelia",
                "Mgbuemnubade",
                "Mgbueto",
                "Mgbuikor",
                "Mgbuitanwos",
                "Mgbuogbakiri",
                "Mgbuohia",
                "Mgbuokporo",
                "Mgbuomohia",
                "Mgbuwoke",
                "Ndele",
                "Ngbere",
                "Ngbereka",
                "Ngbuobogizi",
                "Nkpob",
                "Nmehielle",
                "Obelle",
                "Oboh",
                "Obugner-Unimini",
                "Ubimini",
                "Odegu",
                "Odoha",
                "Ogbakiri",
                "Ogbelegba",
                "Ogbola",
                "Ohamyim",
                "Ohioomuigwuemi",
                "Oluonugbuda",
                "Omaibo",
                "Omeke",
                "Omeneta",
                "Omi Dikenuaji",
                "Omohia",
                "Omokpiriku",
                "Omorihuru",
                "Omota",
                "Omu Agala",
                "Omu Agiri",
                "Omu Amah",
                "Omu chip",
                "Omu Eechi",
                "Omu Ibah",
                "Omu Ikea",
                "Omu Isuea",
                "Omu Mbom",
                "Omu Noro-Omue",
                "Omu Nwenea",
                "Omu Nwibike",
                "Omu Ocham",
                "Omu Sukuta",
                "Omu Woka",
                "Omu-Didenuaji",
                "Omuabali",
                "Omuade",
                "Omuagbaoke",
                "Omuagula",
                "Omuali",
                "Omuama",
                "Omuanaa",
                "Omuaza",
                "Omuchioha",
                "Omuchiou",
                "Omudede",
                "Omueti",
                "Omueze",
                "Omuika",
                "Omuikea",
                "Omuishioha",
                "Omukoro",
                "Omumonyor",
                "Omuoda",
                "Omuogboi",
                "Omuoji",
                "Omuokiedinma",
                "Omuokpata",
                "Omuordm",
                "Omuordu",
                "Omuorupu",
                "Omuosa",
                "Omuosu",
                "Omuotam",
                "Omuovona",
                "Omuse/Omusemgbe-Lela",
                "Onimini",
                "Onimuli",
                "Onimuli-Oji",
                "Orlu-Igbaa",
                "Osa",
                "Ovogo",
                "Rumeeleni",
                "Rumeoro",
                "Rumewhor",
                "Rumiji",
                "Rumodogo",
                "Rumou Kparae Kah",
                "Rumuagwor",
                "Rumuebagwor",
                "Rumuekpe",
                "Rumuigbaa",
                "Rumuigwenya",
                "Rumukani",
                "Rumuohe",
                "Rumuokwu",
                "Udoha",
                "Ukaeli",
                "Ukwu Waterside",
                "Omudioga",
                "Omuagi",
                "Aliagha"
            ],
            "Etche": [
                "Etche",
                "Abaro",
                "Achara",
                "Afara",
                "Agbalu",
                "Akwa",
                "Akwukobi",
                "Amaji",
                "Amaku",
                "Chokocho",
                "Chokotaa",
                "Edegelem",
                "Egbeke",
                "Egbu",
                "Egwi",
                "Elele",
                "Ezelaka",
                "Ezikohia",
                "Igbo",
                "Igbodo",
                "Ihie",
                "Ikem",
                "Ikewerrengwa",
                "Ikpo",
                "Isu",
                "Mbaa",
                "Ndashi",
                "Nihi",
                "Nwuba",
                "Obakwu",
                "Oberi",
                "Obi",
                "Obibi",
                "Obite",
                "Obokwu",
                "Obono",
                "Obwaro",
                "Odagwa",
                "Odagwa-Waterside",
                "Odegwa",
                "Odufor",
                "Ogida",
                "Ohanta",
                "Ohim",
                "Okehi",
                "Okomoko",
                "Okomoko-Akpoku",
                "Okonoche",
                "Okoroagu",
                "Okoroagu Waterside",
                "Okudu",
                "Olwere-Ngwo",
                "Opiro",
                "Owaza",
                "Owu",
                "Ozuzu",
                "Rakwango",
                "Rumumumu",
                "Rumuolo",
                "Ukechi",
                "Ulakwo",
                "Ulmude",
                "Umechem",
                "Umoga",
                "Umu Oyere",
                "Umuakuriki",
                "Umuakuru",
                "Umuakwu",
                "Umuanyagu",
                "Umuasukpu",
                "Umuaturua",
                "Umuabike",
                "Umuchoko",
                "Umudele",
                "Umudike",
                "Umudu",
                "Umuebulu",
                "Umuechere",
                "Umuechie",
                "Umuede",
                "Umuekele",
                "Umuekwo",
                "Umuelechi",
                "Umueze",
                "Umueze-Ulakwo",
                "Umughi",
                "Umuka",
                "Umukpo",
                "Umumba",
                "Umumbiri",
                "Umunju",
                "Umunluoko",
                "Umuobaka",
                "Umuoche",
                "Umuochinana",
                "Umuodiri",
                "Umuofor",
                "Umuogodo",
                "Umuokwo",
                "Umuola",
                "Umuomara",
                "Umuome",
                "Umuoye"
            ],
            "Gokana": [
                "Gokana",
                "B. Dere",
                "Barako",
                "Bera",
                "Biara",
                "Bodo",
                "Bomu",
                "Deken",
                "Deoyor",
                "Gbe",
                "Goi",
                "Giokoo",
                "K. Dere",
                "Kibangba",
                "Kpor",
                "Lewe",
                "Mogho",
                "Nwe-biara",
                "Nwe-ol",
                "Yeghe"
            ],
            "Ikwerre": [
                "Ikwerre",
                "Adanta",
                "Agbaoga",
                "Agwa/Nuahua",
                "Agwara",
                "Ahiniri",
                "Akpabu",
                "Aluu",
                "Apani",
                "Ekuche",
                "Elele",
                "Ezeogo",
                "Igwuruta",
                "Igwuruta-Ali",
                "Imogu",
                "Ipo",
                "Isiokpo",
                "Itu",
                "Mbunta",
                "Mgbaogba",
                "Mgbo",
                "Mgbodo",
                "Mgbu-Ahana",
                "Mgbuanyuri",
                "Mgbuefitibia",
                "Mgbuhie",
                "Mgbumini",
                "Mgbuodo",
                "Mgbuodukwu",
                "Mgbuogidi",
                "Mgbuokiri",
                "Mgbuokwukwu",
                "Mgbuonyi",
                "Nkaralua",
                "Obelle",
                "Obelle/Edoha",
                "Obiti",
                "Obo",
                "Oborum",
                "Ogankira",
                "Ogbasara",
                "Ogbasara-Imea",
                "Ogboda",
                "Okperekpe",
                "Omademe",
                "Omagwa",
                "Omaku",
                "Omaraike",
                "Omerelu",
                "Omesiobi",
                "Omihua",
                "Omizua",
                "Omoawa",
                "Omobiri",
                "Omuadi",
                "Omuagu",
                "Omuolo",
                "Omuketu",
                "Omuagubia",
                "Omuagwawirie",
                "Omuahunwo",
                "Omuchagor",
                "Omuchama",
                "Omuchetu",
                "Omuchi",
                "Omuchinwo",
                "Omuchiolu",
                "Omuchsor",
                "Omudagwa",
                "Omudari",
                "Omudidia",
                "Omuechem",
                "Omuegwa",
                "Omuehia",
                "Omuehie",
                "Omueke",
                "Omuele",
                "Omueze",
                "Omugbala",
                "Omuigwe",
                "Omuigwe-Omute",
                "Omuike",
                "Omuikega",
                "Omuiopi",
                "Omuketai",
                "Omukiole",
                "Omukpiriku",
                "Omukume",
                "Omukwata",
                "Omukwosi",
                "Omumini",
                "Omuna",
                "Omungbe",
                "Omunkpu-Omute",
                "Omunkwo",
                "Omunobo",
                "Omunwonjor",
                "Omuobaa",
                "Omuodu",
                "Omuoduku",
                "Omuogboro",
                "Omuogwor",
                "Omuohechi",
                "Omuohia",
                "Omuohiaa",
                "Omuohie",
                "Omuokiri",
                "Omuokirika",
                "Omuoko",
                "Omuokpa-Omukuosi",
                "Omuolori",
                "Omuolu",
                "Omuonua",
                "Omuoparaaga",
                "Omuosi",
                "Omuota",
                "Omuotiua",
                "Omuotutua",
                "Omuoviri",
                "Omure",
                "Omute",
                "Omutogbule",
                "Omuueka",
                "Omuoda",
                "Omuwhiei",
                "Omuwonini",
                "Omuzua",
                "Onwali",
                "Orua",
                "Ozuaha",
                "Rumuekpe",
                "Ubabah",
                "Ubima",
                "Ubiti",
                "Ubordu",
                "Umuchi",
                "Umukine",
                "Umukpuru",
                "Uuokela"
            ],
            "Khana": [
                "Bori",
                "Baghayagbe",
                "Banchabone",
                "Betem",
                "Bie Gwara",
                "Deken",
                "Eken",
                "Gbam Boue",
                "Gure",
                "Kagwara",
                "Kani",
                "Kani Babbe",
                "Kapnor",
                "Kayangbe",
                "Kerekekiri",
                "Kono Boue",
                "Luawii",
                "Luyorgwaro",
                "Ndagbami",
                "Norkuri Boue",
                "Notem",
                "Sii",
                "Uegure Boue",
                "Zaa Kpong",
                "Agbalekan Ama",
                "Akoro- Sogbo",
                "Ayama",
                "Baen 1",
                "Bale",
                "Bane",
                "Bangha",
                "Bara - Kani Sogbo",
                "Barako - Saako",
                "Bass - Luekun",
                "Beakoro - Beeri",
                "Beam",
                "Bebbe Court",
                "Bere",
                "Bianui -Bamgha",
                "Bonu",
                "Buan",
                "Bunu - Bangh",
                "Daen",
                "Dalorri",
                "Emeh",
                "Iuere-Beeri",
                "Kaani",
                "Kabanghaa",
                "Kalaoko",
                "Kazon",
                "Kenwikun",
                "Kere",
                "Kono",
                "Korokoro Luekun",
                "Korowan",
                "Kpaa",
                "Kpeng",
                "Kpong",
                "Kwawa",
                "Lorre",
                "Losoe Sogbo",
                "Lubara",
                "Luebe",
                "Marihu",
                "Murmga Sogho",
                "Nonwa - Sogho",
                "Nyobe -Bangha",
                "Nyogan Luekun",
                "Nyokuru",
                "Okwali",
                "Opuoko",
                "Peka - Sogbo",
                "Pero -Ue",
                "Posirisu - Duyaakara",
                "Pue",
                "Saa-Beeri",
                "Simbe Banga Luekun",
                "Sogbo",
                "Teenana",
                "Uegwere",
                "Wiiyaakpara",
                "Taabaa"
            ],
            "Obio/Akpor": [
                "Obio/Akpo",
                "Alakahia",
                "Atali",
                "Cheba",
                "Egbelu",
                "Elelenwe",
                "Elimgbu",
                "Eliozu",
                "Elipparanwo",
                "Eneka",
                "Iriebe",
                "Iwofe",
                "Megbuesilaru",
                "Mgbuoba",
                "Mpakurche",
                "Nkpa",
                "Nkpelu-p",
                "Ogbogoro",
                "Oginigba",
                "Ore- Igwe",
                "Rukpokwo",
                "Rukpolu -Obio",
                "Rumolumeni",
                "Rumu -okwurusi",
                "Rumuadaolu",
                "Rumuahalu",
                "Rumuchiorlu",
                "Rumudogo",
                "Rumuegba",
                "Rumuekini",
                "Rumuekwe",
                "Rumueme",
                "Rumuepirieli",
                "Rumuepirikom",
                "Rumuewhara",
                "Rumuibekwe",
                "Rumuigbo",
                "Rumumduru",
                "Rumuodara",
                "Rumuodomaya",
                "Rumuoji",
                "Rumuokoro",
                "Rumuokro",
                "Rumuokwachi",
                "Rumuokwuota",
                "Rumuokwurusi",
                "Rumuola",
                "Rumuolukwu",
                "Rumuomasi",
                "Rumuomoi",
                "Rumuosi",
                "Rumuoto",
                "Rumurolu",
                "Rumusara",
                "Rumuwaji",
                "Rumuwegwu",
                "Runuobiakani",
                "Ozuoba",
                "Woji",
                "rumualogu"
            ],
            "Ogba/Egbema/Ndoni": [
                "Ndoni",
                "Adiai - Obiofu",
                "Agwe",
                "Amuajie",
                "Ase - Imonita",
                "Ase-Azaga",
                "Isara",
                "Isiukwa",
                "Odugili",
                "Ogbeogene",
                "Ogu",
                "Oniku",
                "Owajinobia",
                "Ugbaja",
                "Umuigwe",
                "Umuorieke",
                "Utu",
                "Ogba / Egbema",
                "Agah",
                "Akabuka",
                "Akputa Waterside",
                "Alinso -Okenu",
                "Ama",
                "Eboaha",
                "Ede",
                "Egbema",
                "Egboda",
                "Egita-Akabuta",
                "Ekpe -Aggah",
                "Ekpe -Mgbede",
                "Elehia",
                "Elieta",
                "Erema",
                "Ibewa",
                "Ikiri",
                "Itu",
                "Kreigani",
                "Mgbede",
                "Obagi",
                "Obakata",
                "Obidi",
                "Obiebe",
                "Obieti",
                "Obigbo",
                "Obihuru",
                "Obiozumini/Obukegi",
                "Obite",
                "Oboh",
                "Obokroha",
                "Obosi",
                "Obrikom",
                "Obuburu",
                "Ogbogu",
                "Ohali-Elu",
                "Ohali-Usomini",
                "Ohiauga",
                "Okansu",
                "Okposi",
                "Okpurukpula",
                "Okuku",
                "Okwuzu",
                "Omoku",
                "Onuesi -Ogu",
                "Osiakpu",
                "Uju",
                "Ukpazi",
                "Usomini"
            ],
            "Ogu/Bolo": [
                "Ogu / Obolo",
                "Bolo",
                "Ele",
                "Ogu"
            ],
            "Okrika": [
                "Okrika",
                "Abam - Ama II",
                "Abioboama",
                "Agbkien- Ama",
                "Andikiri",
                "Asemeningolike",
                "Dankiri",
                "Dikiboama",
                "Ekerekana",
                "George -Ama",
                "Ibaka",
                "Ibuluy-Dikiboama",
                "Ikirikoama",
                "Ikpokiri - Ama II",
                "Isaka",
                "Iwokiri - Ama",
                "Iyokiri",
                "Kalio -Ama",
                "Mbikiri",
                "Ndubusiama",
                "Ngbagbebokoama",
                "Ngololo",
                "Oba - Ama",
                "Obiarime -Ama",
                "Odokorobie",
                "Ogan-Ama",
                "Ogbogbo",
                "Ogoloma",
                "Okirika",
                "Okochiri",
                "Okujagu Ama",
                "Okumgba -Ama",
                "Omoaobi",
                "Omodere -Ama",
                "Opuada -Ama",
                "Oraberekiri -Ama",
                "Otobipi",
                "Owuogonoama",
                "Sara -Ama",
                "Semembiri -Ama",
                "Teriapu Kiriama"
            ],
            "Omuma": [
                "Omuma",
                "Eberi",
                "Egbelu",
                "Umerim",
                "Umuabali",
                "Umuagwa",
                "Umuakali",
                "Umudik",
                "Umudou",
                "Umukamanu",
                "Umunachi",
                "Umuokwa",
                "Umuolilo",
                "Umuoyoro",
                "Umuroke",
                "Umusu",
                "Umuwa",
                "Umuru-Ofeh"
            ],
            "Opobo/Nkoro": [
                "Opobo",
                "Epelema",
                "Ikwata",
                "Iloma",
                "Iwoama",
                "Job-Ama",
                "Kalaibiama",
                "Kalasunju",
                "Minima",
                "Nkoro",
                "Obo- Town",
                "Okorobo -Ile",
                "Olam - Nkoro",
                "Olum",
                "Opum",
                "Queens Town"
            ],
            "Oyigbo": [
                "Ndoki",
                "Afa Uku",
                "Afam",
                "Afam Nta",
                "Azusogu",
                "Egberu",
                "Mgboji",
                "Mrihu",
                "Obeakpu",
                "Obeta",
                "Obumku",
                "Okoloma",
                "Okponta",
                "Umuagbai",
                "Umuosi",
                "Oyigbo",
                "Asa",
                "Komkom",
                "Obeama"
            ],
            "Port Harcourt": [
                "Port -Harcourt (Rural)",
                "Abuloma",
                "Amadio-Ama",
                "Boibu-Oromerizemgbu",
                "Elekohia",
                "Okuru",
                "Orada Diobu",
                "Orogbum",
                "Oroworukwo",
                "Rainbow Town",
                "Rumuoparali",
                "Runiu Kalgbo"
            ],
            "Tai": [
                "Tai",
                "Ban- Ogoi",
                "Bara - Obara",
                "Barayira",
                "Botem",
                "Bunu",
                "Emu",
                "Gbam",
                "Gbene -ue",
                "Ggaken",
                "Gio",
                "Horo",
                "Kenkoro",
                "Kira",
                "Korokoro",
                "Koroma",
                "Kpite",
                "Kporgbor",
                "Ledor",
                "Nonwa - Uedume",
                "Nwenkowa",
                "Oloko",
                "Saapeenwa",
                "Sime",
                "Tombee"
            ]
        }
    },
    {
        "Sokoto": {
            "Binji": [
                "Binji",
                "Bunkari",
                "Gwazzai",
                "Inname",
                "Jamali",
                "Maikulki",
                "S/Gabas",
                "S/Yamma",
                "Samama"
            ],
            "Bodinga": [
                "Bodinga",
                "Garko",
                "Kaura-Minyo",
                "Mazar Gari",
                "Toma",
                "Dingyadi",
                "Badawa",
                "Kulafassa",
                "Tulluwa",
                "Sifawa",
                "Badau",
                "Bindin",
                "Danguibi",
                "Dankurmi",
                "Lukuyawa",
                "S/Birn"
            ],
            "Dange-Shuni": [
                "Dange",
                "Ba'olere",
                "Bakwandi",
                "Bisilan",
                "Bodai",
                "Budude",
                "Bulujiri",
                "Bungi",
                "Dali",
                "Fajallu",
                "G/Kare",
                "Galma",
                "Gidan Ratsau",
                "Hausare",
                "Helele",
                "Himasa",
                "Jurga",
                "Radama",
                "Rakwandi",
                "Salau",
                "Sokwando",
                "Wababe",
                "Wahabi",
                "Shuni",
                "Adarawa",
                "Amanawa",
                "B/Hausawa",
                "Bata",
                "Bayo",
                "Danbarunji",
                "Danbua",
                "Dilungu",
                "Duma",
                "Gajara",
                "Galankawa",
                "Geera",
                "Gidado",
                "K/Kimba",
                "Kadabali",
                "Kwanawa",
                "Kwanbi",
                "Lofa",
                "Luga",
                "Lungu",
                "Majebela",
                "Makera",
                "Monde",
                "R/Konduna",
                "Rahen Ali",
                "Rekina",
                "Rudu",
                "Runjin man",
                "Sabaru",
                "Tsafanade",
                "Tsamiya",
                "Tsefe",
                "Tuntobe"
            ],
            "Gada": [
                "Duka Maje",
                "Gada",
                "Gilbadi",
                "Holai",
                "Ilah",
                "Bigal",
                "Gidan Fako",
                "Gidan mani",
                "Banqas",
                "Ingabura",
                "K/ Buda",
                "Kadadi",
                "Kadassaka",
                "Kaddi",
                "Kaffa",
                "Kiri",
                "Kwarma",
                "Kyadawa",
                "Madawa",
                "R/doma",
                "Sagira",
                "Tsitse",
                "Wauru"
            ],
            "Goronyo": [
                "Awakkala",
                "Birjingo",
                "Boyakai",
                "Danasakko",
                "Giyawa",
                "Goronyo",
                "Kagara",
                "Kojiyo",
                "Kwakwazo",
                "Rimawa",
                "S/G-dole",
                "Shinaka",
                "Takakume",
                "Tsolawo",
                "Yarimawa",
                "Z. Sabara"
            ],
            "Gudu": [
                "Gudu",
                "Awalkiti",
                "Bachaka",
                "Balle",
                "Boto",
                "Chillas",
                "Gwazanye",
                "Jurga",
                "K/Chana",
                "K/Sarki",
                "Kurdula",
                "Makaya",
                "Marken-Bori",
                "Salau",
                "Tsafanade",
                "Tulun-Doya",
                "Wababi"
            ],
            "Gwadabawa": [
                "Gwadabawa",
                "Alela",
                "Asara",
                "Asara Arewa",
                "Attakwanyo",
                "Bamana",
                "Chancha",
                "Chimmola",
                "Dan Abba",
                "Gidan Kaya",
                "Gigane",
                "Huchi",
                "Mammande",
                "Manmansuka",
                "Meli",
                "T/Shanu",
                "Tudun Doki",
                "Tambagarka",
                "Wodai",
                "Zugana",
                "Salame",
                "Abdalon-Salame",
                "Bakanta",
                "Tayyamane",
                "Bingga",
                "Dabuwasa",
                "Bati",
                "Tungan Maikomo",
                "Gobiro",
                "Mayal",
                "Here",
                "Yar Tunga",
                "Kubudawa",
                "Jilliki",
                "Tungan Makera",
                "Tungan Jijje",
                "Munlela",
                "Dangero",
                "Darna-Kilya",
                "Illela-Baraya",
                "Kiliya",
                "Kola",
                "Jema",
                "Tungar Zaki"
            ],
            "Illela": [
                "Abarura",
                "Araba",
                "D/Salau",
                "Damba",
                "Dango",
                "Dauna",
                "G/Katta",
                "Gadan",
                "Garu",
                "Gidan Hamma",
                "Illela",
                "Kalmalo",
                "Ketti",
                "R/Gatti",
                "Sabon Gari",
                "Tarke",
                "Tozai",
                "Tsolawa"
            ],
            "Isa": [
                "Bafarawa",
                "Bargaja",
                "Gebe",
                "Gidan Bawa",
                "Gidan Dikko",
                "Isa",
                "Kurar Mota",
                "Modaci",
                "Rijia Mallam Ladan",
                "Shalla",
                "Tiddibale",
                "Tsabare",
                "Turba",
                "Yanfako"
            ],
            "Kebbe": [
                "Budun",
                "Dukura",
                "Fakku",
                "Garaci",
                "Girkau",
                "Gwandi",
                "Jabga",
                "Kebbe",
                "Kuchi",
                "Margai",
                "Matseri",
                "Nasa-Gudu",
                "San gi",
                "Ungushi",
                "Zugu"
            ],
            "Kware": [
                "Durbawa",
                "Kasara",
                "T|mallamawa",
                "Tsaki",
                "Turanka",
                "Hamma Ali",
                "Bargeni",
                "Dundaye",
                "G/Akwara",
                "G/Buba",
                "G/Danga",
                "G/Gabas",
                "G/Hamidu",
                "G/Kaya",
                "G/Modibbo",
                "G/Ruga",
                "G/Yaro",
                "Galaduntse",
                "Gandu",
                "Gumborawa",
                "Hadarawa",
                "Marabawa",
                "R/Samiya",
                "Bankanu",
                "Basansan",
                "R/Kade",
                "Gunduga",
                "K/kede",
                "Kalalawa",
                "Saki",
                "Gebawa",
                "Lambo",
                "Walakai",
                "Zamau",
                "Umaruma",
                "Bassan San",
                "Gidan Akura",
                "Hausawa",
                "More",
                "R/limma",
                "Sirijallu",
                "Ummaruma"
            ],
            "Rabah": [
                "Gandi",
                "Gundumar-Bunu",
                "Kurya",
                "Tsamiya",
                "Yar Tsakuwa",
                "Rabah",
                "Baraya Zaki",
                "G/Buwai",
                "Galadima",
                "Gawa Kuke",
                "Goddodi",
                "Gundumar-Riji",
                "Mai Kujara",
                "Rarah",
                "Tofa",
                "Tursa",
                "Yari-Gwaddadi"
            ],
            "Sabon Birni": [
                "Gangara",
                "Gatawa",
                "Kalgo",
                "Kukawa",
                "Lajinga",
                "Makuwana",
                "Sabon Birni",
                "Tara",
                "Tsamaye",
                "U/Lalle"
            ],
            "Shagari": [
                "Aggur",
                "Bulanyaki",
                "Doruwa",
                "Gangam",
                "Kajiji",
                "Lambara",
                "Lungu",
                "Mandera",
                "Rugga",
                "Sanyinnawal",
                "Shagari",
                "Tunya dole"
            ],
            "Silame": [
                "Gande",
                "Katami",
                "Kubodu",
                "Labani",
                "Maji",
                "Marafa",
                "Silame"
            ],
            "Sokoto North": [
                "Adar Kwanni",
                "Dandi",
                "Karaye",
                "Mabara Kanti Sani",
                "Mabera Idi",
                "Mabera Mujaya",
                "Magajin-Gari",
                "Magajin-Rafi",
                "Mana",
                "Rujin Sambo",
                "Sabon Birni",
                "Salami",
                "Sarkin Musullumi",
                "Ungwar Jariri"
            ],
            "Sokoto South": [
                "Gagi",
                "Rijiyar Dorowa",
                "Sarkin Zamfara",
                "Tudun-Wada"
            ],
            "Tambuwal": [
                "Dogon Daji",
                "Bancho",
                "Barkeji",
                "Dogon-Daji",
                "Gambu",
                "Nabaguda",
                "Sabawa",
                "Salah",
                "Shabra",
                "Gindi",
                "Bakaya",
                "Barga",
                "Danmadi",
                "Kaya",
                "Madacci",
                "Jabo",
                "Barkini",
                "Chakai",
                "Kaura Salihu",
                "Lukingo",
                "Maikada",
                "Moradun",
                "Shimfiri",
                "Yagawal",
                "Zomawa",
                "Alasan",
                "Bagida",
                "Bashire",
                "Dogon Marke",
                "Faga",
                "Ganuwa",
                "Garba Magaji"
            ],
            "Tangaza": [
                "Gidan-Madi",
                "Gongono",
                "Gurdam",
                "Kalanjeni",
                "Kwachehuro",
                "Magonho",
                "Raka",
                "Ruwan Wuri",
                "Sakkwai",
                "Salewa",
                "Suti",
                "Tangaza"
            ],
            "Tureta": [
                "Bimasa",
                "Bimasa Lofa",
                "Dorawa",
                "Duma Nasarawa",
                "Fura-Girke",
                "G/kare",
                "Kawara",
                "Kuruwa",
                "Kwarare",
                "Ruga Budda",
                "Tureta"
            ],
            "Wamako": [
                "Dundaye",
                "Gidan Buba",
                "Gidan Hamidu",
                "Gidan Kaya",
                "Gidan Yaro",
                "Gumborawa",
                "Gumbi",
                "Kalambaina",
                "Kasarawa",
                "Wajake",
                "Wammako",
                "Gedawa",
                "Gwamatse",
                "K/Kimba",
                "Kamatta",
                "Kaura Kamba"
            ],
            "Wurno": [
                "Achida",
                "Alkanmu",
                "G/Bango",
                "Gyalgyal",
                "Kwasare",
                "Lalodu",
                "Sisawa",
                "Wurno",
                "Adakela",
                "Chacho",
                "Dankemu",
                "Dinawa",
                "Dinbiso",
                "Kwargaba",
                "Magargaba",
                "Magarya",
                "Marafa",
                "Marnowa",
                "S/Bazai-Abdu",
                "Wurn"
            ],
            "Yabo": [
                "Kilgori",
                "Bakale",
                "Birni Ruwa",
                "Bingaje",
                "Binji",
                "Budurega",
                "Dono",
                "Fakka",
                "Kibiyare",
                "Muza",
                "Ruggar",
                "Torankawa",
                "Yabo"
            ]
        }
    },
    {
        "Taraba": {
            "Ardo Kola": [
                "Ardo-Kola",
                "Iware",
                "Jauro-Yinu",
                "Jiru",
                "Lamido-Borno",
                "Mallum",
                "Mayo-Ranewo",
                "Sarkin-Dutse",
                "Sibre",
                "Sunkani",
                "Tau",
                "Zongon-Kombi"
            ],
            "Bali": [
                "Bakundi",
                "Aka",
                "Aruta",
                "Asinai",
                "Badakoshi",
                "Bagoni",
                "Bajabure",
                "Bankayire",
                "Bariki",
                "Bayere",
                "Bokki",
                "Borno Kurukuru",
                "Cude",
                "Dali",
                "Daniya",
                "Fondulare",
                "Gangfir",
                "Gangumi",
                "Ganpentom",
                "Garbachede",
                "Garin Garba Kungana",
                "Garin Garba Suntai",
                "Garin Ulu",
                "Garin-Jatau",
                "Garke",
                "Gayo",
                "Gazabu-Balkeji",
                "Gongkwai",
                "Gurama",
                "Hawan-Mata",
                "Jameta-Kundi",
                "Jammiri",
                "Jauro-Bam",
                "Kaigama",
                "Kamalifidi",
                "Kankani",
                "Kararuwa",
                "Kasina",
                "Kungana",
                "Kwagiri",
                "Kwanah Jukun",
                "Kwanan Damisa",
                "Kwassa",
                "Mahanga",
                "Mahurmi",
                "Mai Biutu",
                "Mai hulo",
                "Maichibi",
                "Maigoge",
                "Maigoro",
                "Maikarfi",
                "Maikinta",
                "Mailaya",
                "Maisamari",
                "Maisaye-Yandang",
                "Mallam-Yaro",
                "Mayokam",
                "Murna-Chomu",
                "Nahuta",
                "Nakwai",
                "Nya",
                "Nyagong",
                "Nyalli",
                "Pangri",
                "Panri",
                "Sabon Dale",
                "Sabon Gida",
                "Sabon Kasuwa",
                "Sansani",
                "Sarkin-Bawa",
                "Shuwa",
                "Suntai",
                "Takalafiya",
                "Tondurum",
                "Tonti",
                "Waya",
                "Wurbu",
                "Wuro Amadu",
                "Yakai",
                "Yelwa",
                "Yelwa Kararuwa",
                "Zaga",
                "Dakka",
                "Ardo Tiba",
                "Boduri",
                "Dekusum",
                "Gamgboni",
                "Ganga Dole",
                "Gangbiyiwa",
                "Gangburanmaso",
                "Ganggira",
                "Gangkita",
                "Ganglari",
                "Garbatau",
                "Garin Ibrahim",
                "Garin Jatau",
                "Garin Samari",
                "Garin Sambo",
                "Garin-Kuri",
                "Gong Dole",
                "Jangare",
                "Kampu",
                "Kanwe Maroko",
                "Mading",
                "Mana Gangduniyaru",
                "Masa-Ibbi",
                "Mini Miri Donlola",
                "Nyawanti",
                "Nyenalongba",
                "Nyikusum",
                "Pamanga",
                "Shena",
                "Tiba",
                "Timjemi",
                "Wuro Hausa",
                "Zoban Shakuna"
            ],
            "Donga": [
                "Akate",
                "Akume",
                "Ananum",
                "Anzaye",
                "Atsagbo",
                "Ayabagri",
                "Bibinu",
                "Daton",
                "Donga",
                "Farin-Ruwa",
                "Gadarko",
                "Gankwe",
                "Gankwe-Bariki",
                "Gankwe-Yeba",
                "Gayama",
                "Gbamuna",
                "Gidan-Dutse",
                "Gidan-Jatau",
                "Gidan-Makeri",
                "Jatau",
                "Kumbo",
                "Lagos-Buban",
                "Mararaba",
                "Ndoro",
                "Nhuwha",
                "Nukpo",
                "Nukuya",
                "Numai",
                "Nyabe",
                "Nyimui",
                "Nyiru",
                "Nyita",
                "Sabongida",
                "Sabongida Tukura",
                "Sanso",
                "Suntai",
                "Tai",
                "Tisa",
                "Tor-Damisa",
                "Tunari",
                "Ude"
            ],
            "Gashaka": [
                "Adagoro",
                "Azoratar",
                "Balewa",
                "Boder",
                "Burtai",
                "Danbarau",
                "Dandi Gazabu",
                "Dogo Ajam",
                "Gameri",
                "Gandole",
                "Gangumi",
                "Garbabi",
                "Gashaka",
                "Gayam",
                "Geidam Gindin-Dutse",
                "Gidan Tiv",
                "Gidan Usman",
                "Goje",
                "Gumti",
                "Injawai",
                "Jamtari",
                "Karamti",
                "Kobaje",
                "Kofai-Kwagir",
                "Lagaso",
                "Mai Suma",
                "Mayo Handu",
                "Mayo Kam",
                "Mayo Selbe",
                "Mayo-Yim",
                "Nagamu Sallama",
                "Nyabar",
                "Sangere",
                "Sarkin Ruwa",
                "Serbe",
                "Serti",
                "Taraba",
                "Tonga",
                "Tungwa",
                "Yakuba"
            ],
            "Gassol": [
                "Ashi-Arage",
                "Beida",
                "Borno",
                "Duniya Dan-Anacha",
                "Gargala",
                "Gassol",
                "Gidan-Sartin",
                "Gombe",
                "Jafuma",
                "Kufai",
                "Madani",
                "Maiwuya",
                "Mbodawa",
                "Nafuche",
                "Namguru",
                "Nassarawa",
                "Njiddawa",
                "Sabongida",
                "Sendurde",
                "Takai",
                "Tella",
                "Wurno",
                "Wuro-Boki",
                "Wuro-Jam",
                "Wuryo",
                "Abba",
                "Agungu",
                "Aho-Abun",
                "Awambe",
                "Bada-Koshi",
                "Dajo",
                "Garba Chede",
                "Garin Mallam",
                "Gidan Hav",
                "Gunduma",
                "Jara-Babba",
                "Jauro-Manu",
                "Maigemu Nannai",
                "Mnyamchie",
                "Mutum Biyu",
                "Peou",
                "Sabon-Magaji",
                "Samda",
                "San-Sani",
                "Sarkin Shira",
                "Sarkin-Ruwa",
                "Sha-Apela-Agbe",
                "Torkegh",
                "Tsokugh-Aberaka",
                "Tura Keke",
                "Tutare",
                "Unguwar-Maji",
                "Wuro-Mane",
                "Yerima"
            ],
            "Ibi": [
                "Dampara",
                "Dampar",
                "Farin-Ruwa",
                "Gidan-Alhaji",
                "Gidan-Dangiwa",
                "Kauyen-Dodo",
                "Kurmin-Sauri",
                "Mavo",
                "Sarki-Noma",
                "Anbua-Oranya",
                "Awuru-Audu",
                "Badan-Koshi",
                "Gazok",
                "Gindin-Waya",
                "Gishiru-Hassan",
                "Ibi",
                "Ibua",
                "Kauyen-Sarki",
                "Kegh-Aguji",
                "Kogiwase",
                "Koso",
                "Maso",
                "Mkouor-Nyinka",
                "Moti",
                "Tepga",
                "Tudun-Wadan",
                "Yamuer-Agbakyo",
                "Dogon-Ruwa",
                "Dooshima",
                "Gurbin-Dutse",
                "Kauyen-Safiyo",
                "Rafin-Danisa",
                "Sarkin-Kudu"
            ],
            "Jalingo": [
                "Jalingo (Rural)",
                "Abbare",
                "Abuja",
                "Askarawa",
                "Ambaliya",
                "Bakari",
                "Balau",
                "Baraya",
                "Bubai",
                "Dogo",
                "Dorowa",
                "Fan",
                "Gada Walawol",
                "Gajer",
                "Gamyel",
                "Garin Baba",
                "Garin Jalo",
                "Garin Kari",
                "Garin Sarki-Fada",
                "Hamdella",
                "Iyabamuye",
                "Jaure Shendu",
                "Jauro Abba",
                "Jauro Awo",
                "Jauro Yeno",
                "Jauro Votoh",
                "Jekadafari",
                "Jen Bambu",
                "Jivunu",
                "Kaduna Iyali",
                "Kalanko",
                "Kanbi",
                "Karofi",
                "Kasuwan Yelwa",
                "Kona Manga",
                "Korkaye",
                "Magami",
                "Mallam Ali",
                "Mafindi",
                "Mallam-Gabdo",
                "Mallam-Joda",
                "Mamani",
                "Mayogwoi",
                "Mudibbo",
                "Murbai",
                "Nana Aisha",
                "Nasarawo",
                "Nunkai",
                "Nyandang",
                "Okona",
                "Pan",
                "Pasli",
                "Petal",
                "Porni",
                "Rimi",
                "Rubi",
                "Sabongari",
                "Sambo",
                "Samunaka",
                "Sarkin Noma",
                "Saurara",
                "Sheudu",
                "Sintali Ward",
                "Sundari",
                "Todiri",
                "Tudun Wada",
                "Wueojauro",
                "Wuro Kadiri",
                "Wuro Sambe",
                "Wuro-Sani",
                "Wuro Musa",
                "Yamusala",
                "Zhiru"
            ],
            "Karim Lamido": [
                "Old Muri",
                "Amar",
                "Didango",
                "Jeb-Jeb",
                "Jukun",
                "Kwaai",
                "Moya-Renewo",
                "Muri",
                "Nguruwa",
                "Yashin-Tuwo",
                "Wurkum",
                "Andami",
                "Angulle",
                "Anguwan Rogo",
                "Bachama",
                "Balassa",
                "Bambuka",
                "Bambur",
                "Bandawa",
                "Banyam",
                "Bikwin",
                "Dadiya",
                "Darofai",
                "Gangan Balassa",
                "Garu Awanke",
                "Gomu",
                "Gomu-Ndugan",
                "Hakuri",
                "Jen-Ardido",
                "Jen-Kaigama",
                "Jen-Petel",
                "Karim Maudi",
                "Karim-Lamido",
                "Kirim",
                "Kode Dutse",
                "Kode Menung",
                "Kode Saliya",
                "Kwanchi",
                "Langakwanchi",
                "Loh-Ndara",
                "Low-Bamli",
                "Munga Lelou",
                "Munga-Dosso",
                "Murbai",
                "Mutum Daya",
                "Ngurore-Jabu",
                "Panya",
                "Piribi",
                "Pitiko",
                "Pitiko Buro",
                "Pitiko Dukuli",
                "Sabon Gari-Jen",
                "Sabongari Dadiya",
                "Saladuna",
                "Salakan City",
                "Senge",
                "Wanzami Gomu",
                "Zailani",
                "Zoh Dutse",
                "Zoh Makarau"
            ],
            "Kurmi": [
                "Kurmi",
                "Abong",
                "Akoferi",
                "Akonko",
                "Akwento",
                "Asha",
                "Ashuku",
                "Bafum",
                "Baissa",
                "Bangara",
                "Batuamada",
                "Bente",
                "Bissaula",
                "Boko",
                "Daubelli",
                "Dogo",
                "Gatari",
                "Gidan Ago",
                "Gidan Ali",
                "Gidan Mallam",
                "Gidan Yamusa",
                "Gwanda",
                "Karanuwa",
                "Kpwola",
                "Kufai-Bawuro",
                "Mubi Tosso",
                "Nama-Baba",
                "Namagangere",
                "Ndaforo Dutse",
                "Ndatoro",
                "Ngbashi",
                "Niuwande",
                "Nyido",
                "Sabon Gida Tukura",
                "Sabongida-Akwawen",
                "Samari",
                "Sango",
                "Sarkin-Boka",
                "Shenjuah",
                "Sunkuru",
                "Tigon",
                "Tosso",
                "Tsakwa",
                "Yaboro",
                "Zabe",
                "Zongomata"
            ],
            "Lau": [
                "Abbare",
                "Bujum",
                "Mayo-Lope",
                "Nanzo",
                "Sabongida",
                "Yitti",
                "Gowe",
                "Didango Rhobi",
                "Didango-Filani",
                "Donadda",
                "Karlahi",
                "Kwamiding",
                "Mesheli",
                "Saturaki",
                "Sayonti",
                "Kunini",
                "Garin-Magaji",
                "Jimlari",
                "Mararaban-Fulani",
                "Mayo-Lushi",
                "Lau",
                "Donbelli",
                "Garin Mashi",
                "Garin Sarki",
                "Garin Lakawa",
                "Garin-Dogo",
                "Lainde",
                "Lau Habe",
                "Minda"
            ],
            "Sardauna": [
                "Gembu",
                "Bang",
                "Dorofi",
                "Furmi",
                "Gurgu",
                "Hainare",
                "Kabri",
                "Kakara",
                "Kassalasa",
                "Kaniyaka",
                "Kuai",
                "Kuara-Kuara",
                "Kuma",
                "Kusuku",
                "Lekitaba",
                "Leme",
                "Magu",
                "Mai-Samari",
                "Mayo Nago",
                "Mayo Selbe",
                "Mayo Sumsum",
                "Mayon-Daga",
                "Mayu",
                "Mbamnga",
                "Mbar",
                "Mbartule",
                "Mbaso",
                "Mbu",
                "Naguroje",
                "Nguroje",
                "Njawai",
                "Njeke",
                "Nver",
                "Tamnyar",
                "Titong",
                "Vakude",
                "Wah",
                "Warkaka",
                "Warwar",
                "Wurum-Gora",
                "Yelwa",
                "Yerimaru",
                "Mbinti",
                "Sah-kaka",
                "Tep",
                "Kuh",
                "Leme-Tella",
                "Leme-Dawu",
                "Tappare"
            ],
            "Takum": [
                "Takum",
                "Abin",
                "Abuja",
                "Acha",
                "Adekpa",
                "Aganko",
                "Akaniwe",
                "Army Barrack",
                "Bakin Kasuwa",
                "Bariki Lissa",
                "Bete",
                "Bibi",
                "Bigbo",
                "Bika",
                "Bika Gaba",
                "Bika Lupwe",
                "Bika-Baba",
                "Bong",
                "Botin",
                "Bokyuk",
                "Chachanji",
                "Chiakara",
                "Dafung",
                "Damu",
                "Dogo Gawa",
                "Donga",
                "Dutse",
                "Fadama",
                "Fete",
                "Gadin",
                "Galumje",
                "Gamgang",
                "Gamga",
                "Ganti",
                "Gatati",
                "Gawa",
                "General Hospital",
                "Hagah",
                "Handev",
                "Iyuda",
                "Jada",
                "Jenuwa Nyifiye",
                "Jenuwa Nykwu",
                "Jenuwa Ruma",
                "Jenuwa-Gida",
                "Kabya",
                "Kandev",
                "Kano",
                "Kashimbila",
                "Kasuwa Haske",
                "Katso",
                "Kogi Kandev",
                "Kufi",
                "Kufun Ahmadu",
                "Kukunu",
                "Kumbo",
                "Kunlebira",
                "Kuru-Sati",
                "Kwambai",
                "Kwenbwoi",
                "Lanke",
                "Liji I",
                "Liji II (Ubom)",
                "Liji III",
                "Likam",
                "Lissa Ma'amu",
                "Lufu",
                "Lukpo",
                "Lupwe",
                "Luku Puri",
                "Lutu",
                "Ma'amu",
                "Magji",
                "Mallunche",
                "Malumji",
                "Manga",
                "Mata Zum",
                "Mbalam",
                "Mbarikam",
                "Mbaturum",
                "Mbiya",
                "Mbufu",
                "Mela",
                "Mgbe",
                "Munchiya",
                "Mutum Daya",
                "Negbe",
                "Ngah",
                "Ngorom",
                "Nyayirim",
                "Nykwu",
                "Pyrai",
                "Rimi",
                "Rogo",
                "Sabon Gida",
                "Sabon Gida Yukuben",
                "Sai",
                "Sangere",
                "Shiakpen",
                "Shibong Igang",
                "Shibong Izong",
                "Shinkafa",
                "Tambwa",
                "Taminya",
                "Tampa",
                "Tampwe Bibi",
                "Tongur",
                "Totse",
                "Tsufa",
                "Ukongkem",
                "Vingir",
                "Wayi",
                "Yelwa",
                "Yongtu",
                "Zorto",
                "Zoshi"
            ],
            "Ussa": [
                "Fikyu",
                "Jatau",
                "Kpakya",
                "Kpambo",
                "Kpambo-Puri",
                "Kwesati",
                "Lissam",
                "Lissam Sambo",
                "Lissam-Kuben",
                "Lissam-Tunga",
                "Lufu",
                "Lumbu",
                "Lupwe",
                "Manya",
                "Rufu",
                "Tati",
                "Tati-Kumbo",
                "Tutuwa",
                "Ussa",
                "Yikuben",
                "Yikusku"
            ],
            "Wukari": [
                "Akwana",
                "Arufu",
                "Gidan-Ikwe",
                "Nndo-Yaku",
                "Tombo",
                "Unofo",
                "Warawa",
                "Zebu",
                "Auyi",
                "Barki",
                "Puje",
                "Pwadzu",
                "Bantaje",
                "Anyam",
                "Beyora",
                "Chediya",
                "Gbogodo",
                "Gidan Dorowa",
                "Jibo",
                "Natride",
                "Nayinawa",
                "Nwono",
                "Nyamkwala",
                "Sabongida",
                "Tapare",
                "Tudunwada",
                "Chonku",
                "Agbarike",
                "Kyaior",
                "Gidan Idi",
                "Aben-Kaho",
                "Bye-Pi",
                "Bye-Vvi",
                "Kuyu",
                "Kente",
                "Igba",
                "Kenke",
                "Sondi",
                "Vaase",
                "Rafin Kada",
                "Abako",
                "Agbadu",
                "Ason",
                "Gavyo",
                "Gborbegha",
                "Ityogbedia",
                "Tsokundi",
                "Vereshe",
                "Zapine"
            ],
            "Yorro": [
                "Kwaji",
                "Jika",
                "Kakware",
                "Manzalana",
                "Mbang",
                "Mika-Isoho-Gari",
                "Mika-Sabongida",
                "Pa-Nyala",
                "Pabezalang",
                "Pupule",
                "Yanka",
                "Mumuye",
                "Dadaa",
                "Dankum",
                "Dasso",
                "Demba",
                "Dilla",
                "Donkin",
                "Gampu",
                "Kajon",
                "Kassa",
                "Lankaviri",
                "Lanko",
                "Lapu",
                "Nyaja",
                "Pantisawa",
                "Santewa",
                "Shampa-Ganna",
                "Sumbu"
            ],
            "Zing": [
                "Bitako",
                "Bitako-Mazara",
                "Bitako-Yalli",
                "Bushankin",
                "Jahbansi",
                "Kobanko",
                "Bugong",
                "Bubong",
                "Buzza",
                "Lappo",
                "Lapudinding",
                "Yonko",
                "Zensi",
                "Zippo",
                "Dinding",
                "Dangong",
                "Kossa",
                "Kugong",
                "Lemman",
                "Bansi",
                "Dandi",
                "Dong",
                "Lemma",
                "Monkin",
                "Batta",
                "Bibong",
                "Dogwe",
                "Gudubong",
                "Kayya",
                "Yakoko",
                "Dangwe",
                "Della",
                "Lorro",
                "Medika",
                "Nanapu",
                "Tolang",
                "Bisomporo",
                "Bitako Dokure",
                "Bitako Ibrahim",
                "Boduga Kamawa",
                "Boduga Nanapu",
                "Bosung",
                "Danvoh",
                "Debambu",
                "Didonko",
                "Doppah",
                "Dossa",
                "Dukka",
                "Fufulagwang",
                "Gwangwang",
                "Jaganpo",
                "Jeng",
                "Kagong",
                "Kakulu",
                "Kodari",
                "Koko",
                "Kosensi",
                "Koyu",
                "Kozensi",
                "Kugong-Boli",
                "Kwana",
                "Kwapo",
                "Kwapo-Jitta",
                "La apo",
                "Labumang",
                "Ladanna",
                "Lago Bansi",
                "Mang",
                "Manpali",
                "Mepuru",
                "Nasirde",
                "Ngole",
                "Sagwe",
                "Sagwe-Jabu",
                "Sawankwa",
                "Shari",
                "Taburaze",
                "Tavin Gwa",
                "Togoppi",
                "Wagwala",
                "Yellen",
                "Yelli",
                "Yukwa",
                "Zandi",
                "Zang",
                "Zing"
            ]
        }
    },
    {
        "Yobe": {
            "Bade": [
                "Adia",
                "Alagarno",
                "Amshi",
                "Azam",
                "Bade",
                "Bursari",
                "Chirawa",
                "Dalia",
                "Dikum",
                "Dogona",
                "Gabaruwa",
                "Gapchia",
                "Garin-Dallari",
                "Garinkura",
                "Gasamu",
                "Gashua",
                "Gogaram",
                "Gweek",
                "Gwuiyo",
                "Jawa",
                "Jawun",
                "Karage",
                "Katamba",
                "Katuzu",
                "Lawan-Alwali",
                "Lawan-Audu",
                "Lawan-Fani",
                "Lawan-Musa",
                "LawanFannam",
                "Muguram",
                "N.A Kaku",
                "Ngelewa",
                "Ngeliabe",
                "Sarkin-Hausawa",
                "Tagli",
                "Tarjiwa",
                "Wasur",
                "Yakuburi",
                "Zabadam"
            ],
            "Bursari": [
                "Bade Gana",
                "Bayammari",
                "Bula",
                "Buruta",
                "Bursari",
                "Butsari",
                "Damana",
                "Damanawa",
                "Dambuk",
                "Danani",
                "Dapchi",
                "Gadiriri",
                "Gareji Tsamowa",
                "Garin Alhaji",
                "Garin Boka",
                "Garin Lamido",
                "Garindole",
                "Giljabi",
                "Giruwon",
                "Gojiji Korem",
                "Goroji",
                "Gruawa",
                "Guba",
                "Guji",
                "Gumsa Gama",
                "Jafinori",
                "Jibirinti",
                "Juluri",
                "Kajimaram",
                "Kariari",
                "Kindilwa",
                "Komandugu",
                "Kurnawa",
                "Massaba",
                "Shettimari",
                "Sundwa",
                "Warodi",
                "Yobe"
            ],
            "Damaturu": [
                "Bula Kus",
                "Bulaburum",
                "Bulama Fordi",
                "Chungul Dambaram",
                "Chungul",
                "Damaturu (Rural)",
                "Jabbari",
                "Damakasu",
                "Damburam",
                "Dankalwa",
                "Debsa",
                "Gabai",
                "Garin Maisaja",
                "Goni Matar",
                "Gorogi",
                "Gubberi",
                "Gulamarram",
                "Gumunta",
                "Itsari",
                "Kaburu",
                "Kaita",
                "Kalalawa",
                "Kontula",
                "Korari",
                "Kuilamu",
                "Kukareta",
                "Kunguwol",
                "Kuskuri",
                "Makunari",
                "Malamuhari",
                "Mallam Tari",
                "Marta",
                "Nuw",
                "Sasawa"
            ],
            "Fika": [
                "Anzie",
                "Boza",
                "Bulakos",
                "Chana",
                "Daniski",
                "Daya",
                "Didim",
                "Diffuel",
                "Dozi",
                "Dumbulwa",
                "Fika",
                "Fusami",
                "Gadaka",
                "Galamo",
                "Garin Aba",
                "Garin Jaji",
                "Garin Wayo",
                "Gashaka",
                "Gashinge",
                "Gashua",
                "Godowoli",
                "Gudi",
                "Gurijaji",
                "Jaga",
                "Jamgadole",
                "Jangarsiri",
                "Kadi",
                "Karem",
                "Lewe",
                "Maiduwa",
                "Maluri",
                "Mazawun",
                "Mubi",
                "Ngaida",
                "Paiono",
                "Shembire",
                "Shoye T.Nanai",
                "Turmi",
                "Yelwa",
                "Zei"
            ],
            "Fune": [
                "Abakire",
                "Aigada",
                "Alagarno",
                "Balanyiwa",
                "Bam",
                "Banshe",
                "Basam",
                "Bauwa",
                "Bindigi",
                "Bufuna",
                "Bulakus",
                "Chirokusko",
                "Damagum",
                "Dawura",
                "Dogonkuka",
                "Dubbol",
                "Dumbulwa",
                "Fajalare",
                "Fulatari",
                "Fune",
                "Gabatasha",
                "Gishiwari",
                "Goyeri",
                "Gremari",
                "Gudugurka",
                "Gunnga",
                "Gununu",
                "Jajere",
                "Jamari",
                "Jauro Bukar",
                "Jauro Isa",
                "Jika",
                "Kafase",
                "Kamarum",
                "Kasko",
                "Kayeri",
                "Kolere",
                "Koriel",
                "Kwajula",
                "Kwalte",
                "Lawan-Kalam",
                "Manawaji",
                "Mashio marmari",
                "Mil-Biyar",
                "Ngelshengale",
                "Ngelzarma",
                "Shamaka",
                "Sudande",
                "Tailai"
            ],
            "Geidam": [
                "Abachari",
                "Ashekri",
                "Badi",
                "Balle",
                "Bisuga",
                "Borko",
                "Chirawa",
                "Dabkariba",
                "Dagambi",
                "Damakarwa",
                "Dejina",
                "Dilawa",
                "Fakuri",
                "Futchimiran",
                "Galaria",
                "Gallaba",
                "Geidam",
                "Gosora",
                "Gumsa",
                "Hausari",
                "Karamti",
                "Kawuri",
                "Keleri",
                "Kelluri",
                "Korkio",
                "Kukoram",
                "Kusur",
                "Kwiri",
                "Lariski",
                "Maannam",
                "Magario",
                "Maidari",
                "Maleri",
                "Murimari",
                "Musari",
                "Nallewa",
                "Rogo",
                "Shame-Kura",
                "Zugu-Ngilewa"
            ],
            "Gujba": [
                "Bara",
                "Bokwai",
                "Borno-Kiji",
                "Bukul",
                "Bularaba",
                "Bulturam",
                "Bumsa",
                "Buni Gari",
                "Buni-Yadi",
                "Chandam",
                "Dadingel",
                "Dadma",
                "Dikshi",
                "Garinchina",
                "Gatumba",
                "Gazagana",
                "Gominja",
                "Goriri",
                "Gotala",
                "Gotumba",
                "Gujba",
                "Gulani",
                "Gutunia",
                "Kaduba",
                "Katarko",
                "Kolere Bomo",
                "Ligda",
                "Mafeni",
                "Maladuwari",
                "Mallam-Dunari",
                "Mandum",
                "Matal",
                "Ngeltawa",
                "Ngumal",
                "Ngurbuwa",
                "Njibulwa",
                "Shinda",
                "Taro",
                "Wagun",
                "Waranya"
            ],
            "Gulani": [
                "Bara",
                "Borno-Kiji",
                "Bularaba",
                "Bumsa",
                "Burasari",
                "Chandam",
                "Dokshi",
                "Gabai",
                "Gagure",
                "Gargari",
                "Garin Tuwo",
                "Kukuwa",
                "Kushimaga",
                "Ngulwa",
                "Ngurun",
                "Nguzoa",
                "Ruhu",
                "Tetteba",
                "Zango"
            ],
            "Jakusko": [
                "Bayam",
                "Buduwa",
                "Daifa",
                "Dudua",
                "Dumbari",
                "Gamajam",
                "Ganya",
                "Garin Maiturmi",
                "Garinsalha",
                "Gibbo",
                "Gidigid",
                "Gogaram",
                "Goldimari",
                "Gurunga",
                "Jaba",
                "Jakusko",
                "Japbo",
                "Japoji",
                "Jawur",
                "Katamona",
                "Labo",
                "Lafiya-Loi",
                "Muguram",
                "N.Gambo",
                "Nasari",
                "Ngelsom",
                "Saminaka",
                "Zabudum",
                "Zeddi"
            ],
            "Karasuwa": [
                "Bukarti",
                "Fajiganari",
                "Garin Gawo",
                "Garu-Guna",
                "Gasma",
                "Jaji-Maji",
                "Karasuwa",
                "Waro",
                "Yajiri",
                "Wachakal",
                "Kafetuwa",
                "Dalari",
                "Abaridi",
                "Madugabari",
                "Mamiram",
                "Lamido Audu",
                "Kinnariram",
                "Kilbuwa",
                "Tatikori",
                "Garin Malam",
                "Simeldi",
                "Garin Alhaji",
                "Garin Gyada",
                "Kwana",
                "Barderi",
                "Melawuri",
                "Bukku",
                "Dunari",
                "Maina Ari",
                "Gawu",
                "Mala Kunu",
                "Alajiri",
                "Chumbusko",
                "Zolo",
                "Damamini",
                "Dogon Jeji",
                "Rumfar Kara",
                "Tasha Kargo",
                "Lamido Ngaine",
                "Hardo Kabo",
                "Garin Mammadu",
                "Karau Kawu",
                "Wuri Bawuri",
                "Lamido Hassan",
                "Jajeri",
                "Garin Jarma",
                "Zango",
                "Tabawa",
                "Daban Giwa",
                "Ngurodi"
            ],
            "Machina": [
                "Adturu",
                "Barinari-Lamiri",
                "Bogo",
                "Bulseri",
                "Damai",
                "Dimago",
                "Dole",
                "Faramiram",
                "Flimaram",
                "Garin",
                "Garin Kinna",
                "Garwadole",
                "Gogi",
                "Gunsi",
                "Kabaduna",
                "Kabera",
                "Kom-Komma",
                "Koremarun",
                "Kuka-Yasku",
                "Lamisu",
                "Machina",
                "Mamada",
                "Maskandare",
                "Maskarari",
                "Meori",
                "Sabawa",
                "Shekori",
                "Tagamama"
            ],
            "Nangere": [
                "Mamudo",
                "Bala",
                "Dakasko",
                "Garintuja",
                "Dowasa",
                "Fakarau",
                "Garin Gambo",
                "Kukuri",
                "Tarajim"
            ],
            "Nguru": [
                "Aroro",
                "Bajigama",
                "Bakwa",
                "Bambori",
                "Bilelam",
                "Bujiji",
                "Bulabulin",
                "Bulangua",
                "Bulanguaram",
                "Buleri",
                "Bundi",
                "Dadara",
                "Dogana",
                "Dogon-Kuka",
                "Dumsai",
                "Garbi",
                "Garin Malum",
                "Garin Naruwa",
                "Hausari",
                "Jigamari",
                "Kakori",
                "Kanuri",
                "Karanbari",
                "Kisogana",
                "Maidashi",
                "Maja-Kura",
                "Mamnia",
                "Margadu",
                "Masari",
                "Mirba-Kabir",
                "Mirba-Sagir",
                "Ngilewa",
                "Nguru (Rural)",
                "Tashakang",
                "Wazzagl",
                "Wusur",
                "Yamdem",
                "Yamdugu",
                "Zolo"
            ],
            "Potiskum": [
                "Alaraba",
                "Badejo",
                "Chalumno",
                "Dagare",
                "Daniski",
                "Daria",
                "Dazigal",
                "Kukargadu",
                "Potiskum",
                "Siminti"
            ],
            "Tarmuwa": [
                "Tarmuwa",
                "Babangida",
                "Barkami",
                "Biriri",
                "Borno-Kiji",
                "Bulturi",
                "Churokusko",
                "Dabala",
                "Garga",
                "Jumbam",
                "Lantaiwa",
                "Mandadawa",
                "Shegau"
            ],
            "Yunusari": [
                "Yunusari",
                "Baituwa",
                "Bomba",
                "Bukti",
                "Bulabulin",
                "Buluk Buluk",
                "Chillima",
                "Chokolo",
                "Damatoshia",
                "Dekwe",
                "Dilala",
                "Diriti",
                "Dogaltura",
                "Garin Kaigama",
                "Gremadi",
                "Gremari",
                "Gursula",
                "Jilo",
                "Kafaje",
                "Kalgi",
                "Kanamma",
                "Karaguwa",
                "Karigi",
                "Konta Kunu",
                "Kusur",
                "Mairari",
                "Malgawa",
                "Mar",
                "Maruduari",
                "Mineklbu",
                "Mosogun",
                "Ngamzai",
                "Ngirabo",
                "Sasamna",
                "Sumbal",
                "Umari",
                "Wadi",
                "Yaro",
                "Zagibinri",
                "Zedi"
            ],
            "Yusufari": [
                "Yusufari",
                "Alagiri",
                "Alanjirori",
                "Budum",
                "Bukardi",
                "Bula Madu",
                "Bulatula",
                "Bunsar",
                "Burari",
                "Garin Lawan",
                "Garin Momodu",
                "Gayuameri",
                "Grema Burari",
                "Gulmiri",
                "Gumsi",
                "Guya",
                "Hangilam",
                "Jebuwa",
                "Jogua",
                "Kajimaram",
                "Kaska",
                "Kulala",
                "Kurusalia",
                "Lalawa",
                "Ligarikura",
                "Maimalari",
                "Mayori",
                "Ndiju",
                "Njikilamma",
                "Sumbar",
                "Tilotoluwa",
                "Zingidi",
                "Zumugu"
            ]
        }
    },
    {
        "Zamfara": {
            "Anka": [
                "Bagega",
                "Barayar-Zaki",
                "Dan Galadima",
                "Magaji",
                "Matseri",
                "Sabon Birini",
                "Waramu",
                "Wuya",
                "Yar'sabaya"
            ],
            "Bakura": [
                "Bakura",
                "Birnin Tudu",
                "Dakko",
                "Damri",
                "Dankadu",
                "DanManau",
                "Nasarawa",
                "Rini",
                "Yar Geda",
                "Yar Kufoji"
            ],
            "Birnin Magaji/Kiyaw": [
                "Birnin Magaji",
                "Danfami Sabon Birini",
                "Gusami Gari",
                "Gusami Hayi",
                "Modomawa East",
                "Modomawa West",
                "Nasarawa Godal East",
                "Nasarawa Godal West",
                "Adabka"
            ],
            "Bukkuyum": [
                "Bukkuyum",
                "Gwashi",
                "Kyaram",
                "Nasarawa",
                "Masama",
                "Ruwan Jema",
                "Yashi",
                "Zarummai",
                "Zauma",
                "Bingi North",
                "Bingi South"
            ],
            "Bungudu": [
                "Bungudu",
                "Furfuri/Kwai-Kwai",
                "Gada / Karakkai",
                "Nahuce",
                "Kwatarkwashi",
                "Rawayya/ Bela",
                "Samawa",
                "Sankalawa"
            ],
            "Gummi": [
                "Bardoki",
                "Falale",
                "Felfeldu / Gamo",
                "Gayari",
                "Gyalange",
                "Illelar Awal",
                "Magajin Gari",
                "Shiyar Rafi"
            ],
            "Gusau": [
                "Madawaki",
                "Mayana",
                "Rijiya",
                "Ruwan Bore",
                "Wanke",
                "Wonaka"
            ],
            "Kaura Namoda": [
                "Banga",
                "Dan - Isa",
                "Gabake",
                "Galadima Dan Galadima",
                "Kungurki",
                "Kurya Madaro",
                "Kyam Barawa",
                "Sakajiki",
                "S/Baura/S/Mafara",
                "Yankaba"
            ],
            "Maradun": [
                "Dosara / Birnin Kaya",
                "Damaga / Damagiwa",
                "Faru / Magami",
                "Gidan Goga",
                "Janbako",
                "Kaya",
                "Maradun North",
                "Maradun South",
                "Tsibiri"
            ],
            "Maru": [
                "Bindin",
                "Bingi",
                "Dan Gulbi",
                "Dan Kurmi",
                "Dan Sadau",
                "Kanoma",
                "Kuyan Bana",
                "Maru",
                "Mayanchi",
                "Ruwan Dorawa"
            ],
            "Shinkafi": [
                "Birnin Yaro",
                "Jangeru",
                "Katuru",
                "Shinkafi North",
                "Shinkafi South",
                "Shanawa"
            ],
            "Talata Mafara": [
                "Garbadu",
                "Jangebe",
                "Morai",
                "Ruwan Gizo",
                "Sauna R/ Gora",
                "Shiyar Galadima",
                "Shiyar Kayaye/Matusgi",
                "Take Tsaba/Makera"
            ],
            "Tsafe": [
                "Kwaren Ganuwa",
                "Yan Kuzo B",
                "Yandoton Daji",
                "Yankuzo A",
                "Danjibga/Kunchin - Kalgo",
                "Dauki",
                "Keta/Kizara",
                "Tsafe",
                "Chediya",
                "Yan Waren Daji",
                "Bilbis"
            ],
            "Zurmi": [
                "Dauran / Birnin-Tsaba",
                "Galadima/Yanruwa",
                "Kwashbawa",
                "Mashem",
                "Kuturu/Mayasa",
                "Rukudawa",
                "Yan Buki/ Dutsi",
                "Zurmi"
            ]
        }
    }
]